<!--
Notice to add a illustration :
* Copy & paste the SVG tag with the content at the end of the template
* Add a comment BEGIN and END with the name of the SVG file
* Add a "v-else-if" instruction on the SVG tag, with the condition "name == '<name of file>'"
-->
<template>
  <!-- BEGIN Group 189.svg -->
  <svg
    v-if="name == 'Group189'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="305px"
    height="240px"
    viewBox="0 0 305 240"
    version="1.1"
  >
    <!-- Generator: sketchtool 59.1 (101010) - https://sketch.com -->
    <desc>Created with sketchtool.</desc>
    <defs>
      <path
        d="M1.75133333,3.88 L0.143888889,14.921 L33.7306389,14.917 C35.9763333,14.909 37.1171667,12.369 35.5713889,10.827 L35.5713889,10.827 C32.0461111,7.311 25.8033889,2.512 16.7260556,0.672 L16.7260556,0.672 C16.3622222,0.599 15.9408333,0.565 15.4742222,0.565 L15.4742222,0.565 C10.8286667,0.565 1.75133333,3.88 1.75133333,3.88 L1.75133333,3.88 Z"
        id="path-1"
      />
      <path
        d="M1.75133333,3.88 L0.143888889,14.921 L33.7306389,14.917 C35.9763333,14.909 37.1171667,12.369 35.5713889,10.827 L35.5713889,10.827 C32.0461111,7.311 25.8033889,2.512 16.7260556,0.672 L16.7260556,0.672 C16.3622222,0.599 15.9408333,0.565 15.4742222,0.565 L15.4742222,0.565 C10.8286667,0.565 1.75133333,3.88 1.75133333,3.88 L1.75133333,3.88 Z"
        id="path-3"
      />
      <path
        d="M2.32483333,3.88 L0.717388889,14.921 L34.3041389,14.917 C36.5498333,14.909 37.6906667,12.369 36.1459167,10.827 L36.1459167,10.827 C32.6206389,7.311 26.3768889,2.512 17.2995556,0.672 L17.2995556,0.672 C16.9357222,0.599 16.5143333,0.565 16.0477222,0.565 L16.0477222,0.565 C11.4031944,0.565 2.32483333,3.88 2.32483333,3.88 L2.32483333,3.88 Z"
        id="path-5"
      />
      <path
        d="M2.32483333,3.88 L0.717388889,14.921 L34.3041389,14.917 C36.5498333,14.909 37.6906667,12.369 36.1459167,10.827 L36.1459167,10.827 C32.6206389,7.311 26.3768889,2.512 17.2995556,0.672 L17.2995556,0.672 C16.9357222,0.599 16.5143333,0.565 16.0477222,0.565 L16.0477222,0.565 C11.4031944,0.565 2.32483333,3.88 2.32483333,3.88 L2.32483333,3.88 Z"
        id="path-7"
      />
      <polygon
        id="path-9"
        points="0.986130713 0.528478448 20.5942343 0.528478448 20.5942343 20.1560224 0.986130713 20.1560224"
      />
      <polygon
        id="path-11"
        points="0 0.90108603 41.0207436 0.90108603 41.0207436 75.960381 0 75.960381"
      />
      <path
        d="M20.9656389,0.304 C11.3754444,2.253 4.79458333,7.27 1.08122222,10.944 L1.08122222,10.944 C-0.54575,12.554 0.671138889,15.194 3.04530556,15.194 L3.04530556,15.194 L36.1675,15.194 L36.1808611,3.585 C36.1808611,3.585 27.1374444,0.188 22.3130556,0.188 L22.3130556,0.188 C21.8135556,0.188 21.3603056,0.224 20.9656389,0.304 L20.9656389,0.304 Z"
        id="path-13"
      />
      <path
        d="M20.9656389,0.304 C11.3754444,2.253 4.79458333,7.27 1.08122222,10.944 L1.08122222,10.944 C-0.54575,12.554 0.671138889,15.194 3.04530556,15.194 L3.04530556,15.194 L36.1675,15.194 L36.1808611,3.585 C36.1808611,3.585 27.1374444,0.188 22.3130556,0.188 L22.3130556,0.188 C21.8135556,0.188 21.3603056,0.224 20.9656389,0.304 L20.9656389,0.304 Z"
        id="path-15"
      />
      <path
        d="M10.8869063,6.09413793 C4.1641875,13.2889655 1.72940625,21.3413793 0.85490625,26.5975862 L0.85490625,26.5975862 C0.4723125,28.9034483 3.0339375,30.4344828 4.9850625,29.0627586 L4.9850625,29.0627586 L32.1935625,9.91758621 L25.3285313,0.0775862069 C25.3285313,0.0775862069 13.8362813,2.93896552 10.8869063,6.09413793 L10.8869063,6.09413793 Z"
        id="path-17"
      />
      <path
        d="M10.8869063,6.09413793 C4.1641875,13.2889655 1.72940625,21.3413793 0.85490625,26.5975862 L0.85490625,26.5975862 C0.4723125,28.9034483 3.0339375,30.4344828 4.9850625,29.0627586 L4.9850625,29.0627586 L32.1935625,9.91758621 L25.3285313,0.0775862069 C25.3285313,0.0775862069 13.8362813,2.93896552 10.8869063,6.09413793 L10.8869063,6.09413793 Z"
        id="path-19"
      />
      <polygon
        id="path-21"
        points="0.493037931 0.587731648 63.2262129 0.587731648 63.2262129 64.23169 0.493037931 64.23169"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Illustrations" transform="translate(-793.000000, -270.000000)">
        <g id="Bandeau-Header" transform="translate(75.000000, 270.000000)">
          <g id="Group-189" transform="translate(718.000000, 0.000000)">
            <g id="Group-33" transform="translate(33.000000, 14.000000)">
              <path
                d="M23.3764235,36.0951927 C41.2808,41.0692566 75.4724235,44.9515032 84.7538353,44.7853571 C101.370306,44.4891836 124.432518,42.6626082 124.432518,42.6626082 L124.637506,25.578453 L117.562306,26.7280603 C117.562306,26.7280603 91.4532235,25.7373753 81.8953882,25.5175671 C73.1450824,25.3153023 47.5194824,20.6776584 29.0001412,17.1710466 C23.7781176,16.1824256 13.6643294,33.3966082 23.3764235,36.0951927"
                id="Fill-1"
                fill="#766DFF"
              />
              <path
                d="M116.292,28.034526 C122.668376,22.0068274 125.038165,11.9947178 127.589129,14.4105443 C129.621412,16.3361881 123.354776,28.148042 123.354776,28.148042 L116.292,28.034526 Z"
                id="Fill-3"
                fill="#766DFF"
              />
              <path
                d="M124.408602,24.725432 C133.421873,23.7471306 142.928979,24.3343178 142.379238,27.0741808 C141.829496,29.8150758 124.203614,30.0194046 124.203614,30.0194046 L124.408602,24.725432 Z"
                id="Fill-5"
                fill="#766DFF"
              />
              <path
                d="M124.510165,28.8861023 C133.817459,27.821116 143.618588,28.3216183 143.0264,31.0748968 C142.433176,33.8271434 124.249271,34.1965863 124.249271,34.1965863 L124.510165,28.8861023 Z"
                id="Fill-7"
                fill="#766DFF"
              />
              <path
                d="M142.367021,30.2092858 C141.009751,28.0060438 132.173515,28.7872402 129.269515,29.0431671 L129.182551,28.0638338 C137.837609,27.2991489 142.031586,27.7862356 143.20768,29.6943361 L142.367021,30.2092858 Z"
                id="Fill-9"
                fill="#070000"
              />
              <path
                d="M123.176602,33.7420064 C132.189873,32.763705 141.696979,33.3508922 141.147238,36.0907553 C140.597496,38.8306183 122.971614,39.034947 122.971614,39.034947 L123.176602,33.7420064 Z"
                id="Fill-11"
                fill="#766DFF"
              />
              <path
                d="M140.482475,35.2229772 C139.146946,33.0145753 130.596452,33.7132146 127.785628,33.9423105 L127.704875,32.9619452 C136.095934,32.2767215 140.169816,32.8009589 141.327275,34.7152511 L140.482475,35.2229772 Z"
                id="Fill-13"
                fill="#070000"
              />
              <path
                d="M122.525506,38.2583945 C130.492094,37.6319927 140.099624,38.6742758 139.467059,41.3883397 C138.835529,44.1024037 123.200518,42.6628146 123.200518,42.6628146 L122.525506,38.2583945 Z"
                id="Fill-15"
                fill="#766DFF"
              />
              <path
                d="M83.8404988,37.0561571 L162.716452,0.922988128 C167.203416,-1.13268311 172.563134,0.844558904 174.62544,5.31812055 C176.688781,9.79168219 174.704122,15.1331251 170.216122,17.1898283 L91.3401694,53.3229973"
                id="Fill-17"
                fill="#7BEAFF"
              />
              <path
                d="M138.823313,40.5390338 C137.815972,38.7042027 133.575407,38.4895543 127.517901,38.7320658 L127.47856,37.7496365 C134.255595,37.4792621 138.427831,37.7713078 139.687784,40.0674265 L138.823313,40.5390338 Z"
                id="Fill-19"
                fill="#070000"
              />
              <polygon
                id="Fill-21"
                fill="#766DFF"
                points="16.9432094 217.450183 16.8086212 175.191279 33.8754447 175.191279 31.9218447 211.407005"
              />
              <polygon
                id="Fill-23"
                fill="#766DFF"
                points="73.7681224 217.359989 61.9833694 159.227423 80.2625224 157.267724 87.8253459 211.213615"
              />
              <path
                d="M10.0105694,72.8695205 C10.0882165,79.4235205 10.2787106,187.540269 10.6079341,200.320105 C21.34704,200.866014 25.9489224,201.303566 44.4682635,200.320105 C44.4682635,185.246215 43.4826635,148.053219 41.0041694,128.14458 C53.3873224,148.679621 54.2217694,153.488571 60.3579576,199.583283 C77.1607812,198.190132 86.3013929,197.113795 94.1095812,195.896078 C89.5894871,151.216187 63.8644988,95.568589 48.1000753,66.1978767 C31.5540047,68.3825434 24.8535812,69.7911735 10.0105694,72.8695205"
                id="Fill-25"
                fill="#3424C7"
              />
              <path
                d="M17.5766024,13.4278055 C39.0910494,9.10284658 55.26752,48.0027096 58.5556141,60.4543808 C37.5256847,67.7039242 21.0790024,73.2693032 0.696131765,73.8822895 C-0.399209412,63.3965087 -2.27723294,17.4194402 17.5766024,13.4278055"
                id="Fill-27"
                fill="#070000"
              />
              <path
                d="M19.1766494,13.187874 C21.95952,12.932979 25.2662494,12.8287507 30.8288847,16.153737 C27.7571671,16.7863306 11.8871435,19.3569516 8.00582588,20.0844858 C11.5392847,14.8751342 15.9941553,13.4788877 19.1766494,13.187874"
                id="Fill-29"
                fill="#766DFF"
              />
              <path
                d="M32.3770635,211.214027 C41.5218165,213.11284 47.8101929,218.064201 51.3612518,221.693616 C52.9183341,223.284904 51.7681224,225.906091 49.50704,225.915379 L15.6746635,225.918475 L17.2928282,214.524566 C17.2928282,214.524566 28.3673694,210.381233 32.3770635,211.214027"
                id="Fill-31"
                fill="#7BEAFF"
              />
            </g>
            <g id="Group-40" transform="translate(48.000000, 224.000000)">
              <g id="Group-36">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1" />
                </mask>
                <g id="Clip-35" />
                <path
                  d="M23.6713848,1.3712 C23.6878111,5.5112 12.50045,9.8982 1.7982,6.8332 C-8.90405,3.7672 10.5373944,-1.7888 10.5373944,-1.7888 L23.6713848,1.3712 Z"
                  id="Fill-34"
                  fill="#766DFF"
                  mask="url(#mask-2)"
                />
              </g>
              <g id="Group-39">
                <mask id="mask-4" fill="white">
                  <use xlink:href="#path-3" />
                </mask>
                <g id="Clip-38" />
                <polygon
                  id="Fill-37"
                  fill="#3424C7"
                  mask="url(#mask-4)"
                  points="-4.80671111 17.0002 38.27465 16.8412 38.2530667 11.3562 -4.82829444 11.5152"
                />
              </g>
            </g>
            <path
              d="M121.517822,225.104519 C130.561516,226.898869 136.781423,231.57783 140.292216,235.007573 C141.832091,236.511315 140.695614,238.988298 138.458495,238.997074 L105,239 L106.600282,228.232929 C106.600282,228.232929 117.552439,224.317541 121.517822,225.104519"
              id="Fill-41"
              fill="#7BEAFF"
            />
            <g id="Group-49" transform="translate(104.000000, 224.000000)">
              <g id="Group-45">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#path-5" />
                </mask>
                <g id="Clip-44" />
                <path
                  d="M24.2450903,1.3712 C24.2615167,5.5112 13.0751833,9.8982 2.37293333,6.8332 C-8.33034444,3.7672 11.1121278,-1.7888 11.1121278,-1.7888 L24.2450903,1.3712 Z"
                  id="Fill-43"
                  fill="#766DFF"
                  mask="url(#mask-6)"
                />
              </g>
              <g id="Group-48">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-47" />
                <polygon
                  id="Fill-46"
                  fill="#3424C7"
                  mask="url(#mask-8)"
                  points="-4.23269722 17.0002 38.8476361 16.8412 38.8270806 11.3562 -4.25428056 11.5152"
                />
              </g>
            </g>
            <g id="Group-100">
              <path
                d="M60.5585204,15.1343659 L60.4381126,14.1598228 C61.4209282,14.0382625 61.8459573,13.7920513 61.9149087,13.6014694 C62.0445786,13.2491504 61.3488893,12.4888832 61.0514718,12.1643789 C60.9845786,12.0912366 60.9228311,12.0242754 60.8703456,11.9645254 L61.6072,11.316547 C61.6545398,11.3721763 61.7121709,11.4339866 61.7739184,11.5009478 C62.2956854,12.0716634 63.1714718,13.0276634 62.8349476,13.9403961 C62.5992777,14.5832237 61.8541903,14.9736591 60.5585204,15.1343659"
                id="Fill-50"
                fill="#070000"
              />
              <g id="Group-54" transform="translate(41.165049, 0.000000)">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-53" />
                <path
                  d="M18.1854835,16.7847022 C14.6308816,20.8734565 8.43862913,21.3030384 4.35402718,17.7448228 C0.269425243,14.1866073 -0.159720388,7.98702974 3.39488155,3.8993056 C6.95051262,-0.189448707 13.142765,-0.619030603 17.2263379,2.94021509 C21.3109398,6.49740043 21.7400854,12.696978 18.1854835,16.7847022"
                  id="Fill-52"
                  fill="#766DFF"
                  mask="url(#mask-10)"
                />
              </g>
              <path
                d="M45.5191786,17.7445138 C41.4345767,14.1862983 41.0054311,7.98775086 44.560033,3.90002672 C48.114635,-0.188727586 54.3079165,-0.618309483 58.3914893,2.93990603 C56.9610039,10.3416948 51.5323631,16.5299405 45.5191786,17.7445138"
                id="Fill-55"
                fill="#000000"
              />
              <path
                d="M53.8210369,12.7550797 C53.8210369,11.2036401 52.5644738,9.94579957 51.0146097,9.94579957 C49.4647456,9.94579957 48.2071534,11.2036401 48.2071534,12.7550797 C48.2071534,14.3065194 49.4647456,15.5643599 51.0146097,15.5643599 C52.5644738,15.5643599 53.8210369,14.3065194 53.8210369,12.7550797"
                id="Fill-57"
                fill="#766DFF"
              />
              <path
                d="M45.9794039,3.99212414 C45.9794039,2.44068448 44.7228408,1.18284397 43.1729767,1.18284397 C41.6231126,1.18284397 40.3655204,2.44068448 40.3655204,3.99212414 C40.3655204,5.54356379 41.6231126,6.80140431 43.1729767,6.80140431 C44.7228408,6.80140431 45.9794039,5.54356379 45.9794039,3.99212414"
                id="Fill-59"
                fill="#7BEAFF"
              />
              <g id="Group-63">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-62" />
                <path
                  d="M40.7398136,2.64301034 C37.0061437,-1.67547241 29.0160078,2.11350172 25.5715223,13.1435578 C23.2415806,20.602006 24.1039883,25.8404328 20.178901,32.2542862 C15.8761243,39.2862431 7.29835728,41.2919888 2.68169709,47.6646353 C-0.517856311,52.0809845 3.24051262,56.5509026 -0.000205825243,65.5741828 C3.88268738,69.2828034 9.80427961,70.0945793 13.5616194,71.9530103 C19.4163184,64.5110448 11.9551534,63.3119241 17.4012893,55.7607603 C17.2386874,60.6952862 19.9072117,63.0935276 18.7082796,72.1992216 C22.1939301,74.2162991 23.7736388,75.5792172 26.1704738,75.960381 C27.4229204,67.3460793 29.9453087,61.9077991 30.8540272,58.0776181 C32.9236,49.3541181 37.334435,29.4491267 36.7365126,21.9855276 C36.0284738,13.1435578 36.1097748,5.94265259 40.0883767,5.26170862 C41.6927845,4.98665259 40.7398136,2.64301034 40.7398136,2.64301034"
                  id="Fill-61"
                  fill="#000000"
                  mask="url(#mask-12)"
                />
              </g>
              <path
                d="M57.9656369,10.7636534 L57.2082,10.1403991 C57.9893068,9.18955 59.7738117,8.17792069 61.2742777,8.21809741 L61.252666,9.19882155 C60.0959282,9.17512759 58.5903165,10.002356 57.9656369,10.7636534"
                id="Fill-64"
                fill="#070000"
              />
              <path
                d="M58.3917981,17.0870578 C58.3917981,17.7432776 57.8597398,18.2748466 57.2052155,18.2748466 C56.548633,18.2748466 56.0176039,17.7432776 56.0176039,17.0870578 C56.0176039,16.4308379 56.548633,15.899269 57.2052155,15.899269 C57.8597398,15.899269 58.3917981,16.4308379 58.3917981,17.0870578"
                id="Fill-66"
                fill="#FF3D81"
              />
              <path
                d="M73.3879165,142.629225 C73.0894699,142.048208 71.508732,139.84879 69.5070816,137.063203 C63.3662854,128.519984 53.0884019,114.221191 51.8205184,108.464587 L52.778635,108.253402 C54.002266,113.812212 64.6063825,128.564281 70.3025961,136.490428 C72.4864019,139.527376 73.9282078,141.535182 74.2606155,142.1811 L73.3879165,142.629225 Z"
                id="Fill-68"
                fill="#FFFFFF"
              />
              <path
                d="M117.386664,53.9262293 L99.9913437,16.0364879 C97.9402951,11.5717207 99.9131301,6.2385181 104.374392,4.18641466 C108.834625,2.13431121 114.162412,4.10812155 116.212431,8.57391897 L133.608781,46.4636603"
                id="Fill-70"
                fill="#7BEAFF"
              />
              <path
                d="M81.0843398,108.176345 L80.5059709,107.383112 C85.4962039,103.743513 86.7661456,96.466375 83.5264563,90.079306 L84.4001845,89.6353017 C87.8590777,96.4540129 86.4646117,104.251388 81.0843398,108.176345"
                id="Fill-72"
                fill="#FFFFFF"
              />
              <path
                d="M40.7896233,52.5550698 C48.3516427,68.0890397 62.1882447,84.9406 72.5577204,84.8128586 C86.7812738,84.6387595 123.547837,47.7740397 123.547837,47.7740397 L113.985196,33.6575871 L108.866322,38.6209578 C108.866322,38.6209578 81.3783612,63.7211086 75.5020505,62.8887293 C69.7286524,62.0718026 72.5638951,61.2146991 59.1934874,40.4958716 C52.952866,30.8266733 34.5716427,39.7829922 40.7896233,52.5550698"
                id="Fill-74"
                fill="#766DFF"
              />
              <path
                d="M108.574256,40.4128397 C110.344353,31.8500466 106.575693,22.2982879 110.033557,22.8288267 C112.788528,23.2511974 114.402198,36.4920034 114.402198,36.4920034 L108.574256,40.4128397 Z"
                id="Fill-76"
                fill="#766DFF"
              />
              <path
                d="M113.312868,33.0889319 C120.110247,27.1654405 128.202266,22.2443069 129.314751,24.802225 C130.426208,27.3591129 116.16046,37.5433974 116.16046,37.5433974 L113.312868,33.0889319 Z"
                id="Fill-78"
                fill="#766DFF"
              />
              <path
                d="M115.765584,36.4404948 C122.754381,30.2800638 131.036788,25.1199302 132.121487,27.711844 C133.205157,30.3047879 118.576128,40.9413181 118.576128,40.9413181 L115.765584,36.4404948 Z"
                id="Fill-80"
                fill="#766DFF"
              />
              <path
                d="M119.73832,33.8650638 L119.109524,33.1120078 C125.736068,27.5665897 129.437835,25.5835078 131.482709,26.4787276 L131.089583,27.3780681 C128.72465,26.343775 121.961233,32.0045724 119.73832,33.8650638"
                id="Fill-82"
                fill="#070000"
              />
              <path
                d="M117.442443,41.1773306 C124.239821,35.2538392 132.331841,30.3327056 133.444326,32.8906237 C134.556812,35.4475116 120.290035,45.6317961 120.290035,45.6317961 L117.442443,41.1773306 Z"
                id="Fill-84"
                fill="#766DFF"
              />
              <path
                d="M121.317206,38.7226358 L120.693555,37.9654591 C127.149264,32.635347 130.771788,30.7491013 132.808429,31.6618341 L132.40707,32.5570539 C130.061691,31.5083384 123.480429,36.937347 121.317206,38.7226358"
                id="Fill-86"
                fill="#070000"
              />
              <path
                d="M119.483097,45.248778 C125.626981,40.2071142 134.06067,35.6032737 135.090825,38.1869461 C136.120981,40.7695884 122.542689,48.4732177 122.542689,48.4732177 L119.483097,45.248778 Z"
                id="Fill-88"
                fill="#766DFF"
              />
              <path
                d="M123.82673,42.8000582 L123.234983,42.0181573 C128.612167,37.9438254 132.182206,35.8123987 134.518322,36.9775237 L134.080944,37.8562608 C132.21308,36.9249849 128.63172,39.1594289 123.82673,42.8000582"
                id="Fill-90"
                fill="#070000"
              />
              <path
                d="M88.5444757,55.723056 L88.008301,54.9020086 C89.6291748,53.8388707 102.227738,44.8444353 104.00401,43.4485517 C106.062262,41.831181 107.770612,39.5132931 107.893078,38.1709784 L108.869718,38.2606034 C108.699913,40.1087328 106.598437,42.6573793 104.610165,44.2201509 C102.82566,45.6222155 90.1725534,54.6557974 88.5444757,55.723056"
                id="Fill-92"
                fill="#070000"
              />
              <path
                d="M113.53341,58.4649629 L112.870652,57.7417819 C114.462711,56.2799672 121.437099,50.297756 123.657953,48.594881 L123.985216,48.3445491 C126.402633,46.4922991 132.82541,41.574256 134.318672,39.1523207 L135.153293,39.6674069 C133.565351,42.2438681 127.269157,47.065075 124.58005,49.1243897 L124.253817,49.3736914 C122.0484,51.0652345 115.117235,57.0113897 113.53341,58.4649629"
                id="Fill-94"
                fill="#070000"
              />
              <polygon
                id="Fill-96"
                fill="#E7E6FF"
                points="211.878769 203.176063 192.592944 228.147443 178.422905 222.717404 194.068711 191.046813"
              />
              <path
                d="M177.420639,222.830311 C167.817862,224.838117 161.227338,230.006492 157.510134,233.791345 C155.881027,235.449923 157.098483,238.169578 159.475765,238.169578 L192.642445,238.169578 L192.655823,226.210306 C192.655823,226.210306 181.630794,221.949513 177.420639,222.830311"
                id="Fill-98"
                fill="#FF3D81"
              />
            </g>
            <g id="Group-106" transform="translate(157.000000, 223.000000)">
              <g id="Group-103">
                <mask id="mask-14" fill="white">
                  <use xlink:href="#path-13" />
                </mask>
                <g id="Clip-102" />
                <path
                  d="M13.6249417,1.0578 C13.6249417,5.3658 25.4690528,9.8898 36.7725528,6.6588 C48.075025,3.4278 27.4978861,-2.2812 27.4978861,-2.2812 L13.6249417,1.0578 Z"
                  id="Fill-101"
                  fill="#E7E6FF"
                  mask="url(#mask-14)"
                />
              </g>
              <mask id="mask-16" fill="white">
                <use xlink:href="#path-15" />
              </mask>
              <g id="Clip-105" />
              <polygon
                id="Fill-104"
                fill="#070000"
                mask="url(#mask-16)"
                points="-1.75030556 17.213 43.7977222 17.213 43.7977222 11.505 -1.75030556 11.505"
              />
            </g>
            <g id="Group-113" transform="translate(159.000000, 121.000000)">
              <path
                d="M3.91073016,105.7654 C3.73326984,105.7654 3.57644444,105.779778 3.44438095,105.800319 C2.20628571,105.994427 1.50160317,106.898211 1.37057143,107.654103 C1.30763492,108.019724 1.31588889,108.695508 2.08453968,109.1094 C5.10136508,110.739292 7.87573016,110.949832 10.2281111,110.686914 C7.47747619,106.470968 5.15501587,105.7654 3.91073016,105.7654 L3.91073016,105.7654 Z M11.6364444,113.0994 C11.3527143,112.560211 11.0720794,112.060049 10.7955714,111.595832 C8.21001587,111.948103 5.03739683,111.81767 1.61612698,109.970049 C0.675174603,109.46167 0.221206349,108.534265 0.402793651,107.488751 C0.632873016,106.15567 1.82144444,105.064968 3.29168254,104.833886 C6.59636508,104.317292 9.51104762,107.765022 11.2825556,110.534914 C12.4009683,110.340805 13.4079524,110.062481 14.278746,109.82113 C15.8263651,109.392859 16.8488254,109.1094 17.5266825,109.563346 C17.8393016,109.771832 18.0250159,110.109724 18.0786667,110.567778 L17.1026349,110.681778 C17.0840635,110.520535 17.0417619,110.417832 16.9788254,110.375724 C16.6765238,110.172373 15.5900952,110.473292 14.5418413,110.763941 C13.7700952,110.977562 12.8559683,111.230211 11.8283492,111.426373 C12.0935079,111.878265 12.3215238,112.292157 12.5072381,112.644427 L11.6364444,113.0994 Z"
                id="Fill-107"
                fill="#070000"
              />
              <polygon
                id="Fill-109"
                fill="#E7E6FF"
                points="55.4406667 0.222762162 58.3883651 29.4242216 43.6354286 33.1133027 32.8020952 5.50578919"
              />
              <path
                d="M42.8767857,33.7797405 C36.1498016,40.9227135 33.7138492,48.9170919 32.8399603,54.1364432 C32.4561508,56.4246595 35.0200397,57.9456865 36.9710714,56.5828216 L64.1926587,37.5756324 L57.3243254,27.8065514 C57.3243254,27.8065514 45.8265476,30.6483351 42.8767857,33.7797405"
                id="Fill-111"
                fill="#FF3D81"
              />
            </g>
            <g id="Group-120" transform="translate(191.000000, 148.000000)">
              <g id="Group-116">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#path-17" />
                </mask>
                <g id="Clip-115" />
                <path
                  d="M5.30423438,10.9753448 C7.85554688,14.6239655 20.2635469,11.6084483 27.6349219,2.33844828 C35.0062969,-6.93051724 14.7216094,0.129827586 14.7216094,0.129827586 L5.30423438,10.9753448 Z"
                  id="Fill-114"
                  fill="#E7E6FF"
                  mask="url(#mask-18)"
                />
              </g>
              <g id="Group-119">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#path-19" />
                </mask>
                <g id="Clip-118" />
                <polygon
                  id="Fill-117"
                  fill="#070000"
                  mask="url(#mask-20)"
                  points="39.6567188 7.21727586 2.2419375 33.5448621 -1.1385 28.7107241 36.2762813 2.38313793"
                />
              </g>
            </g>
            <g id="Group-188" transform="translate(167.000000, 36.000000)">
              <path
                d="M25.8423835,128.88374 C24.0165466,128.88374 23.0429743,129.514073 22.587811,129.952207 C21.6816319,130.82434 21.6256437,131.973407 21.9563887,132.67194 C22.1160587,133.00984 22.5173074,133.55854 23.3882347,133.460373 C26.814919,133.066673 29.2172268,131.64584 31.001591,130.07414 C28.794205,129.188573 27.1124858,128.88374 25.8423835,128.88374 M23.187092,134.456507 C22.2560292,134.456507 21.4763419,133.96154 21.0636882,133.092507 C20.4809964,131.861807 20.82522,130.279773 21.9024742,129.244373 C24.3213711,126.916273 28.7174805,128.08084 31.7802415,129.344607 C32.5879229,128.53964 33.2545971,127.731573 33.8321048,127.032007 C34.8575181,125.78994 35.5345604,124.96844 36.3546836,124.951864 C36.7165331,124.948807 37.0804563,125.116207 37.3915018,125.46134 L36.6543241,126.117507 C36.5454581,125.995573 36.437629,125.936673 36.3754199,125.93564 C36.0083863,125.943907 35.2898713,126.815007 34.5941662,127.657173 C34.0840516,128.277173 33.4785498,129.01084 32.7465561,129.76414 C33.2276398,129.982173 33.6548089,130.194007 34.0114744,130.376907 L33.5583848,131.25214 C33.0130184,130.971073 32.4914988,130.719973 31.9948629,130.497807 C30.0736387,132.274107 27.3872427,133.99254 23.5012479,134.437907 C23.3954925,134.450307 23.2907738,134.456507 23.187092,134.456507"
                id="Fill-121"
                fill="#070000"
              />
              <path
                d="M17.1337324,175.41257 C24.1581759,180.476937 29.6813067,183.47877 34.996037,185.948437 C40.044305,180.777637 72.2530635,131.292337 79.9638807,125.71027 C90.8204044,117.850737 111.909287,108.95167 118.592618,106.788903 C135.493792,101.31947 131.543514,80.32007 129.567339,73.9764367 C121.445941,75.72587 91.9256527,87.6474367 86.1091024,87.2103367 C77.6579969,90.9293033 62.0020416,99.44707 49.4544673,110.61637 C41.01373,118.13077 20.7003871,167.04567 17.1337324,175.41257"
                id="Fill-123"
                fill="#4C3BE3"
              />
              <path
                d="M25.3518648,108.12676 C31.5116019,107.44476 39.4453351,106.008427 49.6414056,103.940727 C50.1598147,94.94866 50.1567043,94.5931933 60.6928512,101.76866 C68.0615184,98.36486 86.5656134,91.3102933 94.137497,88.60296 C86.8942848,80.7279267 44.1182749,60.2203933 34.4053616,59.5642267 C24.6934852,58.90806 16.2983679,66.44726 18.1086526,76.1306267 C19.9189372,85.8139933 22.7173096,100.251727 25.3518648,108.12676"
                id="Fill-125"
                fill="#4C3BE3"
              />
              <g id="Group-129" transform="translate(74.650913, 28.933333)">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#path-21" />
                </mask>
                <g id="Clip-128" />
                <path
                  d="M12.9920583,1.63442333 C33.5511271,-6.11351 57.9536811,31.30659 63.2269386,43.0793567 C43.6217426,53.63899 24.3690648,60.3339567 4.32529464,64.23169 C1.53832722,54.0471567 -5.98067863,8.78405667 12.9920583,1.63442333"
                  id="Fill-127"
                  fill="#FF3D81"
                  mask="url(#mask-22)"
                />
              </g>
              <path
                d="M50.1231113,104.050983 L49.1599072,103.830883 C49.6886845,101.534817 50.0588286,90.5763167 48.9432122,86.8067167 L49.8898272,86.5277167 C51.0686896,90.50915 50.6809196,101.624717 50.1231113,104.050983"
                id="Fill-130"
                fill="#070000"
              />
              <polygon
                id="Fill-132"
                fill="#070000"
                points="45.8568117 34.5461933 0.021151092 34.5461933 23.9996464 75.45276 69.8363438 75.45276"
              />
              <path
                d="M107.282279,40.00302 C116.972382,54.3952867 125.78119,79.2779533 114.259029,84.9571533 C99.7995614,92.0840533 56.6731069,81.2588533 56.6731069,81.2588533 L58.5798156,64.2553533 L65.4694728,66.26622 L95.3360589,69.33522 C95.3360589,69.33522 92.694246,63.5578533 87.9922753,46.08522 C85.0891843,35.29722 98.7845164,27.38292 107.282279,40.00302"
                id="Fill-134"
                fill="#E7E6FF"
              />
              <path
                d="M106.510678,38.9317633 C112.537703,47.26353 116.990837,56.5955633 118.279602,63.9249967 C103.820135,71.0518967 95.3358515,69.3344967 95.3358515,69.3344967 C95.3358515,69.3344967 92.6940387,63.5581633 87.992068,46.08553 C85.0889769,35.29753 97.7837794,26.8675967 106.510678,38.9317633"
                id="Fill-136"
                fill="#FF3D81"
              />
              <path
                d="M66.5704701,67.7203267 C60.9778725,60.94786 59.8581088,50.7075267 57.0244846,52.7958933 C54.7673313,54.45956 59.537732,66.9670267 59.537732,66.9670267 L66.5704701,67.7203267 Z"
                id="Fill-138"
                fill="#E7E6FF"
              />
              <path
                d="M58.9122195,63.4366433 C50.0754177,61.35861 40.553279,60.77581 40.7616795,63.56581 C40.9690431,66.3568433 58.4622404,68.7221433 58.4622404,68.7221433 L58.9122195,63.4366433 Z"
                id="Fill-140"
                fill="#E7E6FF"
              />
              <path
                d="M58.297179,67.5584033 C49.1783626,65.3584367 39.3752462,64.6537033 39.6240825,67.46127 C39.8729189,70.26987 57.9011144,72.86767 57.9011144,72.86767 L58.297179,67.5584033 Z"
                id="Fill-142"
                fill="#E7E6FF"
              />
              <path
                d="M53.5479293,67.1305 C50.6946056,66.5198 42.0081424,64.6587667 40.3865587,66.6820333 L39.6151659,66.0682333 C41.0190178,64.3167333 45.2471625,64.3467 53.7563298,66.1684667 L53.5479293,67.1305 Z"
                id="Fill-144"
                fill="#070000"
              />
              <path
                d="M59.0231591,72.54744 C50.1863573,70.4694067 40.6642186,69.8866067 40.872619,72.6766067 C41.0799827,75.46764 58.57318,77.83294 58.57318,77.83294 L59.0231591,72.54744 Z"
                id="Fill-146"
                fill="#E7E6FF"
              />
              <path
                d="M54.4177162,72.1811233 C51.6535587,71.6076233 43.2408156,69.8654233 41.6399682,71.8959233 L40.8633914,71.2883233 C42.2506542,69.5275233 46.3626753,69.5068567 54.6188589,71.2170233 L54.4177162,72.1811233 Z"
                id="Fill-148"
                fill="#070000"
              />
              <path
                d="M59.1127402,77.1157033 C51.2723207,75.51507 41.5946593,75.37247 41.8880788,78.1480033 C42.1804616,80.9225033 57.8975892,81.4092033 57.8975892,81.4092033 L59.1127402,77.1157033 Z"
                id="Fill-150"
                fill="#E7E6FF"
              />
              <path
                d="M42.632929,77.3826133 L41.8314686,76.8070467 C43.3669964,74.6804467 47.5495211,74.90158 54.2535878,76.0031133 L54.0918442,76.9734133 C48.1011084,75.98968 43.859485,75.68278 42.632929,77.3826133"
                id="Fill-152"
                fill="#070000"
              />
              <path
                d="M84.2308025,19.3348033 C84.2308025,24.77117 79.8087727,29.1783367 74.3540719,29.1783367 C68.8983344,29.1783367 64.4763046,24.77117 64.4763046,19.3348033 C64.4763046,13.8984367 68.8983344,9.49127 74.3540719,9.49127 C79.8087727,9.49127 84.2308025,13.8984367 84.2308025,19.3348033"
                id="Fill-154"
                fill="#E7E6FF"
              />
              <path
                d="M60.5115117,101.988347 L59.9308935,101.191647 C64.6017596,97.81058 74.9896415,92.09728 78.2058517,90.50698 L78.6444258,91.3884133 C75.4499888,92.96838 65.1377946,98.63828 60.5115117,101.988347"
                id="Fill-156"
                fill="#070000"
              />
              <path
                d="M95.1760778,69.64925 C94.8017865,68.3183167 93.9744055,66.2650833 93.0163855,63.8873833 C90.9551908,58.7734167 88.1329716,51.7694833 87.5015493,46.1409167 L88.4823793,46.0313833 C89.0992862,51.52665 91.8924745,58.4592833 93.931896,63.52055 C94.901321,65.9251167 95.7380333,68.0010833 96.1268402,69.3836833 L95.1760778,69.64925 Z"
                id="Fill-158"
                fill="#070000"
              />
              <path
                d="M117.798208,64.0350467 C117.121165,61.0962467 111.505758,45.85148 106.902285,40.3169467 L107.662272,39.68868 C112.358022,45.33378 118.074001,60.83068 118.761412,63.8149467 L117.798208,64.0350467 Z"
                id="Fill-160"
                fill="#070000"
              />
              <path
                d="M80.3898056,6.53976 C80.3898056,9.86192667 77.6878573,12.5547933 74.3534498,12.5547933 C71.0200792,12.5547933 68.3181309,9.86192667 68.3181309,6.53976 C68.3181309,3.21759333 71.0200792,0.523693333 74.3534498,0.523693333 C77.6878573,0.523693333 80.3898056,3.21759333 80.3898056,6.53976"
                id="Fill-162"
                fill="#070000"
              />
              <path
                d="M66.5202881,14.9335267 C66.5202881,19.01106 63.2035065,22.3166933 59.1122218,22.3166933 C55.0219738,22.3166933 51.7051923,19.01106 51.7051923,14.9335267 C51.7051923,10.8559933 55.0219738,7.55036 59.1122218,7.55036 C63.2035065,7.55036 66.5202881,10.8559933 66.5202881,14.9335267"
                id="Fill-164"
                fill="#070000"
              />
              <path
                d="M90.9027278,19.3348033 C90.9027278,21.42937 89.1981986,23.12817 87.0965681,23.12817 C84.9949375,23.12817 83.2904083,21.42937 83.2904083,19.3348033 C83.2904083,17.2402367 84.9949375,15.5414367 87.0965681,15.5414367 C89.1981986,15.5414367 90.9027278,17.2402367 90.9027278,19.3348033"
                id="Fill-166"
                fill="#070000"
              />
              <path
                d="M89.0315819,13.6943533 C89.0315819,16.0730867 87.0968791,18.0012867 84.7111603,18.0012867 C82.3244048,18.0012867 80.3897019,16.0730867 80.3897019,13.6943533 C80.3897019,11.31562 82.3244048,9.38845333 84.7111603,9.38845333 C87.0968791,9.38845333 89.0315819,11.31562 89.0315819,13.6943533"
                id="Fill-168"
                fill="#070000"
              />
              <path
                d="M87.7927915,23.67749 C87.7927915,25.3742233 86.4127864,26.74959 84.7103309,26.74959 C83.0089122,26.74959 81.6289071,25.3742233 81.6289071,23.67749 C81.6289071,21.9807567 83.0089122,20.60539 84.7103309,20.60539 C86.4127864,20.60539 87.7927915,21.9807567 87.7927915,23.67749"
                id="Fill-170"
                fill="#070000"
              />
              <path
                d="M87.5695645,8.37578667 C87.5695645,11.1316867 85.3279635,13.3657533 82.5627693,13.3657533 C79.797575,13.3657533 77.555974,11.1316867 77.555974,8.37578667 C77.555974,5.61988667 79.797575,3.38582 82.5627693,3.38582 C85.3279635,3.38582 87.5695645,5.61988667 87.5695645,8.37578667"
                id="Fill-172"
                fill="#070000"
              />
              <path
                d="M71.5312306,7.12297333 C71.5312306,10.8285067 68.5161632,13.83344 64.798133,13.83344 C61.079066,13.83344 58.0650354,10.8285067 58.0650354,7.12297333 C58.0650354,3.41744 61.079066,0.412506667 64.798133,0.412506667 C68.5161632,0.412506667 71.5312306,3.41744 71.5312306,7.12297333"
                id="Fill-174"
                fill="#070000"
              />
              <path
                d="M64.476512,16.6475167 C71.5310232,14.8278167 79.3330805,18.43725 84.7110567,21.81935 C85.4306085,18.30085 82.5627693,10.3751833 82.5627693,10.3751833 L76.2319571,7.83731667 L67.7269371,7.83731667 C67.7269371,7.83731667 65.5745025,14.62425 64.476512,16.6475167"
                id="Fill-176"
                fill="#070000"
              />
              <path
                d="M77.9764038,18.2873133 C75.870626,17.35008 70.4211093,15.8114467 66.3433032,16.41698 L65.9555332,13.8202133 C70.9529971,13.0793133 76.1588614,14.6117467 78.2138352,15.52728 L77.9764038,18.2873133 Z"
                id="Fill-178"
                fill="#FF3D81"
              />
              <path
                d="M67.9448763,21.6794367 L67.3393745,20.90237 C68.2051177,20.2317367 69.8629901,19.9734033 70.9485388,20.6554033 L70.4228719,21.48827 C69.7282037,21.0522033 68.5213473,21.2330367 67.9448763,21.6794367"
                id="Fill-180"
                fill="#070000"
              />
              <path
                d="M68.8014956,28.64586 C68.5142969,28.64586 68.2125828,28.5755933 67.937826,28.3689267 C67.1840591,27.80266 66.9766955,26.4644933 67.2856673,24.1580933 L68.2644237,24.2882933 C67.9253841,26.8251267 68.3390746,27.4378933 68.5319228,27.58256 C68.7102555,27.7168933 69.021301,27.6796933 69.5137897,27.4657933 L69.9077806,28.3678933 C69.6962697,28.45986 69.2680638,28.64586 68.8014956,28.64586"
                id="Fill-182"
                fill="#070000"
              />
              <path
                d="M75.5494197,25.4152467 C75.5494197,26.07348 75.0144215,26.60668 74.3539683,26.60668 C73.693515,26.60668 73.15748,26.07348 73.15748,25.4152467 C73.15748,24.7570133 73.693515,24.2238133 74.3539683,24.2238133 C75.0144215,24.2238133 75.5494197,24.7570133 75.5494197,25.4152467"
                id="Fill-184"
                fill="#FF3D81"
              />
              <path
                d="M81.2169792,17.1314267 C81.2169792,15.91726 80.2299282,14.9335267 79.0116668,14.9335267 C77.7944422,14.9335267 76.8073912,15.91726 76.8073912,17.1314267 C76.8073912,18.34456 77.7944422,19.3293267 79.0116668,19.3293267 C80.2299282,19.3293267 81.2169792,18.34456 81.2169792,17.1314267"
                id="Fill-186"
                fill="#E7E6FF"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END Group 189.svg -->

  <!-- BEGIN Inscription.svg -->
  <svg
    v-else-if="name == 'Inscription'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="426px"
    height="438px"
    viewBox="0 0 426 438"
    version="1.1"
  >
    <!-- Generator: sketchtool 59.1 (101010) - https://sketch.com -->
    <desc>Created with sketchtool.</desc>
    <defs>
      <polygon
        id="path-1"
        points="0.237810209 0.181 408.544149 0.181 408.544149 437.999848 0.237810209 437.999848"
      />
      <path
        d="M172.427,0.182 C75.77,0.421 -14.317,71.766 2.208,270.534 L2.208,270.534 C12.853,398.579 143.234,480.463 240.231,414.833 L240.231,414.833 C325.534,357.116 481.25,346.149 369.733,114.966 L369.733,114.966 C338.088,49.364 253.625,0.404 173.451,0.182 L173.451,0.182 L172.427,0.182 Z"
        id="path-3"
      />
      <path
        d="M3.404,7.788 L0.132,31.563 L68.587,31.563 C73.164,31.547 75.489,26.076 72.339,22.756 L72.339,22.756 C65.154,15.182 52.427,4.848 33.924,0.884 L33.924,0.884 C33.183,0.725 32.322,0.653 31.37,0.653 L31.37,0.653 C21.904,0.653 3.404,7.788 3.404,7.788 L3.404,7.788 Z"
        id="path-5"
      />
      <path
        d="M3.404,7.788 L0.132,31.563 L68.587,31.563 C73.164,31.547 75.489,26.076 72.339,22.756 L72.339,22.756 C65.154,15.182 52.427,4.848 33.924,0.884 L33.924,0.884 C33.183,0.725 32.322,0.653 31.37,0.653 L31.37,0.653 C21.904,0.653 3.404,7.788 3.404,7.788 L3.404,7.788 Z"
        id="path-7"
      />
      <path
        d="M21.318,88.734 C76.885,88.765 126.576,88.734 126.576,88.734 L126.576,88.734 C139.295,122.914 147.005,181.652 147.005,181.652 L147.005,181.652 L191.863,179.013 C191.863,179.013 189.473,97.541 172.057,68.18 L172.057,68.18 C160.276,48.318 91.845,33.953 91.845,33.953 L91.845,33.953 L86.968,5.364 L10.393,0.816 C-2.839,51.079 -5.524,88.721 21.318,88.734 L21.318,88.734 Z"
        id="path-9"
      />
      <path
        d="M3.342,7.788 L0.07,31.563 L68.526,31.563 C73.103,31.547 75.427,26.076 72.277,22.756 L72.277,22.756 C65.093,15.182 52.366,4.848 33.863,0.884 L33.863,0.884 C33.121,0.725 32.261,0.653 31.309,0.653 L31.309,0.653 C21.842,0.653 3.342,7.788 3.342,7.788 L3.342,7.788 Z"
        id="path-11"
      />
      <path
        d="M3.342,7.788 L0.07,31.563 L68.526,31.563 C73.103,31.547 75.427,26.076 72.277,22.756 L72.277,22.756 C65.093,15.182 52.366,4.848 33.863,0.884 L33.863,0.884 C33.121,0.725 32.261,0.653 31.309,0.653 L31.309,0.653 C21.842,0.653 3.342,7.788 3.342,7.788 L3.342,7.788 Z"
        id="path-13"
      />
      <path
        d="M0.302,18.736 C-0.556,29.473 7.45,38.873 18.186,39.731 L18.186,39.731 C28.923,40.591 38.323,32.583 39.181,21.846 L39.181,21.846 C40.041,11.11 32.033,1.711 21.296,0.851 L21.296,0.851 C20.768,0.809 20.243,0.788 19.722,0.788 L19.722,0.788 C9.657,0.789 1.118,8.529 0.302,18.736 L0.302,18.736 Z"
        id="path-15"
      />
      <polygon id="path-17" points="0 438 459.209 438 459.209 0.181 0 0.181" />
      <path
        d="M0.152,6.976 C21.446,68.404 40.378,82.73 54.387,87.498 L54.387,87.498 C71.678,93.384 130.453,103.363 163.237,90.499 L163.237,90.499 C169.773,87.934 156.371,63.264 156.371,63.264 L156.371,63.264 L146.53,68.384 L72.681,59.481 L24.487,0.359 L0.152,6.976 Z"
        id="path-19"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Inscription-1" transform="translate(-52.000000, -294.000000)">
        <g
          id="Illustration-Inscription"
          transform="translate(52.000000, 293.000000)"
        >
          <g id="Group-3" transform="translate(17.000000, 0.819000)">
            <mask id="mask-2" fill="white">
              <use xlink:href="#path-1" />
            </mask>
            <g id="Clip-2" />
            <path
              d="M369.7328,114.9659 C299.7838,-30.0441 -28.0772,-93.7411 2.2078,270.5339 C12.8538,398.5789 143.2338,480.4629 240.2308,414.8329 C325.5338,357.1159 481.2498,346.1489 369.7328,114.9659"
              id="Fill-1"
              fill="#E7E6FF"
              mask="url(#mask-2)"
            />
          </g>
          <g id="Group-9" transform="translate(17.000000, 0.819000)">
            <mask id="mask-4" fill="white">
              <use xlink:href="#path-3" />
            </mask>
            <g id="Clip-5" />
            <polygon
              id="Fill-4"
              fill="#B7B3FF"
              mask="url(#mask-4)"
              points="209.84 208.99 435.598 208.99 435.598 188.294 209.84 188.294"
            />
            <polygon
              id="Fill-6"
              fill="#766DFF"
              mask="url(#mask-4)"
              points="260.8632 162.3682 408.3672 162.3682 442.2092 59.8802 294.7052 59.8802"
            />
            <polygon
              id="Fill-7"
              fill="#FFFFFF"
              mask="url(#mask-4)"
              points="268.5443 156.3399 401.1253 156.3399 431.5443 64.2209 298.9633 64.2209"
            />
            <polygon
              id="Fill-8"
              fill="#4C3BE3"
              mask="url(#mask-4)"
              points="368.4057 188.294 321.1207 188.294 313.0007 162.368 360.2857 162.368"
            />
          </g>
          <polygon
            id="Fill-10"
            fill="#4C3BE3"
            points="285.6186 34.9538 295.2566 32.8608 297.3496 42.4988 287.7116 44.5918"
          />
          <polygon
            id="Fill-11"
            fill="#4C3BE3"
            points="271.9975 107.2692 281.6355 105.1762 283.7285 114.8152 274.0905 116.9082"
          />
          <polygon
            id="Fill-12"
            fill="#070000"
            points="269.9662 66.2429 270.6222 64.4949 260.1852 60.5739 259.5292 62.3219"
          />
          <polygon
            id="Fill-13"
            fill="#4C3BE3"
            points="104.6288 82.5329 95.4088 86.0359 91.9058 76.8159 101.1258 73.3129"
          />
          <polygon
            id="Fill-14"
            fill="#070000"
            points="125.9682 53.4138 126.3582 51.5888 115.4532 49.2648 115.0642 51.0898"
          />
          <polygon
            id="Fill-15"
            fill="#4C3BE3"
            points="366.7699 272.9645 360.7869 265.1235 368.6279 259.1405 374.6109 266.9815"
          />
          <polygon
            id="Fill-16"
            fill="#070000"
            points="340.6498 252.7956 342.5108 252.6486 341.6348 241.5336 339.7748 241.6806"
          />
          <polygon
            id="Fill-17"
            fill="#3424C7"
            points="283.5966 328.7956 319.7636 396.7006 290.5086 400.1316 257.2306 334.9576"
          />
          <g id="Group-22" transform="translate(172.000000, 207.819000)">
            <path
              d="M17.0087,47.6153 C29.7267,81.7943 82.4987,148.6513 82.4987,148.6513 L138.9537,134.4163 C138.9537,134.4163 96.4447,68.7063 79.0287,39.3453 C67.2477,19.4833 0.9677,0.9533 0.9677,0.9533 L17.0087,47.6153 Z"
              id="Fill-18"
              fill="#4C3BE3"
            />
            <path
              d="M148.9237,183.8838 C167.4267,187.8478 180.1537,198.1818 187.3397,205.7558 C190.4887,209.0758 188.1637,214.5468 183.5877,214.5638 L115.1317,214.5638 L118.4037,190.7878 C118.4037,190.7878 140.8107,182.1468 148.9237,183.8838"
              id="Fill-20"
              fill="#E7E6FF"
            />
          </g>
          <g id="Group-29" transform="translate(287.000000, 390.819000)">
            <g id="Group-25">
              <mask id="mask-6" fill="white">
                <use xlink:href="#path-5" />
              </mask>
              <g id="Clip-24" />
              <path
                d="M48.081538,2.3907 C48.1155,11.3047 25.3165,20.7507 3.5015,14.1477 C-18.3125,7.5447 21.3115,-4.4173 21.3115,-4.4173 L48.081538,2.3907 Z"
                id="Fill-23"
                fill="#3424C7"
                mask="url(#mask-6)"
              />
            </g>
            <g id="Group-28">
              <mask id="mask-8" fill="white">
                <use xlink:href="#path-7" />
              </mask>
              <g id="Clip-27" />
              <polygon
                id="Fill-26"
                fill="#766DFF"
                mask="url(#mask-8)"
                points="-9.9586 36.0391 77.8484 35.7071 77.8034 23.8951 -10.0026 24.2271"
              />
            </g>
          </g>
          <g id="Group-34" transform="translate(86.000000, 174.819000)">
            <polygon
              id="Fill-30"
              fill="#4C3BE3"
              points="174.661 150.0283 188.702 221.8823 159.447 225.3123 148.295 156.1903"
            />
            <path
              d="M10.3925,0.8155 C-2.8385,51.0795 -5.5235,88.7205 21.3175,88.7345 C76.8855,88.7645 126.5765,88.7345 126.5765,88.7345 C139.2945,122.9145 147.0045,181.6515 147.0045,181.6515 L191.8635,179.0125 C191.8635,179.0125 189.4725,97.5415 172.0575,68.1795 C160.2755,48.3175 91.8455,33.9535 91.8455,33.9535 L86.9685,5.3645 L10.3925,0.8155 Z"
              id="Fill-32"
              fill="#766DFF"
            />
          </g>
          <g id="Group-52" transform="translate(86.000000, 174.819000)">
            <mask id="mask-10" fill="white">
              <use xlink:href="#path-9" />
            </mask>
            <g id="Clip-36" />
            <polygon
              id="Fill-35"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 -13.449 228.451 -13.449 228.451 -15.316 -28.681 -15.316"
            />
            <polygon
              id="Fill-37"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 -0.633 228.451 -0.633 228.451 -2.499 -28.681 -2.499"
            />
            <polygon
              id="Fill-38"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 12.184 228.451 12.184 228.451 10.318 -28.681 10.318"
            />
            <polygon
              id="Fill-39"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 25.001 228.451 25.001 228.451 23.134 -28.681 23.134"
            />
            <polygon
              id="Fill-40"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 37.817 228.451 37.817 228.451 35.95 -28.681 35.95"
            />
            <polygon
              id="Fill-41"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 50.634 228.451 50.634 228.451 48.768 -28.681 48.768"
            />
            <polygon
              id="Fill-42"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 63.45 228.451 63.45 228.451 61.584 -28.681 61.584"
            />
            <polygon
              id="Fill-43"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 76.268 228.451 76.268 228.451 74.401 -28.681 74.401"
            />
            <polygon
              id="Fill-44"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 87.547 228.451 87.547 228.451 85.68 -28.681 85.68"
            />
            <polygon
              id="Fill-45"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 100.364 228.451 100.364 228.451 98.497 -28.681 98.497"
            />
            <polygon
              id="Fill-46"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 113.18 228.451 113.18 228.451 111.314 -28.681 111.314"
            />
            <polygon
              id="Fill-47"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 125.997 228.451 125.997 228.451 124.131 -28.681 124.131"
            />
            <polygon
              id="Fill-48"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 138.813 228.451 138.813 228.451 136.946 -28.681 136.946"
            />
            <polygon
              id="Fill-49"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 151.631 228.451 151.631 228.451 149.764 -28.681 149.764"
            />
            <polygon
              id="Fill-50"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 164.446 228.451 164.446 228.451 162.58 -28.681 162.58"
            />
            <polygon
              id="Fill-51"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="-28.681 177.264 228.451 177.264 228.451 175.398 -28.681 175.398"
            />
          </g>
          <path
            d="M275.8622,391.7028 C294.3652,395.6668 307.0922,406.0008 314.2782,413.5748 C317.4272,416.8948 315.1022,422.3658 310.5262,422.3828 L242.0702,422.3828 L245.3422,398.6068 C245.3422,398.6068 267.7492,389.9658 275.8622,391.7028"
            id="Fill-53"
            fill="#E7E6FF"
          />
          <g id="Group-61" transform="translate(242.000000, 390.819000)">
            <g id="Group-57">
              <mask id="mask-12" fill="white">
                <use xlink:href="#path-11" />
              </mask>
              <g id="Clip-56" />
              <path
                d="M48.019938,2.3907 C48.0539,11.3047 25.2549,20.7507 3.4399,14.1477 C-18.3741,7.5447 21.2499,-4.4173 21.2499,-4.4173 L48.019938,2.3907 Z"
                id="Fill-55"
                fill="#4C3BE3"
                mask="url(#mask-12)"
              />
            </g>
            <g id="Group-60">
              <mask id="mask-14" fill="white">
                <use xlink:href="#path-13" />
              </mask>
              <g id="Clip-59" />
              <polygon
                id="Fill-58"
                fill="#766DFF"
                mask="url(#mask-14)"
                points="-10.0201 36.0391 77.7869 35.7071 77.7419 23.8951 -10.0641 24.2271"
              />
            </g>
          </g>
          <g id="Group-68" transform="translate(74.000000, 43.819000)">
            <path
              d="M0.7675,149.2491 L101.2825,149.5171 C101.2825,149.5171 123.3685,80.4001 106.8335,57.5831 C90.2985,34.7671 72.6625,38.0501 51.2665,56.2201 C27.4165,76.4741 0.7675,149.2491 0.7675,149.2491"
              id="Fill-62"
              fill="#FFFFFF"
            />
            <path
              d="M123.391,32.8662 C123.391,32.8662 128.396,34.1292 129.2,32.5602 C129.788,31.4122 129.377,30.9182 126.617,24.9472 L123.391,32.8662 Z"
              id="Fill-64"
              fill="#4C3BE3"
            />
            <path
              d="M129.1815,21.8467 C128.3225,32.5827 118.9225,40.5907 108.1865,39.7317 C97.4505,38.8727 89.4435,29.4727 90.3025,18.7367 C91.1605,7.9997 100.5605,-0.0073 111.2965,0.8517 C122.0335,1.7107 130.0405,11.1107 129.1815,21.8467"
              id="Fill-66"
              fill="#4C3BE3"
            />
          </g>
          <g id="Group-71" transform="translate(164.000000, 43.819000)">
            <mask id="mask-16" fill="white">
              <use xlink:href="#path-15" />
            </mask>
            <g id="Clip-70" />
            <path
              d="M26.018,-5.7578 C36.452,20.2892 -0.765,16.9332 9.274,42.0862 L48.957,39.3982 L47.902,0.1852 L26.018,-5.7578 Z"
              id="Fill-69"
              fill="#4C3BE3"
              mask="url(#mask-16)"
            />
          </g>
          <g id="Group-91" transform="translate(0.000000, 0.819000)">
            <path
              d="M194.1933,69.8955 C194.3263,69.7245 197.5413,65.6875 201.7033,67.3485 L202.3963,65.6155 C198.0163,63.8645 194.1493,66.9025 192.7173,68.7525 L194.1933,69.8955 Z"
              id="Fill-72"
              fill="#FFFFFF"
            />
            <path
              d="M157.6498,39.1641 C157.6498,32.5591 163.0048,27.2031 169.6098,27.2031 C176.2158,27.2031 181.5708,32.5591 181.5708,39.1641 C181.5708,45.7691 176.2158,51.1251 169.6098,51.1251 C163.0048,51.1251 157.6498,45.7691 157.6498,39.1641"
              id="Fill-74"
              fill="#070000"
            />
            <path
              d="M201.7157,55.7256 C199.9007,66.0196 180.7397,67.0386 180.7397,67.0386 L171.6047,78.5586 C171.6047,78.5586 152.9377,67.4976 169.0247,48.8456 C182.8137,32.8586 202.7187,50.0396 201.7157,55.7256"
              id="Fill-76"
              fill="#070000"
            />
            <mask id="mask-18" fill="white">
              <use xlink:href="#path-17" />
            </mask>
            <g id="Clip-79" />
            <polygon
              id="Fill-78"
              fill="#FF3D81"
              mask="url(#mask-18)"
              points="18.315 251.211 107.317 251.211 107.317 174.383 18.315 174.383"
            />
            <polygon
              id="Fill-80"
              fill="#000000"
              mask="url(#mask-18)"
              points="0 251.211 89.003 251.211 89.003 174.383 0 174.383"
            />
            <path
              d="M233.3622,414.833 L235.2282,414.833 C235.2282,406.546 229.3432,399.293 221.2342,397.586 L149.3222,382.446 L149.3222,275.353 L147.4552,275.353 L147.4552,383.96 L220.8492,399.412 C228.1002,400.938 233.3622,407.424 233.3622,414.833"
              id="Fill-81"
              fill="#070000"
              mask="url(#mask-18)"
            />
            <polygon
              id="Fill-82"
              fill="#070000"
              mask="url(#mask-18)"
              points="147.455 399.742 149.322 399.742 149.322 383.203 147.455 383.203"
            />
            <polygon
              id="Fill-83"
              fill="#070000"
              mask="url(#mask-18)"
              points="76.405 287.97 220.374 287.97 220.374 262.735 76.405 262.735"
            />
            <polygon
              id="Fill-84"
              fill="#000000"
              mask="url(#mask-18)"
              points="62.817 287.97 123.976 287.97 123.976 262.735 62.817 262.735"
            />
            <path
              d="M209.4745,412.8809 C209.4745,408.0859 213.3625,404.1979 218.1575,404.1979 C222.9535,404.1979 226.8405,408.0859 226.8405,412.8809 C226.8405,417.6769 222.9535,421.5639 218.1575,421.5639 C213.3625,421.5639 209.4745,417.6769 209.4745,412.8809"
              id="Fill-85"
              fill="#070000"
              mask="url(#mask-18)"
            />
            <path
              d="M61.5492,414.833 L63.4162,414.833 C63.4162,407.424 68.6782,400.938 75.9282,399.412 L149.3222,383.96 L149.3222,275.353 L147.4552,275.353 L147.4552,382.446 L75.5442,397.586 C67.4352,399.293 61.5492,406.546 61.5492,414.833"
              id="Fill-86"
              fill="#070000"
              mask="url(#mask-18)"
            />
            <path
              d="M87.3031,412.8809 C87.3031,408.0859 83.4161,404.1979 78.6201,404.1979 C73.8251,404.1979 69.9381,408.0859 69.9381,412.8809 C69.9381,417.6769 73.8251,421.5639 78.6201,421.5639 C83.4161,421.5639 87.3031,417.6769 87.3031,412.8809"
              id="Fill-87"
              fill="#070000"
              mask="url(#mask-18)"
            />
            <path
              d="M139.7064,412.8809 C139.7064,408.0859 143.5934,404.1979 148.3894,404.1979 C153.1844,404.1979 157.0714,408.0859 157.0714,412.8809 C157.0714,417.6769 153.1844,421.5639 148.3894,421.5639 C143.5934,421.5639 139.7064,417.6769 139.7064,412.8809"
              id="Fill-88"
              fill="#070000"
              mask="url(#mask-18)"
            />
            <path
              d="M75.245,277.1866 L94.6,277.1866 L94.6,275.3196 L75.245,275.3196 C58.807,275.3196 45.434,261.9466 45.434,245.5096 L45.434,216.4386 L43.568,216.4386 L43.568,245.5096 C43.568,262.9756 57.778,277.1866 75.245,277.1866"
              id="Fill-89"
              fill="#070000"
              mask="url(#mask-18)"
            />
            <path
              d="M138.1522,103.9756 C159.4452,165.4036 178.3782,179.7296 192.3862,184.4976 C209.6782,190.3836 268.4532,200.3636 301.2372,187.4986 C307.7732,184.9336 294.3712,160.2646 294.3712,160.2646 L284.5292,165.3836 L210.6812,156.4806 L162.4872,97.3596 L138.1522,103.9756 Z"
              id="Fill-90"
              fill="#4C3BE3"
              mask="url(#mask-18)"
            />
          </g>
          <g id="Group-94" transform="translate(138.000000, 97.819000)">
            <mask id="mask-20" fill="white">
              <use xlink:href="#path-19" />
            </mask>
            <g id="Clip-93" />
            <path
              d="M40.0507,-24.8535 L80.6647,29.0265 L131.6477,66.5885 L134.3797,115.797017 C134.3797,115.797017 64.0867,116.0915 38.4177,102.5845 C12.7487,89.0795 -9.1853,5.2185 -9.1853,5.2185 L40.0507,-24.8535 Z"
              id="Fill-92"
              fill="#FFFFFF"
              mask="url(#mask-20)"
            />
          </g>
          <g id="Group-115" transform="translate(136.000000, 104.819000)">
            <path
              d="M147.9208,64.2032 C154.5568,52.3142 151.7028,35.7412 157.6638,38.5342 C162.4108,40.7602 159.9198,61.6522 159.9198,61.6522 L147.9208,64.2032 Z"
              id="Fill-95"
              fill="#4C3BE3"
            />
            <path
              d="M157.622,55.1182 C170.396,49.3132 184.655,45.5802 185.178,49.8872 C185.7,54.1932 159.89,63.0232 159.89,63.0232 L157.622,55.1182 Z"
              id="Fill-97"
              fill="#4C3BE3"
            />
            <path
              d="M164.56,53.3399 C168.555,51.6519 180.713,46.5159 183.668,49.0569 L184.885,47.6429 C182.199,45.3289 175.902,46.5209 163.833,51.6199 L164.56,53.3399 Z"
              id="Fill-99"
              fill="#FFFFFF"
            />
            <path
              d="M159.7914,61.2041 C172.9554,55.1311 187.6054,51.1261 188.0704,55.4721 C188.5364,59.8181 161.9854,69.1611 161.9854,69.1611 L159.7914,61.2041 Z"
              id="Fill-101"
              fill="#4C3BE3"
            />
            <path
              d="M166.9301,59.2891 C171.0501,57.5161 183.5861,52.1201 186.5711,54.6451 L187.7761,53.2201 C185.0651,50.9261 178.6111,52.2291 166.1921,57.5741 L166.9301,59.2891 Z"
              id="Fill-103"
              fill="#FFFFFF"
            />
            <path
              d="M160.1884,69.0098 C172.9624,63.2058 187.2214,59.4718 187.7434,63.7788 C188.2664,68.0848 162.4564,76.9148 162.4564,76.9148 L160.1884,69.0098 Z"
              id="Fill-105"
              fill="#4C3BE3"
            />
            <path
              d="M167.1259,67.2325 C171.1209,65.5435 183.2779,60.4065 186.2339,62.9495 L187.4519,61.5345 C184.7659,59.2195 178.4679,60.4135 166.3989,65.5125 L167.1259,67.2325 Z"
              id="Fill-107"
              fill="#FFFFFF"
            />
            <path
              d="M161.4228,75.9854 C172.8298,71.2064 187.4568,68.0944 187.8458,72.4034 C188.2348,76.7124 165.2368,83.4994 165.2368,83.4994 L161.4228,75.9854 Z"
              id="Fill-109"
              fill="#4C3BE3"
            />
            <path
              d="M169.0512,74.4287 C177.7782,71.1617 184.0632,69.4277 186.3702,71.5867 L187.6462,70.2237 C184.6142,67.3867 178.2912,68.9757 168.3972,72.6797 L169.0512,74.4287 Z"
              id="Fill-111"
              fill="#FFFFFF"
            />
            <path
              d="M85.2558,87.0821 L85.3408,85.2181 C85.0158,85.2021 52.6308,83.5361 38.3858,67.7701 C16.0458,43.0461 2.4928,0.4671 2.3578,0.0401 L0.5768,0.6001 C0.7128,1.0311 14.3908,43.9981 37.0008,69.0221 C41.2748,73.7521 49.9118,80.2371 66.7838,84.2721 C76.8198,86.6741 85.1728,87.0781 85.2558,87.0821"
              id="Fill-113"
              fill="#000000"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END Inscription.svg -->

  <!-- BEGIN Entreprise.svg -->
  <svg
    v-else-if="name == 'Entreprise'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="176px"
    height="138px"
    viewBox="0 0 176 138"
    version="1.1"
  >
    <!-- Generator: sketchtool 59.1 (101010) - https://sketch.com -->
    <desc>Created with sketchtool.</desc>
    <defs>
      <path
        d="M1.04133333,2.328 L0.0855555556,8.9526 L20.0560556,8.9502 C21.3913333,8.9454 22.0696667,7.4214 21.1505556,6.4962 L21.1505556,6.4962 C19.0544444,4.3866 15.3425556,1.5072 9.94522222,0.4032 L9.94522222,0.4032 C9.72888889,0.3594 9.47833333,0.339 9.20088889,0.339 L9.20088889,0.339 C6.43866667,0.339 1.04133333,2.328 1.04133333,2.328 L1.04133333,2.328 Z"
        id="path-1"
      />
      <path
        d="M1.04133333,2.328 L0.0855555556,8.9526 L20.0560556,8.9502 C21.3913333,8.9454 22.0696667,7.4214 21.1505556,6.4962 L21.1505556,6.4962 C19.0544444,4.3866 15.3425556,1.5072 9.94522222,0.4032 L9.94522222,0.4032 C9.72888889,0.3594 9.47833333,0.339 9.20088889,0.339 L9.20088889,0.339 C6.43866667,0.339 1.04133333,2.328 1.04133333,2.328 L1.04133333,2.328 Z"
        id="path-3"
      />
      <path
        d="M1.38233333,2.328 L0.426555556,8.9526 L20.3970556,8.9502 C21.7323333,8.9454 22.4106667,7.4214 21.4921667,6.4962 L21.4921667,6.4962 C19.3960556,4.3866 15.6835556,1.5072 10.2862222,0.4032 L10.2862222,0.4032 C10.0698889,0.3594 9.81933333,0.339 9.54188889,0.339 L9.54188889,0.339 C6.78027778,0.339 1.38233333,2.328 1.38233333,2.328 L1.38233333,2.328 Z"
        id="path-5"
      />
      <path
        d="M1.38233333,2.328 L0.426555556,8.9526 L20.3970556,8.9502 C21.7323333,8.9454 22.4106667,7.4214 21.4921667,6.4962 L21.4921667,6.4962 C19.3960556,4.3866 15.6835556,1.5072 10.2862222,0.4032 L10.2862222,0.4032 C10.0698889,0.3594 9.81933333,0.339 9.54188889,0.339 L9.54188889,0.339 C6.78027778,0.339 1.38233333,2.328 1.38233333,2.328 L1.38233333,2.328 Z"
        id="path-7"
      />
      <polygon
        id="path-9"
        points="0.562838756 0.302935345 11.7542564 0.302935345 11.7542564 11.5538706 0.562838756 11.5538706"
      />
      <polygon
        id="path-11"
        points="0 0.516522118 23.4127829 0.516522118 23.4127829 43.5421431 0 43.5421431"
      />
      <path
        d="M12.4660556,0.171 C6.76377778,1.2673125 2.85083333,4.089375 0.642888889,6.156 L0.642888889,6.156 C-0.3245,7.061625 0.399055556,8.546625 1.81072222,8.546625 L1.81072222,8.546625 L21.505,8.546625 L21.5129444,2.0165625 C21.5129444,2.0165625 16.1357778,0.10575 13.2672222,0.10575 L13.2672222,0.10575 C12.9702222,0.10575 12.7007124,0.126 12.4660556,0.171 L12.4660556,0.171 Z"
        id="path-13"
      />
      <path
        d="M12.4660556,0.171 C6.76377778,1.2673125 2.85083333,4.089375 0.642888889,6.156 L0.642888889,6.156 C-0.3245,7.061625 0.399055556,8.546625 1.81072222,8.546625 L1.81072222,8.546625 L21.505,8.546625 L21.5129444,2.0165625 C21.5129444,2.0165625 16.1357778,0.10575 13.2672222,0.10575 L13.2672222,0.10575 C12.9702222,0.10575 12.7007124,0.126 12.4660556,0.171 L12.4660556,0.171 Z"
        id="path-15"
      />
      <path
        d="M6.598125,3.65648276 C2.52375,7.97337931 1.048125,12.8048276 0.518125,15.9585517 L0.518125,15.9585517 C0.28625,17.342069 1.83875,18.2606897 3.02125,17.4376552 L3.02125,17.4376552 L19.51125,5.95055172 L15.350625,0.0465517241 C15.350625,0.0465517241 8.385625,1.76337931 6.598125,3.65648276 L6.598125,3.65648276 Z"
        id="path-17"
      />
      <path
        d="M6.598125,3.65648276 C2.52375,7.97337931 1.048125,12.8048276 0.518125,15.9585517 L0.518125,15.9585517 C0.28625,17.342069 1.83875,18.2606897 3.02125,17.4376552 L3.02125,17.4376552 L19.51125,5.95055172 L15.350625,0.0465517241 C15.350625,0.0465517241 8.385625,1.76337931 6.598125,3.65648276 L6.598125,3.65648276 Z"
        id="path-19"
      />
      <polygon
        id="path-21"
        points="0.283848309 0.33810369 36.4001479 0.33810369 36.4001479 36.9504883 0.283848309 36.9504883"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Inscription-1" transform="translate(-753.000000, -545.000000)">
        <g id="Entreprise" transform="translate(653.000000, 476.000000)">
          <g
            id="Illustration-Inscription---Entreprise"
            transform="translate(100.000000, 69.000000)"
          >
            <g id="Group-33" transform="translate(19.000000, 8.000000)">
              <path
                d="M13.4148794,20.7627215 C23.68955,23.6239087 43.3108794,25.8570594 48.6371441,25.7614886 C58.1727324,25.5911233 71.4072971,24.5404384 71.4072971,24.5404384 L71.5249324,14.7132694 L67.4647324,15.3745479 C67.4647324,15.3745479 52.4816794,14.8046849 46.9967853,14.6782466 C41.9753029,14.5618995 27.2697029,11.8942283 16.6421265,9.87715068 C13.6453971,9.30847489 7.84146176,19.2104384 13.4148794,20.7627215"
                id="Fill-1"
                fill="#766DFF"
              />
              <path
                d="M66.73575,16.1260548 C70.3949206,12.6587945 71.7548559,6.89961644 73.2187618,8.28925114 C74.3850147,9.39692237 70.7888206,16.1913516 70.7888206,16.1913516 L66.73575,16.1260548 Z"
                id="Fill-3"
                fill="#766DFF"
              />
              <path
                d="M71.3935729,14.2225936 C76.5659612,13.6598539 82.0217435,13.9976164 81.7062671,15.5736438 C81.3907906,17.1502648 71.2759376,17.2677991 71.2759376,17.2677991 L71.3935729,14.2225936 Z"
                id="Fill-5"
                fill="#766DFF"
              />
              <path
                d="M71.4518559,16.6158995 C76.7929735,16.0032968 82.4174853,16.2911963 82.07765,17.8749406 C81.7372206,19.4580913 71.3021382,19.6706027 71.3021382,19.6706027 L71.4518559,16.6158995 Z"
                id="Fill-7"
                fill="#766DFF"
              />
              <path
                d="M81.6992565,17.3770228 C80.9203682,16.1096712 75.8495741,16.559032 74.1830741,16.7062466 L74.1331682,16.1429132 C79.0999918,15.7030502 81.5067624,15.9832329 82.18168,17.0808128 L81.6992565,17.3770228 Z"
                id="Fill-9"
                fill="#070000"
              />
              <path
                d="M70.6865729,19.4091187 C75.8589612,18.846379 81.3147435,19.1841416 80.9992671,20.7601689 C80.6837906,22.3361963 70.5689376,22.4537306 70.5689376,22.4537306 L70.6865729,19.4091187 Z"
                id="Fill-11"
                fill="#766DFF"
              />
              <path
                d="M80.6177841,20.2610046 C79.8513724,18.9906849 74.9445547,19.3925571 73.3315253,19.5243379 L73.2851841,18.960411 C78.1005076,18.5662557 80.4383606,18.8678082 81.1025841,19.9689498 L80.6177841,20.2610046 Z"
                id="Fill-13"
                fill="#070000"
              />
              <path
                d="M70.3129324,22.0070411 C74.8846676,21.6467215 80.3980794,22.2462648 80.0350735,23.8074521 C79.6726618,25.3686393 70.7002971,24.5405571 70.7002971,24.5405571 L70.3129324,22.0070411 Z"
                id="Fill-15"
                fill="#766DFF"
              />
              <path
                d="M48.1130135,21.3154886 L93.3770547,0.530922374 C95.9519606,-0.651543379 99.0277076,0.485808219 100.21119,3.05909589 C101.395266,5.63238356 100.256343,8.70489498 97.6808429,9.88795434 L52.4168018,30.6725205"
                id="Fill-17"
                fill="#7BEAFF"
              />
              <path
                d="M79.6656512,23.3189132 C79.0875747,22.2634795 76.6540688,22.1400091 73.1778865,22.2795068 L73.15531,21.7143927 C77.0444041,21.5588676 79.4386982,21.7268584 80.1617394,23.0476347 L79.6656512,23.3189132 Z"
                id="Fill-19"
                fill="#070000"
              />
              <polygon
                id="Fill-21"
                fill="#766DFF"
                points="9.72309176 125.081963 9.64585647 100.773744 19.4398859 100.773744 18.3187859 121.605799"
              />
              <polygon
                id="Fill-23"
                fill="#766DFF"
                points="42.3328429 125.030082 35.5700018 91.5909954 46.0597429 90.4637352 50.3997724 121.494557"
              />
              <path
                d="M5.74470176,41.9160959 C5.78926059,45.6860959 5.89857824,107.877146 6.08750765,115.228379 C12.25029,115.542397 14.8911429,115.794087 25.5187194,115.228379 C25.5187194,106.557557 24.9531194,85.1633562 23.5308018,73.711484 C30.6370429,85.5236758 31.1159018,88.2898858 34.6372371,114.804543 C44.2797665,114.003174 49.5252312,113.384041 54.0060665,112.683584 C51.4121488,86.9827626 36.6495135,54.9730822 27.6028841,38.0784247 C18.1076959,39.3350913 14.2625665,40.1453653 5.74470176,41.9160959"
                id="Fill-25"
                fill="#3424C7"
              />
              <path
                d="M10.0865729,7.7239589 C22.4329318,5.23615068 31.71602,27.6121781 33.6029376,34.7746438 C21.5346259,38.9447352 12.0964729,42.1460594 0.399484706,42.4986621 C-0.229091765,36.4670183 -1.30682118,10.020032 10.0865729,7.7239589"
                id="Fill-27"
                fill="#070000"
              />
              <path
                d="M11.0047818,7.58594521 C12.60177,7.4393242 14.4993818,7.37936986 17.6915759,9.2919726 C15.9288288,9.65585388 6.82159941,11.1345297 4.59425235,11.5530228 C6.62197588,8.55649315 9.17846412,7.75334247 11.0047818,7.58594521"
                id="Fill-29"
                fill="#766DFF"
              />
              <path
                d="M18.5800194,121.494795 C23.8278606,122.587032 27.4365312,125.43516 29.4743547,127.522877 C30.3679076,128.438219 29.7078429,129.945982 28.41029,129.951324 L8.99511941,129.953105 L9.92372529,123.399087 C9.92372529,123.399087 16.2790018,121.015753 18.5800194,121.494795"
                id="Fill-31"
                fill="#7BEAFF"
              />
            </g>
            <g id="Group-40" transform="translate(27.000000, 128.000000)">
              <g id="Group-36">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1" />
                </mask>
                <g id="Clip-35" />
                <path
                  d="M14.0748774,0.82272 C14.0846444,3.30672 7.4327,5.93892 1.0692,4.09992 C-5.2943,2.26032 6.26547778,-1.07328 6.26547778,-1.07328 L14.0748774,0.82272 Z"
                  id="Fill-34"
                  fill="#766DFF"
                  mask="url(#mask-2)"
                />
              </g>
              <g id="Group-39">
                <mask id="mask-4" fill="white">
                  <use xlink:href="#path-3" />
                </mask>
                <g id="Clip-38" />
                <polygon
                  id="Fill-37"
                  fill="#3424C7"
                  mask="url(#mask-4)"
                  points="-2.85804444 10.20012 22.7579 10.10472 22.7450667 6.81372 -2.87087778 6.90912"
                />
              </g>
            </g>
            <path
              d="M69.635396,129.059725 C74.9108843,130.085068 78.5391637,132.75876 80.5871258,134.718613 C81.4853863,135.577895 80.8224414,136.993313 79.5174553,136.998328 L60,137 L60.933498,130.847388 C60.933498,130.847388 67.3222559,128.610024 69.635396,129.059725"
              id="Fill-41"
              fill="#7BEAFF"
            />
            <g id="Group-49" transform="translate(59.000000, 128.000000)">
              <g id="Group-45">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#path-5" />
                </mask>
                <g id="Clip-44" />
                <path
                  d="M14.4159997,0.82272 C14.4257667,3.30672 7.77443333,5.93892 1.41093333,4.09992 C-4.95317778,2.26032 6.60721111,-1.07328 6.60721111,-1.07328 L14.4159997,0.82272 Z"
                  id="Fill-43"
                  fill="#766DFF"
                  mask="url(#mask-6)"
                />
              </g>
              <g id="Group-48">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-47" />
                <polygon
                  id="Fill-46"
                  fill="#3424C7"
                  mask="url(#mask-8)"
                  points="-2.51673889 10.20012 23.0985944 10.10472 23.0863722 6.81372 -2.52957222 6.90912"
                />
              </g>
            </g>
            <g id="Group-100">
              <path
                d="M34.5640612,8.67534784 L34.4953379,8.11671853 C35.0562845,8.0470375 35.2988718,7.90590388 35.3382262,7.79665819 C35.4122359,7.59470129 35.015168,7.15889957 34.8454155,6.97288664 C34.8072359,6.93095991 34.7719932,6.89257629 34.7420369,6.85832629 L35.1626,6.48689095 C35.1896194,6.51877888 35.2225126,6.55420991 35.2577553,6.59259353 C35.5555563,6.91974009 36.0554155,7.46774009 35.8633427,7.99093836 C35.728833,8.35942112 35.3035709,8.58322716 34.5640612,8.67534784"
                id="Fill-50"
                fill="#070000"
              />
              <g id="Group-54" transform="translate(23.495146, 0.000000)">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-53" />
                <path
                  d="M10.3794505,9.62135647 C8.35064466,11.9651194 4.81638738,12.2113651 2.48508155,10.1717185 C0.153775728,8.13207198 -0.091161165,4.57833922 1.93764466,2.23516681 C3.96703786,-0.108596121 7.50129515,-0.35484181 9.83201359,1.68539526 C12.1633194,3.72445129 12.4082563,7.27818405 10.3794505,9.62135647"
                  id="Fill-52"
                  fill="#766DFF"
                  mask="url(#mask-10)"
                />
              </g>
              <path
                d="M25.9802859,10.1715414 C23.6489801,8.13189483 23.4040432,4.57875259 25.432849,2.23558017 C27.4616549,-0.108182759 30.9964995,-0.354428448 33.327218,1.6852181 C32.5107617,5.92808448 29.4123393,9.47532155 25.9802859,10.1715414"
                id="Fill-55"
                fill="#000000"
              />
              <path
                d="M30.7186107,7.31148922 C30.7186107,6.42217026 30.0014214,5.70114871 29.1168291,5.70114871 C28.2322369,5.70114871 27.5144602,6.42217026 27.5144602,7.31148922 C27.5144602,8.20080819 28.2322369,8.92182974 29.1168291,8.92182974 C30.0014214,8.92182974 30.7186107,8.20080819 30.7186107,7.31148922"
                id="Fill-57"
                fill="#766DFF"
              />
              <path
                d="M26.2429617,2.28837241 C26.2429617,1.39905345 25.5257723,0.678031897 24.6411801,0.678031897 C23.7565879,0.678031897 23.0388112,1.39905345 23.0388112,2.28837241 C23.0388112,3.17769138 23.7565879,3.89871293 24.6411801,3.89871293 C25.5257723,3.89871293 26.2429617,3.17769138 26.2429617,2.28837241"
                id="Fill-59"
                fill="#7BEAFF"
              />
              <g id="Group-63">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-62" />
                <path
                  d="M23.2524408,1.51503103 C21.1214311,-0.960417241 16.5610233,1.21150517 14.595067,7.53417328 C13.2652417,11.8095181 13.757465,14.8122983 11.5172029,18.4888586 C9.06137282,22.5197293 4.16557184,23.6694664 1.53059126,27.322406 C-0.295568932,29.8539534 1.84953786,32.4162078 -0.000117475728,37.5885483 C2.21606214,39.7144103 5.59583883,40.1797379 7.74035825,41.245031 C11.0819553,36.9791345 6.82346019,36.2917724 9.93186796,31.963281 C9.83906214,34.7918586 11.362135,36.1665828 10.6778388,41.3861647 C12.6672903,42.5423974 13.5689165,43.3236517 14.9369214,43.5421431 C15.6517612,38.6042379 17.0914262,35.4868974 17.6100816,33.2913543 C18.7913,28.2908543 21.3088049,16.8808802 20.9675379,12.6025828 C20.5634214,7.53417328 20.6098243,3.40645776 22.8806301,3.01612586 C23.7963534,2.85845776 23.2524408,1.51503103 23.2524408,1.51503103"
                  id="Fill-61"
                  fill="#000000"
                  mask="url(#mask-12)"
                />
              </g>
              <path
                d="M33.0841607,6.16996034 L32.65185,5.81269741 C33.0976704,5.26765 34.116185,4.68776207 34.972583,4.71079224 L34.9602481,5.27296466 C34.3000345,5.25938276 33.4406995,5.7335681 33.0841607,6.16996034"
                id="Fill-64"
                fill="#070000"
              />
              <path
                d="M33.3273942,9.79467328 C33.3273942,10.1708328 33.0237194,10.4755397 32.6501466,10.4755397 C32.275399,10.4755397 31.9723117,10.1708328 31.9723117,9.79467328 C31.9723117,9.41851379 32.275399,9.1138069 32.6501466,9.1138069 C33.0237194,9.1138069 33.3273942,9.41851379 33.3273942,9.79467328"
                id="Fill-66"
                fill="#FF3D81"
              />
              <path
                d="M41.8864995,81.758175 C41.7161597,81.4251233 40.8139461,80.164369 39.6714947,78.5676103 C36.1666063,73.6704509 30.3004558,65.4740716 29.5768053,62.1742612 L30.1236549,62.0532052 C30.8220481,65.2396362 36.8743976,73.6958431 40.1255383,78.2392828 C41.3719558,79.9801276 42.1948733,81.1310457 42.3845966,81.5013 L41.8864995,81.758175 Z"
                id="Fill-68"
                fill="#FFFFFF"
              />
              <path
                d="M66.9989922,30.9116879 L57.0705311,9.19246379 C55.8998854,6.63316207 57.0258903,3.57605431 59.5721767,2.39974397 C62.1178757,1.22343362 65.158735,2.35486466 66.3287932,4.9147569 L76.2578417,26.633981"
                id="Fill-70"
                fill="#7BEAFF"
              />
              <path
                d="M46.2792694,62.0090345 L45.9491626,61.5543362 C48.7973617,59.4680388 49.5221869,55.296625 47.6731189,51.6354181 L48.1718034,51.3809052 C50.145983,55.2895388 49.350085,59.7591638 46.2792694,62.0090345"
                id="Fill-72"
                fill="#FFFFFF"
              />
              <path
                d="M23.2808699,30.1257095 C27.5969282,39.030119 35.494234,48.6898 41.4126612,48.6165759 C49.5308214,48.5167784 70.5155107,27.385119 70.5155107,27.385119 L65.0575883,19.2932612 L62.135967,22.1383733 C62.135967,22.1383733 46.4470835,36.5263259 43.0931515,36.0491879 C39.7979573,35.5809078 41.4161854,35.0895974 33.7849621,23.2131147 C30.2230981,17.6705198 19.7319282,22.8044767 23.2808699,30.1257095"
                id="Fill-74"
                fill="#766DFF"
              />
              <path
                d="M61.9692689,23.165519 C62.9795602,18.2571397 60.8285796,12.7818638 62.8021718,13.0859802 C64.3745845,13.3280922 65.2955942,20.9180103 65.2955942,20.9180103 L61.9692689,23.165519 Z"
                id="Fill-76"
                fill="#766DFF"
              />
              <path
                d="M64.6738539,18.9672957 C68.5534898,15.5718216 73.1720481,12.7509207 73.8070044,14.217175 C74.4413733,15.6828388 66.2991306,21.5206922 66.2991306,21.5206922 L64.6738539,18.9672957 Z"
                id="Fill-78"
                fill="#766DFF"
              />
              <path
                d="M66.0737534,20.8884845 C70.0626417,17.3571914 74.789865,14.3992905 75.4089621,15.8850319 C76.0274718,17.3713638 67.6778845,23.4684543 67.6778845,23.4684543 L66.0737534,20.8884845 Z"
                id="Fill-80"
                fill="#766DFF"
              />
              <path
                d="M68.3412112,19.4121914 L67.9823228,18.9805233 C71.7644539,15.801769 73.8772549,14.6650233 75.0443762,15.1781828 L74.8199976,15.6937043 C73.4702015,15.100825 69.609949,18.3457172 68.3412112,19.4121914"
                id="Fill-82"
                fill="#070000"
              />
              <path
                d="M67.0308282,23.6037418 C70.9104641,20.2082677 75.5290223,17.3873668 76.1639786,18.8536211 C76.798935,20.3192849 68.6561049,26.1571384 68.6561049,26.1571384 L67.0308282,23.6037418 Z"
                id="Fill-84"
                fill="#766DFF"
              />
              <path
                d="M69.2423675,22.1966573 L68.886416,21.7626272 C72.5710422,18.7072909 74.638615,17.6260539 75.8010374,18.1492522 L75.5719597,18.6624116 C74.2333238,18.0612651 70.4770374,21.1732909 69.2423675,22.1966573"
                id="Fill-86"
                fill="#070000"
              />
              <path
                d="M68.1955413,25.9375841 C71.7021917,23.0475927 76.5157597,20.4085711 77.1037257,21.8895884 C77.6916917,23.3700151 69.941818,27.785903 69.941818,27.785903 L68.1955413,25.9375841 Z"
                id="Fill-88"
                fill="#766DFF"
              />
              <path
                d="M70.6746903,24.5339246 L70.3369476,24.085722 C73.406001,21.7502263 75.4436175,20.5284461 76.776967,21.1963211 L76.5273311,21.7000323 C75.4612388,21.1662047 73.4171612,22.4470366 70.6746903,24.5339246"
                id="Fill-90"
                fill="#070000"
              />
              <path
                d="M50.5371772,31.9416681 L50.2311529,31.4710259 C51.1562743,30.8616121 58.3469636,25.705806 59.3607791,24.9056552 C60.5355364,23.9785431 61.510585,22.6498793 61.580483,21.8804353 L62.1379053,21.9318103 C62.0409879,22.9911983 60.8415607,24.4521379 59.7067451,25.3479526 C58.6882306,26.1516466 51.4664102,31.3298922 50.5371772,31.9416681"
                id="Fill-92"
                fill="#070000"
              />
              <path
                d="M64.7997291,33.5133888 L64.4214573,33.0988457 C65.330132,32.2609017 69.3107971,28.8317681 70.5783602,27.8556431 L70.7651466,27.7121474 C72.144899,26.6503974 75.8107291,23.8312681 76.6630155,22.4429621 L77.1393796,22.7382207 C76.2330544,24.2151043 72.6394718,26.978725 71.1046515,28.159169 L70.9184524,28.3020741 C69.6597,29.2717034 65.7037049,32.680169 64.7997291,33.5133888"
                id="Fill-94"
                fill="#070000"
              />
              <polygon
                id="Fill-96"
                fill="#E7E6FF"
                points="120.930807 116.46494 109.923331 130.779078 101.835715 127.666462 110.765632 109.51219"
              />
              <path
                d="M101.263667,127.731182 C95.7828364,128.8821 92.0212636,131.844725 89.8996519,134.014286 C88.9698316,134.965019 89.6647005,136.523984 91.0215451,136.523984 L109.951584,136.523984 L109.95922,129.668669 C109.95922,129.668669 103.666633,127.22629 101.263667,127.731182"
                id="Fill-98"
                fill="#FF3D81"
              />
            </g>
            <g id="Group-106" transform="translate(90.000000, 128.000000)">
              <g id="Group-103">
                <mask id="mask-14" fill="white">
                  <use xlink:href="#path-13" />
                </mask>
                <g id="Clip-102" />
                <path
                  d="M8.10131667,0.5950125 C8.10131667,3.0182625 15.1437611,5.5630125 21.8647611,3.745575 C28.58515,1.9281375 16.3500944,-1.283175 16.3500944,-1.283175 L8.10131667,0.5950125 Z"
                  id="Fill-101"
                  fill="#E7E6FF"
                  mask="url(#mask-14)"
                />
              </g>
              <mask id="mask-16" fill="white">
                <use xlink:href="#path-15" />
              </mask>
              <g id="Clip-105" />
              <polygon
                id="Fill-104"
                fill="#070000"
                mask="url(#mask-16)"
                points="-1.04072222 9.6823125 26.0418889 9.6823125 26.0418889 6.4715625 -1.04072222 6.4715625"
              />
            </g>
            <g id="Group-113" transform="translate(91.000000, 69.000000)">
              <path
                d="M2.22610794,61.2326 C2.12509206,61.2326 2.03582222,61.2409243 1.96064762,61.2528162 C1.25588571,61.3651946 0.85475873,61.8884378 0.780171429,62.3260595 C0.744346032,62.5377351 0.749044444,62.9289784 1.18658413,63.1686 C2.90385397,64.1122216 4.48310794,64.2341135 5.82215556,64.0818973 C4.25640952,61.6410865 2.93439365,61.2326 2.22610794,61.2326 L2.22610794,61.2326 Z M6.62382222,65.4786 C6.46231429,65.1664378 6.30256825,64.8768703 6.14517143,64.6081135 C4.67339365,64.8120595 2.86744127,64.7365459 0.919949206,63.6668703 C0.384330159,63.3725459 0.12591746,62.835627 0.22928254,62.2303297 C0.360250794,61.4585459 1.03682222,60.8270865 1.87372698,60.6933027 C3.75485397,60.3942216 5.41398095,62.3902757 6.42237778,63.9938973 C7.0590127,63.8815189 7.63221905,63.7203838 8.12790159,63.5806541 C9.00885397,63.3327081 9.59086984,63.1686 9.97672698,63.4314108 C10.1546794,63.5521135 10.2603937,63.7477351 10.2909333,64.0129243 L9.73534603,64.0789243 C9.7247746,63.985573 9.70069524,63.9261135 9.66486984,63.9017351 C9.49279048,63.7840054 8.8743619,63.9582216 8.27766349,64.1264919 C7.8383619,64.2501676 7.3180127,64.3964378 6.73306032,64.5100054 C6.88399683,64.771627 7.01379048,65.0112486 7.11950476,65.2151946 L6.62382222,65.4786 Z"
                id="Fill-107"
                fill="#070000"
              />
              <polygon
                id="Fill-109"
                fill="#E7E6FF"
                points="31.5585333 0.128967568 33.236454 17.0350757 24.8386286 19.1708595 18.6719619 3.18756216"
              />
              <path
                d="M24.4067857,19.5566919 C20.5775794,23.6920973 19.1909603,28.3204216 18.6935159,31.3421514 C18.4750397,32.6669081 19.9344841,33.5475027 21.0450714,32.7584757 L36.5404365,21.7543135 L32.6307698,16.0985297 C32.6307698,16.0985297 26.085881,17.743773 24.4067857,19.5566919"
                id="Fill-111"
                fill="#FF3D81"
              />
            </g>
            <g id="Group-120" transform="translate(109.000000, 84.000000)">
              <g id="Group-116">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#path-17" />
                </mask>
                <g id="Clip-115" />
                <path
                  d="M3.2146875,6.5852069 C4.7609375,8.77437931 12.2809375,6.96506897 16.7484375,1.40306897 C21.2159375,-4.15831034 8.9221875,0.0778965517 8.9221875,0.0778965517 L3.2146875,6.5852069 Z"
                  id="Fill-114"
                  fill="#E7E6FF"
                  mask="url(#mask-18)"
                />
              </g>
              <g id="Group-119">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#path-19" />
                </mask>
                <g id="Clip-118" />
                <polygon
                  id="Fill-117"
                  fill="#070000"
                  mask="url(#mask-20)"
                  points="24.034375 4.33036552 1.35875 20.1269172 -0.69 17.2264345 21.985625 1.42988276"
                />
              </g>
            </g>
            <g id="Group-188" transform="translate(96.000000, 20.000000)">
              <path
                d="M14.8777942,74.1427967 C13.8266362,74.1427967 13.2661381,74.5054078 13.0040947,74.7574522 C12.4823957,75.2591633 12.4501626,75.9201856 12.6405768,76.32203 C12.7325008,76.5164133 12.9635049,76.8320633 13.464909,76.7755911 C15.4376954,76.5491078 16.8207351,75.7317467 17.8480166,74.8275967 C16.5771959,74.3181578 15.6090085,74.1427967 14.8777942,74.1427967 M13.3491085,77.3486356 C12.8130836,77.3486356 12.3642076,77.0638967 12.1266375,76.5639689 C11.7911743,75.8559856 11.9893483,74.9458911 12.6095375,74.3502578 C14.0021277,73.0109744 16.5330246,73.6809133 18.2962958,74.4079189 C18.7612884,73.9448467 19.1451013,73.4799911 19.47758,73.0775522 C20.0679236,72.36303 20.4577056,71.8904467 20.9298612,71.8809112 C21.1381826,71.8791522 21.3476979,71.9754522 21.5267708,72.1739967 L21.1023681,72.5514689 C21.0396926,72.4813244 20.9776139,72.4474411 20.9417994,72.4468467 C20.7304933,72.4516022 20.316835,72.9527189 19.9163086,73.4371911 C19.622629,73.7938578 19.2740338,74.2159133 18.8526156,74.6492633 C19.1295816,74.7746911 19.3755084,74.8965522 19.5808453,75.0017689 L19.3199958,75.5052633 C19.0060213,75.3435744 18.7057758,75.1991244 18.4198561,75.0713189 C17.3137825,76.0931689 15.7671895,77.08173 13.5299721,77.3379356 C13.4690874,77.3450689 13.4087995,77.3486356 13.3491085,77.3486356"
                id="Fill-121"
                fill="#070000"
              />
              <path
                d="M9.86411117,100.909382 C13.9081741,103.822754 17.0879119,105.549615 20.1476708,106.970337 C23.0540239,103.995737 41.5970224,75.5283872 46.0362395,72.3171983 C52.2864806,67.7958539 64.427623,62.6764983 68.2753027,61.4323261 C78.005527,58.2859317 75.7313012,46.2056317 74.5935914,42.5563372 C69.917998,43.5627317 52.9227863,50.4208372 49.5741231,50.1693872 C44.7087125,52.3087928 35.6953766,57.2087983 28.4715759,63.6341483 C23.6121344,67.9569483 11.9174804,96.096165 9.86411117,100.909382"
                id="Fill-123"
                fill="#4C3BE3"
              />
              <path
                d="M14.5953962,62.2019533 C18.1416365,61.80962 22.7091892,60.9833422 28.5791987,59.7938589 C28.8776536,54.6210033 28.8758628,54.4165144 34.9416588,58.5443367 C39.1838957,56.5862367 49.8369424,52.5279644 54.1961736,50.97052 C50.0261628,46.4402589 25.399461,34.6429144 19.8076113,34.2654422 C14.2163586,33.88797 9.38318106,38.2250367 10.4253853,43.7955756 C11.4675896,49.3661144 13.0786488,57.6716922 14.5953962,62.2019533"
                id="Fill-125"
                fill="#4C3BE3"
              />
              <g id="Group-129" transform="translate(42.977495, 16.644444)">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#path-21" />
                </mask>
                <g id="Clip-128" />
                <path
                  d="M7.47969585,0.940232778 C19.3158175,-3.51691167 33.3646832,18.009705 36.4005657,24.7822106 C25.113601,30.8568383 14.0295855,34.7082439 2.49012802,36.9504883 C0.88563486,31.0916439 -3.44315398,5.05319389 7.47969585,0.940232778"
                  id="Fill-127"
                  fill="#FF3D81"
                  mask="url(#mask-22)"
                />
              </g>
              <path
                d="M28.856523,59.8572861 L28.3019939,59.7306694 C28.6064178,58.4098139 28.8195146,52.1057306 28.1772398,49.9371972 L28.7222183,49.7766972 C29.4009046,52.0670917 29.1776604,58.4615306 28.856523,59.8572861"
                id="Fill-130"
                fill="#070000"
              />
              <polygon
                id="Fill-132"
                fill="#070000"
                points="26.4003591 19.8733478 0.012176957 19.8733478 13.8169066 43.40562 40.2056857 43.40562"
              />
              <path
                d="M61.7637943,23.01249 C67.3425119,31.2919122 72.4138564,45.6061344 65.7803994,48.8732011 C57.4558973,52.9730844 32.6274401,46.7456844 32.6274401,46.7456844 L33.7251569,36.9641011 L37.6916216,38.12089 L54.8862012,39.88639 C54.8862012,39.88639 53.3652754,36.5628511 50.6582901,26.51139 C48.986943,20.30539 56.8715227,15.75254 61.7637943,23.01249"
                id="Fill-134"
                fill="#E7E6FF"
              />
              <path
                d="M61.3195741,22.3962294 C64.7894099,27.189235 67.3531369,32.5576628 68.0950956,36.7740572 C59.7705935,40.8739406 54.8860818,39.8859739 54.8860818,39.8859739 C54.8860818,39.8859739 53.365156,36.5630294 50.6581707,26.5115683 C48.9868237,20.3055683 56.2953855,15.4560906 61.3195741,22.3962294"
                id="Fill-136"
                fill="#FF3D81"
              />
              <path
                d="M38.32548,38.9573922 C35.1057493,35.0614033 34.4610868,29.1704589 32.8297327,30.3718311 C31.5302604,31.3288867 34.2766417,38.5240422 34.2766417,38.5240422 L38.32548,38.9573922 Z"
                id="Fill-138"
                fill="#E7E6FF"
              />
              <path
                d="M33.9165261,36.4931228 C28.8290651,35.297695 23.3470468,34.9624283 23.4670257,36.5674283 C23.5864076,38.1730228 33.6574674,39.5337061 33.6574674,39.5337061 L33.9165261,36.4931228 Z"
                id="Fill-140"
                fill="#E7E6FF"
              />
              <path
                d="M33.5624393,38.8642428 C28.3126189,37.5986706 22.6688381,37.1932594 22.8120964,38.808365 C22.9553547,40.424065 33.3344198,41.9184983 33.3344198,41.9184983 L33.5624393,38.8642428 Z"
                id="Fill-142"
                fill="#E7E6FF"
              />
              <path
                d="M30.828235,38.6180833 C29.1855396,38.2667667 24.1846305,37.1961722 23.2510638,38.3600944 L22.806963,38.0069944 C23.6151787,36.9994111 26.0493762,37.01665 30.9482138,38.0646556 L30.828235,38.6180833 Z"
                id="Fill-144"
                fill="#070000"
              />
              <path
                d="M33.9803955,41.73428 C28.8929345,40.5388522 23.4109162,40.2035856 23.530895,41.8085856 C23.6502769,43.41418 33.7213367,44.7748633 33.7213367,44.7748633 L33.9803955,41.73428 Z"
                id="Fill-146"
                fill="#E7E6FF"
              />
              <path
                d="M31.3289825,41.5235494 C29.7376213,41.1936328 24.8942964,40.1913994 23.9726678,41.3594828 L23.5255825,41.0099494 C24.3242476,39.9970161 26.6915913,39.9851272 31.4447829,40.9689328 L31.3289825,41.5235494 Z"
                id="Fill-148"
                fill="#070000"
              />
              <path
                d="M34.0319685,44.3622594 C29.5181376,43.441465 23.9465829,43.3594317 24.1155083,44.9561094 C24.2838369,46.5521928 33.3323904,46.8321761 33.3323904,46.8321761 L34.0319685,44.3622594 Z"
                id="Fill-150"
                fill="#E7E6FF"
              />
              <path
                d="M24.5443282,44.5158044 L24.0829171,44.1846989 C24.9669403,42.9613322 27.3748738,43.0885433 31.2344917,43.7222211 L31.1413738,44.2804044 C27.6924298,43.7144933 25.2504724,43.5379433 24.5443282,44.5158044"
                id="Fill-152"
                fill="#070000"
              />
              <path
                d="M48.4927615,11.1227094 C48.4927615,14.2500817 45.9469418,16.7853872 42.8066001,16.7853872 C39.6656615,16.7853872 37.1198418,14.2500817 37.1198418,11.1227094 C37.1198418,7.99533722 39.6656615,5.46003167 42.8066001,5.46003167 C45.9469418,5.46003167 48.4927615,7.99533722 48.4927615,11.1227094"
                id="Fill-154"
                fill="#E7E6FF"
              />
              <path
                d="M34.8372593,58.6707156 L34.5029899,58.2123989 C37.1920679,56.2673767 43.1725058,52.9806933 45.0241195,52.0658433 L45.2766123,52.5729044 C43.4375336,53.48181 37.5006702,56.7435267 34.8372593,58.6707156"
                id="Fill-156"
                fill="#070000"
              />
              <path
                d="M54.794098,40.0670417 C54.5786136,39.3013972 54.1022797,38.1202361 53.5507352,36.7524194 C52.3640788,33.8105139 50.7392907,29.7813694 50.3757727,26.5434306 L50.9404493,26.4804194 C51.2956105,29.641675 52.9036851,33.6298028 54.0778064,36.5413917 C54.635917,37.9246639 55.1176231,39.1189028 55.3414642,39.9142694 L54.794098,40.0670417 Z"
                id="Fill-158"
                fill="#070000"
              />
              <path
                d="M67.8179505,36.8373656 C67.4281685,35.1467656 64.1953058,26.3769267 61.5450269,23.1930822 L61.9825617,22.83166 C64.6859655,26.07911 67.9767284,34.9939933 68.3724796,36.7107489 L67.8179505,36.8373656 Z"
                id="Fill-160"
                fill="#070000"
              />
              <path
                d="M46.28145,3.76212 C46.28145,5.67325889 44.7259035,7.22238111 42.806242,7.22238111 C40.8871774,7.22238111 39.3316309,5.67325889 39.3316309,3.76212 C39.3316309,1.85098111 40.8871774,0.301264444 42.806242,0.301264444 C44.7259035,0.301264444 46.28145,1.85098111 46.28145,3.76212"
                id="Fill-162"
                fill="#070000"
              />
              <path
                d="M38.2965895,8.59079222 C38.2965895,10.93647 36.3870755,12.8380978 34.03167,12.8380978 C31.6768614,12.8380978 29.7673474,10.93647 29.7673474,8.59079222 C29.7673474,6.24511444 31.6768614,4.34348667 34.03167,4.34348667 C36.3870755,4.34348667 38.2965895,6.24511444 38.2965895,8.59079222"
                id="Fill-164"
                fill="#070000"
              />
              <path
                d="M52.3338752,11.1227094 C52.3338752,12.3276483 51.3525557,13.304915 50.1426198,13.304915 C48.932684,13.304915 47.9513645,12.3276483 47.9513645,11.1227094 C47.9513645,9.91777056 48.932684,8.94050389 50.1426198,8.94050389 C51.3525557,8.94050389 52.3338752,9.91777056 52.3338752,11.1227094"
                id="Fill-166"
                fill="#070000"
              />
              <path
                d="M51.2566323,7.87793444 C51.2566323,9.24634556 50.1427989,10.3555789 48.7693098,10.3555789 C47.3952238,10.3555789 46.2813903,9.24634556 46.2813903,7.87793444 C46.2813903,6.50952333 47.3952238,5.40088444 48.7693098,5.40088444 C50.1427989,5.40088444 51.2566323,6.50952333 51.2566323,7.87793444"
                id="Fill-168"
                fill="#070000"
              />
              <path
                d="M50.5434447,13.6209217 C50.5434447,14.5969994 49.7489579,15.388205 48.7688323,15.388205 C47.7893035,15.388205 46.9948168,14.5969994 46.9948168,13.6209217 C46.9948168,12.6448439 47.7893035,11.8536383 48.7688323,11.8536383 C49.7489579,11.8536383 50.5434447,12.6448439 50.5434447,13.6209217"
                id="Fill-170"
                fill="#070000"
              />
              <path
                d="M50.41493,4.81832889 C50.41493,6.40371222 49.1244113,7.68890111 47.5324533,7.68890111 C45.9404952,7.68890111 44.6499765,6.40371222 44.6499765,4.81832889 C44.6499765,3.23294556 45.9404952,1.94775667 47.5324533,1.94775667 C49.1244113,1.94775667 50.41493,3.23294556 50.41493,4.81832889"
                id="Fill-172"
                fill="#070000"
              />
              <path
                d="M41.1814539,4.09762444 C41.1814539,6.22930222 39.4456406,7.95794667 37.3051226,7.95794667 C35.1640076,7.95794667 33.4287913,6.22930222 33.4287913,4.09762444 C33.4287913,1.96594667 35.1640076,0.237302222 37.3051226,0.237302222 C39.4456406,0.237302222 41.1814539,1.96594667 41.1814539,4.09762444"
                id="Fill-174"
                fill="#070000"
              />
              <path
                d="M37.1199612,9.57679722 C41.1813345,8.52998056 45.6730797,10.606375 48.7692501,12.5519917 C49.1835054,10.5279083 47.5324533,5.96851944 47.5324533,5.96851944 L43.8877229,4.50856389 L38.991273,4.50856389 C38.991273,4.50856389 37.7520885,8.412875 37.1199612,9.57679722"
                id="Fill-176"
                fill="#070000"
              />
              <path
                d="M44.8920234,10.5201211 C43.6796999,9.98096 40.5423427,9.09583222 38.194697,9.44417667 L37.9714528,7.95033778 C40.8485574,7.52412111 43.8456408,8.40568222 45.0287157,8.93236 L44.8920234,10.5201211 Z"
                id="Fill-178"
                fill="#FF3D81"
              />
              <path
                d="M39.1167434,12.4715039 L38.7681482,12.0244817 C39.2665677,11.6386872 40.2210263,11.4900761 40.8459907,11.8824094 L40.5433575,12.3615317 C40.143428,12.1106761 39.4486252,12.2147039 39.1167434,12.4715039"
                id="Fill-180"
                fill="#070000"
              />
              <path
                d="M39.6099102,16.47907 C39.4445662,16.47907 39.2708655,16.4386478 39.1126844,16.3197589 C38.6787311,15.9940033 38.5593492,15.2241978 38.7372282,13.8973978 L39.300711,13.9722978 C39.1055215,15.4316589 39.3436884,15.7841644 39.4547136,15.8673867 C39.5573821,15.9446644 39.736455,15.9232644 40.0199871,15.8002144 L40.2468128,16.3191644 C40.1250432,16.37207 39.8785195,16.47907 39.6099102,16.47907"
                id="Fill-182"
                fill="#070000"
              />
              <path
                d="M43.4947773,14.6205989 C43.4947773,14.99926 43.1867719,15.3059933 42.8065404,15.3059933 C42.426309,15.3059933 42.1177067,14.99926 42.1177067,14.6205989 C42.1177067,14.2419378 42.426309,13.9352044 42.8065404,13.9352044 C43.1867719,13.9352044 43.4947773,14.2419378 43.4947773,14.6205989"
                id="Fill-184"
                fill="#FF3D81"
              />
              <path
                d="M46.7576645,9.85517556 C46.7576645,9.15670333 46.1894066,8.59079222 45.4880377,8.59079222 C44.7872658,8.59079222 44.2190078,9.15670333 44.2190078,9.85517556 C44.2190078,10.5530533 44.7872658,11.1195589 45.4880377,11.1195589 C46.1894066,11.1195589 46.7576645,10.5530533 46.7576645,9.85517556"
                id="Fill-186"
                fill="#E7E6FF"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END Entreprise.svg -->

  <!-- BEGIN Particulier.svg -->
  <svg
    v-else-if="name == 'Particulier'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="126px"
    height="140px"
    viewBox="0 0 126 140"
    version="1.1"
  >
    <!-- Generator: sketchtool 59.1 (101010) - https://sketch.com -->
    <desc>Created with sketchtool.</desc>
    <defs>
      <path
        d="M12.4070833,0.315724138 C6.51958333,2.34041379 2.77458333,6.20193103 0.730833333,8.94703448 L0.730833333,8.94703448 C-0.165416667,10.1507586 0.814166667,11.8332414 2.31083333,11.6565517 L2.31083333,11.6565517 L24.6841667,8.92593103 L24.0679167,1.85586207 C24.0679167,1.85586207 17.5791667,0.120413793 14.0129167,0.120413793 L14.0129167,0.120413793 C13.3608333,0.120413793 12.80625,0.178344828 12.4070833,0.315724138 L12.4070833,0.315724138 Z"
        id="path-1"
      />
      <polygon
        id="path-3"
        points="0.142849351 0.117794393 11.4691379 0.117794393 11.4691379 11.932828 0.142849351 11.932828"
      />
      <path
        d="M12.4791795,0.512142857 L14.0299487,5.09485714 C10.7618462,6.41914286 8.22358974,8.42957143 7.63446154,10.7905714 L7.63446154,10.7905714 C5.69682051,18.5511429 0.212512821,40.4472857 0.212512821,40.4472857 L0.212512821,40.4472857 L7.85312821,41.9571429 C9.32225641,36.1461429 15.1667692,12.7581429 15.5626667,6.86014286 L15.5626667,6.86014286 C15.777641,3.66171429 15.8908718,1.50471429 15.9499487,0.117857143 L15.9499487,0.117857143"
        id="path-5"
      />
      <path
        d="M12.4791795,0.512142857 L14.0299487,5.09485714 C10.7618462,6.41914286 8.22358974,8.42957143 7.63446154,10.7905714 L7.63446154,10.7905714 C5.69682051,18.5511429 0.212512821,40.4472857 0.212512821,40.4472857 L0.212512821,40.4472857 L7.85312821,41.9571429 C9.32225641,36.1461429 15.1667692,12.7581429 15.5626667,6.86014286 L15.5626667,6.86014286 C15.777641,3.66171429 15.8908718,1.50471429 15.9499487,0.117857143 L15.9499487,0.117857143"
        id="path-7"
      />
      <path
        d="M12.4791795,0.512142857 L14.0299487,5.09485714 C10.7618462,6.41914286 8.22358974,8.42957143 7.63446154,10.7905714 L7.63446154,10.7905714 C5.69682051,18.5511429 0.212512821,40.4472857 0.212512821,40.4472857 L0.212512821,40.4472857 L7.85312821,41.9571429 C9.32225641,36.1461429 15.1667692,12.7581429 15.5626667,6.86014286 L15.5626667,6.86014286 C15.777641,3.66171429 15.8908718,1.50471429 15.9499487,0.117857143 L15.9499487,0.117857143"
        id="path-9"
      />
      <path
        d="M12.4791795,0.512142857 L14.0299487,5.09485714 C10.7618462,6.41914286 8.22358974,8.42957143 7.63446154,10.7905714 L7.63446154,10.7905714 C5.69682051,18.5511429 0.212512821,40.4472857 0.212512821,40.4472857 L0.212512821,40.4472857 L7.85312821,41.9571429 C9.32225641,36.1461429 15.1667692,12.7581429 15.5626667,6.86014286 L15.5626667,6.86014286 C15.777641,3.66171429 15.8908718,1.50471429 15.9499487,0.117857143 L15.9499487,0.117857143"
        id="path-11"
      />
      <path
        d="M0.272580645,6.33519355 C0.170677419,9.83303226 2.92332258,12.7509032 6.42158065,12.8528065 L6.42158065,12.8528065 C9.919,12.9547097 12.836871,10.2016452 12.9391935,6.70380645 L12.9391935,6.70380645 C13.0406774,3.20596774 10.2876129,0.288096774 6.78977419,0.186193548 L6.78977419,0.186193548 C6.72729032,0.184096774 6.66480645,0.183258065 6.60274194,0.183258065 L6.60274194,0.183258065 C3.18877419,0.183258065 0.372806452,2.89983871 0.272580645,6.33519355"
        id="path-13"
      />
      <path
        d="M13.2620833,0.22748 C7.16916667,1.606 2.97833333,5.19904 0.612083333,7.83332 L0.612083333,7.83332 C-0.425,8.98744 0.340416667,10.89 1.8475,10.89572 L1.8475,10.89572 L24.3891667,10.89572 L24.64625,3.355 C24.64625,3.355 17.1904167,0.16148 13.9583333,0.16148 L13.9583333,0.16148 C13.69625,0.16148 13.4620833,0.18216 13.2620833,0.22748 L13.2620833,0.22748 Z"
        id="path-15"
      />
      <path
        d="M1.62291892,0.882892857 C3.56886486,12.74105 1.06075676,49.7188786 0.422054054,55.84055 L0.422054054,55.84055 L15.3989189,58.6025929 C15.3989189,58.6025929 16.1980541,23.5540643 15.3085405,11.9373857 L15.3085405,11.9373857 C15.0036757,7.95657143 11.9584865,5.80054286 8.00475676,4.99392857 L8.00475676,4.99392857 L8.00475676,0.206921429"
        id="path-17"
      />
      <path
        d="M1.62291892,0.882892857 C3.56886486,12.74105 1.06075676,49.7188786 0.422054054,55.84055 L0.422054054,55.84055 L15.3989189,58.6025929 C15.3989189,58.6025929 16.1980541,23.5540643 15.3085405,11.9373857 L15.3085405,11.9373857 C15.0036757,7.95657143 11.9584865,5.80054286 8.00475676,4.99392857 L8.00475676,4.99392857 L8.00475676,0.206921429"
        id="path-19"
      />
      <path
        d="M1.62291892,0.882892857 C3.56886486,12.74105 1.06075676,49.7188786 0.422054054,55.84055 L0.422054054,55.84055 L15.3989189,58.6025929 C15.3989189,58.6025929 16.1980541,23.5540643 15.3085405,11.9373857 L15.3085405,11.9373857 C15.0036757,7.95657143 11.9584865,5.80054286 8.00475676,4.99392857 L8.00475676,4.99392857 L8.00475676,0.206921429"
        id="path-21"
      />
      <path
        d="M1.62291892,0.882892857 C3.56886486,12.74105 1.06075676,49.7188786 0.422054054,55.84055 L0.422054054,55.84055 L15.3989189,58.6025929 C15.3989189,58.6025929 16.1980541,23.5540643 15.3085405,11.9373857 L15.3085405,11.9373857 C15.0036757,7.95657143 11.9584865,5.80054286 8.00475676,4.99392857 L8.00475676,4.99392857 L8.00475676,0.206921429"
        id="path-23"
      />
      <path
        d="M1.62291892,0.882892857 C3.56886486,12.74105 1.06075676,49.7188786 0.422054054,55.84055 L0.422054054,55.84055 L15.3989189,58.6025929 C15.3989189,58.6025929 16.1980541,23.5540643 15.3085405,11.9373857 L15.3085405,11.9373857 C15.0036757,7.95657143 11.9584865,5.80054286 8.00475676,4.99392857 L8.00475676,4.99392857 L8.00475676,0.206921429"
        id="path-25"
      />
      <path
        d="M1.62291892,0.882892857 C3.56886486,12.74105 1.06075676,49.7188786 0.422054054,55.84055 L0.422054054,55.84055 L15.3989189,58.6025929 C15.3989189,58.6025929 16.1980541,23.5540643 15.3085405,11.9373857 L15.3085405,11.9373857 C15.0036757,7.95657143 11.9584865,5.80054286 8.00475676,4.99392857 L8.00475676,4.99392857 L8.00475676,0.206921429"
        id="path-27"
      />
      <path
        d="M1.62291892,0.882892857 C3.56886486,12.74105 1.06075676,49.7188786 0.422054054,55.84055 L0.422054054,55.84055 L15.3989189,58.6025929 C15.3989189,58.6025929 16.1980541,23.5540643 15.3085405,11.9373857 L15.3085405,11.9373857 C15.0036757,7.95657143 11.9584865,5.80054286 8.00475676,4.99392857 L8.00475676,4.99392857 L8.00475676,0.206921429"
        id="path-29"
      />
      <path
        d="M1.62291892,0.882892857 C3.56886486,12.74105 1.06075676,49.7188786 0.422054054,55.84055 L0.422054054,55.84055 L15.3989189,58.6025929 C15.3989189,58.6025929 16.1980541,23.5540643 15.3085405,11.9373857 L15.3085405,11.9373857 C15.0036757,7.95657143 11.9584865,5.80054286 8.00475676,4.99392857 L8.00475676,4.99392857 L8.00475676,0.206921429"
        id="path-31"
      />
      <polygon
        id="path-33"
        points="0 143 136.740288 143 136.740288 0.116769231 0 0.116769231"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Inscription-1" transform="translate(-1120.000000, -537.000000)">
        <g id="Particulier" transform="translate(975.000000, 476.000000)">
          <g
            id="Illustration-Particulier"
            transform="translate(134.000000, 61.000000)"
          >
            <path
              d="M23.8728759,128.202935 C18.0566801,130.306758 14.3577097,134.31963 12.3384431,137.171594 C11.4531104,138.422364 12.4207614,140.170606 13.8991971,139.98658 L36,137.149665 L35.3912566,129.803268 C35.3912566,129.803268 26.4230952,127.280228 23.8728759,128.202935"
              id="Fill-1"
              fill="#FFFFFF"
            />
            <g id="Group-5" transform="translate(11.000000, 128.000000)">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1" />
              </mask>
              <g id="Clip-4" />
              <polygon
                id="Fill-3"
                fill="#4C3BE3"
                mask="url(#mask-2)"
                points="-10.155875 10.6473103 -9.695875 14.4827586 28.161625 9.97572414 27.701625 6.14027586"
              />
            </g>
            <g id="Group-41" transform="translate(14.000000, 0.000000)">
              <polygon
                id="Fill-6"
                fill="#070000"
                points="8.37873005 129.643527 20.2344443 131.232044 27.9460601 110.603514 17.673932 107.191745"
              />
              <path
                d="M28.6587163,73.8238798 C22.6785389,77.2121757 18.2751695,82.8500885 16.4119773,89.5020573 L3.4069133,116.959674 L22.7780956,124.175007 L38.3673961,94.2198081 L70.1200365,94.3939389 L69.7459576,75.2438143 L28.6587163,73.8238798 Z"
                id="Fill-8"
                fill="#4C3BE3"
              />
              <path
                d="M5.90781872,130.499201 L5.97729655,134.397939 L3.06981872,132.13125 C2.95543448,132.042051 2.79995665,132.029674 2.6732867,132.098814 C2.5461931,132.167955 2.47163153,132.305808 2.4834936,132.450917 L2.75208473,135.809764 L0.4644,134.138877 L0.0365182266,134.733824 L2.96517833,136.873328 C3.02872512,136.919849 3.10371034,136.943322 3.17911921,136.943322 C3.24054778,136.943322 3.30197635,136.927531 3.35789754,136.895948 C3.48160197,136.825528 3.55404532,136.688955 3.5426069,136.546406 L3.27655764,133.221275 L6.13235074,135.447419 C6.24334581,135.534057 6.3937399,135.548568 6.51913892,135.485403 C6.64411429,135.421811 6.72248867,135.29164 6.72000682,135.149945 L6.63733596,130.48597 L5.90781872,130.499201 Z"
                id="Fill-10"
                fill="#070000"
              />
              <path
                d="M42.3874512,11.8074368 L38.098466,8.85233396 L31.6310966,15.6395956 C31.6310966,15.6395956 32.0568601,46.1794991 41.7282591,46.846147 C54.3228108,47.7138137 67.3689685,49.528957 67.3689685,49.528957 L74.9822985,34.8981252 L47.5355892,34.3023246 L42.3874512,11.8074368 Z"
                id="Fill-12"
                fill="#070000"
              />
              <path
                d="M42.5345409,2.55225452 C40.5213783,2.82838847 38.14727,10.9544944 38.14727,10.9544944 L42.4875163,12.3351642 C42.7370433,6.76425763 46.3719202,2.02602087 42.5345409,2.55225452"
                id="Fill-14"
                fill="#070000"
              />
              <g id="Group-18" transform="translate(28.807882, 0.000000)">
                <mask id="mask-4" fill="white">
                  <use xlink:href="#path-3" />
                </mask>
                <g id="Clip-17" />
                <path
                  d="M0.237453202,0.464946417 C-0.8758867,3.78068785 8.20495074,11.932828 8.20495074,11.932828 L11.4691379,10.879934 C7.50508867,5.074719 0.888596059,-1.47396636 0.237453202,0.464946417"
                  id="Fill-16"
                  fill="#070000"
                  mask="url(#mask-4)"
                />
              </g>
              <path
                d="M30.2618749,16.6992757 C29.3451064,16.3475997 28.3186138,16.8012788 27.9483478,17.7163193 C27.5683379,18.6552601 28.0216384,19.7312009 28.9591655,20.1003754 C32.3118946,21.4187336 34.1170473,21.3495935 34.5089192,19.827229 C34.8088601,18.6608084 32.1136286,17.4098832 30.2618749,16.6992757"
                id="Fill-19"
                fill="#070000"
              />
              <path
                d="M29.8156493,19.8543729 L29.5373143,20.5338246 C31.1751271,21.2154103 32.0558857,21.5495879 32.7108414,21.5495879 C33.3310581,21.5495879 33.7491961,21.2504072 34.4160138,20.6635692 L33.9364473,20.1104477 C32.8523389,21.0643262 32.810398,21.1018838 29.8156493,19.8543729"
                id="Fill-21"
                fill="#FFFFFF"
              />
              <path
                d="M31.4932847,13.5454589 C30.5765163,13.1937829 29.5504473,13.647462 29.1797576,14.5625025 C28.7997478,15.5014433 29.2530483,16.5778109 30.1905754,16.9465586 C33.5433044,18.2653436 35.3484571,18.1962034 35.7403291,16.6738389 C36.04027,15.5069916 33.3450384,14.2560664 31.4932847,13.5454589"
                id="Fill-23"
                fill="#070000"
              />
              <path
                d="M30.950468,16.7876642 L30.672133,17.4666891 C32.3103695,18.1487016 33.1911281,18.4828791 33.8460837,18.4828791 C34.4663005,18.4828791 34.8844384,18.1836984 35.5508325,17.5968604 L35.071266,17.0437389 C33.9871576,17.9976174 33.9447931,18.0347483 30.950468,16.7876642"
                id="Fill-25"
                fill="#FFFFFF"
              />
              <path
                d="M32.5271488,10.470385 C31.6108039,10.118709 30.5843113,10.572815 30.2136217,11.4878555 C29.8336118,12.4263695 30.2869123,13.5027371 31.2244394,13.8719115 C34.5771685,15.1902698 36.3823212,15.1211296 36.7741931,13.5987651 C37.0745576,12.4319178 34.3789025,11.1814193 32.5271488,10.470385"
                id="Fill-27"
                fill="#070000"
              />
              <path
                d="M31.9847557,13.7130171 L31.705997,14.3920421 C33.3285586,15.0676526 34.2135537,15.3984159 34.874864,15.3984159 C35.4997409,15.3984159 35.9250808,15.1026495 36.5846966,14.5222134 L36.10513,13.9686651 C35.0210217,14.9225436 34.9786571,14.9596745 31.9847557,13.7130171"
                id="Fill-29"
                fill="#FFFFFF"
              />
              <path
                d="M33.9110286,7.68497445 C33.1027133,7.43700872 32.2321222,7.77332025 31.7966148,8.50270654 C31.1721616,9.54877196 31.7046837,10.9136505 32.8722502,11.241853 C35.5543488,11.9964199 37.2196985,11.6613888 37.5408217,10.2606598 C37.8094128,9.09082492 35.4912256,8.17023614 33.9110286,7.68497445"
                id="Fill-31"
                fill="#070000"
              />
              <path
                d="M33.0728463,10.5391411 L32.8021369,11.2211536 C33.8659103,11.649652 34.726334,11.9684651 35.5066887,11.9684651 C36.1658808,11.9684651 36.7678808,11.7405586 37.386403,11.1579885 L36.8886197,10.621085 C35.9006788,11.5510632 35.057201,11.3372408 33.0728463,10.5391411"
                id="Fill-33"
                fill="#FFFFFF"
              />
              <polygon
                id="Fill-35"
                fill="#FF3D81"
                points="75.4458512 34.3227679 83.2811714 34.4559268 85.8692207 28.6383349 75.8288266 29.6536713"
              />
              <path
                d="M74.6457123,34.5224209 L65.9847074,71.2315922 L82.1349143,74.1201156 L83.9803133,33.8630283 C83.9803133,33.8630283 80.2890916,33.0265174 74.6457123,34.5224209"
                id="Fill-37"
                fill="#FF3D81"
              />
              <path
                d="M76.6284571,29.5659657 L73.0444177,29.9586137 L74.645797,34.5222928 C71.2706148,35.8410779 68.6499448,37.8435826 68.0411665,40.1943489 C66.0407133,47.9231121 60.376999,69.7278785 60.376999,69.7278785 L68.2669695,71.2314642 C69.7840433,65.4441745 75.8188709,42.1537477 76.228536,36.2802461 C76.4505261,33.0951028 76.5670286,30.9466355 76.6284571,29.5659657"
                id="Fill-39"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-54" transform="translate(75.000000, 28.000000)">
              <g id="Group-44">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#path-5" />
                </mask>
                <g id="Clip-43" />
                <path
                  d="M-6.67491282,43.4885143 C-16.2486564,43.4885143 -24.0377846,35.3520857 -24.0377846,25.3505143 C-24.0377846,15.3493714 -16.2486564,7.21251429 -6.67491282,7.21251429 C2.89883077,7.21251429 10.687959,15.3493714 10.687959,25.3505143 C10.687959,35.3520857 2.89883077,43.4885143 -6.67491282,43.4885143 M-6.67491282,6.47494286 C-16.6379897,6.47494286 -24.7438359,14.9426571 -24.7438359,25.3505143 C-24.7438359,35.7588 -16.6379897,44.2265143 -6.67491282,44.2265143 C3.28857436,44.2265143 11.3940103,35.7588 11.3940103,25.3505143 C11.3940103,14.9426571 3.28857436,6.47494286 -6.67491282,6.47494286"
                  id="Fill-42"
                  fill="#E7E6FF"
                  mask="url(#mask-6)"
                />
              </g>
              <g id="Group-47">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-46" />
                <path
                  d="M-6.67491282,41.4511286 C-15.1733744,41.4511286 -22.0874256,34.2284143 -22.0874256,25.3505571 C-22.0874256,16.4727 -15.1733744,9.24998571 -6.67491282,9.24998571 C1.82354872,9.24998571 8.7376,16.4727 8.7376,25.3505571 C8.7376,34.2284143 1.82354872,41.4511286 -6.67491282,41.4511286 M-6.67491282,8.51241429 C-15.5627077,8.51241429 -22.7934769,16.0659857 -22.7934769,25.3505571 C-22.7934769,34.6355571 -15.5627077,42.1891286 -6.67491282,42.1891286 C2.21329231,42.1891286 9.44406154,34.6355571 9.44406154,25.3505571 C9.44406154,16.0659857 2.21329231,8.51241429 -6.67491282,8.51241429"
                  id="Fill-45"
                  fill="#E7E6FF"
                  mask="url(#mask-8)"
                />
              </g>
              <g id="Group-50">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-49" />
                <path
                  d="M-6.67491282,39.4137429 C-14.0980923,39.4137429 -20.1370667,33.1047429 -20.1370667,25.3506 C-20.1370667,17.5960286 -14.0980923,11.2874571 -6.67491282,11.2874571 C0.748266667,11.2874571 6.78724103,17.5960286 6.78724103,25.3506 C6.78724103,33.1047429 0.748266667,39.4137429 -6.67491282,39.4137429 M-6.67491282,10.5494571 C-14.4874256,10.5494571 -20.8435282,17.1893143 -20.8435282,25.3506 C-20.8435282,33.5118857 -14.4874256,40.1517429 -6.67491282,40.1517429 C1.1376,40.1517429 7.49370256,33.5118857 7.49370256,25.3506 C7.49370256,17.1893143 1.1376,10.5494571 -6.67491282,10.5494571"
                  id="Fill-48"
                  fill="#E7E6FF"
                  mask="url(#mask-10)"
                />
              </g>
              <g id="Group-53">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-52" />
                <path
                  d="M-6.67470769,37.3763571 C-13.0226051,37.3763571 -18.1869128,31.9815 -18.1869128,25.3502143 C-18.1869128,18.7193571 -13.0226051,13.3245 -6.67470769,13.3245 C-0.327220513,13.3245 4.83708718,18.7193571 4.83708718,25.3502143 C4.83708718,31.9815 -0.327220513,37.3763571 -6.67470769,37.3763571 M-6.67470769,12.5869286 C-13.4119385,12.5869286 -18.8929641,18.3126429 -18.8929641,25.3502143 C-18.8929641,32.3882143 -13.4119385,38.1143571 -6.67470769,38.1143571 C0.0621128205,38.1143571 5.54313846,32.3882143 5.54313846,25.3502143 C5.54313846,18.3126429 0.0621128205,12.5869286 -6.67470769,12.5869286"
                  id="Fill-51"
                  fill="#E7E6FF"
                  mask="url(#mask-12)"
                />
              </g>
            </g>
            <path
              d="M98.997189,20.6890648 C99.1017291,17.1007088 96.2774255,14.1073289 92.6890756,14.0027886 C89.101156,13.8986786 86.1073511,16.7225569 86.002811,20.3109129 C85.8982709,23.8992689 88.7225745,26.8926487 92.3109244,26.997189 C95.8992742,27.1017293 98.8926489,24.2774208 98.997189,20.6890648"
              id="Fill-55"
              fill="#070000"
            />
            <g id="Group-59" transform="translate(86.000000, 14.000000)">
              <mask id="mask-14" fill="white">
                <use xlink:href="#path-13" />
              </mask>
              <g id="Clip-58" />
              <path
                d="M7.71256452,15.1539323 L14.9900484,14.0078355 L16.7156935,1.38064194 L6.36391935,-0.731648387 C2.23369355,7.0369 12.0021452,7.11070645 7.71256452,15.1539323"
                id="Fill-57"
                fill="#070000"
                mask="url(#mask-14)"
              />
            </g>
            <g id="Group-76" transform="translate(11.000000, 6.000000)">
              <path
                d="M79.1055489,14.5095728 C78.7707361,14.5446262 78.2935123,14.7194709 77.9221516,15.354233 L78.5455671,15.7229272 C78.7228457,15.4192718 78.9303708,15.2587864 79.1794849,15.2326019 C79.7839963,15.1679854 80.5435215,15.8483592 80.7863342,16.1152718 L81.3211105,15.6257913 C81.2068457,15.4999369 80.1759416,14.4006117 79.1055489,14.5095728"
                id="Fill-60"
                fill="#FFFFFF"
              />
              <path
                d="M80.6599708,18.3056024 C80.2058521,18.2920879 79.8273498,18.6510684 79.8143269,19.1076073 C79.800884,19.5641461 80.1583817,19.9450879 80.6120804,19.9581801 C81.0661991,19.9712723 81.4451215,19.6122917 81.4581443,19.1561752 C81.4715872,18.6996364 81.1140895,18.3186947 80.6599708,18.3056024"
                id="Fill-62"
                fill="#FF3D81"
              />
              <path
                d="M76.4420018,18.791451 C76.718842,19.2961354 78.3349333,18.834951 78.3349333,18.834951 L77.2086685,16.2764752 C76.3684858,18.2559364 76.2395178,18.4214898 76.4420018,18.791451"
                id="Fill-64"
                fill="#000000"
              />
              <path
                d="M78.2362119,18.4850083 C77.6069151,18.6640762 76.8851982,18.7219354 76.7587507,18.6159306 C76.6764128,18.4651587 76.7117005,18.3549306 77.2317735,17.1432655 C77.3220932,16.9329451 77.4250155,16.693484 77.5413808,16.4189694 C77.6195178,16.2344112 77.5342393,16.0207121 77.3506594,15.9421587 C77.1670795,15.863183 76.9545132,15.948916 76.8763763,16.1338966 C76.7604311,16.4071442 76.6579288,16.646183 76.5676091,16.8552364 C75.9727598,18.2421684 75.8652164,18.4926102 76.1256731,18.9668869 C76.3033717,19.2916587 76.7053991,19.3938626 77.1389333,19.3938626 C77.6174174,19.3938626 78.1349699,19.2696976 78.4336548,19.1843869 C78.6256365,19.129484 78.7369607,18.9288772 78.6823489,18.7358723 C78.6281571,18.5424451 78.4277735,18.4313723 78.2362119,18.4850083"
                id="Fill-66"
                fill="#FFFFFF"
              />
              <path
                d="M82.5245041,0.0315902913 C82.5245041,0.0315902913 77.6409425,8.40217282 76.9818192,11.7242214 C76.9818192,11.7242214 78.2147872,9.98591068 78.9743123,11.9940903 C81.7658192,11.8137553 83.2025315,14.9052117 83.4234995,16.344935 L89.1657279,15.9340078 C90.3583671,11.7770126 91.7093808,2.91737184 91.7093808,2.91737184 C91.7093808,2.91737184 86.4368146,-0.244191262 82.5245041,0.0315902913"
                id="Fill-68"
                fill="#3424C7"
              />
              <path
                d="M83.1460292,1.20989126 C82.9301023,1.33321165 82.6612438,1.48693981 82.3982667,1.75131845 C81.8298831,2.32273107 81.8639105,3.47695922 81.8823945,4.09693981 C81.8853352,4.17760485 81.8870155,4.24686699 81.8870155,4.30134757 C81.8870155,4.55474563 81.5463215,4.97792039 81.2778831,5.13376019 C80.8577918,5.37744466 80.7006776,6.12370194 80.5250795,7.15123107 L80.490632,7.35141553 C80.4662667,7.48909515 80.3641845,7.57862913 80.1545589,7.75178447 C79.7974813,8.0469932 79.308495,8.45158544 79.0471982,9.47911456 L79.7474904,9.65944951 C79.9503945,8.86209029 80.3028511,8.57068252 80.6141388,8.31306117 C80.8682941,8.10316311 81.1308511,7.88650777 81.2026868,7.47811456 L81.2379744,7.27412913 C81.3077096,6.86658058 81.470705,5.91084757 81.6391616,5.76303204 C82.0306868,5.53581845 82.6104128,4.91414854 82.6104128,4.30134757 C82.6104128,4.24179903 82.6078922,4.16451262 82.6053717,4.07497864 C82.5923489,3.63828932 82.5616822,2.6149835 82.9095178,2.26529417 C83.1031799,2.07017767 83.3161662,1.9485466 83.5035269,1.84127476 C83.8030521,1.67023107 84.1429059,1.47595922 84.1429059,1.04095922 L83.42539,1.02406602 C83.3985041,1.06545437 83.2527324,1.14823107 83.1460292,1.20989126"
                id="Fill-70"
                fill="#070000"
              />
              <path
                d="M84.7000731,4.44417961 L83.9909589,4.30269903 C83.9107215,4.70855825 84.13379,5.0502233 84.3131689,5.32431553 C84.3808037,5.42736408 84.4938082,5.60051942 84.488347,5.65711165 C84.0871598,6.06043689 83.3646027,6.58074757 83.3574612,6.58581553 C83.2948676,6.63100485 83.2482374,6.6947767 83.2242922,6.76826214 C83.2121096,6.80416019 82.9365297,7.65473301 82.93821,8.23163592 C82.9092237,8.30934466 82.6563288,8.4740534 82.4891324,8.58301456 C82.0795434,8.84950485 81.5191416,9.21482039 81.2549041,9.86098544 L81.9236895,10.1371893 C82.1018082,9.70092233 82.5164384,9.43147573 82.8819178,9.19328155 C83.264621,8.94368447 83.6595068,8.68648544 83.6595068,8.24219417 C83.6595068,7.9043301 83.7951963,7.37979612 83.8771142,7.10528155 C84.1001826,6.94015049 84.6458813,6.52668932 84.9995982,6.17150971 C85.4415342,5.72679612 85.1134429,5.22506796 84.9176804,4.92521359 C84.8050959,4.75290291 84.6778082,4.55820874 84.7000731,4.44417961"
                id="Fill-72"
                fill="#070000"
              />
              <path
                d="M13.3708767,76.6601767 C7.22788128,77.9833369 3.00260274,81.4320845 0.617324201,83.9601524 C-0.428703196,85.0683466 0.343424658,86.8940796 1.86247489,86.8999922 L24.5898356,86.8999922 L24.8486119,79.6616767 C24.8486119,79.6616767 16.0645023,76.0798951 13.3708767,76.6601767"
                id="Fill-74"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-79" transform="translate(11.000000, 82.000000)">
              <mask id="mask-16" fill="white">
                <use xlink:href="#path-15" />
              </mask>
              <g id="Clip-78" />
              <polygon
                id="Fill-77"
                fill="#4C3BE3"
                mask="url(#mask-16)"
                points="-10.4167083 12.331836 27.711625 12.451956 27.726625 8.344556 -10.4017083 8.224436"
              />
            </g>
            <g id="Group-92" transform="translate(16.000000, 27.000000)">
              <polygon
                id="Fill-80"
                fill="#070000"
                points="8.32088839 55.5750658 19.7863705 58.6012723 29.8422723 39.1193497 20.1522991 34.4818916"
              />
              <path
                d="M66.3320232,36.79632 C64.4566393,32.7209265 53.8178536,7.51531355 43.9465946,6.56533935 C30.4605321,5.26748129 13.6089339,44.5085265 13.6089339,44.5085265 L33.7782286,50.3041781 L40.996925,37.1327071 C42.2621482,39.8821394 46.7615589,51.6799587 49.6482821,59.313391 C51.1669696,63.3295974 54.9836214,65.9666168 59.2232732,65.92954 L72.3157107,65.8146039 C79.4467018,65.7524361 85.3615679,60.1982168 85.9738268,52.9888877 L87.3683,46.8125652 C73.3757286,43.7041781 69.0504696,42.7031071 69.0504696,42.7031071 C67.7969964,39.979649 67.0609429,38.38032 66.3320232,36.79632"
                id="Fill-82"
                fill="#766DFF"
              />
              <path
                d="M5.73110446,56.3597419 L5.01855089,56.480671 L5.30894375,58.2473419 L2.89222054,57.206671 C2.76548839,57.1521677 2.61861339,57.1760129 2.51412232,57.2679871 C2.40963125,57.3599613 2.36640804,57.5043097 2.40249732,57.6397161 L2.92033661,59.5903355 L0.24763125,58.7161548 L0.0260598214,59.4140516 L3.33116696,60.4947484 C3.36767589,60.5062452 3.40502411,60.5122065 3.44195268,60.5122065 C3.53343482,60.5122065 3.62323839,60.4768645 3.69122054,60.4112903 C3.78689911,60.3184645 3.82508661,60.1805032 3.79067589,60.0502065 L3.29297946,58.1758065 L5.63206875,59.1824129 C5.75292589,59.2343613 5.89308661,59.2156258 5.99673839,59.1330194 C6.09997054,59.0499871 6.15116696,58.9167097 6.12934554,58.7847097 L5.73110446,56.3597419 Z"
                id="Fill-84"
                fill="#070000"
              />
              <path
                d="M69.5121187,56.0536723 C63.3353955,56.0536723 54.5879402,37.1674529 49.3612884,25.8831561 C46.905958,20.5818658 45.5924759,17.7877239 44.890833,17.1826529 C44.269342,16.6465626 43.6671545,16.4575045 43.1006366,16.6218658 C41.555092,17.0685368 40.626842,20.00064 39.221458,24.4383948 L38.910083,25.4194529 C37.9671455,28.3822142 35.8664134,28.8991432 33.6427259,29.4471561 C31.5730473,29.9568465 29.4328688,30.4839948 28.4060027,33.0843948 C27.524333,35.3160465 28.017833,37.5106529 28.4953866,39.6332981 C29.1491902,42.5432594 29.7673241,45.2914142 26.9930652,48.1068465 L27.5037705,48.6250529 C30.5604491,45.5234787 29.868458,42.4461755 29.1995473,39.47064 C28.7261902,37.3646013 28.2788509,35.3756594 29.0761723,33.356911 C29.9649759,31.1073755 31.8340652,30.6466529 33.8131009,30.1591045 C36.0241991,29.6144981 38.5298866,28.9970787 39.597458,25.6447045 L39.9092527,24.6627948 C41.1471991,20.7538916 42.124967,17.666369 43.298708,17.3265755 C43.6226723,17.2324723 43.9906991,17.3683045 44.4229312,17.741311 C45.037708,18.27144 46.7385205,21.943169 48.7074848,26.1948465 C54.3500027,38.3767432 62.8763062,56.786911 69.5121187,56.786911 C72.2162973,56.786911 74.5075473,55.4992723 76.1382795,53.0640852 C77.3544045,51.2467432 77.7706902,49.4532465 77.7878955,49.3774529 L77.0837348,49.2130916 C77.068208,49.2816465 75.4634937,56.0536723 69.5121187,56.0536723"
                id="Fill-86"
                fill="#070000"
              />
              <path
                d="M71.282508,44.7261561 L70.6673116,45.1102335 C71.9870884,47.2869561 74.3614277,48.8743626 77.533508,49.7021303 C79.7278205,50.2739884 81.5675348,50.3016658 81.8982134,50.3016658 C81.9250705,50.3016658 81.9422759,50.30124 81.9485705,50.30124 L81.9393384,49.5684271 C81.8654812,49.5709819 74.2422491,49.6076013 71.282508,44.7261561"
                id="Fill-88"
                fill="#070000"
              />
              <path
                d="M93.3289071,12.0613084 C93.0330589,8.03914065 90.0775143,5.86071484 86.2411393,5.04529548 L86.2411393,0.208985806 L80.0484696,0.891979355 C81.9368625,12.8733213 79.5029339,50.2352826 78.8827018,56.4205471 L93.4170321,59.2108568 C93.4170321,59.2108568 94.1925321,23.7986632 93.3289071,12.0613084"
                id="Fill-90"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-117" transform="translate(94.000000, 28.000000)">
              <g id="Group-95">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#path-17" />
                </mask>
                <g id="Clip-94" />
                <path
                  d="M-2.61932973,55.6489686 C-12.710573,55.6489686 -20.9207351,47.6477257 -20.9207351,37.8132686 C-20.9207351,27.9788114 -12.710573,19.9771471 -2.61932973,19.9771471 C7.47234595,19.9771471 15.6820757,27.9788114 15.6820757,37.8132686 C15.6820757,47.6477257 7.47234595,55.6489686 -2.61932973,55.6489686 M-2.61932973,19.25229 C-13.1209514,19.25229 -21.6649514,27.5788757 -21.6649514,37.8132686 C-21.6649514,48.0476614 -13.1209514,56.3742471 -2.61932973,56.3742471 C7.88272432,56.3742471 16.4262919,48.0476614 16.4262919,37.8132686 C16.4262919,27.5788757 7.88272432,19.25229 -2.61932973,19.25229"
                  id="Fill-93"
                  fill="#E7E6FF"
                  mask="url(#mask-18)"
                />
              </g>
              <g id="Group-98">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#path-19" />
                </mask>
                <g id="Clip-97" />
                <path
                  d="M-2.61932973,53.6451179 C-11.5771676,53.6451179 -18.8649514,46.5427821 -18.8649514,37.8133107 C-18.8649514,29.0834179 -11.5771676,21.9806607 -2.61932973,21.9806607 C6.33850811,21.9806607 13.6262919,29.0834179 13.6262919,37.8133107 C13.6262919,46.5427821 6.33850811,53.6451179 -2.61932973,53.6451179 M-2.61932973,21.2558036 C-11.9875459,21.2558036 -19.6096,28.6834821 -19.6096,37.8133107 C-19.6096,46.9431393 -11.9875459,54.3708179 -2.61932973,54.3708179 C6.74931892,54.3708179 14.3709405,46.9431393 14.3709405,37.8133107 C14.3709405,28.6834821 6.74931892,21.2558036 -2.61932973,21.2558036"
                  id="Fill-96"
                  fill="#E7E6FF"
                  mask="url(#mask-20)"
                />
              </g>
              <g id="Group-101">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#path-21" />
                </mask>
                <g id="Clip-100" />
                <path
                  d="M-2.61932973,51.64211 C-10.4437622,51.64211 -16.8091676,45.43826 -16.8091676,37.8133529 C-16.8091676,30.1880243 -10.4437622,23.9841743 -2.61932973,23.9841743 C5.2051027,23.9841743 11.5705081,30.1880243 11.5705081,37.8133529 C11.5705081,45.43826 5.2051027,51.64211 -2.61932973,51.64211 M-2.61932973,23.2584743 C-10.8537081,23.2584743 -17.5533838,29.7880886 -17.5533838,37.8133529 C-17.5533838,45.8386171 -10.8537081,52.3673886 -2.61932973,52.3673886 C5.61548108,52.3673886 12.3151568,45.8386171 12.3151568,37.8133529 C12.3151568,29.7880886 5.61548108,23.2584743 -2.61932973,23.2584743"
                  id="Fill-99"
                  fill="#E7E6FF"
                  mask="url(#mask-22)"
                />
              </g>
              <g id="Group-104">
                <mask id="mask-24" fill="white">
                  <use xlink:href="#path-23" />
                </mask>
                <g id="Clip-103" />
                <path
                  d="M-2.61932973,49.6386807 C-9.30992432,49.6386807 -14.7538162,44.3337379 -14.7538162,37.8129736 C-14.7538162,31.2926307 -9.30992432,25.9876879 -2.61932973,25.9876879 C4.0716973,25.9876879 9.51515676,31.2926307 9.51515676,37.8129736 C9.51515676,44.3337379 4.0716973,49.6386807 -2.61932973,49.6386807 M-2.61932973,25.2619879 C-9.7203027,25.2619879 -15.4980324,30.892695 -15.4980324,37.8129736 C-15.4980324,44.7336736 -9.7203027,50.3639593 -2.61932973,50.3639593 C4.48207568,50.3639593 10.259373,44.7336736 10.259373,37.8129736 C10.259373,30.892695 4.48207568,25.2619879 -2.61932973,25.2619879"
                  id="Fill-102"
                  fill="#E7E6FF"
                  mask="url(#mask-24)"
                />
              </g>
              <g id="Group-107">
                <mask id="mask-26" fill="white">
                  <use xlink:href="#path-25" />
                </mask>
                <g id="Clip-106" />
                <path
                  d="M17.179027,23.3434343 C10.3517838,23.3434343 4.79718919,17.9301843 4.79718919,11.27667 C4.79718919,4.62315571 10.3517838,-0.790094286 17.179027,-0.790094286 C24.0062703,-0.790094286 29.5604324,4.62315571 29.5604324,11.27667 C29.5604324,17.9301843 24.0062703,23.3434343 17.179027,23.3434343 M17.179027,-1.51537286 C9.94140541,-1.51537286 4.05297297,4.22322 4.05297297,11.27667 C4.05297297,18.33012 9.94140541,24.0687129 17.179027,24.0687129 C24.4166486,24.0687129 30.3050811,18.33012 30.3050811,11.27667 C30.3050811,4.22322 24.4166486,-1.51537286 17.179027,-1.51537286"
                  id="Fill-105"
                  fill="#E7E6FF"
                  mask="url(#mask-26)"
                />
              </g>
              <g id="Group-110">
                <mask id="mask-28" fill="white">
                  <use xlink:href="#path-27" />
                </mask>
                <g id="Clip-109" />
                <path
                  d="M17.179027,-0.147078571 L17.179027,0.578621429 C23.2322162,0.578621429 28.1567568,5.37742857 28.1567568,11.2765857 C28.1567568,17.1757429 23.2322162,21.9749714 17.179027,21.9749714 L17.179027,22.70025 C23.6425946,22.70025 28.900973,17.5761 28.900973,11.2765857 C28.900973,4.97749286 23.6425946,-0.147078571 17.179027,-0.147078571"
                  id="Fill-108"
                  fill="#E7E6FF"
                  mask="url(#mask-28)"
                />
              </g>
              <g id="Group-113">
                <mask id="mask-30" fill="white">
                  <use xlink:href="#path-29" />
                </mask>
                <g id="Clip-112" />
                <path
                  d="M17.179027,21.5593586 C11.3610811,21.5593586 6.62767568,16.9468229 6.62767568,11.2769229 C6.62767568,5.60660143 11.3610811,0.994065714 17.179027,0.994065714 C22.996973,0.994065714 27.7299459,5.60660143 27.7299459,11.2769229 C27.7299459,16.9468229 22.996973,21.5593586 17.179027,21.5593586 M17.179027,0.268365714 C10.9507027,0.268365714 5.88345946,5.20666571 5.88345946,11.2769229 C5.88345946,17.3467586 10.9507027,22.2850586 17.179027,22.2850586 C23.4073514,22.2850586 28.4745946,17.3467586 28.4745946,11.2769229 C28.4745946,5.20666571 23.4073514,0.268365714 17.179027,0.268365714"
                  id="Fill-111"
                  fill="#E7E6FF"
                  mask="url(#mask-30)"
                />
              </g>
              <g id="Group-116">
                <mask id="mask-32" fill="white">
                  <use xlink:href="#path-31" />
                </mask>
                <g id="Clip-115" />
                <path
                  d="M17.179027,19.6987514 C12.4136216,19.6987514 8.5372973,15.9206443 8.5372973,11.2769229 C8.5372973,6.63278 12.4136216,2.85467286 17.179027,2.85467286 C21.9444324,2.85467286 25.8207568,6.63278 25.8207568,11.2769229 C25.8207568,15.9206443 21.9444324,19.6987514 17.179027,19.6987514 M17.179027,2.12981571 C12.0032432,2.12981571 7.79264865,6.23284429 7.79264865,11.2769229 C7.79264865,16.32058 12.0032432,20.42403 17.179027,20.42403 C22.3548108,20.42403 26.5654054,16.32058 26.5654054,11.2769229 C26.5654054,6.23284429 22.3548108,2.12981571 17.179027,2.12981571"
                  id="Fill-114"
                  fill="#E7E6FF"
                  mask="url(#mask-32)"
                />
              </g>
            </g>
            <g id="Group-130">
              <path
                d="M130.8898,90.1561269 C127.823269,89.1424346 123.358162,89.3730115 114.70699,89.8802808 L115.714318,93.6841654 C115.714318,93.6841654 131.62649,93.6841654 132.541785,93.5420115 C133.457079,93.3998577 133.956751,91.1698192 130.8898,90.1561269"
                id="Fill-118"
                fill="#070000"
              />
              <path
                d="M113.928948,92.0000654 C114.752629,97.4378731 117.041706,101.953373 118.140227,100.294488 C119.238748,98.6360269 118.140227,92.9215269 118.140227,92.9215269 L113.928948,92.0000654 Z"
                id="Fill-120"
                fill="#070000"
              />
              <path
                d="M106.177774,35.6039962 C102.693519,33.5440346 101.690813,48.1067654 101.690813,49.2224192 C101.690813,50.3384962 113.677053,93.5418423 113.677053,93.5418423 L123.770087,93.5418423 C123.770087,93.5418423 110.861829,38.3730346 106.177774,35.6039962"
                id="Fill-122"
                fill="#070000"
              />
              <path
                d="M129.493619,92.2863615 C129.13683,92.2863615 125.927837,93.0043231 125.927837,93.0043231 C129.13683,94.1529769 128.332481,98.6587462 129.351156,99.2506308 C130.36941,99.8420923 131.490205,98.3173231 131.133837,96.1274769 C130.777048,93.9376308 129.849987,92.2863615 129.493619,92.2863615"
                id="Fill-124"
                fill="#070000"
              />
              <path
                d="M130.699135,91.0353231 C130.36504,91.1609769 127.60781,92.9632846 127.60781,92.9632846 C131.013478,92.9095538 131.824552,97.4136308 132.984429,97.6099385 C134.144306,97.8058231 134.66457,95.9819385 133.570251,94.0565154 C132.475512,92.1302462 131.03323,90.9096692 130.699135,91.0353231"
                id="Fill-126"
                fill="#070000"
              />
              <mask id="mask-34" fill="white">
                <use xlink:href="#path-33" />
              </mask>
              <g id="Clip-129" />
              <polygon
                id="Fill-128"
                fill="#070000"
                mask="url(#mask-34)"
                points="17.1405491 94.0483077 136.740288 94.0483077 136.740288 93.3201923 17.1405491 93.3201923"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END Particulier.svg -->

  <!-- BEGIN Basket.svg -->
  <svg
    v-else-if="name == 'basket'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="150px"
    height="142px"
    viewBox="0 0 150 142"
    version="1.1"
  >
    <!-- Generator: sketchtool 59.1 (101010) - https://sketch.com -->
    <desc>Created with sketchtool.</desc>
    <defs>
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-1"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-3"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-5"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-7"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-9"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-11"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-13"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-15"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-17"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-19"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-21"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-23"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-25"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-27"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-29"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-31"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-33"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-35"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-37"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-39"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-41"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-43"
      />
      <path
        d="M0.0732899023,5.91596091 C0.0732899023,6.12557003 0.11970684,6.33224756 0.203745928,6.53648208 L0.203745928,6.53648208 L0.163680782,6.53697068 C0.163680782,6.53697068 6.31612378,22.9851792 6.31612378,37.6480456 L6.31612378,37.6480456 C6.31612378,39.5995114 12.6952769,41.1815961 20.564658,41.1815961 L20.564658,41.1815961 C28.4335505,41.1815961 34.8131922,39.5995114 34.8131922,37.6480456 L34.8131922,37.6480456 C34.8131922,25.1296417 39.3635179,10.8586319 40.6939739,6.95228013 L40.6939739,6.95228013 C40.9285016,6.61661238 41.0565147,6.27019544 41.0565147,5.91596091 L41.0565147,5.91596091 C41.0565147,2.8509772 31.8815961,0.365960912 20.564658,0.365960912 L20.564658,0.365960912 C9.24723127,0.365960912 0.0732899023,2.8509772 0.0732899023,5.91596091 L0.0732899023,5.91596091 Z"
        id="path-45"
      />
      <path
        d="M5.93794788,0.444625407 C2.46400651,0.854560261 -0.0205211726,4.00358306 0.389413681,7.47801303 L0.389413681,7.47801303 C0.799348534,10.9529316 3.94788274,13.4374593 7.4228013,13.0270358 L7.4228013,13.0270358 C10.8972313,12.617101 13.381759,9.46807818 12.9718241,5.99413681 L12.9718241,5.99413681 C12.5916938,2.7713355 9.85553746,0.400651466 6.68794788,0.400651466 L6.68794788,0.400651466 C6.44071661,0.400651466 6.19006515,0.415309446 5.93794788,0.444625407 L5.93794788,0.444625407 Z"
        id="path-47"
      />
      <polygon
        id="path-49"
        points="0 0.387459283 21.6864332 0.387459283 21.6864332 17.6843648 0 17.6843648"
      />
      <polygon
        id="path-51"
        points="0.23228013 0.230667752 25.1606189 0.230667752 25.1606189 7.81758958 0.23228013 7.81758958"
      />
      <path
        d="M10.8459283,0.353745928 C3.86628664,1.497557 -0.865309446,8.08338762 0.278501629,15.0640065 L0.278501629,15.0640065 C1.4223127,22.0436482 8.00863192,26.7747557 14.9887622,25.6309446 L14.9887622,25.6309446 C21.9688925,24.4871336 26.7,17.9013029 25.5561889,10.9211726 L25.5561889,10.9211726 C24.5271987,4.64218241 19.0944625,0.183224756 12.9327362,0.183224756 L12.9327362,0.183224756 C12.2442997,0.183224756 11.547557,0.238925081 10.8459283,0.353745928 L10.8459283,0.353745928 Z"
        id="path-53"
      />
      <path
        d="M10.8459283,0.353745928 C3.86628664,1.497557 -0.865309446,8.08338762 0.278501629,15.0640065 L0.278501629,15.0640065 C1.4223127,22.0436482 8.00863192,26.7747557 14.9887622,25.6309446 L14.9887622,25.6309446 C21.9688925,24.4871336 26.7,17.9013029 25.5561889,10.9211726 L25.5561889,10.9211726 C24.5271987,4.64218241 19.0944625,0.183224756 12.9327362,0.183224756 L12.9327362,0.183224756 C12.2442997,0.183224756 11.547557,0.238925081 10.8459283,0.353745928 L10.8459283,0.353745928 Z"
        id="path-55"
      />
      <path
        d="M10.8459283,0.353745928 C3.86628664,1.497557 -0.865309446,8.08338762 0.278501629,15.0640065 L0.278501629,15.0640065 C1.4223127,22.0436482 8.00863192,26.7747557 14.9887622,25.6309446 L14.9887622,25.6309446 C21.9688925,24.4871336 26.7,17.9013029 25.5561889,10.9211726 L25.5561889,10.9211726 C24.5271987,4.64218241 19.0944625,0.183224756 12.9327362,0.183224756 L12.9327362,0.183224756 C12.2442997,0.183224756 11.547557,0.238925081 10.8459283,0.353745928"
        id="path-57"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Competences-Perso-/-Socle-commun-10"
        transform="translate(-647.000000, -540.000000)"
      >
        <g id="Popup-Ajout" transform="translate(1.000000, 0.000000)">
          <g
            id="Illustration-Validée"
            transform="translate(646.000000, 540.000000)"
          >
            <g id="Group-27" transform="translate(13.680782, 3.034691)">
              <path
                d="M22.8043974,114.530717 C-15.902443,86.8134528 -15.6884365,-35.6925733 107.947231,10.8841368 C148.923616,26.3209446 141.125081,78.1921173 110.820684,90.4579153 C72.9469055,105.78772 77.3433225,153.58544 22.8043974,114.530717"
                id="Fill-1"
                fill="#766DFF"
              />
              <path
                d="M69.6722638,22.9226384 C70.1584202,19.7311075 69.9639577,15.4856678 71.5621661,15.4968833 C73.1608632,15.5081433 74.5533713,23.6330619 74.5533713,23.6330619 L69.6722638,22.9226384 Z"
                id="Fill-3"
                fill="#3424C7"
              />
              <path
                d="M73.7652117,18.9733876 C76.5643974,14.6268078 80.2362215,10.6246906 81.2573941,11.8544951 C82.2785668,13.0842997 76.0450163,20.9698046 76.0450163,20.9698046 L73.7652117,18.9733876 Z"
                id="Fill-5"
                fill="#3424C7"
              />
              <path
                d="M75.1499023,17.8860098 L74.5181433,17.4545765 C78.846645,11.1110912 80.2704235,11.3094625 80.7385016,11.3744463 L80.6339414,12.1322638 C80.2059283,12.0707003 78.8158632,12.5138599 75.1499023,17.8860098"
                id="Fill-7"
                fill="#070000"
              />
              <path
                d="M75.8336482,20.8735505 C78.6328339,16.5269707 82.304658,12.5248534 83.3258306,13.754658 C84.3470033,14.9844625 78.1134528,22.8699674 78.1134528,22.8699674 L75.8336482,20.8735505 Z"
                id="Fill-9"
                fill="#3424C7"
              />
              <path
                d="M77.5179967,19.1601792 L76.8862378,18.7292345 C79.6751629,14.642101 81.4991042,12.9002443 82.7963355,13.0805375 L82.690798,13.838355 C82.0468241,13.7484528 80.629886,14.6000814 77.5179967,19.1601792"
                id="Fill-11"
                fill="#070000"
              />
              <path
                d="M77.8414984,22.9531759 C80.640684,18.6065961 84.3125081,14.6044788 85.3336808,15.8342834 C86.3548534,17.0640879 80.1213029,24.9495928 80.1213029,24.9495928 L77.8414984,22.9531759 Z"
                id="Fill-13"
                fill="#3424C7"
              />
              <path
                d="M79.6680293,21.0396743 L79.0357818,20.6087296 C81.7665635,16.6066124 83.4893648,14.9776221 84.8007655,15.1588925 L84.695228,15.9167101 C83.7668893,15.7877199 82.0758469,17.5110098 79.6680293,21.0396743"
                id="Fill-15"
                fill="#070000"
              />
              <path
                d="M79.7257329,24.6030293 C82.3055375,20.8461889 86.215798,16.9642671 87.1964169,18.2209446 C88.1765472,19.4781107 82.4061889,26.1694788 82.4061889,26.1694788 L79.7257329,24.6030293 Z"
                id="Fill-17"
                fill="#3424C7"
              />
              <path
                d="M81.8089739,22.6214658 L81.1952932,22.1641368 C83.5303094,19.0307492 85.180798,17.2688599 86.7057166,17.5478502 L86.5693974,18.3002932 C85.374772,18.0862866 83.5767264,20.249316 81.8089739,22.6214658"
                id="Fill-19"
                fill="#070000"
              />
              <path
                d="M35.5623616,32.3720033 C43.1473779,53.3597883 52.4415147,49.2677687 58.4889088,45.5827524 C64.5358143,41.8972476 76.6403746,33.7493648 82.4063355,26.1692345 L74.2183876,18.5514821 L52.2514495,36.4444788 L47.3771824,26.4487134 L35.5623616,32.3720033 Z"
                id="Fill-21"
                fill="#3424C7"
              />
              <path
                d="M51.1221987,48.5100977 L50.3956515,48.2721498 C50.5906026,47.67557 49.9309935,46.7897394 48.9542834,46.3372964 C48.4436971,46.1003257 46.6862052,45.4754072 45.5223616,47.368241 L44.87057,46.9675896 C46.0598208,45.034202 47.9868567,45.0464169 49.2762704,45.6434853 C50.6546091,46.2820847 51.4480945,47.5143322 51.1221987,48.5100977"
                id="Fill-23"
                fill="#070000"
              />
              <path
                d="M85.059772,18.3382085 C73.0309446,18.3382085 64.9504886,21.0098697 64.9504886,23.5056352 C64.9504886,26.0009121 73.0309446,28.6730619 85.059772,28.6730619 C97.0885993,28.6730619 105.169055,26.0009121 105.169055,23.5056352 C105.169055,21.0098697 97.0885993,18.3382085 85.059772,18.3382085 M85.059772,29.4377199 C74.7986971,29.4377199 64.185342,27.2189902 64.185342,23.5056352 C64.185342,19.7922801 74.7986971,17.5735505 85.059772,17.5735505 C95.3203583,17.5735505 105.934202,19.7922801 105.934202,23.5056352 C105.934202,27.2189902 95.3203583,29.4377199 85.059772,29.4377199"
                id="Fill-25"
                fill="#070000"
              />
            </g>
            <g id="Group-97" transform="translate(78.175896, 20.624267)">
              <g id="Group-30">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1" />
                </mask>
                <g id="Clip-29" />
                <polygon
                  id="Fill-28"
                  fill="#070000"
                  mask="url(#mask-2)"
                  points="-42.48943 44.6664821 -43.0298208 44.1256026 28.7258795 -27.6300977 29.2662704 -27.0892182"
                />
              </g>
              <g id="Group-33">
                <mask id="mask-4" fill="white">
                  <use xlink:href="#path-3" />
                </mask>
                <g id="Clip-32" />
                <polygon
                  id="Fill-31"
                  fill="#070000"
                  mask="url(#mask-4)"
                  points="-37.5929805 49.5630293 -38.1333713 49.0221498 33.622329 -22.7335505 34.1627199 -22.192671"
                />
              </g>
              <g id="Group-36">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#path-5" />
                </mask>
                <g id="Clip-35" />
                <polygon
                  id="Fill-34"
                  fill="#070000"
                  mask="url(#mask-6)"
                  points="-32.6959935 54.4597231 -33.236873 53.9188436 38.5188274 -17.8368567 39.0592182 -17.2959772"
                />
              </g>
              <g id="Group-39">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-38" />
                <polygon
                  id="Fill-37"
                  fill="#070000"
                  mask="url(#mask-8)"
                  points="-27.7994951 59.3563681 -28.339886 58.8154886 43.4153257 -12.9402117 43.9562052 -12.3993322"
                />
              </g>
              <g id="Group-42">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-41" />
                <polygon
                  id="Fill-40"
                  fill="#070000"
                  mask="url(#mask-10)"
                  points="-22.9029967 64.2529153 -23.4433876 63.7120358 48.3123127 -8.0436645 48.8527036 -7.50278502"
                />
              </g>
              <g id="Group-45">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-44" />
                <polygon
                  id="Fill-43"
                  fill="#070000"
                  mask="url(#mask-12)"
                  points="-18.0060586 69.1496091 -18.5469381 68.6087296 53.2087622 -3.14697068 53.7491531 -2.60609121"
                />
              </g>
              <g id="Group-48">
                <mask id="mask-14" fill="white">
                  <use xlink:href="#path-13" />
                </mask>
                <g id="Clip-47" />
                <polygon
                  id="Fill-46"
                  fill="#070000"
                  mask="url(#mask-14)"
                  points="-13.1095603 74.0462541 -13.6504397 73.5053746 58.1052606 1.74967427 58.6461401 2.29055375"
                />
              </g>
              <g id="Group-51">
                <mask id="mask-16" fill="white">
                  <use xlink:href="#path-15" />
                </mask>
                <g id="Clip-50" />
                <polygon
                  id="Fill-49"
                  fill="#070000"
                  mask="url(#mask-16)"
                  points="-8.21306189 78.9427524 -8.75345277 78.401873 63.001759 6.64617264 63.5426384 7.18705212"
                />
              </g>
              <g id="Group-54">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#path-17" />
                </mask>
                <g id="Clip-53" />
                <polygon
                  id="Fill-52"
                  fill="#070000"
                  mask="url(#mask-18)"
                  points="-3.31656352 83.8394951 -3.8569544 83.2986156 67.8987459 11.5429153 68.4391368 12.0837948"
                />
              </g>
              <g id="Group-57">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#path-19" />
                </mask>
                <g id="Clip-56" />
                <polygon
                  id="Fill-55"
                  fill="#070000"
                  mask="url(#mask-20)"
                  points="1.58037459 88.7361401 1.03949511 88.1952606 72.7951954 16.4395603 73.3360749 16.9804397"
                />
              </g>
              <g id="Group-60">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#path-21" />
                </mask>
                <g id="Clip-59" />
                <polygon
                  id="Fill-58"
                  fill="#070000"
                  mask="url(#mask-22)"
                  points="80.935798 30.1908958 15.5147883 -35.230114 16.0556678 -35.7705049 81.4761889 29.6500163"
                />
              </g>
              <g id="Group-63">
                <mask id="mask-24" fill="white">
                  <use xlink:href="#path-23" />
                </mask>
                <g id="Clip-62" />
                <polygon
                  id="Fill-61"
                  fill="#070000"
                  mask="url(#mask-24)"
                  points="75.5650163 35.5616287 10.1440065 -29.8588925 10.6853746 -30.399772 76.1054072 35.0207492"
                />
              </g>
              <g id="Group-66">
                <mask id="mask-26" fill="white">
                  <use xlink:href="#path-25" />
                </mask>
                <g id="Clip-65" />
                <polygon
                  id="Fill-64"
                  fill="#070000"
                  mask="url(#mask-26)"
                  points="70.1942345 40.9324593 4.77322476 -24.4880619 5.31410423 -25.0289414 70.7346254 40.3915798"
                />
              </g>
              <g id="Group-69">
                <mask id="mask-28" fill="white">
                  <use xlink:href="#path-27" />
                </mask>
                <g id="Clip-68" />
                <polygon
                  id="Fill-67"
                  fill="#070000"
                  mask="url(#mask-28)"
                  points="64.8234528 46.303241 -0.597557003 -19.1172801 -0.0566775244 -19.6581596 65.3638436 45.7623616"
                />
              </g>
              <g id="Group-72">
                <mask id="mask-30" fill="white">
                  <use xlink:href="#path-29" />
                </mask>
                <g id="Clip-71" />
                <polygon
                  id="Fill-70"
                  fill="#070000"
                  mask="url(#mask-30)"
                  points="59.452671 51.6740717 -5.96833876 -13.7464495 -5.42745928 -14.287329 59.9930619 51.1331922"
                />
              </g>
              <g id="Group-75">
                <mask id="mask-32" fill="white">
                  <use xlink:href="#path-31" />
                </mask>
                <g id="Clip-74" />
                <polygon
                  id="Fill-73"
                  fill="#070000"
                  mask="url(#mask-32)"
                  points="54.0819381 57.0448534 -11.3390717 -8.37566775 -10.7981922 -8.91654723 54.622329 56.5039739"
                />
              </g>
              <g id="Group-78">
                <mask id="mask-34" fill="white">
                  <use xlink:href="#path-33" />
                </mask>
                <g id="Clip-77" />
                <polygon
                  id="Fill-76"
                  fill="#070000"
                  mask="url(#mask-34)"
                  points="48.7111564 62.415684 -16.7098534 -3.00532573 -16.1689739 -3.54571661 49.2515472 61.8748046"
                />
              </g>
              <g id="Group-81">
                <mask id="mask-36" fill="white">
                  <use xlink:href="#path-35" />
                </mask>
                <g id="Clip-80" />
                <polygon
                  id="Fill-79"
                  fill="#070000"
                  mask="url(#mask-36)"
                  points="43.3403746 67.7863681 -22.0806352 2.36584691 -21.5397557 1.82496743 43.8807655 67.2454886"
                />
              </g>
              <g id="Group-84">
                <mask id="mask-38" fill="white">
                  <use xlink:href="#path-37" />
                </mask>
                <g id="Clip-83" />
                <polygon
                  id="Fill-82"
                  fill="#070000"
                  mask="url(#mask-38)"
                  points="37.9695928 73.1571498 -27.4514169 7.73662866 -26.9105375 7.19574919 38.5099837 72.6162704"
                />
              </g>
              <g id="Group-87">
                <mask id="mask-40" fill="white">
                  <use xlink:href="#path-39" />
                </mask>
                <g id="Clip-86" />
                <polygon
                  id="Fill-85"
                  fill="#070000"
                  mask="url(#mask-40)"
                  points="32.5983225 78.5279805 -32.8221987 13.1074593 -32.2813192 12.5665798 33.139202 77.987101"
                />
              </g>
              <g id="Group-90">
                <mask id="mask-42" fill="white">
                  <use xlink:href="#path-41" />
                </mask>
                <g id="Clip-89" />
                <polygon
                  id="Fill-88"
                  fill="#070000"
                  mask="url(#mask-42)"
                  points="27.2547557 83.8716938 -38.1662541 18.4511726 -37.624886 17.9102932 27.7956352 83.3308143"
                />
              </g>
              <g id="Group-93">
                <mask id="mask-44" fill="white">
                  <use xlink:href="#path-43" />
                </mask>
                <g id="Clip-92" />
                <polygon
                  id="Fill-91"
                  fill="#070000"
                  mask="url(#mask-44)"
                  points="21.8839739 89.2425733 -43.5370358 23.8215635 -42.9956678 23.2811726 22.4248534 88.7016938"
                />
              </g>
              <g id="Group-96">
                <mask id="mask-46" fill="white">
                  <use xlink:href="#path-45" />
                </mask>
                <g id="Clip-95" />
                <polygon
                  id="Fill-94"
                  fill="#070000"
                  mask="url(#mask-46)"
                  points="16.5131922 94.6133062 -48.9078176 29.192785 -48.3664495 28.6519055 17.0535831 94.0724267"
                />
              </g>
            </g>
            <g id="Group-106" transform="translate(40.065147, 11.340879)">
              <path
                d="M44.8094951,46.9316287 L44.0448371,46.9316287 C44.0448371,32.5071987 37.8865309,15.5010098 37.8244788,15.3309772 L38.5427199,15.0681107 C38.6057492,15.2396091 44.8094951,32.3694137 44.8094951,46.9316287"
                id="Fill-98"
                fill="#070000"
              />
              <path
                d="M73.3062215,46.9316287 L72.5415635,46.9316287 C72.5415635,32.3694137 78.7453094,15.2396091 78.8078502,15.0681107 L79.5260912,15.3309772 C79.4640391,15.5010098 73.3062215,32.5071987 73.3062215,46.9316287"
                id="Fill-100"
                fill="#070000"
              />
              <path
                d="M0.0835993485,38.1962541 C6.87610749,14.3609121 18.8257818,11.5338762 23.5383225,13.170684 C26.8119381,14.3081433 29.6130782,15.6224756 31.566987,22.95 C33.5213844,30.2775244 29.9287134,48.1348534 29.9287134,48.1348534 L0.0835993485,38.1962541 Z"
                id="Fill-102"
                fill="#FFFFFF"
              />
              <path
                d="M23.3535831,7.47811075 C22.9436482,4.00368078 25.4281759,0.85465798 28.9021173,0.444723127 C32.3770358,0.0347882736 35.5260586,2.51931596 35.9359935,5.99374593 C36.3459283,9.4686645 33.8614007,12.6171987 30.3869707,13.0271336 C26.9120521,13.4370684 23.7635179,10.9525407 23.3535831,7.47811075"
                id="Fill-104"
                fill="#4C3BE3"
              />
            </g>
            <g id="Group-109" transform="translate(63.029316, 11.340879)">
              <mask id="mask-48" fill="white">
                <use xlink:href="#path-47" />
              </mask>
              <g id="Clip-108" />
              <path
                d="M6.33947883,15.4331922 C1.35820847,7.80078176 11.0803583,6.86560261 6.2818241,-0.506872964 L-3.8419544,2.50973941 L-1.00954397,14.933355 L6.33947883,15.4331922 Z"
                id="Fill-107"
                fill="#4C3BE3"
                mask="url(#mask-48)"
              />
            </g>
            <g id="Group-182" transform="translate(0.000000, 0.103094)">
              <path
                d="M71.7168078,19.3310912 L71.1085016,18.8674104 C71.2115961,18.7320684 72.1414007,17.5550326 73.2309772,17.5604072 C73.5715309,17.5652932 74.0679479,17.6981922 74.4984039,18.3006352 L73.8759283,18.7452606 C73.6770684,18.4662704 73.4620847,18.3289739 73.2197394,18.3250651 C72.6221824,18.3157818 71.9332573,19.0477036 71.7168078,19.3310912"
                id="Fill-110"
                fill="#070000"
              />
              <path
                d="M71.2983713,22.3838599 C71.2456026,21.9338599 71.567101,21.5258795 72.0175896,21.4726221 C72.4675896,21.4193648 72.87557,21.7413518 72.9288274,22.1913518 C72.9815961,22.6418404 72.6596091,23.0498208 72.2096091,23.1030782 C71.7591205,23.1558469 71.3511401,22.8338599 71.2983713,22.3838599"
                id="Fill-112"
                fill="#FF3D81"
              />
              <path
                d="M75.2706352,19.1621824 C76.2791042,21.0457329 76.4222638,21.1981759 76.2532085,21.5817264 C76.0225896,22.1055049 74.3755212,21.7913355 74.3755212,21.7913355 L75.2706352,19.1621824 Z"
                id="Fill-114"
                fill="#4C3BE3"
              />
              <path
                d="M75.3221336,22.2723127 C74.9332085,22.2723127 74.5477036,22.2136808 74.3038925,22.1672638 C74.0962378,22.1276873 73.9604072,21.9273616 73.9999837,21.7201954 C74.0390717,21.5125407 74.2393974,21.3752443 74.4465635,21.415798 C75.0714821,21.5340391 75.7853257,21.5306189 75.9152932,21.4084691 C75.9680619,21.2799674 75.9231107,21.1758958 75.3050326,20.0320847 C75.1965635,19.831759 75.0734365,19.6040717 74.9336971,19.342671 C74.8340228,19.1565147 74.9043811,18.9249186 75.0900489,18.8247557 C75.2762052,18.72557 75.5082899,18.7954397 75.6079642,18.9815961 C75.747215,19.2420195 75.8698534,19.4687296 75.9778339,19.6680782 C76.6955863,20.995114 76.8240879,21.2340391 76.603241,21.7358306 C76.4170847,22.1579805 75.8659446,22.2723127 75.3221336,22.2723127"
                id="Fill-116"
                fill="#070000"
              />
              <path
                d="M73.8907329,16.0703257 C71.0998534,16.138241 69.191873,18.3340065 69.0980619,19.7768404 L63.3535993,19.8760261 C61.8032736,15.87 59.6847068,7.22765472 59.6847068,7.22765472 C59.6847068,7.22765472 64.6498534,3.63693811 68.5635342,3.56511401 C68.5635342,3.56511401 74.151645,11.4134853 75.0980619,14.6401954 C75.0980619,14.6401954 74.4702117,14.0172313 73.8907329,16.0703257"
                id="Fill-118"
                fill="#070000"
              />
              <path
                d="M67.5603909,18.785228 C67.3673941,18.0625896 66.6252117,17.6326221 65.9025733,17.8251303 C65.1799349,18.018127 64.7499674,18.7603094 64.9429642,19.4829479 C65.1354723,20.2055863 65.8776547,20.6355537 66.6002932,20.4430456 C67.3234202,20.2500489 67.752899,19.5078664 67.5603909,18.785228"
                id="Fill-120"
                fill="#4C3BE3"
              />
              <path
                d="M44.3838762,99.6958632 L43.8625407,94.8763192 L63.9420195,100.526482 L63.1988599,107.633648 C62.5016287,114.300586 56.884202,119.365407 50.1811075,119.371275 C45.9053746,119.374691 41.8969055,117.29228 39.442671,113.790977 L19.5371336,85.3994463 L28.2767101,77.8657329 L44.3838762,99.6958632 Z"
                id="Fill-122"
                fill="#4C3BE3"
              />
              <polygon
                id="Fill-124"
                fill="#070000"
                points="8.80680782 80.6784528 8.05045603 80.5660749 8.67879479 76.3284528 13.6214658 78.537899 14.5957329 75.0590717 15.3320521 75.2652606 14.1193485 79.5981596 9.28758958 77.4385505"
              />
              <path
                d="M44.6110261,50.0737134 C42.4201466,65.8398371 43.8624919,94.8768078 43.8624919,94.8768078 L63.9419707,100.526482 L67.4681922,56.3038436 L44.6110261,50.0737134 Z"
                id="Fill-126"
                fill="#FF3D81"
              />
              <g id="Group-130" transform="translate(0.000000, 64.006515)">
                <mask id="mask-50" fill="white">
                  <use xlink:href="#path-49" />
                </mask>
                <g id="Clip-129" />
                <path
                  d="M21.6864332,4.04267101 L12.4230782,10.2161238 L1.27617264,17.6843648 C1.27617264,17.6843648 -1.3182899,14.1175896 0.891156352,12.6410423 C2.10043974,11.8333876 2.61591205,12.7983713 3.83741042,12.009772 C5.0584202,11.220684 4.37535831,10.2947883 5.44148208,9.60635179 C6.66298046,8.81775244 7.20972313,9.83110749 8.4307329,9.04250814 C9.65027687,8.25488599 8.97161238,7.33045603 10.031873,6.64201954 L10.031873,6.64201954 C10.0323616,6.64153094 10.0328502,6.64104235 10.0338274,6.64104235 C10.034316,6.64055375 10.0348046,6.64006515 10.0352932,6.63957655 L10.0352932,6.63957655 C11.0774756,5.9232899 11.6716124,6.90439739 12.8662378,6.07915309 C14.062329,5.252443 13.3348046,4.35928339 14.5304072,3.53306189 C15.5750326,2.81140065 16.1691694,3.79641694 17.364772,2.97019544 C18.5613518,2.14348534 17.8792671,1.31677524 19.0753583,0.490065147 C19.133013,0.450488599 19.189202,0.417752443 19.2439251,0.387459283 L21.6864332,4.04267101 Z"
                  id="Fill-128"
                  fill="#070000"
                  mask="url(#mask-50)"
                />
              </g>
              <path
                d="M1.2759772,81.6910749 L2.68460912,83.8028013 C2.68460912,83.8028013 10.3487785,85.4909121 17.0528502,81.0114332 L19.5373779,85.399544 L28.2769544,77.8658306 L21.6862378,68.0493811 L1.2759772,81.6910749 Z"
                id="Fill-131"
                fill="#FF3D81"
              />
              <polygon
                id="Fill-133"
                fill="#FFFFFF"
                points="13.1469381 79.6011401 12.3832573 79.5610749 12.7487296 72.5824104 13.5124104 72.6224756"
              />
              <polygon
                id="Fill-135"
                fill="#FFFFFF"
                points="15.6438274 77.932671 14.8801466 77.8926059 15.2456189 70.9139414 16.0092997 70.9540065"
              />
              <polygon
                id="Fill-137"
                fill="#FFFFFF"
                points="63.6597068 96.8945277 44.3009121 92.5684691 44.4675244 91.8223779 63.8268078 96.1479479"
              />
              <polygon
                id="Fill-139"
                fill="#FFFFFF"
                points="43.8623941 94.8765635 44.3837296 99.6961075 63.4224919 105.497248 64.0058795 99.1024593"
              />
              <polygon
                id="Fill-141"
                fill="#FFFFFF"
                points="28.2768078 77.8657818 33.3807166 84.7833713 24.4373941 92.3884202 19.5372313 85.3994951"
              />
              <polygon
                id="Fill-143"
                fill="#FF3D81"
                points="51.7453094 53.3007166 51.022671 53.0500651 54.6940065 42.4621173 55.4171336 42.7122801"
              />
              <path
                d="M71.0192345,53.6782573 C81.2343811,60.1311889 99.1029479,71.1149023 102.646759,76.0184853 L90.735684,91.5451954 C90.735684,91.5451954 53.0338925,75.8240228 47.5811238,67.1357492 C42.1288436,58.4479642 43.396759,49.3722313 43.396759,49.3722313 L71.0192345,53.6782573 Z"
                id="Fill-145"
                fill="#FF3D81"
              />
              <path
                d="M97.9971987,82.0875244 C92.2204886,77.7741694 87.7898697,74.9622801 83.5595765,74.2704235 C78.4996417,73.4432248 73.1983388,72.2730293 68.7115309,69.3365472 C63.2138111,65.7370358 59.9885668,60.2451792 58.8525733,52.5463192 L59.6094137,52.4349186 C60.7112052,59.9046254 63.8255375,65.2240065 69.1307492,68.6964821 C73.7162541,71.6979479 79.046873,72.7577199 83.6831922,73.5155375 C88.0669055,74.2323127 92.5854723,77.0925733 98.4550163,81.4743322 L97.9971987,82.0875244 Z"
                id="Fill-147"
                fill="#FFFFFF"
              />
              <polygon
                id="Fill-149"
                fill="#FFFFFF"
                points="75.7000651 59.5309446 70.1104886 66.4050489 67.9464821 64.6456026 73.5360586 57.7714984"
              />
              <g id="Group-153" transform="translate(80.618893, 133.387622)">
                <mask id="mask-52" fill="white">
                  <use xlink:href="#path-51" />
                </mask>
                <g id="Clip-152" />
                <path
                  d="M0.870879479,0.230667752 L11.8829316,1.86112378 L25.1606189,3.7935342 C25.1606189,3.7935342 24.6944951,8.17969055 22.0643648,7.79369707 C20.6264169,7.58213355 20.8907492,6.52089577 19.4557329,6.28685668 C18.0212052,6.05330619 17.9063844,7.19809446 16.6541042,6.99434853 C15.2190879,6.76079805 15.4931922,5.64190554 14.0581759,5.40835505 C12.625114,5.17480456 12.5088274,6.31617264 11.2609446,6.11584691 L11.2609446,6.11584691 C11.2599674,6.11584691 11.2594788,6.11584691 11.2589902,6.11535831 C11.258013,6.11535831 11.2575244,6.11535831 11.2565472,6.11535831 L11.2565472,6.11535831 C10.0028013,5.94825733 10.220228,4.82203583 8.78032573,4.63343648 C7.33895765,4.44483713 7.27983713,5.595 5.83846906,5.40640065 C4.57983713,5.24174267 4.79970684,4.11258958 3.35833876,3.92399023 C1.91697068,3.73539088 1.86811075,4.80591205 0.426742671,4.6173127 C0.356872964,4.60802932 0.293355049,4.59483713 0.23228013,4.58017915 L0.870879479,0.230667752 Z"
                  id="Fill-151"
                  fill="#070000"
                  mask="url(#mask-52)"
                />
              </g>
              <path
                d="M105.779463,137.181156 L106.150798,134.670244 C106.150798,134.670244 101.595586,128.278876 93.6182248,127.107704 L94.7170847,122.186042 L83.9434691,121.636857 L81.4897231,133.61829 L105.779463,137.181156 Z"
                id="Fill-154"
                fill="#FF3D81"
              />
              <polygon
                id="Fill-156"
                fill="#FFFFFF"
                points="91.1606189 136.247394 90.6212052 135.705537 95.5707166 130.772638 96.1106189 131.314495"
              />
              <polygon
                id="Fill-158"
                fill="#FFFFFF"
                points="88.189886 135.81127 87.6499837 135.269414 92.5994951 130.336515 93.139886 130.878371"
              />
              <path
                d="M83.9432736,121.63671 L90.7352932,91.5448534 L102.646857,76.0186319 C102.646857,76.0186319 108.575033,78.8007166 105.810537,90.490456 C103.483339,100.331336 94.7173779,122.186384 94.7173779,122.186384 L83.9432736,121.63671 Z"
                id="Fill-160"
                fill="#4C3BE3"
              />
              <polygon
                id="Fill-162"
                fill="#FFFFFF"
                points="90.1457003 89.9734202 89.5315309 89.5170684 100.767362 74.4090879 101.381531 74.8654397"
              />
              <path
                d="M102.647003,76.0184853 L90.7354397,91.5451954 L89.9072638,94.8764658 C89.9072638,94.8764658 103.793746,86.6064332 106.545537,83.8551303 C106.545537,83.8551303 106.550912,78.2855863 102.647003,76.0184853"
                id="Fill-164"
                fill="#FFFFFF"
              />
              <polygon
                id="Fill-166"
                fill="#FFFFFF"
                points="85.6190228 114.213616 83.943127 121.636906 94.7172313 122.186091 98.0416612 113.627296"
              />
              <path
                d="M83.7709935,88.7218241 C79.2363029,86.4312704 75.2322313,84.4558632 71.699658,82.7125407 C52.0608958,73.0221498 46.782557,70.4174267 44.1231107,60.2726384 L44.8633388,60.0786645 C47.4338599,69.8858306 52.6457492,72.4578176 72.0377687,82.0265472 C75.5722964,83.7703583 79.5778339,85.7472313 84.115456,88.0392508 L83.7709935,88.7218241 Z"
                id="Fill-168"
                fill="#070000"
              />
              <path
                d="M99.0984528,80.7160261 C94.0624593,76.7324756 87.9515472,72.5784039 80.804316,71.9744951 L80.8683225,71.2122801 C88.2178339,71.8332899 94.4479642,76.0616287 99.5733713,80.1160261 L99.0984528,80.7160261 Z"
                id="Fill-170"
                fill="#FFFFFF"
              />
              <polygon
                id="Fill-172"
                fill="#FF3D81"
                points="53.7560423 54.0149511 53.0334039 53.7642997 56.7047394 43.1763518 57.4278664 43.4265147"
              />
              <path
                d="M61.2042997,40.7379479 C56.5709121,34.4843648 55.7754723,31.1379479 57.7992508,26.4136808 L58.5023453,26.7151466 C56.588013,31.1833876 57.3316612,34.226873 61.8189577,40.2825733 L61.2042997,40.7379479 Z"
                id="Fill-174"
                fill="#FF3D81"
              />
              <path
                d="M62.9597394,39.5158143 C60.57,36.6628827 59.3255375,34.6708632 58.7963844,32.8547394 C58.2261889,30.8949674 58.4582736,29.0172801 59.5483388,26.7667915 L60.2367752,27.1005049 C58.3385668,31.0190717 59.0812378,33.6936645 63.5460586,39.024772 L62.9597394,39.5158143 Z"
                id="Fill-176"
                fill="#FF3D81"
              />
              <path
                d="M69.6860912,72.1526384 C65.1553094,70.950684 59.3512378,65.449544 57.3147557,56.2120847 L58.0618241,56.0474267 C60.0289251,64.9721824 65.5681759,70.2690879 69.8820195,71.4133876 L69.6860912,72.1526384 Z"
                id="Fill-178"
                fill="#FFFFFF"
              />
              <path
                d="M114.481221,10.9211238 C113.336922,3.94099349 106.75158,-0.790114007 99.7714495,0.353697068 C92.7908306,1.49750814 88.0597231,8.08333876 89.2040228,15.0634691 C90.3473453,22.0440879 96.9336645,26.7751954 103.913795,25.6308958 C110.893925,24.4870847 115.625033,17.9012541 114.481221,10.9211238"
                id="Fill-180"
                fill="#FF3D81"
              />
            </g>
            <g id="Group-192" transform="translate(88.925081, 0.103094)">
              <g id="Group-185">
                <mask id="mask-54" fill="white">
                  <use xlink:href="#path-53" />
                </mask>
                <g id="Clip-184" />
                <path
                  d="M19.253013,30.697329 C16.0438925,27.9186645 14.5336319,24.8360912 13.3199511,22.3593811 C12.2367264,20.1474919 11.3811889,18.4002606 9.7526873,17.4645928 C6.37060261,15.5214332 4.19144951,15.7852769 1.88477199,16.0647557 C-1.00285016,16.4141042 -3.98868078,16.7756678 -9.18737785,12.5434202 L-8.70464169,11.9502606 C-3.75806189,15.9772964 -1.06197068,15.6509121 1.79291531,15.3054723 C4.1220684,15.0230619 6.53135179,14.7313681 10.1333062,16.8015635 C11.9645765,17.8535179 12.9114821,19.7854397 14.0074104,22.0227362 C15.251873,24.5629642 16.6624593,27.4427687 19.7538274,30.119316 L19.253013,30.697329 Z"
                  id="Fill-183"
                  fill="#070000"
                  mask="url(#mask-54)"
                />
              </g>
              <g id="Group-188">
                <mask id="mask-56" fill="white">
                  <use xlink:href="#path-55" />
                </mask>
                <g id="Clip-187" />
                <path
                  d="M30.2822638,13.960456 C26.6075081,10.9687622 23.1912215,10.2744625 20.1770521,9.66175896 C18.4278664,9.30605863 16.9171173,8.99921824 15.6374756,8.28830619 C12.2104397,6.38472313 11.3524593,3.72087948 10.5233062,1.14449511 C9.82265472,-1.03074919 9.16060261,-3.08579805 6.9154886,-4.47830619 L7.31858306,-5.12863192 C9.80262215,-3.58758958 10.5389414,-1.30143322 11.2513192,0.909967427 C12.0350326,3.34465798 12.8456189,5.86289902 16.0092997,7.61941368 C17.1853583,8.27315961 18.6428502,8.56925081 20.3294951,8.91224756 C23.2767264,9.51127036 26.9441531,10.256873 30.765,13.3672964 L30.2822638,13.960456 Z"
                  id="Fill-186"
                  fill="#070000"
                  mask="url(#mask-56)"
                />
              </g>
              <g id="Group-191">
                <mask id="mask-58" fill="white">
                  <use xlink:href="#path-57" />
                </mask>
                <g id="Clip-190" />
                <path
                  d="M4.88941368,25.9651466 L4.17557003,25.6910423 C9.11140065,12.8271987 21.6923453,0.45781759 21.8184039,0.334201954 L22.3529316,0.881921824 C22.2273616,1.00407166 9.76514658,13.2596091 4.88941368,25.9651466"
                  id="Fill-189"
                  fill="#070000"
                  mask="url(#mask-58)"
                />
              </g>
            </g>
            <g id="Group-225" transform="translate(57.654723, 21.601466)">
              <path
                d="M34.8939088,15.6793974 C33.8815309,12.6139251 31.7844625,8.91767101 33.2141042,8.20333876 C34.6442345,7.48900651 39.566873,14.1012215 39.566873,14.1012215 L34.8939088,15.6793974 Z"
                id="Fill-193"
                fill="#4C3BE3"
              />
              <path
                d="M36.7533225,10.3045114 C37.2790554,5.16151466 38.7394788,-0.0699185668 40.2067427,0.563794788 C41.6744951,1.19750814 39.6902932,11.0515798 39.6902932,11.0515798 L36.7533225,10.3045114 Z"
                id="Fill-195"
                fill="#4C3BE3"
              />
              <path
                d="M37.4948208,8.70771987 L36.7360261,8.6095114 C37.7215309,0.993224756 39.0808143,0.52465798 39.5273941,0.370749186 L39.7770684,1.09387622 C39.3685993,1.23459283 38.3288599,2.25820847 37.4948208,8.70771987"
                id="Fill-197"
                fill="#070000"
              />
              <path
                d="M39.4583062,11.0613029 C39.9840391,5.91830619 41.4444625,0.686872964 42.9117264,1.32058632 C44.3794788,1.95429967 42.3952769,11.8083713 42.3952769,11.8083713 L39.4583062,11.0613029 Z"
                id="Fill-199"
                fill="#4C3BE3"
              />
              <path
                d="M40.1835831,8.77084691 L39.4247883,8.67263844 C40.0594788,3.76563518 40.8954723,1.38713355 42.1345603,0.959609121 L42.3842345,1.68273616 C41.7710423,1.89429967 40.8915635,3.29560261 40.1835831,8.77084691"
                id="Fill-201"
                fill="#070000"
              />
              <path
                d="M42.190456,12.0056189 C42.7161889,6.86262215 44.1766124,1.63118893 45.6438762,2.26490228 C47.1116287,2.89861564 45.1274267,12.7526873 45.1274267,12.7526873 L42.190456,12.0056189 Z"
                id="Fill-203"
                fill="#4C3BE3"
              />
              <path
                d="M42.9514984,9.47247557 L42.1927036,9.3742671 C42.814202,4.56938111 43.6130619,2.33550489 44.8633876,1.90456026 L45.1125733,2.6276873 C44.2262541,2.93306189 43.4992182,5.23583062 42.9514984,9.47247557"
                id="Fill-205"
                fill="#070000"
              />
              <path
                d="M44.6177199,12.6227687 C45.2157655,8.10469055 46.9429642,2.87228013 48.3862866,3.54850163 C49.8291205,4.22521173 47.7169055,12.8045277 47.7169055,12.8045277 L44.6177199,12.6227687 Z"
                id="Fill-207"
                fill="#4C3BE3"
              />
              <path
                d="M45.5767427,9.91260586 L44.8228339,9.78263844 C45.4853746,5.93100977 46.1586645,3.61456026 47.6440065,3.17091205 L47.8633876,3.90381107 C46.7024756,4.25022801 46.0780456,6.99664495 45.5767427,9.91260586"
                id="Fill-209"
                fill="#070000"
              />
              <path
                d="M0.0334690554,21.8714169 C3.01734528,27.9784202 21.1575733,43.3243485 25.6795603,37.8745114 C31.3898208,30.992101 36.7531759,30.992101 47.6391694,12.9295603 L36.8885179,9.84747557 L22.7196254,26.0108306 L9.73656352,14.6137622 L0.0334690554,21.8714169 Z"
                id="Fill-211"
                fill="#4C3BE3"
              />
              <polygon
                id="Fill-213"
                fill="#FFFFFF"
                points="75.1971498 50.8695928 72.1390065 52.6109609 73.8808632 55.6686156 76.9380293 53.9272476"
              />
              <polygon
                id="Fill-215"
                fill="#FFFFFF"
                points="84.7515635 24.6406026 81.5185016 23.2524919 80.1299023 26.4860423 83.3634528 27.8741531"
              />
              <polygon
                id="Fill-217"
                fill="#B7B3FF"
                points="84.806873 44.3294463 84.1282085 43.9761889 85.965342 40.448013 86.6440065 40.8012704"
              />
              <path
                d="M58.2412378,63.8636971 L57.5469381,63.5431759 C57.8229967,62.9446417 57.8684365,62.3172801 57.6725081,61.8218404 C57.5513355,61.5164658 57.3480782,61.2926873 57.1003583,61.1925244 C56.5819544,60.9829153 55.9184365,60.4801466 55.6076873,59.6974104 C55.343355,59.0290065 55.387329,58.2765635 55.7357003,57.5221661 L56.43,57.8426873 C56.1681107,58.4104397 56.1309772,58.9395928 56.3190879,59.4154886 C56.5409121,59.9744463 57.032443,60.3404072 57.3871661,60.4835668 C57.8308143,60.6628827 58.1850489,61.038127 58.3839088,61.5404072 C58.6570358,62.2293322 58.6047557,63.0760749 58.2412378,63.8636971"
                id="Fill-219"
                fill="#B7B3FF"
              />
              <path
                d="M64.4756189,41.16943 L64.3710586,40.4116124 C65.024316,40.3217101 65.5774104,40.0221987 65.8891368,39.5902769 C66.0811564,39.3235016 66.1598208,39.0318078 66.1109609,38.7689414 C66.008355,38.2197557 66.0738274,37.3891368 66.5663355,36.7060749 C66.9865309,36.1226873 67.6436971,35.754772 68.4674756,35.6414169 L68.5715472,36.3992345 C67.9520033,36.4847394 67.4858795,36.7383225 67.1868567,37.1531433 C66.8350651,37.6412541 66.7920684,38.2529805 66.8629153,38.6282248 C66.9503746,39.0987459 66.8252932,39.5990717 66.5091694,40.0373453 C66.0757818,40.6383225 65.3350651,41.0511889 64.4756189,41.16943"
                id="Fill-221"
                fill="#B7B3FF"
              />
              <polygon
                id="Fill-223"
                fill="#FFFFFF"
                points="71.5760423 19.3857166 71.2965635 15.8780619 67.7884202 16.1580293 68.0683876 19.665684"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END Basket.svg -->

  <!-- BEGIN error404.svg -->
  <svg
    v-else-if="name == 'error404'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="550px"
    height="590px"
    viewBox="0 0 550 590"
    version="1.1"
  >
    <!-- Generator: sketchtool 59.1 (101010) - https://sketch.com -->
    <desc>Created with sketchtool.</desc>
    <defs>
      <polygon
        id="path-1"
        points="0 0.192061345 549.101193 0.192061345 549.101193 589.586393 0 589.586393"
      />
      <polygon
        id="path-3"
        points="0 589.586524 549.284247 589.586524 549.284247 0.192061345 0 0.192061345"
      />
      <path
        d="M30.6942956,0.804987016 C27.384659,1.17668287 24.363697,3.23906385 22.3514976,6.49936747 L22.3514976,6.49936747 L19.7182754,10.7653739 C17.4525538,14.4366669 14.1450477,16.8909215 10.4572584,17.6449331 L10.4572584,17.6449331 C5.69146698,18.6198382 0.284413566,18.8757773 0.284413566,18.8757773 L0.284413566,18.8757773 L0.401587695,23.6918936 L23.6350869,23.6632199 L29.1007274,16.5287835 L28.8035312,24.0327918 L34.6792811,24.2558093 L35.1927169,0.320720421 L30.6942956,0.804987016 Z"
        id="path-5"
      />
      <path
        d="M11.9841158,3.56451486 C9.61243861,5.95525582 8.53459893,9.50465308 9.00957913,13.3682805 L9.00957913,13.3682805 L9.6317817,18.424039 C10.1658658,22.7714297 9.11166763,26.8153885 6.68303586,29.7492834 L6.68303586,29.7492834 C3.54408301,33.5405623 0.0902677298,37.938705 0.0902677298,37.938705 L0.0902677298,37.938705 L2.92940276,41.3326069 L20.8690394,26.1847685 L20.6659371,17.0591354 L25.1578312,22.5630227 L30.2568834,18.2577453 L15.1026509,0.421133231 L11.9841158,3.56451486 Z"
        id="path-7"
      />
      <path
        d="M2.03563418,4.09998469 L0.462305198,15.2317152 L33.3562787,15.2285145 C35.5559567,15.2199796 36.6733718,12.6594895 35.1596951,11.1050587 L35.1596951,11.1050587 C31.7073192,7.55877999 25.5918949,2.72158754 16.7015742,0.866299132 L16.7015742,0.866299132 C16.3457909,0.791618173 15.9324858,0.758545176 15.4755067,0.758545176 L15.4755067,0.758545176 C10.9270201,0.758545176 2.03563418,4.09998469 2.03563418,4.09998469 L2.03563418,4.09998469 Z"
        id="path-9"
      />
      <path
        d="M2.03563418,4.09998469 L0.462305198,15.2317152 L33.3562787,15.2285145 C35.5559567,15.2199796 36.6733718,12.6594895 35.1596951,11.1050587 L35.1596951,11.1050587 C31.7073192,7.55877999 25.5918949,2.72158754 16.7015742,0.866299132 L16.7015742,0.866299132 C16.3457909,0.791618173 15.9324858,0.758545176 15.4755067,0.758545176 L15.4755067,0.758545176 C10.9270201,0.758545176 2.03563418,4.09998469 2.03563418,4.09998469 L2.03563418,4.09998469 Z"
        id="path-11"
      />
      <path
        d="M1.62232907,4.09998469 L0.0490000901,15.2317152 L32.9440388,15.2285145 C35.1426516,15.2199796 36.2611319,12.6594895 34.7474552,11.1050587 L34.7474552,11.1050587 C31.2950793,7.55877999 25.179655,2.72158754 16.2882691,0.866299132 L16.2882691,0.866299132 C15.9324858,0.791618173 15.5191807,0.758545176 15.0622016,0.758545176 L15.0622016,0.758545176 C10.513715,0.758545176 1.62232907,4.09998469 1.62232907,4.09998469 L1.62232907,4.09998469 Z"
        id="path-13"
      />
      <path
        d="M1.62232907,4.09998469 L0.0490000901,15.2317152 L32.9440388,15.2285145 C35.1426516,15.2199796 36.2611319,12.6594895 34.7474552,11.1050587 L34.7474552,11.1050587 C31.2950793,7.55877999 25.179655,2.72158754 16.2882691,0.866299132 L16.2882691,0.866299132 C15.9324858,0.791618173 15.5191807,0.758545176 15.0622016,0.758545176 L15.0622016,0.758545176 C10.513715,0.758545176 1.62232907,4.09998469 1.62232907,4.09998469 L1.62232907,4.09998469 Z"
        id="path-15"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Error-404" transform="translate(-445.000000, -177.000000)">
        <g
          id="Illustration-error-404"
          transform="translate(445.000000, 177.000000)"
        >
          <g id="Group-104">
            <g id="Group-3">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1" />
              </mask>
              <g id="Clip-2" />
              <path
                d="M52.1945695,154.715464 C146.263943,-40.4966707 587.179892,-126.246756 546.451908,364.143142 C532.135763,536.518181 356.796624,646.749512 226.352984,558.399601 C111.634393,480.701112 -97.7767613,465.935005 52.1945695,154.715464"
                id="Fill-1"
                fill="#FFFFFF"
                mask="url(#mask-2)"
              />
            </g>
            <path
              d="M255.93911,437.244367 C256.491262,436.797236 256.7668,436.152936 256.7668,435.313622 C256.7668,434.474308 256.491262,433.830008 255.93911,433.3818 C255.386957,432.934668 254.58725,432.710564 253.537838,432.710564 L250.722182,432.710564 L250.722182,437.915603 L253.537838,437.915603 C254.58725,437.915603 255.386957,437.692576 255.93911,437.244367 M257.131673,432.346394 C257.99273,433.065037 258.423258,434.053035 258.423258,435.313622 C258.423258,436.573132 257.99273,437.562208 257.131673,438.28085 C256.270616,438.999492 255.088816,439.358275 253.587348,439.358275 L250.722182,439.358275 L250.722182,442.872835 L249.0668,442.872835 L249.0668,431.268969 L253.587348,431.268969 C255.088816,431.268969 256.270616,431.627752 257.131673,432.346394"
              id="Fill-4"
              fill="#3424C7"
            />
            <path
              d="M265.278562,441.339444 C265.719853,441.067933 266.040597,440.684369 266.23864,440.187676 L266.23864,438.96049 L263.787857,438.96049 C262.44138,438.96049 261.767603,439.414085 261.767603,440.3202 C261.767603,440.761944 261.938738,441.109952 262.281008,441.363147 C262.623278,441.618497 263.097935,441.745633 263.70498,441.745633 C264.313102,441.745633 264.836194,441.609877 265.278562,441.339444 M266.859677,434.898598 C267.50547,435.495491 267.828366,436.385444 267.828366,437.567379 L267.828366,442.872619 L266.321517,442.872619 L266.321517,441.712233 C266.056742,442.121654 265.678953,442.43303 265.188151,442.648515 C264.696272,442.864 264.112906,442.97282 263.440205,442.97282 C262.457524,442.97282 261.670734,442.734709 261.08091,442.259564 C260.49001,441.78442 260.194022,441.159514 260.194022,440.385923 C260.194022,439.612332 260.476018,438.990658 261.038933,438.5209 C261.601849,438.051143 262.496272,437.816265 263.722202,437.816265 L266.23864,437.816265 L266.23864,437.500579 C266.23864,436.816414 266.040597,436.290631 265.642358,435.927539 C265.245196,435.562292 264.659677,435.380207 263.887955,435.380207 C263.368092,435.380207 262.861145,435.465324 262.363885,435.636634 C261.867701,435.807945 261.446859,436.037436 261.105665,436.325109 L260.442652,435.131322 C260.895783,434.766075 261.437172,434.488099 262.065744,434.294163 C262.695391,434.100226 263.36271,434.003258 264.069853,434.003258 C265.283943,434.003258 266.213885,434.302782 266.859677,434.898598"
              id="Fill-6"
              fill="#3424C7"
            />
            <path
              d="M276.530528,440.7502 C276.989041,440.506702 277.347456,440.168391 277.606849,439.730956 C277.866243,439.294599 277.996477,438.800061 277.996477,438.247342 C277.996477,437.397254 277.714481,436.70878 277.151566,436.184074 C276.58865,435.65829 275.865362,435.396476 274.982779,435.396476 C274.088356,435.396476 273.359687,435.65829 272.796771,436.184074 C272.232779,436.70878 271.951859,437.397254 271.951859,438.247342 C271.951859,438.800061 272.081018,439.294599 272.340411,439.730956 C272.600881,440.168391 272.959295,440.506702 273.416732,440.7502 C273.875245,440.994775 274.39726,441.115447 274.982779,441.115447 C275.556458,441.115447 276.072016,440.994775 276.530528,440.7502 L276.530528,440.7502 Z M279.552838,434.086328 L279.552838,441.67894 C279.552838,443.21427 279.17182,444.350954 278.410861,445.08468 C277.648826,445.820561 276.511155,446.187963 274.998924,446.187963 C274.171233,446.187963 273.381213,446.073756 272.631018,445.847497 C271.879746,445.621237 271.272701,445.29801 270.809883,444.877814 L271.570841,443.650628 C271.978767,444.0051 272.484638,444.284153 273.086301,444.488864 C273.687965,444.692497 274.309002,444.79593 274.949413,444.79593 C275.976223,444.79593 276.735029,444.551355 277.225832,444.065436 C277.71771,443.579517 277.963112,442.838249 277.963112,441.844864 L277.963112,441.148847 C277.587476,441.601366 277.12681,441.940754 276.580039,442.167014 C276.034344,442.39435 275.440215,442.50748 274.799804,442.50748 C273.96135,442.50748 273.202544,442.328627 272.523386,441.968767 C271.844227,441.609985 271.311448,441.106828 270.925049,440.460373 C270.53865,439.813918 270.344912,439.075882 270.344912,438.247342 C270.344912,437.418802 270.53865,436.681844 270.925049,436.034312 C271.311448,435.387857 271.844227,434.889009 272.523386,434.533459 C273.202544,434.180064 273.96135,434.003366 274.799804,434.003366 C275.462818,434.003366 276.078474,434.126192 276.646771,434.368613 C277.215068,434.612111 277.681115,434.970893 278.045988,435.446038 L278.045988,434.086328 L279.552838,434.086328 Z"
              id="Fill-8"
              fill="#3424C7"
            />
            <path
              d="M284.595078,436.042716 C284.081673,436.507086 283.780303,437.114753 283.692045,437.865718 L289.323356,437.865718 C289.234022,437.126605 288.933728,436.520015 288.420323,436.051335 C287.906918,435.581578 287.268659,435.346699 286.507701,435.346699 C285.745665,435.346699 285.108483,435.578345 284.595078,436.042716 M290.812984,439.009943 L283.692045,439.009943 C283.791067,439.783534 284.131184,440.405209 284.710245,440.874966 C285.290382,441.344723 286.01044,441.579602 286.871497,441.579602 C287.92091,441.579602 288.765822,441.226206 289.405157,440.518338 L290.283434,441.546201 C289.886272,442.010572 289.392241,442.363967 288.801341,442.607465 C288.21044,442.849885 287.550656,442.972712 286.821986,442.972712 C285.895274,442.972712 285.071888,442.78093 284.355059,442.399522 C283.637153,442.019191 283.081771,441.485866 282.68999,440.800623 C282.298209,440.115381 282.102319,439.34179 282.102319,438.47985 C282.102319,437.628685 282.292828,436.860481 282.673845,436.175239 C283.054863,435.489997 283.579031,434.956671 284.247427,434.57634 C284.914746,434.193855 285.66817,434.00315 286.507701,434.00315 C287.346155,434.00315 288.094198,434.193855 288.750753,434.57634 C289.408386,434.956671 289.921791,435.489997 290.290969,436.175239 C290.661223,436.860481 290.84635,437.644846 290.84635,438.529412 C290.84635,438.651161 290.834511,438.81062 290.812984,439.009943"
              id="Fill-10"
              fill="#3424C7"
            />
            <path
              d="M305.509716,434.973695 C306.166272,435.62015 306.49455,436.567206 306.49455,437.817019 L306.49455,442.872296 L304.904824,442.872296 L304.904824,437.999103 C304.904824,437.147938 304.700323,436.50687 304.292397,436.0759 C303.883395,435.64493 303.298953,435.429445 302.536918,435.429445 C301.675861,435.429445 300.997779,435.680485 300.500519,436.183643 C300.003258,436.6868 299.754628,437.407597 299.754628,438.347112 L299.754628,442.872296 L298.165978,442.872296 L298.165978,434.086974 L299.688973,434.086974 L299.688973,435.412207 C300.009716,434.959688 300.442397,434.61168 300.989168,434.368182 C301.535939,434.125761 302.156977,434.004012 302.851204,434.004012 C303.966272,434.004012 304.85316,434.326162 305.509716,434.973695"
              id="Fill-12"
              fill="#3424C7"
            />
            <path
              d="M315.097798,441.190005 C315.544472,440.930345 315.894276,440.566176 316.149364,440.095341 C316.402299,439.626661 316.529305,439.087949 316.529305,438.479204 C316.529305,437.871536 316.402299,437.332824 316.149364,436.863067 C315.894276,436.394387 315.544472,436.032372 315.097798,435.7781 C314.650049,435.52275 314.145254,435.396692 313.582339,435.396692 C313.018346,435.396692 312.514628,435.52275 312.066879,435.7781 C311.620205,436.032372 311.266096,436.394387 311.006703,436.863067 C310.747309,437.332824 310.618151,437.871536 310.618151,438.479204 C310.618151,439.087949 310.747309,439.626661 311.006703,440.095341 C311.266096,440.566176 311.620205,440.930345 312.066879,441.190005 C312.514628,441.449664 313.018346,441.578955 313.582339,441.578955 C314.145254,441.578955 314.650049,441.449664 315.097798,441.190005 M311.230577,442.391333 C310.535274,442.005615 309.991732,441.47229 309.599951,440.792435 C309.207094,440.11258 309.01228,439.341144 309.01228,438.479204 C309.01228,437.618342 309.207094,436.846905 309.599951,436.16705 C309.991732,435.487195 310.535274,434.957102 311.230577,434.575694 C311.926957,434.194286 312.709442,434.003581 313.582339,434.003581 C314.454159,434.003581 315.235568,434.194286 315.925489,434.575694 C316.615411,434.957102 317.155724,435.487195 317.547505,436.16705 C317.940362,436.846905 318.136252,437.618342 318.136252,438.479204 C318.136252,439.341144 317.940362,440.11258 317.547505,440.792435 C317.155724,441.47229 316.615411,442.005615 315.925489,442.391333 C315.235568,442.779206 314.454159,442.972065 313.582339,442.972065 C312.709442,442.972065 311.926957,442.779206 311.230577,442.391333"
              id="Fill-14"
              fill="#3424C7"
            />
            <path
              d="M328.014726,434.973695 C328.671282,435.62015 328.99956,436.567206 328.99956,437.817019 L328.99956,442.872296 L327.409834,442.872296 L327.409834,437.999103 C327.409834,437.147938 327.205333,436.50687 326.797407,436.0759 C326.388405,435.64493 325.803963,435.429445 325.041928,435.429445 C324.180871,435.429445 323.502789,435.680485 323.005528,436.183643 C322.508268,436.6868 322.259638,437.407597 322.259638,438.347112 L322.259638,442.872296 L320.670988,442.872296 L320.670988,434.086974 L322.193982,434.086974 L322.193982,435.412207 C322.514726,434.959688 322.947407,434.61168 323.494178,434.368182 C324.040949,434.125761 324.661986,434.004012 325.356213,434.004012 C326.471282,434.004012 327.35817,434.326162 328.014726,434.973695"
              id="Fill-16"
              fill="#3424C7"
            />
            <path
              d="M264.500274,463.907399 C264.268865,464.106723 263.981487,464.257562 263.639217,464.36315 C263.296947,464.468737 262.943914,464.520454 262.579041,464.520454 C261.696458,464.520454 261.011918,464.28342 260.526497,463.807198 C260.04,463.333132 259.796751,462.653276 259.796751,461.768711 L259.796751,456.94508 L258.307123,456.94508 L258.307123,455.634931 L259.796751,455.634931 L259.796751,453.711728 L261.386477,453.711728 L261.386477,455.634931 L263.903992,455.634931 L263.903992,456.94508 L261.386477,456.94508 L261.386477,461.70191 C261.386477,462.178132 261.505949,462.542302 261.74274,462.796574 C261.980607,463.050846 262.319648,463.176905 262.762016,463.176905 C263.247436,463.176905 263.66182,463.038995 264.00409,462.763174 L264.500274,463.907399 Z"
              id="Fill-18"
              fill="#3424C7"
            />
            <path
              d="M269.501399,455.949863 C270.041712,455.684816 270.699344,455.552293 271.472143,455.552293 L271.472143,457.094088 C271.383885,457.083313 271.26226,457.077926 271.10727,457.077926 C270.246213,457.077926 269.570284,457.334353 269.078405,457.848285 C268.587603,458.362217 268.342202,459.094866 268.342202,460.045154 L268.342202,464.420576 L266.752476,464.420576 L266.752476,455.635255 L268.27547,455.635255 L268.27547,457.110249 C268.552084,456.601705 268.96001,456.214909 269.501399,455.949863"
              id="Fill-20"
              fill="#3424C7"
            />
            <path
              d="M278.948053,462.738501 C279.395802,462.478841 279.745607,462.114672 279.999618,461.643837 C280.25363,461.175157 280.380636,460.636445 280.380636,460.0277 C280.380636,459.420032 280.25363,458.88132 279.999618,458.411563 C279.745607,457.942883 279.395802,457.580868 278.948053,457.326596 C278.500303,457.071246 277.995509,456.945188 277.432593,456.945188 C276.869677,456.945188 276.364883,457.071246 275.918209,457.326596 C275.47046,457.580868 275.117427,457.942883 274.858033,458.411563 C274.59864,458.88132 274.468405,459.420032 274.468405,460.0277 C274.468405,460.636445 274.59864,461.175157 274.858033,461.643837 C275.117427,462.114672 275.47046,462.478841 275.918209,462.738501 C276.364883,462.99816 276.869677,463.127451 277.432593,463.127451 C277.995509,463.127451 278.500303,462.99816 278.948053,462.738501 M275.081908,463.939829 C274.385528,463.554111 273.841986,463.020786 273.450205,462.340931 C273.058425,461.661076 272.862534,460.88964 272.862534,460.0277 C272.862534,459.166838 273.058425,458.395401 273.450205,457.715546 C273.841986,457.035691 274.385528,456.505598 275.081908,456.12419 C275.777211,455.742782 276.560773,455.552077 277.432593,455.552077 C278.304413,455.552077 279.085822,455.742782 279.77682,456.12419 C280.465665,456.505598 281.007055,457.035691 281.398836,457.715546 C281.790616,458.395401 281.986507,459.166838 281.986507,460.0277 C281.986507,460.88964 281.790616,461.661076 281.398836,462.340931 C281.007055,463.020786 280.465665,463.554111 279.77682,463.939829 C279.085822,464.327702 278.304413,464.520561 277.432593,464.520561 C276.560773,464.520561 275.777211,464.327702 275.081908,463.939829"
              id="Fill-22"
              fill="#3424C7"
            />
            <path
              d="M292.701067,455.635255 L292.701067,464.420576 L291.194217,464.420576 L291.194217,463.095344 C290.873474,463.547862 290.451556,463.899103 289.927387,464.14691 C289.403219,464.395796 288.831693,464.520777 288.213885,464.520777 C287.042847,464.520777 286.121517,464.196472 285.44774,463.551095 C284.773963,462.903562 284.438151,461.951119 284.438151,460.690532 L284.438151,455.635255 L286.027877,455.635255 L286.027877,460.508447 C286.027877,461.359613 286.231301,462.003913 286.640303,462.439192 C287.048229,462.876627 287.633748,463.095344 288.395783,463.095344 C289.234237,463.095344 289.89725,462.839994 290.382671,462.332527 C290.868092,461.823983 291.111341,461.10534 291.111341,460.177678 L291.111341,455.635255 L292.701067,455.635255 Z"
              id="Fill-24"
              fill="#3424C7"
            />
            <polygon
              id="Fill-26"
              fill="#3424C7"
              points="303.829041 455.635255 299.987652 464.420576 298.36456 464.420576 294.522094 455.635255 296.178552 455.635255 299.191174 462.680535 302.272681 455.635255"
            />
            <path
              d="M309.989472,452.204088 L312.009726,452.204088 L309.227436,454.358937 L307.736732,454.358937 L309.989472,452.204088 Z M307.083405,457.591212 C306.568924,458.055582 306.26863,458.663249 306.180372,459.414214 L311.810607,459.414214 C311.722348,458.675101 311.422055,458.068511 310.90865,457.599831 C310.395245,457.130074 309.756986,456.895195 308.994951,456.895195 C308.233992,456.895195 307.595734,457.126841 307.083405,457.591212 L307.083405,457.591212 Z M313.301311,460.558439 L306.180372,460.558439 C306.28047,461.33203 306.619511,461.953705 307.198571,462.423462 C307.777632,462.893219 308.498767,463.128098 309.359824,463.128098 C310.409237,463.128098 311.253072,462.774702 311.89456,462.066834 L312.771761,463.094697 C312.373523,463.559067 311.879491,463.912463 311.288591,464.155961 C310.697691,464.398381 310.038982,464.521208 309.310313,464.521208 C308.383601,464.521208 307.560215,464.329426 306.842309,463.948018 C306.124403,463.567687 305.571174,463.034362 305.178317,462.349119 C304.786536,461.663877 304.590646,460.890286 304.590646,460.028346 C304.590646,459.177181 304.781155,458.408977 305.162172,457.723735 C305.54319,457.038493 306.066282,456.505167 306.735753,456.124836 C307.403072,455.742351 308.156497,455.551646 308.994951,455.551646 C309.834481,455.551646 310.582524,455.742351 311.23908,456.124836 C311.895636,456.505167 312.409041,457.038493 312.779295,457.723735 C313.14955,458.408977 313.333601,459.193342 313.333601,460.077908 C313.333601,460.199657 313.323914,460.359116 313.301311,460.558439 L313.301311,460.558439 Z"
              id="Fill-28"
              fill="#3424C7"
            />
            <path
              d="M317.549012,457.591212 C317.03453,458.055582 316.734237,458.663249 316.645978,459.414214 L322.27729,459.414214 C322.189031,458.675101 321.887661,458.068511 321.374256,457.599831 C320.860851,457.130074 320.222593,456.895195 319.460558,456.895195 C318.699599,456.895195 318.062417,457.126841 317.549012,457.591212 M323.766918,460.558439 L316.645978,460.558439 C316.746076,461.33203 317.085117,461.953705 317.664178,462.423462 C318.244315,462.893219 318.964374,463.128098 319.825431,463.128098 C320.874843,463.128098 321.718679,462.774702 322.360166,462.066834 L323.237368,463.094697 C322.839129,463.559067 322.345098,463.912463 321.754198,464.155961 C321.163297,464.398381 320.504589,464.521208 319.77592,464.521208 C318.849207,464.521208 318.025822,464.329426 317.307916,463.948018 C316.59001,463.567687 316.036781,463.034362 315.643924,462.349119 C315.252143,461.663877 315.057329,460.890286 315.057329,460.028346 C315.057329,459.177181 315.246761,458.408977 315.627779,457.723735 C316.008796,457.038493 316.532965,456.505167 317.20136,456.124836 C317.868679,455.742351 318.622104,455.551646 319.460558,455.551646 C320.301164,455.551646 321.048131,455.742351 321.704687,456.124836 C322.362319,456.505167 322.874648,457.038493 323.244902,457.723735 C323.615157,458.408977 323.800284,459.193342 323.800284,460.077908 C323.800284,460.199657 323.789521,460.359116 323.766918,460.558439"
              id="Fill-30"
              fill="#3424C7"
            />
            <polygon
              id="Fill-32"
              fill="#FF3D81"
              points="245.139305 152.981995 235.056331 152.981995 235.056331 165.986513 216.345568 165.986513 216.345568 152.981995 180.472867 152.981995 180.472867 140.462319 210.915528 98.0516468 230.790871 98.0516468 203.15956 137.745054 216.926781 137.745054 216.926781 126.196137 235.056331 126.196137 235.056331 137.745054 245.139305 137.745054"
            />
            <path
              d="M291.529922,146.91674 C293.436086,143.779279 294.389706,138.813428 294.389706,132.019188 C294.389706,125.226024 293.436086,120.261251 291.529922,117.122712 C289.622681,113.985251 287.053503,112.415443 283.822387,112.415443 C280.525616,112.415443 277.923072,113.985251 276.017984,117.122712 C274.110744,120.261251 273.1582,125.226024 273.1582,132.019188 C273.1582,138.813428 274.110744,143.779279 276.017984,146.91674 C277.923072,150.055279 280.525616,151.624009 283.822387,151.624009 C287.053503,151.624009 289.622681,150.055279 291.529922,146.91674 M268.31045,163.171848 C263.785597,160.391015 260.246654,156.330201 257.69362,150.992638 C255.139511,145.655076 253.86407,139.33167 253.86407,132.019188 C253.86407,124.70886 255.139511,118.384377 257.69362,113.045737 C260.246654,107.708174 263.785597,103.648438 268.31045,100.866527 C272.833151,98.0856935 278.004873,96.6936606 283.822387,96.6936606 C289.574247,96.6936606 294.712603,98.0856935 299.237456,100.866527 C303.761233,103.648438 307.2991,107.708174 309.853209,113.045737 C312.406243,118.384377 313.682759,124.70886 313.682759,132.019188 C313.682759,139.33167 312.406243,145.655076 309.853209,150.992638 C307.2991,156.330201 303.761233,160.391015 299.237456,163.171848 C294.712603,165.954836 289.574247,167.345792 283.822387,167.345792 C278.004873,167.345792 272.833151,165.954836 268.31045,163.171848"
              id="Fill-34"
              fill="#FF3D81"
            />
            <polygon
              id="Fill-36"
              fill="#FF3D81"
              points="389.110362 152.981995 379.027387 152.981995 379.027387 165.986513 360.316624 165.986513 360.316624 152.981995 324.443924 152.981995 324.443924 140.462319 354.886585 98.0516468 374.761928 98.0516468 347.130616 137.745054 360.897838 137.745054 360.897838 126.196137 379.027387 126.196137 379.027387 137.745054 389.110362 137.745054"
            />
            <path
              d="M448.528982,386.511235 C448.528982,383.541852 450.981918,381.087478 453.947182,381.087478 C456.914599,381.087478 459.366458,383.541852 459.366458,386.511235 C459.366458,389.480618 456.914599,391.934991 453.947182,391.934991 C450.981918,391.934991 448.528982,389.480618 448.528982,386.511235 M458.510783,362.587017 C458.510783,360.590549 457.199824,359.277168 454.290528,359.277168 C451.153053,359.277168 449.270568,361.388921 448.129667,364.072786 L440.258532,359.560531 C442.767436,353.679946 448.300802,350.36902 454.632798,350.36902 C461.134853,350.36902 467.636908,354.365189 467.636908,361.788645 C467.636908,370.294914 458.510783,372.922753 458.510783,376.861818 L449.384658,376.861818 C449.384658,370.181785 458.510783,367.612126 458.510783,362.587017"
              id="Fill-38"
              fill="#B7B3FF"
            />
            <path
              d="M105.18271,217.048799 C105.18271,214.079416 107.635646,211.625042 110.60091,211.625042 C113.568327,211.625042 116.020186,214.079416 116.020186,217.048799 C116.020186,220.018181 113.568327,222.472555 110.60091,222.472555 C107.635646,222.472555 105.18271,220.018181 105.18271,217.048799 M115.164511,193.124581 C115.164511,191.127035 113.852476,189.813654 110.944256,189.813654 C107.806781,189.813654 105.924295,191.926484 104.783395,194.609272 L96.9122603,190.099172 C99.4211644,184.21751 104.95453,180.906584 111.28545,180.906584 C117.787505,180.906584 124.28956,184.90383 124.28956,192.326209 C124.28956,200.833555 115.164511,203.460317 115.164511,207.399382 L106.038386,207.399382 C106.038386,200.719348 115.164511,198.14969 115.164511,193.124581"
              id="Fill-40"
              fill="#B7B3FF"
            />
            <path
              d="M466.468023,184.673476 C466.468023,181.704093 468.919883,179.24972 471.886223,179.24972 C474.852564,179.24972 477.304423,181.704093 477.304423,184.673476 C477.304423,187.642859 474.852564,190.097233 471.886223,190.097233 C468.919883,190.097233 466.468023,187.642859 466.468023,184.673476 M476.448748,160.750336 C476.448748,158.751713 475.137789,157.438332 472.229569,157.438332 C469.092094,157.438332 467.208532,159.551162 466.068708,162.23395 L458.196497,157.72385 C460.706477,151.842188 466.239843,148.531261 472.570763,148.531261 C479.072818,148.531261 485.574873,152.528507 485.574873,159.950887 C485.574873,168.458233 476.448748,171.084995 476.448748,175.02406 L467.323699,175.02406 C467.323699,168.344026 476.448748,165.774368 476.448748,160.750336"
              id="Fill-42"
              fill="#B7B3FF"
            />
            <path
              d="M392.719589,346.322428 C396.76225,345.47234 399.978297,357.445762 393.696888,361.073451 C391.405401,362.396529 362.566458,377.882355 357.5282,367.260024 C352.113229,355.840399 360.091996,326.88353 360.091996,326.88353 L370.017828,323.897986 L371.615088,329.137502 L370.710978,354.45483 C370.710978,354.45483 384.908728,347.965501 392.719589,346.322428"
              id="Fill-44"
              fill="#FFFFFF"
            />
            <path
              d="M371.257857,330.260502 C372.737798,324.708532 377.833102,321.352354 375.601888,319.934463 C373.824883,318.804244 368.926546,325.239703 368.926546,325.239703 L371.257857,330.260502 Z"
              id="Fill-46"
              fill="#FFFFFF"
            />
            <path
              d="M371.358708,324.415688 C369.040313,317.820771 365.64775,311.13535 364.221624,311.982206 C362.795499,312.830139 368.328865,325.442474 368.328865,325.442474 L371.358708,324.415688 Z"
              id="Fill-48"
              fill="#FFFFFF"
            />
            <path
              d="M368.468464,325.458312 C366.148992,318.863395 362.757505,312.176897 361.33138,313.02483 C359.904178,313.872763 365.43862,326.485098 365.43862,326.485098 L368.468464,325.458312 Z"
              id="Fill-50"
              fill="#FFFFFF"
            />
            <path
              d="M366.671869,322.33809 C364.618249,316.865849 363.010225,313.898622 361.891928,313.518291 L362.23635,312.505511 C363.752886,313.021598 365.378131,315.849838 367.672847,321.962069 L366.671869,322.33809 Z"
              id="Fill-52"
              fill="#070000"
            />
            <path
              d="M365.783474,326.664166 C363.465078,320.069249 360.072515,313.382751 358.646389,314.230684 C357.219188,315.078617 362.75363,327.690952 362.75363,327.690952 L365.783474,326.664166 Z"
              id="Fill-54"
              fill="#FFFFFF"
            />
            <path
              d="M363.987094,323.543944 C361.933474,318.071703 360.324374,315.104475 359.207153,314.724144 L359.551575,313.711365 C361.068112,314.227452 362.693356,317.054614 364.988072,323.167923 L363.987094,323.543944 Z"
              id="Fill-56"
              fill="#070000"
            />
            <path
              d="M363.279521,327.512207 C361.09136,321.722126 357.399579,315.041015 356.015431,315.94282 C354.630205,316.844624 359.878346,327.817118 359.878346,327.817118 L363.279521,327.512207 Z"
              id="Fill-58"
              fill="#FFFFFF"
            />
            <path
              d="M361.200391,324.165187 C359.645108,320.39851 358.008023,316.853782 356.565753,316.426045 L356.869276,315.400336 C358.651663,315.927197 360.169276,318.864257 362.18953,323.756843 L361.200391,324.165187 Z"
              id="Fill-60"
              fill="#070000"
            />
            <path
              d="M136.114775,358.425572 C153.705088,363.333242 187.295988,367.163487 196.414579,366.999718 C212.739139,366.707736 235.396771,364.906282 235.396771,364.906282 L235.598043,348.049971 L228.647162,349.183422 C228.647162,349.183422 202.997358,348.207275 193.606458,347.988558 C185.009883,347.789234 159.833659,343.213411 141.63953,339.754877 C136.509785,338.779808 126.57319,355.763255 136.114775,358.425572"
              id="Fill-62"
              fill="#E7E6FF"
            />
            <path
              d="M227.399491,350.472668 C233.663679,344.525283 235.991761,334.647453 238.498513,337.030716 C240.495088,338.930216 234.338532,350.58472 234.338532,350.58472 L227.399491,350.472668 Z"
              id="Fill-64"
              fill="#E7E6FF"
            />
            <path
              d="M235.37363,347.208394 C244.228523,346.243022 253.568836,346.822676 253.028523,349.525935 C252.489286,352.229194 235.172358,352.43175 235.172358,352.43175 L235.37363,347.208394 Z"
              id="Fill-66"
              fill="#E7E6FF"
            />
            <path
              d="M235.473728,351.313383 C244.617074,350.262894 254.246918,350.756354 253.664628,353.472542 C253.082339,356.187653 235.216487,356.5529 235.216487,356.5529 L235.473728,351.313383 Z"
              id="Fill-68"
              fill="#E7E6FF"
            />
            <path
              d="M253.016468,352.618575 C251.682906,350.444332 243.001301,351.214691 240.149051,351.467886 L240.062945,350.501436 C248.565881,349.747238 252.687114,350.22777 253.842006,352.111108 L253.016468,352.618575 Z"
              id="Fill-70"
              fill="#070000"
            />
            <path
              d="M234.163523,356.103937 C243.018415,355.138564 252.358728,355.718219 251.818415,358.421477 C251.279178,361.124736 233.96225,361.327292 233.96225,361.327292 L234.163523,356.103937 Z"
              id="Fill-72"
              fill="#E7E6FF"
            />
            <path
              d="M251.165303,357.565356 C249.853268,355.385725 241.452583,356.075277 238.690744,356.301536 L238.612172,355.335086 C246.855714,354.658464 250.858552,355.175628 251.995147,357.064353 L251.165303,357.565356 Z"
              id="Fill-74"
              fill="#070000"
            />
            <path
              d="M233.523434,360.559842 C241.35044,359.941401 250.788699,360.970341 250.168738,363.647742 C249.547701,366.32622 234.187524,364.905097 234.187524,364.905097 L233.523434,360.559842 Z"
              id="Fill-76"
              fill="#E7E6FF"
            />
            <path
              d="M249.535323,362.810475 C248.546184,361.000401 244.379746,360.788149 238.428767,361.027337 L238.388943,360.058732 C245.048141,359.791531 249.146771,360.079203 250.385616,362.345028 L249.535323,362.810475 Z"
              id="Fill-78"
              fill="#070000"
            />
            <path
              d="M82.9599119,299.899533 C32.5385812,299.899533 53.1006164,288.206242 6.81881605,278.509419"
              id="Stroke-80"
              stroke="#3424C7"
              stroke-width="13.677"
            />
            <path
              d="M184.022358,301.822844 L187.491341,237.731153 L158.2068,237.731153 C140.683219,237.731153 132.765802,269.585217 115.31864,278.894167 C100.806605,286.637619 88.1092466,286.802465 80.7310665,286.802465 C73.3518102,286.802465 72.8136497,300.360779 72.8136497,300.360779 C72.8136497,300.360779 73.3518102,313.92017 80.7310665,313.92017 C88.1092466,313.92017 100.806605,314.083939 115.31864,321.827391 C132.765802,331.137418 140.683219,362.990405 158.2068,362.990405 L187.491341,362.990405 L183.772652,301.819612 L184.022358,301.822844 Z"
              id="Fill-82"
              fill="#766DFF"
            />
            <path
              d="M221.618249,300.360887 C221.618249,278.415898 218.507681,258.671011 213.547994,244.915529 L213.547994,225.113539 L196.715411,225.113539 C182.961106,225.113539 171.811497,258.802457 171.811497,300.360887 C171.811497,341.919316 182.961106,375.608235 196.715411,375.608235 L213.547994,375.608235 L213.547994,355.806244 C218.507681,342.050762 221.618249,322.305875 221.618249,300.360887"
              id="Fill-84"
              fill="#3424C7"
            />
            <path
              d="M237.297877,300.360887 C237.297877,341.919316 226.148268,375.608235 212.395039,375.608235 C198.640734,375.608235 187.492202,341.919316 187.492202,300.360887 C187.492202,258.802457 198.640734,225.113539 212.395039,225.113539 C226.148268,225.113539 237.297877,258.802457 237.297877,300.360887"
              id="Fill-86"
              fill="#B7B3FF"
            />
            <path
              d="M215.623033,272.43145 C215.623033,277.818574 214.177534,282.185377 212.395147,282.185377 C210.611683,282.185377 209.166184,277.818574 209.166184,272.43145 C209.166184,267.044326 210.611683,262.677523 212.395147,262.677523 C214.177534,262.677523 215.623033,267.044326 215.623033,272.43145"
              id="Fill-88"
              fill="#7BEAFF"
            />
            <mask id="mask-4" fill="white">
              <use xlink:href="#path-3" />
            </mask>
            <g id="Clip-91" />
            <polygon
              id="Fill-90"
              fill="#7BEAFF"
              mask="url(#mask-4)"
              points="212.394716 282.185377 265.659687 282.185377 265.659687 262.677523 212.394716 262.677523"
            />
            <path
              d="M277.018532,272.43145 C277.018532,277.818574 272.656204,282.185377 267.274599,282.185377 C261.892994,282.185377 257.529589,277.818574 257.529589,272.43145 C257.529589,267.044326 261.892994,262.677523 267.274599,262.677523 C272.656204,262.677523 277.018532,267.044326 277.018532,272.43145"
              id="Fill-92"
              fill="#7BEAFF"
              mask="url(#mask-4)"
            />
            <path
              d="M215.623033,328.290323 C215.623033,333.677447 214.177534,338.04425 212.395147,338.04425 C210.611683,338.04425 209.166184,333.677447 209.166184,328.290323 C209.166184,322.903199 210.611683,318.536397 212.395147,318.536397 C214.177534,318.536397 215.623033,322.903199 215.623033,328.290323"
              id="Fill-93"
              fill="#7BEAFF"
              mask="url(#mask-4)"
            />
            <polygon
              id="Fill-94"
              fill="#7BEAFF"
              mask="url(#mask-4)"
              points="212.394716 338.044465 265.659687 338.044465 265.659687 318.536612 212.394716 318.536612"
            />
            <path
              d="M277.018532,328.290323 C277.018532,333.677447 272.656204,338.04425 267.274599,338.04425 C261.892994,338.04425 257.529589,333.677447 257.529589,328.290323 C257.529589,322.903199 261.892994,318.536397 267.274599,318.536397 C272.656204,318.536397 277.018532,322.903199 277.018532,328.290323"
              id="Fill-95"
              fill="#7BEAFF"
              mask="url(#mask-4)"
            />
            <path
              d="M472.882896,299.899533 C523.304227,299.899533 500.568023,314.064437 549.284462,314.064437"
              id="Stroke-96"
              stroke="#3424C7"
              stroke-width="13.677"
              mask="url(#mask-4)"
            />
            <path
              d="M475.111957,286.802034 C467.733777,286.802034 455.036419,286.638266 440.524384,278.894814 C423.077221,269.584786 415.159804,237.731799 397.635147,237.731799 L368.350607,237.731799 L372.286712,298.742056 L371.829276,298.735591 L368.350607,362.989974 L397.635147,362.989974 C415.159804,362.989974 423.077221,331.136987 440.524384,321.82696 C455.036419,314.083508 467.733777,313.919739 475.111957,313.919739 C482.490137,313.919739 483.028297,300.360348 483.028297,300.360348 C483.028297,300.360348 482.490137,286.802034 475.111957,286.802034"
              id="Fill-97"
              fill="#766DFF"
              mask="url(#mask-4)"
            />
            <path
              d="M334.22456,300.360887 C334.22456,278.415898 337.335127,258.671011 342.294814,244.915529 L342.294814,225.113539 L359.127397,225.113539 C372.881703,225.113539 384.030235,258.802457 384.030235,300.360887 C384.030235,341.919316 372.881703,375.608235 359.127397,375.608235 L342.294814,375.608235 L342.294814,355.806244 C337.335127,342.050762 334.22456,322.305875 334.22456,300.360887"
              id="Fill-98"
              fill="#3424C7"
              mask="url(#mask-4)"
            />
            <path
              d="M318.544609,300.360887 C318.544609,341.919316 329.694217,375.608235 343.447446,375.608235 C357.201751,375.608235 368.35136,341.919316 368.35136,300.360887 C368.35136,258.802457 357.201751,225.113539 343.447446,225.113539 C329.694217,225.113539 318.544609,258.802457 318.544609,300.360887"
              id="Fill-99"
              fill="#B7B3FF"
              mask="url(#mask-4)"
            />
            <path
              d="M340.219775,272.43145 C340.219775,277.818574 341.665274,282.185377 343.447661,282.185377 C345.231125,282.185377 346.675548,277.818574 346.675548,272.43145 C346.675548,267.044326 345.231125,262.677523 343.447661,262.677523 C341.665274,262.677523 340.219775,267.044326 340.219775,272.43145"
              id="Fill-100"
              fill="#7BEAFF"
              mask="url(#mask-4)"
            />
            <path
              d="M340.219775,328.290323 C340.219775,333.677447 341.665274,338.04425 343.447661,338.04425 C345.231125,338.04425 346.675548,333.677447 346.675548,328.290323 C346.675548,322.903199 345.231125,318.536397 343.447661,318.536397 C341.665274,318.536397 340.219775,322.903199 340.219775,328.290323"
              id="Fill-101"
              fill="#7BEAFF"
              mask="url(#mask-4)"
            />
            <polygon
              id="Fill-102"
              fill="#E7E6FF"
              mask="url(#mask-4)"
              points="380.116409 537.302223 382.84273 469.868359 400.550362 465.320549 397.086761 525.118703"
            />
            <path
              d="M397.202789,523.112107 L396.685078,547.39403 L390.748092,547.167771 L391.048386,539.555764 L385.525783,546.792827 L362.04907,546.821917 L361.930675,541.936873 C361.930675,541.936873 367.395157,541.676136 372.210616,540.68706 C375.935763,539.923166 379.27774,537.43216 381.567074,533.707503 L384.22774,529.379487 C386.26091,526.072871 389.314432,523.980512 392.658562,523.603413 L397.202789,523.112107 Z"
              id="Fill-103"
              fill="#4C3BE3"
              mask="url(#mask-4)"
            />
          </g>
          <g id="Group-107" transform="translate(362.174579, 523.047473)">
            <mask id="mask-6" fill="white">
              <use xlink:href="#path-5" />
            </mask>
            <g id="Clip-106" />
            <polygon
              id="Fill-105"
              fill="#070000"
              mask="url(#mask-6)"
              points="36.1775122 13.7034703 29.2024559 13.8723264 23.0092706 21.5324469 -2.19168881 22.1409661 -2.0862321 26.4781257 38.7244516 25.8664205"
            />
          </g>
          <g id="Group-112" transform="translate(389.969372, 449.770291)">
            <path
              d="M24.6858806,2.79603793 L35.3166616,27.9059724 L54.7290658,59.5576293 L50.4518836,78.9924799 C50.4518836,78.9924799 28.2137519,49.9525659 15.1624502,34.0864162 C7.31773354,24.5490926 -3.18333844,13.4279496 1.17531394,9.18507706 C15.4647473,-4.72629761 24.6858806,2.79603793 24.6858806,2.79603793"
              id="Fill-108"
              fill="#E7E6FF"
            />
            <path
              d="M54.7287443,59.5570917 L69.8457427,77.3178033 L64.759219,81.6047604 L60.2783614,76.1242938 L60.4809648,85.2110945 L42.5854058,100.294474 L39.7532466,96.9150142 C39.7532466,96.9150142 43.1985758,92.535587 46.3298162,88.7604412 C48.7524809,85.839031 49.8040888,81.8122805 49.270245,77.482314 L48.6506432,72.4491447 C48.17683,68.6030335 49.2509495,65.0676648 51.6178714,62.6870972 L54.7287443,59.5570917 Z"
              id="Fill-110"
              fill="#4C3BE3"
            />
          </g>
          <g id="Group-115" transform="translate(429.555896, 508.728943)">
            <mask id="mask-8" fill="white">
              <use xlink:href="#path-7" />
            </mask>
            <g id="Clip-114" />
            <polygon
              id="Fill-113"
              fill="#070000"
              mask="url(#mask-8)"
              points="24.4557847 10.3346095 19.0665863 14.885008 19.0289748 24.888542 -0.440914876 41.3289355 2.38317553 44.7055601 34.1498941 18.3804139"
            />
          </g>
          <g id="Group-166" transform="translate(112.863706, 316.692190)">
            <path
              d="M270.053791,88.5457887 C270.077441,99.0594885 267.584521,164.570325 268.562769,173.425496 C296.800816,164.544512 303.488379,182.953973 325.973036,163.328042 C326.451411,143.648332 326.404111,140.404412 317.742852,127.588991 C310.652165,117.098954 318.85225,94.6958997 303.479779,80.0896548 C289.879979,82.2042261 281.544445,84.6414684 270.053791,88.5457887"
              id="Fill-116"
              fill="#766DFF"
            />
            <path
              d="M276.445889,92.4560246 C277.727731,92.4560246 278.767291,93.4940327 278.767291,94.7739613 C278.767291,96.0552965 277.727731,97.0918981 276.445889,97.0918981 C275.164046,97.0918981 274.124486,96.0552965 274.124486,94.7739613 C274.124486,93.4940327 275.164046,92.4560246 276.445889,92.4560246"
              id="Fill-323"
              fill="#BBB3FF"
            />
            <path
              d="M276.445889,118.269712 C277.727731,118.269712 278.767291,119.30772 278.767291,120.587649 C278.767291,121.868984 277.727731,122.905586 276.445889,122.905586 C275.164046,122.905586 274.124486,121.868984 274.124486,120.587649 C274.124486,119.30772 275.164046,118.269712 276.445889,118.269712"
              id="Fill-323-Copy-6"
              fill="#BBB3FF"
            />
            <path
              d="M276.445889,144.0834 C277.727731,144.0834 278.767291,145.121408 278.767291,146.401337 C278.767291,147.682672 277.727731,148.719273 276.445889,148.719273 C275.164046,148.719273 274.124486,147.682672 274.124486,146.401337 C274.124486,145.121408 275.164046,144.0834 276.445889,144.0834"
              id="Fill-323-Copy-12"
              fill="#BBB3FF"
            />
            <path
              d="M289.344678,92.4560246 C290.626521,92.4560246 291.666081,93.4940327 291.666081,94.7739613 C291.666081,96.0552965 290.626521,97.0918981 289.344678,97.0918981 C288.062836,97.0918981 287.023276,96.0552965 287.023276,94.7739613 C287.023276,93.4940327 288.062836,92.4560246 289.344678,92.4560246"
              id="Fill-323-Copy-2"
              fill="#BBB3FF"
            />
            <path
              d="M289.344678,118.269712 C290.626521,118.269712 291.666081,119.30772 291.666081,120.587649 C291.666081,121.868984 290.626521,122.905586 289.344678,122.905586 C288.062836,122.905586 287.023276,121.868984 287.023276,120.587649 C287.023276,119.30772 288.062836,118.269712 289.344678,118.269712"
              id="Fill-323-Copy-7"
              fill="#BBB3FF"
            />
            <path
              d="M289.344678,144.0834 C290.626521,144.0834 291.666081,145.121408 291.666081,146.401337 C291.666081,147.682672 290.626521,148.719273 289.344678,148.719273 C288.062836,148.719273 287.023276,147.682672 287.023276,146.401337 C287.023276,145.121408 288.062836,144.0834 289.344678,144.0834"
              id="Fill-323-Copy-13"
              fill="#BBB3FF"
            />
            <path
              d="M302.243468,92.4560246 C303.52531,92.4560246 304.56487,93.4940327 304.56487,94.7739613 C304.56487,96.0552965 303.52531,97.0918981 302.243468,97.0918981 C300.961626,97.0918981 299.922065,96.0552965 299.922065,94.7739613 C299.922065,93.4940327 300.961626,92.4560246 302.243468,92.4560246"
              id="Fill-323-Copy-4"
              fill="#BBB3FF"
            />
            <path
              d="M302.243468,118.269712 C303.52531,118.269712 304.56487,119.30772 304.56487,120.587649 C304.56487,121.868984 303.52531,122.905586 302.243468,122.905586 C300.961626,122.905586 299.922065,121.868984 299.922065,120.587649 C299.922065,119.30772 300.961626,118.269712 302.243468,118.269712"
              id="Fill-323-Copy-8"
              fill="#BBB3FF"
            />
            <path
              d="M302.243468,144.0834 C303.52531,144.0834 304.56487,145.121408 304.56487,146.401337 C304.56487,147.682672 303.52531,148.719273 302.243468,148.719273 C300.961626,148.719273 299.922065,147.682672 299.922065,146.401337 C299.922065,145.121408 300.961626,144.0834 302.243468,144.0834"
              id="Fill-323-Copy-14"
              fill="#BBB3FF"
            />
            <path
              d="M315.145816,144.0834 C316.427659,144.0834 317.467219,145.121408 317.467219,146.401337 C317.467219,147.682672 316.427659,148.719273 315.145816,148.719273 C313.863974,148.719273 312.824414,147.682672 312.824414,146.401337 C312.824414,145.121408 313.863974,144.0834 315.145816,144.0834"
              id="Fill-323-Copy-18"
              fill="#BBB3FF"
            />
            <path
              d="M276.445889,105.362868 C277.727731,105.362868 278.767291,106.400876 278.767291,107.680805 C278.767291,108.96214 277.727731,109.998742 276.445889,109.998742 C275.164046,109.998742 274.124486,108.96214 274.124486,107.680805 C274.124486,106.400876 275.164046,105.362868 276.445889,105.362868"
              id="Fill-323-Copy"
              fill="#BBB3FF"
            />
            <path
              d="M276.445889,131.176556 C277.727731,131.176556 278.767291,132.214564 278.767291,133.494493 C278.767291,134.775828 277.727731,135.81243 276.445889,135.81243 C275.164046,135.81243 274.124486,134.775828 274.124486,133.494493 C274.124486,132.214564 275.164046,131.176556 276.445889,131.176556"
              id="Fill-323-Copy-9"
              fill="#BBB3FF"
            />
            <path
              d="M276.445889,156.990244 C277.727731,156.990244 278.767291,158.028252 278.767291,159.30818 C278.767291,160.589516 277.727731,161.626117 276.445889,161.626117 C275.164046,161.626117 274.124486,160.589516 274.124486,159.30818 C274.124486,158.028252 275.164046,156.990244 276.445889,156.990244"
              id="Fill-323-Copy-15"
              fill="#BBB3FF"
            />
            <path
              d="M289.344678,105.362868 C290.626521,105.362868 291.666081,106.400876 291.666081,107.680805 C291.666081,108.96214 290.626521,109.998742 289.344678,109.998742 C288.062836,109.998742 287.023276,108.96214 287.023276,107.680805 C287.023276,106.400876 288.062836,105.362868 289.344678,105.362868"
              id="Fill-323-Copy-3"
              fill="#BBB3FF"
            />
            <path
              d="M289.344678,131.176556 C290.626521,131.176556 291.666081,132.214564 291.666081,133.494493 C291.666081,134.775828 290.626521,135.81243 289.344678,135.81243 C288.062836,135.81243 287.023276,134.775828 287.023276,133.494493 C287.023276,132.214564 288.062836,131.176556 289.344678,131.176556"
              id="Fill-323-Copy-10"
              fill="#BBB3FF"
            />
            <path
              d="M289.344678,156.990244 C290.626521,156.990244 291.666081,158.028252 291.666081,159.30818 C291.666081,160.589516 290.626521,161.626117 289.344678,161.626117 C288.062836,161.626117 287.023276,160.589516 287.023276,159.30818 C287.023276,158.028252 288.062836,156.990244 289.344678,156.990244"
              id="Fill-323-Copy-16"
              fill="#BBB3FF"
            />
            <path
              d="M302.243468,105.362868 C303.52531,105.362868 304.56487,106.400876 304.56487,107.680805 C304.56487,108.96214 303.52531,109.998742 302.243468,109.998742 C300.961626,109.998742 299.922065,108.96214 299.922065,107.680805 C299.922065,106.400876 300.961626,105.362868 302.243468,105.362868"
              id="Fill-323-Copy-5"
              fill="#BBB3FF"
            />
            <path
              d="M302.243468,131.176556 C303.52531,131.176556 304.56487,132.214564 304.56487,133.494493 C304.56487,134.775828 303.52531,135.81243 302.243468,135.81243 C300.961626,135.81243 299.922065,134.775828 299.922065,133.494493 C299.922065,132.214564 300.961626,131.176556 302.243468,131.176556"
              id="Fill-323-Copy-11"
              fill="#BBB3FF"
            />
            <path
              d="M315.145816,131.176556 C316.427659,131.176556 317.467219,132.214564 317.467219,133.494493 C317.467219,134.775828 316.427659,135.81243 315.145816,135.81243 C313.863974,135.81243 312.824414,134.775828 312.824414,133.494493 C312.824414,132.214564 313.863974,131.176556 315.145816,131.176556"
              id="Fill-323-Copy-19"
              fill="#BBB3FF"
            />
            <path
              d="M302.243468,156.990244 C303.52531,156.990244 304.56487,158.028252 304.56487,159.30818 C304.56487,160.589516 303.52531,161.626117 302.243468,161.626117 C300.961626,161.626117 299.922065,160.589516 299.922065,159.30818 C299.922065,158.028252 300.961626,156.990244 302.243468,156.990244"
              id="Fill-323-Copy-17"
              fill="#BBB3FF"
            />
            <path
              d="M315.145816,156.990244 C316.427659,156.990244 317.467219,158.028252 317.467219,159.30818 C317.467219,160.589516 316.427659,161.626117 315.145816,161.626117 C313.863974,161.626117 312.824414,160.589516 312.824414,159.30818 C312.824414,158.028252 313.863974,156.990244 315.145816,156.990244"
              id="Fill-323-Copy-20"
              fill="#BBB3FF"
            />
            <path
              d="M315.087177,76.2066309 C313.34783,65.9112718 303.659948,41.5764933 298.948232,35.6468742 C293.230318,28.4513087 287.772553,25.0073326 279.518719,27.3208843 C271.955033,29.441909 270.96066,34.5573214 269.849112,40.0975841 C267.409941,52.2461509 270.187736,83.4075741 270.053361,88.5455736 C279.962693,86.7257086 308.883364,79.2569483 315.087177,76.2066309"
              id="Fill-120"
              fill="#070000"
            />
            <path
              d="M288.519462,27.2393561 C287.298264,26.8338661 284.973043,26.3541617 282.239323,26.7521227 C277.595332,27.4286565 276.10216,28.5709121 274.972337,29.417386 C272.560042,36.3128673 281.48145,30.9027486 288.519462,27.2393561"
              id="Fill-122"
              fill="#E7E6FF"
            />
            <path
              d="M287.191302,33.6166276 C290.267946,30.8674699 298.024056,33.3810777 297.352183,40.5960034 C297.107083,43.2289996 293.068316,75.6811072 281.509937,73.6611861 C269.087261,71.4885341 250.114621,48.2744999 250.114621,48.2744999 L253.41379,38.4577696 L258.60173,40.1786821 L278.694518,55.5227683 C278.694518,55.5227683 281.171313,38.9966304 287.191302,33.6166276"
              id="Fill-124"
              fill="#E7E6FF"
            />
            <path
              d="M259.310046,41.1177626 C255.643228,36.7068487 255.852853,30.615894 253.409383,31.61725 C251.463636,32.4142476 253.875932,40.1217845 253.875932,40.1217845 L259.310046,41.1177626 Z"
              id="Fill-126"
              fill="#E7E6FF"
            />
            <path
              d="M254.609295,37.6631383 C247.901308,35.7496987 240.498872,34.6579948 240.365572,36.3100708 C240.232272,37.9621468 253.695547,40.7263625 253.695547,40.7263625 L254.609295,37.6631383 Z"
              id="Fill-128"
              fill="#E7E6FF"
            />
            <path
              d="M253.789717,40.6214944 C247.081729,38.7080548 239.679293,37.6174265 239.545993,39.268427 C239.412694,40.920503 252.875969,43.6847187 252.875969,43.6847187 L253.789717,40.6214944 Z"
              id="Fill-130"
              fill="#E7E6FF"
            />
            <path
              d="M250.212446,40.2864543 C244.570857,38.8043184 241.226538,38.4042062 240.27194,39.0957979 L239.645216,38.2299638 C240.941663,37.2909909 244.182782,37.5975285 250.483345,39.2528312 L250.212446,40.2864543 Z"
              id="Fill-132"
              fill="#070000"
            />
            <path
              d="M253.221473,43.5068194 C246.513485,41.5933798 239.111049,40.5016759 238.97775,42.1537519 C238.84445,43.8058279 252.307725,46.5700436 252.307725,46.5700436 L253.221473,43.5068194 Z"
              id="Fill-134"
              fill="#E7E6FF"
            />
            <path
              d="M249.64431,43.1717792 C244.001645,41.6896433 240.658401,41.2895312 239.703803,41.9811229 L239.077079,41.1152888 C240.372452,40.1763159 243.614646,40.4828534 249.915209,42.1381561 L249.64431,43.1717792 Z"
              id="Fill-136"
              fill="#070000"
            />
            <path
              d="M252.466609,46.0381741 C246.48962,44.4828994 238.91841,43.6375012 238.852835,45.287426 C238.788335,46.9362753 250.750912,48.9884635 250.750912,48.9884635 L252.466609,46.0381741 Z"
              id="Fill-138"
              fill="#E7E6FF"
            />
            <path
              d="M248.541147,45.8029469 C244.576554,44.8983923 240.745261,44.1885158 239.564913,45.1178086 L238.90379,44.2777882 C240.363637,43.1290791 243.630556,43.5840453 248.778721,44.7607193 L248.541147,45.8029469 Z"
              id="Fill-140"
              fill="#070000"
            />
            <path
              d="M282.286301,8.31125452 C293.117981,0.6370603 297.857647,2.56878459 305.656757,9.24054728 C313.455867,15.91231 322.179476,17.251395 322.179476,17.251395 C322.179476,17.251395 317.443035,26.9702484 312.988243,29.1385982 L309.044076,26.0377289 L311.298346,31.139159 C311.298346,31.139159 307.341279,32.5072844 304.29796,31.8920582 C304.29796,31.8920582 301.666365,29.5559194 299.432519,24.2329219 C295.83665,15.6606265 295.512001,5.06303216 286.363768,9.16955963 C277.215535,13.2750115 282.286301,8.31125452 282.286301,8.31125452"
              id="Fill-142"
              fill="#3424C7"
            />
            <path
              d="M285.849812,11.874619 C287.189259,16.3210267 284.671614,21.01374 280.227572,22.352825 C275.782456,23.6929856 271.093314,21.174 269.753867,16.7275923 C268.414419,12.280109 270.932065,7.58847127 275.377181,6.24831065 C279.821223,4.90815003 284.510364,7.42713572 285.849812,11.874619"
              id="Fill-144"
              fill="#E7E6FF"
            />
            <path
              d="M272.07726,14.5824748 L271.83216,14.3232624 C273.480132,12.764761 275.184004,13.0379558 275.256029,13.0497871 L275.195829,13.400423 C275.179704,13.3982719 273.589782,13.1508907 272.07726,14.5824748"
              id="Fill-146"
              fill="#070000"
            />
            <path
              d="M288.203735,6.79147366 C287.160987,4.21655832 283.910193,1.03609689 278.415878,0.73923948 C268.153947,0.184245196 267.055299,9.24162285 270.502818,10.2483567 C273.510662,7.43896699 278.476078,8.76837191 279.808001,14.4613656 C279.808001,14.4613656 283.025469,12.1026399 283.880093,13.3653594 C284.733641,14.628079 282.957745,16.2909107 282.363271,16.700703 C282.363271,16.700703 284.585292,18.2108037 284.476717,19.7004686 C289.076633,15.4863841 290.355881,12.1058666 288.203735,6.79147366"
              id="Fill-148"
              fill="#3424C7"
            />
            <path
              d="M277.005266,19.657876 C277.18049,20.238684 276.851541,20.8517591 276.271042,21.0260015 C275.690543,21.2013194 275.077794,20.8721949 274.90257,20.291387 C274.72842,19.710579 275.057369,19.0975039 275.637868,18.9232615 C276.218367,18.7479435 276.830041,19.0770681 277.005266,19.657876"
              id="Fill-150"
              fill="#FF3D81"
            />
            <path
              d="M268.140187,48.0685282 C267.820913,47.8695477 260.313127,43.1811367 258.50283,41.0493563 C257.676157,40.0759652 256.779609,38.3335413 255.912085,36.6481226 C255.205812,35.2767704 254.238313,33.3988246 253.844864,33.1933907 L254.238313,32.2006393 C254.937062,32.4727586 255.618611,33.7451583 256.861309,36.1587381 C257.662182,37.7150883 258.56948,39.4779481 259.316604,40.356689 C261.019401,42.3626277 268.628236,47.1134218 268.704561,47.1607469 L268.140187,48.0685282 Z"
              id="Fill-152"
              fill="#070000"
            />
            <polygon
              id="Fill-154"
              fill="#E7E6FF"
              points="16.7605086 219.978115 16.6282838 178.356771 33.3756774 178.356771 31.457881 214.025909"
            />
            <polygon
              id="Fill-156"
              fill="#E7E6FF"
              points="72.5192566 219.889273 60.9555032 162.633438 78.8918446 160.70279 86.3125557 213.835963"
            />
            <path
              d="M9.95781383,77.5769074 C10.0341387,84.0314049 10.2211883,190.51932 10.5436877,203.106719 C21.080818,203.644504 25.5979595,204.074733 43.7697255,203.106719 C43.7697255,188.259547 42.8011523,151.627773 40.3705818,132.01905 C52.5212841,152.244075 53.3393575,156.979811 59.3604212,202.380709 C75.8487403,201.008282 84.8174485,199.947769 92.4789592,198.749584 C88.0435175,154.7437 62.8014898,99.9337121 47.3322688,71.0051728 C31.0976492,73.157389 24.5218865,74.5437992 9.95781383,77.5769074"
              id="Fill-158"
              fill="#3424C7"
            />
            <path
              d="M17.3817499,19.030711 C38.4925603,14.7714525 54.3659806,53.0843428 57.5920495,65.3479956 C36.9563882,72.4887069 20.8185185,77.9698133 0.818180966,78.5742838 C-0.256817019,68.245582 -2.10043856,22.9619205 17.3817499,19.030711"
              id="Fill-160"
              fill="#070000"
            />
            <path
              d="M18.951677,18.7944082 C21.6832469,18.5438003 24.9275908,18.4405455 30.3853555,21.7145816 C27.3721362,22.3384124 11.7986404,24.8703049 7.99099752,25.5866347 C11.457866,20.4561643 15.8288078,19.0815855 18.951677,18.7944082"
              id="Fill-162"
              fill="#E7E6FF"
            />
            <path
              d="M31.9044352,213.836071 C40.8774434,215.706488 47.0490068,220.583124 50.5330753,224.158319 C52.0606474,225.725425 50.9318995,228.30787 48.7131037,228.315399 L15.5160909,228.318625 L17.1038629,217.096125 C17.1038629,217.096125 27.9699426,213.016486 31.9044352,213.836071"
              id="Fill-164"
              fill="#7BEAFF"
            />
          </g>
          <g id="Group-173" transform="translate(128.024502, 530.627871)">
            <g id="Group-169">
              <mask id="mask-10" fill="white">
                <use xlink:href="#path-9" />
              </mask>
              <g id="Clip-168" />
              <path
                d="M23.5041889,1.57096733 C23.5201498,5.74456611 12.5633035,10.1688795 2.08154513,7.07815467 C-8.40021327,3.98742981 10.6405826,-1.61470904 10.6405826,-1.61470904 L23.5041889,1.57096733 Z"
                id="Fill-167"
                fill="#E7E6FF"
                mask="url(#mask-10)"
              />
            </g>
            <g id="Group-172">
              <mask id="mask-12" fill="white">
                <use xlink:href="#path-11" />
              </mask>
              <g id="Clip-171" />
              <polygon
                id="Fill-170"
                fill="#3424C7"
                mask="url(#mask-12)"
                points="-4.3876385 17.327583 37.8067652 17.1686192 37.7854608 11.6379607 -4.40894289 11.7979913"
              />
            </g>
          </g>
          <path
            d="M199.844777,531.576906 C208.731465,533.41235 214.843658,538.197803 218.29421,541.70615 C219.807087,543.243955 218.689197,545.778113 216.491746,545.785501 L183.614089,545.788668 L185.186586,534.776003 C185.186586,534.776003 195.948134,530.772646 199.844777,531.576906"
            id="Fill-174"
            fill="#7BEAFF"
          />
          <g id="Group-182" transform="translate(182.771822, 530.627871)">
            <g id="Group-178">
              <mask id="mask-14" fill="white">
                <use xlink:href="#path-13" />
              </mask>
              <g id="Clip-177" />
              <path
                d="M23.0914164,1.57096733 C23.1073773,5.74456611 12.1515963,10.1688795 1.66877263,7.07815467 C-8.81298577,3.98742981 10.2278101,-1.61470904 10.2278101,-1.61470904 L23.0914164,1.57096733 Z"
                id="Fill-176"
                fill="#E7E6FF"
                mask="url(#mask-14)"
              />
            </g>
            <g id="Group-181">
              <mask id="mask-16" fill="white">
                <use xlink:href="#path-15" />
              </mask>
              <g id="Clip-180" />
              <polygon
                id="Fill-179"
                fill="#3424C7"
                mask="url(#mask-16)"
                points="-4.800411 17.327583 37.3939927 17.1686192 37.3726883 11.6379607 -4.82171539 11.7979913"
              />
            </g>
          </g>
          <g id="Group-225" transform="translate(80.015314, 309.111792)">
            <path
              d="M60.0637599,15.1172505 L59.9440907,14.1515888 C60.9176159,14.0316912 61.3380753,13.7875754 61.4070738,13.5985476 C61.5353678,13.2496564 60.8453832,12.4957058 60.5510616,12.1738185 C60.4852974,12.1014479 60.4238456,12.0355583 60.3720968,11.9761495 L61.1008931,11.3345354 C61.1494077,11.3885433 61.2054689,11.4501123 61.2669207,11.5170822 C61.7844092,12.0830852 62.6501243,13.0293041 62.3180692,13.9344769 C62.0841213,14.5706903 61.3467002,14.957387 60.0637599,15.1172505"
              id="Fill-183"
              fill="#070000"
            />
            <path
              d="M58.8677145,16.7528265 C55.3487926,20.803421 49.21871,21.2300836 45.1747528,17.703366 C41.1318738,14.1777286 40.707102,8.0359473 44.2260239,3.98535286 C47.7449458,-0.0663217329 53.8750285,-0.491904189 57.9179075,3.03373321 C61.9618646,6.55937061 62.3866364,12.7022321 58.8677145,16.7528265"
              id="Fill-185"
              fill="#E7E6FF"
            />
            <path
              d="M45.1750763,17.7036901 C41.1321972,14.1780527 40.7063473,8.03627135 44.2263473,3.98459675 C47.7452692,-0.0659976854 53.8753519,-0.491580141 57.9182309,3.03405726 C56.5016061,10.3683336 51.1272723,16.5003935 45.1750763,17.7036901"
              id="Fill-187"
              fill="#000000"
            />
            <path
              d="M53.3935485,12.7596965 C53.3935485,11.222631 52.1494199,9.97612803 50.6152821,9.97612803 C49.0811443,9.97612803 47.8370156,11.222631 47.8370156,12.7596965 C47.8370156,14.2967621 49.0811443,15.543265 50.6152821,15.543265 C52.1494199,15.543265 53.3935485,14.2967621 53.3935485,12.7596965"
              id="Fill-189"
              fill="#E7E6FF"
            />
            <path
              d="M45.6306818,4.07673427 C45.6306818,2.5396687 44.3865531,1.29316578 42.8524153,1.29316578 C41.3182775,1.29316578 40.0741489,2.5396687 40.0741489,4.07673427 C40.0741489,5.61379984 41.3182775,6.86030277 42.8524153,6.86030277 C44.3865531,6.86030277 45.6306818,5.61379984 45.6306818,4.07673427"
              id="Fill-191"
              fill="#7BEAFF"
            />
            <path
              d="M40.4437219,2.74025414 C36.7479914,-1.53825374 28.8379639,2.21637726 25.4279302,13.144341 C23.121872,20.5347855 23.975728,25.7249472 20.0891737,32.0805999 C15.8295963,39.0476224 7.33739418,41.035114 2.76732374,47.3497207 C-0.400137213,51.7254429 3.32038959,56.155173 0.113038897,65.095645 C3.95646922,68.7703443 9.81810475,69.5739822 13.5386315,71.4167326 C19.3345029,64.0424904 11.9473544,62.8532359 17.3400159,55.372058 C17.1783008,60.2608555 19.8196484,62.6382844 18.6337372,71.6597683 C22.0847387,73.6580616 23.6479853,75.0082597 26.0208858,75.3863152 C27.260702,66.8519827 29.7575841,61.4630719 30.6577985,57.668475 C32.7061905,49.0250466 37.0724998,29.3013521 36.4806224,21.9055067 C35.7798567,13.144341 35.8607142,6.00881381 39.7990175,5.3347949 C41.3870603,5.06259495 40.4437219,2.74025414 40.4437219,2.74025414"
              id="Fill-193"
              fill="#000000"
            />
            <path
              d="M57.4966934,10.786571 L56.7474132,10.1687203 C57.5204116,9.22682207 59.2874193,8.22443496 60.7730426,8.26440083 L60.7504025,9.23654349 C59.6054591,9.21278001 58.1155234,10.0326203 57.4966934,10.786571"
              id="Fill-195"
              fill="#070000"
            />
            <path
              d="M57.9183387,17.0518144 C57.9183387,17.7020698 57.3922254,18.2291872 56.7432086,18.2291872 C56.0941917,18.2291872 55.5680784,17.7020698 55.5680784,17.0518144 C55.5680784,16.401559 56.0941917,15.8744416 56.7432086,15.8744416 C57.3922254,15.8744416 57.9183387,16.401559 57.9183387,17.0518144"
              id="Fill-197"
              fill="#FF3D81"
            />
            <path
              d="M72.7641139,141.445678 C72.4697923,140.869953 70.9043896,138.690193 68.9217617,135.930388 C62.8434279,127.465186 52.66831,113.296747 51.4144784,107.59351 L52.3621292,107.383959 C53.5728368,112.891687 64.071385,127.509472 69.7098536,135.362225 C71.8714462,138.372627 73.2999302,140.361198 73.6276729,141.001732 L72.7641139,141.445678 Z"
              id="Fill-199"
              fill="#FFFFFF"
            />
            <path
              d="M80.3833776,107.307808 L79.810906,106.521452 C84.7507651,102.915883 86.0078309,95.704745 82.8004802,89.3760962 L83.6661954,88.9364717 C87.0902444,95.6928632 85.710275,103.419237 80.3833776,107.307808"
              id="Fill-201"
              fill="#FFFFFF"
            />
            <path
              d="M40.4928833,52.1955279 C47.9792172,67.5877867 61.6775694,84.2848771 71.9432478,84.1584985 C86.0232478,83.9856732 122.421018,47.4590328 122.421018,47.4590328 L112.954213,33.4720601 L107.886059,38.3889417 C107.886059,38.3889417 80.6747884,63.2606717 74.857355,62.4354306 C69.1412631,61.6242316 71.9486383,60.775227 58.7127914,40.2468144 C52.5341942,30.6658083 34.3369262,39.5403907 40.4928833,52.1955279"
              id="Fill-203"
              fill="#E7E6FF"
            />
            <path
              d="M107.59756,40.1645063 C109.349474,31.6798611 105.619244,22.2155122 109.042215,22.7415494 C111.769811,23.1595707 113.366478,36.2802562 113.366478,36.2802562 L107.59756,40.1645063 Z"
              id="Fill-205"
              fill="#E7E6FF"
            />
            <path
              d="M112.288701,32.9076773 C119.018208,27.0380959 127.028499,22.1622604 128.130318,24.6963123 C129.231059,27.2303641 115.107935,37.321205 115.107935,37.321205 L112.288701,32.9076773 Z"
              id="Fill-207"
              fill="#E7E6FF"
            />
            <path
              d="M114.7168,36.2288407 C121.634975,30.1237848 129.835011,25.0113945 130.907722,27.5800115 C131.981511,30.1486284 117.499379,40.6877351 117.499379,40.6877351 L114.7168,36.2288407 Z"
              id="Fill-209"
              fill="#E7E6FF"
            />
            <path
              d="M118.649389,33.6761021 L118.027325,32.9307927 C124.58757,27.4360263 128.250957,25.4701378 130.275631,26.3580281 L129.887515,27.2491589 C127.545879,26.2240885 120.850872,31.8333516 118.649389,33.6761021"
              id="Fill-211"
              fill="#070000"
            />
            <path
              d="M116.377183,40.9219134 C123.10669,35.052332 131.116981,30.1764965 132.218801,32.7105484 C133.319542,35.2456804 119.196418,45.3354411 119.196418,45.3354411 L116.377183,40.9219134 Z"
              id="Fill-213"
              fill="#E7E6FF"
            />
            <path
              d="M120.212636,38.4899365 L119.594884,37.7392264 C125.986945,32.4583314 129.571631,30.5896571 131.58768,31.4926697 L131.192017,32.38056 C128.869787,31.3403673 122.353745,36.7206369 120.212636,38.4899365"
              id="Fill-215"
              fill="#070000"
            />
            <path
              d="M118.397329,44.9560895 C124.479975,39.9614365 132.827712,35.3988469 133.848674,37.9577424 C134.868557,40.5177181 121.425715,48.1511983 121.425715,48.1511983 L118.397329,44.9560895 Z"
              id="Fill-217"
              fill="#E7E6FF"
            />
            <path
              d="M122.697335,42.5299454 L122.111926,41.7543916 C127.434511,37.7178392 130.968527,35.6061293 133.282132,36.7608188 L132.848735,37.6314265 C130.999792,36.707891 127.453917,38.922216 122.697335,42.5299454"
              id="Fill-219"
              fill="#070000"
            />
            <path
              d="M87.7688012,55.3346845 L87.2372974,54.5213252 C88.8425899,53.4681706 101.315141,44.5557827 103.073524,43.1720996 C105.111135,41.5702246 106.801598,39.2727274 106.923423,37.9430523 L107.889402,38.0316253 C107.722296,39.862494 105.641561,42.3889847 103.672948,43.9368519 C101.907019,45.3270159 89.3805623,54.2772094 87.7688012,55.3346845"
              id="Fill-221"
              fill="#070000"
            />
            <path
              d="M112.507232,58.0514992 L111.851746,57.334274 C113.42793,55.8868616 120.332089,49.9589516 122.529259,48.271744 L122.853768,48.0233076 C125.247152,46.1891984 131.605792,41.3155232 133.083869,38.915411 L133.909694,39.4252458 C132.337823,41.9787405 126.105321,46.7552015 123.443489,48.7956209 L123.120059,49.0440574 C120.936904,50.7193832 114.074791,56.6116479 112.507232,58.0514992"
              id="Fill-223"
              fill="#070000"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END error404.svg -->

  <!-- BEGIN notAllowed.svg -->
  <svg
    v-else-if="name == 'notAllowed'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="150px"
    height="159px"
    viewBox="0 0 150 159"
    version="1.1"
  >
    <defs>
      <polygon
        id="path-1"
        points="0.210920989 0.108942272 147.458796 0.108942272 147.458796 158.134673 0.210920989 158.134673"
      />
      <polygon
        id="path-3"
        points="0.398177083 0.315591033 0.398177083 10.1778108 0.398177083 21.8483865 4.79817708 21.8483865 6.58424479 16.620805 11.2740451 21.8483865 25.5654514 21.8483865 25.5654514 15.962517 18.1963108 9.39706182 17.022309 0.315591033"
      />
      <polygon
        id="path-5"
        points="0.213043478 8.20320724 4.92092391 16.6239309 10.4923913 26.5885485 14.322894 24.4715461 13.382269 19.1480674 19.960462 21.3544408 32.4016304 14.4761924 29.591644 9.45014391 20.0422554 7.39130345 14.6847826 0.20285773"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-7"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-9"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-11"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-13"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-15"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-17"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-19"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-21"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-23"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-25"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-27"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-29"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-31"
      />
      <path
        d="M2.33545405,2.06794085 C-1.87306235,14.6389683 0.312020421,26.8860561 7.27327119,26.8860561 L7.27327119,26.8860561 C14.234522,26.8860561 44.4892249,26.8545096 44.4892249,26.8545096 L44.4892249,26.8545096 L42.7270614,52.677403 L55.6392559,52.1919643 L56.8098024,32.3252302 L60.4534866,51.7037005 L94.8081567,36.391898 C94.8081567,36.391898 83.6101949,15.3056815 70.6961208,10.3288749 L70.6961208,10.3288749 C64.8241221,8.066476 57.906103,8.09001814 50.9406231,8.11450195 L50.9406231,8.11450195 C42.587968,8.14322335 34.1681157,8.17194475 27.4018777,4.25782994 L27.4018777,4.25782994 C22.210309,1.25432478 16.9736289,0.380440848 12.6401164,0.380440848 L12.6401164,0.380440848 C6.61586672,0.380440848 2.33545405,2.06794085 2.33545405,2.06794085 L2.33545405,2.06794085 Z"
        id="path-33"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Page-non-droit" transform="translate(-766.000000, -635.000000)">
        <g id="Passeports" transform="translate(310.000000, 409.000000)">
          <g
            id="Illustration-non-acces"
            transform="translate(456.000000, 226.000000)"
          >
            <g id="Group-3" transform="translate(2.343750, 0.000000)">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1" />
              </mask>
              <g id="Clip-2" />
              <path
                d="M14.2075128,41.5389303 C39.4330687,-10.8007263 157.669757,-33.7918086 146.748401,97.6896718 C142.909338,143.906299 95.8898145,173.460916 60.9099542,149.773077 C30.1468157,128.940473 -26.0089386,124.982079 14.2075128,41.5389303"
                id="Fill-1"
                fill="#E7E6FF"
                mask="url(#mask-2)"
              />
            </g>
            <polygon
              id="Fill-4"
              fill="#000000"
              points="70.3125 124.21875 85.546875 124.21875 85.546875 97.265625 70.3125 97.265625"
            />
            <g id="Group-11" transform="translate(70.312500, 123.046875)">
              <path
                d="M29.6639558,1.06875 C29.2451342,1.06875 28.8368431,1.21418717 28.5118376,1.4856383 L19.916184,8.6532746 L30.3359848,4.4815492 C30.8227751,4.28636968 31.1966032,3.89174701 31.3626959,3.39811336 C31.5283099,2.90542719 31.4675209,2.3672623 31.1956459,1.92242354 C30.9242496,1.47900598 30.4719223,1.17676197 29.9554555,1.09243684 C29.858289,1.07632979 29.7606437,1.06875 29.6639558,1.06875 L29.6639558,1.06875 Z M18.2303675,10.0384807 L17.8914811,9.48184009 L28.083443,0.982056184 C28.6329368,0.523952793 29.3537885,0.327825798 30.0631525,0.442943816 C30.7720379,0.558535572 31.3918937,0.973528923 31.7642859,1.58228059 C32.1371567,2.19197972 32.2204423,2.92958777 31.9935607,3.60608378 C31.7662005,4.28210605 31.2530843,4.82406084 30.5853631,5.09124834 L18.2303675,10.0384807 Z"
                id="Fill-5"
                fill="#070000"
              />
              <path
                d="M20.2034237,9.47388132 L31.436935,9.8467121 C31.9639321,9.86424036 32.4660393,9.65342753 32.819764,9.26922706 C33.17301,8.8850266 33.3381454,8.36912733 33.2716126,7.8537018 C33.2060371,7.33922374 32.9169306,6.88112035 32.4789629,6.59640459 C32.0414739,6.31216257 31.5020318,6.23115359 30.9984887,6.37564328 L20.2034237,9.47388132 Z M31.4972453,10.5056799 C31.469962,10.5056799 31.4422002,10.5047324 31.4149169,10.5042586 L18.0944779,10.0622623 L18.0131068,9.41750665 L30.8132499,5.74367852 C31.5039464,5.54565658 32.2439442,5.65603723 32.8441753,6.04639628 C33.4444064,6.43675532 33.8407312,7.06493019 33.9311966,7.77032414 C34.0221407,8.47761303 33.7957378,9.18537566 33.3108621,9.71264461 C32.8441753,10.2190691 32.1874631,10.5056799 31.4972453,10.5056799 L31.4972453,10.5056799 Z"
                id="Fill-7"
                fill="#070000"
              />
              <polygon
                id="Fill-9"
                fill="#766DFF"
                points="0.399244608 10.4349036 0.399244608 21.8571692 4.81003356 21.8571692 6.60115372 16.7412866 11.3024851 21.8571692 25.6309678 21.8571692 25.6309678 16.0960572 18.2429561 9.67029255 17.0654693 0.782518285 0.399244608 0.782518285"
              />
            </g>
            <g id="Group-14" transform="translate(70.312500, 123.046875)">
              <mask id="mask-4" fill="white">
                <use xlink:href="#path-3" />
              </mask>
              <g id="Clip-13" />
              <polygon
                id="Fill-12"
                fill="#000000"
                mask="url(#mask-4)"
                points="-0.263828125 13.3760742 8.44498264 13.3760742 13.2087847 17.8485606 26.709566 17.8485606 27.6496267 23.5088697 -4.20883681 23.0558127"
              />
            </g>
            <g id="Group-23" transform="translate(94.921875, 93.750000)">
              <polygon
                id="Fill-15"
                fill="#000000"
                points="11.9287031 32.9759062 0.160734375 6.902625 13.7094844 0.3841875 25.3387031 25.5199687"
              />
              <path
                d="M37.9666406,19.0756875 C37.7674219,19.0756875 37.5672656,19.1099062 37.3750781,19.1788125 C36.8922656,19.3517812 36.5107031,19.7258437 36.3283594,20.2058437 L32.4180469,30.4949062 L39.3302344,21.9280312 C39.6532031,21.5281875 39.7835156,21.0088125 39.6883594,20.5035 C39.5932031,19.9981875 39.2819531,19.56225 38.8357031,19.3067812 C38.5675781,19.1535 38.2680469,19.0756875 37.9666406,19.0756875 L37.9666406,19.0756875 Z M31.6408594,32.4950625 L31.0830469,32.1749062 L35.7199219,19.9742812 C35.9697656,19.316625 36.4928906,18.8033437 37.1552344,18.5656875 C37.8175781,18.3285 38.5478906,18.39225 39.1586719,18.7414687 C39.7708594,19.091625 40.1974219,19.68975 40.3282031,20.3830312 C40.4585156,21.0763125 40.2794531,21.7883437 39.8369531,22.33725 L31.6408594,32.4950625 Z"
                id="Fill-17"
                fill="#070000"
              />
              <path
                d="M42.0518438,22.7327344 C41.586375,22.7327344 41.1387188,22.9178906 40.80825,23.2516406 L33.0584063,31.0675781 L42.8524688,26.0439844 C43.3099688,25.8091406 43.6399688,25.3877344 43.7580938,24.8871094 C43.8762188,24.3864844 43.768875,23.8619531 43.4641875,23.4475781 C43.1604375,23.0341406 42.6930938,22.7753906 42.1816875,22.7374219 C42.1385625,22.7341406 42.0949688,22.7327344 42.0518438,22.7327344 L42.0518438,22.7327344 Z M31.5359062,32.5802344 L31.1562187,32.0613281 L40.3460625,22.7932031 C40.8415313,22.2930469 41.5291875,22.0375781 42.2295,22.0882031 C42.9312188,22.1402344 43.5724688,22.4950781 43.9891875,23.0617969 C44.4068438,23.6303906 44.5535625,24.3499219 44.3918438,25.0366406 C44.230125,25.7228906 43.7773125,26.3013281 43.1496563,26.6233594 L31.5359062,32.5802344 Z"
                id="Fill-19"
                fill="#070000"
              />
              <polygon
                id="Fill-21"
                fill="#766DFF"
                points="16.5696094 41.3230781 22.0614844 51.2010469 25.8372656 49.1019844 24.9100781 43.8252656 31.3938281 46.0124531 43.6577344 39.1940156 40.8878906 34.2121406 31.4744531 32.1707344 26.1935156 25.0447969 11.9285156 32.9760469"
              />
            </g>
            <g id="Group-26" transform="translate(105.468750, 118.359375)">
              <mask id="mask-6" fill="white">
                <use xlink:href="#path-5" />
              </mask>
              <g id="Clip-25" />
              <polygon
                id="Fill-24"
                fill="#000000"
                mask="url(#mask-6)"
                points="5.87182065 19.6733697 13.4534103 15.4819223 19.7358152 17.0083203 31.4883967 10.5107257 35.0088451 14.890845 7.05877717 29.8370621"
              />
            </g>
            <path
              d="M25.5839641,70.8419871 C21.3611998,83.5182215 23.5539068,95.8678052 30.5379452,95.8678052 C37.521512,95.8678052 67.8757248,95.8359947 67.8757248,95.8359947 L66.1073215,121.875 L79.0622553,121.385973 L80.2366335,101.3525 L83.8922453,120.893623 L118.359375,105.453202 C118.359375,105.453202 107.124757,84.1905144 94.1684087,79.1725317 C81.2120605,74.1540741 63.1819834,80.2887468 50.7324424,73.0502034 C38.2829014,65.81166 25.5839641,70.8419871 25.5839641,70.8419871"
              id="Fill-27"
              fill="#B7B3FF"
            />
            <g id="Group-71" transform="translate(23.437500, 69.140625)">
              <g id="Group-31">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-30" />
                <polygon
                  id="Fill-29"
                  fill="#FFFFFF"
                  mask="url(#mask-8)"
                  points="18.7049194 113.002232 18.3318106 112.602958 115.01115 21.9073661 115.384259 22.3066406"
                />
              </g>
              <g id="Group-34">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-33" />
                <polygon
                  id="Fill-32"
                  fill="#FFFFFF"
                  mask="url(#mask-10)"
                  points="13.2463007 107.160252 12.8731919 106.760978 109.553001 16.0653861 109.92564 16.4646606"
                />
              </g>
              <g id="Group-37">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-36" />
                <polygon
                  id="Fill-35"
                  fill="#FFFFFF"
                  mask="url(#mask-12)"
                  points="7.78768197 101.318508 7.41457321 100.919233 104.094383 10.2236415 104.467021 10.6229161"
                />
              </g>
              <g id="Group-40">
                <mask id="mask-14" fill="white">
                  <use xlink:href="#path-13" />
                </mask>
                <g id="Clip-39" />
                <polygon
                  id="Fill-38"
                  fill="#FFFFFF"
                  mask="url(#mask-14)"
                  points="2.32901628 95.4765276 1.95590753 95.0772531 98.6357169 4.38166155 99.0083557 4.7809361"
                />
              </g>
              <g id="Group-43">
                <mask id="mask-16" fill="white">
                  <use xlink:href="#path-15" />
                </mask>
                <g id="Clip-42" />
                <polygon
                  id="Fill-41"
                  fill="#FFFFFF"
                  mask="url(#mask-16)"
                  points="-3.12941445 89.6347831 -3.50252321 89.2355085 93.1768162 -1.46008301 93.549925 -1.06080845"
                />
              </g>
              <g id="Group-46">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#path-17" />
                </mask>
                <g id="Clip-45" />
                <polygon
                  id="Fill-44"
                  fill="#FFFFFF"
                  mask="url(#mask-18)"
                  points="-8.58798615 83.7928502 -8.96109491 83.3935756 87.7182445 -7.3020159 88.0913533 -6.90274135"
                />
              </g>
              <g id="Group-49">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#path-19" />
                </mask>
                <g id="Clip-48" />
                <polygon
                  id="Fill-47"
                  fill="#FFFFFF"
                  mask="url(#mask-20)"
                  points="-14.0466518 77.9509644 -14.4197606 77.5516898 82.2595788 -13.1439017 82.6326876 -12.7446272"
                />
              </g>
              <g id="Group-52">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#path-21" />
                </mask>
                <g id="Clip-51" />
                <polygon
                  id="Fill-50"
                  fill="#FFFFFF"
                  mask="url(#mask-22)"
                  points="-19.5053175 72.1090315 -19.8784263 71.7097569 76.801383 -18.9858346 77.1740219 -18.5865601"
                />
              </g>
              <g id="Group-55">
                <mask id="mask-24" fill="white">
                  <use xlink:href="#path-23" />
                </mask>
                <g id="Clip-54" />
                <polygon
                  id="Fill-53"
                  fill="#FFFFFF"
                  mask="url(#mask-24)"
                  points="-24.9639832 66.2672869 -25.337092 65.8680123 71.3427174 -24.8275792 71.7158261 -24.4283046"
                />
              </g>
              <g id="Group-58">
                <mask id="mask-26" fill="white">
                  <use xlink:href="#path-25" />
                </mask>
                <g id="Clip-57" />
                <polygon
                  id="Fill-56"
                  fill="#FFFFFF"
                  mask="url(#mask-26)"
                  points="-30.422367 60.4255423 -30.7954757 60.0262678 65.8838637 -30.6693237 66.2569725 -30.2700492"
                />
              </g>
              <g id="Group-61">
                <mask id="mask-28" fill="white">
                  <use xlink:href="#path-27" />
                </mask>
                <g id="Clip-60" />
                <polygon
                  id="Fill-59"
                  fill="#FFFFFF"
                  mask="url(#mask-28)"
                  points="-35.8809857 54.5835624 -36.2540944 54.1842878 60.425245 -36.5113037 60.7983538 -36.1120292"
                />
              </g>
              <g id="Group-64">
                <mask id="mask-30" fill="white">
                  <use xlink:href="#path-29" />
                </mask>
                <g id="Clip-63" />
                <polygon
                  id="Fill-62"
                  fill="#FFFFFF"
                  mask="url(#mask-30)"
                  points="-41.3396513 48.7418649 -41.7127601 48.3425903 54.9665793 -42.3530012 55.3396881 -41.9537266"
                />
              </g>
              <g id="Group-67">
                <mask id="mask-32" fill="white">
                  <use xlink:href="#path-31" />
                </mask>
                <g id="Clip-66" />
                <polygon
                  id="Fill-65"
                  fill="#FFFFFF"
                  mask="url(#mask-32)"
                  points="-46.79827 42.8998849 -47.1713788 42.5006104 49.5084305 -48.1949812 49.8810694 -47.7957066"
                />
              </g>
              <g id="Group-70">
                <mask id="mask-34" fill="white">
                  <use xlink:href="#path-33" />
                </mask>
                <g id="Clip-69" />
                <polygon
                  id="Fill-68"
                  fill="#FFFFFF"
                  mask="url(#mask-34)"
                  points="-52.2568887 37.0580462 -52.6299975 36.6587716 44.0498118 -54.0368199 44.4224507 -53.6375453"
                />
              </g>
            </g>
            <g id="Group-105" transform="translate(0.000000, 18.750000)">
              <polygon
                id="Fill-72"
                fill="#4C3BE3"
                points="51.9624406 51.9655197 121.561778 51.9655197 121.561778 48.6398174 51.9624406 48.6398174"
              />
              <polygon
                id="Fill-74"
                fill="#B7B3FF"
                points="65.2322002 39.5297823 117.628706 39.5297823 129.650093 2.9138764 77.253587 2.9138764"
              />
              <polygon
                id="Fill-75"
                fill="#3424C7"
                points="65.2322002 39.5297823 117.628706 39.5297823 119.199069 34.5402809 66.803035 34.5402809"
              />
              <polygon
                id="Fill-76"
                fill="#4C3BE3"
                points="106.488363 48.7924508 89.6917892 48.7924508 86.8074482 39.5296875 103.604022 39.5296875"
              />
              <polygon
                id="Fill-77"
                fill="#070000"
                points="75.9076554 49.1214185 103.433318 49.1214185 103.433318 48.4630091 75.9076554 48.4630091"
              />
              <path
                d="M50.1379535,17.1973315 C71.6046145,23.1798982 57.556177,53.7705758 55.2289096,63.5722963 C39.0992221,59.4104284 30.916554,57.1299333 16.5382082,52.7466994 C17.7018419,45.1392029 33.9507677,12.6861131 50.1379535,17.1973315"
                id="Fill-78"
                fill="#4C3BE3"
              />
              <path
                d="M72.3142001,124.229199 L71.6595678,124.229199 C71.6595678,121.961503 70.0580987,119.976794 67.8519548,119.509414 L45.2951826,114.73322 L45.2951826,81.1761447 L45.9498149,81.1761447 L45.9498149,114.199003 L67.9867459,118.865225 C70.4945202,119.396124 72.3142001,121.65197 72.3142001,124.229199"
                id="Fill-79"
                fill="#070000"
              />
              <polygon
                id="Fill-80"
                fill="#070000"
                points="45.2954654 119.571225 45.9500977 119.571225 45.9500977 114.466064 45.2954654 114.466064"
              />
              <path
                d="M64.3695843,123.626487 C64.3695843,122.146132 65.5624384,120.946396 67.0343007,120.946396 C68.506163,120.946396 69.6990171,122.146132 69.6990171,123.626487 C69.6990171,125.106842 68.506163,126.306578 67.0343007,126.306578 C65.5624384,126.306578 64.3695843,125.106842 64.3695843,123.626487"
                id="Fill-81"
                fill="#070000"
              />
              <path
                d="M19.5854768,124.229199 L18.9308445,124.229199 C18.9308445,121.65197 20.7505244,119.396124 23.2582987,118.865225 L45.2952297,114.199003 L45.2952297,81.1761447 L45.949862,81.1761447 L45.949862,114.73322 L23.3930898,119.509414 C21.1869459,119.976794 19.5854768,121.961977 19.5854768,124.229199"
                id="Fill-82"
                fill="#070000"
              />
              <path
                d="M26.8756488,123.626487 C26.8756488,122.146132 25.6827947,120.946396 24.2109324,120.946396 C22.7390701,120.946396 21.546216,122.146132 21.546216,123.626487 C21.546216,125.106842 22.7390701,126.306578 24.2109324,126.306578 C25.6827947,126.306578 26.8756488,125.106842 26.8756488,123.626487"
                id="Fill-83"
                fill="#070000"
              />
              <path
                d="M42.9578766,123.626487 C42.9578766,122.146132 44.1507307,120.946396 45.622593,120.946396 C47.0944552,120.946396 48.2873094,122.146132 48.2873094,123.626487 C48.2873094,125.106842 47.0944552,126.306578 45.622593,126.306578 C44.1507307,126.306578 42.9578766,125.106842 42.9578766,123.626487"
                id="Fill-84"
                fill="#070000"
              />
              <polygon
                id="Fill-85"
                fill="#3424C7"
                points="5.703643 73.7243153 33.0181641 73.7243153 33.0181641 50.0102001 5.703643 50.0102001"
              />
              <polygon
                id="Fill-86"
                fill="#766DFF"
                points="0.082477072 73.7243153 27.3969981 73.7243153 27.3969981 50.0102001 0.082477072 50.0102001"
              />
              <polygon
                id="Fill-87"
                fill="#3424C7"
                points="23.5309443 85.0708567 67.7146187 85.0708567 67.7146187 77.2813378 23.5309443 77.2813378"
              />
              <polygon
                id="Fill-88"
                fill="#766DFF"
                points="19.3609035 85.0708567 38.1303286 85.0708567 38.1303286 77.2813378 19.3609035 77.2813378"
              />
              <path
                d="M29.1151134,81.7834077 L23.174879,81.7834077 C17.7921896,81.7834077 13.4128927,77.378843 13.4128927,71.9646225 L13.4128927,62.9914835 L14.0670538,62.9914835 L14.0670538,71.9646225 C14.0670538,77.0157461 18.1532035,81.1249982 23.174879,81.1249982 L29.1151134,81.1249982 L29.1151134,81.7834077 Z"
                id="Fill-89"
                fill="#070000"
              />
              <path
                d="M46.2487118,31.7212553 C40.7302887,28.5169013 47.2784969,15.4506268 55.4602225,20.3879863 C63.641948,25.3253459 75.5045075,33.3551914 79.3945975,35.6138817 C83.2846875,37.873046 99.0604305,40.4095102 105.317377,41.6182532 C111.326421,42.7791204 106.287307,48.4502581 100.925826,48.6934287 C100.925826,48.6934287 85.083159,48.8849315 75.1557473,48.4696928 C65.2288069,48.054454 51.4513655,34.7421647 46.2487118,31.7212553"
                id="Fill-90"
                fill="#070000"
              />
              <path
                d="M105.317471,41.6182058 C109.547838,41.6366924 113.916295,42.4060218 113.502967,43.6465239 C113.089639,44.886552 104.915926,44.0589185 104.915926,44.0589185 L105.317471,41.6182058 Z"
                id="Fill-91"
                fill="#070000"
              />
              <path
                d="M104.459333,43.7900562 C108.553494,43.8327177 112.784804,44.6257479 112.391742,45.8624579 C111.998208,47.0991678 104.083708,46.2265028 104.083708,46.2265028 L104.459333,43.7900562 Z"
                id="Fill-92"
                fill="#070000"
              />
              <path
                d="M103.925117,45.8425966 C107.531486,45.9900158 111.783061,46.9996717 111.354651,48.2197911 C110.925771,49.4403845 99.5684422,48.6061148 99.5684422,48.6061148 L103.925117,45.8425966 Z"
                id="Fill-93"
                fill="#070000"
              />
              <path
                d="M61.6706517,8.47314607 C61.6706517,12.1088553 58.7401236,15.0562921 55.1252713,15.0562921 C51.5099478,15.0562921 48.5794196,12.1088553 48.5794196,8.47314607 C48.5794196,4.8374368 51.5099478,1.89 55.1252713,1.89 C58.7401236,1.89 61.6706517,4.8374368 61.6706517,8.47314607"
                id="Fill-94"
                fill="#000000"
              />
              <path
                d="M34.8315757,12.2920154 C39.0544017,11.2287956 39.9673051,9.32466994 39.9673051,9.32466994 L34.8197932,10.0731426 L35.4310662,6.4601861 C40.7614415,6.18146419 45.5960118,0.528339185 52.6555779,0.431639747 C53.7593567,0.327356039 54.8537097,0.377127809 55.8735976,0.617454354 C55.8735976,0.617454354 55.8740689,0.617928371 55.8740689,0.617928371 C57.8233556,1.0772507 59.8273128,2.56187149 60.7854607,4.63664326 C60.7854607,4.63664326 60.3989967,7.2845014 57.4873204,10.3442802 C55.8472049,12.5683673 45.0672159,22.3283743 45.0672159,22.3283743 C45.0672159,22.3283743 44.7976337,17.7323069 40.9537309,15.7760393 C37.1093567,13.8202458 34.8315757,12.2920154 34.8315757,12.2920154"
                id="Fill-95"
                fill="#FF3D81"
              />
              <path
                d="M56.5921378,12.1853143 C56.0242243,12.3161429 55.4186069,11.783822 55.2395138,10.99648 C55.0599495,10.208664 55.3747762,9.46445751 55.9422185,9.33362886 C56.510132,9.20280021 57.1157494,9.73512114 57.2953138,10.5224631 C57.4744068,11.3102791 57.1600514,12.0544856 56.5921378,12.1853143"
                id="Fill-96"
                fill="#FFD4E3"
              />
              <path
                d="M53.5078724,9.58817591 C53.5078724,7.87697507 54.886889,6.49000176 56.5882732,6.49000176 C58.2891861,6.49000176 59.6682027,7.87697507 59.6682027,9.58817591 C59.6682027,11.2993768 58.2891861,12.6863501 56.5882732,12.6863501 C54.886889,12.6863501 53.5078724,11.2993768 53.5078724,9.58817591"
                id="Fill-97"
                fill="#FF3D81"
              />
              <path
                d="M58.0425089,7.16822507 C58.0425089,3.61215063 57.5005167,1.55965765 56.4834566,0.995577598 C55.4663965,0.431023525 53.0401567,0.162729986 52.6555779,0.386465941 C52.6555779,0.386465941 55.2585543,0.567540379 56.0508055,2.65748069 C56.653595,4.2468592 56.1313973,7.04545471 56.1313973,7.04545471 L58.0425089,7.16822507 Z"
                id="Fill-98"
                fill="#FF3D81"
              />
              <path
                d="M54.6009528,9.54361833 C54.5462823,8.08933462 55.6740973,6.8654231 57.1200382,6.81043715 C58.5664504,6.75497718 59.7833407,7.88929951 59.8380112,9.34405723 C59.8926817,10.7983409 58.7648667,12.0222525 57.3189258,12.0772384 C55.8725136,12.1326984 54.6556233,10.9983761 54.6009528,9.54361833"
                id="Fill-99"
                fill="#FF3D81"
              />
              <path
                d="M57.2207074,7.13755618 C57.1914869,7.13755618 57.1622665,7.1380302 57.1325747,7.13945225 C56.5203592,7.16267907 55.9538595,7.42433638 55.5377038,7.87607444 C55.1215481,8.3278125 54.9047512,8.9155934 54.9278448,9.53134129 C54.9514096,10.1466152 55.2115659,10.7163834 55.6607125,11.1354143 C56.109859,11.5539712 56.6928541,11.772019 57.3064835,11.7487921 C58.5700323,11.7004424 59.5588145,10.6272683 59.5107422,9.35642907 C59.4640837,8.11545295 58.4451384,7.13755618 57.2207074,7.13755618 M57.2183509,12.4086236 C55.6437458,12.4086236 54.3340099,11.1520049 54.2741551,9.55599017 C54.243992,8.76485604 54.5225289,8.00927317 55.0574516,7.42860253 C55.5928456,6.84745787 56.3210003,6.51137992 57.107596,6.48151685 C58.7387568,6.41562851 60.1031632,7.6978441 60.1649032,9.33130618 C60.2266432,10.9647683 58.9550824,12.3441573 57.330991,12.4062535 C57.2932872,12.4081496 57.2555834,12.4086236 57.2183509,12.4086236"
                id="Fill-100"
                fill="#FFFFFF"
              />
              <path
                d="M58.3594094,6.95050913 L57.7052484,6.92491222 C57.8833989,2.33121489 57.2268814,1.31824087 55.7804692,0.887833567 C55.1432749,0.698700843 53.3146404,0.69917486 52.6637784,0.715291433 L52.647283,0.0573560393 C52.7471981,0.0549859551 55.0999155,-0.000948033708 55.9661604,0.256917135 C57.9762445,0.854652388 58.5352034,2.41843399 58.3594094,6.95050913"
                id="Fill-101"
                fill="#FFFFFF"
              />
              <path
                d="M93.5245695,30.8307757 C100.278263,30.8506285 107.280331,25.5525421 109.16505,18.9973631 C111.049298,12.442184 107.102181,7.11186447 100.348487,7.09142582 C93.5952641,7.07157303 86.592725,12.3696594 84.7080061,18.9253125 C82.8237585,25.4804916 86.7708755,30.8108111 93.5245695,30.8307757"
                id="Fill-102"
                fill="#FFFFFF"
              />
              <path
                d="M93.6173208,30.3926414 C100.121698,30.4120207 106.865495,25.3092293 108.680462,18.9957988 C110.495429,12.6823683 106.693943,7.54923982 100.189565,7.52975245 C93.6851877,7.51084445 86.941391,12.6131619 85.1264241,18.9265923 C83.3114572,25.2400228 87.1129433,30.3731513 93.6173208,30.3926414"
                id="Fill-103"
                fill="#FF3D81"
              />
              <polygon
                id="Fill-104"
                fill="#FFFFFF"
                points="88.5451223 20.2347841 89.8520304 16.7299034 104.662085 16.7299034 103.355177 20.2347841"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END notAllowed.svg -->

  <!-- BEGIN login.svg -->
  <svg
    v-else-if="name == 'login'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="1264px"
    viewBox="0 0 1264 812"
    version="1.1"
  >
    <defs>
      <clipPath id="cut-off-bottom">
        <rect x="0" y="0" width="200" height="100" />
      </clipPath>
      <polygon
        id="path-1"
        points="0.6448 0.057 64.6648 0.057 64.6648 64.0786 0.6448 64.0786"
      />
      <path
        d="M0.553,12.98 L40.383,32.694 C43.051,34.003 45.978,31.489 45.102,28.651 L45.102,28.651 C43.103,22.174 38.674,12.496 29.05,4.862 L29.05,4.862 C24.83,1.514 9.304,0.089 9.304,0.089 L9.304,0.089 L0.553,12.98 Z"
        id="path-3"
      />
      <path
        d="M0.553,12.98 L40.383,32.694 C43.051,34.003 45.978,31.489 45.102,28.651 L45.102,28.651 C43.103,22.174 38.674,12.496 29.05,4.862 L29.05,4.862 C24.83,1.514 9.304,0.089 9.304,0.089 L9.304,0.089 L0.553,12.98 Z"
        id="path-5"
      />
      <path
        d="M0.243,154.646 C0.243,239.646 69.15,308.554 154.152,308.554 L154.152,308.554 C239.153,308.554 308.061,239.646 308.061,154.646 L308.061,154.646 C308.061,69.643 239.153,0.737 154.152,0.737 L154.152,0.737 C69.15,0.737 0.243,69.643 0.243,154.646 L0.243,154.646 Z M59.181,154.646 C59.181,102.195 101.701,59.675 154.152,59.675 L154.152,59.675 C206.602,59.675 249.122,102.195 249.122,154.646 L249.122,154.646 C249.122,207.096 206.602,249.616 154.152,249.616 L154.152,249.616 C101.701,249.616 59.181,207.096 59.181,154.646 L59.181,154.646 Z"
        id="path-7"
      />
      <polygon id="path-9" points="0 811 1264 811 1264 0.057 0 0.057" />
      <path
        d="M32.329,1.865 L0.614,32.996 L12.941,42.524 C12.941,42.524 27.253,36.338 30.221,31.843 L30.221,31.843 C36.991,21.592 38.189,11.016 38.073,4.24 L38.073,4.24 C38.039,2.225 36.389,0.898 34.667,0.898 L34.667,0.898 C33.849,0.898 33.015,1.197 32.329,1.865"
        id="path-11"
      />
      <path
        d="M32.329,1.865 L0.614,32.996 L12.941,42.524 C12.941,42.524 27.253,36.338 30.221,31.843 L30.221,31.843 C36.991,21.592 38.189,11.016 38.073,4.24 L38.073,4.24 C38.039,2.225 36.389,0.898 34.667,0.898 L34.667,0.898 C33.849,0.898 33.015,1.197 32.329,1.865 L32.329,1.865 Z"
        id="path-13"
      />
      <path
        d="M0.864,0.933 L2.996,16.367 C2.996,16.367 17.545,21.969 22.812,20.839 L22.812,20.839 C34.822,18.26 43.082,11.548 47.745,6.628 L47.745,6.628 C49.788,4.472 48.276,0.921 45.305,0.911 L45.305,0.911"
        id="path-15"
      />
      <path
        d="M0.864,0.933 L2.996,16.367 C2.996,16.367 17.545,21.969 22.812,20.839 L22.812,20.839 C34.822,18.26 43.082,11.548 47.745,6.628 L47.745,6.628 C49.788,4.472 48.276,0.921 45.305,0.911 L45.305,0.911 L0.864,0.933 Z"
        id="path-17"
      />
      <polygon id="path-19" points="0 811 1264 811 1264 0.057 0 0.057" />
      <path
        d="M11.537,1.765 C1.768,10.596 -2.401,22.685 3.436,27.185 L3.436,27.185 C9.274,31.683 29.289,15.957 32.982,12.263 L32.982,12.263 C36.675,8.571 36.199,0.23 36.199,0.23 L36.199,0.23 L11.537,1.765 Z"
        id="path-21"
      />
      <path
        d="M5.347,1.47 L0.349,16.228 L43.992,24.612 C46.912,25.162 49.065,21.96 47.463,19.457 L47.463,19.457 C43.81,13.748 36.962,5.601 25.651,0.806 L25.651,0.806 C24.285,0.228 22.132,0.018 19.728,0.018 L19.728,0.018 C13.404,0.018 5.347,1.47 5.347,1.47 L5.347,1.47 Z"
        id="path-23"
      />
      <path
        d="M5.347,1.47 L0.349,16.228 L43.992,24.612 C46.912,25.162 49.065,21.96 47.463,19.457 L47.463,19.457 C43.81,13.748 36.962,5.601 25.651,0.806 L25.651,0.806 C24.285,0.228 22.132,0.018 19.728,0.018 L19.728,0.018 C13.404,0.018 5.347,1.47 5.347,1.47 L5.347,1.47 Z"
        id="path-25"
      />
      <path
        d="M0.838,11.643 C-0.129,18.568 4.702,24.966 11.628,25.932 L11.628,25.932 C18.553,26.898 24.951,22.066 25.916,15.142 L25.916,15.142 C26.882,8.215 22.052,1.819 15.126,0.853 L15.126,0.853 C14.532,0.771 13.943,0.73 13.36,0.73 L13.36,0.73 C7.144,0.731 1.721,5.312 0.838,11.643 L0.838,11.643 Z"
        id="path-27"
      />
      <path
        d="M0.218,25.096 L42.878,36.554 C45.936,37.375 48.483,34.147 46.985,31.358 L46.985,31.358 C43.568,24.995 36.954,15.784 25.326,9.771 L25.326,9.771 C20.228,7.135 7.632,0.541 7.632,0.541 L7.632,0.541 L0.218,25.096 Z"
        id="path-29"
      />
      <path
        d="M0.218,25.096 L42.878,36.554 C45.936,37.375 48.483,34.147 46.985,31.358 L46.985,31.358 C43.568,24.995 36.954,15.784 25.326,9.771 L25.326,9.771 C20.228,7.135 7.632,0.541 7.632,0.541 L7.632,0.541 L0.218,25.096 Z"
        id="path-31"
      />
      <path
        d="M0.495,1.991 L0.359,22.554 L44.53,22.554 C47.696,22.554 49.319,18.776 47.149,16.471 L47.149,16.471 C42.198,11.212 33.421,4.03 20.632,1.24 L20.632,1.24 C19.306,0.951 17.482,0.84 15.467,0.84 L15.467,0.84 C8.965,0.84 0.495,1.991 0.495,1.991 L0.495,1.991 Z"
        id="path-33"
      />
      <path
        d="M0.495,1.991 L0.359,22.554 L44.53,22.554 C47.696,22.554 49.319,18.776 47.149,16.471 L47.149,16.471 C42.198,11.212 33.421,4.03 20.632,1.24 L20.632,1.24 C19.306,0.951 17.482,0.84 15.467,0.84 L15.467,0.84 C8.965,0.84 0.495,1.991 0.495,1.991 L0.495,1.991 Z"
        id="path-35"
      />
      <path
        d="M0.564,11.832 C-0.486,19.124 4.574,25.886 11.865,26.936 L11.865,26.936 C19.157,27.988 25.919,22.928 26.97,15.636 L26.97,15.636 C28.02,8.345 22.96,1.582 15.669,0.532 L15.669,0.532 C15.024,0.439 14.384,0.394 13.751,0.394 L13.751,0.394 C7.227,0.395 1.522,5.186 0.564,11.832 L0.564,11.832 Z"
        id="path-37"
      />
      <path
        d="M0.677,4.06 L0.75,48.501 L16.182,46.352 C16.182,46.352 21.769,31.796 20.631,26.53 L20.631,26.53 C18.038,14.522 11.316,6.271 6.391,1.615 L6.391,1.615 C5.708,0.968 4.886,0.679 4.08,0.679 L4.08,0.679 C2.341,0.679 0.682,2.029 0.677,4.06 L0.677,4.06 Z"
        id="path-39"
      />
      <path
        d="M0.677,4.06 L0.75,48.501 L16.182,46.352 C16.182,46.352 21.769,31.796 20.631,26.53 L20.631,26.53 C18.038,14.522 11.316,6.271 6.391,1.615 L6.391,1.615 C5.708,0.968 4.886,0.679 4.08,0.679 L4.08,0.679 C2.341,0.679 0.682,2.029 0.677,4.06 L0.677,4.06 Z"
        id="path-41"
      />
      <path
        d="M25.815,0.738 C13.826,3.42 5.625,10.203 1.005,15.162 L1.005,15.162 C-1.021,17.336 0.521,20.874 3.493,20.8590475 L3.493,20.8590475 L44.946,20.641 L45.871,1.956 C45.871,1.956 36.332,0.413992111 29.851,0.413992111 L29.851,0.413992111 C28.259,0.413 26.852,0.507 25.815,0.738 L25.815,0.738 Z"
        id="path-43"
      />
      <path
        d="M25.815,0.738 C13.826,3.42 5.625,10.203 1.005,15.162 L1.005,15.162 C-1.021,17.336 0.521,20.874 3.493,20.8590475 L3.493,20.8590475 L44.946,20.641 L45.871,1.956 C45.871,1.956 36.332,0.413992111 29.851,0.413992111 L29.851,0.413992111 C28.259,0.413 26.852,0.507 25.815,0.738 L25.815,0.738 Z"
        id="path-45"
      />
      <path
        d="M7.786,1.561 C2.115,3.563 -0.859,9.782 1.142,15.451 L1.142,15.451 C3.143,21.121 9.362,24.095 15.032,22.095 L15.032,22.095 C20.702,20.094 23.676,13.875 21.676,8.205 L21.676,8.205 C20.097,3.733 15.895,0.938 11.409,0.938 L11.409,0.938 C10.206,0.938 8.984,1.138 7.786,1.561 L7.786,1.561 Z"
        id="path-47"
      />
      <path
        d="M0.652,69.544 C39.216,71.148 77.334,34.994 80.675,9.67 L80.675,9.67 C81.476,3.594 77.284,0.798 70.452,0.797 L70.452,0.797 C48.809,0.795 0.652,28.846 0.652,69.544"
        id="path-49"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Connexion-1" transform="translate(-394.000000, -212.000000)">
        <g
          id="Illustration-Login"
          transform="translate(394.000000, 212.000000)"
        >
          <g id="Group-14" transform="translate(20.000000, 0.943000)">
            <path
              d="M0,811 C40.528,701.771 179.83,560.155 372.398,540.966 C564.967,521.777 567.306,442.976 642.861,384.194 C718.417,325.414 874.479,153.492 1030.217,283.667 L1030,811 L0,811 Z"
              id="Fill-1"
              fill="#E7E6FF"
            />
            <g id="Group-5" transform="translate(532.000000, 0.000000)">
              <mask id="login-mask-2" fill="white">
                <use xlink:href="#path-1" />
              </mask>
              <g id="Clip-4" />
              <path
                d="M32.6548,44.6836 C25.6868,44.6836 20.0388,39.0356 20.0388,32.0676 C20.0388,25.0996 25.6868,19.4516 32.6548,19.4516 C39.6228,19.4516 45.2708,25.0996 45.2708,32.0676 C45.2708,39.0356 39.6228,44.6836 32.6548,44.6836 M32.6548,0.0566 C14.9758,0.0566 0.6448,14.3886 0.6448,32.0676 C0.6448,49.7456 14.9758,64.0786 32.6548,64.0786 C50.3338,64.0786 64.6648,49.7456 64.6648,32.0676 C64.6648,14.3886 50.3338,0.0566 32.6548,0.0566"
                id="Fill-3"
                fill="#E7E6FF"
                mask="url(#login-mask-2)"
              />
            </g>
            <path
              d="M1028.2168,74.4727 C992.8668,74.4727 964.2098,103.1297 964.2098,138.4807 C964.2098,173.8297 992.8668,202.4877 1028.2168,202.4877 L1028.2168,74.4727 Z"
              id="Fill-6"
              fill="#E7E6FF"
            />
            <path
              d="M1202.9561,623 L617.0331,623 C599.3411,623 585.0001,608.658 585.0001,590.968 L585.0001,217.032 C585.0001,199.342 599.3411,185 617.0331,185 L1202.9561,185 C1220.6471,185 1234.9891,199.342 1234.9891,217.032 L1234.9891,590.968 C1234.9891,608.658 1220.6471,623 1202.9561,623"
              id="Fill-8"
              fill="#FFFFFF"
            />
            <polygon
              id="Fill-10"
              fill="#070000"
              points="484.7744 341.0684 484.9994 402.1084 466.3044 398.0894 462.9904 342.8094"
            />
            <path
              d="M486.0498,402.8613 C495.6738,410.4963 500.1028,420.1733 502.1018,426.6503 C502.9788,429.4893 500.0498,432.0033 497.3828,430.6943 L457.5528,410.9793 L466.3038,398.0893 C466.3038,398.0893 481.8298,399.5133 486.0498,402.8613"
              id="Fill-12"
              fill="#E7E6FF"
            />
          </g>
          <g id="Group-21" transform="translate(477.000000, 398.943000)">
            <g id="Group-17">
              <mask id="mask-4" fill="white">
                <use xlink:href="#path-3" />
              </mask>
              <g id="Clip-16" />
              <path
                d="M36.853,9.8154 C34.306,15.0114 18.32,13.9424 7.53,3.8174 C-3.261,-6.3066 23.239,-1.8546 23.239,-1.8546 L36.853,9.8154 Z"
                id="Fill-15"
                fill="#070000"
                mask="url(#mask-4)"
              />
            </g>
            <g id="Group-20">
              <mask id="mask-6" fill="white">
                <use xlink:href="#path-5" />
              </mask>
              <g id="Clip-19" />
              <polygon
                id="Fill-18"
                fill="#070000"
                mask="url(#mask-6)"
                points="-6.6064 12.6777 44.5776 37.7727 47.9536 30.8877 -3.2314 5.7927"
              />
            </g>
          </g>
          <g id="Group-62" transform="translate(288.000000, 204.943000)">
            <path
              d="M267.0068,45.6865 C276.2578,41.8515 286.7048,36.1855 288.4308,39.8055 C289.8058,42.6895 271.9308,52.7725 271.9308,52.7725 L267.0068,45.6865 Z"
              id="Fill-22"
              fill="#070000"
            />
            <path
              d="M280.2983,48.3916 C290.2903,51.0226 300.1673,55.5256 298.4613,58.2276 C296.7563,60.9286 277.9143,53.9596 277.9143,53.9596 L280.2983,48.3916 Z"
              id="Fill-24"
              fill="#070000"
            />
            <path
              d="M277.9668,53.498 C287.9588,56.129 289.1658,56.914 287.4598,59.616 C285.7538,62.317 275.5828,59.066 275.5828,59.066 L277.9668,53.498 Z"
              id="Fill-26"
              fill="#070000"
            />
            <path
              d="M287.7793,58.7266 C287.4193,56.7076 285.8203,56.1366 282.3723,55.6196 L282.5863,54.1926 C285.2643,54.5936 288.5963,55.0936 289.1993,58.4736 L287.7793,58.7266 Z"
              id="Fill-28"
              fill="#FFFFFF"
            />
            <path
              d="M275.2563,58.5996 C285.2483,61.2316 286.4553,62.0166 284.7493,64.7176 C283.0443,67.4186 272.8723,64.1676 272.8723,64.1676 L275.2563,58.5996 Z"
              id="Fill-30"
              fill="#070000"
            />
            <path
              d="M285.0352,63.3281 C284.7612,61.7871 283.9882,61.5751 281.7942,61.1921 C281.2772,61.1011 280.6912,60.9991 280.0742,60.8561 L280.3992,59.4511 C280.9782,59.5851 281.5192,59.6801 282.0432,59.7701 C284.1602,60.1401 285.9902,60.4611 286.4552,63.0751 L285.0352,63.3281 Z"
              id="Fill-32"
              fill="#FFFFFF"
            />
            <path
              d="M273.2866,63.2012 C282.0216,65.7802 283.1476,67.0942 281.3656,69.7332 C279.5826,72.3742 271.9676,69.2642 271.9676,69.2642 L273.2866,63.2012 Z"
              id="Fill-34"
              fill="#070000"
            />
            <path
              d="M281.877,68.7129 C281.63,66.8949 281.514,66.8589 279.566,66.2719 C279.212,66.1649 278.813,66.0439 278.361,65.8969 L278.81,64.5259 C279.25,64.6689 279.639,64.7859 279.983,64.8909 C282.226,65.5669 282.953,65.9059 283.307,68.5189 L281.877,68.7129 Z"
              id="Fill-36"
              fill="#FFFFFF"
            />
            <path
              d="M204.0869,0.4102 C219.0619,22.2202 236.4389,38.5652 236.4389,38.5652 C236.4389,38.5652 274.0249,47.6012 280.2979,48.3912 L273.0059,69.6872 C273.0059,69.6872 240.0069,63.5132 226.5769,55.7442 C203.6129,42.4622 181.1539,13.1072 181.1539,13.1072 L204.0869,0.4102 Z"
              id="Fill-38"
              fill="#070000"
            />
            <path
              d="M96.8906,242.5088 C105.3376,236.1868 114.5286,227.6838 117.2326,230.9308 C119.3876,233.5168 103.7606,248.4608 103.7606,248.4608 L96.8906,242.5088 Z"
              id="Fill-40"
              fill="#4C3BE3"
            />
            <path
              d="M111.0522,241.7139 C121.9372,241.7999 133.1922,243.8279 132.1542,247.0289 C131.1152,250.2319 110.0672,248.0189 110.0672,248.0189 L111.0522,241.7139 Z"
              id="Fill-42"
              fill="#4C3BE3"
            />
            <path
              d="M131.3647,245.9521 C130.1147,243.1961 119.8787,242.8421 116.5157,242.7241 L116.5657,241.2831 C126.7247,241.6361 131.5437,242.8531 132.6787,245.3561 L131.3647,245.9521 Z"
              id="Fill-44"
              fill="#070000"
            />
            <path
              d="M20.8745,212.6543 C41.8365,231.0243 63.8295,243.1913 63.8295,243.1913 C63.8295,243.1913 104.5545,242.6373 111.1645,241.8113 L109.2585,265.4513 C109.2585,265.4513 71.9575,265.0503 56.2255,260.6133 C29.3245,253.0273 0.7655,231.5843 0.7655,231.5843 L20.8745,212.6543 Z"
              id="Fill-46"
              fill="#4C3BE3"
            />
            <path
              d="M110.0122,247.7686 C120.8972,247.8556 132.1522,249.8826 131.1142,253.0846 C130.0752,256.2866 109.0272,254.0736 109.0272,254.0736 L110.0122,247.7686 Z"
              id="Fill-48"
              fill="#4C3BE3"
            />
            <path
              d="M130.3252,252.0068 C129.0742,249.2508 118.8392,248.8968 115.4752,248.7798 L115.5252,247.3388 C125.6842,247.6898 130.5032,248.9078 131.6382,251.4108 L130.3252,252.0068 Z"
              id="Fill-50"
              fill="#070000"
            />
            <path
              d="M108.6724,253.5459 C119.5574,253.6319 130.8124,255.6599 129.7744,258.8609 C128.7354,262.0639 107.6874,259.8509 107.6874,259.8509 L108.6724,253.5459 Z"
              id="Fill-52"
              fill="#4C3BE3"
            />
            <path
              d="M128.9854,257.7842 C127.7344,255.0272 117.4994,254.6742 114.1354,254.5562 L114.1854,253.1152 C124.3444,253.4672 129.1634,254.6842 130.2984,257.1872 L128.9854,257.7842 Z"
              id="Fill-54"
              fill="#070000"
            />
            <path
              d="M107.8579,258.7559 C117.4469,259.1159 128.7569,261.7029 127.6249,264.8619 C126.4919,268.0219 108.0889,265.2889 108.0889,265.2889 L107.8579,258.7559 Z"
              id="Fill-56"
              fill="#4C3BE3"
            />
            <path
              d="M126.855,263.8057 C125.936,261.5317 120.945,260.6987 113.735,260.1477 L113.845,258.7087 C122.018,259.3327 126.985,260.2797 128.193,263.2647 L126.855,263.8057 Z"
              id="Fill-58"
              fill="#070000"
            />
            <path
              d="M209.1519,365.6152 C156.7009,365.6152 114.1809,323.0952 114.1809,270.6452 C114.1809,218.1942 156.7009,175.6752 209.1519,175.6752 C261.6029,175.6752 304.1219,218.1942 304.1219,270.6452 C304.1219,323.0952 261.6029,365.6152 209.1519,365.6152 M209.1519,116.7362 C124.1509,116.7362 55.2429,185.6432 55.2429,270.6452 C55.2429,355.6462 124.1509,424.5532 209.1519,424.5532 C294.1529,424.5532 363.0609,355.6462 363.0609,270.6452 C363.0609,185.6432 294.1529,116.7362 209.1519,116.7362"
              id="Fill-60"
              fill="#E7E6FF"
            />
          </g>
          <g id="Group-67" transform="translate(343.000000, 320.943000)">
            <mask id="mask-8" fill="white">
              <use xlink:href="#path-7" />
            </mask>
            <g id="Clip-64" />
            <polygon
              id="Fill-63"
              fill="#3424C7"
              mask="url(#mask-8)"
              points="154.152 334.628 334.135 334.628 334.135 154.646 154.152 154.646"
            />
            <polygon
              id="Fill-65"
              fill="#766DFF"
              mask="url(#mask-8)"
              points="154.1519 376.9238 154.1519 154.6458 243.3209 -15.0642 -11.0151 0.7368 -109.4691 308.0258"
            />
            <polygon
              id="Fill-66"
              fill="#B7B3FF"
              mask="url(#mask-8)"
              points="154.1519 154.6455 -25.5131 68.8945 -7.4151 260.7155 154.1519 343.7855"
            />
          </g>
          <g id="Group-79" transform="translate(0.000000, 0.943000)">
            <path
              d="M1249.6919,590.5957 C1249.6919,608.1437 1235.4969,622.3687 1217.9869,622.3687 L637.0129,622.3687 C619.5039,622.3687 605.3089,608.1437 605.3089,590.5957 L605.3089,220.4047 C605.3089,202.8567 619.5039,188.6307 637.0129,188.6307 L1217.9869,188.6307 C1235.4969,188.6307 1249.6919,202.8567 1249.6919,220.4047 L1249.6919,590.5957 Z M1232.2959,178.9997 L622.7039,178.9997 C605.1939,178.9997 590.9999,193.2257 590.9999,210.7737 L590.9999,600.2267 C590.9999,617.7747 605.1939,631.9997 622.7039,631.9997 L1232.2959,631.9997 C1249.8059,631.9997 1263.9999,617.7747 1263.9999,600.2267 L1263.9999,210.7737 C1263.9999,193.2257 1249.8059,178.9997 1232.2959,178.9997 L1232.2959,178.9997 Z"
              id="Fill-68"
              fill="#070000"
            />
            <path
              d="M1247.522,589.126 C1247.522,606.513 1233.427,620.607 1216.041,620.607 L639.152,620.607 C621.766,620.607 607.671,606.513 607.671,589.126 L607.671,222.338 C607.671,204.951 621.766,190.856 639.152,190.856 L1216.041,190.856 C1233.427,190.856 1247.522,204.951 1247.522,222.338 L1247.522,589.126 Z M1230.249,181.314 L624.944,181.314 C607.558,181.314 593.463,195.408 593.463,212.795 L593.463,598.668 C593.463,616.055 607.558,630.149 624.944,630.149 L1230.249,630.149 C1247.635,630.149 1261.73,616.055 1261.73,598.668 L1261.73,212.795 C1261.73,195.408 1247.635,181.314 1230.249,181.314 L1230.249,181.314 Z"
              id="Fill-70"
              fill="#766DFF"
            />
            <mask id="mask-10" fill="white">
              <use xlink:href="#path-9" />
            </mask>
            <g id="Clip-73" />
            <polygon
              id="Fill-72"
              fill="#B7B3FF"
              mask="url(#mask-10)"
              points="863.952 678.021 982.692 678.021 982.692 632 863.952 632"
            />
            <path
              d="M999.9087,694 L846.7347,694 L846.7347,692.027 C846.7347,684.292 853.0067,678.021 860.7417,678.021 L985.9017,678.021 C993.6377,678.021 999.9087,684.292 999.9087,692.027 L999.9087,694 Z"
              id="Fill-74"
              fill="#070000"
              mask="url(#mask-10)"
            />
            <polygon
              id="Fill-75"
              fill="#070000"
              mask="url(#mask-10)"
              points="607.68 475.366 651.061 475.366 651.061 473.924 607.68 473.924"
            />
            <path
              d="M923.2388,262.9805 C923.2388,253.6075 915.6408,246.0095 906.2688,246.0095 C896.8968,246.0095 889.2988,253.6075 889.2988,262.9805 C889.2988,272.3525 896.8968,279.9505 906.2688,279.9505 C915.6408,279.9505 923.2388,272.3525 923.2388,262.9805"
              id="Fill-76"
              fill="#070000"
              mask="url(#mask-10)"
            />
            <path
              d="M916.6343,262.9805 C916.6343,257.2555 911.9933,252.6155 906.2693,252.6155 C900.5443,252.6155 895.9033,257.2555 895.9033,262.9805 C895.9033,268.7055 900.5443,273.3455 906.2693,273.3455 C911.9933,273.3455 916.6343,268.7055 916.6343,262.9805"
              id="Fill-77"
              fill="#FFFFFF"
              mask="url(#mask-10)"
            />
            <path
              d="M755.2217,93.8428 C761.9917,83.5918 763.1887,73.0168 763.0737,66.2398 C763.0227,63.2688 759.4577,61.7918 757.3297,63.8648 L725.6137,94.9958 L737.9417,104.5248 C737.9417,104.5248 752.2537,98.3378 755.2217,93.8428"
              id="Fill-78"
              fill="#070000"
              mask="url(#mask-10)"
            />
          </g>
          <g id="Group-86" transform="translate(725.000000, 62.943000)">
            <g id="Group-82">
              <mask id="mask-12" fill="white">
                <use xlink:href="#path-11" />
              </mask>
              <g id="Clip-81" />
              <path
                d="M10.0952,39.5332 C2.9912,52.5122 26.7892,40.0342 26.7892,40.0342 L36.0952,24.7072 C32.0572,20.5612 17.1992,26.5532 10.0952,39.5332"
                id="Fill-80"
                fill="#070000"
                mask="url(#mask-12)"
              />
            </g>
            <g id="Group-85">
              <mask id="mask-14" fill="white">
                <use xlink:href="#path-13" />
              </mask>
              <g id="Clip-84" />
              <polygon
                id="Fill-83"
                fill="#E7E6FF"
                mask="url(#mask-14)"
                points="-6.0967 35.5117 -0.7457 41.0047 40.0863 1.2267 34.7353 -4.2653"
              />
            </g>
          </g>
          <g id="Group-91" transform="translate(736.000000, 69.943000)">
            <path
              d="M0.6909,36.2588 L33.3019,81.9968 C58.9689,116.5968 59.5799,112.1868 71.7519,95.8058 C83.9229,79.4248 26.3689,16.5818 26.3689,16.5818 L0.6909,36.2588 Z"
              id="Fill-87"
              fill="#3424C7"
            />
            <path
              d="M74.8115,20.8389 C86.8225,18.2599 95.0825,11.5479 99.7445,6.6279 C101.7885,4.4719 100.2765,0.9209 97.3055,0.9109 L52.8645,0.9329 L54.9955,16.3669 C54.9955,16.3669 69.5455,21.9699 74.8115,20.8389"
              id="Fill-89"
              fill="#070000"
            />
          </g>
          <g id="Group-98" transform="translate(788.000000, 69.943000)">
            <g id="Group-94">
              <mask id="mask-16" fill="white">
                <use xlink:href="#path-15" />
              </mask>
              <g id="Clip-93" />
              <path
                d="M3.0576,12.2373 C-11.1024,16.5313 14.6256,24.2843 14.6256,24.2843 L32.0026183,19.8563 C32.0216,14.0693 17.2176,7.9443 3.0576,12.2373"
                id="Fill-92"
                fill="#070000"
                mask="url(#mask-16)"
              />
            </g>
            <g id="Group-97">
              <mask id="mask-18" fill="white">
                <use xlink:href="#path-17" />
              </mask>
              <g id="Clip-96" />
              <polygon
                id="Fill-95"
                fill="#E7E6FF"
                mask="url(#mask-18)"
                points="-5.7129 5.6982 51.2911 5.8862 51.3161 -1.7808 -5.6879 -1.9698"
              />
            </g>
          </g>
          <g id="Group-155" transform="translate(0.000000, 0.943000)">
            <path
              d="M791.0654,85.3291 L802.1124,130.4891 L736.4374,130.4891 L743.2664,179.5811 L776.5144,179.5811 C785.1914,179.5811 825.5404,180.9331 835.9534,164.5531 C846.3654,148.1711 821.8274,85.3291 821.8274,85.3291 L791.0654,85.3291 Z"
              id="Fill-99"
              fill="#4C3BE3"
            />
            <path
              d="M637.6333,140.0352 C609.3973,161.7822 638.2823,180.1082 638.2823,180.1082 L749.6063,179.8322 L740.8843,126.1922 C740.8843,126.1922 668.1423,116.5362 637.6333,140.0352"
              id="Fill-101"
              fill="#E7E6FF"
            />
            <mask id="login-mask-20" fill="white">
              <use xlink:href="#path-19" />
            </mask>
            <g id="Clip-104" />
            <polygon
              id="Fill-103"
              fill="#4C3BE3"
              mask="url(#login-mask-20)"
              points="636.69 297.938 704.022 297.938 704.022 267.048 636.69 267.048"
            />
            <polygon
              id="Fill-105"
              fill="#4C3BE3"
              mask="url(#login-mask-20)"
              points="669.8306 308.9941 678.8086 294.2611 660.8536 294.2611"
            />
            <path
              d="M607.063,173.127 L634.72,188.288 C634.72,188.288 656.49,158.461 646.08,147.943 C635.669,137.426 631.294,143.032 607.063,173.127"
              id="Fill-106"
              fill="#E7E6FF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M626.1626,256.3857 L627.8056,264.8567 C627.8056,264.8567 648.2296,262.8527 648.1366,259.6587 C648.0196,255.6507 636.1746,256.6147 626.1626,256.3857"
              id="Fill-107"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M637.2031,264.0898 L632.7731,268.2208 C632.7731,268.2208 647.1941,282.2058 649.8461,280.4238 C652.4971,278.6418 645.2811,270.5318 637.2031,264.0898"
              id="Fill-108"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M651.2534,279.4902 L649.8524,279.1482 C650.3004,277.3102 647.2104,273.5852 640.6664,268.0742 L641.5954,266.9702 C648.9874,273.1962 651.8764,276.9402 651.2534,279.4902"
              id="Fill-109"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M613.0884,223.1377 C613.0884,223.1377 617.0784,208.7307 634.7194,188.2877 L607.0634,173.1267 C607.0634,173.1267 576.0544,210.0237 590.1844,229.9717 C599.1524,242.6327 621.9554,280.7637 621.9554,280.7637 L637.2294,264.2287 C631.8094,260.9717 613.0884,223.1377 613.0884,223.1377"
              id="Fill-110"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M632.8784,268.002 L628.4484,272.133 C628.4484,272.133 642.8694,286.118 645.5214,284.336 C648.1724,282.554 640.9564,274.444 632.8784,268.002"
              id="Fill-111"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M646.9292,283.4023 L645.5282,283.0603 C645.9762,281.2223 642.8862,277.4973 636.3422,271.9863 L637.2712,270.8823 C644.6632,277.1083 647.5522,280.8523 646.9292,283.4023"
              id="Fill-112"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M628.4932,271.5303 L624.0632,275.6613 C624.0632,275.6613 638.4842,289.6463 641.1362,287.8643 C643.7872,286.0823 636.5712,277.9733 628.4932,271.5303"
              id="Fill-113"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M642.5439,286.9307 L641.1419,286.5887 C641.5909,284.7517 638.4999,281.0257 631.9569,275.5147 L632.8859,274.4107 C640.2779,280.6367 643.1659,284.3807 642.5439,286.9307"
              id="Fill-114"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M624.832,274.9443 L621.956,280.7633 C621.956,280.7633 633.317,292.7813 636.014,291.0863 C638.711,289.3903 631.781,280.8323 624.832,274.9443"
              id="Fill-115"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M637.4106,290.2354 L636.0236,289.8364 C636.7026,287.4864 632.7516,283.4574 628.3806,279.4544 L629.3546,278.3904 C635.1026,283.6544 638.2636,287.2804 637.4106,290.2354"
              id="Fill-116"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M617.731,180.1396 L616.425,179.5256 C626.436,158.2536 636.843,152.2496 637.281,152.0046 L637.985,153.2636 C637.883,153.3226 627.518,159.3416 617.731,180.1396"
              id="Fill-117"
              fill="#070000"
              mask="url(login-#mask-20)"
            />
            <path
              d="M620.8437,182.5605 L619.5797,181.8675 C630.0647,162.7675 639.4477,155.8445 639.8427,155.5595 L640.6887,156.7275 C640.5947,156.7955 631.1537,163.7825 620.8437,182.5605"
              id="Fill-118"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M692.4687,168.3818 C698.1037,180.5658 712.1537,195.9308 712.1537,195.9308 L738.2727,179.8348 C735.9617,171.8268 733.3087,161.0018 720.8907,148.5838 C704.8517,132.5448 686.8337,156.1988 692.4687,168.3818"
              id="Fill-119"
              fill="#E7E6FF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M662.834,219.3076 C660.981,221.9106 676.846,234.9296 676.846,234.9296 L682.92,228.8016 C674.471,223.4266 665.16,216.0396 662.834,219.3076"
              id="Fill-120"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M649.8706,235.6182 C651.0836,238.5732 670.8456,234.9652 670.8456,234.9652 L669.4596,229.0682 C659.1636,229.9332 648.6576,232.6632 649.8706,235.6182"
              id="Fill-121"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M650.5742,234.5537 L649.2192,234.0597 C650.1192,231.5937 654.6012,230.0877 664.2062,229.0217 L664.3652,230.4547 C655.8632,231.3997 651.2232,232.7787 650.5742,234.5537"
              id="Fill-122"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M712.1533,195.9307 C718.8983,216.8467 715.5923,223.1587 715.5923,223.1587 C715.5923,223.1587 675.6763,229.4757 669.3613,229.1697 L672.8643,251.4057 C672.8643,251.4057 710.6133,248.8827 725.1843,243.5517 C750.0983,234.4367 738.2733,179.8347 738.2733,179.8347 L712.1533,195.9307 Z"
              id="Fill-123"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M651.2905,241.2744 C652.5035,244.2294 672.2655,240.6214 672.2655,240.6214 L670.8795,234.7244 C660.5835,235.5894 650.0775,238.3184 651.2905,241.2744"
              id="Fill-124"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M651.9941,240.21 L650.6391,239.715 C651.5391,237.25 656.0211,235.743 665.6271,234.678 L665.7861,236.111 C657.2831,237.055 652.6421,238.434 651.9941,240.21"
              id="Fill-125"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M652.9741,246.6455 C654.1871,249.6005 673.9501,245.9925 673.9501,245.9925 L672.5631,240.0955 C662.2671,240.9605 651.7611,243.6895 652.9741,246.6455"
              id="Fill-126"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M653.6777,245.5811 L652.3227,245.0861 C653.2227,242.6211 657.7047,241.1141 667.3107,240.0491 L667.4697,241.4821 C658.9667,242.4261 654.3267,243.8051 653.6777,245.5811"
              id="Fill-127"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M655.4404,252.1699 C656.7404,255.0789 673.9604,251.1679 673.9604,251.1679 L673.7094,244.9679 C664.6594,245.9989 654.1414,249.2619 655.4404,252.1699"
              id="Fill-128"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M656.127,251.125 L654.753,250.688 C655.687,247.757 660.33,246.5 668.033,245.318 L668.252,246.745 C662.394,247.643 656.87,248.795 656.127,251.125"
              id="Fill-129"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M730.105,187.5527 C721.479,166.1767 711.494,159.6447 711.395,159.5797 L712.168,158.3637 C712.592,158.6327 722.645,165.2117 731.443,187.0127 L730.105,187.5527 Z"
              id="Fill-130"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M726.8604,189.7959 C717.6054,170.4279 708.5904,162.9599 708.5014,162.8869 L709.4114,161.7679 C709.7894,162.0749 718.7674,169.5149 728.1624,189.1729 L726.8604,189.7959 Z"
              id="Fill-131"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M678.8296,152.8047 C674.1676,147.5927 666.1636,147.1467 660.9526,151.8077 C655.7406,156.4697 655.2946,164.4737 659.9556,169.6847 C664.6176,174.8967 672.6216,175.3427 677.8326,170.6817 C683.0446,166.0197 683.4916,158.0157 678.8296,152.8047"
              id="Fill-132"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M670.6099,170.3262 C670.1889,170.3262 669.7399,170.2922 669.2619,170.2132 L669.4969,168.7902 C672.2559,169.2462 673.7979,167.9042 673.8619,167.8472 L674.8319,168.9152 C674.7589,168.9812 673.2519,170.3262 670.6099,170.3262"
              id="Fill-133"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M662.6191,167.9531 C662.5121,167.9141 659.9831,166.9781 658.8631,163.6411 L660.2301,163.1821 C661.1311,165.8621 663.0841,166.5871 663.1041,166.5941 L662.6191,167.9531 Z"
              id="Fill-134"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M664.0464,176.8184 C665.1364,177.1664 667.7434,172.4754 667.7434,172.4754 L662.6264,170.3744 C662.5604,175.0904 663.2484,176.5644 664.0464,176.8184"
              id="Fill-135"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M656.9687,159.082 C656.9687,159.082 660.3057,156.269 658.3617,154.329 C656.4177,152.389 654.3997,156.217 656.9687,159.082"
              id="Fill-136"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M679.0688,166.3037 C679.6528,167.1497 684.9088,165.7417 684.4708,163.8247 C684.0338,161.9077 676.0348,161.9117 679.0688,166.3037"
              id="Fill-137"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M675.333,149.6387 C669.092,146.3207 662.292,147.8247 658.543,154.5847 C660.901,156.2627 659.215,159.6707 659.215,159.6707 L659.759,160.4377 C659.759,160.4377 662.179,155.3567 664.174,156.5227 C666.169,157.6897 665.018,161.0717 669.135,162.3927 C673.253,163.7137 673.869,160.3577 676.091,160.6097 C678.314,160.8617 678.348,163.8337 677.675,165.7247 L679.069,166.3037 C679.069,166.3037 680.132,162.1687 681.999,162.5047 C682.661,157.9787 681.574,152.9567 675.333,149.6387"
              id="Fill-138"
              fill="#766DFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M594.4155,332.3008 L592.9725,332.3008 C592.9725,327.2528 597.1035,324.5698 600.7475,322.2008 C605.3185,319.2308 608.9295,316.8838 605.0925,310.8948 C603.4985,308.4068 601.9055,306.3848 600.5005,304.5998 C595.1515,297.8068 591.9215,293.7068 598.5825,277.8328 L599.9125,278.3918 C593.5815,293.4818 596.4415,297.1128 601.6345,303.7068 C603.0605,305.5178 604.6755,307.5698 606.3075,310.1148 C610.9175,317.3128 606.1465,320.4128 601.5335,323.4108 C598.0345,325.6848 594.4155,328.0358 594.4155,332.3008"
              id="Fill-139"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M917.8926,305.5771 C908.7626,304.0641 906.6906,304.9641 907.0936,307.7971 C907.4976,310.6301 917.7996,311.0021 917.7996,311.0021 L917.8926,305.5771 Z"
              id="Fill-140"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M917.9263,310.6055 C908.7963,309.0925 906.7383,309.3335 907.1413,312.1665 C907.5453,314.9995 917.8333,316.0295 917.8333,316.0295 L917.9263,310.6055 Z"
              id="Fill-141"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M907.8003,311.8906 L906.3983,311.5526 C906.9753,309.1556 909.4903,308.4286 913.8783,309.3976 L913.5673,310.8066 C910.0983,310.0416 908.1583,310.4066 907.8003,311.8906"
              id="Fill-142"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M918.271,315.7686 C909.141,314.2556 907.083,314.4966 907.486,317.3296 C907.89,320.1626 918.178,321.1926 918.178,321.1926 L918.271,315.7686 Z"
              id="Fill-143"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M906.7778,317.4648 C906.5588,316.3318 906.9738,315.6228 907.3608,315.2268 C908.3818,314.1838 910.4718,313.9448 913.7528,314.5018 L913.5108,315.9238 C909.7828,315.2928 908.6908,315.9308 908.3928,316.2358 C908.2558,316.3758 908.0858,316.6278 908.1948,317.1928 L906.7778,317.4648 Z"
              id="Fill-144"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M918.1943,320.251 C910.1103,319.157 907.9243,319.857 908.4133,322.668 C908.9023,325.48 917.0493,325.689 917.0493,325.689 L918.1943,320.251 Z"
              id="Fill-145"
              fill="#FFFFFF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M907.6338,322.1699 C907.5818,321.5789 907.5918,320.7159 908.2698,320.0479 C909.0908,319.2359 910.6588,318.9779 913.1998,319.2329 L913.0548,320.6679 C910.3998,320.4019 909.5528,320.8079 909.2828,321.0739 C909.0888,321.2659 909.0278,321.5469 909.0708,322.0449 L907.6338,322.1699 Z"
              id="Fill-146"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M934.3574,325.1641 C928.2164,325.8631 922.2414,326.1381 917.0494,325.6891 L916.7874,305.6721 L928.0504,304.8961 C928.0504,304.8961 948.3054,323.5751 934.3574,325.1641"
              id="Fill-147"
              fill="#E7E6FF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M922.5576,324.8711 C929.7316,335.7921 941.7486,373.8801 947.1826,379.9111 C955.6676,389.3301 958.8346,364.7201 958.8346,364.7201 L935.8306,313.5781 L922.5576,324.8711 Z"
              id="Fill-148"
              fill="#E7E6FF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M921.4478,544.2314 C917.6138,563.2994 928.9948,561.1964 935.7218,550.1844 C942.4488,539.1714 942.7508,530.2274 936.4968,527.0864 C930.2418,523.9454 921.4478,544.2314 921.4478,544.2314"
              id="Fill-149"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M940.4761,419.2041 C940.4761,419.2041 879.7341,409.3721 855.4571,430.2721 C846.7831,437.7401 849.6681,452.2331 856.9591,467.7771 C858.5961,471.2651 860.4531,474.8051 862.4521,478.3301 C866.9601,486.2831 872.1871,494.1621 877.2031,501.1921 C887.7891,516.0291 912.8481,535.8591 912.8481,535.8591 L924.4641,514.4151 C924.4641,514.4151 889.0051,461.9741 897.5581,457.0351 C906.1111,452.0981 958.8871,461.9441 961.0761,460.6811 C963.2641,459.4171 955.8781,422.5241 955.8781,422.5241 L940.4761,419.2041 Z"
              id="Fill-150"
              fill="#B7B3FF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M919.3096,610.3301 C917.4206,597.4421 919.1776,593.0671 921.0386,588.4341 C922.3676,585.1251 923.7426,581.7021 923.7426,574.6661 C923.7426,570.5961 922.1446,566.6911 920.4546,562.5581 C918.4766,557.7231 916.4326,552.7251 916.4326,546.6431 C916.4326,540.5661 917.3426,535.6771 918.3966,530.0151 C919.9956,521.4271 921.8076,511.6931 921.3466,493.9771 L921.8136,262.9781 L923.2566,262.9781 L922.7886,493.9611 C923.2536,511.8081 921.3476,522.0501 919.8146,530.2791 C918.7736,535.8711 917.8746,540.6991 917.8746,546.6431 C917.8746,552.4411 919.8646,557.3061 921.7896,562.0111 C923.5356,566.2801 925.1846,570.3121 925.1846,574.6661 C925.1846,581.9811 923.7576,585.5351 922.3766,588.9731 C920.5916,593.4191 918.9046,597.6181 920.7376,610.1211 L919.3096,610.3301 Z"
              id="Fill-151"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M982.1787,428.6641 C975.7457,456.9071 960.4887,461.4601 948.1357,480.6411 C935.7817,499.8211 937.7787,523.7681 937.7787,523.7681 L907.2127,524.9291 C907.2127,524.9291 906.6377,498.9221 911.0377,472.9351 C913.3937,459.0151 919.1567,449.7791 932.1327,436.0391 C940.7417,426.9241 948.1357,420.9411 948.1357,420.9411 L982.1787,428.6641 Z"
              id="Fill-152"
              fill="#E7E6FF"
              mask="url(#login-mask-20)"
            />
            <path
              d="M934.2983,527.1191 L932.8573,527.0541 C932.9903,524.1351 933.1113,521.3811 933.2253,518.7791 C934.5343,488.8631 934.9753,478.7851 944.1733,469.5871 C945.1603,468.5991 946.2183,467.5611 947.3273,466.4731 C957.2953,456.6951 970.9463,443.3031 974.3293,426.8251 L975.7433,427.1151 C972.2713,444.0241 958.4383,457.5951 948.3373,467.5041 C947.2323,468.5881 946.1773,469.6231 945.1933,470.6071 C936.3913,479.4091 935.9573,489.3461 934.6663,518.8431 C934.5523,521.4441 934.4313,524.1991 934.2983,527.1191"
              id="Fill-153"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
            <path
              d="M911.5371,524.7646 C901.7681,533.5956 897.5991,545.6856 903.4361,550.1846 C909.2741,554.6826 929.2891,538.9566 932.9821,535.2636 C936.6751,531.5706 936.1991,523.2306 936.1991,523.2306 L911.5371,524.7646 Z"
              id="Fill-154"
              fill="#070000"
              mask="url(#login-mask-20)"
            />
          </g>
          <g id="Group-158" transform="translate(900.000000, 523.943000)">
            <mask id="mask-22" fill="white">
              <use xlink:href="#path-21" />
            </mask>
            <g id="Clip-157" />
            <path
              d="M-1.5674,17.833 C2.4576,26.254 4.7766,28.734 14.2476,22.211 C23.7196,15.688 34.0836,7.854 36.4966,4.087 C38.9096,0.32 43.7336,10.238 43.7336,10.238 L24.4636,37.133 L0.7616,35.882 L-1.5674,17.833 Z"
              id="Fill-156"
              fill="#B7B3FF"
              mask="url(#mask-22)"
            />
          </g>
          <g id="Group-215" transform="translate(424.000000, 245.943000)">
            <polygon
              id="Fill-159"
              fill="#FFFFFF"
              points="483.0918 297.6768 481.6788 297.3848 484.0238 286.0338 505.5708 284.6588 505.6618 286.0988 485.2138 287.4048"
            />
            <polygon
              id="Fill-161"
              fill="#FFFFFF"
              points="480.126 293.7822 479.998 292.3452 490.091 291.4462 490.51 281.7732 491.952 281.8362 491.478 292.7712"
            />
            <path
              d="M554.8525,97.3799 C551.4175,91.4509 543.8275,89.4289 537.8985,92.8629 C531.9695,96.2979 529.9475,103.8879 533.3815,109.8169 C536.8155,115.7459 544.4065,117.7689 550.3355,114.3339 C556.2645,110.8999 558.2865,103.3099 554.8525,97.3799"
              id="Fill-163"
              fill="#FFFFFF"
            />
            <path
              d="M551.1855,89.1641 C550.7985,87.0221 545.5375,87.0741 543.6595,85.3041 C540.7515,86.9881 540.9695,89.4761 536.2785,88.7271 C531.4835,87.9621 532.5845,91.8321 527.4545,93.6111 C527.7955,94.7641 529.3905,97.0961 529.3905,97.0961 C529.3905,97.0961 528.0605,96.4251 526.1855,94.1561 C524.2675,95.3201 523.1985,97.7441 523.1985,97.7441 C524.8865,100.6571 531.8125,106.1921 531.8125,106.1921 C531.8125,106.1921 531.7575,104.1611 534.3575,103.5991 C535.3885,103.3761 541.8725,103.4981 542.8115,103.5991 C546.1235,103.9511 548.6715,104.0811 549.7265,105.9021 C550.7815,107.7241 550.5105,110.3081 550.5105,110.3081 L551.8105,110.0881 C551.8105,110.0881 550.9455,106.4861 552.6445,105.5021 C554.3445,104.5181 554.8815,107.2851 554.2535,109.6431 L555.2065,109.9471 C555.2065,109.9471 558.4225,103.5991 556.1625,98.5951 C553.4325,92.5521 552.3335,95.5131 551.1855,89.1641"
              id="Fill-165"
              fill="#070000"
            />
            <path
              d="M536.54,109.1543 C535.516,109.1543 534.153,109.0103 533.067,108.3863 L533.787,107.1343 C535.056,107.8653 537.119,107.7373 537.808,107.6263 L538.038,109.0503 C537.983,109.0583 537.374,109.1543 536.54,109.1543"
              id="Fill-167"
              fill="#070000"
            />
            <path
              d="M543.6177,109.1719 C543.0827,109.1719 542.5367,109.1099 542.0207,108.9509 L542.4477,107.5729 C544.1257,108.0909 546.4557,107.1769 546.4797,107.1679 L547.0157,108.5069 C546.9297,108.5419 545.3327,109.1719 543.6177,109.1719"
              id="Fill-169"
              fill="#070000"
            />
            <path
              d="M543.9741,111.9531 C543.5331,110.7551 542.2041,110.1411 541.0061,110.5821 C539.8071,111.0231 539.1941,112.3521 539.6351,113.5511 C540.0761,114.7491 541.4051,115.3621 542.6031,114.9221 C543.8011,114.4801 544.4151,113.1511 543.9741,111.9531"
              id="Fill-171"
              fill="#070000"
            />
            <path
              d="M541.6504,114.4814 C541.7284,114.6924 541.8354,114.8844 541.9624,115.0574 C542.1764,115.0434 542.3914,114.9994 542.6034,114.9214 C543.8014,114.4804 544.4154,113.1514 543.9744,111.9534 C543.8964,111.7424 543.7894,111.5494 543.6624,111.3774 C543.4484,111.3924 543.2334,111.4354 543.0214,111.5134 C541.8234,111.9544 541.2094,113.2834 541.6504,114.4814"
              id="Fill-173"
              fill="#FFB3A1"
            />
            <path
              d="M568.5625,143.5879 C566.1695,132.6709 559.7795,119.8149 541.9185,117.9489 C518.8305,115.5389 504.4355,171.4739 504.4355,171.4739 L563.5495,184.8819 C563.5495,184.8819 572.9125,163.4379 568.5625,143.5879"
              id="Fill-175"
              fill="#070000"
            />
            <path
              d="M509.2944,120.0137 C509.9344,114.2697 512.2404,107.0207 509.4714,106.2977 C506.7024,105.5757 500.5254,118.9777 500.5254,118.9777 L509.2944,120.0137 Z"
              id="Fill-177"
              fill="#E7E6FF"
            />
            <path
              d="M504.0503,111.2871 C501.2273,102.4741 496.7353,93.8501 494.3993,95.5031 C492.0633,97.1561 499.1823,113.6811 499.1823,113.6811 L504.0503,111.2871 Z"
              id="Fill-179"
              fill="#E7E6FF"
            />
            <path
              d="M499.5928,113.6123 C496.7698,104.7993 495.6158,103.0773 493.2808,104.7303 C490.9448,106.3833 494.7248,116.0073 494.7248,116.0073 L499.5928,113.6123 Z"
              id="Fill-181"
              fill="#E7E6FF"
            />
            <path
              d="M497.4233,109.8262 C496.5203,106.3902 495.3083,104.8312 493.8263,105.1902 L493.4853,103.7882 C495.8873,103.2092 497.6773,105.1172 498.8193,109.4602 L497.4233,109.8262 Z"
              id="Fill-183"
              fill="#070000"
            />
            <path
              d="M495.1567,116.2764 C492.3337,107.4634 491.1797,105.7414 488.8447,107.3944 C486.5087,109.0474 490.2887,118.6714 490.2887,118.6714 L495.1567,116.2764 Z"
              id="Fill-185"
              fill="#E7E6FF"
            />
            <path
              d="M492.8447,112.1123 C491.7047,108.5083 490.6367,107.8273 490.2317,107.7013 C490.0437,107.6443 489.7417,107.6063 489.2897,107.9623 L488.3997,106.8263 C489.3077,106.1133 490.1287,106.1603 490.6567,106.3233 C492.0517,106.7543 493.2167,108.5053 494.2207,111.6773 L492.8447,112.1123 Z"
              id="Fill-187"
              fill="#070000"
            />
            <path
              d="M491.1333,118.2559 C488.4153,110.5639 486.7943,108.9389 484.5163,110.6559 C482.2393,112.3749 485.7723,119.7199 485.7723,119.7199 L491.1333,118.2559 Z"
              id="Fill-189"
              fill="#E7E6FF"
            />
            <path
              d="M488.4155,113.874 C487.4405,111.391 486.6925,110.821 486.3325,110.703 C486.0725,110.617 485.7945,110.691 485.3715,110.958 L484.6035,109.735 C485.1065,109.42 485.8805,109.034 486.7835,109.333 C487.8805,109.693 488.8255,110.969 489.7585,113.347 L488.4155,113.874 Z"
              id="Fill-191"
              fill="#070000"
            />
            <path
              d="M494.1426,134.8779 C490.7166,129.7339 487.7446,124.5439 485.7716,119.7199 L503.4616,110.3469 L513.7786,124.6419 C513.7786,124.6419 501.9246,146.5619 494.1426,134.8779"
              id="Fill-193"
              fill="#E7E6FF"
            />
            <path
              d="M494.8091,135.7842 C502.2871,146.4992 512.5191,158.5022 518.1201,164.3792 C526.8661,173.5552 541.0371,184.9412 563.8861,152.1732 L546.2061,136.4512 L533.1421,151.4722 L513.7781,124.6412 L494.8091,135.7842 Z"
              id="Fill-195"
              fill="#E7E6FF"
            />
            <path
              d="M504.0503,59.8965 C499.2323,56.7045 493.8363,51.3425 491.9293,53.4765 C490.0223,55.6105 499.1253,67.2245 499.1253,67.2245 L504.0503,59.8965 Z"
              id="Fill-197"
              fill="#E7E6FF"
            />
            <path
              d="M161.0249,13.9395 C159.8769,13.9395 158.8049,14.2085 157.8799,14.7515 C155.8049,15.9705 154.7249,18.4725 154.8399,21.7965 C154.9869,26.0205 156.3999,29.1315 159.0389,31.0445 C161.7749,33.0285 165.4299,33.4625 168.5549,33.3635 C171.2639,32.8535 173.4719,32.5785 174.5329,32.4605 C174.0259,21.2065 168.0209,16.6665 166.0539,15.4785 C164.3629,14.4585 162.6209,13.9395 161.0249,13.9395 M168.7049,34.8175 C166.6929,35.1995 164.4119,35.7105 162.1419,36.3775 C156.3229,38.0875 149.3869,41.1885 149.3869,46.2505 C149.3869,51.8355 154.1369,54.4915 158.5489,54.5935 C168.8999,54.8395 174.0969,44.9845 174.5269,35.7305 C174.5539,35.1485 174.5669,34.5835 174.5669,34.0305 C173.4089,34.3015 171.2359,34.7265 168.7049,34.8175 M241.3349,96.7905 C227.2919,96.7905 219.2809,82.3085 210.8009,66.9765 C201.9219,50.9255 192.7439,34.3355 176.0099,33.8445 C176.0119,34.4775 175.9989,35.1275 175.9679,35.7975 C175.6649,42.3125 173.5639,47.6865 169.8909,51.3375 C166.7909,54.4185 162.6379,56.1285 158.5159,56.0365 C152.2919,55.8915 147.9439,51.8675 147.9439,46.2505 C147.9439,39.9565 156.1969,36.3925 163.6229,34.4605 C161.7079,34.0865 159.8219,33.3945 158.1919,32.2125 C155.1739,30.0255 153.5619,26.5385 153.3989,21.8465 C153.2639,17.9685 154.5959,15.0075 157.1489,13.5065 C159.8239,11.9355 163.4309,12.2115 166.7989,14.2445 C168.9289,15.5295 175.4369,20.4275 175.9749,32.4005 C193.5769,32.8555 202.9719,49.8425 212.0629,66.2785 C220.3319,81.2275 228.1429,95.3475 241.3349,95.3475 C256.1039,95.3475 261.7119,85.4335 267.6489,74.9385 C274.3979,63.0065 281.3769,50.6695 301.9009,50.6695 C328.6819,50.6695 334.4299,39.3375 340.5149,27.3405 C347.1469,14.2675 353.9959,0.7495 387.7509,0.9135 C430.5349,1.1215 480.6089,0.9165 481.1099,0.9135 L481.1159,2.3555 C480.6149,2.3575 430.5329,2.5635 387.7439,2.3555 C387.5469,2.3545 387.3469,2.3545 387.1509,2.3545 C354.8029,2.3545 348.1969,15.3865 341.8019,27.9935 C335.7869,39.8515 329.5679,52.1125 301.9009,52.1125 C282.2179,52.1125 275.4499,64.0775 268.9039,75.6485 C262.7539,86.5205 256.9449,96.7905 241.3349,96.7905"
              id="Fill-199"
              fill="#070000"
            />
            <path
              d="M312.5576,51.0332 C312.5576,49.4192 311.2486,48.1102 309.6346,48.1102 C308.0196,48.1102 306.7106,49.4192 306.7106,51.0332 C306.7106,52.6472 308.0196,53.9562 309.6346,53.9562 C311.2486,53.9562 312.5576,52.6472 312.5576,51.0332"
              id="Fill-201"
              fill="#070000"
            />
            <path
              d="M363.666,5.6436 C363.666,4.0296 362.357,2.7206 360.743,2.7206 C359.128,2.7206 357.819,4.0296 357.819,5.6436 C357.819,7.2586 359.128,8.5676 360.743,8.5676 C362.357,8.5676 363.666,7.2586 363.666,5.6436"
              id="Fill-203"
              fill="#070000"
            />
            <polygon
              id="Fill-205"
              fill="#070000"
              points="97.2729 122.75 111.4379 180.361 92.3469 181.47 79.9509 125.738"
            />
            <path
              d="M29.0684,6.9131 C-4.1116,31.0381 -3.9476,57.7481 8.7874,69.6421 C26.0654,85.7791 65.8184,74.6721 69.6894,87.3011 C76.6294,109.9361 85.9474,152.6991 85.9474,152.6991 L115.1204,152.6991 C115.1204,152.6991 112.0774,89.4861 101.9104,69.7951 C95.0324,56.4731 61.1834,45.1411 61.1834,45.1411 L74.1544,28.5251 L29.0684,6.9131 Z"
              id="Fill-207"
              fill="#3424C7"
            />
            <polygon
              id="Fill-209"
              fill="#070000"
              points="17.8145 16.374 66.1945 45.821 13.9235 20.482"
            />
            <path
              d="M25.082,38.7158 C24.865,39.8078 24.579,41.7928 24.781,43.9658 C25.176,48.2168 27.181,51.1668 30.737,52.7348 C35.765,54.9498 39.487,54.0638 41.725,52.9298 C44.305,51.6218 46.267,49.2698 47.084,46.5448 C36.76,44.5128 27.803,40.1318 25.082,38.7158 M36.722,55.5478 C34.823,55.5478 32.626,55.1448 30.155,54.0548 C20.463,49.7828 23.863,37.5588 23.898,37.4358 C23.959,37.2238 24.114,37.0518 24.318,36.9678 C24.521,36.8838 24.753,36.8988 24.945,37.0068 C25.051,37.0668 35.67,42.9808 48.106,45.2708 C48.299,45.3058 48.469,45.4178 48.577,45.5808 C48.686,45.7438 48.723,45.9448 48.681,46.1358 C47.92,49.5798 45.564,52.6008 42.377,54.2168 C40.983,54.9228 39.082,55.5478 36.722,55.5478"
              id="Fill-211"
              fill="#070000"
            />
            <path
              d="M112.6509,180.8066 C123.9619,185.6006 130.8099,193.7476 134.4629,199.4566 C136.0649,201.9596 133.9119,205.1616 130.9919,204.6126 L87.3489,196.2276 L92.3469,181.4696 C92.3469,181.4696 107.6919,178.7046 112.6509,180.8066"
              id="Fill-213"
              fill="#E7E6FF"
            />
          </g>
          <g id="Group-222" transform="translate(511.000000, 425.943000)">
            <g id="Group-218">
              <mask id="mask-24" fill="white">
                <use xlink:href="#path-23" />
              </mask>
              <g id="Clip-217" />
              <path
                d="M34.4922,3.502 C33.4222,9.189 17.7292,12.419 4.6312,5.537 C-8.4678,-1.346 18.2602,-4.117 18.2602,-4.117 L34.4922,3.502 Z"
                id="Fill-216"
                fill="#070000"
                mask="url(#mask-24)"
              />
            </g>
            <g id="Group-221">
              <mask id="mask-26" fill="white">
                <use xlink:href="#path-25" />
              </mask>
              <g id="Clip-220" />
              <polygon
                id="Fill-219"
                fill="#070000"
                mask="url(#mask-26)"
                points="-6.6323 17.8447 49.3887 28.3887 50.8067 20.8527 -5.2143 10.3087"
              />
            </g>
          </g>
          <g id="Group-229" transform="translate(436.000000, 197.943000)">
            <path
              d="M0.1582,62.5928 L56.7062,95.1568 C56.7062,95.1568 91.4392,63.3358 89.4802,45.1488 C87.5212,26.9598 75.4892,22.7628 57.3012,21.6438 C39.1132,20.5248 0.1582,62.5928 0.1582,62.5928"
              id="Fill-223"
              fill="#FFFFFF"
            />
            <path
              d="M102.1362,17.0527 C103.6972,21.0277 103.9452,21.3637 103.5192,22.0847 C102.9392,23.0717 99.7432,22.0617 99.7432,22.0617 L102.1362,17.0527 Z"
              id="Fill-225"
              fill="#070000"
            />
            <path
              d="M103.916,15.1416 C102.95,22.0666 96.553,26.8976 89.628,25.9316 C82.703,24.9656 77.872,18.5686 78.838,11.6436 C79.804,4.7176 86.201,-0.1134 93.126,0.8536 C100.051,1.8196 104.882,8.2156 103.916,15.1416"
              id="Fill-227"
              fill="#FFFFFF"
            />
          </g>
          <g id="Group-232" transform="translate(514.000000, 197.943000)">
            <mask id="mask-28" fill="white">
              <use xlink:href="#path-27" />
            </mask>
            <g id="Clip-231" />
            <path
              d="M18.4375,-3.25 C24.2075,14.027 0.2145,10.435 5.7625,27.117 L31.5825,26.889 L32.3935,1.436 L18.4375,-3.25 Z"
              id="Fill-230"
              fill="#070000"
              mask="url(#mask-28)"
            />
          </g>
          <g id="Group-263" transform="translate(191.000000, 190.943000)">
            <path
              d="M342.9844,25.1475 L341.8994,24.1985 C342.9174,23.0305 345.5914,21.1735 348.4274,22.5045 L347.8144,23.8105 C345.2634,22.6135 343.0764,25.0435 342.9844,25.1475"
              id="Fill-233"
              fill="#FFFFFF"
            />
            <path
              d="M348.6108,8.7275 C351.6978,13.4015 344.9288,20.7355 334.7788,29.8655 C324.6298,38.9945 316.6638,55.3635 290.5748,63.1405 C264.4858,70.9185 258.5608,69.7455 258.5608,69.7455 L250.8148,20.3925 C250.8148,20.3925 261.1418,19.3785 277.8628,17.7305 C294.5848,16.0815 312.1038,6.1695 322.8958,1.6635 C333.6888,-2.8425 346.2148,5.1015 348.6108,8.7275"
              id="Fill-235"
              fill="#FF3D81"
            />
            <path
              d="M247.1543,31.6934 L247.0123,30.2564 C248.5263,30.1074 250.1733,29.9484 251.9233,29.7784 C269.2173,28.1034 298.1633,25.2994 304.9253,21.3964 C312.4193,17.0694 323.2613,11.1854 323.3703,11.1274 L324.0583,12.3944 C323.9493,12.4544 313.1233,18.3284 305.6463,22.6454 C298.6133,26.7064 270.5993,29.4194 252.0623,31.2144 C250.3143,31.3834 248.6673,31.5434 247.1543,31.6934"
              id="Fill-237"
              fill="#070000"
            />
            <path
              d="M249.9409,46.333 L249.5389,44.947 C260.6219,41.733 273.2449,39.227 284.3809,37.015 C295.4249,34.821 304.9639,32.927 307.8979,31.233 C313.6889,27.89 323.2279,18.234 323.3239,18.137 L324.3519,19.149 C323.9559,19.552 314.5799,29.041 308.6189,32.482 C305.4789,34.296 296.2929,36.12 284.6629,38.43 C273.5539,40.636 260.9639,43.137 249.9409,46.333"
              id="Fill-239"
              fill="#070000"
            />
            <path
              d="M245.3618,60.3398 L244.9538,58.9568 C249.5268,57.6078 255.1238,55.7518 261.0508,53.7878 C273.0698,49.8048 285.4998,45.6868 291.9048,44.9238 L292.0758,46.3568 C285.8148,47.1018 273.4558,51.1968 261.5048,55.1578 C255.5668,57.1258 249.9578,58.9848 245.3618,60.3398"
              id="Fill-241"
              fill="#070000"
            />
            <path
              d="M298.0908,63.6592 C276.7948,102.8472 296.9438,104.4402 310.4758,108.5862 C324.0078,112.7312 352.2478,120.0072 371.2268,118.5632 L371.7448,96.2192 L315.8538,87.1382 L321.6448,70.3682 L298.0908,63.6592 Z"
              id="Fill-243"
              fill="#070000"
            />
            <path
              d="M359.1792,95.2256 C365.5612,90.3376 372.4262,82.5756 374.5312,84.9786 C376.6362,87.3816 364.5962,103.4626 364.5962,103.4626 L359.1792,95.2256 Z"
              id="Fill-245"
              fill="#070000"
            />
            <path
              d="M370.5122,96.1006 C383.8432,94.4936 391.8052,94.6316 392.1752,97.8136 C392.7542,102.7986 370.5542,102.1576 370.5542,102.1576 L370.5122,96.1006 Z"
              id="Fill-247"
              fill="#070000"
            />
            <path
              d="M370.418,101.7139 C380.628,100.1279 388.949,101.0939 388.466,104.2519 C387.984,107.4099 370.46,107.7709 370.46,107.7709 L370.418,101.7139 Z"
              id="Fill-249"
              fill="#070000"
            />
            <path
              d="M387.7515,103.7695 C386.3995,101.7425 381.8285,101.0665 375.2085,101.9145 L375.0245,100.4835 C382.4205,99.5355 387.2355,100.3955 388.9525,102.9685 L387.7515,103.7695 Z"
              id="Fill-251"
              fill="#FFFFFF"
            />
            <path
              d="M369.9751,107.4736 C380.1851,105.8876 383.7931,106.8546 383.3101,110.0126 C382.8281,113.1706 370.0171,113.5306 370.0171,113.5306 L369.9751,107.4736 Z"
              id="Fill-253"
              fill="#070000"
            />
            <path
              d="M384.5562,109.8926 L383.1132,109.8926 C383.1132,109.0026 382.9292,108.4436 382.5142,108.0796 C381.5882,107.2636 379.2132,107.1136 375.2522,107.6216 L375.0692,106.1896 C379.6462,105.6026 382.1592,105.8436 383.4682,106.9966 C384.4432,107.8546 384.5562,109.0596 384.5562,109.8926"
              id="Fill-255"
              fill="#FFFFFF"
            />
            <path
              d="M370.0103,112.4785 C379.0483,111.3485 383.2823,112.5485 382.7053,115.6815 C382.1273,118.8145 371.2273,118.5635 371.2273,118.5635 L370.0103,112.4785 Z"
              id="Fill-257"
              fill="#070000"
            />
            <path
              d="M382.6606,115.1455 C382.1476,113.3985 381.8416,112.3425 375.7376,112.9185 L375.6026,111.4825 C382.3956,110.8405 383.3256,112.2855 384.0446,114.7405 L382.6606,115.1455 Z"
              id="Fill-259"
              fill="#FFFFFF"
            />
            <path
              d="M25.3262,412.7705 C36.9542,418.7835 43.5682,427.9955 46.9852,434.3585 C48.4832,437.1475 45.9362,440.3745 42.8782,439.5535 L0.2192,428.0955 L7.6322,403.5415 C7.6322,403.5415 20.2282,410.1345 25.3262,412.7705"
              id="Fill-261"
              fill="#E7E6FF"
            />
          </g>
          <g id="Group-270" transform="translate(191.000000, 593.943000)">
            <g id="Group-266">
              <mask id="mask-30" fill="white">
                <use xlink:href="#path-29" />
              </mask>
              <g id="Clip-265" />
              <path
                d="M34.501,13.3525 C32.901,19.3075 15.966,21.4635 2.609,13.0865 C-10.748,4.7105 2.913,-12.2945 2.913,-12.2945 L34.501,13.3525 Z"
                id="Fill-264"
                fill="#FFFFFF"
                mask="url(#mask-30)"
              />
            </g>
            <g id="Group-269">
              <mask id="mask-32" fill="white">
                <use xlink:href="#path-31" />
              </mask>
              <g id="Clip-268" />
              <polygon
                id="Fill-267"
                fill="#070000"
                mask="url(#mask-32)"
                points="-10.3579 25.248 48.3051 41.005 50.4241 33.113 -8.2389 17.357"
              />
            </g>
          </g>
          <g id="Group-279" transform="translate(196.000000, 455.943000)">
            <polygon
              id="Fill-271"
              fill="#FFFFFF"
              points="28.75 131.8018 22.581 151.2168 0.961 143.2718 8.756 126.5998"
            />
            <polygon
              id="Fill-273"
              fill="#B7B3FF"
              points="64.8901 0.709 2.8301 137.541 39.2171 147.327 95.2161 25.566"
            />
            <path
              d="M35.3286,159.5322 C37.1726,159.7742 39.2896,159.8442 41.7476,159.5852 C43.6346,159.3852 44.4476,158.4272 44.5696,157.6672 C44.6696,157.0502 44.3546,156.5112 43.7256,156.2262 C43.3576,156.0592 40.6916,155.1102 35.3286,159.5322 M29.0006,166.0342 L27.8896,165.1152 C29.4386,163.2432 30.8726,161.6922 32.1956,160.4102 C30.6706,160.0332 29.3636,159.5792 28.2156,159.1802 C24.3036,157.8212 22.8396,157.3122 20.4886,162.1932 L19.1886,161.5672 C22.0976,155.5262 24.7196,156.4372 28.6896,157.8172 C30.0276,158.2832 31.5916,158.8262 33.4786,159.2192 C39.7616,153.6382 43.2446,154.4252 44.3226,154.9122 C45.5416,155.4662 46.1986,156.6362 45.9946,157.8972 C45.7906,159.1592 44.5956,160.7342 41.8996,161.0182 C38.7366,161.3532 36.1176,161.1722 33.9076,160.7742 C32.4466,162.1252 30.8126,163.8442 29.0006,166.0342"
              id="Fill-275"
              fill="#070000"
            />
            <path
              d="M124.6318,153.2402 C137.4208,156.0302 146.1978,163.2122 151.1488,168.4702 C153.3188,170.7762 151.6958,174.5532 148.5298,174.5532 L104.3588,174.5532 L104.4948,153.9912 C104.4948,153.9912 119.0238,152.0162 124.6318,153.2402"
              id="Fill-277"
              fill="#E7E6FF"
            />
          </g>
          <g id="Group-285" transform="translate(300.000000, 607.943000)">
            <g id="Group-282">
              <mask id="mask-34" fill="white">
                <use xlink:href="#path-33" />
              </mask>
              <g id="Clip-281" />
              <path
                d="M30.4214,2.3193 C30.4214,8.4863 14.6254,14.9613 -0.4476,10.3363 C-15.5206,5.7113 11.9214,-2.4597 11.9214,-2.4597 L30.4214,2.3193 Z"
                id="Fill-280"
                fill="#FFFFFF"
                mask="url(#mask-34)"
              />
            </g>
            <mask id="mask-36" fill="white">
              <use xlink:href="#path-35" />
            </mask>
            <g id="Clip-284" />
            <polygon
              id="Fill-283"
              fill="#070000"
              mask="url(#mask-36)"
              points="-9.816 25.444 50.926 25.444 50.926 17.273 -9.816 17.273"
            />
          </g>
          <g id="Group-300" transform="translate(259.000000, 403.943000)">
            <path
              d="M86.1357,207.3164 C85.2467,207.3164 82.6627,207.8044 79.1707,212.7084 C81.0147,212.4634 83.0777,211.9814 85.3847,211.0934 C87.1547,210.4114 87.6907,209.2754 87.6127,208.5094 C87.5487,207.8874 87.1047,207.4494 86.4237,207.3374 C86.3697,207.3284 86.2727,207.3164 86.1357,207.3164 M74.7467,220.6294 L73.4347,220.0284 C74.4457,217.8194 75.4277,215.9494 76.3737,214.3684 C74.8027,214.3994 73.4227,214.3004 72.2107,214.2124 C68.0807,213.9144 66.5337,213.8024 65.5297,219.1274 L64.1117,218.8594 C65.3537,212.2704 68.1217,212.4684 72.3147,212.7734 C73.7277,212.8764 75.3797,212.9954 77.3027,212.8834 C81.9237,205.8664 85.4907,205.7204 86.6577,205.9134 C87.9797,206.1304 88.9177,207.0924 89.0477,208.3624 C89.1777,209.6334 88.4327,211.4644 85.9027,212.4394 C82.9357,213.5834 80.3577,214.0874 78.1217,214.2764 C77.0597,215.9594 75.9287,218.0444 74.7467,220.6294"
              id="Fill-286"
              fill="#070000"
            />
            <path
              d="M19.7871,32.2158 C-2.7769,42.5958 -9.0929,77.3108 17.7151,100.3518 C50.1851,128.2598 59.2991,133.7488 59.2991,133.7488 L41.4951,205.9908 L76.5811,205.0738 C76.5811,205.0738 96.6631,145.6878 91.6451,125.7468 C86.0771,103.6218 44.2391,63.4818 44.2391,63.4818 L19.7871,32.2158 Z"
              id="Fill-288"
              fill="#E7E6FF"
            />
            <path
              d="M61.7354,205.6006 C61.5124,204.7116 56.4104,183.5886 68.0614,162.0796 C79.5994,140.7786 78.8384,126.0046 65.5154,112.6816 C57.8374,105.0036 50.4924,101.2656 43.3894,97.6496 C37.3644,94.5816 31.6734,91.6856 26.6934,86.7046 C21.2024,81.2136 18.3524,74.1056 18.6664,66.6876 C18.9814,59.2456 22.5064,51.7936 28.5924,45.7086 L31.6524,48.7696 C26.2594,54.1636 23.2634,60.4216 22.9904,66.8716 C22.7284,73.0636 25.1304,79.0206 29.7534,83.6436 C34.2494,88.1396 39.3954,90.7586 45.3534,93.7916 C52.4114,97.3856 60.4124,101.4576 68.5764,109.6216 C76.1844,117.2296 80.0554,125.4126 80.4104,134.6396 C80.7414,143.2666 77.9474,152.9156 71.8674,164.1406 C61.0104,184.1846 65.8834,204.3456 65.9334,204.5476 L61.7354,205.6006 Z"
              id="Fill-290"
              fill="#FFFFFF"
            />
            <path
              d="M35.3682,96.9307 C21.9872,90.5177 17.2202,81.2147 15.5772,74.5407 C13.4932,66.0747 15.2332,57.0247 20.2282,50.3317 L21.3852,51.1957 C16.7152,57.4507 15.0262,66.2647 16.9782,74.1967 C18.5462,80.5687 23.1182,89.4597 35.9922,95.6287 L35.3682,96.9307 Z"
              id="Fill-292"
              fill="#FFFFFF"
            />
            <path
              d="M82.0127,151.2773 L80.6847,150.7143 C84.8767,140.8333 84.3277,124.4313 73.2177,111.7733 L74.3017,110.8223 C85.8237,123.9473 86.3757,140.9943 82.0127,151.2773"
              id="Fill-294"
              fill="#FFFFFF"
            />
            <path
              d="M13.46,23.0186 C55.116,-8.4154 82.854,6.5266 82.854,6.5266 C82.854,6.5266 96.453,24.1446 90.439,38.9376 C84.425,53.7306 51.001,77.5856 51.001,77.5856 L13.46,23.0186 Z"
              id="Fill-296"
              fill="#766DFF"
            />
            <path
              d="M72.5649,11.832 C73.6149,4.541 80.3779,-0.519 87.6689,0.532 C94.9609,1.582 100.0199,8.345 98.9699,15.636 C97.9189,22.928 91.1569,27.987 83.8649,26.936 C76.5739,25.886 71.5149,19.124 72.5649,11.832"
              id="Fill-298"
              fill="#4C3BE3"
            />
          </g>
          <g id="Group-303" transform="translate(331.000000, 403.943000)">
            <mask id="mask-38" fill="white">
              <use xlink:href="#path-37" />
            </mask>
            <g id="Clip-302" />
            <path
              d="M8.3569,31.2441 C2.3599,13.0141 22.6489,16.3841 16.8839,-1.2179 L-5.3491,-0.5699 L-6.3241,26.2411 L8.3569,31.2441 Z"
              id="Fill-301"
              fill="#4C3BE3"
              mask="url(#mask-38)"
            />
          </g>
          <g id="Group-344" transform="translate(296.000000, 389.943000)">
            <path
              d="M49.7319,34.2598 C48.9289,34.2598 48.4409,34.1938 48.3929,34.1858 L48.5989,32.7578 C48.6229,32.7618 51.1899,33.1038 54.4229,32.0598 L54.8669,33.4328 C52.7479,34.1168 50.9039,34.2598 49.7319,34.2598"
              id="Fill-304"
              fill="#070000"
            />
            <path
              d="M49.6074,37.5684 C49.7434,36.6234 50.6194,35.9674 51.5644,36.1034 C52.5094,36.2404 53.1644,37.1164 53.0284,38.0604 C52.8924,39.0054 52.0164,39.6614 51.0714,39.5254 C50.1274,39.3884 49.4714,38.5124 49.6074,37.5684"
              id="Fill-306"
              fill="#FF3D81"
            />
            <path
              d="M59.2324,39.6484 C58.0554,39.6484 56.6154,39.0384 55.8764,38.6814 C55.5174,38.5084 55.3664,38.0774 55.5394,37.7184 C55.7114,37.3604 56.1444,37.2104 56.5024,37.3814 C57.7724,37.9914 59.2644,38.3704 59.5734,38.1604 C59.7984,37.8764 59.7694,37.6644 59.1164,34.9374 C59.0044,34.4714 58.8784,33.9404 58.7344,33.3334 C58.6434,32.9454 58.8834,32.5564 59.2714,32.4654 C59.6594,32.3734 60.0474,32.6154 60.1394,33.0024 C60.2814,33.6084 60.4084,34.1364 60.5194,34.6014 C61.2514,37.6554 61.3824,38.2064 60.6864,39.0744 C60.3504,39.4944 59.8244,39.6484 59.2324,39.6484"
              id="Fill-308"
              fill="#070000"
            />
            <path
              d="M60.4956,29.8232 L59.7536,28.5852 C61.3026,27.6572 61.5586,27.2852 61.5966,27.1682 L63.0216,27.3882 C62.9016,28.2272 61.9656,28.9412 60.4956,29.8232"
              id="Fill-310"
              fill="#070000"
            />
            <path
              d="M44.1997,34.4326 C49.3347,27.6496 60.6727,25.4046 61.0747,22.6056 C61.0747,22.6056 62.3857,27.3766 61.2177,32.3946 C61.2177,32.3946 66.2647,23.0306 59.1357,17.5786 C50.2487,10.7856 42.2337,14.2126 38.1577,17.7696 C35.5867,20.0106 32.1317,25.1706 35.2087,31.5576 C35.8437,32.8756 37.5947,35.0066 37.5947,35.0066 L38.5067,32.0336 C38.5067,32.0336 36.2757,28.7416 38.2297,27.2796 C40.1837,25.8176 42.0387,32.0306 41.8217,33.5376 L44.1997,34.4326 Z"
              id="Fill-312"
              fill="#070000"
            />
            <path
              d="M51.7749,10.7109 C52.4599,5.9599 49.1629,1.5549 44.4129,0.8699 C39.6619,0.1859 35.2559,3.4819 34.5719,8.2319 C33.8879,12.9829 37.1839,17.3889 41.9349,18.0729 C46.6849,18.7579 51.0909,15.4609 51.7749,10.7109"
              id="Fill-314"
              fill="#070000"
            />
            <path
              d="M72.5215,88.0127 C78.3325,84.4847 84.9235,78.4337 87.0655,81.0297 C89.2075,83.6257 77.9705,96.8547 77.9705,96.8547 L72.5215,88.0127 Z"
              id="Fill-316"
              fill="#4C3BE3"
            />
            <path
              d="M84.4292,89.2842 C95.2302,87.9302 106.6552,88.4512 106.0492,91.7622 C105.4432,95.0722 84.2862,95.6642 84.2862,95.6642 L84.4292,89.2842 Z"
              id="Fill-318"
              fill="#4C3BE3"
            />
            <path
              d="M104.8286,91.0859 C104.3386,90.3009 101.7216,88.6219 88.0476,89.9679 L87.9066,88.5309 C103.9486,86.9529 105.5316,89.4869 106.0526,90.3209 L104.8286,91.0859 Z"
              id="Fill-320"
              fill="#070000"
            />
            <path
              d="M84.1562,95.1924 C94.9572,93.8384 106.3822,94.3584 105.7762,97.6704 C105.1702,100.9804 84.0132,101.5724 84.0132,101.5724 L84.1562,95.1924 Z"
              id="Fill-322"
              fill="#4C3BE3"
            />
            <path
              d="M104.854,96.7129 C104.118,95.5349 100.803,94.3709 89.191,95.5139 L89.05,94.0779 C99.382,93.0619 104.633,93.6389 106.078,95.9479 L104.854,96.7129 Z"
              id="Fill-324"
              fill="#070000"
            />
            <path
              d="M83.5117,101.2441 C94.3127,99.8901 105.7377,100.4111 105.1317,103.7221 C104.5257,107.0331 83.3687,107.6241 83.3687,107.6241 L83.5117,101.2441 Z"
              id="Fill-326"
              fill="#4C3BE3"
            />
            <path
              d="M104.2065,102.7578 C102.6025,100.1928 92.4105,101.1948 89.0605,101.5248 L88.9195,100.0878 C99.0365,99.0938 103.9735,99.6628 105.4305,101.9938 L104.2065,102.7578 Z"
              id="Fill-328"
              fill="#070000"
            />
            <path
              d="M83.394,106.5166 C92.946,105.6056 104.499,106.6736 103.794,109.9546 C103.089,113.2366 84.487,112.9616 84.487,112.9616 L83.394,106.5166 Z"
              id="Fill-330"
              fill="#4C3BE3"
            />
            <path
              d="M102.8916,109.0088 C101.6796,106.8758 96.6226,106.7108 89.4036,107.1188 L89.3226,105.6778 C97.5056,105.2178 102.5546,105.4958 104.1456,108.2958 L102.8916,109.0088 Z"
              id="Fill-332"
              fill="#070000"
            />
            <path
              d="M11.1685,45.7051 C-12.4705,86.3141 6.6965,95.7921 20.8195,100.5761 C34.9415,105.3601 64.4555,113.8951 84.4875,112.9621 L85.7235,89.4461 L27.1465,78.1561 L36.6995,56.7771 L11.1685,45.7051 Z"
              id="Fill-334"
              fill="#4C3BE3"
            />
            <path
              d="M6.1064,92.5596 L5.5704,91.2206 C6.8564,90.7056 7.4074,88.4456 6.7974,86.1806 C6.4844,85.0186 5.0984,81.2806 0.4014,81.9696 L0.1924,80.5416 C4.8594,79.8586 7.3844,82.8126 8.1904,85.8056 C9.0114,88.8526 8.1154,91.7566 6.1064,92.5596"
              id="Fill-336"
              fill="#070000"
            />
            <polygon
              id="Fill-338"
              fill="#E7E6FF"
              points="353.9717 104.6406 327.1817 118.2516 327.1817 136.3516 355.0607 123.7976"
            />
            <polygon
              id="Fill-340"
              fill="#E7E6FF"
              points="471.7803 212.5742 467.0003 194.0002 484.0003 193.0002 490.8713 213.9562"
            />
            <path
              d="M331.6313,116.5303 C329.0383,104.5223 322.3163,96.2713 317.3913,91.6143 C315.2333,89.5733 311.6843,91.0893 311.6773,94.0593 L311.7503,138.5013 L327.1823,136.3513 C327.1823,136.3513 332.7683,121.7963 331.6313,116.5303"
              id="Fill-342"
              fill="#070000"
            />
          </g>
          <g id="Group-351" transform="translate(607.000000, 479.943000)">
            <g id="Group-347">
              <mask id="mask-40" fill="white">
                <use xlink:href="#path-39" />
              </mask>
              <g id="Clip-346" />
              <path
                d="M19.6387,17.3407927 C13.8507,17.3288 7.7427,32.1398 12.0527,46.2948 C16.3627,60.4488 24.0867,34.7128 24.0867,34.7128 L19.6387,17.3407927 Z"
                id="Fill-345"
                fill="#E7E6FF"
                mask="url(#mask-40)"
              />
            </g>
            <g id="Group-350">
              <mask id="mask-42" fill="white">
                <use xlink:href="#path-41" />
              </mask>
              <g id="Clip-349" />
              <polygon
                id="Fill-348"
                fill="#E7E6FF"
                mask="url(#mask-42)"
                points="-2.145 55.0566 -2.022 -1.9484 5.646 -1.9314 5.523 55.0736"
              />
            </g>
          </g>
          <path
            d="M766.8149,602.6813 C754.8269,605.3633 746.6249,612.1463 742.0049,617.1053 C739.9799,619.2793 741.5209,622.8173 744.4919,622.801354 L785.9449,622.5833 L786.8709,603.8993 C786.8709,603.8993 772.0719,601.5053 766.8149,602.6813"
            id="Fill-352"
            fill="#070000"
          />
          <g id="Group-360" transform="translate(741.000000, 601.943000)">
            <g id="Group-356">
              <mask id="mask-44" fill="white">
                <use xlink:href="#path-43" />
              </mask>
              <g id="Clip-355" />
              <path
                d="M16.6333,1.7998 C16.6633,7.5868 31.5193,13.5848 45.6423,9.1708 C59.7643,4.7558 33.9713,-2.7762 33.9713,-2.7762 L16.6333,1.7998 Z"
                id="Fill-354"
                fill="#E7E6FF"
                mask="url(#mask-44)"
              />
            </g>
            <g id="Group-359">
              <mask id="mask-46" fill="white">
                <use xlink:href="#path-45" />
              </mask>
              <g id="Clip-358" />
              <polygon
                id="Fill-357"
                fill="#B7B3FF"
                mask="url(#mask-46)"
                points="54.5088 23.3027 -2.4952 23.6027 -2.5352 15.9347 54.4678 15.6347"
              />
            </g>
          </g>
          <g id="Group-369" transform="translate(634.000000, 374.943000)">
            <path
              d="M0.1763,127.666 C0.1763,127.666 31.5163,107.105 48.6533,99.1 C67.0683,90.497 110.1283,79.858 110.1283,79.858 L131.6503,106.92 L57.4493,130.566 L15.4693,160.954 L0.1763,127.666 Z"
              id="Fill-361"
              fill="#070000"
            />
            <path
              d="M153.3857,52.5752 C153.4147,52.7012 153.4457,52.8332 153.4767,52.9692 C157.6607,71.2262 157.0107,90.2612 151.6747,108.2162 L141.0797,143.8592 L156.9277,216.1372 L118.8217,221.9172 C118.8217,221.9172 106.3837,181.4792 103.7627,148.2212 C101.9397,125.0792 111.7407,72.6862 111.9417,66.8322 L153.3857,52.5752 Z"
              id="Fill-363"
              fill="#070000"
            />
            <path
              d="M110.1279,79.8584 C97.1909,46.6804 93.5449,33.1934 109.1099,24.4784 C124.6759,15.7624 138.7109,20.1934 145.9989,27.0004 C150.7499,31.4364 156.9999,41.0004 157.9999,48.0004 C159.3739,57.6174 163.5309,79.8634 155.9999,86.0004 C146.5349,93.7124 110.1279,79.8584 110.1279,79.8584"
              id="Fill-365"
              fill="#00AEFF"
            />
            <path
              d="M115.6753,8.2051 C113.6743,2.5341 107.4553,-0.4399 101.7853,1.5611 C96.1153,3.5621 93.1413,9.7811 95.1423,15.4511 C97.1433,21.1211 103.3623,24.0961 109.0323,22.0951 C114.7023,20.0941 117.6763,13.8751 115.6753,8.2051"
              id="Fill-367"
              fill="#E7E6FF"
            />
          </g>
          <g id="Group-372" transform="translate(728.000000, 374.943000)">
            <mask id="mask-48" fill="white">
              <use xlink:href="#path-47" />
            </mask>
            <g id="Clip-371" />
            <path
              d="M8.6201,27.2832 C14.0921,14.1742 4.7201,15.3622 6.5351,0.3532 L24.4361,-2.6658 L29.4831,18.6432 L8.6201,27.2832 Z"
              id="Fill-370"
              fill="#E7E6FF"
              mask="url(#mask-48)"
            />
          </g>
          <g id="Group-461" transform="translate(616.000000, 370.943000)">
            <path
              d="M115.5601,16.4531 L114.7831,15.2371 C117.3891,13.5721 119.6481,14.3921 119.7431,14.4281 L119.2351,15.7791 C119.1721,15.7571 117.5331,15.1921 115.5601,16.4531"
              id="Fill-373"
              fill="#070000"
            />
            <path
              d="M121.1089,20.3369 C120.8499,19.6019 120.0439,19.2169 119.3099,19.4759 C118.5749,19.7349 118.1899,20.5409 118.4489,21.2749 C118.7079,22.0099 119.5139,22.3959 120.2489,22.1359 C120.9829,21.8769 121.3679,21.0709 121.1089,20.3369"
              id="Fill-375"
              fill="#FF3D81"
            />
            <path
              d="M114.2974,24.7959 C113.6064,24.7959 112.9744,24.6239 112.6514,24.1009 C112.1224,23.2449 112.2084,22.5589 112.3514,21.4219 C112.4384,20.7259 112.5574,19.7719 112.6074,18.3589 L114.0484,18.4089 C113.9974,19.8869 113.8734,20.8779 113.7824,21.6019 C113.6534,22.6359 113.6284,22.9179 113.8574,23.3059 C114.1544,23.4459 115.2974,23.2829 116.2594,22.9589 L116.7214,24.3259 C116.1714,24.5119 115.1864,24.7959 114.2974,24.7959"
              id="Fill-377"
              fill="#070000"
            />
            <path
              d="M118.0972,8.4229 C118.0972,6.9479 116.9022,5.7529 115.4282,5.7529 C113.9532,5.7529 112.7582,6.9479 112.7582,8.4229 C112.7582,9.8969 113.9532,11.0919 115.4282,11.0919 C116.9022,11.0919 118.0972,9.8969 118.0972,8.4229"
              id="Fill-379"
              fill="#070000"
            />
            <path
              d="M121.8286,8.4229 C121.8286,6.9479 120.6336,5.7529 119.1596,5.7529 C117.6846,5.7529 116.4896,6.9479 116.4896,8.4229 C116.4896,9.8969 117.6846,11.0919 119.1596,11.0919 C120.6336,11.0919 121.8286,9.8969 121.8286,8.4229"
              id="Fill-381"
              fill="#070000"
            />
            <path
              d="M121.0566,4.6221 C121.0566,3.1481 119.8616,1.9531 118.3876,1.9531 C116.9126,1.9531 115.7186,3.1481 115.7186,4.6221 C115.7186,6.0971 116.9126,7.2921 118.3876,7.2921 C119.8616,7.2921 121.0566,6.0971 121.0566,4.6221"
              id="Fill-383"
              fill="#070000"
            />
            <path
              d="M126.0308,4.1523 C126.3068,2.7043 125.3568,1.3063 123.9088,1.0303 C122.4608,0.7553 121.0628,1.7053 120.7868,3.1523 C120.5108,4.6003 121.4608,5.9993 122.9088,6.2743 C124.3568,6.5503 125.7548,5.6003 126.0308,4.1523"
              id="Fill-385"
              fill="#070000"
            />
            <path
              d="M124.2744,6.8223 C124.5504,5.3743 123.6004,3.9763 122.1524,3.7003 C120.7044,3.4243 119.3064,4.3743 119.0304,5.8223 C118.7544,7.2703 119.7044,8.6683 121.1524,8.9443 C122.6004,9.2203 123.9984,8.2703 124.2744,6.8223"
              id="Fill-387"
              fill="#070000"
            />
            <path
              d="M130.6841,5.1221 C130.9601,3.6741 130.0101,2.2761 128.5611,2.0001 C127.1141,1.7251 125.7161,2.6741 125.4401,4.1221 C125.1631,5.5701 126.1141,6.9691 127.5621,7.2441 C129.0101,7.5201 130.4081,6.5701 130.6841,5.1221"
              id="Fill-389"
              fill="#070000"
            />
            <path
              d="M134.7012,7.2695 C134.9772,5.8215 134.0272,4.4235 132.5792,4.1475 C131.1312,3.8715 129.7332,4.8215 129.4572,6.2695 C129.1812,7.7175 130.1312,9.1155 131.5792,9.3915 C133.0272,9.6675 134.4252,8.7175 134.7012,7.2695"
              id="Fill-391"
              fill="#070000"
            />
            <path
              d="M137.1279,11.2871 C137.4039,9.8391 136.4539,8.4411 135.0059,8.1651 C133.5579,7.8891 132.1599,8.8391 131.8839,10.2871 C131.6079,11.7351 132.5579,13.1331 134.0059,13.4091 C135.4539,13.6851 136.8519,12.7351 137.1279,11.2871"
              id="Fill-393"
              fill="#070000"
            />
            <path
              d="M137.5791,15.416 C137.8551,13.968 136.9051,12.57 135.4561,12.294 C134.0091,12.018 132.6111,12.968 132.3351,14.416 C132.0581,15.864 133.0091,17.262 134.4571,17.538 C135.9051,17.814 137.3031,16.864 137.5791,15.416"
              id="Fill-395"
              fill="#070000"
            />
            <path
              d="M135.4316,13.6748 C135.7076,12.2278 134.7576,10.8288 133.3096,10.5538 C131.8616,10.2778 130.4636,11.2278 130.1876,12.6758 C129.9116,14.1238 130.8616,15.5218 132.3096,15.7968 C133.7576,16.0728 135.1556,15.1228 135.4316,13.6748"
              id="Fill-397"
              fill="#070000"
            />
            <path
              d="M133.2598,9.1113 C133.2598,5.9063 130.6608,3.3073 127.4558,3.3073 C124.2508,3.3073 121.6528,5.9063 121.6528,9.1113 C121.6528,12.3163 124.2508,14.9153 127.4558,14.9153 C130.6608,14.9153 133.2598,12.3163 133.2598,9.1113"
              id="Fill-399"
              fill="#070000"
            />
            <path
              d="M136.3047,14.1582 C136.3047,11.8252 134.4127,9.9332 132.0787,9.9332 C129.7457,9.9332 127.8537,11.8252 127.8537,14.1582 C127.8537,16.4922 129.7457,18.3842 132.0787,18.3842 C134.4127,18.3842 136.3047,16.4922 136.3047,14.1582"
              id="Fill-401"
              fill="#070000"
            />
            <path
              d="M125.1172,10.2236 C125.1172,8.7486 123.9222,7.5546 122.4482,7.5546 C120.9742,7.5546 119.7792,8.7486 119.7792,10.2236 C119.7792,11.6976 120.9742,12.8926 122.4482,12.8926 C123.9222,12.8926 125.1172,11.6976 125.1172,10.2236"
              id="Fill-403"
              fill="#070000"
            />
            <path
              d="M127.167,12.8926 C127.167,11.4186 125.972,10.2236 124.498,10.2236 C123.023,10.2236 121.829,11.4186 121.829,12.8926 C121.829,14.3676 123.023,15.5626 124.498,15.5626 C125.972,15.5626 127.167,14.3676 127.167,12.8926"
              id="Fill-405"
              fill="#070000"
            />
            <path
              d="M129.6802,14.9941 C129.6802,14.0571 128.9212,13.2981 127.9842,13.2981 C127.0472,13.2981 126.0252,14.2091 126.0252,15.1451 C126.0252,16.0821 127.4102,17.8981 128.3472,17.8981 C129.2842,17.8981 129.6802,15.9311 129.6802,14.9941"
              id="Fill-407"
              fill="#E7E6FF"
            />
            <path
              d="M132.4277,17.7754 C132.4277,16.8384 131.6687,16.0794 130.7317,16.0794 C129.7947,16.0794 129.0357,16.8384 129.0357,17.7754 C129.0357,18.7124 129.7947,19.4714 130.7317,19.4714 C131.6687,19.4714 132.4277,18.7124 132.4277,17.7754"
              id="Fill-409"
              fill="#070000"
            />
            <path
              d="M134.5059,19.3945 C134.5059,18.4575 133.7469,17.6985 132.8099,17.6985 C131.8729,17.6985 131.1129,18.4575 131.1129,19.3945 C131.1129,20.3315 131.8729,21.0905 132.8099,21.0905 C133.7469,21.0905 134.5059,20.3315 134.5059,19.3945"
              id="Fill-411"
              fill="#070000"
            />
            <path
              d="M136.6528,17.6982 C136.6528,16.7612 135.8938,16.0032 134.9568,16.0032 C134.0198,16.0032 133.2608,16.7612 133.2608,17.6982 C133.2608,18.6352 134.0198,19.3942 134.9568,19.3942 C135.8938,19.3942 136.6528,18.6352 136.6528,17.6982"
              id="Fill-413"
              fill="#070000"
            />
            <path
              d="M126.1938,18.8945 C126.1938,17.9575 125.4348,17.1985 124.4978,17.1985 C123.5608,17.1985 122.8008,17.9575 122.8008,18.8945 C122.8008,19.8315 123.5608,20.5905 124.4978,20.5905 C125.4348,20.5905 126.1938,19.8315 126.1938,18.8945"
              id="Fill-415"
              fill="#070000"
            />
            <path
              d="M126.54,16.0791 C126.54,15.1421 125.781,14.3831 124.844,14.3831 C123.907,14.3831 123.148,15.1421 123.148,16.0791 C123.148,17.0161 123.907,17.7751 124.844,17.7751 C125.781,17.7751 126.54,17.0161 126.54,16.0791"
              id="Fill-417"
              fill="#070000"
            />
            <path
              d="M141.9937,243.5957 C139.4427,241.3117 136.1047,240.4647 133.4227,239.7837 C130.4367,239.0267 127.6167,238.3107 128.1867,235.5897 L129.5987,235.8857 C129.3367,237.1347 130.5357,237.5637 133.7777,238.3857 C136.6127,239.1057 140.1407,239.9997 142.9567,242.5217 L141.9937,243.5957 Z"
              id="Fill-419"
              fill="#FFFFFF"
            />
            <path
              d="M145.8213,242.1621 C143.2703,239.8781 139.9323,239.0311 137.2503,238.3501 C134.2643,237.5931 131.4443,236.8781 132.0143,234.1561 L133.4263,234.4521 C133.1643,235.7011 134.3643,236.1301 137.6053,236.9521 C140.4403,237.6711 143.9683,238.5661 146.7843,241.0871 L145.8213,242.1621 Z"
              id="Fill-421"
              fill="#FFFFFF"
            />
            <path
              d="M1.3447,125.9736 L0.1147,125.2186 C1.9037,122.2996 2.1377,118.8646 2.3267,116.1036 C2.5357,113.0306 2.7557,110.1246 5.5127,110.2006 L5.4757,111.6416 L5.4267,111.6416 C4.1937,111.6416 3.9907,112.9096 3.7657,116.2026 C3.5667,119.1196 3.3197,122.7516 1.3447,125.9736"
              id="Fill-423"
              fill="#FFFFFF"
            />
            <path
              d="M3.4424,129.4814 L2.2124,128.7274 C4.0014,125.8084 4.2354,122.3734 4.4234,119.6124 C4.6304,116.5764 4.8264,113.7074 7.5084,113.7074 C7.5424,113.7074 7.5754,113.7074 7.6104,113.7084 L7.5724,115.1504 C7.5564,115.1504 7.5394,115.1494 7.5244,115.1494 C6.2914,115.1494 6.0874,116.4174 5.8624,119.7104 C5.6644,122.6274 5.4174,126.2594 3.4424,129.4814"
              id="Fill-425"
              fill="#FFFFFF"
            />
            <path
              d="M91.6553,141.6563 L90.3783,140.9853 C103.5033,116.0213 120.6663,96.0293 120.8383,95.8303 L121.9303,96.7733 C121.7593,96.9713 104.6993,116.8453 91.6553,141.6563"
              id="Fill-427"
              fill="#FFFFFF"
            />
            <path
              d="M162.856,40.3721 C171.02,61.2941 172.181,64.4641 166.737,75.3501 C161.293,86.2341 143.711,106.9621 131.556,117.9241 C131.556,117.9241 118.508,128.4771 117.318,124.7181 C112.059,108.1011 144.828,64.8061 144.828,64.8061 L141.762,48.7991 L162.856,40.3721 Z"
              id="Fill-429"
              fill="#E7E6FF"
            />
            <path
              d="M117.9238,117.1924 C117.0958,124.0554 113.3528,134.6724 116.0528,135.1794 C118.7538,135.6864 125.3978,122.3984 125.3978,122.3984 L117.9238,117.1924 Z"
              id="Fill-431"
              fill="#E7E6FF"
            />
            <path
              d="M117.3179,124.7178 C121.3589,133.5018 127.1069,141.8758 129.3209,139.8668 C131.5349,137.8588 122.0639,121.6198 122.0639,121.6198 L117.3179,124.7178 Z"
              id="Fill-433"
              fill="#E7E6FF"
            />
            <path
              d="M125.7544,139.4297 C124.1674,137.9837 121.7864,134.7887 118.3074,127.7297 L119.6014,127.0917 C125.1274,138.3047 127.6094,139.1817 128.2384,139.1837 L128.2344,140.6257 C127.8354,140.6247 127.0654,140.6227 125.7544,139.4297"
              id="Fill-435"
              fill="#070000"
            />
            <path
              d="M168.7002,70.332 C166.5742,68.395 165.3422,65.398 165.5902,62.627 C165.7952,60.33 166.9992,58.515 168.9802,57.517 L169.6302,58.806 C167.6822,59.786 167.1392,61.495 167.0272,62.756 C166.8022,65.272 168.1122,68.129 170.1992,69.703 L169.3322,70.855 C169.1132,70.691 168.9022,70.517 168.7002,70.332"
              id="Fill-437"
              fill="#070000"
            />
            <path
              d="M121.647,121.7422 C125.688,130.5262 131.436,138.9012 133.65,136.8922 C135.864,134.8842 126.394,118.6442 126.394,118.6442 L121.647,121.7422 Z"
              id="Fill-439"
              fill="#E7E6FF"
            />
            <path
              d="M129.835,136.7148 C127.945,134.9928 125.745,131.5068 123.028,125.9928 L124.322,125.3548 C128.884,134.6118 131.285,136.5618 132.496,136.5648 L132.492,138.0068 C131.668,138.0048 130.791,137.5858 129.835,136.7148"
              id="Fill-441"
              fill="#070000"
            />
            <path
              d="M125.9111,118.4189 C129.9521,127.2029 135.7001,135.5779 137.9141,133.5689 C140.1281,131.5609 130.6581,115.3209 130.6581,115.3209 L125.9111,118.4189 Z"
              id="Fill-443"
              fill="#E7E6FF"
            />
            <path
              d="M134.043,133.3906 C132.216,131.7266 130.125,128.4016 127.501,123.0776 L128.795,122.4396 C132.326,129.6016 135.002,133.2376 136.754,133.2436 L136.75,134.6856 C135.896,134.6826 135.006,134.2676 134.043,133.3906"
              id="Fill-445"
              fill="#070000"
            />
            <path
              d="M129.8335,115.8594 C133.6235,123.4934 139.8445,131.7094 141.9895,129.6384 C144.1355,127.5694 135.2085,113.6634 135.2085,113.6634 L129.8335,115.8594 Z"
              id="Fill-447"
              fill="#E7E6FF"
            />
            <path
              d="M137.71,129.3428 C135.933,127.7238 134.099,124.7768 131.909,120.7638 L133.175,120.0718 C135.825,124.9278 138.588,129.4088 140.85,129.3218 L140.906,130.7628 C139.819,130.8058 138.775,130.3128 137.71,129.3428"
              id="Fill-449"
              fill="#070000"
            />
            <path
              d="M181.6519,258.5439 C204.8179,258.5439 218.6289,260.4939 214.9659,209.0109 C212.4049,173.0069 201.5259,160.6799 188.1879,163.1919 C174.8499,165.7049 165.6189,187.9509 170.8929,219.6249 C175.3759,246.5529 181.6519,258.5439 181.6519,258.5439"
              id="Fill-451"
              fill="#070000"
            />
            <path
              d="M202.937,227.1641 L201.769,226.3171 C224.578,194.8401 232.448,165.1381 235.033,145.7641 C237.835,124.7661 235.208,111.0351 235.182,110.8981 L236.597,110.6181 C236.625,110.7571 239.294,124.6711 236.473,145.8861 C233.872,165.4401 225.942,195.4161 202.937,227.1641"
              id="Fill-453"
              fill="#070000"
            />
            <path
              d="M235.8892,105.8799 C233.6232,105.8799 231.7802,107.7239 231.7802,109.9889 C231.7802,112.2549 233.6232,114.0989 235.8892,114.0989 C238.1552,114.0989 239.9992,112.2549 239.9992,109.9889 C239.9992,107.7239 238.1552,105.8799 235.8892,105.8799 M235.8892,115.5419 C232.8282,115.5419 230.3372,113.0509 230.3372,109.9889 C230.3372,106.9279 232.8282,104.4379 235.8892,104.4379 C238.9512,104.4379 241.4412,106.9279 241.4412,109.9889 C241.4412,113.0509 238.9512,115.5419 235.8892,115.5419"
              id="Fill-455"
              fill="#070000"
            />
            <path
              d="M230.4692,164.7275 C230.2532,164.7275 230.0532,164.7065 229.8802,164.6765 C224.6912,163.7885 216.6612,151.4275 216.6612,144.3295 C216.6612,140.8595 218.5662,139.5245 220.3482,139.4315 C220.4242,139.4275 220.4992,139.4255 220.5752,139.4255 C225.2342,139.4255 232.2662,146.6915 233.7332,160.7445 L232.2972,160.8935 C230.8242,146.7675 223.9102,140.8695 220.5652,140.8695 C220.5172,140.8695 220.4702,140.8705 220.4232,140.8725 C218.4062,140.9775 218.1042,143.0825 218.1042,144.3295 C218.1042,147.4055 219.8122,151.9195 222.5632,156.1085 C225.1922,160.1135 228.1592,162.9175 230.1232,163.2535 C230.7462,163.3615 231.5242,163.2965 232.0342,161.8535 L233.3942,162.3335 C232.6992,164.3065 231.4272,164.7275 230.4692,164.7275"
              id="Fill-457"
              fill="#070000"
            />
            <path
              d="M181.6519,258.5439 C220.2159,260.1479 258.3339,223.9939 261.6739,198.6699 C265.0149,173.3459 181.6519,204.9979 181.6519,258.5439"
              id="Fill-459"
              fill="#766DFF"
            />
          </g>
          <g id="Group-464" transform="translate(797.000000, 559.943000)">
            <mask id="mask-50" fill="white">
              <use xlink:href="#path-49" />
            </mask>
            <g id="Clip-463" />
            <path
              d="M0.7754,70.2549 L0.5284,68.8339 C8.0774,67.5199 13.6294,60.5539 21.3144,50.9129 C23.6944,47.9279 26.3924,44.5429 29.3744,41.0659 C37.2374,31.8959 45.7704,27.3459 53.2994,23.3309 C64.2924,17.4699 73.7854,12.4069 77.6254,-4.9841 L79.0344,-4.6741 C75.0514,13.3669 65.2854,18.5739 53.9784,24.6039 C46.5624,28.5589 38.1564,33.0409 30.4694,42.0049 C27.5044,45.4619 24.8154,48.8359 22.4424,51.8129 C14.5594,61.7019 8.8634,68.8469 0.7754,70.2549"
              id="Fill-462"
              fill="#070000"
              mask="url(#mask-50)"
            />
          </g>
          <g
            id="Group-469"
            transform="translate(828.000000, 565.943000)"
            fill="#070000"
          >
            <path
              d="M24.5205,17.6484 L23.2585,16.9504 C27.1335,9.9474 27.4695,1.0284 27.4715,0.9384 L28.9135,0.9854 C28.9015,1.3644 28.5675,10.3344 24.5205,17.6484"
              id="Fill-465"
            />
            <path
              d="M24.9834,35.6084 C3.9514,35.0404 1.1354,33.7484 0.8834,33.6024 L1.6054,32.3534 C1.6834,32.3864 4.5944,33.6144 25.0224,34.1664 L24.9834,35.6084 Z"
              id="Fill-467"
            />
          </g>
          <text
            id="2015"
            font-family="Montserrat-ExtraBold, Montserrat"
            font-size="16"
            font-weight="700"
            letter-spacing="0.154"
            fill="#000000"
          >
            <tspan x="713.0903" y="281.19085">2</tspan>
            <tspan x="722.8123" y="281.19085" letter-spacing="0.042">0</tspan>
            <tspan x="733.6863" y="281.19085" letter-spacing="0.17">1</tspan>
            <tspan x="740.3363" y="281.19085" letter-spacing="0.042">5</tspan>
          </text>
          <text
            id="2020"
            font-family="Montserrat-ExtraBold, Montserrat"
            font-size="16"
            font-weight="700"
            letter-spacing="0.049"
            fill="#000000"
          >
            <tspan x="762.0983" y="235.19085">2</tspan>
            <tspan x="771.7153" y="235.19085" letter-spacing="-0.063">0</tspan>
            <tspan x="782.4843" y="235.19085">20</tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
  <!-- END login.svg -->
  <!-- BEGIN cartographie.svg -->
  <svg
    v-else-if="name == 'cartographie'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="168px"
    height="260px"
    viewBox="0 0 168 260"
    version="1.1"
  >
    <defs>
      <path
        d="M1.55708824,1.51686957 C0.297088235,1.88878261 0.0951176471,3.56147826 1.23405882,4.20973913 L1.23405882,4.20973913 L18.3070588,13.8545217 L20.8900588,7.54965217 C20.8900588,7.54965217 16.5368824,2.2686087 14.2651765,1.55278261 L14.2651765,1.55278261 C12.0237353,0.846695652 9.88111765,0.586173913 7.93923529,0.585565217 L7.93923529,0.585565217 C5.39144118,0.585565217 3.18891176,1.03478261 1.55708824,1.51686957 L1.55708824,1.51686957 Z"
        id="cartographie-path-1"
      />
      <path
        d="M1.55708824,1.51686957 C0.297088235,1.88878261 0.0951176471,3.56147826 1.23405882,4.20973913 L1.23405882,4.20973913 L18.3070588,13.8545217 L20.8900588,7.54965217 C20.8900588,7.54965217 16.5368824,2.2686087 14.2651765,1.55278261 L14.2651765,1.55278261 C12.0237353,0.846695652 9.88111765,0.586173913 7.93923529,0.585565217 L7.93923529,0.585565217 C5.39144118,0.585565217 3.18891176,1.03478261 1.55708824,1.51686957 L1.55708824,1.51686957 Z"
        id="cartographie-path-3"
      />
      <path
        d="M29.7294,4.76193548 L35.1756,14.4916129 C35.1756,14.4916129 19.8672,14.1503763 14.0886,21.6043548 L14.0886,21.6043548 C8.3016,29.0707527 0.498,52.1263978 0.498,52.1263978 L0.498,52.1263978 L12.7224,54.9201613 C12.7224,54.9201613 21.5166,41.4262366 26.6238,32.7421505 L26.6238,32.7421505 L53.1264,32.7421505 C60.6222,32.7421505 64.3212,16.3131183 50.7228,0.153172043 L50.7228,0.153172043 L29.7294,4.76193548 Z"
        id="cartographie-path-5"
      />
      <path
        d="M11.9447429,0.0961875 C6.49125714,0.9495 2.65634286,3.5263125 0.4708,5.436 L0.4708,5.436 C-0.487142857,6.2735625 0.132,7.727625 1.47022857,7.7776875 L1.47022857,7.7776875 L21.4826857,8.458875 L20.7906286,2.206125 C20.7906286,2.206125 15.2076571,0.0579375 12.5022857,0.0579375 L12.5022857,0.0579375 C12.2986286,0.0579375 12.1119429,0.0703125 11.9447429,0.0961875 L11.9447429,0.0961875 Z"
        id="cartographie-path-7"
      />
      <path
        d="M11.9447429,0.0961875 C6.49125714,0.9495 2.65634286,3.5263125 0.4708,5.436 L0.4708,5.436 C-0.487142857,6.2735625 0.132,7.727625 1.47022857,7.7776875 L1.47022857,7.7776875 L21.4826857,8.458875 L20.7906286,2.206125 C20.7906286,2.206125 15.2076571,0.0579375 12.5022857,0.0579375 L12.5022857,0.0579375 C12.2986286,0.0579375 12.1119429,0.0703125 11.9447429,0.0961875 L11.9447429,0.0961875 Z"
        id="cartographie-path-9"
      />
      <path
        d="M0.947548387,7.91564151 C-1.69529032,15.6270566 10.0136129,32.967 10.0136129,32.967 L10.0136129,32.967 L37.4508387,24.5077925 C37.4508387,24.5077925 24.9519032,2.28633962 17.0552581,0.938943396 L17.0552581,0.938943396 C15.0247097,0.592754717 13.1492258,0.37545283 11.4367742,0.37545283 L11.4367742,0.37545283 C6.49003226,0.376075472 2.91190323,2.18671698 0.947548387,7.91564151 L0.947548387,7.91564151 Z"
        id="cartographie-path-11"
      />
      <path
        d="M0.187578947,4.87357895 C-0.0717894737,7.76426316 2.06221053,10.3174211 4.95289474,10.5762105 L4.95289474,10.5762105 C7.84357895,10.835 10.3973158,8.70157895 10.6555263,5.81031579 L10.6555263,5.81031579 C10.9143158,2.91963158 8.78089474,0.366473684 5.88963158,0.108263158 L5.88963158,0.108263158 C5.73042105,0.0937894737 5.57178947,0.0868421053 5.41489474,0.0868421053 L5.41489474,0.0868421053 C2.72452632,0.0868421053 0.431894737,2.14210526 0.187578947,4.87357895 L0.187578947,4.87357895 Z"
        id="cartographie-path-13"
      />
      <polygon
        id="cartographie-path-15"
        points="0 259 167.586875 259 167.586875 0.468951501 0 0.468951501"
      />
      <path
        d="M0.419257143,11.3669286 L19.8565714,16.4098571 C21.2494857,16.7717143 22.4104571,15.351 21.7278286,14.1233571 L21.7278286,14.1233571 C20.1708571,11.3226071 17.1568571,7.26871429 11.8592571,4.62217857 L11.8592571,4.62217857 C9.53605714,3.46192857 3.7972,0.560392857 3.7972,0.560392857 L3.7972,0.560392857 L0.419257143,11.3669286 Z"
        id="cartographie-path-17"
      />
      <path
        d="M0.419257143,11.3669286 L19.8565714,16.4098571 C21.2494857,16.7717143 22.4104571,15.351 21.7278286,14.1233571 L21.7278286,14.1233571 C20.1708571,11.3226071 17.1568571,7.26871429 11.8592571,4.62217857 L11.8592571,4.62217857 C9.53605714,3.46192857 3.7972,0.560392857 3.7972,0.560392857 L3.7972,0.560392857 L0.419257143,11.3669286 Z"
        id="cartographie-path-19"
      />
      <path
        d="M0.537777778,0.726 L0.477277778,10.3710588 L20.0444444,10.3710588 C21.4475556,10.3710588 22.1656111,8.59876471 21.2043333,7.51752941 L21.2043333,7.51752941 C19.0110556,5.05158824 15.1231667,1.683 9.45816667,0.374 L9.45816667,0.374 C8.87027778,0.238117647 8.06177778,0.186352941 7.16955556,0.186352941 L7.16955556,0.186352941 C4.28938889,0.186352941 0.537777778,0.726 0.537777778,0.726 L0.537777778,0.726 Z"
        id="cartographie-path-21"
      />
      <path
        d="M0.537777778,0.726 L0.477277778,10.3710588 L20.0444444,10.3710588 C21.4475556,10.3710588 22.1656111,8.59876471 21.2043333,7.51752941 L21.2043333,7.51752941 C19.0110556,5.05158824 15.1231667,1.683 9.45816667,0.374 L9.45816667,0.374 C8.87027778,0.238117647 8.06177778,0.186352941 7.16955556,0.186352941 L7.16955556,0.186352941 C4.28938889,0.186352941 0.537777778,0.726 0.537777778,0.726 L0.537777778,0.726 Z"
        id="cartographie-path-23"
      />
      <path
        d="M0.2412,5.028 C-0.2154,8.199 1.9842,11.1402 5.1558,11.5974 L5.1558,11.5974 C8.3274,12.054 11.268,9.8538 11.7252,6.6822 L11.7252,6.6822 C12.1824,3.5106 9.981,0.57 6.8106,0.1128 L6.8106,0.1128 C6.5298,0.0726 6.2514,0.0528 5.976,0.0528 L5.976,0.0528 C3.1386,0.0534 0.657,2.1372 0.2412,5.028 L0.2412,5.028 Z"
        id="cartographie-path-25"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Cartographie-Collective-1"
        transform="translate(-1127.000000, -141.000000)"
      >
        <g id="Bandeau-Header" transform="translate(440.000000, 141.000000)">
          <g id="Illustration" transform="translate(687.000000, 0.000000)">
            <g
              id="cartographie-Group-153"
              transform="translate(13.000000, 34.000000)"
            >
              <path
                d="M3.46613514,47.2600862 C3.46613514,46.4041713 2.77551737,45.7105436 1.9233166,45.7105436 C1.07111583,45.7105436 0.380498069,46.4041713 0.380498069,47.2600862 C0.380498069,48.1160011 1.07111583,48.8096287 1.9233166,48.8096287 C2.77551737,48.8096287 3.46613514,48.1160011 3.46613514,47.2600862"
                id="Fill-1"
                fill="#7BEAFF"
              />
              <path
                d="M12.8958803,47.2600862 C12.8958803,46.4041713 12.2052625,45.7105436 11.3530618,45.7105436 C10.500861,45.7105436 9.81024324,46.4041713 9.81024324,47.2600862 C9.81024324,48.1160011 10.500861,48.8096287 11.3530618,48.8096287 C12.2052625,48.8096287 12.8958803,48.1160011 12.8958803,47.2600862"
                id="Fill-3"
                fill="#7BEAFF"
              />
              <path
                d="M22.3262239,47.2600862 C22.3262239,46.4041713 21.6356062,45.7105436 20.7834054,45.7105436 C19.9312046,45.7105436 19.2405869,46.4041713 19.2405869,47.2600862 C19.2405869,48.1160011 19.9312046,48.8096287 20.7834054,48.8096287 C21.6356062,48.8096287 22.3262239,48.1160011 22.3262239,47.2600862"
                id="Fill-5"
                fill="#7BEAFF"
              />
              <path
                d="M31.7566274,47.2600862 C31.7566274,46.4041713 31.0660097,45.7105436 30.2138089,45.7105436 C29.3610097,45.7105436 28.6709903,46.4041713 28.6709903,47.2600862 C28.6709903,48.1160011 29.3610097,48.8096287 30.2138089,48.8096287 C31.0660097,48.8096287 31.7566274,48.1160011 31.7566274,47.2600862"
                id="Fill-7"
                fill="#7BEAFF"
              />
              <path
                d="M41.1863726,47.2600862 C41.1863726,46.4041713 40.4957548,45.7105436 39.6435541,45.7105436 C38.7913533,45.7105436 38.1007355,46.4041713 38.1007355,47.2600862 C38.1007355,48.1160011 38.7913533,48.8096287 39.6435541,48.8096287 C40.4957548,48.8096287 41.1863726,48.1160011 41.1863726,47.2600862"
                id="Fill-9"
                fill="#7BEAFF"
              />
              <path
                d="M50.6167162,47.2600862 C50.6167162,46.4041713 49.9260985,45.7105436 49.0738977,45.7105436 C48.2216969,45.7105436 47.5310792,46.4041713 47.5310792,47.2600862 C47.5310792,48.1160011 48.2216969,48.8096287 49.0738977,48.8096287 C49.9260985,48.8096287 50.6167162,48.1160011 50.6167162,47.2600862"
                id="Fill-11"
                fill="#7BEAFF"
              />
              <path
                d="M3.46613514,38.1249979 C3.46613514,37.269083 2.77551737,36.5754553 1.9233166,36.5754553 C1.07111583,36.5754553 0.380498069,37.269083 0.380498069,38.1249979 C0.380498069,38.9809128 1.07111583,39.6745404 1.9233166,39.6745404 C2.77551737,39.6745404 3.46613514,38.9809128 3.46613514,38.1249979"
                id="Fill-13"
                fill="#7BEAFF"
              />
              <path
                d="M12.8958803,38.1249979 C12.8958803,37.269083 12.2052625,36.5754553 11.3530618,36.5754553 C10.500861,36.5754553 9.81024324,37.269083 9.81024324,38.1249979 C9.81024324,38.9809128 10.500861,39.6745404 11.3530618,39.6745404 C12.2052625,39.6745404 12.8958803,38.9809128 12.8958803,38.1249979"
                id="Fill-15"
                fill="#7BEAFF"
              />
              <path
                d="M22.3262239,38.1249979 C22.3262239,37.269083 21.6356062,36.5754553 20.7834054,36.5754553 C19.9312046,36.5754553 19.2405869,37.269083 19.2405869,38.1249979 C19.2405869,38.9809128 19.9312046,39.6745404 20.7834054,39.6745404 C21.6356062,39.6745404 22.3262239,38.9809128 22.3262239,38.1249979"
                id="Fill-17"
                fill="#7BEAFF"
              />
              <path
                d="M31.7566274,38.1249979 C31.7566274,37.269083 31.0660097,36.5754553 30.2138089,36.5754553 C29.3610097,36.5754553 28.6709903,37.269083 28.6709903,38.1249979 C28.6709903,38.9809128 29.3610097,39.6745404 30.2138089,39.6745404 C31.0660097,39.6745404 31.7566274,38.9809128 31.7566274,38.1249979"
                id="Fill-19"
                fill="#7BEAFF"
              />
              <path
                d="M41.1863726,38.1249979 C41.1863726,37.269083 40.4957548,36.5754553 39.6435541,36.5754553 C38.7913533,36.5754553 38.1007355,37.269083 38.1007355,38.1249979 C38.1007355,38.9809128 38.7913533,39.6745404 39.6435541,39.6745404 C40.4957548,39.6745404 41.1863726,38.9809128 41.1863726,38.1249979"
                id="Fill-21"
                fill="#7BEAFF"
              />
              <path
                d="M50.6167162,38.1249979 C50.6167162,37.269083 49.9260985,36.5754553 49.0738977,36.5754553 C48.2216969,36.5754553 47.5310792,37.269083 47.5310792,38.1249979 C47.5310792,38.9809128 48.2216969,39.6745404 49.0738977,39.6745404 C49.9260985,39.6745404 50.6167162,38.9809128 50.6167162,38.1249979"
                id="Fill-23"
                fill="#7BEAFF"
              />
              <path
                d="M3.46613514,28.9899096 C3.46613514,28.1339947 2.77551737,27.440367 1.9233166,27.440367 C1.07111583,27.440367 0.380498069,28.1339947 0.380498069,28.9899096 C0.380498069,29.8458245 1.07111583,30.5394521 1.9233166,30.5394521 C2.77551737,30.5394521 3.46613514,29.8458245 3.46613514,28.9899096"
                id="Fill-25"
                fill="#7BEAFF"
              />
              <path
                d="M12.8958803,28.9899096 C12.8958803,28.1339947 12.2052625,27.440367 11.3530618,27.440367 C10.500861,27.440367 9.81024324,28.1339947 9.81024324,28.9899096 C9.81024324,29.8458245 10.500861,30.5394521 11.3530618,30.5394521 C12.2052625,30.5394521 12.8958803,29.8458245 12.8958803,28.9899096"
                id="Fill-27"
                fill="#7BEAFF"
              />
              <path
                d="M22.3262239,28.9899096 C22.3262239,28.1339947 21.6356062,27.440367 20.7834054,27.440367 C19.9312046,27.440367 19.2405869,28.1339947 19.2405869,28.9899096 C19.2405869,29.8458245 19.9312046,30.5394521 20.7834054,30.5394521 C21.6356062,30.5394521 22.3262239,29.8458245 22.3262239,28.9899096"
                id="Fill-29"
                fill="#7BEAFF"
              />
              <path
                d="M31.7566274,28.9899096 C31.7566274,28.1339947 31.0660097,27.440367 30.2138089,27.440367 C29.3610097,27.440367 28.6709903,28.1339947 28.6709903,28.9899096 C28.6709903,29.8458245 29.3610097,30.5394521 30.2138089,30.5394521 C31.0660097,30.5394521 31.7566274,29.8458245 31.7566274,28.9899096"
                id="Fill-31"
                fill="#7BEAFF"
              />
              <path
                d="M41.1863726,28.9899096 C41.1863726,28.1339947 40.4957548,27.440367 39.6435541,27.440367 C38.7913533,27.440367 38.1007355,28.1339947 38.1007355,28.9899096 C38.1007355,29.8458245 38.7913533,30.5394521 39.6435541,30.5394521 C40.4957548,30.5394521 41.1863726,29.8458245 41.1863726,28.9899096"
                id="Fill-33"
                fill="#7BEAFF"
              />
              <path
                d="M50.6167162,28.9899096 C50.6167162,28.1339947 49.9260985,27.440367 49.0738977,27.440367 C48.2216969,27.440367 47.5310792,28.1339947 47.5310792,28.9899096 C47.5310792,29.8458245 48.2216969,30.5394521 49.0738977,30.5394521 C49.9260985,30.5394521 50.6167162,29.8458245 50.6167162,28.9899096"
                id="Fill-35"
                fill="#7BEAFF"
              />
              <path
                d="M22.3262239,19.8547612 C22.3262239,18.9988463 21.6356062,18.3052186 20.7834054,18.3052186 C19.9312046,18.3052186 19.2405869,18.9988463 19.2405869,19.8547612 C19.2405869,20.7106761 19.9312046,21.4043037 20.7834054,21.4043037 C21.6356062,21.4043037 22.3262239,20.7106761 22.3262239,19.8547612"
                id="Fill-37"
                fill="#7BEAFF"
              />
              <path
                d="M31.7566274,19.8547612 C31.7566274,18.9988463 31.0660097,18.3052186 30.2138089,18.3052186 C29.3610097,18.3052186 28.6709903,18.9988463 28.6709903,19.8547612 C28.6709903,20.7106761 29.3610097,21.4043037 30.2138089,21.4043037 C31.0660097,21.4043037 31.7566274,20.7106761 31.7566274,19.8547612"
                id="Fill-39"
                fill="#7BEAFF"
              />
              <path
                d="M41.1863726,19.8547612 C41.1863726,18.9988463 40.4957548,18.3052186 39.6435541,18.3052186 C38.7913533,18.3052186 38.1007355,18.9988463 38.1007355,19.8547612 C38.1007355,20.7106761 38.7913533,21.4043037 39.6435541,21.4043037 C40.4957548,21.4043037 41.1863726,20.7106761 41.1863726,19.8547612"
                id="Fill-41"
                fill="#7BEAFF"
              />
              <path
                d="M50.6167162,19.8547612 C50.6167162,18.9988463 49.9260985,18.3052186 49.0738977,18.3052186 C48.2216969,18.3052186 47.5310792,18.9988463 47.5310792,19.8547612 C47.5310792,20.7106761 48.2216969,21.4043037 49.0738977,21.4043037 C49.9260985,21.4043037 50.6167162,20.7106761 50.6167162,19.8547612"
                id="Fill-43"
                fill="#7BEAFF"
              />
              <path
                d="M22.3262239,10.7196729 C22.3262239,9.86375798 21.6356062,9.17013032 20.7834054,9.17013032 C19.9312046,9.17013032 19.2405869,9.86375798 19.2405869,10.7196729 C19.2405869,11.5755878 19.9312046,12.2692154 20.7834054,12.2692154 C21.6356062,12.2692154 22.3262239,11.5755878 22.3262239,10.7196729"
                id="Fill-45"
                fill="#7BEAFF"
              />
              <path
                d="M31.7566274,10.7196729 C31.7566274,9.86375798 31.0660097,9.17013032 30.2138089,9.17013032 C29.3610097,9.17013032 28.6709903,9.86375798 28.6709903,10.7196729 C28.6709903,11.5755878 29.3610097,12.2692154 30.2138089,12.2692154 C31.0660097,12.2692154 31.7566274,11.5755878 31.7566274,10.7196729"
                id="Fill-47"
                fill="#7BEAFF"
              />
              <path
                d="M41.1863726,10.7196729 C41.1863726,9.86375798 40.4957548,9.17013032 39.6435541,9.17013032 C38.7913533,9.17013032 38.1007355,9.86375798 38.1007355,10.7196729 C38.1007355,11.5755878 38.7913533,12.2692154 39.6435541,12.2692154 C40.4957548,12.2692154 41.1863726,11.5755878 41.1863726,10.7196729"
                id="Fill-49"
                fill="#7BEAFF"
              />
              <path
                d="M50.6167162,10.7196729 C50.6167162,9.86375798 49.9260985,9.17013032 49.0738977,9.17013032 C48.2216969,9.17013032 47.5310792,9.86375798 47.5310792,10.7196729 C47.5310792,11.5755878 48.2216969,12.2692154 49.0738977,12.2692154 C49.9260985,12.2692154 50.6167162,11.5755878 50.6167162,10.7196729"
                id="Fill-51"
                fill="#7BEAFF"
              />
              <path
                d="M22.3262239,1.58452447 C22.3262239,0.728609574 21.6356062,0.0349819149 20.7834054,0.0349819149 C19.9312046,0.0349819149 19.2405869,0.728609574 19.2405869,1.58452447 C19.2405869,2.44043936 19.9312046,3.13406702 20.7834054,3.13406702 C21.6356062,3.13406702 22.3262239,2.44043936 22.3262239,1.58452447"
                id="Fill-53"
                fill="#7BEAFF"
              />
              <path
                d="M12.8958803,19.8547612 C12.8958803,18.9988463 12.2052625,18.3052186 11.3530618,18.3052186 C10.500861,18.3052186 9.81024324,18.9988463 9.81024324,19.8547612 C9.81024324,20.7106761 10.500861,21.4043037 11.3530618,21.4043037 C12.2052625,21.4043037 12.8958803,20.7106761 12.8958803,19.8547612"
                id="Fill-55"
                fill="#7BEAFF"
              />
              <path
                d="M12.8958803,10.7196729 C12.8958803,9.86375798 12.2052625,9.17013032 11.3530618,9.17013032 C10.500861,9.17013032 9.81024324,9.86375798 9.81024324,10.7196729 C9.81024324,11.5755878 10.500861,12.2692154 11.3530618,12.2692154 C12.2052625,12.2692154 12.8958803,11.5755878 12.8958803,10.7196729"
                id="Fill-57"
                fill="#7BEAFF"
              />
              <path
                d="M12.8958803,1.58452447 C12.8958803,0.728609574 12.2052625,0.0349819149 11.3530618,0.0349819149 C10.500861,0.0349819149 9.81024324,0.728609574 9.81024324,1.58452447 C9.81024324,2.44043936 10.500861,3.13406702 11.3530618,3.13406702 C12.2052625,3.13406702 12.8958803,2.44043936 12.8958803,1.58452447"
                id="Fill-59"
                fill="#7BEAFF"
              />
              <path
                d="M3.46613514,19.8547612 C3.46613514,18.9988463 2.77551737,18.3052186 1.9233166,18.3052186 C1.07111583,18.3052186 0.380498069,18.9988463 0.380498069,19.8547612 C0.380498069,20.7106761 1.07111583,21.4043037 1.9233166,21.4043037 C2.77551737,21.4043037 3.46613514,20.7106761 3.46613514,19.8547612"
                id="Fill-61"
                fill="#7BEAFF"
              />
              <path
                d="M3.46613514,10.7196729 C3.46613514,9.86375798 2.77551737,9.17013032 1.9233166,9.17013032 C1.07111583,9.17013032 0.380498069,9.86375798 0.380498069,10.7196729 C0.380498069,11.5755878 1.07111583,12.2692154 1.9233166,12.2692154 C2.77551737,12.2692154 3.46613514,11.5755878 3.46613514,10.7196729"
                id="Fill-63"
                fill="#7BEAFF"
              />
              <path
                d="M3.46613514,1.58452447 C3.46613514,0.728609574 2.77551737,0.0349819149 1.9233166,0.0349819149 C1.07111583,0.0349819149 0.380498069,0.728609574 0.380498069,1.58452447 C0.380498069,2.44043936 1.07111583,3.13406702 1.9233166,3.13406702 C2.77551737,3.13406702 3.46613514,2.44043936 3.46613514,1.58452447"
                id="Fill-65"
                fill="#7BEAFF"
              />
              <path
                d="M31.7566274,1.58452447 C31.7566274,0.728609574 31.0660097,0.0349819149 30.2138089,0.0349819149 C29.3610097,0.0349819149 28.6709903,0.728609574 28.6709903,1.58452447 C28.6709903,2.44043936 29.3610097,3.13406702 30.2138089,3.13406702 C31.0660097,3.13406702 31.7566274,2.44043936 31.7566274,1.58452447"
                id="Fill-67"
                fill="#7BEAFF"
              />
              <path
                d="M41.1863726,1.58452447 C41.1863726,0.728609574 40.4957548,0.0349819149 39.6435541,0.0349819149 C38.7913533,0.0349819149 38.1007355,0.728609574 38.1007355,1.58452447 C38.1007355,2.44043936 38.7913533,3.13406702 39.6435541,3.13406702 C40.4957548,3.13406702 41.1863726,2.44043936 41.1863726,1.58452447"
                id="Fill-69"
                fill="#7BEAFF"
              />
              <path
                d="M50.6167162,1.58452447 C50.6167162,0.728609574 49.9260985,0.0349819149 49.0738977,0.0349819149 C48.2216969,0.0349819149 47.5310792,0.728609574 47.5310792,1.58452447 C47.5310792,2.44043936 48.2216969,3.13406702 49.0738977,3.13406702 C49.9260985,3.13406702 50.6167162,2.44043936 50.6167162,1.58452447"
                id="Fill-71"
                fill="#7BEAFF"
              />
              <path
                d="M88.2078069,223.818499 C88.2078069,222.613366 87.2353166,221.636637 86.0354131,221.636637 C84.8355097,221.636637 83.8630193,222.613366 83.8630193,223.818499 C83.8630193,225.023031 84.8355097,225.99976 86.0354131,225.99976 C87.2353166,225.99976 88.2078069,225.023031 88.2078069,223.818499"
                id="Fill-73"
                fill="#FFFFFF"
              />
              <path
                d="M101.483108,223.818499 C101.483108,222.613366 100.510618,221.636637 99.3113127,221.636637 C98.1114093,221.636637 97.1389189,222.613366 97.1389189,223.818499 C97.1389189,225.023031 98.1114093,225.99976 99.3113127,225.99976 C100.510618,225.99976 101.483108,225.023031 101.483108,223.818499"
                id="Fill-75"
                fill="#FFFFFF"
              />
              <path
                d="M114.759008,223.818499 C114.759008,222.613366 113.786517,221.636637 112.586614,221.636637 C111.387309,221.636637 110.414819,222.613366 110.414819,223.818499 C110.414819,225.023031 111.387309,225.99976 112.586614,225.99976 C113.786517,225.99976 114.759008,225.023031 114.759008,223.818499"
                id="Fill-77"
                fill="#FFFFFF"
              />
              <path
                d="M128.034907,223.818499 C128.034907,222.613366 127.062417,221.636637 125.862514,221.636637 C124.66261,221.636637 123.69012,222.613366 123.69012,223.818499 C123.69012,225.023031 124.66261,225.99976 125.862514,225.99976 C127.062417,225.99976 128.034907,225.023031 128.034907,223.818499"
                id="Fill-79"
                fill="#FFFFFF"
              />
              <path
                d="M141.310208,223.818499 C141.310208,222.613366 140.337718,221.636637 139.138413,221.636637 C137.93851,221.636637 136.966019,222.613366 136.966019,223.818499 C136.966019,225.023031 137.93851,225.99976 139.138413,225.99976 C140.337718,225.99976 141.310208,225.023031 141.310208,223.818499"
                id="Fill-81"
                fill="#FFFFFF"
              />
              <path
                d="M154.586108,223.818499 C154.586108,222.613366 153.613618,221.636637 152.414313,221.636637 C151.214409,221.636637 150.241919,222.613366 150.241919,223.818499 C150.241919,225.023031 151.214409,225.99976 152.414313,225.99976 C153.613618,225.99976 154.586108,225.023031 154.586108,223.818499"
                id="Fill-83"
                fill="#FFFFFF"
              />
              <path
                d="M88.2078069,210.957837 C88.2078069,209.753305 87.2353166,208.776576 86.0354131,208.776576 C84.8355097,208.776576 83.8630193,209.753305 83.8630193,210.957837 C83.8630193,212.16297 84.8355097,213.139698 86.0354131,213.139698 C87.2353166,213.139698 88.2078069,212.16297 88.2078069,210.957837"
                id="Fill-85"
                fill="#FFFFFF"
              />
              <path
                d="M101.483108,210.957837 C101.483108,209.753305 100.510618,208.776576 99.3113127,208.776576 C98.1114093,208.776576 97.1389189,209.753305 97.1389189,210.957837 C97.1389189,212.16297 98.1114093,213.139698 99.3113127,213.139698 C100.510618,213.139698 101.483108,212.16297 101.483108,210.957837"
                id="Fill-87"
                fill="#FFFFFF"
              />
              <path
                d="M114.759008,210.957837 C114.759008,209.753305 113.786517,208.776576 112.586614,208.776576 C111.387309,208.776576 110.414819,209.753305 110.414819,210.957837 C110.414819,212.16297 111.387309,213.139698 112.586614,213.139698 C113.786517,213.139698 114.759008,212.16297 114.759008,210.957837"
                id="Fill-89"
                fill="#FFFFFF"
              />
              <path
                d="M128.034907,210.957837 C128.034907,209.753305 127.062417,208.776576 125.862514,208.776576 C124.66261,208.776576 123.69012,209.753305 123.69012,210.957837 C123.69012,212.16297 124.66261,213.139698 125.862514,213.139698 C127.062417,213.139698 128.034907,212.16297 128.034907,210.957837"
                id="Fill-91"
                fill="#FFFFFF"
              />
              <path
                d="M141.310208,210.957837 C141.310208,209.753305 140.337718,208.776576 139.138413,208.776576 C137.93851,208.776576 136.966019,209.753305 136.966019,210.957837 C136.966019,212.16297 137.93851,213.139698 139.138413,213.139698 C140.337718,213.139698 141.310208,212.16297 141.310208,210.957837"
                id="Fill-93"
                fill="#FFFFFF"
              />
              <path
                d="M154.586108,210.957837 C154.586108,209.753305 153.613618,208.776576 152.414313,208.776576 C151.214409,208.776576 150.241919,209.753305 150.241919,210.957837 C150.241919,212.16297 151.214409,213.139698 152.414313,213.139698 C153.613618,213.139698 154.586108,212.16297 154.586108,210.957837"
                id="Fill-95"
                fill="#FFFFFF"
              />
              <path
                d="M88.2078069,198.097475 C88.2078069,196.892943 87.2353166,195.916214 86.0354131,195.916214 C84.8355097,195.916214 83.8630193,196.892943 83.8630193,198.097475 C83.8630193,199.302608 84.8355097,200.279337 86.0354131,200.279337 C87.2353166,200.279337 88.2078069,199.302608 88.2078069,198.097475"
                id="Fill-97"
                fill="#FFFFFF"
              />
              <path
                d="M101.483108,198.097475 C101.483108,196.892943 100.510618,195.916214 99.3113127,195.916214 C98.1114093,195.916214 97.1389189,196.892943 97.1389189,198.097475 C97.1389189,199.302608 98.1114093,200.279337 99.3113127,200.279337 C100.510618,200.279337 101.483108,199.302608 101.483108,198.097475"
                id="Fill-99"
                fill="#FFFFFF"
              />
              <path
                d="M114.759008,198.097475 C114.759008,196.892943 113.786517,195.916214 112.586614,195.916214 C111.387309,195.916214 110.414819,196.892943 110.414819,198.097475 C110.414819,199.302608 111.387309,200.279337 112.586614,200.279337 C113.786517,200.279337 114.759008,199.302608 114.759008,198.097475"
                id="Fill-101"
                fill="#FFFFFF"
              />
              <path
                d="M128.034907,198.097475 C128.034907,196.892943 127.062417,195.916214 125.862514,195.916214 C124.66261,195.916214 123.69012,196.892943 123.69012,198.097475 C123.69012,199.302608 124.66261,200.279337 125.862514,200.279337 C127.062417,200.279337 128.034907,199.302608 128.034907,198.097475"
                id="Fill-103"
                fill="#FFFFFF"
              />
              <path
                d="M141.310208,198.097475 C141.310208,196.892943 140.337718,195.916214 139.138413,195.916214 C137.93851,195.916214 136.966019,196.892943 136.966019,198.097475 C136.966019,199.302608 137.93851,200.279337 139.138413,200.279337 C140.337718,200.279337 141.310208,199.302608 141.310208,198.097475"
                id="Fill-105"
                fill="#FFFFFF"
              />
              <path
                d="M154.586108,198.097475 C154.586108,196.892943 153.613618,195.916214 152.414313,195.916214 C151.214409,195.916214 150.241919,196.892943 150.241919,198.097475 C150.241919,199.302608 151.214409,200.279337 152.414313,200.279337 C153.613618,200.279337 154.586108,199.302608 154.586108,198.097475"
                id="Fill-107"
                fill="#FFFFFF"
              />
              <path
                d="M114.759008,185.237113 C114.759008,184.032581 113.786517,183.055853 112.586614,183.055853 C111.387309,183.055853 110.414819,184.032581 110.414819,185.237113 C110.414819,186.441645 111.387309,187.418374 112.586614,187.418374 C113.786517,187.418374 114.759008,186.441645 114.759008,185.237113"
                id="Fill-109"
                fill="#FFFFFF"
              />
              <path
                d="M128.034907,185.237113 C128.034907,184.032581 127.062417,183.055853 125.862514,183.055853 C124.66261,183.055853 123.69012,184.032581 123.69012,185.237113 C123.69012,186.441645 124.66261,187.418374 125.862514,187.418374 C127.062417,187.418374 128.034907,186.441645 128.034907,185.237113"
                id="Fill-111"
                fill="#FFFFFF"
              />
              <path
                d="M141.310208,185.237113 C141.310208,184.032581 140.337718,183.055853 139.138413,183.055853 C137.93851,183.055853 136.966019,184.032581 136.966019,185.237113 C136.966019,186.441645 137.93851,187.418374 139.138413,187.418374 C140.337718,187.418374 141.310208,186.441645 141.310208,185.237113"
                id="Fill-113"
                fill="#FFFFFF"
              />
              <path
                d="M154.586108,185.237113 C154.586108,184.032581 153.613618,183.055853 152.414313,183.055853 C151.214409,183.055853 150.241919,184.032581 150.241919,185.237113 C150.241919,186.441645 151.214409,187.418374 152.414313,187.418374 C153.613618,187.418374 154.586108,186.441645 154.586108,185.237113"
                id="Fill-115"
                fill="#FFFFFF"
              />
              <path
                d="M114.759008,172.376752 C114.759008,171.171619 113.786517,170.195491 112.586614,170.195491 C111.387309,170.195491 110.414819,171.171619 110.414819,172.376752 C110.414819,173.581284 111.387309,174.558012 112.586614,174.558012 C113.786517,174.558012 114.759008,173.581284 114.759008,172.376752"
                id="Fill-117"
                fill="#FFFFFF"
              />
              <path
                d="M128.034907,172.376752 C128.034907,171.171619 127.062417,170.195491 125.862514,170.195491 C124.66261,170.195491 123.69012,171.171619 123.69012,172.376752 C123.69012,173.581284 124.66261,174.558012 125.862514,174.558012 C127.062417,174.558012 128.034907,173.581284 128.034907,172.376752"
                id="Fill-119"
                fill="#FFFFFF"
              />
              <path
                d="M141.310208,172.376752 C141.310208,171.171619 140.337718,170.195491 139.138413,170.195491 C137.93851,170.195491 136.966019,171.171619 136.966019,172.376752 C136.966019,173.581284 137.93851,174.558012 139.138413,174.558012 C140.337718,174.558012 141.310208,173.581284 141.310208,172.376752"
                id="Fill-121"
                fill="#FFFFFF"
              />
              <path
                d="M154.586108,172.376752 C154.586108,171.171619 153.613618,170.195491 152.414313,170.195491 C151.214409,170.195491 150.241919,171.171619 150.241919,172.376752 C150.241919,173.581284 151.214409,174.558012 152.414313,174.558012 C153.613618,174.558012 154.586108,173.581284 154.586108,172.376752"
                id="Fill-123"
                fill="#FFFFFF"
              />
              <path
                d="M114.759008,159.51639 C114.759008,158.311257 113.786517,157.334528 112.586614,157.334528 C111.387309,157.334528 110.414819,158.311257 110.414819,159.51639 C110.414819,160.720922 111.387309,161.697651 112.586614,161.697651 C113.786517,161.697651 114.759008,160.720922 114.759008,159.51639"
                id="Fill-125"
                fill="#FFFFFF"
              />
              <path
                d="M101.483108,185.237113 C101.483108,184.032581 100.510618,183.055853 99.3113127,183.055853 C98.1114093,183.055853 97.1389189,184.032581 97.1389189,185.237113 C97.1389189,186.441645 98.1114093,187.418374 99.3113127,187.418374 C100.510618,187.418374 101.483108,186.441645 101.483108,185.237113"
                id="Fill-127"
                fill="#FFFFFF"
              />
              <path
                d="M101.483108,172.376752 C101.483108,171.171619 100.510618,170.195491 99.3113127,170.195491 C98.1114093,170.195491 97.1389189,171.171619 97.1389189,172.376752 C97.1389189,173.581284 98.1114093,174.558012 99.3113127,174.558012 C100.510618,174.558012 101.483108,173.581284 101.483108,172.376752"
                id="Fill-129"
                fill="#FFFFFF"
              />
              <path
                d="M101.483108,159.51639 C101.483108,158.311257 100.510618,157.334528 99.3113127,157.334528 C98.1114093,157.334528 97.1389189,158.311257 97.1389189,159.51639 C97.1389189,160.720922 98.1114093,161.697651 99.3113127,161.697651 C100.510618,161.697651 101.483108,160.720922 101.483108,159.51639"
                id="Fill-131"
                fill="#FFFFFF"
              />
              <path
                d="M88.2078069,185.237113 C88.2078069,184.032581 87.2353166,183.055853 86.0354131,183.055853 C84.8355097,183.055853 83.8630193,184.032581 83.8630193,185.237113 C83.8630193,186.441645 84.8355097,187.418374 86.0354131,187.418374 C87.2353166,187.418374 88.2078069,186.441645 88.2078069,185.237113"
                id="Fill-133"
                fill="#FFFFFF"
              />
              <path
                d="M88.2078069,172.376752 C88.2078069,171.171619 87.2353166,170.195491 86.0354131,170.195491 C84.8355097,170.195491 83.8630193,171.171619 83.8630193,172.376752 C83.8630193,173.581284 84.8355097,174.558012 86.0354131,174.558012 C87.2353166,174.558012 88.2078069,173.581284 88.2078069,172.376752"
                id="Fill-135"
                fill="#FFFFFF"
              />
              <path
                d="M88.2078069,159.51639 C88.2078069,158.311257 87.2353166,157.334528 86.0354131,157.334528 C84.8355097,157.334528 83.8630193,158.311257 83.8630193,159.51639 C83.8630193,160.720922 84.8355097,161.697651 86.0354131,161.697651 C87.2353166,161.697651 88.2078069,160.720922 88.2078069,159.51639"
                id="Fill-137"
                fill="#FFFFFF"
              />
              <path
                d="M128.034907,159.51639 C128.034907,158.311257 127.062417,157.334528 125.862514,157.334528 C124.66261,157.334528 123.69012,158.311257 123.69012,159.51639 C123.69012,160.720922 124.66261,161.697651 125.862514,161.697651 C127.062417,161.697651 128.034907,160.720922 128.034907,159.51639"
                id="Fill-139"
                fill="#FFFFFF"
              />
              <path
                d="M141.310208,159.51639 C141.310208,158.311257 140.337718,157.334528 139.138413,157.334528 C137.93851,157.334528 136.966019,158.311257 136.966019,159.51639 C136.966019,160.720922 137.93851,161.697651 139.138413,161.697651 C140.337718,161.697651 141.310208,160.720922 141.310208,159.51639"
                id="Fill-141"
                fill="#FFFFFF"
              />
              <path
                d="M154.586108,159.51639 C154.586108,158.311257 153.613618,157.334528 152.414313,157.334528 C151.214409,157.334528 150.241919,158.311257 150.241919,159.51639 C150.241919,160.720922 151.214409,161.697651 152.414313,161.697651 C153.613618,161.697651 154.586108,160.720922 154.586108,159.51639"
                id="Fill-143"
                fill="#FFFFFF"
              />
              <path
                d="M31.7192239,47.9374851 C31.7192239,38.1076872 39.6535483,30.138783 49.4400927,30.138783 C59.227834,30.138783 67.1615598,38.1076872 67.1615598,47.9374851 C67.1615598,57.767283 59.227834,65.7355862 49.4400927,65.7355862 C39.6535483,65.7355862 31.7192239,57.767283 31.7192239,47.9374851"
                id="Fill-145"
                fill="#FF3D81"
              />
              <polygon
                id="Fill-147"
                fill="#4C3BE3"
                points="81.3711699 11.4190106 62.2175985 28.1754681 68.1177722 33.9018032 87.7423282 19.1763404"
              />
              <path
                d="M135.313384,12.1967872 C134.442033,30.1391436 128.873403,30.1391436 121.396898,30.1391436 C107.519909,30.1391436 92.0695811,20.6747926 92.0695811,20.6747926 C85.4297162,22.1786543 78.248249,26.3001489 78.248249,26.3001489 L68.7585386,18.1034415 C68.7585386,18.1034415 78.3607587,11.5788936 86.9797162,7.54635638 C95.5849093,3.51982979 115.545199,11.2374894 115.545199,11.2374894 L135.313384,12.1967872 Z"
                id="Fill-149"
                fill="#3919D0"
              />
              <path
                d="M61.6986776,27.9803027 C56.6776351,26.3682495 52.1712645,27.1057548 49.3854537,27.9442388 C48.1646042,28.3120899 47.9689093,29.9632122 49.0718629,30.6039463 L65.614971,40.1272016 L68.1177124,33.9019835 C68.1177124,33.9019835 63.8997973,28.6871537 61.6986776,27.9803027"
                id="Fill-151"
                fill="#E7E6FF"
              />
            </g>
            <g
              id="cartographie-Group-160"
              transform="translate(60.000000, 60.000000)"
            >
              <g id="cartographie-Group-156">
                <mask id="cartographie-mask-2" fill="white">
                  <use xlink:href="#cartographie-path-1" />
                </mask>
                <g id="Clip-155" />
                <path
                  d="M10.5192088,-0.0713391304 C9.23635588,2.11509565 13.5716206,7.64874783 19.9562382,9.09866087 C26.3408559,10.5491826 18.1687676,2.02683478 18.1687676,2.02683478 L10.5192088,-0.0713391304 Z"
                  id="Fill-154"
                  fill="#4C3BE3"
                  mask="url(#cartographie-mask-2)"
                />
              </g>
              <g id="Group-159">
                <mask id="cartographie-mask-4" fill="white">
                  <use xlink:href="#cartographie-path-3" />
                </mask>
                <g id="Clip-158" />
                <polygon
                  id="Fill-157"
                  fill="#070000"
                  mask="url(#cartographie-mask-4)"
                  points="20.1843971 16.3762261 -1.66795588 3.92353043 0.0318088235 1.02735652 21.8841618 13.4794435"
                />
              </g>
            </g>
            <g id="Group-191" transform="translate(25.000000, 16.000000)">
              <path
                d="M60.361451,20.7813124 C58.253374,19.4987624 55.8242394,17.2287624 55.1179125,18.3046229 C54.4115856,19.3810808 58.6059317,24.4085334 58.6059317,24.4085334 L60.361451,20.7813124 Z"
                id="Fill-161"
                fill="#4C3BE3"
              />
              <path
                d="M56.1956365,21.532085 C52.3714154,21.2160771 48.3618288,21.6581297 48.6356365,22.962185 C48.9088385,24.2656429 56.3616173,24.0649271 56.3616173,24.0649271 L56.1956365,21.532085 Z"
                id="Fill-163"
                fill="#4C3BE3"
              />
              <path
                d="M49.1103779,22.6623658 L48.5494356,22.3941474 C48.7202625,22.0452842 49.2436471,20.9849553 54.9633202,21.2842368 L54.9300029,21.8983316 C50.1395798,21.6468395 49.2642433,22.3493447 49.1103779,22.6623658"
                id="Fill-165"
                fill="#FFFFFF"
              />
              <path
                d="M56.3991144,23.8749042 C52.5748933,23.5588963 48.5653067,24.0009489 48.8391144,25.3050042 C49.1123163,26.6084621 56.5650952,26.4083437 56.5650952,26.4083437 L56.3991144,23.8749042 Z"
                id="Fill-167"
                fill="#4C3BE3"
              />
              <path
                d="M49.2044538,24.9001676 L48.6429058,24.6319492 C49.1184346,23.6648097 50.9745115,23.3195308 54.6624346,23.5124808 L54.6291173,24.1265755 C50.5638,23.913315 49.4352519,24.4294413 49.2044538,24.9001676"
                id="Fill-169"
                fill="#FFFFFF"
              />
              <path
                d="M56.7363462,26.2679024 C52.912125,25.9518945 48.9019327,26.3939471 49.1763462,27.6980024 C49.4495481,29.0014603 56.9023269,28.8007445 56.9023269,28.8007445 L56.7363462,26.2679024 Z"
                id="Fill-171"
                fill="#4C3BE3"
              />
              <path
                d="M49.5422308,27.28994 L48.9806827,27.0217216 C49.4604519,26.0456216 51.2056731,25.7104979 54.8172692,25.8992663 L54.7839519,26.5133611 C53.6123942,26.4518321 50.045625,26.2648558 49.5422308,27.28994"
                id="Fill-173"
                fill="#FFFFFF"
              />
              <path
                d="M56.8735529,28.3613203 C53.4969952,28.1958492 49.4516683,28.8583308 49.759399,30.1480492 C50.0677356,31.4377676 56.6070144,30.9461334 56.6070144,30.9461334 L56.8735529,28.3613203 Z"
                id="Fill-175"
                fill="#4C3BE3"
              />
              <path
                d="M50.1184385,29.7476929 L49.5471981,29.5009797 C50.0657365,28.3337218 51.8533615,28.115085 54.773775,28.1300192 L54.7701404,28.7447113 C52.2519577,28.7285824 50.4964385,28.8964429 50.1184385,29.7476929"
                id="Fill-177"
                fill="#FFFFFF"
              />
              <path
                d="M91.0427538,13.0855345 C85.6386865,18.4140608 84.3683885,20.7181108 81.3655904,22.5287345 C76.7902154,25.2873818 63.6698596,30.9044371 56.6065904,30.9456555 L55.7433692,21.6231239 L75.3690808,15.0526687 L89.291475,3.86575026 L91.0427538,13.0855345 Z"
                id="Fill-179"
                fill="#4C3BE3"
              />
              <polygon
                id="Fill-181"
                fill="#D5CFFF"
                points="72.7513702 15.6596547 91.6095721 0.0301073684 91.9506202 17.1447126 79.823726 24.2671363"
              />
              <polygon
                id="Fill-183"
                fill="#FF3D81"
                points="124.482487 49.7986029 92.3028144 49.7986029 0.347650962 226.434471 32.527324 226.434471"
              />
              <path
                d="M83.7403875,208.580742 C83.7403875,198.811379 91.771676,190.892066 101.678426,190.892066 C111.585176,190.892066 119.616464,198.811379 119.616464,208.580742 C119.616464,218.350105 111.585176,226.270016 101.678426,226.270016 C91.771676,226.270016 83.7403875,218.350105 83.7403875,208.580742"
                id="Fill-185"
                fill="#FF3D81"
              />
              <polygon
                id="Fill-187"
                fill="#4C3BE3"
                points="74.1101712 57.6530418 64.7704212 81.2759761 72.7381038 83.5854024 83.4499212 61.5329497"
              />
              <path
                d="M116.633536,16.8812134 C130.362689,33.2043055 126.628122,49.7986029 119.060247,49.7986029 L92.3028144,49.7986029 C87.145901,58.5709582 78.2677471,72.2011134 78.2677471,72.2011134 L65.9258048,69.379145 C65.9258048,69.379145 73.8044394,46.0907371 79.6470837,38.5489608 C85.4812471,31.0191318 100.936843,31.3638134 100.936843,31.3638134 L95.4388817,21.5365055 L116.633536,16.8812134 Z"
                id="Fill-189"
                fill="#3424C7"
              />
            </g>
            <g id="Group-194" transform="translate(91.000000, 33.000000)">
              <mask id="cartographie-mask-6" fill="white">
                <use xlink:href="#cartographie-path-5" />
              </mask>
              <g id="Clip-193" />
              <polygon
                id="Fill-192"
                fill="#070000"
                mask="url(#cartographie-mask-6)"
                points="52.31238 -4.81841398 20.52138 -1.47997312 28.99998 13.3570161 58.05798 6.84572581"
              />
            </g>
            <g id="Group-199" transform="translate(79.000000, 45.000000)">
              <path
                d="M51.921,2.37935534 C51.9984,3.58573398 52.5918,4.74828738 53.547,5.53714175 C54.3744,6.22117087 55.848,6.94487961 58.1718,6.51077282 C61.4658,5.89425825 61.8642,2.41785049 61.9044,1.25115146 C60.6282,1.57569515 56.4456,2.53096699 51.921,2.37935534 M56.8104,7.25224854 C55.0746,7.25224854 53.8872,6.61382136 53.1504,6.00441359 C51.9726,5.03078252 51.279,3.55612233 51.2952,2.05836505 C51.2958,1.97604466 51.3312,1.89727767 51.3918,1.8404233 C51.453,1.78356893 51.5346,1.75454951 51.618,1.75751068 C57.0582,2.00269515 62.0772,0.575413592 62.127,0.560607767 C62.2182,0.534549515 62.3154,0.551132039 62.3922,0.60443301 C62.469,0.658326214 62.517,0.7442 62.5224,0.837180583 C62.5248,0.891073786 62.7612,6.27210291 58.2864,7.10952039 C57.756,7.2084233 57.264,7.25224854 56.8104,7.25224854"
                id="Fill-195"
                fill="#070000"
              />
              <path
                d="M11.40162,51.6257806 C6.19602,52.5236058 2.53542,55.2366252 0.44922,57.2478485 C-0.46458,58.1290913 0.12582,59.6600136 1.40322,59.7133146 L20.50602,60.4305087 L19.84542,53.8472466 C19.84542,53.8472466 13.68462,51.2319456 11.40162,51.6257806"
                id="Fill-197"
                fill="#E7E6FF"
              />
            </g>
            <g id="Group-206" transform="translate(78.000000, 97.000000)">
              <g id="Group-202">
                <mask id="cartographie-mask-8" fill="white">
                  <use xlink:href="#cartographie-path-7" />
                </mask>
                <g id="Clip-201" />
                <path
                  d="M7.78888,0.34965 C7.68013714,2.681775 14.2405371,5.379525 20.6909371,3.8692125 C27.1419657,2.3589 15.6906514,-1.1646 15.6906514,-1.1646 L7.78888,0.34965 Z"
                  id="Fill-200"
                  fill="#4C3BE3"
                  mask="url(#cartographie-mask-8)"
                />
              </g>
              <g id="Group-205">
                <mask id="cartographie-mask-10" fill="white">
                  <use xlink:href="#cartographie-path-9" />
                </mask>
                <g id="Clip-204" />
                <polygon
                  id="Fill-203"
                  fill="#070000"
                  mask="url(#cartographie-mask-10)"
                  points="24.3827886 9.73029375 -1.28366857 8.76954375 -1.13972571 5.67973125 24.5267314 6.64048125"
                />
              </g>
            </g>
            <path
              d="M148,37.434734 L121.225491,46 C121.225491,46 109.799659,28.4426547 112.379204,20.6345567 C114.959346,12.8258282 120.39176,12.2060979 128.097498,13.5703873 C135.802637,14.9346767 148,37.434734 148,37.434734"
              id="Fill-207"
              fill="#E7E6FF"
            />
            <g id="Group-211" transform="translate(111.000000, 13.000000)">
              <mask id="cartographie-mask-12" fill="white">
                <use xlink:href="#cartographie-path-11" />
              </mask>
              <g id="Clip-210" />
              <path
                d="M10.4246258,-0.432922642 C6.09998065,10.4745113 22.3768516,32.6816434 22.3768516,32.6816434 L17.6587226,34.9978698 C17.6587226,34.9978698 4.79510968,16.3130208 4.05533548,8.39800189 C3.28798065,0.18660566 4.76323871,-1.50760189 4.76323871,-1.50760189 L10.4246258,-0.432922642 Z"
                id="Fill-209"
                fill="#070000"
                mask="url(#cartographie-mask-12)"
              />
            </g>
            <g
              id="Group-216"
              transform="translate(108.000000, 4.000000)"
              fill="#4C3BE3"
            >
              <path
                d="M1.8708,8.06311579 C1.8708,8.06311579 0.4332,8.17137895 0.2856,7.71864211 C0.1782,7.38690526 0.3144,7.27401053 1.3548,5.81332632 L1.8708,8.06311579 Z"
                id="Fill-212"
              />
              <path
                d="M0.7944,4.87357895 C0.5262,7.76426316 2.7372,10.3174211 5.733,10.5762105 C8.7294,10.835 11.3754,8.701 11.643,5.81031579 C11.9112,2.91963158 9.7002,0.366473684 6.7044,0.108263158 C3.708,-0.150526316 1.0626,1.98289474 0.7944,4.87357895"
                id="Fill-214"
              />
            </g>
            <g id="Group-219" transform="translate(109.000000, 4.000000)">
              <mask id="cartographie-mask-14" fill="white">
                <use xlink:href="#cartographie-path-13" />
              </mask>
              <g id="Clip-218" />
              <path
                d="M4.93564211,-1.86177895 C0.983168421,4.58364211 11.0209579,5.38027368 7.21437895,11.6056947 L-3.20493684,9.09248421 L-1.1462,-1.27530526 L4.93564211,-1.86177895 Z"
                id="Fill-217"
                fill="#4C3BE3"
                mask="url(#cartographie-mask-14)"
              />
            </g>
            <g id="Group-253">
              <path
                d="M112.449814,8.3186254 C112.442639,8.31264388 111.672589,7.66723741 110.675351,7.66723741 L110.675351,7.05173857 C111.906354,7.05173857 112.812717,7.81916813 112.850981,7.85146836 L112.449814,8.3186254 Z"
                id="Fill-220"
                fill="#FFFFFF"
              />
              <path
                d="M129.391507,7.04174942 C129.111109,5.53380716 127.661885,4.53907968 126.155265,4.81961316 C124.648048,5.10014665 123.653201,6.55006813 123.934198,8.05741224 C124.214596,9.5653545 125.663821,10.560082 127.17044,10.2801467 C128.677657,9.99901501 129.671906,8.54969169 129.391507,7.04174942"
                id="Fill-222"
                fill="#070000"
              />
              <path
                d="M124.331838,7.28471894 C124.21346,6.64768661 123.600649,6.2265873 122.963923,6.34561963 C122.326599,6.46405381 121.9063,7.07656189 122.025275,7.71419238 C122.143653,8.35122471 122.755866,8.77172587 123.39319,8.65329169 C124.029916,8.53485751 124.450215,7.92175127 124.331838,7.28471894"
                id="Fill-224"
                fill="#FF3D81"
              />
              <path
                d="M110.17165,5.44821155 C111.806212,-0.00753672055 120.969685,1.73129238 122.4775,5.3997612 C123.985315,9.06763187 120.623522,12.9538282 118.519038,11.5086919 C116.414554,10.0635557 115.51118,8.16561801 115.419707,7.67752564 C115.329429,7.18943326 110.17165,5.44821155 110.17165,5.44821155"
                id="Fill-226"
                fill="#070000"
              />
              <path
                d="M117.654884,8.01195266 C117.654884,7.20624134 117.002614,6.55365704 116.19729,6.55365704 C115.393162,6.55365704 114.740293,7.20624134 114.740293,8.01195266 C114.740293,8.81706582 115.393162,9.47024827 116.19729,9.47024827 C117.002614,9.47024827 117.654884,8.81706582 117.654884,8.01195266"
                id="Fill-228"
                fill="#4C3BE3"
              />
              <path
                d="M119.743345,36.8374564 C119.724214,36.8159229 117.834961,34.6314702 115.481765,31.4068305 C113.493267,28.681648 114.493495,26.8495072 115.033367,26.1729968 C114.580185,25.8278628 113.767089,25.0508628 113.40837,23.7271515 C112.945623,22.0158374 113.394619,19.9994656 114.744,17.7342624 L115.271915,18.0494887 C114.015203,20.1597704 113.587132,22.0110522 113.999658,23.5530891 C114.42474,25.1471654 115.63721,25.8422185 115.649167,25.8487982 C115.737651,25.8984448 115.796242,25.9881677 115.805808,26.0892554 C115.815374,26.189745 115.774719,26.2890383 115.696996,26.354237 C115.619872,26.4206319 113.788612,28.0422231 115.979189,31.043752 C118.315046,34.2456619 120.189352,36.4127681 120.207288,36.4337035 L119.743345,36.8374564 Z"
                id="Fill-230"
                fill="#070000"
              />
              <polygon
                id="Fill-232"
                fill="#070000"
                points="74.9128142 52.5877667 106.513554 52.5877667 98.8435473 27.2637875 67.2428071 27.2637875"
              />
              <mask id="cartographie-mask-16" fill="white">
                <use xlink:href="#cartographie-path-15" />
              </mask>
              <g id="Clip-235" />
              <polygon
                id="Fill-234"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
                points="80.2478007 54.6693372 118.287544 54.6693372 118.287544 52.5877667 80.2478007 52.5877667"
              />
              <path
                d="M84.7933665,37.6987958 C84.6361281,37.6987958 84.4794875,37.7173386 84.3240427,37.7556203 C83.1354875,38.0481169 82.4401708,39.3927635 82.7743772,40.7529621 C83.1091815,42.1137589 84.349153,42.9822762 85.5365125,42.690976 C86.7244698,42.3984794 87.4203843,41.0538328 87.0861779,39.693036 C86.922363,39.0272924 86.5403274,38.4590476 86.0106192,38.0935764 C85.6327687,37.8333801 85.2130676,37.6987958 84.7933665,37.6987958 M85.0713737,43.3627012 C83.7632456,43.3627012 82.536427,42.3631885 82.1771103,40.9001076 C81.7621922,39.2097289 82.6589893,37.5313132 84.1775658,37.1580661 C84.919516,36.9756296 85.6949466,37.1275603 86.3597722,37.5869413 C87.0138363,38.0379483 87.483758,38.7341977 87.6834448,39.5458905 C88.098363,41.2362693 87.200968,42.9152831 85.6829893,43.2885303 C85.4791174,43.3387751 85.2746477,43.3627012 85.0713737,43.3627012"
                id="Fill-236"
                fill="#766DFF"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M128.107593,36.1400106 C127.841543,34.1846503 128.01313,32.6689321 128.150639,31.4510938 C128.453159,28.7857266 128.591265,27.5690845 123.697742,25.6412393 C123.60328,25.6041538 123.53333,25.5222069 123.510611,25.4229136 C123.487892,25.3236203 123.515991,25.2195418 123.585942,25.1453709 C124.298596,24.3785395 125.999522,22.0918028 125.319152,20.7351931 C122.841002,15.7968467 123.657685,14.1585072 123.759322,13.9880337 L124.287835,14.3020637 C124.28365,14.3098397 123.542298,15.8225672 125.869187,20.4588467 C126.694241,22.1031677 125.030383,24.3797358 124.326098,25.2303085 C129.245927,27.2502693 129.071949,28.787521 128.762853,31.5204794 C128.628333,32.7042231 128.461529,34.1780707 128.718013,36.0568674 L128.107593,36.1400106 Z"
                id="Fill-237"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M124.731152,36.6356397 L122.854454,43.849358 L99.1120484,41.0864919 L98.11481,49.6813441 C98.11481,49.6813441 120.87313,56.6324734 126.662255,53.2882032 C132.451977,49.943933 134.430312,44.218418 134.430312,44.218418 L124.731152,36.6356397 Z"
                id="Fill-238"
                fill="#4C3BE3"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M128.988009,19.9063931 C127.440735,27.7744901 124.731211,36.6355201 124.731211,36.6355201 L134.16492,45.0000836 L139.932521,27.9694878 L128.988009,19.9063931 Z"
                id="Fill-239"
                fill="#EAE5FF"
                mask="url(#cartographie-mask-16)"
              />
              <polygon
                id="Fill-240"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
                points="134.456977 45.0988984 133.87346 44.9015081 138.946343 29.9219769 139.529261 30.1199654"
              />
              <path
                d="M106.935946,42.3268806 C104.551661,41.0426473 100.383348,36.7933725 99.5846007,37.870645 C98.7858534,38.9485157 101.602992,43.0787582 101.602992,43.0787582 L106.935946,42.3268806 Z"
                id="Fill-241"
                fill="#4C3BE3"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M100.803707,41.1022233 C96.478753,40.7858007 91.9439488,41.2284335 92.2530448,42.5342002 C92.5627388,43.8393688 100.991436,43.6383896 100.991436,43.6383896 L100.803707,41.1022233 Z"
                id="Fill-242"
                fill="#4C3BE3"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M92.7424569,42.2494797 L92.2043786,41.9504035 C92.3956954,41.6058677 92.9786135,40.5567083 99.4056598,40.8539901 L99.3775601,41.4688908 C93.9208484,41.2152741 92.9194249,41.9306644 92.7424569,42.2494797"
                id="Fill-243"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M101.033765,43.4481173 C96.7088114,43.1316947 92.174605,43.5743275 92.4831032,44.8800942 C92.7927972,46.1852628 101.222093,45.9848818 101.222093,45.9848818 L101.033765,43.4481173 Z"
                id="Fill-244"
                fill="#4C3BE3"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M92.8481594,44.4899194 L92.310679,44.1908432 C92.8409851,43.2337993 94.9257395,42.8934506 99.0647573,43.0848594 L99.0372555,43.7003582 C94.4038036,43.4850233 93.1136114,44.0107993 92.8481594,44.4899194"
                id="Fill-245"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M101.415023,45.8442561 C97.0900698,45.5278335 92.5552655,45.9704663 92.8643616,47.276233 C93.1740555,48.5814016 101.602753,48.3804224 101.602753,48.3804224 L101.415023,45.8442561 Z"
                id="Fill-246"
                fill="#4C3BE3"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M93.2300157,46.8831273 L92.6925352,46.584051 C93.2282221,45.618633 95.1862292,45.2872566 99.240948,45.4750764 L99.2122505,46.0899771 C95.6274534,45.9236908 93.6150406,46.1904667 93.2300157,46.8831273"
                id="Fill-247"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M101.570947,47.9404215 C97.7511886,47.7747333 93.1769253,48.4380843 93.5248826,49.7294954 C93.8728399,51.0209065 101.268427,50.528627 101.268427,50.528627 L101.570947,47.9404215 Z"
                id="Fill-248"
                fill="#4C3BE3"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M93.8827644,49.3432085 L93.332131,49.0668621 C93.9132555,47.9106335 95.9250705,47.6941023 99.1947929,47.708458 L99.1918036,48.3239568 C96.7046861,48.3125919 94.3419246,48.4280353 93.8827644,49.3432085"
                id="Fill-249"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M62.5444868,93.1861663 C56.2692982,93.1861663 51.1635331,88.0779446 51.1635331,81.7997367 C51.1635331,75.5215289 56.2692982,70.4133072 62.5444868,70.4133072 C68.8196754,70.4133072 73.9254406,75.5215289 73.9254406,81.7997367 L73.3102377,81.7997367 C73.3102377,75.8606813 68.4806861,71.0294042 62.5444868,71.0294042 C56.6082875,71.0294042 51.7787359,75.8606813 51.7787359,81.7997367 C51.7787359,87.7387921 56.6082875,92.5706674 62.5444868,92.5706674 L62.5444868,93.1861663 Z"
                id="Fill-250"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M127.255755,232.391847 L127.255755,231.776348 C131.317051,231.776348 134.621449,228.47036 134.621449,224.406512 C134.621449,220.342665 131.317051,217.037275 127.255755,217.037275 C123.193862,217.037275 119.889463,220.342665 119.889463,224.406512 L119.273663,224.406512 C119.273663,220.003512 122.854873,216.421178 127.255755,216.421178 C131.65604,216.421178 135.23725,220.003512 135.23725,224.406512 C135.23725,228.809512 131.65604,232.391847 127.255755,232.391847"
                id="Fill-251"
                fill="#070000"
                mask="url(#cartographie-mask-16)"
              />
              <path
                d="M15.464968,230.65553 C20.5043701,233.262279 23.3705338,237.256741 24.8514448,240.01542 C25.500726,241.224884 24.3964698,242.624561 23.0721993,242.26866 L4.58382918,237.300406 L7.79675445,226.653891 C7.79675445,226.653891 13.2558577,229.512461 15.464968,230.65553"
                id="Fill-252"
                fill="#E7E6FF"
                mask="url(#cartographie-mask-16)"
              />
            </g>
            <g id="Group-260" transform="translate(4.000000, 227.000000)">
              <g id="Group-256">
                <mask id="cartographie-mask-18" fill="white">
                  <use xlink:href="#cartographie-path-17" />
                </mask>
                <g id="Clip-255" />
                <path
                  d="M16.0395086,6.198625 C15.3109943,8.81966071 7.59402286,9.768625 1.50819429,6.08205357 C-4.57763429,2.39548214 1.64710857,-5.08876786 1.64710857,-5.08876786 L16.0395086,6.198625 Z"
                  id="Fill-254"
                  fill="#FFFFFF"
                  mask="url(#cartographie-mask-18)"
                />
              </g>
              <g id="Group-259">
                <mask id="login-cartographie-mask-20" fill="white">
                  <use xlink:href="#cartographie-path-19" />
                </mask>
                <g id="Clip-258" />
                <polygon
                  id="Fill-257"
                  fill="#070000"
                  mask="url(#login-cartographie-mask-20)"
                  points="-4.40012571 11.4340179 22.3292457 18.3688036 23.29536 14.8959464 -3.43464 7.96116071"
                />
              </g>
            </g>
            <g id="Group-269" transform="translate(5.000000, 168.000000)">
              <polygon
                id="Fill-261"
                fill="#FFFFFF"
                points="12.6596198 56.8725953 9.9597009 65.2948315 0.500025225 61.8485008 3.91159279 54.6159339"
              />
              <polygon
                id="Fill-263"
                fill="#B7B3FF"
                points="28.4724045 0.00616377953 1.31869279 59.3627622 17.2393414 63.6073921 41.7408189 10.7891874"
              />
              <path
                d="M15.537964,68.9018992 C16.344982,69.007222 17.2709099,69.0371433 18.3465315,68.9246394 C19.1722613,68.8384661 19.5277838,68.4225606 19.5815045,68.0928283 C19.624964,67.8253323 19.4873423,67.5919465 19.2120991,67.4680724 C19.0509369,67.395663 17.8847748,66.9839465 15.537964,68.9018992 M12.7692342,71.7228756 L12.2827297,71.323726 C12.9605766,70.511663 13.5889279,69.8390331 14.1671802,69.2830961 C13.4995946,69.119726 12.927982,68.9228441 12.4257838,68.7493008 C10.713964,68.159852 10.0735405,67.9390331 9.045,70.0562614 L8.47640541,69.7851748 C9.7488018,67.1646709 10.8962523,67.5596315 12.6334234,68.1586551 C13.2183153,68.3603244 13.9028018,68.5955055 14.7285315,68.7660567 C17.4773423,66.3460252 19.0008378,66.6865291 19.4734595,66.8977732 C20.0064414,67.1377417 20.2937568,67.6464031 20.2044234,68.1927654 C20.1156937,68.7403244 19.592973,69.423726 18.4129279,69.5470016 C17.0288649,69.6918205 15.8826216,69.6134268 14.9162523,69.4410803 C14.2764324,70.0263402 13.5623694,70.7725764 12.7692342,71.7228756"
                id="Fill-265"
                fill="#070000"
              />
              <path
                d="M54.6118811,66.1727213 C60.2078901,67.382737 64.0480162,70.498737 66.2143495,72.7793354 C67.163818,73.7793039 66.4539802,75.4183906 65.0681063,75.4183906 L45.7419261,75.4183906 L45.8010793,66.4982646 C45.8010793,66.4982646 52.1582324,65.6419181 54.6118811,66.1727213"
                id="Fill-267"
                fill="#E7E6FF"
              />
            </g>
            <g id="Group-275" transform="translate(50.000000, 233.000000)">
              <g id="Group-272">
                <mask id="cartographie-mask-22" fill="white">
                  <use xlink:href="#cartographie-path-21" />
                </mask>
                <g id="Clip-271" />
                <path
                  d="M13.7946111,0.880258824 C13.7946111,3.77261176 6.79738889,6.80990588 0.119777778,4.64031765 C-6.55722222,2.47072941 5.599,-1.36115294 5.599,-1.36115294 L13.7946111,0.880258824 Z"
                  id="Fill-270"
                  fill="#FFFFFF"
                  mask="url(#cartographie-mask-22)"
                />
              </g>
              <mask id="cartographie-mask-24" fill="white">
                <use xlink:href="#cartographie-path-23" />
              </mask>
              <g id="Clip-274" />
              <polygon
                id="Fill-273"
                fill="#070000"
                mask="url(#cartographie-mask-24)"
                points="-4.03027778 11.7272941 22.8775556 11.7272941 22.8775556 7.89476471 -4.03027778 7.89476471"
              />
            </g>
            <g id="Group-290" transform="translate(34.000000, 144.000000)">
              <path
                d="M36.3841397,90.9878187 C36.0130438,90.9878187 34.9354274,91.2024313 33.4792356,93.3570438 C34.2484685,93.2497375 35.1086055,93.0381563 36.0705781,92.6477313 C36.8087425,92.3482438 37.0325507,91.8486938 36.9997562,91.512225 C36.9732904,91.2388063 36.7880301,91.0460187 36.5043863,90.9969125 C36.4819479,90.9926687 36.441674,90.9878187 36.3841397,90.9878187 M31.6341123,96.8381313 L31.0869616,96.5744125 C31.5081123,95.6032 31.9183315,94.7817313 32.3124411,94.0863625 C31.6577014,94.1003063 31.0817836,94.0572625 30.5766329,94.0184625 C28.8540575,93.8875125 28.2090986,93.8384063 27.7902493,96.1785313 L27.1987973,96.0609188 C27.7171808,93.1648625 28.8713178,93.2521625 30.6197836,93.3861438 C31.2095096,93.4310063 31.8981945,93.4831438 32.7002219,93.4346438 C34.6270438,90.35065 36.1148795,90.2869937 36.6021945,90.3712625 C37.1533726,90.46705 37.5446055,90.889 37.5981123,91.4473563 C37.6527699,92.0063188 37.3420849,92.8108125 36.2869068,93.238825 C35.0493452,93.7414063 33.9746055,93.9632938 33.0414,94.04635 C32.5989616,94.785975 32.1271808,95.7020188 31.6341123,96.8381313"
                id="Fill-276"
                fill="#070000"
              />
              <path
                d="M8.7126411,14.0379006 C-0.697660274,18.5993256 -3.33215342,33.8556069 7.84847671,43.9811944 C21.3903123,56.2456319 25.1916,58.6579006 25.1916,58.6579006 L17.7662301,90.4053944 L32.3994904,90.0022381 C32.3994904,90.0022381 40.7747507,63.9043881 38.6816548,55.1410444 C36.3595726,45.4186131 18.9111616,27.7779506 18.9111616,27.7779506 L8.7126411,14.0379006 Z"
                id="Fill-278"
                fill="#E7E6FF"
              />
              <path
                d="M26.2077699,90.2335831 C26.1151397,89.8431581 23.9869479,80.5602581 28.8462904,71.1076081 C33.6578795,61.7471081 33.3402904,55.2547769 27.7842082,49.3996144 C24.5818521,46.0258331 21.5187288,44.3822894 18.5562904,42.7933081 C16.0437699,41.4456144 13.6704822,40.1724894 11.5929205,37.9833206 C9.30305753,35.5704456 8.1144,32.4470456 8.24557808,29.1872394 C8.37733151,25.9159144 9.84675616,22.6421644 12.3851671,19.9679956 L13.6612767,21.3126581 C11.412263,23.6830956 10.1626192,26.4336519 10.0492767,29.2672644 C9.93996164,31.9893269 10.9416329,34.6071144 12.8690301,36.6386581 C14.7440712,38.6138206 16.890674,39.7650894 19.3755781,41.0982331 C22.3190301,42.6775144 25.6560164,44.4671644 29.0608932,48.0549519 C32.2339068,51.3984206 33.8477425,54.9946956 33.9961808,59.0492956 C34.134263,62.8401769 32.9691945,67.0815019 30.4336603,72.0139519 C25.9057151,80.8227644 27.9378247,89.6825019 27.958537,89.7710144 L26.2077699,90.2335831 Z"
                id="Fill-280"
                fill="#FFFFFF"
              />
              <path
                d="M15.2110767,42.4774519 C9.63025479,39.6589956 7.64244658,35.5710519 6.9572137,32.6386206 C6.08844658,28.9174581 6.81337808,24.9404581 8.89669315,21.9995394 L9.37940548,22.3790519 C7.43187123,25.1277894 6.72765205,29.0011206 7.54176164,32.4870581 C8.19592603,35.2873269 10.1020356,39.1940019 15.4711315,41.9057581 L15.2110767,42.4774519 Z"
                id="Fill-282"
                fill="#FFFFFF"
              />
              <path
                d="M34.6648438,66.3609738 L34.110789,66.1130175 C35.8586795,61.771055 35.6302685,54.5633488 30.9964603,49.0003988 L31.4486795,48.5820863 C36.2539397,54.350555 36.4840767,61.8419863 34.6648438,66.3609738"
                id="Fill-284"
                fill="#FFFFFF"
              />
              <path
                d="M6.07412055,9.99603187 C23.4465863,-3.81798063 35.0149973,2.74831312 35.0149973,2.74831312 C35.0149973,2.74831312 40.6867233,10.4913381 38.1788055,16.9921569 C35.6703123,23.4929756 21.7303397,33.9768569 21.7303397,33.9768569 L6.07412055,9.99603187 Z"
                id="Fill-286"
                fill="#766DFF"
              />
              <path
                d="M30.7244959,5.08031437 C31.1623315,1.87567687 33.9826603,-0.347441875 37.0233452,0.114520625 C40.0640301,0.575876875 42.1743863,3.54771437 41.7365507,6.75174562 C41.2981397,9.95577687 38.4783863,12.1795019 35.437126,11.7181456 C32.3958658,11.2561831 30.2860849,8.28434562 30.7244959,5.08031437"
                id="Fill-288"
                fill="#4C3BE3"
              />
            </g>
            <g id="Group-293" transform="translate(65.000000, 144.000000)">
              <mask id="cartographie-mask-26" fill="white">
                <use xlink:href="#cartographie-path-25" />
              </mask>
              <g id="Clip-292" />
              <path
                d="M3.62976,13.47072 C1.02156,5.54172 9.84576,7.00752 7.33896,-0.64848 L-2.33124,-0.36648 L-2.75544,11.29512 L3.62976,13.47072 Z"
                id="Fill-291"
                fill="#4C3BE3"
                mask="url(#cartographie-mask-26)"
              />
            </g>
            <g id="Group-328" transform="translate(50.000000, 139.000000)">
              <path
                d="M22.0964474,14.9321951 C21.7457551,14.9321951 21.5324474,14.9029268 21.5119603,14.8992683 L21.6017423,14.2687805 C21.6119859,14.27 22.7339603,14.4212195 24.1457679,13.9596341 L24.3397936,14.5663415 C23.4142551,14.8687805 22.6092295,14.9321951 22.0964474,14.9321951"
                id="Fill-294"
                fill="#070000"
              />
              <path
                d="M22.0423372,16.3943293 C22.101991,15.9766463 22.4840167,15.6870122 22.8973756,15.747378 C23.3101321,15.8077439 23.5957474,16.1943293 23.5360936,16.6120122 C23.4770423,17.0296951 23.0944141,17.319939 22.6822603,17.2595732 C22.2695038,17.1992073 21.9826833,16.8120122 22.0423372,16.3943293"
                id="Fill-296"
                fill="#FF3D81"
              />
              <path
                d="M26.2467282,17.3140244 C25.7321385,17.3140244 25.1036641,17.0439024 24.7800872,16.8865854 C24.6240231,16.8097561 24.557741,16.6195122 24.6330615,16.4609756 C24.7083821,16.302439 24.8975872,16.2359756 25.0542538,16.3115854 C25.6080103,16.5817073 26.2599846,16.7487805 26.394959,16.6554878 C26.4937795,16.5304878 26.4811256,16.4365854 26.1955103,15.2317073 C26.1473051,15.0256098 26.0912667,14.7908537 26.0292026,14.522561 C25.9888308,14.3512195 26.0942795,14.1792683 26.2636,14.1390244 C26.4335231,14.0981707 26.602241,14.204878 26.6420103,14.3762195 C26.7046769,14.6445122 26.7601128,14.8780488 26.8089205,15.0829268 C27.1282795,16.4329268 27.1861256,16.6762195 26.8818308,17.0603659 C26.7348051,17.2457317 26.5052282,17.3140244 26.2467282,17.3140244"
                id="Fill-298"
                fill="#070000"
              />
              <path
                d="M26.7980744,12.9710366 L26.4744974,12.4240854 C27.1505744,12.0137195 27.2626513,11.8496951 27.2795231,11.7978659 L27.9013692,11.8948171 C27.8489462,12.2655488 27.4398051,12.5814024 26.7980744,12.9710366"
                id="Fill-300"
                fill="#070000"
              />
              <path
                d="M19.6802859,15.0084146 C21.9236321,12.0102439 26.8749013,11.0181707 27.05085,9.78097561 C27.05085,9.78097561 27.6238885,11.890122 27.1135167,14.1078049 C27.1135167,14.1078049 29.3182987,9.96817073 26.2042474,7.55902439 C22.3225295,4.55597561 18.8216321,6.07121951 17.0410551,7.64317073 C15.9184782,8.63402439 14.4090551,10.915122 15.7527731,13.7382927 C16.0299526,14.3206098 16.795209,15.2626829 16.795209,15.2626829 L17.1935038,13.9480488 C17.1935038,13.9480488 16.2191577,12.4931707 17.072991,11.8468293 C17.9262218,11.2004878 18.7366705,13.9468293 18.6414654,14.6132927 L19.6802859,15.0084146 Z"
                id="Fill-302"
                fill="#070000"
              />
              <path
                d="M22.9890859,4.52347561 C23.2879577,2.42408537 21.8478295,0.47652439 19.7732013,0.174085366 C17.6985731,-0.128353659 15.7733808,1.32835366 15.474509,3.42835366 C15.1756372,5.5277439 16.6157654,7.47530488 18.6903936,7.7777439 C20.7662269,8.08018293 22.6902141,6.62286585 22.9890859,4.52347561"
                id="Fill-304"
                fill="#070000"
              />
              <path
                d="M32.0511077,38.6909146 C34.5891077,37.1317683 37.4675564,34.4567683 38.4033385,35.6043293 C39.3397231,36.7518902 34.4312359,42.5994512 34.4312359,42.5994512 L32.0511077,38.6909146 Z"
                id="Fill-306"
                fill="#4C3BE3"
              />
              <path
                d="M37.2517782,39.2530488 C41.9698551,38.6542683 46.9596885,38.8847561 46.6951628,40.3481707 C46.4306372,41.8115854 37.1897141,42.0731707 37.1897141,42.0731707 L37.2517782,39.2530488 Z"
                id="Fill-308"
                fill="#4C3BE3"
              />
              <path
                d="M46.1625564,40.0492073 C45.9486462,39.7028659 44.8049795,38.9601829 38.8329667,39.5546951 L38.7709026,38.919939 C45.7775179,38.222378 46.4692615,39.3431098 46.6970308,39.7114024 L46.1625564,40.0492073 Z"
                id="Fill-310"
                fill="#070000"
              />
              <path
                d="M37.1328923,41.8644512 C41.8503667,41.2656707 46.8402,41.4961585 46.5762769,42.9595732 C46.3111487,44.4229878 37.0702256,44.6845732 37.0702256,44.6845732 L37.1328923,41.8644512 Z"
                id="Fill-312"
                fill="#4C3BE3"
              />
              <path
                d="M46.1731013,42.5364634 C45.8519346,42.0157317 44.4033705,41.5017073 39.3315885,42.0065854 L39.2701269,41.3718293 C43.7833321,40.922439 46.076691,41.1773171 46.7081782,42.1986585 L46.1731013,42.5364634 Z"
                id="Fill-314"
                fill="#070000"
              />
              <path
                d="M36.8510128,44.5395732 C41.5690897,43.9407927 46.5589231,44.1712805 46.2943974,45.6346951 C46.0298718,47.0981098 36.7889487,47.3596951 36.7889487,47.3596951 L36.8510128,44.5395732 Z"
                id="Fill-316"
                fill="#4C3BE3"
              />
              <path
                d="M45.8906795,45.2085976 C45.1905,44.0744512 40.7381538,44.5171341 39.2751282,44.6628659 L39.2136667,44.0281098 C43.6322692,43.5890854 45.7888462,43.8403049 46.4251538,44.8707927 L45.8906795,45.2085976 Z"
                id="Fill-318"
                fill="#070000"
              />
              <path
                d="M36.7998551,46.869939 C40.9726115,46.4668902 46.0184833,46.9388415 45.7105731,48.3894512 C45.4026628,49.840061 37.2776885,49.7187195 37.2776885,49.7187195 L36.7998551,46.869939 Z"
                id="Fill-320"
                fill="#4C3BE3"
              />
              <path
                d="M45.3163756,47.9712805 C44.7867218,47.0285976 42.5777218,46.9560366 39.4251064,47.1359146 L39.3895551,46.4993293 C42.9639654,46.2956707 45.1687474,46.4188415 45.8641064,47.6560366 L45.3163756,47.9712805 Z"
                id="Fill-322"
                fill="#070000"
              />
              <path
                d="M5.25231026,19.9906707 C-5.07262564,37.940061 3.2994,42.1296951 9.46784872,44.2443293 C15.6362974,46.3589634 28.5281564,50.1315244 37.2773872,49.7187195 L37.8172846,39.3248171 L12.2312077,34.3345732 L16.4039641,24.8845732 L5.25231026,19.9906707 Z"
                id="Fill-324"
                fill="#4C3BE3"
              />
              <path
                d="M3.04156282,40.7009146 L2.80716538,40.1088415 C3.36935769,39.8814024 3.60978077,38.8820122 3.34344744,37.8807927 C3.20666538,37.367378 2.60169103,35.7155488 0.549357692,36.0198171 L0.458370513,35.3887195 C2.49684487,35.0868902 3.60013974,36.392378 3.95203718,37.7155488 C4.30996026,39.0618902 3.91889615,40.3454268 3.04156282,40.7009146"
                id="Fill-326"
                fill="#070000"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END cartographie.svg -->
  <!-- BEGIN freemium.svg -->
  <svg
    v-else-if="name == 'freemium'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="146px"
    height="148px"
    viewBox="0 0 146 148"
    version="1.1"
  >
    <defs>
      <polygon
        id="path-1"
        points="0 0.275360913 134.792028 0.275360913 134.792028 123.050072 0 123.050072"
      />
      <path
        d="M0.711764706,2.17291176 L0.0827205882,9.73355882 L22.9305147,12.6539706 C24.4584559,12.8432353 25.4591912,11.0435 24.54375,9.7565 L24.54375,9.7565 C22.45625,6.82079412 18.6327206,2.691 12.6194853,0.526117647 L12.6194853,0.526117647 C12.2117647,0.379294118 11.6459559,0.317352941 10.9801471,0.317352941 L10.9801471,0.317352941 C7.33823529,0.317352941 0.711764706,2.17291176 0.711764706,2.17291176 L0.711764706,2.17291176 Z"
        id="path-3"
      />
      <path
        d="M0.726565217,7.24097368 C1.13973913,13.2481491 7.23276087,37.0712807 8.7646087,42.9909474 L8.7646087,42.9909474 L16.7309565,41.4523772 C16.7309565,41.4523772 11.0123043,19.1493333 8.99263043,11.2441228 L8.99263043,11.2441228 C8.37804348,8.83951754 5.73158696,6.79135965 2.32419565,5.44251754 L2.32419565,5.44251754 L3.94104348,0.774377193 L0.322630435,0.37304386 C0.384717391,1.78487719 0.502608696,3.9827807 0.726565217,7.24097368"
        id="path-5"
      />
      <path
        d="M0.726565217,7.24097368 C1.13973913,13.2481491 7.23276087,37.0712807 8.7646087,42.9909474 L8.7646087,42.9909474 L16.7309565,41.4523772 C16.7309565,41.4523772 11.0123043,19.1493333 8.99263043,11.2441228 L8.99263043,11.2441228 C8.37804348,8.83951754 5.73158696,6.79135965 2.32419565,5.44251754 L2.32419565,5.44251754 L3.94104348,0.774377193 L0.322630435,0.37304386 C0.384717391,1.78487719 0.502608696,3.9827807 0.726565217,7.24097368"
        id="path-7"
      />
      <path
        d="M0.726565217,7.24097368 C1.13973913,13.2481491 7.23276087,37.0712807 8.7646087,42.9909474 L8.7646087,42.9909474 L16.7309565,41.4523772 C16.7309565,41.4523772 11.0123043,19.1493333 8.99263043,11.2441228 L8.99263043,11.2441228 C8.37804348,8.83951754 5.73158696,6.79135965 2.32419565,5.44251754 L2.32419565,5.44251754 L3.94104348,0.774377193 L0.322630435,0.37304386 C0.384717391,1.78487719 0.502608696,3.9827807 0.726565217,7.24097368"
        id="path-9"
      />
      <path
        d="M0.726565217,7.24097368 C1.13973913,13.2481491 7.23276087,37.0712807 8.7646087,42.9909474 L8.7646087,42.9909474 L16.7309565,41.4523772 C16.7309565,41.4523772 11.0123043,19.1493333 8.99263043,11.2441228 L8.99263043,11.2441228 C8.37804348,8.83951754 5.73158696,6.79135965 2.32419565,5.44251754 L2.32419565,5.44251754 L3.94104348,0.774377193 L0.322630435,0.37304386 C0.384717391,1.78487719 0.502608696,3.9827807 0.726565217,7.24097368"
        id="path-11"
      />
      <path
        d="M6.40033333,0.244111111 C2.91452778,0.345944444 0.171166667,3.25397222 0.272638889,6.73977778 L0.272638889,6.73977778 C0.37375,10.2259444 3.28213889,12.9693056 6.76794444,12.8678333 L6.76794444,12.8678333 C10.25375,12.7663611 12.9974722,9.85833333 12.8956389,6.37216667 L12.8956389,6.37216667 C12.7963333,2.94883333 9.99013889,0.241222222 6.58738889,0.241222222 L6.58738889,0.241222222 C6.52527778,0.241222222 6.46280556,0.242305556 6.40033333,0.244111111"
        id="path-13"
      />
      <path
        d="M0.176449275,3.21617241 L0.435144928,10.7397931 L23.1210145,10.7397931 C24.6376812,10.7341034 25.4083333,8.83603448 24.3644928,7.68406897 L24.3644928,7.68406897 C21.982971,5.0562069 17.7655797,1.47096552 11.6336957,0.0959655172 L11.6336957,0.0959655172 C11.4322464,0.0508275862 11.1967391,0.0299655172 10.932971,0.0299655172 L10.932971,0.0299655172 C7.68007246,0.0299655172 0.176449275,3.21617241 0.176449275,3.21617241 L0.176449275,3.21617241 Z"
        id="path-15"
      />
      <path
        d="M8.07885714,5.15259259 C4.048,5.9737037 0.942857143,8.16592593 0.632,12.2148148 L0.632,12.2148148 C-0.274666667,24.0311111 0.539428571,59.68 0.539428571,59.68 L0.539428571,59.68 L15.8102857,56.8707407 C15.1584762,50.6444444 12.6015238,13.0325926 14.5855238,0.971111111 L14.5855238,0.971111111 L8.07885714,0.283703704"
        id="path-17"
      />
      <path
        d="M8.07885714,5.15259259 C4.048,5.9737037 0.942857143,8.16592593 0.632,12.2148148 L0.632,12.2148148 C-0.274666667,24.0311111 0.539428571,59.68 0.539428571,59.68 L0.539428571,59.68 L15.8102857,56.8707407 C15.1584762,50.6444444 12.6015238,13.0325926 14.5855238,0.971111111 L14.5855238,0.971111111 L8.07885714,0.283703704"
        id="path-19"
      />
      <path
        d="M8.07885714,5.15259259 C4.048,5.9737037 0.942857143,8.16592593 0.632,12.2148148 L0.632,12.2148148 C-0.274666667,24.0311111 0.539428571,59.68 0.539428571,59.68 L0.539428571,59.68 L15.8102857,56.8707407 C15.1584762,50.6444444 12.6015238,13.0325926 14.5855238,0.971111111 L14.5855238,0.971111111 L8.07885714,0.283703704"
        id="path-21"
      />
      <path
        d="M8.07885714,5.15259259 C4.048,5.9737037 0.942857143,8.16592593 0.632,12.2148148 L0.632,12.2148148 C-0.274666667,24.0311111 0.539428571,59.68 0.539428571,59.68 L0.539428571,59.68 L15.8102857,56.8707407 C15.1584762,50.6444444 12.6015238,13.0325926 14.5855238,0.971111111 L14.5855238,0.971111111 L8.07885714,0.283703704"
        id="path-23"
      />
      <path
        d="M8.07885714,5.15259259 C4.048,5.9737037 0.942857143,8.16592593 0.632,12.2148148 L0.632,12.2148148 C-0.274666667,24.0311111 0.539428571,59.68 0.539428571,59.68 L0.539428571,59.68 L15.8102857,56.8707407 C15.1584762,50.6444444 12.6015238,13.0325926 14.5855238,0.971111111 L14.5855238,0.971111111 L8.07885714,0.283703704"
        id="path-25"
      />
      <path
        d="M8.07885714,5.15259259 C4.048,5.9737037 0.942857143,8.16592593 0.632,12.2148148 L0.632,12.2148148 C-0.274666667,24.0311111 0.539428571,59.68 0.539428571,59.68 L0.539428571,59.68 L15.8102857,56.8707407 C15.1584762,50.6444444 12.6015238,13.0325926 14.5855238,0.971111111 L14.5855238,0.971111111 L8.07885714,0.283703704"
        id="path-27"
      />
      <path
        d="M8.07885714,5.15259259 C4.048,5.9737037 0.942857143,8.16592593 0.632,12.2148148 L0.632,12.2148148 C-0.274666667,24.0311111 0.539428571,59.68 0.539428571,59.68 L0.539428571,59.68 L15.8102857,56.8707407 C15.1584762,50.6444444 12.6015238,13.0325926 14.5855238,0.971111111 L14.5855238,0.971111111 L8.07885714,0.283703704"
        id="path-29"
      />
      <path
        d="M8.07885714,5.15259259 C4.048,5.9737037 0.942857143,8.16592593 0.632,12.2148148 L0.632,12.2148148 C-0.274666667,24.0311111 0.539428571,59.68 0.539428571,59.68 L0.539428571,59.68 L15.8102857,56.8707407 C15.1584762,50.6444444 12.6015238,13.0325926 14.5855238,0.971111111 L14.5855238,0.971111111 L8.07885714,0.283703704"
        id="path-31"
      />
      <polygon
        id="path-33"
        points="0 147.657658 145.954961 147.657658 145.954961 0.0494709799 0 0.0494709799"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Parametre-du-compte-/-Offres"
        transform="translate(-432.000000, -1098.000000)"
      >
        <g id="Price-1" transform="translate(360.000000, 597.000000)">
          <g
            id="Illustration-Gratuit"
            transform="translate(72.000000, 501.000000)"
          >
            <g id="Group-6" transform="translate(0.000000, 15.000000)">
              <g id="Group-3">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1" />
                </mask>
                <g id="Clip-2" />
                <path
                  d="M52.8681,0.369207493 C6.106725,-2.01912104 -10.823775,41.650389 6.8541,77.4760663 C24.53235,113.301744 67.397475,136.067853 111.153225,114.907075 C128.8566,106.345432 142.188975,85.4435303 130.213725,46.2738184 C118.2381,7.10448127 103.18035,2.93886167 52.8681,0.369207493"
                  id="Fill-1"
                  fill="#E7E6FF"
                  mask="url(#mask-2)"
                />
              </g>
              <path
                d="M121.621838,117.777602 C127.754963,119.899187 131.655338,123.945671 133.784588,126.822156 C134.717963,128.083193 133.697588,129.846248 132.138713,129.660801 L108.834338,126.799677 L109.475963,119.391176 C109.475963,119.391176 118.932713,116.847372 121.621838,117.777602"
                id="Fill-4"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-9" transform="translate(109.000000, 132.000000)">
              <mask id="mask-4" fill="white">
                <use xlink:href="#path-3" />
              </mask>
              <g id="Clip-8" />
              <polygon
                id="Fill-7"
                fill="#4C3BE3"
                mask="url(#mask-4)"
                points="35.6611029 11.5746265 35.1916176 15.6765088 -3.46867647 10.85695 -2.99919118 6.75506765"
              />
            </g>
            <g id="Group-44" transform="translate(42.000000, 0.000000)">
              <polygon
                id="Fill-10"
                fill="#070000"
                points="79.1719966 132.238129 67.0947424 133.859043 59.2392508 112.806355 69.7034203 109.324419"
              />
              <path
                d="M58.5132881,75.2706989 C64.6050508,78.7289247 69.0908136,84.4828495 70.9887797,91.2717204 L84.2368814,119.293548 L64.5036271,126.657473 L48.6229831,96.085914 L16.2773898,96.2639247 L16.6584746,76.72 L58.5132881,75.2706989 Z"
                id="Fill-12"
                fill="#4C3BE3"
              />
              <path
                d="M81.6889458,133.111548 L81.6184712,137.089882 L84.5798949,134.776871 C84.6966068,134.686172 84.8550814,134.673 84.9840983,134.743753 C85.1134881,134.814505 85.1895559,134.955634 85.1772508,135.103538 L84.9039288,138.53128 L87.2340644,136.826441 L87.6699627,137.432731 L84.6869119,139.61628 C84.6220305,139.664075 84.5455898,139.687785 84.4687763,139.687785 C84.4061322,139.687785 84.3434881,139.671978 84.2868102,139.639613 C84.1604034,139.568108 84.0869458,139.428484 84.0985051,139.282839 L84.3692169,135.889344 L81.4603695,138.161333 C81.3470136,138.249774 81.1941322,138.264452 81.0666068,138.200097 C80.9387085,138.135366 80.8592847,138.002516 80.861476,137.858 L80.9461661,133.097624 L81.6889458,133.111548 Z"
                id="Fill-14"
                fill="#070000"
              />
              <path
                d="M44.5280746,11.9792957 L48.8971254,8.96365054 L55.4851932,15.8906398 C55.4851932,15.8906398 55.0515322,47.058328 45.1996339,47.7383817 C32.3699051,48.6239194 19.0800407,50.4766613 19.0800407,50.4766613 L11.3241085,35.5448333 L39.2838712,34.9366613 L44.5280746,11.9792957 Z"
                id="Fill-16"
                fill="#070000"
              />
              <path
                d="M44.3782136,2.53392473 C46.429061,2.81580645 48.8471966,11.1089247 48.8471966,11.1089247 L44.4263153,12.517957 C44.1720102,6.83252688 40.4692983,1.99688172 44.3782136,2.53392473"
                id="Fill-18"
                fill="#070000"
              />
              <path
                d="M58.1194881,0.403967742 C59.2537932,3.78730108 50.0033525,12.1075161 50.0033525,12.1075161 L46.6779966,11.0330538 C50.7159288,5.10826882 57.4561322,-1.57484946 58.1194881,0.403967742"
                id="Fill-20"
                fill="#070000"
              />
              <path
                d="M56.8801051,16.9717258 C57.8138,16.6126935 58.8597322,17.0759731 59.2370881,18.0096828 C59.624139,18.9678548 59.1625119,20.0664032 58.2071898,20.4427473 C54.7919695,21.7881774 52.9529186,21.7181774 52.5539356,20.1642527 C52.2481729,18.9735 54.9936983,17.6969409 56.8801051,16.9717258"
                id="Fill-22"
                fill="#070000"
              />
              <path
                d="M57.3347593,20.1919892 L57.618522,20.8852151 C55.949878,21.5810753 55.0527254,21.922043 54.3852678,21.922043 C53.7536068,21.922043 53.3277763,21.6164516 52.6487593,21.0176882 L53.1372339,20.453172 C54.2413356,21.4267742 54.2838441,21.4647849 57.3347593,20.1919892"
                id="Fill-24"
                fill="#FFFFFF"
              />
              <path
                d="M55.6256576,13.7531559 C56.5593525,13.3941237 57.6052847,13.8574032 57.9822678,14.7911129 C58.3696915,15.7492849 57.9080644,16.8478333 56.9527424,17.2241774 C53.537522,18.5696075 51.6984712,18.4996075 51.2994881,16.9456828 C50.9937254,15.7549301 53.7392508,14.478371 55.6256576,13.7531559"
                id="Fill-26"
                fill="#070000"
              />
              <path
                d="M56.1786034,17.0619731 L56.4623661,17.7551989 C54.7933492,18.4510591 53.8961966,18.7920269 53.228739,18.7920269 C52.5974508,18.7920269 52.1712475,18.4864355 51.4922305,17.8880484 L51.981078,17.3235323 C53.0851797,18.2967581 53.128061,18.3347688 56.1786034,17.0619731"
                id="Fill-28"
                fill="#FFFFFF"
              />
              <path
                d="M54.5725661,10.6150484 C55.5058881,10.2560161 56.5518203,10.7192957 56.9291763,11.6530054 C57.3162271,12.6111774 56.8546,13.7097258 55.8996508,14.0860699 C52.4840576,15.4315 50.6453797,15.3615 50.2460237,13.8075753 C49.940261,12.6168226 52.6861593,11.3402634 54.5725661,10.6150484"
                id="Fill-30"
                fill="#070000"
              />
              <path
                d="M55.125139,13.9238656 L55.4089017,14.6170914 C53.7562915,15.3065538 52.8546644,15.6441344 52.1812407,15.6441344 C51.5439864,15.6441344 51.1110712,15.3423065 50.439139,14.7499409 L50.9279864,14.1850484 C52.0320881,15.1586505 52.0753424,15.1962849 55.125139,13.9238656"
                id="Fill-32"
                fill="#FFFFFF"
              />
              <path
                d="M53.1627763,7.77244624 C53.9860983,7.51916667 54.8731831,7.86239247 55.316539,8.60680108 C55.9526746,9.67448925 55.4101322,11.0673387 54.2210136,11.4022849 C51.488539,12.1722849 49.7923017,11.8305645 49.4649119,10.4008333 C49.1919627,9.20706989 51.5530475,8.26733871 53.1627763,7.77244624"
                id="Fill-34"
                fill="#070000"
              />
              <path
                d="M54.0166746,10.6848602 L54.2922339,11.3810968 C53.2090136,11.8180323 52.3319966,12.1435699 51.5373864,12.1435699 C50.8658271,12.1435699 50.2528102,11.9113656 49.6222678,11.3167419 L50.1297593,10.7691613 C51.1361661,11.7179247 51.9952847,11.4996452 54.0166746,10.6848602"
                id="Fill-36"
                fill="#FFFFFF"
              />
              <polygon
                id="Fill-38"
                fill="#FF3D81"
                points="10.8522271 34.9577742 2.87070169 35.0936344 0.234430508 29.1560538 10.4621932 30.1925054"
              />
              <path
                d="M11.6671593,35.1615645 L20.490278,72.6251129 L4.03837966,75.5730161 L2.15831186,34.4886613 C2.15831186,34.4886613 5.91844746,33.6347366 11.6671593,35.1615645"
                id="Fill-40"
                fill="#FF3D81"
              />
              <path
                d="M9.64744746,30.1031613 L13.2983288,30.5035914 L11.6673458,35.1616022 C15.1053119,36.5074086 17.7751424,38.5505806 18.3952441,40.9501505 C20.4330407,48.8375699 26.2026339,71.0904194 26.2026339,71.0904194 L18.1651763,72.6251505 C16.6195831,66.7191828 10.4718881,42.9496667 10.0550068,36.9556344 C9.82904068,33.7047742 9.71009153,31.5121935 9.64744746,30.1031613"
                id="Fill-42"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-57" transform="translate(51.000000, 30.000000)">
              <g id="Group-47">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#path-5" />
                </mask>
                <g id="Clip-46" />
                <path
                  d="M5.80878913,26.0749737 C5.80878913,15.8877456 13.9292457,7.59968421 23.9108326,7.59968421 C33.8924196,7.59968421 42.0128761,15.8877456 42.0128761,26.0749737 C42.0128761,36.2625789 33.8924196,44.5506404 23.9108326,44.5506404 C13.9292457,44.5506404 5.80878913,36.2625789 5.80878913,26.0749737 M5.07261522,26.0749737 C5.07261522,36.6767368 13.523463,45.302386 23.9108326,45.302386 C34.2982022,45.302386 42.74905,36.6767368 42.74905,26.0749737 C42.74905,15.4735877 34.2982022,6.8479386 23.9108326,6.8479386 C13.523463,6.8479386 5.07261522,15.4735877 5.07261522,26.0749737"
                  id="Fill-45"
                  fill="#E7E6FF"
                  mask="url(#mask-6)"
                />
              </g>
              <g id="Group-50">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-49" />
                <path
                  d="M7.84213696,26.0749737 C7.84213696,17.0317719 15.0505065,9.67462281 23.9108326,9.67462281 C32.7711587,9.67462281 39.9795283,17.0317719 39.9795283,26.0749737 C39.9795283,35.1181754 32.7711587,42.4753246 23.9108326,42.4753246 C15.0505065,42.4753246 7.84213696,35.1181754 7.84213696,26.0749737 M7.10596304,26.0749737 C7.10596304,35.5327105 14.6447239,43.2270702 23.9108326,43.2270702 C33.1773109,43.2270702 40.7157022,35.5327105 40.7157022,26.0749737 C40.7157022,16.617614 33.1773109,8.92325439 23.9108326,8.92325439 C14.6447239,8.92325439 7.10596304,16.617614 7.10596304,26.0749737"
                  id="Fill-48"
                  fill="#E7E6FF"
                  mask="url(#mask-8)"
                />
              </g>
              <g id="Group-53">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-52" />
                <path
                  d="M9.87544783,26.0749737 C9.87544783,18.1761754 16.1717304,11.7503158 23.9107957,11.7503158 C31.6498609,11.7503158 37.9461435,18.1761754 37.9461435,26.0749737 C37.9461435,33.9737719 31.6498609,40.4000088 23.9107957,40.4000088 C16.1717304,40.4000088 9.87544783,33.9737719 9.87544783,26.0749737 M9.13927391,26.0749737 C9.13927391,34.388307 15.7655783,41.1513772 23.9107957,41.1513772 C32.056013,41.1513772 38.6823174,34.388307 38.6823174,26.0749737 C38.6823174,17.7616404 32.056013,10.9989474 23.9107957,10.9989474 C15.7655783,10.9989474 9.13927391,17.7616404 9.13927391,26.0749737"
                  id="Fill-51"
                  fill="#E7E6FF"
                  mask="url(#mask-10)"
                />
              </g>
              <g id="Group-56">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-55" />
                <path
                  d="M11.9087957,26.0749737 C11.9087957,19.3205789 17.2926217,13.8252544 23.9107957,13.8252544 C30.5286,13.8252544 35.9127957,19.3205789 35.9127957,26.0749737 C35.9127957,32.8293684 30.5286,38.324693 23.9107957,38.324693 C17.2926217,38.324693 11.9087957,32.8293684 11.9087957,26.0749737 M11.1726217,26.0749737 C11.1726217,33.2439035 16.8868391,39.0760614 23.9107957,39.0760614 C30.9347522,39.0760614 36.6489696,33.2439035 36.6489696,26.0749737 C36.6489696,18.9060439 30.9347522,13.073886 23.9107957,13.073886 C16.8868391,13.073886 11.1726217,18.9060439 11.1726217,26.0749737"
                  id="Fill-54"
                  fill="#E7E6FF"
                  mask="url(#mask-12)"
                />
              </g>
            </g>
            <path
              d="M43.0028063,21.6892026 C42.8983546,18.1010447 45.7226396,15.107258 49.3107974,15.0028063 C52.899327,14.8983546 55.892742,17.7226396 55.9971937,21.3107974 C56.1016454,24.899327 53.2773604,27.892742 49.6892026,27.9971937 C46.100673,28.1016454 43.107258,25.2773604 43.0028063,21.6892026"
              id="Fill-58"
              fill="#070000"
            />
            <g id="Group-62" transform="translate(43.000000, 15.000000)">
              <mask id="mask-14" fill="white">
                <use xlink:href="#path-13" />
              </mask>
              <g id="Clip-61" />
              <path
                d="M5.48090833,15.1614306 L-1.77200833,14.018875 L-3.49198056,1.43451389 L6.82496389,-0.670402778 C10.9416306,7.07181944 1.20571389,7.145125 5.48090833,15.1614306"
                id="Fill-60"
                fill="#070000"
                mask="url(#mask-14)"
              />
            </g>
            <g id="Group-79" transform="translate(40.000000, 7.000000)">
              <path
                d="M13.1452964,15.0379833 C13.4918775,15.0741339 13.9852767,15.254887 14.3694071,15.9097406 L13.7246838,16.2904519 C13.5410672,15.9771464 13.3266601,15.8118326 13.0690711,15.7843431 C12.443498,15.7173138 11.6579644,16.4196151 11.4067589,16.694887 L10.8536561,16.1899079 C10.9715613,16.0599916 12.0383399,14.9261423 13.1452964,15.0379833"
                id="Fill-63"
                fill="#FFFFFF"
              />
              <path
                d="M11.5373557,18.9553556 C12.0067233,18.9414226 12.3987391,19.3123431 12.4126324,19.783431 C12.4261502,20.2541423 12.0562885,20.6472803 11.5869209,20.6608368 C11.1171779,20.6747699 10.7251621,20.3038494 10.7116443,19.8331381 C10.6981265,19.3620502 11.0676126,18.9689121 11.5373557,18.9553556"
                id="Fill-65"
                fill="#FF3D81"
              />
              <path
                d="M15.9008221,19.456795 C15.6146957,19.9779665 13.9426206,19.5016067 13.9426206,19.5016067 L15.1077787,16.8614812 C15.9766719,18.9043682 16.1103478,19.074954 15.9008221,19.456795"
                id="Fill-67"
                fill="#000000"
              />
              <path
                d="M14.0447925,19.1405146 C14.6958992,19.32541 15.4427569,19.3849079 15.5730534,19.2757029 C15.6582905,19.1201799 15.6218676,19.0068326 15.0837846,17.7558703 C14.9906621,17.5393431 14.8840217,17.2915607 14.7634881,17.0087573 C14.6827569,16.8182134 14.770998,16.5979205 14.9606225,16.5165816 C15.1506225,16.4348661 15.3702866,16.5237364 15.4517688,16.7142803 C15.5715514,16.9963305 15.6778162,17.2426067 15.7705632,17.4587573 C16.3863735,18.8900962 16.4975198,19.1484226 16.2282905,19.6375858 C16.0439229,19.9731088 15.6286265,20.0785481 15.1795356,20.0785481 C14.6846344,20.0785481 14.1491798,19.9501381 13.8405237,19.8623975 C13.6418874,19.8059121 13.5266107,19.5984226 13.5829348,19.3992176 C13.6392589,19.2000126 13.8469071,19.085159 14.0447925,19.1405146"
                id="Fill-69"
                fill="#FFFFFF"
              />
              <path
                d="M9.60851779,0.0974937238 C9.60851779,0.0974937238 14.6607905,8.73561088 15.3426877,12.1635188 C15.3426877,12.1635188 14.0671344,10.3699205 13.2808498,12.4421799 C10.3933004,12.2565314 8.90709486,15.4464477 8.67841897,16.9323891 L2.73847826,16.5079958 C1.50422925,12.2181213 0.10701581,3.07540167 0.10701581,3.07540167 C0.10701581,3.07540167 5.56144269,-0.187192469 9.60851779,0.0974937238"
                id="Fill-71"
                fill="#3424C7"
              />
              <path
                d="M8.96552174,1.31324686 C9.18894071,1.4405272 9.46718182,1.59943933 9.73941502,1.87207531 C10.3270632,2.46178243 10.2917668,3.65287029 10.2726166,4.29266109 C10.2699881,4.37625941 10.2677352,4.44780753 10.2677352,4.50391632 C10.2677352,4.76525523 10.6203241,5.20169874 10.8981897,5.36249372 C11.3330119,5.61404184 11.4952253,6.38412552 11.6769644,7.44454393 L11.7126364,7.65128033 C11.7377945,7.79324686 11.8433083,7.88588285 12.0599684,8.06475314 C12.4294545,8.36939749 12.9356206,8.78663598 13.2059763,9.84705439 L12.4812727,10.0327029 C12.2713715,9.21027615 11.9067668,8.90939749 11.5849684,8.64391632 C11.3221225,8.42738912 11.0506403,8.20295397 10.975917,7.78194979 L10.9394941,7.57182427 C10.8673992,7.15044351 10.6984269,6.16458577 10.5241976,6.01207531 C10.1190395,5.7774728 9.51975099,5.1365523 9.51975099,4.50391632 C9.51975099,4.442159 9.52200395,4.36270293 9.52463241,4.27044351 C9.5381502,3.81931381 9.5696917,2.76341423 9.21034387,2.40266109 C9.00983004,2.20119665 8.78979051,2.07579916 8.59566008,1.96508787 C8.28550198,1.78847699 7.93403953,1.58776569 7.93403953,1.1388954 L8.6763913,1.12119665 C8.70417787,1.16412552 8.85550198,1.25035983 8.96552174,1.31324686"
                id="Fill-73"
                fill="#070000"
              />
              <path
                d="M7.35795652,4.65089121 L8.09167194,4.50478243 C8.17428063,4.92390377 7.94372727,5.27599582 7.7582332,5.55917573 C7.6883913,5.66574477 7.57123715,5.84461506 7.57686957,5.90298326 C7.99216601,6.31909205 8.73939921,6.85570293 8.74690909,6.86135146 C8.81149407,6.90766946 8.85993281,6.97356904 8.88471542,7.04925941 C8.89710672,7.08653975 9.18210672,7.96394561 9.18060474,8.55930126 C9.21064427,8.63988703 9.47198814,8.80971967 9.6454664,8.92193724 C10.0686482,9.19720921 10.6487866,9.57415481 10.9221462,10.2410586 L10.2301107,10.5264979 C10.0457431,10.0761213 9.61692885,9.79746025 9.23843083,9.55193724 C8.84303557,9.29474059 8.43412253,9.02888285 8.43412253,8.57059833 C8.43412253,8.22227197 8.29443874,7.68076569 8.20957708,7.39683264 C7.97864822,7.22662343 7.41390514,6.80034728 7.04779842,6.43319247 C6.59119763,5.97490795 6.93026877,5.45674895 7.13303557,5.14720921 C7.24943874,4.96984519 7.38123715,4.76875732 7.35795652,4.65089121"
                id="Fill-75"
                fill="#070000"
              />
              <path
                d="M81.1476482,79.1748075 C87.5025099,80.5398703 91.8732609,84.0992008 94.3413834,86.7080711 C95.4231818,87.8517113 94.6245059,89.7356862 93.0526877,89.7417113 L69.5418775,89.7417113 L69.2737747,82.2724644 C69.2737747,82.2724644 78.3614822,78.5760628 81.1476482,79.1748075"
                id="Fill-77"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-82" transform="translate(110.000000, 86.000000)">
              <mask id="mask-16" fill="white">
                <use xlink:href="#path-15" />
              </mask>
              <g id="Clip-81" />
              <polygon
                id="Fill-80"
                fill="#4C3BE3"
                mask="url(#mask-16)"
                points="35.4637681 12.1727897 -2.90869565 12.2926517 -2.92355072 8.19496207 35.448913 8.0751"
              />
            </g>
            <g id="Group-95" transform="translate(32.000000, 28.000000)">
              <polygon
                id="Fill-83"
                fill="#070000"
                points="89.0305616 57.14006 77.106728 60.24766 66.6493352 40.2431933 76.7266374 35.4809267"
              />
              <path
                d="M28.7015143,37.8577156 C30.6517409,33.6730711 41.7158458,7.79189333 51.981308,6.81647111 C66.0065749,5.48367111 83.5310883,45.7766933 83.5310883,45.7766933 L62.5559708,51.7274489 L55.0488049,38.2033822 C53.7328166,41.0261378 49.0540826,53.1407156 46.0518196,60.9788489 C44.4722566,65.1030489 40.5031759,67.8102044 36.0940498,67.7724471 L22.4786623,67.65456 C15.0627482,67.5907156 8.91154032,61.8870267 8.27503943,54.4844711 L6.82481289,48.1427156 C21.376475,44.9504933 25.8742135,43.9233156 25.8742135,43.9233156 C27.1777583,41.1262489 27.9432185,39.4844267 28.7015143,37.8577156"
                id="Fill-85"
                fill="#766DFF"
              />
              <path
                d="M91.7238502,57.9459733 L92.4648006,58.0698844 L92.1631414,59.8839733 L94.6759624,58.8156178 C94.8079383,58.7597067 94.9606533,58.7842622 95.0692506,58.8783289 C95.1778479,58.9727733 95.2227197,59.1208622 95.1853894,59.2602622 L94.6465507,61.2628622 L97.4267172,60.36564 L97.6567323,61.0819067 L94.2193258,62.19144 C94.1816184,62.2039067 94.1431569,62.2099511 94.1043183,62.2099511 C94.0092956,62.2099511 93.9161584,62.1733067 93.8452685,62.1056844 C93.7457209,62.0108622 93.7057511,61.8688178 93.7415731,61.7354622 L94.2592957,59.8103067 L91.8267914,60.8442844 C91.7008487,60.8975511 91.5552981,60.8786622 91.4478321,60.7932844 C91.3399889,60.7082844 91.2868215,60.5711511 91.3094459,60.4359067 L91.7238502,57.9459733 Z"
                id="Fill-87"
                fill="#070000"
              />
              <path
                d="M25.3941984,57.6316244 C31.8180308,57.6316244 40.9149407,38.23878 46.3500851,26.6519578 C48.9036301,21.2085578 50.2697692,18.3393356 50.9994073,17.7182689 C51.6460892,17.1678467 52.272032,16.9736689 52.8610216,17.1421578 C54.4681109,17.6015356 55.4337974,20.6116689 56.8953362,25.1684244 L57.2188656,26.17558 C58.1996351,29.2178244 60.3840247,29.7486022 62.6969965,30.3114911 C64.8493348,30.8347133 67.0748255,31.3760689 68.1430761,34.0462022 C69.0597429,36.3378022 68.5461682,38.5916244 68.0499388,40.7710244 C67.3696973,43.7588689 66.7271632,46.5808689 69.6125334,49.4716244 L69.0812361,50.0035356 C65.9025024,46.8188689 66.6219596,43.6591356 67.3176611,40.6036689 C67.8101197,38.4416467 68.275052,36.39938 67.4458663,34.3261356 C66.5212809,32.0160244 64.5778415,31.5434244 62.5197717,31.0428689 C60.2203746,30.48338 57.6144162,29.8494689 56.5039334,26.4071578 L56.1804039,25.3988689 C54.8926962,21.38498 53.8757277,18.2146689 52.6551392,17.86598 C52.3180351,17.7692689 51.935682,17.9086689 51.4858328,18.2921133 C50.8463153,18.8361133 49.0778383,22.6063356 47.0299495,26.9719356 C41.1623012,39.4809133 32.2950294,58.3841578 25.3941984,58.3841578 C22.5819806,58.3841578 20.1992501,57.0623133 18.5035484,54.5618022 C17.2384651,52.69558 16.8055842,50.8539133 16.7878617,50.7764689 L17.5197623,50.6076022 C17.5359765,50.6778689 19.204906,57.6316244 25.3941984,57.6316244"
                id="Fill-89"
                fill="#070000"
              />
              <path
                d="M23.55321,46.0004133 L24.1927275,46.3948133 C22.8205553,48.6293689 20.3510978,50.2598578 17.0520775,51.10948 C14.7704028,51.6969244 12.8571294,51.7252578 12.5132379,51.7252578 C12.4849574,51.7252578 12.467612,51.72488 12.4608246,51.72488 L12.4706285,50.9723467 C12.5475516,50.9749911 20.4751551,51.0127689 23.55321,46.0004133"
                id="Fill-91"
                fill="#070000"
              />
              <path
                d="M0.625678864,12.4593378 C0.933371236,8.32909333 4.00690129,6.09302667 7.99672113,5.25549333 L7.99672113,0.289604444 L14.4367677,0.990382222 C12.4733435,13.2934711 15.0042641,51.6571822 15.6494377,58.0080044 L0.534049885,60.8734489 C0.534049885,60.8734489 -0.272134295,24.5115822 0.625678864,12.4593378"
                id="Fill-93"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-120" transform="translate(32.000000, 30.000000)">
              <g id="Group-98">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#path-17" />
                </mask>
                <g id="Clip-97" />
                <path
                  d="M0.251161905,38.5344815 C0.251161905,28.5315185 8.62182857,20.3933704 18.9109714,20.3933704 C29.2001143,20.3933704 37.570781,28.5315185 37.570781,38.5344815 C37.570781,48.5378148 29.2001143,56.675963 18.9109714,56.675963 C8.62182857,56.675963 0.251161905,48.5378148 0.251161905,38.5344815 M-0.507695238,38.5344815 C-0.507695238,48.9444815 8.20354286,57.4141111 18.9109714,57.4141111 C29.6184,57.4141111 38.3296381,48.9444815 38.3296381,38.5344815 C38.3296381,28.1248519 29.6184,19.6552222 18.9109714,19.6552222 C8.20354286,19.6552222 -0.507695238,28.1248519 -0.507695238,38.5344815"
                  id="Fill-96"
                  fill="#E7E6FF"
                  mask="url(#mask-18)"
                />
              </g>
              <g id="Group-101">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#path-19" />
                </mask>
                <g id="Clip-100" />
                <path
                  d="M2.3471619,38.5344815 C2.3471619,29.6548519 9.7776381,22.4311481 18.9109714,22.4311481 C28.0443048,22.4311481 35.474781,29.6548519 35.474781,38.5344815 C35.474781,47.4141111 28.0443048,54.6381852 18.9109714,54.6381852 C9.7776381,54.6381852 2.3471619,47.4141111 2.3471619,38.5344815 M1.58830476,38.5344815 C1.58830476,47.8207778 9.35897143,55.375963 18.9109714,55.375963 C28.4625905,55.375963 36.2336381,47.8207778 36.2336381,38.5344815 C36.2336381,29.2481852 28.4625905,21.693 18.9109714,21.693 C9.35897143,21.693 1.58830476,29.2481852 1.58830476,38.5344815"
                  id="Fill-99"
                  fill="#E7E6FF"
                  mask="url(#mask-20)"
                />
              </g>
              <g id="Group-104">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#path-21" />
                </mask>
                <g id="Clip-103" />
                <path
                  d="M4.4431619,38.5344815 C4.4431619,30.7785556 10.9334476,24.4685556 18.9109714,24.4685556 C26.8884952,24.4685556 33.378781,30.7785556 33.378781,38.5344815 C33.378781,46.2904074 26.8884952,52.6004074 18.9109714,52.6004074 C10.9334476,52.6004074 4.4431619,46.2904074 4.4431619,38.5344815 M3.68430476,38.5344815 C3.68430476,46.6974444 10.514781,53.3381852 18.9109714,53.3381852 C27.3071619,53.3381852 34.1376381,46.6974444 34.1376381,38.5344815 C34.1376381,30.3715185 27.3071619,23.7307778 18.9109714,23.7307778 C10.514781,23.7307778 3.68430476,30.3715185 3.68430476,38.5344815"
                  id="Fill-102"
                  fill="#E7E6FF"
                  mask="url(#mask-22)"
                />
              </g>
              <g id="Group-107">
                <mask id="mask-24" fill="white">
                  <use xlink:href="#path-23" />
                </mask>
                <g id="Clip-106" />
                <path
                  d="M6.53912381,38.5344815 C6.53912381,31.9022593 12.089219,26.5063333 18.9109333,26.5063333 C25.7326476,26.5063333 31.2827429,31.9022593 31.2827429,38.5344815 C31.2827429,45.1667037 25.7326476,50.5626296 18.9109333,50.5626296 C12.089219,50.5626296 6.53912381,45.1667037 6.53912381,38.5344815 M5.78026667,38.5344815 C5.78026667,45.5737407 11.6705524,51.3004074 18.9109333,51.3004074 C26.1513143,51.3004074 32.0416,45.5737407 32.0416,38.5344815 C32.0416,31.4952222 26.1513143,25.7685556 18.9109333,25.7685556 C11.6705524,25.7685556 5.78026667,31.4952222 5.78026667,38.5344815"
                  id="Fill-105"
                  fill="#E7E6FF"
                  mask="url(#mask-24)"
                />
              </g>
              <g id="Group-110">
                <mask id="mask-26" fill="white">
                  <use xlink:href="#path-25" />
                </mask>
                <g id="Clip-109" />
                <path
                  d="M-13.8991238,11.5431852 C-13.8991238,4.77577778 -8.23588571,-0.730148148 -1.27474286,-0.730148148 C5.68601905,-0.730148148 11.3492571,4.77577778 11.3492571,11.5431852 C11.3492571,18.3105926 5.68601905,23.8168889 -1.27474286,23.8168889 C-8.23588571,23.8168889 -13.8991238,18.3105926 -13.8991238,11.5431852 M-14.657981,11.5431852 C-14.657981,18.7176296 -8.65417143,24.5546667 -1.27474286,24.5546667 C6.10430476,24.5546667 12.1081143,18.7176296 12.1081143,11.5431852 C12.1081143,4.36874074 6.10430476,-1.46792593 -1.27474286,-1.46792593 C-8.65417143,-1.46792593 -14.657981,4.36874074 -14.657981,11.5431852"
                  id="Fill-108"
                  fill="#E7E6FF"
                  mask="url(#mask-26)"
                />
              </g>
              <g id="Group-113">
                <mask id="mask-28" fill="white">
                  <use xlink:href="#path-27" />
                </mask>
                <g id="Clip-112" />
                <path
                  d="M-1.27485714,-0.0762592593 L-1.27485714,0.661518519 C-7.44666667,0.661518519 -12.467619,5.543 -12.467619,11.5433704 C-12.467619,17.5433704 -7.44666667,22.4248519 -1.27485714,22.4248519 L-1.27485714,23.1626296 C-7.86495238,23.1626296 -13.2264762,17.9504074 -13.2264762,11.5433704 C-13.2264762,5.13633333 -7.86495238,-0.0762592593 -1.27485714,-0.0762592593"
                  id="Fill-111"
                  fill="#E7E6FF"
                  mask="url(#mask-28)"
                />
              </g>
              <g id="Group-116">
                <mask id="mask-30" fill="white">
                  <use xlink:href="#path-29" />
                </mask>
                <g id="Clip-115" />
                <path
                  d="M-12.0326857,11.5431852 C-12.0326857,5.77614815 -7.20678095,1.0842963 -1.27497143,1.0842963 C4.6568381,1.0842963 9.48312381,5.77614815 9.48312381,11.5431852 C9.48312381,17.3102222 4.6568381,22.0020741 -1.27497143,22.0020741 C-7.20678095,22.0020741 -12.0326857,17.3102222 -12.0326857,11.5431852 M-12.7915429,11.5431852 C-12.7915429,17.7168889 -7.62506667,22.7398519 -1.27497143,22.7398519 C5.07550476,22.7398519 10.241981,17.7168889 10.241981,11.5431852 C10.241981,5.36948148 5.07550476,0.346518519 -1.27497143,0.346518519 C-7.62506667,0.346518519 -12.7915429,5.36948148 -12.7915429,11.5431852"
                  id="Fill-114"
                  fill="#E7E6FF"
                  mask="url(#mask-30)"
                />
              </g>
              <g id="Group-119">
                <mask id="mask-32" fill="white">
                  <use xlink:href="#path-31" />
                </mask>
                <g id="Clip-118" />
                <path
                  d="M-10.0860571,11.5431852 C-10.0860571,6.81985185 -6.13329524,2.97688889 -1.27500952,2.97688889 C3.58365714,2.97688889 7.5360381,6.81985185 7.5360381,11.5431852 C7.5360381,16.2665185 3.58365714,20.1094815 -1.27500952,20.1094815 C-6.13329524,20.1094815 -10.0860571,16.2665185 -10.0860571,11.5431852 M-10.8449143,11.5431852 C-10.8449143,16.6735556 -6.5519619,20.8472593 -1.27500952,20.8472593 C4.00194286,20.8472593 8.29489524,16.6735556 8.29489524,11.5431852 C8.29489524,6.41281481 4.00194286,2.23911111 -1.27500952,2.23911111 C-6.5519619,2.23911111 -10.8449143,6.41281481 -10.8449143,11.5431852"
                  id="Fill-117"
                  fill="#E7E6FF"
                  mask="url(#mask-32)"
                />
              </g>
            </g>
            <g id="Group-133">
              <path
                d="M10.6619033,93.0662802 C13.8318674,92.0190816 18.4471938,92.2577507 27.3892247,92.7811612 L26.3480833,96.7108942 C26.3480833,96.7108942 9.90075167,96.7108942 8.95456658,96.5639918 C8.00800617,96.4170894 7.49193933,94.1134789 10.6619033,93.0662802"
                id="Fill-121"
                fill="#070000"
              />
              <path
                d="M28.1935008,94.971064 C27.3418967,100.588475 24.9762463,105.253853 23.8405239,103.540118 C22.7051769,101.826382 23.8405239,95.9230972 23.8405239,95.9230972 L28.1935008,94.971064 Z"
                id="Fill-123"
                fill="#070000"
              />
              <path
                d="M36.2053728,36.7101484 C39.806581,34.5821409 40.8432185,49.6266058 40.8432185,50.7791664 C40.8432185,51.9321045 28.4538612,96.5639918 28.4538612,96.5639918 L18.021054,96.5639918 C18.021054,96.5639918 31.3641028,39.5707795 36.2053728,36.7101484"
                id="Fill-125"
                fill="#070000"
              />
              <path
                d="M12.1052766,95.2670213 C12.4738422,95.2670213 15.7909321,96.0087084 15.7909321,96.0087084 C12.4738422,97.1952566 13.3051789,101.85006 12.2527779,102.461461 C11.2000015,103.072862 10.0410093,101.497344 10.4099501,99.2352737 C10.7785157,96.9732037 11.7367111,95.2670213 12.1052766,95.2670213"
                id="Fill-127"
                fill="#070000"
              />
              <path
                d="M10.8590972,93.9745825 C11.2043928,94.1041134 14.0542077,95.9662615 14.0542077,95.9662615 C10.5340689,95.9107483 9.69560103,100.564042 8.49682468,100.766457 C7.29804833,100.968873 6.76021285,99.0851991 7.89180668,97.0954083 C9.02302519,95.1059952 10.5138015,93.844674 10.8590972,93.9745825"
                id="Fill-129"
                fill="#070000"
              />
              <mask id="mask-34" fill="white">
                <use xlink:href="#path-33" />
              </mask>
              <g id="Clip-132" />
              <polygon
                id="Fill-131"
                fill="#070000"
                mask="url(#mask-34)"
                points="4.61457584 97.0873646 128.237918 97.0873646 128.237918 96.3351036 4.61457584 96.3351036"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END freemium.svg -->

  <!-- BEGIN standard.svg -->
  <svg
    v-else-if="name == 'standard'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="147px"
    height="151px"
    viewBox="0 0 147 151"
    version="1.1"
  >
    <defs>
      <polygon
        id="path-1"
        points="0 0.284583333 134.692192 0.284583333 134.692192 144.712143 0 144.712143"
      />
      <polygon
        id="path-3"
        points="0.0325 9.491625 3.31958333 9.42825 7.30875 11.002875 9.75583333 12.9963437 9.1825 0.238875"
      />
      <polygon
        id="path-5"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-7"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-9"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-11"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-13"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-15"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-17"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-19"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-21"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-23"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-25"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-27"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-29"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-31"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-33"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-35"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-37"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-39"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-41"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-43"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-45"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-47"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-49"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-51"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-53"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-55"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-57"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-59"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-61"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-63"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-65"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-67"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-69"
        points="0.0635636364 0.164876033 4.71750909 49.9252066 41.3255636 49.9165289 45.9025636 0.164876033"
      />
      <polygon
        id="path-71"
        points="0 151 146.993318 151 146.993318 0.285686981 0 0.285686981"
      />
      <path
        d="M1.50860606,2.96163636 C-0.789090909,5.90715152 -0.26430303,10.1576364 2.68078788,12.4549091 L2.68078788,12.4549091 C5.62630303,14.7530303 9.87636364,14.2282424 12.1744848,11.2827273 L12.1744848,11.2827273 C14.4721818,8.33721212 13.9469697,4.08757576 11.002303,1.78945455 L11.002303,1.78945455 C9.76606061,0.825575758 8.30115152,0.358060606 6.84642424,0.35848456 L6.84642424,0.35848456 C4.83424242,0.35848456 2.842,1.25236364 1.50860606,2.96163636 L1.50860606,2.96163636 Z"
        id="path-73"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Parametre-du-compte-/-Offres"
        transform="translate(-770.000000, -1086.000000)"
      >
        <g id="Price-2" transform="translate(700.000000, 597.000000)">
          <g
            id="Illustration-Standart"
            transform="translate(70.000000, 489.000000)"
          >
            <g id="Group-24">
              <g id="Group-3">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1" />
                </mask>
                <g id="Clip-2" />
                <path
                  d="M12.8031667,38.149625 C35.87775,-9.68620833 144.03275,-30.6987083 134.042333,89.4687917 C130.530667,131.707958 87.5206667,158.719625 55.5231667,137.070042 C27.3835833,118.030042 -23.9843333,114.412125 12.8031667,38.149625"
                  id="Fill-1"
                  fill-opacity="0.6"
                  fill="#B7B3FF"
                  mask="url(#mask-2)"
                />
              </g>
              <path
                d="M49.4061667,37.9563333 C60.222,46.6571667 67.5149167,54.9596667 67.5149167,54.9596667 C67.5149167,54.9596667 76.2228333,47.2205 78.21325,44.9246667 L81.6545,45.4821667 L82.7599167,54.3825833 C82.7599167,54.3825833 70.177,69.45675 64.7536667,66.8200833 C55.5215833,62.33175 45.5115833,44.39175 45.5115833,44.39175 L49.4061667,37.9563333 Z"
                id="Fill-4"
                fill="#3424C7"
              />
              <path
                d="M77.263625,45.9525417 C80.309875,41.670875 82.166125,36.8012917 83.9415417,37.9304583 C85.356125,38.8300417 80.214875,48.2917083 80.214875,48.2917083 L77.263625,45.9525417 Z"
                id="Fill-6"
                fill="#3424C7"
              />
              <path
                d="M85.1483333,54.8358333 C85.1583333,55.6354167 84.5720833,56.3195833 83.78,56.4325 C79.7795833,57.0025 79.6379167,56.5658333 79.85875,55.0641667 C80.0025,54.0879167 81.80375,53.56 83.2604167,53.29125 C84.23375,53.1120833 85.1358333,53.84625 85.1483333,54.8358333"
                id="Fill-8"
                fill="#3424C7"
              />
              <path
                d="M81.3830833,56.9545417 C81.9026667,56.9545417 82.5626667,56.8249583 83.4735,56.6107917 L83.32725,55.987875 C81.0668333,56.5187083 80.7639167,56.471625 80.0939167,55.477875 L79.5630833,55.835375 C80.1051667,56.639125 80.5730833,56.9545417 81.3830833,56.9545417"
                id="Fill-10"
                fill="#FFFFFF"
              />
              <polygon
                id="Fill-12"
                fill="#070000"
                points="51.8998333 37.0987917 63.3869167 50.594625 55.0523333 59.1667083 43.6323333 44.8187917 48.75275 37.0987917"
              />
              <path
                d="M95.8417083,66.3230417 C95.8417083,65.478875 96.5262917,64.7947083 97.3700417,64.7947083 C98.214625,64.7947083 98.8987917,65.478875 98.8987917,66.3230417 C98.8987917,67.1672083 98.214625,67.851375 97.3700417,67.851375 C96.5262917,67.851375 95.8417083,67.1672083 95.8417083,66.3230417"
                id="Fill-14"
                fill="#070000"
              />
              <path
                d="M81.9350417,66.3230417 C81.9350417,65.478875 82.619625,64.7947083 83.463375,64.7947083 C84.3075417,64.7947083 84.992125,65.478875 84.992125,66.3230417 C84.992125,67.1672083 84.3075417,67.851375 83.463375,67.851375 C82.619625,67.851375 81.9350417,67.1672083 81.9350417,66.3230417"
                id="Fill-16"
                fill="#070000"
              />
              <path
                d="M97.074625,66.4819583 L97.6300417,66.1640417 C97.5587917,66.0394583 90.4575417,53.6315417 88.2787917,49.4277917 C86.685875,46.354875 84.622125,44.574875 83.142125,44.9994583 C82.275875,45.2477917 81.3054583,46.306125 81.5979583,49.9377917 C81.984625,54.732375 83.115875,66.238625 83.127125,66.3540417 L83.7642083,66.2915417 C83.7525417,66.176125 82.622125,54.6752917 82.2362917,49.8865417 C82.0379583,47.4257083 82.432125,45.868625 83.318375,45.6144583 C84.2979583,45.3327917 86.1204583,46.6544583 87.7104583,49.722375 C89.8954583,53.9377917 97.003375,66.357375 97.074625,66.4819583"
                id="Fill-18"
                fill="#070000"
              />
              <polygon
                id="Fill-20"
                fill="#FF3D81"
                points="103.682667 116.074208 122.256 65.829625 119.8085 63.784625 115.819333 62.1700417 112.532667 62.2350417 93.9593333 112.480042"
              />
              <polygon
                id="Fill-22"
                fill="#070000"
                points="122.256083 65.8294583 121.68275 52.744875 112.53275 62.2352917 115.819417 62.169875 119.808583 63.784875"
              />
            </g>
            <g id="Group-27" transform="translate(113.000000, 53.000000)">
              <mask id="mask-4" fill="white">
                <use xlink:href="#path-3" />
              </mask>
              <g id="Clip-26" />
              <polygon
                id="Fill-25"
                fill="#FFFFFF"
                mask="url(#mask-4)"
                points="13.32725 9.77896562 16.3785 -0.636065625 5.64558333 -4.50437813 3.10016667 1.27940312"
              />
            </g>
            <g id="Group-44" transform="translate(80.000000, 62.000000)">
              <polygon
                id="Fill-28"
                fill="#070000"
                points="17.7779804 51.9773333 37.1773206 0.244 36.8235371 0.114833333 17.4237742 51.8481667"
              />
              <polygon
                id="Fill-30"
                fill="#070000"
                points="21.8541412 53.328875 40.9825433 2.182625 40.6287598 2.053875 21.5003577 53.200125"
              />
              <polygon
                id="Fill-32"
                fill="#070000"
                points="24.4471588 54.4075417 22.2297773 52.353375 18.0355196 50.7542083 14.5834887 50.813375 17.4357361 53.1937917 21.8924784 54.5687917"
              />
              <path
                d="M19.3673856,53.023875 C20.0766433,53.2822083 20.7241897,53.2980417 20.8133753,53.0592917 C20.9029835,52.8205417 20.4008392,52.417625 19.6915814,52.158875 C18.9823237,51.9005417 18.3347773,51.8847083 18.2451691,52.1234583 C18.1559835,52.3622083 18.6581278,52.765125 19.3673856,53.023875"
                id="Fill-34"
                fill="#FFFFFF"
              />
              <path
                d="M6.50864433,49.2260833 L34.5716649,36.5123333 C36.1681289,35.789 38.0748402,36.4848333 38.8086134,38.0585833 L38.8086134,38.059 C39.5423866,39.63275 38.8365103,41.5123333 37.2400464,42.2356667 L9.17702577,54.9494167"
                id="Fill-36"
                fill="#7BEAFF"
              />
              <path
                d="M6.90718969,50.4744583 L0.681107216,37.119875 C-0.0526659794,35.5457083 0.653210309,33.666125 2.24967423,32.9427917 C3.84656082,32.2194583 5.75327216,32.9152917 6.48704536,34.4894583 L12.7135505,47.8440417"
                id="Fill-38"
                fill="#7BEAFF"
              />
              <path
                d="M8.86969485,18.1325417 L15.8392722,15.9454583 C19.4485402,14.8125417 23.3063443,16.7787917 24.4551897,20.337125 L24.5604371,20.662125 C25.7092825,24.2200417 23.7146536,28.0229583 20.1053856,29.1554583 L18.5621794,29.6400417 L19.1835196,31.5650417 L15.5539629,30.5837917 L13.1358082,31.3425417 C9.52654021,32.4754583 5.66873608,30.5092083 4.51946804,26.950875 L4.4146433,26.625875 C3.26579794,23.0679583 5.26000412,19.2650417 8.86969485,18.1325417"
                id="Fill-40"
                fill="#766DFF"
              />
              <path
                d="M18.7217835,20.5291667 C17.8130206,20.8141667 17.311299,21.77125 17.6004124,22.6670833 C17.8895258,23.5629167 18.8608454,24.0579167 19.7691856,23.7725 C20.6775258,23.4875 21.1796701,22.5304167 20.8905567,21.6345833 C20.6014433,20.73875 19.6301237,20.24375 18.7217835,20.5291667 M13.9636701,22.0220833 C13.0553299,22.3075 12.5531856,23.2645833 12.842299,24.16 C13.1314124,25.0558333 14.102732,25.5508333 15.0110722,25.2658333 C15.9198351,24.9808333 16.4219794,24.0233333 16.132866,23.1275 C15.8433299,22.2320833 14.872433,21.7370833 13.9636701,22.0220833 M11.3747526,24.6208333 C11.663866,25.5166667 11.1617216,26.47375 10.2533814,26.75875 C9.34461856,27.0441667 8.37372165,26.5491667 8.08418557,25.6533333 C7.79507216,24.7575 8.29721649,23.8004167 9.20597938,23.5154167 C10.1143196,23.23 11.0856392,23.725 11.3747526,24.6208333"
                id="Fill-42"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-144" transform="translate(77.000000, 67.000000)">
              <g id="Group-47">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#path-5" />
                </mask>
                <g id="Clip-46" />
                <polygon
                  id="Fill-45"
                  fill="#070000"
                  mask="url(#mask-6)"
                  points="-24.8158291 25.265124 24.4765164 -23.4427273 24.0223709 -23.8914876 -25.2699745 24.8163636"
                />
              </g>
              <g id="Group-50">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-49" />
                <polygon
                  id="Fill-48"
                  fill="#070000"
                  mask="url(#mask-8)"
                  points="-20.2387036 29.7881818 29.0536418 -18.9196694 28.5994964 -19.3684298 -20.6928491 29.3394215"
                />
              </g>
              <g id="Group-53">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-52" />
                <polygon
                  id="Fill-51"
                  fill="#070000"
                  mask="url(#mask-10)"
                  points="-15.6615782 34.3108264 33.6307673 -14.3970248 33.1766218 -14.8457851 -16.1157236 33.8620661"
                />
              </g>
              <g id="Group-56">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-55" />
                <polygon
                  id="Fill-54"
                  fill="#070000"
                  mask="url(#mask-12)"
                  points="-11.0844527 38.8338843 38.2078927 -9.87396694 37.7537473 -10.3227273 -11.5385982 38.385124"
                />
              </g>
              <g id="Group-59">
                <mask id="mask-14" fill="white">
                  <use xlink:href="#path-13" />
                </mask>
                <g id="Clip-58" />
                <polygon
                  id="Fill-57"
                  fill="#070000"
                  mask="url(#mask-14)"
                  points="-6.50732727 43.3567769 42.7850182 -5.35107438 42.3308727 -5.79983471 -6.96147273 42.9080165"
                />
              </g>
              <g id="Group-62">
                <mask id="mask-16" fill="white">
                  <use xlink:href="#path-15" />
                </mask>
                <g id="Clip-61" />
                <polygon
                  id="Fill-60"
                  fill="#070000"
                  mask="url(#mask-16)"
                  points="-1.93020182 47.8796281 47.3621436 -0.82822314 46.9079982 -1.27698347 -2.38434727 47.4308678"
                />
              </g>
              <g id="Group-65">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#path-17" />
                </mask>
                <g id="Clip-64" />
                <polygon
                  id="Fill-63"
                  fill="#070000"
                  mask="url(#mask-18)"
                  points="24.0224127 24.2215702 24.4765582 23.7728099 -0.874041818 -1.27719008 -1.32818727 -0.828429752"
                />
              </g>
              <g id="Group-68">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#path-19" />
                </mask>
                <g id="Clip-67" />
                <polygon
                  id="Fill-66"
                  fill="#070000"
                  mask="url(#mask-20)"
                  points="28.5995382 19.698719 29.0536836 19.2499587 3.70308364 -5.80004132 3.24893818 -5.35128099"
                />
              </g>
              <g id="Group-71">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#path-21" />
                </mask>
                <g id="Clip-70" />
                <polygon
                  id="Fill-69"
                  fill="#070000"
                  mask="url(#mask-22)"
                  points="33.1766636 15.1758678 33.6308091 14.7271074 8.28020909 -10.3228926 7.82606364 -9.87413223"
                />
              </g>
              <g id="Group-74">
                <mask id="mask-24" fill="white">
                  <use xlink:href="#path-23" />
                </mask>
                <g id="Clip-73" />
                <polygon
                  id="Fill-72"
                  fill="#070000"
                  mask="url(#mask-24)"
                  points="37.7537891 10.6528099 38.2079345 10.2040496 12.8573345 -14.8459504 12.4031891 -14.3967769"
                />
              </g>
              <g id="Group-77">
                <mask id="mask-26" fill="white">
                  <use xlink:href="#path-25" />
                </mask>
                <g id="Clip-76" />
                <polygon
                  id="Fill-75"
                  fill="#070000"
                  mask="url(#mask-26)"
                  points="42.3309145 6.12995868 42.78506 5.68119835 17.43446 -19.3683884 16.9803145 -18.9196281"
                />
              </g>
              <g id="Group-80">
                <mask id="mask-28" fill="white">
                  <use xlink:href="#path-27" />
                </mask>
                <g id="Clip-79" />
                <polygon
                  id="Fill-78"
                  fill="#070000"
                  mask="url(#mask-28)"
                  points="46.90804 1.60710744 47.3621855 1.15834711 22.0115855 -23.8916529 21.55744 -23.4424793"
                />
              </g>
              <g id="Group-83">
                <mask id="mask-30" fill="white">
                  <use xlink:href="#path-29" />
                </mask>
                <g id="Clip-82" />
                <polygon
                  id="Fill-81"
                  fill="#070000"
                  mask="url(#mask-30)"
                  points="1.13653455 46.8358678 1.59068 46.3871074 -23.7595018 21.3375207 -24.2136473 21.786281"
                />
              </g>
              <g id="Group-86">
                <mask id="mask-32" fill="white">
                  <use xlink:href="#path-31" />
                </mask>
                <g id="Clip-85" />
                <polygon
                  id="Fill-84"
                  fill="#070000"
                  mask="url(#mask-32)"
                  points="5.71366 42.3130165 6.16780545 41.8642562 -19.1823764 16.8142562 -19.63694 17.2630165"
                />
              </g>
              <g id="Group-89">
                <mask id="mask-34" fill="white">
                  <use xlink:href="#path-33" />
                </mask>
                <g id="Clip-88" />
                <polygon
                  id="Fill-87"
                  fill="#070000"
                  mask="url(#mask-34)"
                  points="10.2908273 37.7901653 10.7449727 37.341405 -14.6052091 12.291405 -15.0593545 12.7401653"
                />
              </g>
              <g id="Group-92">
                <mask id="mask-36" fill="white">
                  <use xlink:href="#path-35" />
                </mask>
                <g id="Clip-91" />
                <polygon
                  id="Fill-90"
                  fill="#070000"
                  mask="url(#mask-36)"
                  points="14.8681618 33.267314 15.3223073 32.8185537 -10.0282927 7.76855372 -10.4824382 8.21731405"
                />
              </g>
              <g id="Group-95">
                <mask id="mask-38" fill="white">
                  <use xlink:href="#path-37" />
                </mask>
                <g id="Clip-94" />
                <polygon
                  id="Fill-93"
                  fill="#070000"
                  mask="url(#mask-38)"
                  points="19.4452873 28.7444215 19.8994327 28.2956612 -5.45116727 3.24566116 -5.90531273 3.69442149"
                />
              </g>
              <g id="Group-98">
                <mask id="mask-40" fill="white">
                  <use xlink:href="#path-39" />
                </mask>
                <g id="Clip-97" />
                <polygon
                  id="Fill-96"
                  fill="#070000"
                  mask="url(#mask-40)"
                  points="2.64696545 52.4024793 51.9393109 3.6946281 51.4851655 3.24586777 2.19282 51.953719"
                />
              </g>
              <g id="Group-101">
                <mask id="mask-42" fill="white">
                  <use xlink:href="#path-41" />
                </mask>
                <g id="Clip-100" />
                <polygon
                  id="Fill-99"
                  fill="#070000"
                  mask="url(#mask-42)"
                  points="7.22409091 56.9253306 56.5164364 8.21747934 56.0622909 7.76871901 6.76994545 56.4765702"
                />
              </g>
              <g id="Group-104">
                <mask id="mask-44" fill="white">
                  <use xlink:href="#path-43" />
                </mask>
                <g id="Clip-103" />
                <polygon
                  id="Fill-102"
                  fill="#070000"
                  mask="url(#mask-44)"
                  points="11.8012164 61.4483884 61.0935618 12.740124 60.6394164 12.2913636 11.3470709 60.9996281"
                />
              </g>
              <g id="Group-107">
                <mask id="mask-46" fill="white">
                  <use xlink:href="#path-45" />
                </mask>
                <g id="Clip-106" />
                <polygon
                  id="Fill-105"
                  fill="#070000"
                  mask="url(#mask-46)"
                  points="16.3785509 65.9710331 65.6708964 17.2631818 65.2167509 16.8144215 15.9244055 65.5222727"
                />
              </g>
              <g id="Group-110">
                <mask id="mask-48" fill="white">
                  <use xlink:href="#path-47" />
                </mask>
                <g id="Clip-109" />
                <polygon
                  id="Fill-108"
                  fill="#070000"
                  mask="url(#mask-48)"
                  points="20.9556764 70.4940909 70.2480218 21.7862397 69.7938764 21.3374793 20.5015309 70.0453306"
                />
              </g>
              <g id="Group-113">
                <mask id="mask-50" fill="white">
                  <use xlink:href="#path-49" />
                </mask>
                <g id="Clip-112" />
                <polygon
                  id="Fill-111"
                  fill="#070000"
                  mask="url(#mask-50)"
                  points="46.90804 46.8358678 47.3621855 46.3871074 22.0115855 21.3375207 21.55744 21.786281"
                />
              </g>
              <g id="Group-116">
                <mask id="mask-52" fill="white">
                  <use xlink:href="#path-51" />
                </mask>
                <g id="Clip-115" />
                <polygon
                  id="Fill-114"
                  fill="#070000"
                  mask="url(#mask-52)"
                  points="51.4852073 42.3130165 51.9393527 41.8642562 26.5891709 16.8142562 26.1350255 17.2630165"
                />
              </g>
              <g id="Group-119">
                <mask id="mask-54" fill="white">
                  <use xlink:href="#path-53" />
                </mask>
                <g id="Clip-118" />
                <polygon
                  id="Fill-117"
                  fill="#070000"
                  mask="url(#mask-54)"
                  points="56.0623327 37.7901653 56.5164782 37.341405 31.1662964 12.291405 30.7121509 12.7401653"
                />
              </g>
              <g id="Group-122">
                <mask id="mask-56" fill="white">
                  <use xlink:href="#path-55" />
                </mask>
                <g id="Clip-121" />
                <polygon
                  id="Fill-120"
                  fill="#070000"
                  mask="url(#mask-56)"
                  points="60.6394582 33.267314 61.0936036 32.8185537 35.7434218 7.76855372 35.2892764 8.21731405"
                />
              </g>
              <g id="Group-125">
                <mask id="mask-58" fill="white">
                  <use xlink:href="#path-57" />
                </mask>
                <g id="Clip-124" />
                <polygon
                  id="Fill-123"
                  fill="#070000"
                  mask="url(#mask-58)"
                  points="65.2165836 28.7444215 65.6707291 28.2956612 40.3205473 3.24566116 39.8664018 3.69442149"
                />
              </g>
              <g id="Group-128">
                <mask id="mask-60" fill="white">
                  <use xlink:href="#path-59" />
                </mask>
                <g id="Clip-127" />
                <polygon
                  id="Fill-126"
                  fill="#070000"
                  mask="url(#mask-60)"
                  points="69.7937091 24.2215702 70.2478545 23.7728099 44.8976727 -1.27719008 44.4435273 -0.828429752"
                />
              </g>
              <g id="Group-131">
                <mask id="mask-62" fill="white">
                  <use xlink:href="#path-61" />
                </mask>
                <g id="Clip-130" />
                <polygon
                  id="Fill-129"
                  fill="#070000"
                  mask="url(#mask-62)"
                  points="24.0224127 69.4503306 24.4765582 69.0015702 -0.874041818 43.9515702 -1.32818727 44.4003306"
                />
              </g>
              <g id="Group-134">
                <mask id="mask-64" fill="white">
                  <use xlink:href="#path-63" />
                </mask>
                <g id="Clip-133" />
                <polygon
                  id="Fill-132"
                  fill="#070000"
                  mask="url(#mask-64)"
                  points="28.5995382 64.9272727 29.0536836 64.4785124 3.70308364 39.4289256 3.24893818 39.877686"
                />
              </g>
              <g id="Group-137">
                <mask id="mask-66" fill="white">
                  <use xlink:href="#path-65" />
                </mask>
                <g id="Clip-136" />
                <polygon
                  id="Fill-135"
                  fill="#070000"
                  mask="url(#mask-66)"
                  points="33.1766636 60.4046281 33.6308091 59.9558678 8.28020909 34.9058678 7.82606364 35.3546281"
                />
              </g>
              <g id="Group-140">
                <mask id="mask-68" fill="white">
                  <use xlink:href="#path-67" />
                </mask>
                <g id="Clip-139" />
                <polygon
                  id="Fill-138"
                  fill="#070000"
                  mask="url(#mask-68)"
                  points="37.7537891 55.8815702 38.2079345 55.4328099 12.8573345 30.3832231 12.4031891 30.8319835"
                />
              </g>
              <g id="Group-143">
                <mask id="mask-70" fill="white">
                  <use xlink:href="#path-69" />
                </mask>
                <g id="Clip-142" />
                <polygon
                  id="Fill-141"
                  fill="#070000"
                  mask="url(#mask-70)"
                  points="42.3309145 51.358719 42.78506 50.9099587 17.43446 25.8599587 16.9803145 26.308719"
                />
              </g>
            </g>
            <g id="Group-194">
              <polygon
                id="Stroke-145"
                stroke="#070000"
                stroke-width="1.536"
                stroke-linejoin="round"
                points="81.551925 117.043572 118.110658 117.034788 122.681439 66.6739873 76.9043028 66.6739873"
              />
              <path
                d="M113.061793,66.5802501 C113.061793,65.7328097 113.747932,65.0459898 114.594017,65.0459898 C115.440102,65.0459898 116.125824,65.7328097 116.125824,66.5802501 C116.125824,67.4276906 115.440102,68.1145105 114.594017,68.1145105 C113.747932,68.1145105 113.061793,67.4276906 113.061793,66.5802501"
                id="Fill-147"
                fill="#070000"
              />
              <path
                d="M99.1235199,66.5802501 C99.1235199,65.7328097 99.8096591,65.0459898 100.655327,65.0459898 C101.50183,65.0459898 102.187551,65.7328097 102.187551,66.5802501 C102.187551,67.4276906 101.50183,68.1145105 100.655327,68.1145105 C99.8096591,68.1145105 99.1235199,67.4276906 99.1235199,66.5802501"
                id="Fill-149"
                fill="#070000"
              />
              <path
                d="M100.934042,66.7397831 C101.005454,66.6147166 108.129525,54.1469687 110.319491,49.9152042 C111.913105,46.8353898 113.740999,45.5098524 114.721556,45.7913565 C115.60982,46.0465089 116.004883,47.6096307 115.806099,50.0800075 C115.419389,54.8873288 114.285985,66.4327637 114.27471,66.548628 L114.913241,66.6113704 C114.924516,66.4955061 116.058337,54.9446335 116.445883,50.1314562 C116.739048,46.4857055 115.766426,45.4232679 114.898207,45.1739715 C113.415261,44.7477416 111.346403,46.5342263 109.749866,49.6194784 C107.566164,53.839531 100.448775,66.295567 100.377363,66.4206335 L100.934042,66.7397831 Z"
                id="Fill-151"
                fill="#070000"
              />
              <path
                d="M86.0883784,52.4812003 C85.9965034,53.2918319 85.3153756,53.9083803 84.5006114,53.9175825 C80.3683244,53.965685 79.799117,53.4248457 80.206708,51.9583471 C80.4865091,50.951541 82.7658443,50.7147931 84.4525858,50.6804939 C85.4293841,50.6604163 86.1986284,51.5086934 86.0883784,52.4812003"
                id="Fill-153"
                fill="#3424C7"
              />
              <path
                d="M82.2586943,54.2466454 C82.5998847,54.2466454 82.9982881,54.2194571 83.4731148,54.176374 L83.4154841,53.5364017 C81.3495494,53.723374 81.1344784,53.5794848 80.5869869,52.4944598 L80.014021,52.7839114 C80.5886574,53.9224765 81.0868705,54.2466454 82.2586943,54.2466454"
                id="Fill-155"
                fill="#FFFFFF"
              />
              <path
                d="M86.6819744,49.496838 C86.5900994,50.3074695 85.9089716,50.924018 85.0942074,50.9332202 C80.9619205,50.9813227 80.3927131,50.4404834 80.800304,48.9739848 C81.0801051,47.9667604 83.3594403,47.7304307 85.0461818,47.6961316 C86.0229801,47.6756357 86.7922244,48.524331 86.6819744,49.496838"
                id="Fill-157"
                fill="#3424C7"
              />
              <path
                d="M83.0066403,51.2007956 C83.2187881,51.2007956 83.4526517,51.1966127 83.7132426,51.1920116 L83.7859074,51.1907568 L83.7742142,50.5478565 L83.7015494,50.5495296 C81.8339813,50.582574 81.7224784,50.5855019 81.1812511,49.5134438 L80.6087028,49.8033136 C81.2313648,51.0364105 81.6924102,51.2007956 83.0066403,51.2007956"
                id="Fill-159"
                fill="#FFFFFF"
              />
              <path
                d="M87.6103713,46.3527753 C87.6103713,47.2324235 86.8849764,47.9384845 86.0071526,47.9175704 C82.4695474,47.8330773 81.3081639,47.3386673 81.7462406,45.9311465 C82.0698912,44.8904596 84.4486185,44.754936 86.0752236,44.7879803 C86.927573,44.8051299 87.6103713,45.4986424 87.6103713,46.3527753"
                id="Fill-161"
                fill="#3424C7"
              />
              <path
                d="M83.8337241,48.3892676 L83.8600338,47.7472039 C82.4493349,47.6886443 82.3340736,47.6836249 82.1407185,46.5387856 L81.5080338,46.6458659 C81.7623605,48.1512648 82.175798,48.320251 83.8337241,48.3892676"
                id="Fill-163"
                fill="#FFFFFF"
              />
              <polygon
                id="Fill-165"
                fill="#3424C7"
                points="30.1746315 88.2813343 29.3281287 99.1918163 19.7965151 98.4502014 20.6430179 87.5397194"
              />
              <path
                d="M70.9674239,83.9553307 C77.996279,90.1944332 76.3162193,105.450453 63.676725,104.56453 C55.7287023,104.007378 46.3499352,103.27371 23.5536597,101.597234 L28.0317307,84.7831119 L59.681833,91.8587795 C59.681833,91.8587795 21.8690063,63.3724831 29.3296739,59.8438515 C37.4418188,56.007364 49.4853784,64.5035191 49.4853784,64.5035191 L70.9674239,83.9553307 Z"
                id="Fill-167"
                fill="#766DFF"
              />
              <polygon
                id="Fill-169"
                fill="#7BEAFF"
                points="26.0621395 86.440933 16.1099889 84.4239745 15.8151537 90.1598831 17.8547787 90.9960299 15.4977673 92.3182211 14.2958753 107.806806 17.7495401 108.339279 21.1610259 99.7218222 22.8623838 99.5908997"
              />
              <polygon
                id="Fill-171"
                fill="#070000"
                points="18.9042 105.062872 19.3656631 104.616565 17.3636233 102.539373 21.4391148 100.337116 19.0925438 97.1937224 18.5784614 97.5785424 20.4798563 100.125465 16.3141602 102.376243"
              />
              <polygon
                id="Fill-173"
                fill="#070000"
                points="27.2260705 102.737598 32.0507608 85.7808413 31.4339455 85.6047443 26.6092551 102.561501"
              />
              <mask id="mask-72" fill="white">
                <use xlink:href="#path-71" />
              </mask>
              <g id="Clip-176" />
              <polygon
                id="Fill-175"
                fill="#3424C7"
                mask="url(#mask-72)"
                points="40.4437926 146.231997 51.3702358 146.231997 51.3702358 136.656255 40.4437926 136.656255"
              />
              <path
                d="M50.5402287,78.8752892 C62.7378878,100.014453 60.7667514,104.914214 54.2114702,142.236311 L37.1277315,139.067403 L44.5082173,101.50814 C44.5082173,101.50814 23.1702486,72.4793307 23.734027,63.5121895 C24.2978054,54.5446299 26.881581,52.4398321 26.881581,52.4398321 L45.3935582,62.7442227 L50.5402287,78.8752892 Z"
                id="Fill-177"
                fill="#B7B3FF"
                mask="url(#mask-72)"
              />
              <polygon
                id="Fill-178"
                fill="#7BEAFF"
                mask="url(#mask-72)"
                points="38.9306531 140.905671 37.6940991 151.000084 43.4262639 150.84992 44.1007099 148.748469 45.5995253 151.000084 61.1096957 151.000084 61.3719571 147.510352 52.5302412 144.77102 52.2679798 143.082413"
              />
              <polygon
                id="Fill-179"
                fill="#070000"
                mask="url(#mask-72)"
                points="55.5475415 149.40488 58.0214847 146.610752 57.541229 146.184522 55.6289761 148.344533 53.1212062 144.445722 50.1736892 147.032799 50.5967318 147.515916 52.9846466 145.419902"
              />
              <polygon
                id="Fill-180"
                fill="#070000"
                mask="url(#mask-72)"
                points="54.8197662 138.822038 54.9262577 138.18834 37.7477207 135.290897 37.6408116 135.924595"
              />
              <path
                d="M49.6407724,141.366827 C49.9932384,138.352265 49.2895594,134.906872 48.5445366,131.258611 C47.2983776,125.156706 45.8860082,118.239985 49.4006446,112.033509 C52.0299401,107.390573 52.915281,102.369091 51.961869,97.5115753 C51.1450168,93.3517554 48.9713378,89.3345698 45.8421588,86.2003787 C41.0174685,81.3679604 34.0023946,71.1681404 41.2304514,57.1552568 L40.6608264,56.8603676 C33.2452611,71.2363205 40.4399088,81.6979853 45.3882128,86.6546335 C48.4288577,89.7001488 50.5398946,93.599797 51.3321077,97.6358053 C52.255869,102.340229 51.3951673,107.209038 48.8427128,111.716451 C45.2094741,118.132905 46.6473179,125.174692 47.9160281,131.387442 C48.6501929,134.983417 49.3438491,138.379872 49.003494,141.291955 L49.6407724,141.366827 Z"
                id="Fill-181"
                fill="#FFFFFF"
                mask="url(#mask-72)"
              />
              <path
                d="M49.4852114,64.5033518 C55.7673733,43.5967535 58.274308,28.362903 47.3679102,28.0943657 C33.7374188,27.7580665 23.9201574,55.6629501 23.9201574,55.6629501 L49.4852114,64.5033518 Z"
                id="Fill-182"
                fill="#070000"
                mask="url(#mask-72)"
              />
              <path
                d="M103.405271,49.081818 C106.458444,44.7835465 108.318913,39.8950784 110.098364,41.0286241 C111.516163,41.9312778 106.363228,51.429638 106.363228,51.429638 L103.405271,49.081818 Z"
                id="Fill-183"
                fill="#3424C7"
                mask="url(#mask-72)"
              />
              <path
                d="M107.464768,48.2777535 C112.829432,47.4123269 118.841816,46.0980831 118.597094,47.7628476 C118.35279,49.4280305 107.504859,51.4675762 107.504859,51.4675762 L107.464768,48.2777535 Z"
                id="Fill-184"
                fill="#3424C7"
                mask="url(#mask-72)"
              />
              <path
                d="M106.894433,50.8327906 C112.32508,50.6466548 113.068015,51.1364637 112.61741,52.7577269 C112.166805,54.3785717 106.535703,54.002954 106.535703,54.002954 L106.894433,50.8327906 Z"
                id="Fill-185"
                fill="#3424C7"
                mask="url(#mask-72)"
              />
              <path
                d="M112.237382,52.2218233 L112.80993,51.9319535 C112.06783,50.4616903 111.453938,50.3495906 109.351254,50.5399091 L109.408884,51.1798814 C111.474819,50.9929091 111.68989,51.1363801 112.237382,52.2218233"
                id="Fill-186"
                fill="#FFFFFF"
                mask="url(#mask-72)"
              />
              <path
                d="M106.300837,53.8171111 C111.731484,53.6309753 112.474419,54.1207842 112.023814,55.7420474 C111.573209,57.3628922 105.942107,56.9872745 105.942107,56.9872745 L106.300837,53.8171111 Z"
                id="Fill-187"
                fill="#3424C7"
                mask="url(#mask-72)"
              />
              <path
                d="M111.642741,55.2024629 L112.21529,54.9125931 C111.492818,53.4803936 110.988759,53.4895958 109.112003,53.523895 L109.038503,53.5255681 L109.050196,54.1680501 L109.123696,54.166377 C110.989594,54.133751 111.101514,54.1304047 111.642741,55.2024629"
                id="Fill-188"
                fill="#FFFFFF"
                mask="url(#mask-72)"
              />
              <path
                d="M106.004373,56.4368983 C110.793984,56.4151476 111.576591,57.1826961 111.077961,58.7847183 C110.839921,59.5505936 109.727398,60.0880867 108.63158,60.4402806 C107.435535,60.824264 106.200234,59.9684579 106.130492,58.7123554 L106.004373,56.4368983 Z"
                id="Fill-189"
                fill="#3424C7"
                mask="url(#mask-72)"
              />
              <path
                d="M110.683525,58.1772465 L111.316209,58.0701662 C111.061883,56.5647673 110.648445,56.3957812 108.990519,56.3267645 L108.963792,56.9688283 C110.374908,57.0273878 110.49017,57.0324072 110.683525,58.1772465"
                id="Fill-190"
                fill="#FFFFFF"
                mask="url(#mask-72)"
              />
              <path
                d="M65.9107909,44.9927296 C76.7512057,53.7273058 78.0407966,53.6311008 78.0407966,53.6311008 C78.0407966,53.6311008 102.36178,50.3546936 104.35672,48.0499568 L107.805791,48.6092006 L107.464601,59.0340565 C107.464601,59.0340565 78.6455011,67.4683058 73.209842,64.8214139 C63.9567767,60.3156742 58.765004,57.058508 58.765004,57.058508 L65.9107909,44.9927296 Z"
                id="Fill-191"
                fill="#3424C7"
                mask="url(#mask-72)"
              />
              <path
                d="M53.2208906,31.490067 C57.3928509,36.552959 78.0409219,53.6314355 78.0409219,53.6314355 L71.2192031,63.8408759 L51.598044,52.6974105 L53.2208906,31.490067 Z"
                id="Fill-192"
                fill="#070000"
                mask="url(#mask-72)"
              />
              <path
                d="M49.9282994,18.3966521 C52.1900949,15.4929346 56.3741659,14.9755191 59.2732398,17.2409374 C62.1723136,19.5063557 62.6889017,23.6967102 60.4271062,26.600846 C58.1653108,29.5045634 53.9816574,30.0219789 51.0821659,27.7565607 C48.183092,25.4911424 47.666504,21.3003695 49.9282994,18.3966521"
                id="Fill-193"
                fill="#3424C7"
                mask="url(#mask-72)"
              />
            </g>
            <g id="Group-197" transform="translate(48.000000, 15.000000)">
              <mask id="mask-74" fill="white">
                <use xlink:href="#path-73" />
              </mask>
              <g id="Clip-196" />
              <path
                d="M-20.0615758,20.8949576 C-23.4296364,11.7648364 -13.0874545,13.1062909 -16.3269697,4.29053333 L-27.5821212,5.02065455 L-27.5914545,18.6252606 L-20.0615758,20.8949576 Z"
                id="Fill-195"
                fill="#D1CFFF"
                mask="url(#mask-74)"
              />
            </g>
            <g id="Group-212" transform="translate(40.000000, 9.000000)">
              <path
                d="M18.1214909,12.9111429 C18.1670727,12.831 18.6049091,12.123 19.5207273,12.42 L19.7143455,11.7917143 C18.5651818,11.4201429 17.8045091,12.1487143 17.5628,12.5862857 L18.1214909,12.9111429 Z"
                id="Fill-198"
                fill="#070000"
              />
              <path
                d="M17.4760691,15.7732286 C17.7696327,15.3879429 18.3124327,15.3189429 18.6883782,15.6198 C19.0647418,15.9206571 19.1316509,16.4769429 18.8380873,16.8626571 C18.5449418,17.2479429 18.0017236,17.3165143 17.6257782,17.0156571 C17.2494145,16.7152286 17.1825055,16.1585143 17.4760691,15.7732286"
                id="Fill-200"
                fill="#FF3D81"
              />
              <path
                d="M21.6882891,12.1056857 C22.23318,13.1951143 23.0875255,13.8684 22.9085436,14.2815429 C22.6910891,14.7846857 20.7595073,15.0726857 20.7595073,15.0726857 L21.6882891,12.1056857 Z"
                id="Fill-202"
                fill="#3424C7"
              />
              <path
                d="M14.6945745,7.79044286 C13.3434291,3.8973 11.2596291,0.129728571 11.2596291,0.129728571 L8.73506545,1.59587143 L9.72866545,2.75815714 L8.11490182,1.9563 L6.81352,2.95658571 L12.6091018,9.48158571 L14.6945745,7.79044286 Z"
                id="Fill-204"
                fill="#070000"
              />
              <path
                d="M9.59902909,10.7421 C6.37442909,8.2611 2.60661091,6.29995714 2.60661091,6.29995714 L1.29226545,8.95195714 L2.74712,9.35824286 L0.485592727,10.5801 L0.243465455,12.9119571 L8.77186545,13.3323857 L9.59902909,10.7421 Z"
                id="Fill-206"
                fill="#070000"
              />
              <path
                d="M16.3252327,11.4134143 C16.8772327,14.8257 15.5390509,14.8274143 14.7691782,14.6362714 C12.8447055,19.6244143 9.87436,17.4309857 9.87436,17.4309857 C9.87436,17.4309857 5.53154182,12.5379857 10.7579782,7.85327143 C13.9892691,4.95698571 18.5871782,6.55255714 20.4071055,9.04727143 C20.8344873,9.63312857 16.3252327,11.4134143 16.3252327,11.4134143"
                id="Fill-208"
                fill="#070000"
              />
              <path
                d="M12.51568,14.3803714 C12.6361164,13.5245143 13.4105891,12.9313714 14.2456982,13.0548 C15.0803891,13.1782286 15.6595709,13.9719429 15.5391345,14.8273714 C15.4186982,15.6832286 14.6442255,16.2768 13.8091164,16.1533714 C12.9744255,16.0299429 12.3952436,15.2362286 12.51568,14.3803714"
                id="Fill-210"
                fill="#3424C7"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END standard.svg -->

  <!-- BEGIN plus.svg -->
  <svg
    v-else-if="name == 'plus'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="175px"
    height="150px"
    viewBox="0 0 175 150"
    version="1.1"
  >
    <defs>
      <polygon
        id="plus-path-1"
        points="0 150 174.848918 150 174.848918 0.1592 0 0.1592"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-3"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-5"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-7"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-9"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-11"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-13"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-15"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-17"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-19"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-21"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-23"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-25"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-27"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-29"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-31"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-33"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-35"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-37"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-39"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-41"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-43"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-45"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-47"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-49"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-51"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-53"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-55"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-57"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-59"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-61"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-63"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-65"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-67"
      />
      <path
        d="M38.1466537,31.0244 C35.928439,33.0036 27.9975512,33.2264 27.9975512,33.2264 L27.9975512,33.2264 L0.219687805,44.0056 C0.219687805,44.0056 7.40774634,61.8316 16.2217317,61.7586248 L16.2217317,61.7586248 C31.8223317,61.6296 45.3276,61.7586248 45.3276,61.7586248 L45.3276,61.7586248 C51.4061561,61.7586248 57.0172829,58.4564 60.0249512,53.1092 L60.0249512,53.1092 L80.8664488,16.0572 L64.3416585,0.2904 C64.3416585,0.2904 51.0786,19.4884 38.1466537,31.0244"
        id="plus-path-69"
      />
      <path
        d="M4.926375,0.4635 C1.837125,1.09275 -0.157125,4.107375 0.47175,7.196625 L0.47175,7.196625 C1.101,10.285875 4.115625,12.2805 7.204875,11.65125 L7.204875,11.65125 C10.294125,11.022375 12.28875,8.00775 11.6595,4.918125 L11.6595,4.918125 C11.108625,2.21325 8.72925,0.347625 6.071625,0.347625 L6.071625,0.347625 C5.694,0.347625 5.31075,0.3855 4.926375,0.4635 L4.926375,0.4635 Z"
        id="plus-path-71"
      />
      <polygon
        id="plus-path-73"
        points="0 150 174.848918 150 174.848918 0.1592 0 0.1592"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Parametre-du-compte-/-Offres"
        transform="translate(-1108.000000, -1086.000000)"
      >
        <g id="Price-3" transform="translate(1040.000000, 597.000000)">
          <g
            id="Illustration-Plus"
            transform="translate(68.000000, 489.000000)"
          >
            <g id="Group-42">
              <path
                d="M117.858235,31.92712 C154.019055,63.02552 141.363246,183.76352 31.853508,137.45832 C-4.44125285,122.11112 0.41928246,64.86352 24.0111959,47.88592 C53.7787358,26.46432 69.1293052,-9.98008 117.858235,31.92712"
                id="Fill-1"
                fill="#766DFF"
              />
              <path
                d="M140.640285,29.58728 L150.680661,17.63008 L130.016708,0.15928 L126.724396,4.07968 C126.724396,4.07968 132.600251,10.19688 132.614601,15.34408 C132.629351,20.46768 130.594328,23.27208 130.594328,23.27208 L140.640285,29.58728 Z"
                id="Fill-3"
                fill="#FF3D81"
              />
              <polygon
                id="Fill-5"
                fill="#070000"
                points="147.553303 21.35448 140.821185 15.66288 138.702449 10.85488 128.370672 2.11968 130.016629 0.15928 150.680581 17.63008"
              />
              <path
                d="M133.231885,24.91248 L132.589288,24.54408 C134.696065,20.84528 136.546521,13.79608 133.009846,9.53688 L133.578696,9.06128 C135.359789,11.20608 137.579778,17.27968 133.231885,24.91248"
                id="Fill-7"
                fill="#070000"
              />
              <path
                d="M130.594248,23.27224 C130.594248,23.27224 99.6088838,40.87464 90.0883257,54.83944 C80.567369,68.80424 77.3125285,84.29624 77.3125285,84.29624 L87.0005125,110.63264 L109.129841,62.60704 L140.640205,29.58744 L130.594248,23.27224 Z"
                id="Fill-9"
                fill="#4C3BE3"
              />
              <path
                d="M83.4025285,58.7742 L107.971891,69.3206 C107.971891,69.3206 96.0069134,113.473 83.269385,114.6346 C70.5322551,115.7966 58.5668793,116.9586 58.5668793,116.9586 L62.3646583,91.7194 C62.3646583,91.7194 66.7328815,85.6194 68.2161959,84.0378 C73.2206378,78.7034 83.4025285,58.7742 83.4025285,58.7742"
                id="Fill-11"
                fill="#FF3D81"
              />
              <path
                d="M32.5347722,58.99744 C44.3510592,51.91704 53.0344875,28.00704 58.5667198,25.73704 C64.0993508,23.46704 66.8901822,25.00464 66.8901822,25.00464 L51.2514009,56.15184 L40.0398405,69.89704 L32.5347722,58.99744 Z"
                id="Fill-13"
                fill="#4C3BE3"
              />
              <path
                d="M55.5622608,30.26912 C55.3717141,27.00512 53.3845273,20.71592 54.9643109,20.39032 C56.5448918,20.06432 59.6267255,27.81872 59.6267255,27.81872 L55.5622608,30.26912 Z"
                id="Fill-15"
                fill="#4C3BE3"
              />
              <path
                d="M56.9925171,27.25332 C59.0331207,22.43492 62.0009453,17.81052 63.2271412,18.86252 C64.4529385,19.91492 59.6019704,28.85452 59.6019704,28.85452 L56.9925171,27.25332 Z"
                id="Fill-17"
                fill="#4C3BE3"
              />
              <path
                d="M57.3292426,27.4076 L56.655951,27.0992 C57.0541856,26.2244 60.6036162,18.5532 62.629869,18.4884 L62.6533884,19.2308 C61.7572608,19.2596 59.3686503,22.9276 57.3292426,27.4076"
                id="Fill-19"
                fill="#070000"
              />
              <path
                d="M59.3749487,28.79492 C61.4155524,23.97612 64.383377,19.35212 65.6095729,20.40412 C66.8353702,21.45612 61.9844021,30.39612 61.9844021,30.39612 L59.3749487,28.79492 Z"
                id="Fill-21"
                fill="#4C3BE3"
              />
              <path
                d="M60.7430979,26.78904 L60.0698064,26.48064 C62.1419021,21.92904 63.6527221,19.88064 64.9682118,19.83824 L64.9917312,20.58064 C64.3331891,20.60184 63.0619476,21.69624 60.7430979,26.78904"
                id="Fill-23"
                fill="#070000"
              />
              <path
                d="M61.7278417,30.52576 C63.7684453,25.70736 66.7362699,21.08296 67.9624658,22.13496 C69.1882631,23.18696 64.3368964,32.12696 64.3368964,32.12696 L61.7278417,30.52576 Z"
                id="Fill-25"
                fill="#4C3BE3"
              />
              <path
                d="M63.2024658,28.29608 L62.5291743,27.98768 C64.5578189,23.53088 65.9901082,21.61128 67.3171583,21.56848 L67.3406777,22.31088 C66.3891401,22.34168 64.9967141,24.35528 63.2024658,28.29608"
                id="Fill-27"
                fill="#070000"
              />
              <path
                d="M63.8840888,31.849 C65.8074943,27.657 69.0332346,23.111 70.2231549,24.1974 C71.4130752,25.2834 66.8184282,32.9522 66.8184282,32.9522 L63.8840888,31.849 Z"
                id="Fill-29"
                fill="#4C3BE3"
              />
              <path
                d="M65.6030353,29.50664 L64.9428986,29.17024 C66.7204043,25.66024 68.0546298,23.62544 69.60332,23.62544 L69.6204613,23.62544 L69.6132859,24.36864 L69.6045159,24.36864 C68.3747323,24.36864 66.9548007,26.83744 65.6030353,29.50664"
                id="Fill-31"
                fill="#070000"
              />
              <mask id="mask-2" fill="white">
                <use xlink:href="#plus-path-1" />
              </mask>
              <g id="Clip-34" />
              <polygon
                id="Fill-33"
                fill="#B7B3FF"
                mask="url(#mask-2)"
                points="47.5669134 91.4612 71.3222665 91.4612 71.3222665 78.7448 47.5669134 78.7448"
              />
              <path
                d="M150.680661,69.35116 L165.245524,74.90836 L174.848998,49.56436 L170.073371,47.74236 C170.073371,47.74236 166.26164,55.32836 161.425023,57.04316 C156.61033,58.75036 153.300478,57.74996 153.300478,57.74996 L150.680661,69.35116 Z"
                id="Fill-35"
                fill="#FF3D81"
                mask="url(#mask-2)"
              />
              <polygon
                id="Fill-36"
                fill="#070000"
                mask="url(#mask-2)"
                points="160.708759 73.17732 163.837631 64.92052 167.659727 61.32532 172.461264 48.65332 174.849077 49.56452 165.245205 74.90812"
              />
              <path
                d="M156.385142,61.14824 C155.220735,61.14824 153.969026,61.03824 152.62922,60.79024 L152.763559,60.05944 C156.938844,60.83264 164.180814,60.25544 167.017887,55.49824 L167.653309,55.87984 C166.446646,57.90264 162.707864,61.14824 156.385142,61.14824"
                id="Fill-37"
                fill="#070000"
                mask="url(#mask-2)"
              />
              <path
                d="M153.300399,57.75 C100.322039,41.564 96.9073462,50.822 74.0058656,88.9436 L85.9712415,112.3108 L112.678474,66.4804 L150.680581,69.3512 L153.300399,57.75 Z"
                id="Fill-38"
                fill="#4C3BE3"
                mask="url(#mask-2)"
              />
              <polygon
                id="Fill-39"
                fill="#766DFF"
                mask="url(#mask-2)"
                points="50.5156036 81.2224 76.5997722 81.2224 76.5997722 69.3024 50.5156036 69.3024"
              />
              <polygon
                id="Fill-40"
                fill="#B7B3FF"
                mask="url(#mask-2)"
                points="46.689123 69.3024 80.3106492 69.3024 80.3106492 52.1824 46.689123 52.1824"
              />
              <path
                d="M59.3397096,88.42636 C59.3397096,88.42636 67.3410763,88.20356 69.5794021,86.22476 C82.6258713,74.68836 96.0067938,55.49036 96.0067938,55.49036 L112.678434,71.25716 L91.6517255,108.30916 C88.6169305,113.65636 82.9563383,116.958982 76.8237642,116.958982 C76.8237642,116.958982 63.1984795,116.82956 47.4592426,116.958982 C38.5673292,117.03156 31.3149943,99.20516 31.3149943,99.20516 L59.3397096,88.42636 Z"
                id="Fill-41"
                fill="#FF3D81"
                mask="url(#mask-2)"
              />
            </g>
            <g id="Group-145" transform="translate(31.000000, 55.000000)">
              <g id="Group-45">
                <mask id="mask-4" fill="white">
                  <use xlink:href="#plus-path-3" />
                </mask>
                <g id="Clip-44" />
                <path
                  d="M9.79068732,60.76972 C9.79068732,59.74212 8.96764829,58.90892 7.95258,58.90892 C6.93751171,58.90892 6.11447268,59.74212 6.11447268,60.76972 C6.11447268,61.79732 6.93751171,62.63052 7.95258,62.63052 C8.96764829,62.63052 9.79068732,61.79732 9.79068732,60.76972"
                  id="Fill-43"
                  fill="#FFFFFF"
                  mask="url(#mask-4)"
                />
              </g>
              <g id="Group-48">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#plus-path-5" />
                </mask>
                <g id="Clip-47" />
                <path
                  d="M21.0250317,60.76972 C21.0250317,59.74212 20.2019927,58.90892 19.1869244,58.90892 C18.1718561,58.90892 17.3488171,59.74212 17.3488171,60.76972 C17.3488171,61.79732 18.1718561,62.63052 19.1869244,62.63052 C20.2019927,62.63052 21.0250317,61.79732 21.0250317,60.76972"
                  id="Fill-46"
                  fill="#FFFFFF"
                  mask="url(#mask-6)"
                />
              </g>
              <g id="Group-51">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#plus-path-7" />
                </mask>
                <g id="Clip-50" />
                <path
                  d="M32.2593761,60.76972 C32.2593761,59.74212 31.4363371,58.90892 30.4212688,58.90892 C29.4062005,58.90892 28.5831615,59.74212 28.5831615,60.76972 C28.5831615,61.79732 29.4062005,62.63052 30.4212688,62.63052 C31.4363371,62.63052 32.2593761,61.79732 32.2593761,60.76972"
                  id="Fill-49"
                  fill="#FFFFFF"
                  mask="url(#mask-8)"
                />
              </g>
              <g id="Group-54">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#plus-path-9" />
                </mask>
                <g id="Clip-53" />
                <path
                  d="M43.493918,60.76972 C43.493918,59.74212 42.670879,58.90892 41.6558107,58.90892 C40.6407424,58.90892 39.8177034,59.74212 39.8177034,60.76972 C39.8177034,61.79732 40.6407424,62.63052 41.6558107,62.63052 C42.670879,62.63052 43.493918,61.79732 43.493918,60.76972"
                  id="Fill-52"
                  fill="#FFFFFF"
                  mask="url(#mask-10)"
                />
              </g>
              <g id="Group-57">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#plus-path-11" />
                </mask>
                <g id="Clip-56" />
                <path
                  d="M54.7282624,60.76972 C54.7282624,59.74212 53.9052234,58.90892 52.8901551,58.90892 C51.8750868,58.90892 51.0520478,59.74212 51.0520478,60.76972 C51.0520478,61.79732 51.8750868,62.63052 52.8901551,62.63052 C53.9052234,62.63052 54.7282624,61.79732 54.7282624,60.76972"
                  id="Fill-55"
                  fill="#FFFFFF"
                  mask="url(#mask-12)"
                />
              </g>
              <g id="Group-60">
                <mask id="mask-14" fill="white">
                  <use xlink:href="#plus-path-13" />
                </mask>
                <g id="Clip-59" />
                <path
                  d="M65.9626068,60.76972 C65.9626068,59.74212 65.1395678,58.90892 64.1244995,58.90892 C63.1094312,58.90892 62.2863922,59.74212 62.2863922,60.76972 C62.2863922,61.79732 63.1094312,62.63052 64.1244995,62.63052 C65.1395678,62.63052 65.9626068,61.79732 65.9626068,60.76972"
                  id="Fill-58"
                  fill="#FFFFFF"
                  mask="url(#mask-14)"
                />
              </g>
              <g id="Group-63">
                <mask id="mask-16" fill="white">
                  <use xlink:href="#plus-path-15" />
                </mask>
                <g id="Clip-62" />
                <path
                  d="M77.1971488,60.76972 C77.1971488,59.74212 76.3741098,58.90892 75.3590415,58.90892 C74.343578,58.90892 73.5209341,59.74212 73.5209341,60.76972 C73.5209341,61.79732 74.343578,62.63052 75.3590415,62.63052 C76.3741098,62.63052 77.1971488,61.79732 77.1971488,60.76972"
                  id="Fill-61"
                  fill="#FFFFFF"
                  mask="url(#mask-16)"
                />
              </g>
              <g id="Group-66">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#plus-path-17" />
                </mask>
                <g id="Clip-65" />
                <path
                  d="M9.79068732,49.8002 C9.79068732,48.7726 8.96764829,47.9394 7.95258,47.9394 C6.93751171,47.9394 6.11447268,48.7726 6.11447268,49.8002 C6.11447268,50.8278 6.93751171,51.661 7.95258,51.661 C8.96764829,51.661 9.79068732,50.8278 9.79068732,49.8002"
                  id="Fill-64"
                  fill="#FFFFFF"
                  mask="url(#mask-18)"
                />
              </g>
              <g id="Group-69">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#plus-path-19" />
                </mask>
                <g id="Clip-68" />
                <path
                  d="M21.0250317,49.8002 C21.0250317,48.7726 20.2019927,47.9394 19.1869244,47.9394 C18.1718561,47.9394 17.3488171,48.7726 17.3488171,49.8002 C17.3488171,50.8278 18.1718561,51.661 19.1869244,51.661 C20.2019927,51.661 21.0250317,50.8278 21.0250317,49.8002"
                  id="Fill-67"
                  fill="#FFFFFF"
                  mask="url(#mask-20)"
                />
              </g>
              <g id="Group-72">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#plus-path-21" />
                </mask>
                <g id="Clip-71" />
                <path
                  d="M32.2593761,49.8002 C32.2593761,48.7726 31.4363371,47.9394 30.4212688,47.9394 C29.4062005,47.9394 28.5831615,48.7726 28.5831615,49.8002 C28.5831615,50.8278 29.4062005,51.661 30.4212688,51.661 C31.4363371,51.661 32.2593761,50.8278 32.2593761,49.8002"
                  id="Fill-70"
                  fill="#FFFFFF"
                  mask="url(#mask-22)"
                />
              </g>
              <g id="Group-75">
                <mask id="mask-24" fill="white">
                  <use xlink:href="#plus-path-23" />
                </mask>
                <g id="Clip-74" />
                <path
                  d="M43.493918,49.8002 C43.493918,48.7726 42.670879,47.9394 41.6558107,47.9394 C40.6407424,47.9394 39.8177034,48.7726 39.8177034,49.8002 C39.8177034,50.8278 40.6407424,51.661 41.6558107,51.661 C42.670879,51.661 43.493918,50.8278 43.493918,49.8002"
                  id="Fill-73"
                  fill="#FFFFFF"
                  mask="url(#mask-24)"
                />
              </g>
              <g id="Group-78">
                <mask id="mask-26" fill="white">
                  <use xlink:href="#plus-path-25" />
                </mask>
                <g id="Clip-77" />
                <path
                  d="M54.7282624,49.8002 C54.7282624,48.7726 53.9052234,47.9394 52.8901551,47.9394 C51.8750868,47.9394 51.0520478,48.7726 51.0520478,49.8002 C51.0520478,50.8278 51.8750868,51.661 52.8901551,51.661 C53.9052234,51.661 54.7282624,50.8278 54.7282624,49.8002"
                  id="Fill-76"
                  fill="#FFFFFF"
                  mask="url(#mask-26)"
                />
              </g>
              <g id="Group-81">
                <mask id="mask-28" fill="white">
                  <use xlink:href="#plus-path-27" />
                </mask>
                <g id="Clip-80" />
                <path
                  d="M65.9626068,49.8002 C65.9626068,48.7726 65.1395678,47.9394 64.1244995,47.9394 C63.1094312,47.9394 62.2863922,48.7726 62.2863922,49.8002 C62.2863922,50.8278 63.1094312,51.661 64.1244995,51.661 C65.1395678,51.661 65.9626068,50.8278 65.9626068,49.8002"
                  id="Fill-79"
                  fill="#FFFFFF"
                  mask="url(#mask-28)"
                />
              </g>
              <g id="Group-84">
                <mask id="mask-30" fill="white">
                  <use xlink:href="#plus-path-29" />
                </mask>
                <g id="Clip-83" />
                <path
                  d="M77.1971488,49.8002 C77.1971488,48.7726 76.3741098,47.9394 75.3590415,47.9394 C74.343578,47.9394 73.5209341,48.7726 73.5209341,49.8002 C73.5209341,50.8278 74.343578,51.661 75.3590415,51.661 C76.3741098,51.661 77.1971488,50.8278 77.1971488,49.8002"
                  id="Fill-82"
                  fill="#FFFFFF"
                  mask="url(#mask-30)"
                />
              </g>
              <g id="Group-87">
                <mask id="mask-32" fill="white">
                  <use xlink:href="#plus-path-31" />
                </mask>
                <g id="Clip-86" />
                <path
                  d="M9.79068732,38.83064 C9.79068732,37.80304 8.96764829,36.96984 7.95258,36.96984 C6.93751171,36.96984 6.11447268,37.80304 6.11447268,38.83064 C6.11447268,39.85824 6.93751171,40.69144 7.95258,40.69144 C8.96764829,40.69144 9.79068732,39.85824 9.79068732,38.83064"
                  id="Fill-85"
                  fill="#FFFFFF"
                  mask="url(#mask-32)"
                />
              </g>
              <g id="Group-90">
                <mask id="mask-34" fill="white">
                  <use xlink:href="#plus-path-33" />
                </mask>
                <g id="Clip-89" />
                <path
                  d="M21.0250317,38.83064 C21.0250317,37.80304 20.2019927,36.96984 19.1869244,36.96984 C18.1718561,36.96984 17.3488171,37.80304 17.3488171,38.83064 C17.3488171,39.85824 18.1718561,40.69144 19.1869244,40.69144 C20.2019927,40.69144 21.0250317,39.85824 21.0250317,38.83064"
                  id="Fill-88"
                  fill="#FFFFFF"
                  mask="url(#mask-34)"
                />
              </g>
              <g id="Group-93">
                <mask id="mask-36" fill="white">
                  <use xlink:href="#plus-path-35" />
                </mask>
                <g id="Clip-92" />
                <path
                  d="M32.2593761,38.83064 C32.2593761,37.80304 31.4363371,36.96984 30.4212688,36.96984 C29.4062005,36.96984 28.5831615,37.80304 28.5831615,38.83064 C28.5831615,39.85824 29.4062005,40.69144 30.4212688,40.69144 C31.4363371,40.69144 32.2593761,39.85824 32.2593761,38.83064"
                  id="Fill-91"
                  fill="#FFFFFF"
                  mask="url(#mask-36)"
                />
              </g>
              <g id="Group-96">
                <mask id="mask-38" fill="white">
                  <use xlink:href="#plus-path-37" />
                </mask>
                <g id="Clip-95" />
                <path
                  d="M43.493918,38.83064 C43.493918,37.80304 42.670879,36.96984 41.6558107,36.96984 C40.6407424,36.96984 39.8177034,37.80304 39.8177034,38.83064 C39.8177034,39.85824 40.6407424,40.69144 41.6558107,40.69144 C42.670879,40.69144 43.493918,39.85824 43.493918,38.83064"
                  id="Fill-94"
                  fill="#FFFFFF"
                  mask="url(#mask-38)"
                />
              </g>
              <g id="Group-99">
                <mask id="mask-40" fill="white">
                  <use xlink:href="#plus-path-39" />
                </mask>
                <g id="Clip-98" />
                <path
                  d="M54.7282624,38.83064 C54.7282624,37.80304 53.9052234,36.96984 52.8901551,36.96984 C51.8750868,36.96984 51.0520478,37.80304 51.0520478,38.83064 C51.0520478,39.85824 51.8750868,40.69144 52.8901551,40.69144 C53.9052234,40.69144 54.7282624,39.85824 54.7282624,38.83064"
                  id="Fill-97"
                  fill="#FFFFFF"
                  mask="url(#mask-40)"
                />
              </g>
              <g id="Group-102">
                <mask id="mask-42" fill="white">
                  <use xlink:href="#plus-path-41" />
                </mask>
                <g id="Clip-101" />
                <path
                  d="M65.9626068,38.83064 C65.9626068,37.80304 65.1395678,36.96984 64.1244995,36.96984 C63.1094312,36.96984 62.2863922,37.80304 62.2863922,38.83064 C62.2863922,39.85824 63.1094312,40.69144 64.1244995,40.69144 C65.1395678,40.69144 65.9626068,39.85824 65.9626068,38.83064"
                  id="Fill-100"
                  fill="#FFFFFF"
                  mask="url(#mask-42)"
                />
              </g>
              <g id="Group-105">
                <mask id="mask-44" fill="white">
                  <use xlink:href="#plus-path-43" />
                </mask>
                <g id="Clip-104" />
                <path
                  d="M77.1971488,38.83064 C77.1971488,37.80304 76.3741098,36.96984 75.3590415,36.96984 C74.343578,36.96984 73.5209341,37.80304 73.5209341,38.83064 C73.5209341,39.85824 74.343578,40.69144 75.3590415,40.69144 C76.3741098,40.69144 77.1971488,39.85824 77.1971488,38.83064"
                  id="Fill-103"
                  fill="#FFFFFF"
                  mask="url(#mask-44)"
                />
              </g>
              <g id="Group-108">
                <mask id="mask-46" fill="white">
                  <use xlink:href="#plus-path-45" />
                </mask>
                <g id="Clip-107" />
                <path
                  d="M43.493918,27.86132 C43.493918,26.83372 42.670879,26.00052 41.6558107,26.00052 C40.6407424,26.00052 39.8177034,26.83372 39.8177034,27.86132 C39.8177034,28.88892 40.6407424,29.72212 41.6558107,29.72212 C42.670879,29.72212 43.493918,28.88892 43.493918,27.86132"
                  id="Fill-106"
                  fill="#FFFFFF"
                  mask="url(#mask-46)"
                />
              </g>
              <g id="Group-111">
                <mask id="mask-48" fill="white">
                  <use xlink:href="#plus-path-47" />
                </mask>
                <g id="Clip-110" />
                <path
                  d="M54.7282624,27.86132 C54.7282624,26.83372 53.9052234,26.00052 52.8901551,26.00052 C51.8750868,26.00052 51.0520478,26.83372 51.0520478,27.86132 C51.0520478,28.88892 51.8750868,29.72212 52.8901551,29.72212 C53.9052234,29.72212 54.7282624,28.88892 54.7282624,27.86132"
                  id="Fill-109"
                  fill="#FFFFFF"
                  mask="url(#mask-48)"
                />
              </g>
              <g id="Group-114">
                <mask id="mask-50" fill="white">
                  <use xlink:href="#plus-path-49" />
                </mask>
                <g id="Clip-113" />
                <path
                  d="M65.9626068,27.86132 C65.9626068,26.83372 65.1395678,26.00052 64.1244995,26.00052 C63.1094312,26.00052 62.2863922,26.83372 62.2863922,27.86132 C62.2863922,28.88892 63.1094312,29.72212 64.1244995,29.72212 C65.1395678,29.72212 65.9626068,28.88892 65.9626068,27.86132"
                  id="Fill-112"
                  fill="#FFFFFF"
                  mask="url(#mask-50)"
                />
              </g>
              <g id="Group-117">
                <mask id="mask-52" fill="white">
                  <use xlink:href="#plus-path-51" />
                </mask>
                <g id="Clip-116" />
                <path
                  d="M77.1971488,27.86132 C77.1971488,26.83372 76.3741098,26.00052 75.3590415,26.00052 C74.343578,26.00052 73.5209341,26.83372 73.5209341,27.86132 C73.5209341,28.88892 74.343578,29.72212 75.3590415,29.72212 C76.3741098,29.72212 77.1971488,28.88892 77.1971488,27.86132"
                  id="Fill-115"
                  fill="#FFFFFF"
                  mask="url(#mask-52)"
                />
              </g>
              <g id="Group-120">
                <mask id="mask-54" fill="white">
                  <use xlink:href="#plus-path-53" />
                </mask>
                <g id="Clip-119" />
                <path
                  d="M43.493918,16.8918 C43.493918,15.8642 42.670879,15.031 41.6558107,15.031 C40.6407424,15.031 39.8177034,15.8642 39.8177034,16.8918 C39.8177034,17.9194 40.6407424,18.7526 41.6558107,18.7526 C42.670879,18.7526 43.493918,17.9194 43.493918,16.8918"
                  id="Fill-118"
                  fill="#FFFFFF"
                  mask="url(#mask-54)"
                />
              </g>
              <g id="Group-123">
                <mask id="mask-56" fill="white">
                  <use xlink:href="#plus-path-55" />
                </mask>
                <g id="Clip-122" />
                <path
                  d="M54.7282624,16.8918 C54.7282624,15.8642 53.9052234,15.031 52.8901551,15.031 C51.8750868,15.031 51.0520478,15.8642 51.0520478,16.8918 C51.0520478,17.9194 51.8750868,18.7526 52.8901551,18.7526 C53.9052234,18.7526 54.7282624,17.9194 54.7282624,16.8918"
                  id="Fill-121"
                  fill="#FFFFFF"
                  mask="url(#mask-56)"
                />
              </g>
              <g id="Group-126">
                <mask id="mask-58" fill="white">
                  <use xlink:href="#plus-path-57" />
                </mask>
                <g id="Clip-125" />
                <path
                  d="M65.9626068,16.8918 C65.9626068,15.8642 65.1395678,15.031 64.1244995,15.031 C63.1094312,15.031 62.2863922,15.8642 62.2863922,16.8918 C62.2863922,17.9194 63.1094312,18.7526 64.1244995,18.7526 C65.1395678,18.7526 65.9626068,17.9194 65.9626068,16.8918"
                  id="Fill-124"
                  fill="#FFFFFF"
                  mask="url(#mask-58)"
                />
              </g>
              <g id="Group-129">
                <mask id="mask-60" fill="white">
                  <use xlink:href="#plus-path-59" />
                </mask>
                <g id="Clip-128" />
                <path
                  d="M77.1971488,16.8918 C77.1971488,15.8642 76.3741098,15.031 75.3590415,15.031 C74.343578,15.031 73.5209341,15.8642 73.5209341,16.8918 C73.5209341,17.9194 74.343578,18.7526 75.3590415,18.7526 C76.3741098,18.7526 77.1971488,17.9194 77.1971488,16.8918"
                  id="Fill-127"
                  fill="#FFFFFF"
                  mask="url(#mask-60)"
                />
              </g>
              <g id="Group-132">
                <mask id="mask-62" fill="white">
                  <use xlink:href="#plus-path-61" />
                </mask>
                <g id="Clip-131" />
                <path
                  d="M43.493918,5.92224 C43.493918,4.89464 42.670879,4.06144 41.6558107,4.06144 C40.6407424,4.06144 39.8177034,4.89464 39.8177034,5.92224 C39.8177034,6.94984 40.6407424,7.78304 41.6558107,7.78304 C42.670879,7.78304 43.493918,6.94984 43.493918,5.92224"
                  id="Fill-130"
                  fill="#FFFFFF"
                  mask="url(#mask-62)"
                />
              </g>
              <g id="Group-135">
                <mask id="mask-64" fill="white">
                  <use xlink:href="#plus-path-63" />
                </mask>
                <g id="Clip-134" />
                <path
                  d="M54.7282624,5.92224 C54.7282624,4.89464 53.9052234,4.06144 52.8901551,4.06144 C51.8750868,4.06144 51.0520478,4.89464 51.0520478,5.92224 C51.0520478,6.94984 51.8750868,7.78304 52.8901551,7.78304 C53.9052234,7.78304 54.7282624,6.94984 54.7282624,5.92224"
                  id="Fill-133"
                  fill="#FFFFFF"
                  mask="url(#mask-64)"
                />
              </g>
              <g id="Group-138">
                <mask id="mask-66" fill="white">
                  <use xlink:href="#plus-path-65" />
                </mask>
                <g id="Clip-137" />
                <path
                  d="M65.9626068,5.92224 C65.9626068,4.89464 65.1395678,4.06144 64.1244995,4.06144 C63.1094312,4.06144 62.2863922,4.89464 62.2863922,5.92224 C62.2863922,6.94984 63.1094312,7.78304 64.1244995,7.78304 C65.1395678,7.78304 65.9626068,6.94984 65.9626068,5.92224"
                  id="Fill-136"
                  fill="#FFFFFF"
                  mask="url(#mask-66)"
                />
              </g>
              <g id="Group-141">
                <mask id="mask-68" fill="white">
                  <use xlink:href="#plus-path-67" />
                </mask>
                <g id="Clip-140" />
                <path
                  d="M77.1971488,5.92224 C77.1971488,4.89464 76.3741098,4.06144 75.3590415,4.06144 C74.343578,4.06144 73.5209341,4.89464 73.5209341,5.92224 C73.5209341,6.94984 74.343578,7.78304 75.3590415,7.78304 C76.3741098,7.78304 77.1971488,6.94984 77.1971488,5.92224"
                  id="Fill-139"
                  fill="#FFFFFF"
                  mask="url(#mask-68)"
                />
              </g>
              <g id="Group-144">
                <mask id="mask-70" fill="white">
                  <use xlink:href="#plus-path-69" />
                </mask>
                <g id="Clip-143" />
                <path
                  d="M86.4697917,0.48888 C86.4697917,-1.07752 85.2152795,-2.34712 83.667982,-2.34712 C82.1210795,-2.34712 80.8665673,-1.07752 80.8665673,0.48888 C80.8665673,2.05528 82.1210795,3.32528 83.667982,3.32528 C85.2152795,3.32528 86.4697917,2.05528 86.4697917,0.48888"
                  id="Fill-142"
                  fill="#FFFFFF"
                  mask="url(#mask-70)"
                />
              </g>
            </g>
            <g id="Group-154" transform="translate(23.000000, 44.000000)">
              <path
                d="M76.999714,10.7755335 L76.5668735,10.1762652 C85.2789903,4.02227134 101.040395,6.4851372 102.80943,6.78635671 L102.683185,7.51205793 C100.828784,7.19617378 95.9052237,6.50257622 90.250644,6.8771189 C84.589251,7.25166159 80.1309942,8.56315549 76.999714,10.7755335"
                id="Fill-146"
                fill="#070000"
              />
              <path
                d="M4.60506187,17.5541616 C-2.07110156,21.5223323 0.270244747,36.4017835 2.24367665,44.451875 C4.21710856,52.5019665 9.39115525,64.7564482 9.39115525,64.7564482 L36.8148051,44.4162043 C36.8148051,44.4162043 28.1760307,27.2038872 21.0578089,20.4537957 C12.6250346,12.458003 6.75443541,16.276753 4.60506187,17.5541616"
                id="Fill-148"
                fill="#FFFFFF"
              />
              <path
                d="M13.6793218,8.9701189 C13.6793218,8.9701189 15.2932556,8.9166128 15.3990611,8.38155183 C15.4764113,7.98957012 15.3100883,7.87819817 13.9630728,6.33960061 L13.6793218,8.9701189 Z"
                id="Fill-150"
                fill="#4C3BE3"
              />
              <path
                d="M14.4650074,5.19809756 C15.1375132,8.46355488 13.0057739,11.6493476 9.70416304,12.3144085 C6.40215136,12.9794695 3.18069611,10.8713293 2.50819027,7.60626829 C1.83568444,4.34081098 3.96742374,1.15501829 7.26903463,0.489957317 C10.5710463,-0.175103659 13.7925016,1.93303659 14.4650074,5.19809756"
                id="Fill-152"
                fill="#4C3BE3"
              />
            </g>
            <g id="Group-157" transform="translate(25.000000, 44.000000)">
              <mask id="mask-72" fill="white">
                <use xlink:href="#plus-path-71" />
              </mask>
              <g id="Clip-156" />
              <path
                d="M5.7184125,-1.778325 C10.7655375,4.7013 0.0255375,6.776175 4.8889125,13.03605 L15.8325375,9.062175 L12.3555375,-1.88145 L5.7184125,-1.778325 Z"
                id="Fill-155"
                fill="#4C3BE3"
                mask="url(#mask-72)"
              />
            </g>
            <g id="Group-190">
              <path
                d="M34.9316344,51.16776 L34.2435934,50.89336 C34.5198462,50.19496 35.4426822,48.91016 36.9491173,49.06536 L36.8753702,49.80416 C35.5399487,49.67456 34.9376139,51.15256 34.9316344,51.16776"
                id="Fill-158"
                fill="#FFFFFF"
              />
              <path
                d="M28.7500683,52.27188 C28.7500683,50.63188 27.4250114,49.30268 25.7910137,49.30268 C24.1566173,49.30268 22.8315604,50.63188 22.8315604,52.27188 C22.8315604,53.91188 24.1566173,55.24108 25.7910137,55.24108 C27.4250114,55.24108 28.7500683,53.91188 28.7500683,52.27188"
                id="Fill-160"
                fill="#070000"
              />
              <path
                d="M27.0130638,47.74236 C27.0130638,46.10236 25.6884055,44.77316 24.0540091,44.77316 C22.4196128,44.77316 21.0945558,46.10236 21.0945558,47.74236 C21.0945558,49.38236 22.4196128,50.71156 24.0540091,50.71156 C25.6884055,50.71156 27.0130638,49.38236 27.0130638,47.74236"
                id="Fill-162"
                fill="#070000"
              />
              <path
                d="M30.5834226,47.74236 C30.5834226,46.10236 29.2583656,44.77316 27.6243679,44.77316 C25.9899715,44.77316 24.6649146,46.10236 24.6649146,47.74236 C24.6649146,49.38236 25.9899715,50.71156 27.6243679,50.71156 C29.2583656,50.71156 30.5834226,49.38236 30.5834226,47.74236"
                id="Fill-164"
                fill="#070000"
              />
              <path
                d="M30.4547836,44.25664 C30.4547836,42.61664 29.1297267,41.28744 27.4957289,41.28744 C25.8613326,41.28744 24.5362756,42.61664 24.5362756,44.25664 C24.5362756,45.89664 25.8613326,47.22584 27.4957289,47.22584 C29.1297267,47.22584 30.4547836,45.89664 30.4547836,44.25664"
                id="Fill-166"
                fill="#070000"
              />
              <path
                d="M34.8093736,43.97088 C34.8093736,42.33088 33.4847153,41.00168 31.8503189,41.00168 C30.2159226,41.00168 28.8912642,42.33088 28.8912642,43.97088 C28.8912642,45.61088 30.2159226,46.94008 31.8503189,46.94008 C33.4847153,46.94008 34.8093736,45.61088 34.8093736,43.97088"
                id="Fill-168"
                fill="#070000"
              />
              <path
                d="M33.9410706,47.28748 C33.9410706,45.64748 32.6160137,44.31828 30.9820159,44.31828 C29.3476196,44.31828 28.0225626,45.64748 28.0225626,47.28748 C28.0225626,48.92748 29.3476196,50.25668 30.9820159,50.25668 C32.6160137,50.25668 33.9410706,48.92748 33.9410706,47.28748"
                id="Fill-170"
                fill="#070000"
              />
              <path
                d="M30.3582346,50.42052 C30.3582346,49.66292 29.7463326,49.04892 28.9913212,49.04892 C28.2363098,49.04892 27.6244077,49.66292 27.6244077,50.42052 C27.6244077,51.17812 28.2363098,51.79212 28.9913212,51.79212 C29.7463326,51.79212 30.3582346,51.17812 30.3582346,50.42052"
                id="Fill-172"
                fill="#4C3BE3"
              />
              <path
                d="M38.7532916,64.54376 C43.7617198,69.56936 49.6893964,76.65656 49.6893964,76.65656 L56.4007859,66.11776 C65.3142255,63.19336 66.8900228,65.96376 66.8900228,65.96376 C66.8900228,65.96376 57.7190661,92.85416 50.3327904,91.46096 C42.128918,89.91416 35.7814806,83.21376 32.8993622,79.58416 C23.2113781,67.38416 30.3580752,56.11976 38.7532916,64.54376"
                id="Fill-174"
                fill="#4C3BE3"
              />
              <polygon
                id="Fill-176"
                fill="#070000"
                points="55.7403303 52.27616 80.3108884 54.17256 80.3108884 52.27616"
              />
              <mask id="mask-74" fill="white">
                <use xlink:href="#plus-path-73" />
              </mask>
              <g id="Clip-179" />
              <polygon
                id="Fill-178"
                fill="#B7B3FF"
                mask="url(#mask-74)"
                points="55.7400911 52.276 86.7828588 52.276 86.7828588 28.2664 55.7400911 28.2664"
              />
              <polygon
                id="Fill-180"
                fill="#070000"
                mask="url(#mask-74)"
                points="55.7400911 40.9668 86.7828588 40.9668 86.7828588 40.224 55.7400911 40.224"
              />
              <path
                d="M93.7563098,135.2498 L39.0502733,135.2498 C34.5776082,135.2498 30.8352392,132.031 30.1511845,127.5962 L19.7839294,60.3622 C19.1796014,56.4954 15.9096128,53.6882 12.0085877,53.6882 L0.000159453303,53.6882 L0.000159453303,52.9454 L12.0085877,52.9454 C16.276754,52.9454 19.8540888,56.0166 20.5154214,60.2478 L30.8826765,127.4826 C31.5105239,131.5526 34.9451481,134.507 39.0502733,134.507 L93.7563098,134.507 L93.7563098,135.2498 Z"
                id="Fill-181"
                fill="#070000"
                mask="url(#mask-74)"
              />
              <path
                d="M51.2514408,142.25352 C51.2514408,140.15192 49.5536617,138.44832 47.4592426,138.44832 C45.3648235,138.44832 43.6670444,140.15192 43.6670444,142.25352 C43.6670444,144.35512 45.3648235,146.05872 47.4592426,146.05872 C49.5536617,146.05872 51.2514408,144.35512 51.2514408,142.25352"
                id="Fill-182"
                fill="#070000"
                mask="url(#mask-74)"
              />
              <path
                d="M47.4591629,135.2498 C43.6107574,135.2498 40.4794932,138.3914 40.4794932,142.2534 C40.4794932,146.1154 43.6107574,149.2574 47.4591629,149.2574 C51.3075683,149.2574 54.4388326,146.1154 54.4388326,142.2534 C54.4388326,138.3914 51.3075683,135.2498 47.4591629,135.2498 M47.4591629,149.9998 C43.2025569,149.9998 39.7392312,146.525 39.7392312,142.2534 C39.7392312,137.9822 43.2025569,134.507 47.4591629,134.507 C51.7161674,134.507 55.1790945,137.9822 55.1790945,142.2534 C55.1790945,146.525 51.7161674,149.9998 47.4591629,149.9998"
                id="Fill-183"
                fill="#070000"
                mask="url(#mask-74)"
              />
              <path
                d="M84.8970046,142.25352 C84.8970046,140.15192 83.1992255,138.44832 81.1048064,138.44832 C79.0103872,138.44832 77.3126082,140.15192 77.3126082,142.25352 C77.3126082,144.35512 79.0103872,146.05872 81.1048064,146.05872 C83.1992255,146.05872 84.8970046,144.35512 84.8970046,142.25352"
                id="Fill-184"
                fill="#070000"
                mask="url(#mask-74)"
              />
              <path
                d="M81.1047665,135.2498 C77.256361,135.2498 74.1250968,138.3914 74.1250968,142.2534 C74.1250968,146.1154 77.256361,149.2574 81.1047665,149.2574 C84.9535706,149.2574 88.0844362,146.1154 88.0844362,142.2534 C88.0844362,138.3914 84.9535706,135.2498 81.1047665,135.2498 M81.1047665,149.9998 C76.8481606,149.9998 73.3848349,146.525 73.3848349,142.2534 C73.3848349,137.9822 76.8481606,134.507 81.1047665,134.507 C85.3617711,134.507 88.8246982,137.9822 88.8246982,142.2534 C88.8246982,146.525 85.3617711,149.9998 81.1047665,149.9998"
                id="Fill-185"
                fill="#070000"
                mask="url(#mask-74)"
              />
              <path
                d="M87.8873519,117.33008 L28.9749374,117.33008 L28.9749374,116.58728 L87.8873519,116.58728 C92.6585934,116.58728 96.8661674,113.53128 98.3570558,108.98328 L112.167306,66.85208 L21.1015319,66.85208 L21.1015319,66.10928 L113.190199,66.10928 L99.0602449,109.21528 C97.4692995,114.06888 92.9790945,117.33008 87.8873519,117.33008"
                id="Fill-186"
                fill="#070000"
                mask="url(#mask-74)"
              />
              <polygon
                id="Fill-187"
                fill="#070000"
                mask="url(#mask-74)"
                points="23.2112187 79.1164 85.9712415 79.1164 85.9712415 78.3736 23.2112187 78.3736"
              />
              <polygon
                id="Fill-188"
                fill="#070000"
                mask="url(#mask-74)"
                points="24.9536446 91.8328 104.490148 91.8328 104.490148 91.09 24.9536446 91.09"
              />
              <polygon
                id="Fill-189"
                fill="#070000"
                mask="url(#mask-74)"
                points="42.934795 104.5492 100.322039 104.5492 100.322039 103.8064 42.934795 103.8064"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END plus.svg -->
  <!-- START no_result.svg -->
  <svg
    v-else-if="name === 'no_result'"
    width="150px"
    height="157px"
    viewBox="0 0 150 157"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <polygon
        id="path-1"
        points="0.0997403423 0.1078125 145.945312 0.1078125 145.945312 156.494852 0.0997403423 156.494852"
      />
      <polygon
        id="path-3"
        points="0.28171875 0.305625 0.28171875 9.8559375 0.28171875 21.1584375 4.60125 21.1584375 6.35578125 16.0964062 10.9598438 21.1584375 24.9914063 21.1584375 24.9914063 15.4579687 17.75625 9.09984375 16.6035938 0.305625"
      />
      <polygon
        id="path-5"
        points="0.10078125 8.27501645 4.741875 16.7684868 10.23375 26.8197533 14.0090625 24.6838651 13.0823437 19.3145724 19.5665625 21.5401316 31.83 14.6020724 29.0596875 9.53231908 19.6467187 7.45557566 14.3657812 0.204621711"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-7"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-9"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-11"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-13"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-15"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-17"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-19"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-21"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-23"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-25"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-27"
      />
      <path
        d="M2.2209375,2.05828125 C-1.97765625,14.574375 0.20203125,26.7665625 7.14609375,26.7665625 L7.14609375,26.7665625 C14.0901563,26.7665625 44.2701563,26.7351563 44.2701563,26.7351563 L44.2701563,26.7351563 L42.5123438,52.4432813 L55.393125,51.9604688 L56.5603125,32.1810938 L60.1954688,51.474375 L94.4648438,36.2301563 C94.4648438,36.2301563 83.2945313,15.2376563 70.4128125,10.2829687 L70.4128125,10.2829687 C64.5548438,8.030625 57.6539063,8.0540625 50.705625,8.0784375 L50.705625,8.0784375 C42.3740625,8.10703125 33.9745313,8.135625 27.2254688,4.23890625 L27.2254688,4.23890625 C22.04625,1.24875 16.8225,0.37875 12.4996875,0.37875 L12.4996875,0.37875 C6.4903125,0.37875 2.2209375,2.05828125 2.2209375,2.05828125 L2.2209375,2.05828125 Z"
        id="path-29"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Passeport-Compétence-/-Ajouter-passeport-Payant"
        transform="translate(-646.000000, -537.000000)"
      >
        <g id="Formulaire" transform="translate(238.000000, 316.000000)">
          <g id="Group-99" transform="translate(408.000000, 221.000000)">
            <g id="Group-3" transform="translate(3.750000, 0.000000)">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1" />
              </mask>
              <g id="Clip-2" />
              <path
                d="M13.9630313,41.10825 C38.9483438,-10.688625 156.059438,-33.4412813 145.241625,96.6766875 C141.439125,142.414031 94.8674063,171.662156 60.2206875,148.219969 C29.7505313,127.603406 -25.8704063,123.686063 13.9630313,41.10825"
                id="Fill-1"
                fill="#E7E6FF"
                mask="url(#mask-2)"
              />
            </g>
            <polygon
              id="Fill-4"
              fill="#000000"
              points="71.25 122.8125 86.25 122.8125 86.25 95.625 71.25 95.625"
            />
            <g id="Group-11" transform="translate(70.312500, 121.875000)">
              <path
                d="M29.3486673,1.08009574 C28.9327342,1.08009574 28.5277342,1.22706383 28.2044947,1.50137234 L19.6681215,8.74445745 L30.0160616,4.52834043 C30.4994947,4.33158511 30.8712201,3.93280851 31.0356919,3.43397872 C31.2001637,2.93562766 31.139794,2.3922766 30.869794,1.94275532 C30.6002694,1.49467021 30.151537,1.18876596 29.6381567,1.10403191 C29.5416602,1.08775532 29.4446884,1.08009574 29.3486673,1.08009574 L29.3486673,1.08009574 Z M17.9939313,10.1442447 L17.657382,9.58174468 L27.7790546,0.992489362 C28.3247588,0.52956383 29.0406391,0.33137234 29.7455863,0.447702128 C30.4491074,0.564510638 31.0646884,0.98387234 31.4345123,1.59855319 C31.8048116,2.21514894 31.8879982,2.96052128 31.662206,3.6441383 C31.4364137,4.3272766 30.9268363,4.87445745 30.2637201,5.14493617 L17.9939313,10.1442447 Z"
                id="Fill-5"
                fill="#070000"
              />
              <path
                d="M19.9535229,9.57355851 L31.1095616,9.95031383 C31.6329243,9.9680266 32.1315687,9.75499468 32.4823785,9.36675 C32.8336637,8.97850532 32.9976602,8.45717553 32.9315863,7.93632447 C32.866463,7.41643085 32.5793504,6.95350532 32.1444032,6.66579255 C31.7099313,6.37855851 31.1742095,6.29669681 30.6741391,6.44270745 L19.9535229,9.57355851 Z M31.169456,10.6162181 C31.1418856,10.6162181 31.1147905,10.6157394 31.0876954,10.6147819 L17.8591215,10.168133 L17.7783116,9.51659043 L30.4901778,5.80409043 C31.1761109,5.60398404 31.9110053,5.7155266 32.5066215,6.10999468 C33.1031884,6.50446277 33.4967799,7.13972872 33.5866215,7.85206915 C33.6769384,8.56680319 33.4520968,9.28201596 32.9705651,9.81483511 C32.5070968,10.3265904 31.8549137,10.6162181 31.169456,10.6162181 L31.169456,10.6162181 Z"
                id="Fill-7"
                fill="#070000"
              />
              <polygon
                id="Fill-9"
                fill="#766DFF"
                points="0.285924296 10.5446968 0.285924296 22.0876755 4.66629401 22.0876755 6.44506162 16.9174628 11.1139701 22.0876755 25.3436356 22.0876755 25.3436356 16.2659202 18.0065757 9.77203723 16.8372095 0.790707447 0.285924296 0.790707447"
              />
            </g>
            <g id="Group-14" transform="translate(70.312500, 121.875000)">
              <mask id="mask-4" fill="white">
                <use xlink:href="#path-3" />
              </mask>
              <g id="Clip-13" />
              <polygon
                id="Fill-12"
                fill="#000000"
                mask="url(#mask-4)"
                points="-0.3680625 12.9537187 8.18240625 12.9537187 12.8595938 17.2849687 26.1149063 17.2849687 27.037875 22.7665312 -4.24134375 22.3277812"
              />
            </g>
            <g id="Group-23" transform="translate(94.687500, 92.812500)">
              <polygon
                id="Fill-15"
                fill="#000000"
                points="11.9439947 32.9759531 0.0521526316 6.90220312 13.7439947 0.384234375 25.4951526 25.5200156"
              />
              <path
                d="M38.2560158,19.0756406 C38.0547,19.0756406 37.8524368,19.1098594 37.6582263,19.1787656 C37.1703316,19.3517344 36.7847526,19.7257969 36.6004895,20.2057969 L32.6490158,30.4948594 L39.6339632,21.9284531 C39.9603316,21.5281406 40.0920158,21.0092344 39.9958579,20.5034531 C39.8997,19.9981406 39.5856474,19.5622031 39.1342263,19.3067344 C38.8632789,19.1539219 38.5605947,19.0756406 38.2560158,19.0756406 L38.2560158,19.0756406 Z M31.8636474,32.4950156 L31.2999632,32.1748594 L35.9856474,19.9742344 C36.2381211,19.3165781 36.7672263,18.8032969 37.4365421,18.5656406 C38.1053842,18.3284531 38.8433842,18.3922031 39.4605947,18.7414219 C40.0797,19.0915781 40.5102789,19.6897031 40.6424368,20.3829844 C40.7745947,21.0762656 40.5936474,21.7882969 40.1460158,22.3372031 L31.8636474,32.4950156 Z"
                id="Fill-17"
                fill="#070000"
              />
              <path
                d="M42.3843158,22.7326875 C41.9139474,22.7326875 41.4615789,22.9178438 41.1276316,23.2515938 L33.2957368,31.0675312 L43.1933684,26.0439375 C43.6556842,25.8090937 43.9891579,25.3876875 44.1085263,24.8870625 C44.2278947,24.3864375 44.1194211,23.8619063 43.8115263,23.4475313 C43.5045789,23.0340938 43.0323158,22.7753438 42.5155263,22.737375 C42.4719474,22.7345625 42.4278947,22.7326875 42.3843158,22.7326875 L42.3843158,22.7326875 Z M31.7576842,32.5801875 L31.374,32.0612812 L40.6605789,22.7931563 C41.1612632,22.293 41.8561579,22.0375313 42.5638421,22.0881563 C43.2729474,22.1401875 43.9209474,22.4950313 44.3420526,23.06175 C44.7641053,23.6303438 44.9123684,24.349875 44.7484737,25.0365938 C44.5850526,25.7228437 44.1274737,26.3012812 43.4932105,26.6233125 L31.7576842,32.5801875 Z"
                id="Fill-19"
                fill="#070000"
              />
              <polygon
                id="Fill-21"
                fill="#766DFF"
                points="16.6337526 41.3230781 22.1839105 51.2010469 25.9989632 49.1019844 25.0620158 43.8252656 31.6140158 46.0124531 44.0070158 39.1940156 41.2080158 34.2121406 31.6959632 32.1707344 26.3589632 25.0447969 11.9438053 32.9760469"
              />
            </g>
            <g id="Group-26" transform="translate(105.937500, 117.187500)">
              <mask id="mask-6" fill="white">
                <use xlink:href="#path-5" />
              </mask>
              <g id="Clip-25" />
              <polygon
                id="Fill-24"
                fill="#000000"
                mask="url(#mask-6)"
                points="5.67876563 19.8445378 13.1520469 15.6166431 19.3447031 17.1558372 30.9298594 10.6017418 34.3995469 15.019949 6.84876563 30.0966102"
              />
            </g>
            <path
              d="M25.5786642,69.1938005 C21.3663264,81.8136961 23.5536194,94.1083927 30.5204132,94.1083927 C37.487207,94.1083927 67.7660008,94.0767236 67.7660008,94.0767236 L66.0019639,120 L78.9253805,119.513147 L80.0963888,99.5687109 L83.7429744,119.022985 L118.125,103.650715 C118.125,103.650715 106.918122,82.483001 93.9937644,77.4868477 C81.0698776,72.4911671 63.0838489,78.5985746 50.6650475,71.3922025 C38.2462461,64.1858304 25.5786642,69.1938005 25.5786642,69.1938005"
              id="Fill-27"
              fill="#B7B3FF"
            />
            <g id="Group-65" transform="translate(23.437500, 67.500000)">
              <g id="Group-31">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-30" />
                <polygon
                  id="Fill-29"
                  fill="#FFFFFF"
                  mask="url(#mask-8)"
                  points="75.2684531 115.781297 74.8962656 115.383797 114.618141 21.8100469 114.990328 22.2075469"
                />
              </g>
              <g id="Group-34">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-33" />
                <polygon
                  id="Fill-32"
                  fill="#FFFFFF"
                  mask="url(#mask-10)"
                  points="13.1045156 106.684031 12.7323281 106.286531 109.173422 15.9940313 109.545141 16.3915313"
                />
              </g>
              <g id="Group-37">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-36" />
                <polygon
                  id="Fill-35"
                  fill="#FFFFFF"
                  mask="url(#mask-12)"
                  points="7.65942188 100.868156 7.28723438 100.470656 103.728328 10.1781562 104.100047 10.5756562"
                />
              </g>
              <g id="Group-40">
                <mask id="mask-14" fill="white">
                  <use xlink:href="#path-13" />
                </mask>
                <g id="Clip-39" />
                <polygon
                  id="Fill-38"
                  fill="#FFFFFF"
                  mask="url(#mask-14)"
                  points="2.2141875 95.0521406 1.842 94.6546406 98.2830938 4.36214062 98.6548125 4.75964062"
                />
              </g>
              <g id="Group-43">
                <mask id="mask-16" fill="white">
                  <use xlink:href="#path-15" />
                </mask>
                <g id="Clip-42" />
                <polygon
                  id="Fill-41"
                  fill="#FFFFFF"
                  mask="url(#mask-16)"
                  points="-3.2308125 89.2363594 -3.603 88.8388594 92.837625 -1.45364063 93.2098125 -1.05614062"
                />
              </g>
              <g id="Group-46">
                <mask id="mask-18" fill="white">
                  <use xlink:href="#path-17" />
                </mask>
                <g id="Clip-45" />
                <polygon
                  id="Fill-44"
                  fill="#FFFFFF"
                  mask="url(#mask-18)"
                  points="-8.67590625 83.4203906 -9.04809375 83.0228906 87.3925313 -7.26960938 87.7647188 -6.87210938"
                />
              </g>
              <g id="Group-49">
                <mask id="mask-20" fill="white">
                  <use xlink:href="#path-19" />
                </mask>
                <g id="Clip-48" />
                <polygon
                  id="Fill-47"
                  fill="#FFFFFF"
                  mask="url(#mask-20)"
                  points="-14.1210938 77.6046094 -14.4932813 77.2071094 81.9473438 -13.0853906 82.3195313 -12.6878906"
                />
              </g>
              <g id="Group-52">
                <mask id="mask-22" fill="white">
                  <use xlink:href="#path-21" />
                </mask>
                <g id="Clip-51" />
                <polygon
                  id="Fill-50"
                  fill="#FFFFFF"
                  mask="url(#mask-22)"
                  points="-19.5661875 71.7885938 -19.938375 71.3910937 76.5027187 -18.9014062 76.8744375 -18.5039062"
                />
              </g>
              <g id="Group-55">
                <mask id="mask-24" fill="white">
                  <use xlink:href="#path-23" />
                </mask>
                <g id="Clip-54" />
                <polygon
                  id="Fill-53"
                  fill="#FFFFFF"
                  mask="url(#mask-24)"
                  points="-25.0114219 65.9728125 -25.3836094 65.5753125 71.0574844 -24.7171875 71.4292031 -24.3196875"
                />
              </g>
              <g id="Group-58">
                <mask id="mask-26" fill="white">
                  <use xlink:href="#path-25" />
                </mask>
                <g id="Clip-57" />
                <polygon
                  id="Fill-56"
                  fill="#FFFFFF"
                  mask="url(#mask-26)"
                  points="-30.4562812 60.1569375 -30.8284687 59.7594375 65.6121563 -30.5330625 65.9843438 -30.1355625"
                />
              </g>
              <g id="Group-61">
                <mask id="mask-28" fill="white">
                  <use xlink:href="#path-27" />
                </mask>
                <g id="Clip-60" />
                <polygon
                  id="Fill-59"
                  fill="#FFFFFF"
                  mask="url(#mask-28)"
                  points="-35.9015156 54.3409219 -36.2737031 53.9434219 60.1669219 -36.3490781 60.5391094 -35.9515781"
                />
              </g>
              <g id="Group-64">
                <mask id="mask-30" fill="white">
                  <use xlink:href="#path-29" />
                </mask>
                <g id="Clip-63" />
                <polygon
                  id="Fill-62"
                  fill="#FFFFFF"
                  mask="url(#mask-30)"
                  points="-41.3466094 48.5251875 -41.7187969 48.1276875 54.7218281 -42.1648125 55.0940156 -41.7673125"
                />
              </g>
            </g>
            <g id="Group-98" transform="translate(0.000000, 17.812500)">
              <polygon
                id="Fill-66"
                fill="#4C3BE3"
                points="52.040625 51.5805899 121.264219 51.5805899 121.264219 48.2795225 52.040625 48.2795225"
              />
              <polygon
                id="Fill-68"
                fill="#B7B3FF"
                points="65.2393125 39.2369691 117.352594 39.2369691 129.309 2.89229213 77.1957188 2.89229213"
              />
              <polygon
                id="Fill-69"
                fill="#3424C7"
                points="65.2393125 39.2369691 117.352594 39.2369691 118.914469 34.284427 66.8016562 34.284427"
              />
              <polygon
                id="Fill-70"
                fill="#4C3BE3"
                points="106.272469 48.4311194 89.5666875 48.4311194 86.6979375 39.2369691 103.403719 39.2369691"
              />
              <polygon
                id="Fill-71"
                fill="#070000"
                points="75.8573438 48.7580267 103.234219 48.7580267 103.234219 48.1044944 75.8573438 48.1044944"
              />
              <path
                d="M50.2266094,17.0699909 C71.5772344,23.0082423 57.6047344,53.3723223 55.2900469,63.1014375 C39.2480156,58.9703982 31.1095781,56.7067956 16.8084844,52.3560302 C17.9658281,44.8048855 34.1269219,12.5921889 50.2266094,17.0699909"
                id="Fill-72"
                fill="#4C3BE3"
              />
              <path
                d="M72.2829375,123.308936 L71.6318438,123.308936 C71.6318438,121.058037 70.0390313,119.08803 67.8448125,118.624112 L45.4104375,113.883297 L45.4104375,80.5747928 L46.0610625,80.5747928 L46.0610625,113.353037 L67.978875,117.984695 C70.4730938,118.511661 72.2829375,120.750797 72.2829375,123.308936"
                id="Fill-73"
                fill="#070000"
              />
              <polygon
                id="Fill-74"
                fill="#070000"
                points="45.4101563 118.685513 46.06125 118.685513 46.06125 113.618167 45.4101563 113.618167"
              />
              <path
                d="M64.3812188,122.710782 C64.3812188,121.241393 65.567625,120.050544 67.0315313,120.050544 C68.4954375,120.050544 69.6818438,121.241393 69.6818438,122.710782 C69.6818438,124.180171 68.4954375,125.371021 67.0315313,125.371021 C65.567625,125.371021 64.3812188,124.180171 64.3812188,122.710782"
                id="Fill-75"
                fill="#070000"
              />
              <path
                d="M19.8393281,123.308936 L19.1882344,123.308936 C19.1882344,120.750797 20.9980781,118.511661 23.4918281,117.984695 L45.4101094,113.353037 L45.4101094,80.5747928 L46.0612031,80.5747928 L46.0612031,113.883297 L23.6263594,118.624112 C21.4321406,119.08803 19.8393281,121.058508 19.8393281,123.308936"
                id="Fill-76"
                fill="#070000"
              />
              <path
                d="M27.0900938,122.710782 C27.0900938,121.241393 25.9036875,120.050544 24.4397813,120.050544 C22.975875,120.050544 21.7894688,121.241393 21.7894688,122.710782 C21.7894688,124.180171 22.975875,125.371021 24.4397813,125.371021 C25.9036875,125.371021 27.0900938,124.180171 27.0900938,122.710782"
                id="Fill-77"
                fill="#070000"
              />
              <path
                d="M43.0853906,122.710782 C43.0853906,121.241393 44.2717969,120.050544 45.7357031,120.050544 C47.1996094,120.050544 48.3860156,121.241393 48.3860156,122.710782 C48.3860156,124.180171 47.1996094,125.371021 45.7357031,125.371021 C44.2717969,125.371021 43.0853906,124.180171 43.0853906,122.710782"
                id="Fill-78"
                fill="#070000"
              />
              <polygon
                id="Fill-79"
                fill="#3424C7"
                points="6.03234375 73.1782093 33.1992188 73.1782093 33.1992188 49.6397542 6.03234375 49.6397542"
              />
              <polygon
                id="Fill-80"
                fill="#766DFF"
                points="0.44203125 73.1782093 27.6089063 73.1782093 27.6089063 49.6397542 0.44203125 49.6397542"
              />
              <polygon
                id="Fill-81"
                fill="#3424C7"
                points="23.7632813 84.4407022 67.708125 84.4407022 67.708125 76.7093539 23.7632813 76.7093539"
              />
              <polygon
                id="Fill-82"
                fill="#766DFF"
                points="19.6157813 84.4407022 38.28375 84.4407022 38.28375 76.7093539 19.6157813 76.7093539"
              />
              <path
                d="M29.3173594,81.1775576 L23.4092344,81.1775576 C18.0556406,81.1775576 13.7000156,76.8056194 13.7000156,71.4315042 L13.7000156,62.5248329 L14.3511094,62.5248329 L14.3511094,71.4315042 C14.3511094,76.4452121 18.4147031,80.5240253 23.4092344,80.5240253 L29.3173594,80.5240253 L29.3173594,81.1775576 Z"
                id="Fill-83"
                fill="#070000"
              />
              <path
                d="M46.3583906,31.486236 C40.8697969,28.305618 47.3826094,15.3361306 55.5201094,20.2369171 C63.6580781,25.1377037 75.4560469,33.1080688 79.3251094,35.3500281 C83.1941719,37.5924579 98.8846406,40.1101334 105.107766,41.3099228 C111.084328,42.462191 106.072453,48.0913202 100.739953,48.3326896 C100.739953,48.3326896 84.9829219,48.5227739 75.1091719,48.110611 C65.2358906,47.698448 51.5329219,34.4847683 46.3583906,31.486236"
                id="Fill-84"
                fill="#070000"
              />
              <path
                d="M105.107906,41.3098757 C109.315406,41.3282254 113.66025,42.091856 113.249156,43.3231692 C112.838063,44.5544824 104.708531,43.7325091 104.708531,43.7325091 L105.107906,41.3098757 Z"
                id="Fill-85"
                fill="#070000"
              />
              <path
                d="M104.254266,43.4656383 C108.326297,43.5079838 112.534734,44.2951397 112.143797,45.5231594 C111.752859,46.7507086 103.880672,45.8840372 103.880672,45.8840372 L104.254266,43.4656383 Z"
                id="Fill-86"
                fill="#070000"
              />
              <path
                d="M103.723031,45.5030688 C107.309906,45.6493961 111.5385,46.651573 111.112406,47.8626545 C110.685844,49.0742065 99.3899063,48.2461166 99.3899063,48.2461166 L103.723031,45.5030688 Z"
                id="Fill-87"
                fill="#070000"
              />
              <path
                d="M61.6969219,8.41033497 C61.6969219,12.0191131 58.7822344,14.944717 55.1869219,14.944717 C51.5916094,14.944717 48.6769219,12.0191131 48.6769219,8.41033497 C48.6769219,4.80155688 51.5916094,1.87595295 55.1869219,1.87595295 C58.7822344,1.87595295 61.6969219,4.80155688 61.6969219,8.41033497"
                id="Fill-88"
                fill="#000000"
              />
              <path
                d="M35.002875,12.2010105 C39.2033438,11.1456664 40.1108438,9.25564537 40.1108438,9.25564537 L34.9911563,9.99857374 L35.599125,6.41237992 C40.9011563,6.13572261 45.709125,0.524472612 52.7305313,0.428489466 C53.8283438,0.324507725 54.9167813,0.37438132 55.9311563,0.612927669 L55.931625,0.612927669 L55.931625,0.613398174 C57.870375,1.06931812 59.8635,2.54294171 60.8164688,4.6023448 C60.8164688,4.6023448 60.4320938,7.23058919 57.5361563,10.2677029 C55.9049063,12.4753153 45.1836563,22.163026 45.1836563,22.163026 C45.1836563,22.163026 44.9150625,17.6010035 41.0919375,15.6592268 C37.2683438,13.7179206 35.002875,12.2010105 35.002875,12.2010105"
                id="Fill-89"
                fill="#FF3D81"
              />
              <path
                d="M56.6459531,12.0950997 C56.0811094,12.2249593 55.4787656,11.6965815 55.3006406,10.9146011 C55.1220469,10.1330913 55.4351719,9.39439747 55.9995469,9.26406742 C56.5643906,9.13420787 57.1667344,9.66305618 57.3448594,10.444566 C57.5234531,11.2260758 57.2103281,11.9652402 56.6459531,12.0950997"
                id="Fill-90"
                fill="#FFD4E3"
              />
              <path
                d="M53.5782656,9.51719944 C53.5782656,7.81867416 54.9498281,6.44197472 56.6420156,6.44197472 C58.3337344,6.44197472 59.7057656,7.81867416 59.7057656,9.51719944 C59.7057656,11.2152542 58.3337344,12.5924242 56.6420156,12.5924242 C54.9498281,12.5924242 53.5782656,11.2152542 53.5782656,9.51719944"
                id="Fill-91"
                fill="#FF3D81"
              />
              <path
                d="M58.0884844,7.11517416 C58.0884844,3.58544101 57.5489531,1.54815169 56.5378594,0.98825 C55.5262969,0.427877809 53.1131719,0.161571629 52.7306719,0.383650281 C52.7306719,0.383650281 55.3195781,0.563383427 56.1075469,2.6378427 C56.7070781,4.21544803 56.1877031,6.9933132 56.1877031,6.9933132 L58.0884844,7.11517416 Z"
                id="Fill-92"
                fill="#FF3D81"
              />
              <path
                d="M54.6655313,9.47297191 C54.6111563,8.02946067 55.732875,6.81461517 57.171,6.75956601 C58.6095938,6.70498736 59.8199063,7.8309073 59.8742813,9.27488904 C59.9286563,10.7184003 58.8069375,11.9332458 57.3683438,11.9878244 C55.9302188,12.0428736 54.7199063,10.9164831 54.6655313,9.47297191"
                id="Fill-93"
                fill="#FF3D81"
              />
              <path
                d="M57.271125,7.08473244 C57.2420625,7.08473244 57.2125313,7.08520295 57.1834688,7.08661447 C56.5745625,7.10966924 56.011125,7.36938834 55.5972188,7.8177802 C55.1833125,8.26617205 54.9676875,8.84959902 54.9906563,9.46078581 C55.0140938,10.0715021 55.2728438,10.6370499 55.7195625,11.0529768 C56.1662813,11.4684333 56.746125,11.6848659 57.3564375,11.6618111 C58.6131562,11.6138195 59.5965937,10.5485948 59.5487812,9.28716924 C59.502375,8.05538553 58.4889375,7.08473244 57.271125,7.08473244 M57.2687813,12.3167549 C55.7026875,12.3167549 54.4000313,11.0694445 54.3405,9.48525211 C54.3105,8.69997823 54.5875313,7.94999228 55.1195625,7.37362289 C55.6520625,6.79678301 56.3762813,6.46319452 57.158625,6.43355267 C58.7809687,6.36815239 60.138,7.64087008 60.1994062,9.26223244 C60.2603437,10.8835948 58.996125,12.2527662 57.3808125,12.3144024 C57.3433125,12.3162844 57.3058125,12.3167549 57.2687813,12.3167549"
                id="Fill-94"
                fill="#FFFFFF"
              />
              <path
                d="M58.4035313,6.89897683 L57.7529063,6.87356952 C57.9300938,2.31389958 57.277125,1.30842907 55.839,0.881209972 C55.2047813,0.69347823 53.3860313,0.693948736 52.7386875,0.710416433 L52.72275,0.0568841292 C52.8216563,0.0545316011 55.1616563,-0.000988061798 56.0232188,0.254966994 C58.0224375,0.848274579 58.578375,2.40047261 58.4035313,6.89897683"
                id="Fill-95"
                fill="#FFFFFF"
              />
              <path
                d="M93.3786094,30.6023996 C100.095797,30.6221053 107.060016,25.363264 108.934547,18.8566419 C110.808609,12.3500197 106.882828,7.05918399 100.165641,7.03936457 C93.4489219,7.01919101 86.4842344,12.2780323 84.6097031,18.785125 C82.7356406,25.2917472 86.6614219,30.5825829 93.3786094,30.6023996"
                id="Fill-96"
                fill="#FFFFFF"
              />
              <path
                d="M93.5634375,23.8633862 C93.4148438,23.6290744 93.403125,23.3406545 93.5278125,22.9971854 C93.6520313,22.6537163 93.8723438,22.3676489 94.18875,22.1385126 C94.5051563,21.9098469 94.8445313,21.7950435 95.2078125,21.7950435 C95.5598438,21.7950435 95.8115625,21.9098469 95.9620313,22.1385126 C96.1120313,22.3676489 96.1246875,22.6537163 96.0004688,22.9971854 C95.8757813,23.3406545 95.6545313,23.6290744 95.33625,23.8633862 C95.0179688,24.097698 94.6828125,24.2148539 94.3303125,24.2148539 C93.9670313,24.2148539 93.7115625,24.097698 93.5634375,23.8633862 M95.5753125,19.0868132 C95.9634375,18.7174663 96.48,18.314243 97.1259375,17.8771433 C97.62,17.5440253 98.0020313,17.2551348 98.2720312,17.0104719 C98.5420313,16.7662795 98.7342188,16.4877402 98.8471875,16.1753244 C99.005625,15.7382247 98.9573438,15.384875 98.7032813,15.1138638 C98.44875,14.843323 98.0264063,14.7082879 97.4353125,14.7082879 C96.3159375,14.7082879 95.325,15.1086882 94.464375,15.9099593 L93.3126563,14.9266025 C93.9810938,14.3125927 94.726875,13.8416166 95.5509375,13.5136742 C96.375,13.1862022 97.26375,13.0219958 98.2176563,13.0219958 C99.37875,13.0219958 100.212656,13.2746573 100.719375,13.7795098 C101.225625,14.2843624 101.318438,14.9788287 100.997812,15.8633792 C100.843125,16.2901278 100.637344,16.6646503 100.38,16.9869466 C100.123125,17.310184 99.8554688,17.5830772 99.5775,17.8065674 C99.2995313,18.0305281 98.9465625,18.2883652 98.52,18.5796081 C97.9973438,18.9334284 97.5914063,19.2453736 97.3017188,19.5159143 C97.0115625,19.7869256 96.79875,20.1092219 96.6628125,20.4837444 L94.6879688,20.4837444 C94.8914063,19.9219607 95.1871875,19.4561601 95.5753125,19.0868132"
                id="Fill-97"
                fill="#3424C7"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END no_result.svg -->

  <!-- END check_validation.svg (Illustration MDP perdu.svg) -->
  <svg
    v-else-if="name == 'check_validation'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="417px"
    height="439px"
    viewBox="0 0 417 439"
    version="1.1"
  >
    <title>{{ label }}</title>
    <defs>
      <polygon
        id="path-1"
        points="0.938795412 0.143 408.373 0.143 408.373 437.026758 0.938795412 437.026758"
      />
      <polygon
        id="path-3"
        points="0.707 0.475 0.707 27.157 0.707 58.73 12.774 58.73 17.673 44.589 30.536 58.73 69.736 58.73 69.736 42.806 49.523 25.044 46.302 0.475"
      />
      <polygon
        id="path-5"
        points="0.723 22.245 13.687 45.564 29.03 73.16 39.577 67.295 36.987 52.555 55.101 58.664 89.361 39.617 81.623 25.698 55.326 19.995 40.574 0.089"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-7"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-9"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-11"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-13"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-15"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-17"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-19"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-21"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-23"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-25"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-27"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-29"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-31"
      />
      <path
        d="M6.173,5.471 C-5.557,40.433 0.533,74.496 19.933,74.496 L19.933,74.496 C39.331,74.496 123.643,74.407 123.643,74.407 L123.643,74.407 L118.731,146.226 L154.715,144.876 L157.977,89.622 L168.13,143.518 L263.866,100.931 C263.866,100.931 232.661,42.287 196.674,28.447 L196.674,28.447 C180.309,22.154 161.03,22.221 141.62,22.288 L141.62,22.288 C118.345,22.368 94.88,22.448 76.025,11.561 L76.025,11.561 C61.557,3.208 46.965,0.778 34.889,0.778 L34.889,0.778 C18.101,0.778 6.173,5.471 6.173,5.471 L6.173,5.471 Z"
        id="path-33"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Connexion---Mot-de-passe-perdu"
        transform="translate(-48.000000, -293.000000)"
      >
        <g
          id="Illustration-MDP-perdu"
          transform="translate(48.000000, 293.000000)"
        >
          <g id="Group-3" transform="translate(8.000000, 0.857000)">
            <mask id="mask-2" fill="white">
              <use xlink:href="#path-1" />
            </mask>
            <g id="Clip-2" />
            <path
              d="M39.6674,114.6826 C109.4674,-30.0174 436.6274,-93.5794 406.4074,269.9186 C395.7844,397.6906 265.6824,479.3986 168.8934,413.9096 C83.7714,356.3156 -71.6116,345.3706 39.6674,114.6826"
              id="Fill-1"
              fill="#E7E6FF"
              mask="url(#mask-2)"
            />
          </g>
          <polygon
            id="Fill-4"
            fill="#000000"
            points="196.706 343.332 238.882 343.332 238.882 267.381 196.706 267.381"
          />
          <g id="Group-11" transform="translate(196.000000, 341.857000)">
            <path
              d="M80.769,2.2666 C79.623,2.2666 78.507,2.6686 77.617,3.4186 L54.102,23.2326 L82.607,11.7006 C83.939,11.1616 84.962,10.0706 85.416,8.7056 C85.87,7.3426 85.703,5.8566 84.959,4.6266 C84.217,3.4016 82.98,2.5646 81.566,2.3316 C81.3,2.2876 81.034,2.2666 80.769,2.2666 L80.769,2.2666 Z M49.488,27.0606 L48.561,25.5216 L76.445,2.0276 C77.948,0.7616 79.92,0.2186 81.862,0.5376 C83.8,0.8566 85.497,2.0036 86.515,3.6856 C87.535,5.3706 87.764,7.4106 87.142,9.2806 C86.52,11.1496 85.116,12.6466 83.289,13.3856 L49.488,27.0606 Z"
              id="Fill-5"
              fill="#070000"
            />
            <path
              d="M54.8866,25.5 L85.6186,26.53 C87.0606,26.579 88.4346,25.997 89.4026,24.935 C90.3696,23.873 90.8206,22.446 90.6386,21.021 C90.4586,19.599 89.6686,18.333 88.4706,17.546 C87.2736,16.76 85.7976,16.536 84.4206,16.937 L54.8866,25.5 Z M85.7846,28.352 C85.7086,28.352 85.6336,28.35 85.5586,28.348 L49.1166,27.126 L48.8936,25.345 L83.9136,15.189 C85.8036,14.642 87.8266,14.947 89.4686,16.026 C91.1116,17.104 92.1956,18.842 92.4436,20.791 C92.6916,22.746 92.0736,24.702 90.7456,26.159 C89.4696,27.561 87.6726,28.352 85.7846,28.352 L85.7846,28.352 Z"
              id="Fill-7"
              fill="#070000"
            />
            <polygon
              id="Fill-9"
              fill="#766DFF"
              points="0.7065 28.1563 0.7065 59.7303 12.7735 59.7303 17.6735 45.5893 30.5365 59.7303 69.7355 59.7303 69.7355 43.8053 49.5225 26.0443 46.3025 1.4753 0.7065 1.4753"
            />
          </g>
          <g id="Group-14" transform="translate(196.000000, 342.857000)">
            <mask id="mask-4" fill="white">
              <use xlink:href="#path-3" />
            </mask>
            <g id="Clip-13" />
            <polygon
              id="Fill-12"
              fill="#000000"
              mask="url(#mask-4)"
              points="-1.1095 35.8096 22.7775 35.8096 35.8445 47.9106 72.8735 47.9106 75.4515 63.2216 -11.9295 61.9966"
            />
          </g>
          <g id="Group-23" transform="translate(262.000000, 260.857000)">
            <polygon
              id="Fill-15"
              fill="#000000"
              points="33.7226 91.2451 0.8476 18.4061 38.6986 0.1971 71.1856 70.4161"
            />
            <path
              d="M106.4623,52.4131 C105.9053,52.4131 105.3473,52.5091 104.8103,52.7011 C103.4613,53.1841 102.3953,54.2301 101.8863,55.5691 L90.9623,84.3131 L110.2723,60.3821 C111.1733,59.2651 111.5383,57.8141 111.2723,56.4021 C111.0053,54.9901 110.1373,53.7711 108.8903,53.0591 C108.1413,52.6311 107.3043,52.4131 106.4623,52.4131 L106.4623,52.4131 Z M88.7903,89.9011 L87.2333,89.0071 L100.1863,54.9231 C100.8843,53.0861 102.3463,51.6521 104.1963,50.9891 C106.0463,50.3261 108.0863,50.5051 109.7923,51.4791 C111.5033,52.4581 112.6943,54.1291 113.0593,56.0651 C113.4243,58.0021 112.9243,59.9911 111.6873,61.5241 L88.7903,89.9011 Z"
              id="Fill-17"
              fill="#070000"
            />
            <path
              d="M117.8749,62.6299 C116.5739,62.6299 115.3249,63.1469 114.4009,64.0789 L92.7499,85.9139 L120.1109,71.8799 C121.3889,71.2249 122.3119,70.0459 122.6409,68.6479 C122.9709,67.2489 122.6719,65.7829 121.8209,64.6259 C120.9729,63.4719 119.6669,62.7479 118.2379,62.6429 C118.1169,62.6339 117.9959,62.6299 117.8749,62.6299 L117.8749,62.6299 Z M88.4979,90.1399 L87.4369,88.6909 L113.1089,62.7979 C114.4939,61.4009 116.4149,60.6879 118.3719,60.8289 C120.3309,60.9749 122.1229,61.9649 123.2869,63.5489 C124.4539,65.1369 124.8639,67.1479 124.4109,69.0659 C123.9589,70.9839 122.6939,72.5989 120.9409,73.4989 L88.4979,90.1399 Z"
              id="Fill-19"
              fill="#070000"
            />
            <polygon
              id="Fill-21"
              fill="#766DFF"
              points="46.6874 114.5635 62.0304 142.1595 72.5774 136.2945 69.9874 121.5545 88.1014 127.6645 122.3614 108.6165 114.6234 94.6985 88.3264 88.9955 73.5734 69.0885 33.7224 91.2455"
            />
          </g>
          <g id="Group-26" transform="translate(295.000000, 329.857000)">
            <mask id="mask-6" fill="white">
              <use xlink:href="#path-5" />
            </mask>
            <g id="Clip-25" />
            <polygon
              id="Fill-24"
              fill="#000000"
              mask="url(#mask-6)"
              points="16.3051 54.0088 37.1821 42.4018 54.4821 46.6278 86.8461 28.6338 96.5401 40.7638 19.5741 82.1548"
            />
          </g>
          <path
            d="M71.1727,196.3277 C59.4437,231.2907 65.5337,265.3517 84.9327,265.3517 C104.3307,265.3517 188.6427,265.2647 188.6427,265.2647 L183.7307,337.0827 L219.7147,335.7327 L222.9767,280.4787 L233.1307,334.3757 L328.8667,291.7887 C328.8667,291.7887 297.6607,233.1437 261.6737,219.3047 C225.6867,205.4637 175.6057,222.3837 141.0257,202.4187 C106.4447,182.4537 71.1727,196.3277 71.1727,196.3277"
            id="Fill-27"
            fill="#B7B3FF"
          />
          <g id="Group-71" transform="translate(65.000000, 190.857000)">
            <g id="Group-31">
              <mask id="mask-8" fill="white">
                <use xlink:href="#path-7" />
              </mask>
              <g id="Clip-30" />
              <polygon
                id="Fill-29"
                fill="#FFFFFF"
                mask="url(#mask-8)"
                points="51.789 314 50.749 312.89 320.166 60.648 321.206 61.759"
              />
            </g>
            <g id="Group-34">
              <mask id="mask-10" fill="white">
                <use xlink:href="#path-9" />
              </mask>
              <g id="Clip-33" />
              <polygon
                id="Fill-32"
                fill="#FFFFFF"
                mask="url(#mask-10)"
                points="36.5775 297.752 35.5375 296.642 304.9555 44.4 305.9945 45.511"
              />
            </g>
            <g id="Group-37">
              <mask id="mask-12" fill="white">
                <use xlink:href="#path-11" />
              </mask>
              <g id="Clip-36" />
              <polygon
                id="Fill-35"
                fill="#FFFFFF"
                mask="url(#mask-12)"
                points="21.3661 281.5049 20.3261 280.3949 289.7431 28.1529 290.7831 29.2639"
              />
            </g>
            <g id="Group-40">
              <mask id="mask-14" fill="white">
                <use xlink:href="#path-13" />
              </mask>
              <g id="Clip-39" />
              <polygon
                id="Fill-38"
                fill="#FFFFFF"
                mask="url(#mask-14)"
                points="6.1542 265.2578 5.1142 264.1478 274.5322 11.9058 275.5712 13.0168"
              />
            </g>
            <g id="Group-43">
              <mask id="mask-16" fill="white">
                <use xlink:href="#path-15" />
              </mask>
              <g id="Clip-42" />
              <polygon
                id="Fill-41"
                fill="#FFFFFF"
                mask="url(#mask-16)"
                points="-9.0567 249.0108 -10.0967 247.9008 259.3203 -4.3412 260.3603 -3.2302"
              />
            </g>
            <g id="Group-46">
              <mask id="mask-18" fill="white">
                <use xlink:href="#path-17" />
              </mask>
              <g id="Clip-45" />
              <polygon
                id="Fill-44"
                fill="#FFFFFF"
                mask="url(#mask-18)"
                points="-24.2682 232.7627 -25.3082 231.6527 244.1088 -20.5883 245.1488 -19.4773"
              />
            </g>
            <g id="Group-49">
              <mask id="mask-20" fill="white">
                <use xlink:href="#path-19" />
              </mask>
              <g id="Clip-48" />
              <polygon
                id="Fill-47"
                fill="#FFFFFF"
                mask="url(#mask-20)"
                points="-39.4796 216.5157 -40.5196 215.4057 228.8974 -36.8363 229.9374 -35.7253"
              />
            </g>
            <g id="Group-52">
              <mask id="mask-22" fill="white">
                <use xlink:href="#path-21" />
              </mask>
              <g id="Clip-51" />
              <polygon
                id="Fill-50"
                fill="#FFFFFF"
                mask="url(#mask-22)"
                points="-54.6915 200.2686 -55.7315 199.1586 213.6865 -53.0834 214.7255 -51.9724"
              />
            </g>
            <g id="Group-55">
              <mask id="mask-24" fill="white">
                <use xlink:href="#path-23" />
              </mask>
              <g id="Clip-54" />
              <polygon
                id="Fill-53"
                fill="#FFFFFF"
                mask="url(#mask-24)"
                points="-69.9029 184.0215 -70.9429 182.9115 198.4741 -69.3305 199.5141 -68.2195"
              />
            </g>
            <g id="Group-58">
              <mask id="mask-26" fill="white">
                <use xlink:href="#path-25" />
              </mask>
              <g id="Clip-57" />
              <polygon
                id="Fill-56"
                fill="#FFFFFF"
                mask="url(#mask-26)"
                points="-85.1139 167.7744 -86.1539 166.6644 183.2631 -85.5776 184.3031 -84.4666"
              />
            </g>
            <g id="Group-61">
              <mask id="mask-28" fill="white">
                <use xlink:href="#path-27" />
              </mask>
              <g id="Clip-60" />
              <polygon
                id="Fill-59"
                fill="#FFFFFF"
                mask="url(#mask-28)"
                points="-100.3258 151.5264 -101.3658 150.4164 168.0512 -101.8246 169.0912 -100.7136"
              />
            </g>
            <g id="Group-64">
              <mask id="mask-30" fill="white">
                <use xlink:href="#path-29" />
              </mask>
              <g id="Clip-63" />
              <polygon
                id="Fill-62"
                fill="#FFFFFF"
                mask="url(#mask-30)"
                points="-115.5372 135.2803 -116.5772 134.1693 152.8398 -118.0727 153.8798 -116.9617"
              />
            </g>
            <g id="Group-67">
              <mask id="mask-32" fill="white">
                <use xlink:href="#path-31" />
              </mask>
              <g id="Clip-66" />
              <polygon
                id="Fill-65"
                fill="#FFFFFF"
                mask="url(#mask-32)"
                points="-130.7486 119.0323 -131.7886 117.9223 137.6284 -134.3197 138.6684 -133.2087"
              />
            </g>
            <g id="Group-70">
              <mask id="mask-34" fill="white">
                <use xlink:href="#path-33" />
              </mask>
              <g id="Clip-69" />
              <polygon
                id="Fill-68"
                fill="#FFFFFF"
                mask="url(#mask-34)"
                points="-145.9606 102.7852 -147.0006 101.6752 122.4174 -150.5668 123.4564 -149.4558"
              />
            </g>
          </g>
          <g id="Group-108" transform="translate(0.000000, 51.857000)">
            <polygon
              id="Fill-72"
              fill="#4C3BE3"
              points="144.876 143.471 338.258 143.471 338.258 134.283 144.876 134.283"
            />
            <polygon
              id="Fill-74"
              fill="#B7B3FF"
              points="181.7465 109.1162 327.3295 109.1162 360.7315 7.9622 215.1485 7.9622"
            />
            <polygon
              id="Fill-75"
              fill="#3424C7"
              points="181.7465 109.1162 327.3295 109.1162 331.6935 95.3322 186.1105 95.3322"
            />
            <polygon
              id="Fill-76"
              fill="#4C3BE3"
              points="296.3769 134.7051 249.7079 134.7051 241.6939 109.1161 288.3629 109.1161"
            />
            <polygon
              id="Fill-77"
              fill="#070000"
              points="211.41 135.614 287.889 135.614 287.889 133.796 211.41 133.796"
            />
            <path
              d="M139.807,47.4219 C199.453,63.9479 160.418,148.4569 153.952,175.5349 C109.137,164.0379 86.401,157.7369 46.45,145.6279 C49.683,124.6129 94.83,34.9589 139.807,47.4219"
              id="Fill-78"
              fill="#4C3BE3"
            />
            <path
              d="M201.4237,343.1035 L199.6047,343.1035 C199.6047,336.8385 195.1547,331.3555 189.0257,330.0645 L126.3517,316.8705 L126.3517,224.1655 L128.1707,224.1655 L128.1707,315.3945 L189.3997,328.2855 C196.3667,329.7515 201.4237,335.9845 201.4237,343.1035"
              id="Fill-79"
              fill="#070000"
            />
            <polygon
              id="Fill-80"
              fill="#070000"
              points="126.352 330.235 128.17 330.235 128.17 316.131 126.352 316.131"
            />
            <path
              d="M179.3495,341.4385 C179.3495,337.3495 182.6645,334.0355 186.7535,334.0355 C190.8425,334.0355 194.1575,337.3495 194.1575,341.4385 C194.1575,345.5275 190.8425,348.8425 186.7535,348.8425 C182.6645,348.8425 179.3495,345.5275 179.3495,341.4385"
              id="Fill-81"
              fill="#070000"
            />
            <path
              d="M54.9169,343.1035 L53.0979,343.1035 C53.0979,335.9845 58.1549,329.7515 65.1219,328.2855 L126.3519,315.3945 L126.3519,224.1655 L128.1699,224.1655 L128.1699,316.8705 L65.4959,330.0645 C59.3659,331.3555 54.9169,336.8395 54.9169,343.1035"
              id="Fill-82"
              fill="#070000"
            />
            <path
              d="M75.1727,341.4385 C75.1727,337.3495 71.8577,334.0355 67.7687,334.0355 C63.6797,334.0355 60.3647,337.3495 60.3647,341.4385 C60.3647,345.5275 63.6797,348.8425 67.7687,348.8425 C71.8577,348.8425 75.1727,345.5275 75.1727,341.4385"
              id="Fill-83"
              fill="#070000"
            />
            <path
              d="M119.8573,341.4385 C119.8573,337.3495 123.1713,334.0355 127.2613,334.0355 C131.3503,334.0355 134.6653,337.3495 134.6653,341.4385 C134.6653,345.5275 131.3503,348.8425 127.2613,348.8425 C123.1713,348.8425 119.8573,345.5275 119.8573,341.4385"
              id="Fill-84"
              fill="#070000"
            />
            <polygon
              id="Fill-85"
              fill="#3424C7"
              points="16.346 203.581 92.24 203.581 92.24 138.069 16.346 138.069"
            />
            <polygon
              id="Fill-86"
              fill="#766DFF"
              points="0.728 203.581 76.622 203.581 76.622 138.069 0.728 138.069"
            />
            <polygon
              id="Fill-87"
              fill="#3424C7"
              points="65.879 234.926 188.643 234.926 188.643 213.407 65.879 213.407"
            />
            <polygon
              id="Fill-88"
              fill="#766DFF"
              points="54.292 234.926 106.443 234.926 106.443 213.407 54.292 213.407"
            />
            <path
              d="M81.3949,225.8448 L64.8909,225.8448 C49.9339,225.8448 37.7659,213.6758 37.7659,198.7188 L37.7659,173.9298 L39.5839,173.9298 L39.5839,198.7188 C39.5839,212.6728 50.9369,224.0258 64.8909,224.0258 L81.3949,224.0258 L81.3949,225.8448 Z"
              id="Fill-89"
              fill="#070000"
            />
            <path
              d="M129.0009,87.545 C113.6679,78.692 131.8619,42.596 154.5949,56.235 C177.3289,69.876 210.2879,92.059 221.0969,98.299 C231.9059,104.539 275.7379,111.546 293.1239,114.886 C309.8189,118.093 295.8169,133.76 280.9219,134.431 C280.9219,134.431 236.9019,134.961 209.3199,133.814 C181.7369,132.666 143.4569,95.891 129.0009,87.545"
              id="Fill-90"
              fill="#070000"
            />
            <path
              d="M293.1234,114.8858 C304.8774,114.9368 317.0144,117.0628 315.8664,120.4888 C314.7184,123.9148 292.0074,121.6288 292.0074,121.6288 L293.1234,114.8858 Z"
              id="Fill-91"
              fill="#070000"
            />
            <path
              d="M290.7387,120.8858 C302.1137,121.0028 313.8717,123.1948 312.7787,126.6118 C311.6867,130.0278 289.6957,127.6158 289.6957,127.6158 L290.7387,120.8858 Z"
              id="Fill-92"
              fill="#070000"
            />
            <path
              d="M289.2548,126.5557 C299.2748,126.9627 311.0878,129.7517 309.8978,133.1227 C308.7058,136.4937 277.1488,134.1907 277.1488,134.1907 L289.2548,126.5557 Z"
              id="Fill-93"
              fill="#070000"
            />
            <path
              d="M171.8505,23.3203 C171.8505,33.3643 163.7075,41.5073 153.6635,41.5073 C143.6195,41.5073 135.4765,33.3643 135.4765,23.3203 C135.4765,13.2763 143.6195,5.1333 153.6635,5.1333 C163.7075,5.1333 171.8505,13.2763 171.8505,23.3203"
              id="Fill-94"
              fill="#000000"
            />
            <path
              d="M97.2782,33.8701 C109.0112,30.9331 111.5482,25.6741 111.5482,25.6741 L97.2452,27.7411 L98.9442,17.7601 C113.7552,16.9891 127.1862,1.3721 146.8022,1.1041 C149.8692,0.8161 152.9092,0.9551 155.7432,1.6191 L155.7442,1.6191 C161.1612,2.8891 166.7292,6.9901 169.3912,12.7231 C169.3912,12.7231 168.3172,20.0361 160.2272,28.4901 C155.6702,34.6341 125.7182,61.5971 125.7182,61.5971 C125.7182,61.5971 124.9692,48.8991 114.2882,43.4951 C103.6062,38.0921 97.2782,33.8701 97.2782,33.8701"
              id="Fill-95"
              fill="#FF3D81"
            />
            <path
              d="M157.7396,33.5752 C156.1626,33.9362 154.4796,32.4672 153.9816,30.2912 C153.4826,28.1152 154.3566,26.0582 155.9346,25.6972 C157.5116,25.3352 159.1946,26.8052 159.6936,28.9812 C160.1916,31.1572 159.3176,33.2142 157.7396,33.5752"
              id="Fill-96"
              fill="#FFD4E3"
            />
            <path
              d="M149.1703,26.4004 C149.1703,21.6734 153.0023,17.8414 157.7293,17.8414 C162.4553,17.8414 166.2873,21.6734 166.2873,26.4004 C166.2873,31.1274 162.4553,34.9594 157.7293,34.9594 C153.0023,34.9594 149.1703,31.1274 149.1703,26.4004"
              id="Fill-97"
              fill="#FF3D81"
            />
            <path
              d="M161.7699,19.7159 C161.7699,9.8919 160.2629,4.2219 157.4379,2.6629 C154.6119,1.1039 147.8709,0.3629 146.8019,0.9809 C146.8019,0.9809 154.0339,1.4819 156.2359,7.2549 C157.9109,11.6459 156.4599,19.3769 156.4599,19.3769 L161.7699,19.7159 Z"
              id="Fill-98"
              fill="#FF3D81"
            />
            <path
              d="M152.2074,26.2774 C152.0554,22.2594 155.1894,18.8794 159.2074,18.7264 C163.2254,18.5744 166.6064,21.7084 166.7584,25.7264 C166.9104,29.7444 163.7764,33.1254 159.7584,33.2774 C155.7404,33.4294 152.3594,30.2964 152.2074,26.2774"
              id="Fill-99"
              fill="#FF3D81"
            />
            <path
              d="M159.4862,19.6309 C159.4052,19.6309 159.3232,19.6329 159.2412,19.6359 C157.5412,19.6999 155.9672,20.4229 154.8102,21.6709 C153.6532,22.9189 153.0522,24.5429 153.1162,26.2429 C153.1812,27.9439 153.9032,29.5179 155.1522,30.6749 C156.4002,31.8309 158.0202,32.4339 159.7242,32.3689 C163.2352,32.2349 165.9832,29.2709 165.8502,25.7609 C165.7192,22.3319 162.8882,19.6309 159.4862,19.6309 M159.4792,34.1929 C155.1052,34.1929 151.4652,30.7199 151.2992,26.3129 C151.2162,24.1259 151.9892,22.0389 153.4762,20.4349 C154.9632,18.8299 156.9862,17.9019 159.1732,17.8189 C163.7042,17.6369 167.4952,21.1789 167.6672,25.6919 C167.8382,30.2039 164.3062,34.0149 159.7932,34.1869 C159.6882,34.1909 159.5832,34.1929 159.4792,34.1929"
              id="Fill-100"
              fill="#FFFFFF"
            />
            <path
              d="M162.6503,19.1143 L160.8333,19.0433 C161.3273,6.3533 159.5033,3.5533 155.4853,2.3663 C153.7143,1.8433 148.6333,1.8433 146.8243,1.8893 L146.7793,0.0713 C147.0563,0.0653 153.5943,-0.0897 156.0013,0.6223 C161.5853,2.2733 163.1383,6.5933 162.6503,19.1143"
              id="Fill-101"
              fill="#FFFFFF"
            />
            <path
              d="M303.1049,70.2539946 C314.8189,70.2879 326.9649,61.1509 330.2329,49.8469 C333.5019,38.5409 326.6559,29.3489 314.9409,29.3147998 C303.2279,29.2799 291.0819,38.4169 287.8129,49.7219 C284.5439,61.0269 291.3909,70.2199 303.1049,70.2539946"
              id="Fill-102"
              fill="#3424C7"
            />
            <polygon
              id="Fill-103"
              fill="#FFFFFF"
              points="303.5292 60.2461 296.3112 50.9891 298.0732 49.6161 303.9412 57.1421 322.9612 42.8341 324.3042 44.6181"
            />
            <path
              d="M233.6381,69.3702002 C245.3521,69.4051 257.4981,60.2681 260.7661,48.9631 C264.0351,37.6581 257.1881,28.4661 245.4741,28.431994 C233.7601,28.3961 221.6141,37.5331 218.3461,48.8391 C215.0771,60.1431 221.9241,69.3361 233.6381,69.3702002"
              id="Fill-104"
              fill="#FFFFFF"
            />
            <polygon
              id="Fill-105"
              fill="#3424C7"
              points="238.7509 55.7061 236.6049 55.0861 242.4539 34.8571 244.5989 35.4771"
            />
            <polygon
              id="Fill-106"
              fill="#3424C7"
              points="237.852 59.2852 235.258 59.2782 234.534 61.7812 237.128 61.7892"
            />
            <polygon
              id="Fill-107"
              fill="#3424C7"
              points="271.3612 43.4727 268.4192 56.3297 278.2262 50.4707"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END check_validation.svg -->

  <!-- BEGIN fiche_de_poste.svg -->
  <svg
    v-else-if="name == 'fiche_de_poste'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="209px"
    height="235px"
    viewBox="0 0 209 235"
    version="1.1"
  >
    <title>{{ label }}</title>
    <defs>
      <path
        d="M0.00858741259,3.17318182 L0.560671329,14.0522727 L32.1407273,14.2145911 C34.4046993,14.2268182 35.5787692,11.76 34.0366434,10.2422727 L34.0366434,10.2422727 C30.5158601,6.78409091 24.2674685,2.05227273 15.1331189,0.178636364 L15.1331189,0.178636364 C14.7436643,0.0995454545 14.2885874,0.0627272727 13.7807273,0.0627272727 L13.7807273,0.0627272727 C9.07303497,0.0640909091 0.00858741259,3.17318182 0.00858741259,3.17318182"
        id="path-1"
      />
      <path
        d="M0.00858741259,3.17318182 L0.560671329,14.0522727 L32.1407273,14.2145911 C34.4046993,14.2268182 35.5787692,11.76 34.0366434,10.2422727 L34.0366434,10.2422727 C30.5158601,6.78409091 24.2674685,2.05227273 15.1331189,0.178636364 L15.1331189,0.178636364 C14.7436643,0.0995454545 14.2885874,0.0627272727 13.7807273,0.0627272727 L13.7807273,0.0627272727 C9.07303497,0.0640909091 0.00858741259,3.17318182 0.00858741259,3.17318182 L0.00858741259,3.17318182 Z"
        id="path-3"
      />
      <path
        d="M20.78496,0.459377778 C11.55744,2.36515556 5.22144,7.26613333 1.6488,10.8558222 L1.6488,10.8558222 C0.08352,12.4288 1.25424,15.0072889 3.53808,15.0072889 L3.53808,15.0072889 L35.41824,15.0072889 L35.4312,3.66506667 C35.4312,3.66506667 26.72496,0.3456 22.08096,0.3456 L22.08096,0.3456 C21.60144,0.3456 21.16512,0.381155556 20.78496,0.459377778"
        id="path-5"
      />
      <path
        d="M20.78496,0.459377778 C11.55744,2.36515556 5.22144,7.26613333 1.6488,10.8558222 L1.6488,10.8558222 C0.08352,12.4288 1.25424,15.0072889 3.53808,15.0072889 L3.53808,15.0072889 L35.41824,15.0072889 L35.4312,3.66506667 C35.4312,3.66506667 26.72496,0.3456 22.08096,0.3456 L22.08096,0.3456 C21.60144,0.3456 21.16512,0.381155556 20.78496,0.459377778 L20.78496,0.459377778 Z"
        id="path-7"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-9"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-11"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-13"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-15"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-17"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-19"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-21"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-23"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-25"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-27"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-29"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-31"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-33"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-35"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-37"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-39"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-41"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-43"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-45"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-47"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-49"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-51"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-53"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-55"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-57"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-59"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-61"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-63"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-65"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-67"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-69"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-71"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-73"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-75"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-77"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-79"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-81"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-83"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-85"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-87"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-89"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-91"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-93"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-95"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-97"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-99"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-101"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-103"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-105"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-107"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-109"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-111"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-113"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-115"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-117"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-119"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-121"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-123"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-125"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-127"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-129"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-131"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-133"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-135"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-137"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-139"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-141"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-143"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-145"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-147"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-149"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-151"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-153"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-155"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-157"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-159"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-161"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-163"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-165"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-167"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-169"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-171"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-173"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-175"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-177"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-179"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-181"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-183"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-185"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-187"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-189"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-191"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-193"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-195"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-197"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-199"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-201"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-203"
      />
      <path
        d="M0.104045977,127.236527 L39.9451034,128.208989 L50.4052874,35.1886484 L83.288092,46.4853626 L74.5867126,80.6887912 L112.252782,91.529044 C112.252782,91.529044 125.781609,51.9458901 122.648828,38.2421209 L122.648828,38.2421209 C117.817103,17.1088022 67.3377011,10.3157473 67.3377011,10.3157473 L67.3377011,10.3157473 L51.1478621,6.53363736 L25.4328276,0.528758242"
        id="path-205"
      />
      <polygon
        id="path-207"
        points="0 0.763612903 7.15661497 0.763612903 7.15661497 8.37845161 0 8.37845161"
      />
      <path
        d="M3.98285714,2.28461538 C0.138571429,5.48169231 -0.304285714,11.0935385 2.99571429,14.8195385 L2.99571429,14.8195385 C6.29285714,18.5441538 12.0828571,18.972 15.9257143,15.7763077 L15.9257143,15.7763077 C19.77,12.5792308 20.2114286,6.96876923 16.9128571,3.24276923 L16.9128571,3.24276923 C15.1,1.19353846 12.5328571,0.142615385 9.95,0.142615385 L9.95,0.142615385 C7.83571429,0.142615385 5.71285714,0.846 3.98285714,2.28461538 L3.98285714,2.28461538 Z"
        id="path-209"
      />
      <polygon
        id="path-211"
        points="0.458041653 0.845948963 38.2677518 0.845948963 38.2677518 61.6681022 0.458041653 61.6681022"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Fiche-de-poste-/-Personnelle-1"
        transform="translate(-1094.000000, -147.000000)"
      >
        <g
          id="Illustration-FIche-de-poste"
          transform="translate(1094.000000, 147.000000)"
        >
          <polygon
            id="Fill-1"
            fill="#E7E6FF"
            points="114 235 177 235 177 186 114 186"
          />
          <polygon
            id="Fill-2"
            fill="#766DFF"
            points="140 186 140 199.385696 140 200.692848 140 202 141.500234 200.692848 143.000469 202 144.500703 200.692848 146.000937 202 147.499766 200.692848 149 202 149 200.692848 149 199.385696 149 186"
          />
          <polygon
            id="Fill-3"
            fill="#766DFF"
            points="150 136 147.457531 174.725111 135 176 136.299547 140.662289"
          />
          <path
            d="M150.243338,173.122627 C159.449439,175.108583 165.746913,180.124061 169.293915,183.790997 C170.849593,185.398263 169.6663,188.01296 167.384544,188 L135.556421,187.827951 L135,176.298133 C135,176.298133 146.207491,172.252507 150.243338,173.122627"
            id="Fill-4"
            fill="#FF3D81"
          />
          <g id="Group-12" transform="translate(135.000000, 173.000000)">
            <g id="Group-8">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1" />
              </mask>
              <g id="Clip-7" />
              <path
                d="M8.91967832,-2.27454545 L22.1283217,0.921818182 C22.1054965,4.95681818 10.7884895,9.135 0.0292727273,6.05318182 C-10.7299441,2.97136364 8.91967832,-2.27454545 8.91967832,-2.27454545"
                id="Fill-6"
                fill="#766DFF"
                mask="url(#mask-2)"
              />
            </g>
            <g id="Group-11">
              <mask id="mask-4" fill="white">
                <use xlink:href="#path-3" />
              </mask>
              <g id="Clip-10" />
              <polygon
                id="Fill-9"
                fill="#070000"
                mask="url(#mask-4)"
                points="36.7330098 10.7825455 36.7030517 16.1293636 -6.7246965 15.9057273 -6.69473846 10.5589091"
              />
            </g>
          </g>
          <g id="Group-19" transform="translate(60.000000, 174.000000)">
            <path
              d="M102.503286,4.88189024 C103.636143,3.41264634 104.670429,2.56937805 105.524714,2.18515854 C106.096143,1.92757317 106.587571,1.87432927 106.976143,1.97937805 C107.610429,2.14918293 107.886143,2.70896341 107.871857,3.1565 C107.853286,3.77096341 107.373286,4.21706098 106.556143,4.38254878 C105.106143,4.67610976 103.754714,4.82576829 102.503286,4.88189024 M90.9875714,5.98993902 L92.4675714,6.17269512 C92.4961429,5.93669512 92.5661429,5.8820122 92.589,5.86330488 C92.9518571,5.57837805 94.2904286,5.7640122 95.7104286,5.95396341 C96.8118571,6.10362195 98.1561429,6.28493902 99.7118571,6.36552439 C99.4532857,6.80442683 99.1904286,7.27642683 98.9247143,7.78152439 L100.240429,8.48520732 C100.646143,7.71389024 101.047571,7.02315854 101.440429,6.40581707 C103.069,6.39718293 104.883286,6.25328049 106.850429,5.85467073 C107.167571,5.78991463 107.449,5.6992561 107.699,5.5870122 C108.871857,5.05889024 109.336143,4.06164634 109.361857,3.20254878 C109.399,1.95203659 108.574714,0.852621951 107.357571,0.527402439 C106.323286,0.25254878 103.810429,0.251109756 100.639,4.90059756 C98.8118571,4.85886585 97.2347143,4.64589024 95.9075714,4.4660122 C93.8747143,4.19259756 92.5332857,4.00984146 91.6775714,4.67610976 C91.289,4.97830488 91.0561429,5.42008537 90.9875714,5.98993902"
              id="Fill-13"
              fill="#070000"
            />
            <polygon
              id="Fill-15"
              fill="#766DFF"
              points="35.0891429 48.3794244 23.1862857 45.1603268 19.2762857 12.5534732 35.7505714 27.9769366"
            />
            <path
              d="M20.6212857,43.2767878 C11.4641429,45.2036415 5.17985714,50.1639585 1.63557143,53.7946171 C0.0827142857,55.386178 1.24414286,57.9965683 3.50985714,57.9965683 L35.137,57.9965683 L35.1484286,46.5203488 C35.1484286,46.5203488 24.637,42.4320805 20.6212857,43.2767878"
              id="Fill-17"
              fill="#FF3D81"
            />
          </g>
          <g id="Group-26" transform="translate(60.000000, 217.000000)">
            <g id="Group-22">
              <mask id="mask-6" fill="white">
                <use xlink:href="#path-5" />
              </mask>
              <g id="Clip-21" />
              <path
                d="M35.999856,6.66865778 C25.120656,9.82456889 13.721616,5.40572444 13.721616,1.19736889 L27.073296,-2.06520889 C27.073296,-2.06520889 46.877616,3.51132444 35.999856,6.66865778"
                id="Fill-20"
                fill="#766DFF"
                mask="url(#mask-6)"
              />
            </g>
            <g id="Group-25">
              <mask id="mask-8" fill="white">
                <use xlink:href="#path-7" />
              </mask>
              <g id="Clip-24" />
              <polygon
                id="Fill-23"
                fill="#070000"
                mask="url(#mask-8)"
                points="38.623248 16.4957867 -1.076112 16.9807644 -1.076112 11.4028089 38.623248 10.9192533"
              />
            </g>
          </g>
          <g id="Group-31" transform="translate(56.000000, 73.000000)">
            <path
              d="M8.40962299,147.630408 C8.51794483,147.007075 9.10801379,146.261908 10.1484736,146.098992 C12.3833241,145.754742 14.5583126,148.106408 16.0306345,150.227158 C13.9468644,150.390075 11.539554,150.119492 8.94553103,148.721242 C8.39822069,148.425158 8.35118621,147.964742 8.40962299,147.630408 M6.94442759,147.379658 C6.75486437,148.476158 7.25086437,149.487658 8.23716322,150.020325 C11.4697149,151.764242 14.4670943,151.927158 16.9271402,151.618325 C17.2293011,152.121242 17.4687494,152.558992 17.6326575,152.870658 L18.9510483,152.184992 C18.7985425,151.895992 18.6474621,151.619742 18.4963816,151.351992 C19.3244736,151.177742 20.0684736,150.973742 20.7098529,150.795242 C21.4581287,150.588408 22.4757839,150.306492 22.7708184,150.385825 C22.7779448,150.405658 22.783646,150.436825 22.7907724,150.484992 L24.2673701,150.312158 C24.2060828,149.795075 23.9894391,149.408325 23.6231402,149.164658 C22.8734391,148.663158 21.8543586,148.945075 20.3121977,149.371492 C19.5439678,149.583992 18.6631402,149.827658 17.6882437,150.006158 C14.3929793,144.856575 11.4668644,144.398992 9.91615172,144.639825 C8.40534713,144.876408 7.18245057,146.002658 6.94442759,147.379658"
              id="Fill-27"
              fill="#070000"
            />
            <path
              d="M25.4322575,0.527991667 L51.1487172,6.53040833 L67.337131,10.310075 C67.337131,10.310075 117.816533,17.097325 122.649683,38.2184083 C125.782464,51.9119083 112.252211,91.4694917 112.252211,91.4694917 L74.5861425,80.6362417 L83.2875218,46.4549083 L50.4061425,35.164075 L39.9445333,128.125742 L0.103475862,127.153908 L25.4322575,0.527991667 Z"
              id="Fill-29"
              fill="#E7E6FF"
            />
          </g>
          <g id="Group-329" transform="translate(56.000000, 73.000000)">
            <g id="Group-34">
              <mask id="mask-10" fill="white">
                <use xlink:href="#path-9" />
              </mask>
              <g id="Clip-33" />
              <path
                d="M97.6445839,110.678598 C98.9415954,110.678598 99.9934575,111.724774 99.9934575,113.014774 C99.9934575,114.304774 98.9415954,115.350949 97.6445839,115.350949 C96.3475724,115.350949 95.2957103,114.304774 95.2957103,113.014774 C95.2957103,111.724774 96.3475724,110.678598 97.6445839,110.678598"
                id="Fill-32"
                fill="#BBB3FF"
                mask="url(#mask-10)"
              />
            </g>
            <g id="Group-37">
              <mask id="mask-12" fill="white">
                <use xlink:href="#path-11" />
              </mask>
              <g id="Clip-36" />
              <path
                d="M83.2872368,110.678598 C84.5842483,110.678598 85.6361103,111.724774 85.6361103,113.014774 C85.6361103,114.304774 84.5842483,115.350949 83.2872368,115.350949 C81.9888,115.350949 80.9383632,114.304774 80.9383632,113.014774 C80.9383632,111.724774 81.9888,110.678598 83.2872368,110.678598"
                id="Fill-35"
                fill="#BBB3FF"
                mask="url(#mask-12)"
              />
            </g>
            <g id="Group-40">
              <mask id="mask-14" fill="white">
                <use xlink:href="#path-13" />
              </mask>
              <g id="Clip-39" />
              <path
                d="M68.9293195,110.678598 C70.226331,110.678598 71.2781931,111.724774 71.2781931,113.014774 C71.2781931,114.304774 70.226331,115.350949 68.9293195,115.350949 C67.632308,115.350949 66.580446,114.304774 66.580446,113.014774 C66.580446,111.724774 67.632308,110.678598 68.9293195,110.678598"
                id="Fill-38"
                fill="#BBB3FF"
                mask="url(#mask-14)"
              />
            </g>
            <g id="Group-43">
              <mask id="mask-16" fill="white">
                <use xlink:href="#path-15" />
              </mask>
              <g id="Clip-42" />
              <path
                d="M54.5714023,110.678598 C55.8698391,110.678598 56.9202759,111.724774 56.9202759,113.014774 C56.9202759,114.304774 55.8698391,115.350949 54.5714023,115.350949 C53.2743908,115.350949 52.2225287,114.304774 52.2225287,113.014774 C52.2225287,111.724774 53.2743908,110.678598 54.5714023,110.678598"
                id="Fill-41"
                fill="#BBB3FF"
                mask="url(#mask-16)"
              />
            </g>
            <g id="Group-46">
              <mask id="mask-18" fill="white">
                <use xlink:href="#path-17" />
              </mask>
              <g id="Clip-45" />
              <path
                d="M40.2140552,110.678598 C41.5110667,110.678598 42.5629287,111.724774 42.5629287,113.014774 C42.5629287,114.304774 41.5110667,115.350949 40.2140552,115.350949 C38.9170437,115.350949 37.8651816,114.304774 37.8651816,113.014774 C37.8651816,111.724774 38.9170437,110.678598 40.2140552,110.678598"
                id="Fill-44"
                fill="#BBB3FF"
                mask="url(#mask-18)"
              />
            </g>
            <g id="Group-49">
              <mask id="mask-20" fill="white">
                <use xlink:href="#path-19" />
              </mask>
              <g id="Clip-48" />
              <path
                d="M25.8561379,110.678598 C27.1531494,110.678598 28.2050115,111.724774 28.2050115,113.014774 C28.2050115,114.304774 27.1531494,115.350949 25.8561379,115.350949 C24.5591264,115.350949 23.5072644,114.304774 23.5072644,113.014774 C23.5072644,111.724774 24.5591264,110.678598 25.8561379,110.678598"
                id="Fill-47"
                fill="#BBB3FF"
                mask="url(#mask-20)"
              />
            </g>
            <g id="Group-52">
              <mask id="mask-22" fill="white">
                <use xlink:href="#path-21" />
              </mask>
              <g id="Clip-51" />
              <path
                d="M11.4987908,110.678598 C12.7958023,110.678598 13.8476644,111.724774 13.8476644,113.014774 C13.8476644,114.304774 12.7958023,115.350949 11.4987908,115.350949 C10.200354,115.350949 9.14991724,114.304774 9.14991724,113.014774 C9.14991724,111.724774 10.200354,110.678598 11.4987908,110.678598"
                id="Fill-50"
                fill="#BBB3FF"
                mask="url(#mask-22)"
              />
            </g>
            <g id="Group-55">
              <mask id="mask-24" fill="white">
                <use xlink:href="#path-23" />
              </mask>
              <g id="Clip-54" />
              <path
                d="M97.6445839,96.905367 C98.9415954,96.905367 99.9934575,97.9515429 99.9934575,99.2415429 C99.9934575,100.531543 98.9415954,101.577719 97.6445839,101.577719 C96.3475724,101.577719 95.2957103,100.531543 95.2957103,99.2415429 C95.2957103,97.9515429 96.3475724,96.905367 97.6445839,96.905367"
                id="Fill-53"
                fill="#BBB3FF"
                mask="url(#mask-24)"
              />
            </g>
            <g id="Group-58">
              <mask id="mask-26" fill="white">
                <use xlink:href="#path-25" />
              </mask>
              <g id="Clip-57" />
              <path
                d="M83.2872368,96.905367 C84.5842483,96.905367 85.6361103,97.9515429 85.6361103,99.2415429 C85.6361103,100.531543 84.5842483,101.577719 83.2872368,101.577719 C81.9888,101.577719 80.9383632,100.531543 80.9383632,99.2415429 C80.9383632,97.9515429 81.9888,96.905367 83.2872368,96.905367"
                id="Fill-56"
                fill="#BBB3FF"
                mask="url(#mask-26)"
              />
            </g>
            <g id="Group-61">
              <mask id="mask-28" fill="white">
                <use xlink:href="#path-27" />
              </mask>
              <g id="Clip-60" />
              <path
                d="M68.9293195,96.905367 C70.226331,96.905367 71.2781931,97.9515429 71.2781931,99.2415429 C71.2781931,100.531543 70.226331,101.577719 68.9293195,101.577719 C67.632308,101.577719 66.580446,100.531543 66.580446,99.2415429 C66.580446,97.9515429 67.632308,96.905367 68.9293195,96.905367"
                id="Fill-59"
                fill="#BBB3FF"
                mask="url(#mask-28)"
              />
            </g>
            <g id="Group-64">
              <mask id="mask-30" fill="white">
                <use xlink:href="#path-29" />
              </mask>
              <g id="Clip-63" />
              <path
                d="M54.5714023,96.905367 C55.8698391,96.905367 56.9202759,97.9515429 56.9202759,99.2415429 C56.9202759,100.531543 55.8698391,101.577719 54.5714023,101.577719 C53.2743908,101.577719 52.2225287,100.531543 52.2225287,99.2415429 C52.2225287,97.9515429 53.2743908,96.905367 54.5714023,96.905367"
                id="Fill-62"
                fill="#BBB3FF"
                mask="url(#mask-30)"
              />
            </g>
            <g id="Group-67">
              <mask id="mask-32" fill="white">
                <use xlink:href="#path-31" />
              </mask>
              <g id="Clip-66" />
              <path
                d="M40.2140552,96.905367 C41.5110667,96.905367 42.5629287,97.9515429 42.5629287,99.2415429 C42.5629287,100.531543 41.5110667,101.577719 40.2140552,101.577719 C38.9170437,101.577719 37.8651816,100.531543 37.8651816,99.2415429 C37.8651816,97.9515429 38.9170437,96.905367 40.2140552,96.905367"
                id="Fill-65"
                fill="#BBB3FF"
                mask="url(#mask-32)"
              />
            </g>
            <g id="Group-70">
              <mask id="mask-34" fill="white">
                <use xlink:href="#path-33" />
              </mask>
              <g id="Clip-69" />
              <path
                d="M25.8561379,96.905367 C27.1531494,96.905367 28.2050115,97.9515429 28.2050115,99.2415429 C28.2050115,100.531543 27.1531494,101.577719 25.8561379,101.577719 C24.5591264,101.577719 23.5072644,100.531543 23.5072644,99.2415429 C23.5072644,97.9515429 24.5591264,96.905367 25.8561379,96.905367"
                id="Fill-68"
                fill="#BBB3FF"
                mask="url(#mask-34)"
              />
            </g>
            <g id="Group-73">
              <mask id="mask-36" fill="white">
                <use xlink:href="#path-35" />
              </mask>
              <g id="Clip-72" />
              <path
                d="M11.4987908,96.905367 C12.7958023,96.905367 13.8476644,97.9515429 13.8476644,99.2415429 C13.8476644,100.531543 12.7958023,101.577719 11.4987908,101.577719 C10.200354,101.577719 9.14991724,100.531543 9.14991724,99.2415429 C9.14991724,97.9515429 10.200354,96.905367 11.4987908,96.905367"
                id="Fill-71"
                fill="#BBB3FF"
                mask="url(#mask-36)"
              />
            </g>
            <g id="Group-76">
              <mask id="mask-38" fill="white">
                <use xlink:href="#path-37" />
              </mask>
              <g id="Clip-75" />
              <path
                d="M97.6445839,83.1319945 C98.9415954,83.1319945 99.9934575,84.1781703 99.9934575,85.4681703 C99.9934575,86.7581703 98.9415954,87.8043462 97.6445839,87.8043462 C96.3475724,87.8043462 95.2957103,86.7581703 95.2957103,85.4681703 C95.2957103,84.1781703 96.3475724,83.1319945 97.6445839,83.1319945"
                id="Fill-74"
                fill="#BBB3FF"
                mask="url(#mask-38)"
              />
            </g>
            <g id="Group-79">
              <mask id="mask-40" fill="white">
                <use xlink:href="#path-39" />
              </mask>
              <g id="Clip-78" />
              <path
                d="M83.2872368,83.1319945 C84.5842483,83.1319945 85.6361103,84.1781703 85.6361103,85.4681703 C85.6361103,86.7581703 84.5842483,87.8043462 83.2872368,87.8043462 C81.9888,87.8043462 80.9383632,86.7581703 80.9383632,85.4681703 C80.9383632,84.1781703 81.9888,83.1319945 83.2872368,83.1319945"
                id="Fill-77"
                fill="#BBB3FF"
                mask="url(#mask-40)"
              />
            </g>
            <g id="Group-82">
              <mask id="mask-42" fill="white">
                <use xlink:href="#path-41" />
              </mask>
              <g id="Clip-81" />
              <path
                d="M68.9293195,83.1319945 C70.226331,83.1319945 71.2781931,84.1781703 71.2781931,85.4681703 C71.2781931,86.7581703 70.226331,87.8043462 68.9293195,87.8043462 C67.632308,87.8043462 66.580446,86.7581703 66.580446,85.4681703 C66.580446,84.1781703 67.632308,83.1319945 68.9293195,83.1319945"
                id="Fill-80"
                fill="#BBB3FF"
                mask="url(#mask-42)"
              />
            </g>
            <g id="Group-85">
              <mask id="mask-44" fill="white">
                <use xlink:href="#path-43" />
              </mask>
              <g id="Clip-84" />
              <path
                d="M97.6445839,69.358622 C98.9415954,69.358622 99.9934575,70.4047978 99.9934575,71.6947978 C99.9934575,72.9847978 98.9415954,74.0309736 97.6445839,74.0309736 C96.3475724,74.0309736 95.2957103,72.9847978 95.2957103,71.6947978 C95.2957103,70.4047978 96.3475724,69.358622 97.6445839,69.358622"
                id="Fill-83"
                fill="#BBB3FF"
                mask="url(#mask-44)"
              />
            </g>
            <g id="Group-88">
              <mask id="mask-46" fill="white">
                <use xlink:href="#path-45" />
              </mask>
              <g id="Clip-87" />
              <path
                d="M83.2872368,69.358622 C84.5842483,69.358622 85.6361103,70.4047978 85.6361103,71.6947978 C85.6361103,72.9847978 84.5842483,74.0309736 83.2872368,74.0309736 C81.9888,74.0309736 80.9383632,72.9847978 80.9383632,71.6947978 C80.9383632,70.4047978 81.9888,69.358622 83.2872368,69.358622"
                id="Fill-86"
                fill="#BBB3FF"
                mask="url(#mask-46)"
              />
            </g>
            <g id="Group-91">
              <mask id="mask-48" fill="white">
                <use xlink:href="#path-47" />
              </mask>
              <g id="Clip-90" />
              <path
                d="M68.9293195,69.358622 C70.226331,69.358622 71.2781931,70.4047978 71.2781931,71.6947978 C71.2781931,72.9847978 70.226331,74.0309736 68.9293195,74.0309736 C67.632308,74.0309736 66.580446,72.9847978 66.580446,71.6947978 C66.580446,70.4047978 67.632308,69.358622 68.9293195,69.358622"
                id="Fill-89"
                fill="#BBB3FF"
                mask="url(#mask-48)"
              />
            </g>
            <g id="Group-94">
              <mask id="mask-50" fill="white">
                <use xlink:href="#path-49" />
              </mask>
              <g id="Clip-93" />
              <path
                d="M97.6445839,55.5853912 C98.9415954,55.5853912 99.9934575,56.631567 99.9934575,57.921567 C99.9934575,59.211567 98.9415954,60.2577429 97.6445839,60.2577429 C96.3475724,60.2577429 95.2957103,59.211567 95.2957103,57.921567 C95.2957103,56.631567 96.3475724,55.5853912 97.6445839,55.5853912"
                id="Fill-92"
                fill="#BBB3FF"
                mask="url(#mask-50)"
              />
            </g>
            <g id="Group-97">
              <mask id="mask-52" fill="white">
                <use xlink:href="#path-51" />
              </mask>
              <g id="Clip-96" />
              <path
                d="M83.2872368,55.5853912 C84.5842483,55.5853912 85.6361103,56.631567 85.6361103,57.921567 C85.6361103,59.211567 84.5842483,60.2577429 83.2872368,60.2577429 C81.9888,60.2577429 80.9383632,59.211567 80.9383632,57.921567 C80.9383632,56.631567 81.9888,55.5853912 83.2872368,55.5853912"
                id="Fill-95"
                fill="#BBB3FF"
                mask="url(#mask-52)"
              />
            </g>
            <g id="Group-100">
              <mask id="mask-54" fill="white">
                <use xlink:href="#path-53" />
              </mask>
              <g id="Clip-99" />
              <path
                d="M68.9293195,55.5853912 C70.226331,55.5853912 71.2781931,56.631567 71.2781931,57.921567 C71.2781931,59.211567 70.226331,60.2577429 68.9293195,60.2577429 C67.632308,60.2577429 66.580446,59.211567 66.580446,57.921567 C66.580446,56.631567 67.632308,55.5853912 68.9293195,55.5853912"
                id="Fill-98"
                fill="#BBB3FF"
                mask="url(#mask-54)"
              />
            </g>
            <g id="Group-103">
              <mask id="mask-56" fill="white">
                <use xlink:href="#path-55" />
              </mask>
              <g id="Clip-102" />
              <path
                d="M97.6445839,41.8120187 C98.9415954,41.8120187 99.9934575,42.8581945 99.9934575,44.1481945 C99.9934575,45.4381945 98.9415954,46.4843703 97.6445839,46.4843703 C96.3475724,46.4843703 95.2957103,45.4381945 95.2957103,44.1481945 C95.2957103,42.8581945 96.3475724,41.8120187 97.6445839,41.8120187"
                id="Fill-101"
                fill="#BBB3FF"
                mask="url(#mask-56)"
              />
            </g>
            <g id="Group-106">
              <mask id="mask-58" fill="white">
                <use xlink:href="#path-57" />
              </mask>
              <g id="Clip-105" />
              <path
                d="M83.2872368,41.8120187 C84.5842483,41.8120187 85.6361103,42.8581945 85.6361103,44.1481945 C85.6361103,45.4381945 84.5842483,46.4843703 83.2872368,46.4843703 C81.9888,46.4843703 80.9383632,45.4381945 80.9383632,44.1481945 C80.9383632,42.8581945 81.9888,41.8120187 83.2872368,41.8120187"
                id="Fill-104"
                fill="#BBB3FF"
                mask="url(#mask-58)"
              />
            </g>
            <g id="Group-109">
              <mask id="mask-60" fill="white">
                <use xlink:href="#path-59" />
              </mask>
              <g id="Clip-108" />
              <path
                d="M68.9293195,41.8120187 C70.226331,41.8120187 71.2781931,42.8581945 71.2781931,44.1481945 C71.2781931,45.4381945 70.226331,46.4843703 68.9293195,46.4843703 C67.632308,46.4843703 66.580446,45.4381945 66.580446,44.1481945 C66.580446,42.8581945 67.632308,41.8120187 68.9293195,41.8120187"
                id="Fill-107"
                fill="#BBB3FF"
                mask="url(#mask-60)"
              />
            </g>
            <g id="Group-112">
              <mask id="mask-62" fill="white">
                <use xlink:href="#path-61" />
              </mask>
              <g id="Clip-111" />
              <path
                d="M54.5714023,83.1319945 C55.8698391,83.1319945 56.9202759,84.1781703 56.9202759,85.4681703 C56.9202759,86.7581703 55.8698391,87.8043462 54.5714023,87.8043462 C53.2743908,87.8043462 52.2225287,86.7581703 52.2225287,85.4681703 C52.2225287,84.1781703 53.2743908,83.1319945 54.5714023,83.1319945"
                id="Fill-110"
                fill="#BBB3FF"
                mask="url(#mask-62)"
              />
            </g>
            <g id="Group-115">
              <mask id="mask-64" fill="white">
                <use xlink:href="#path-63" />
              </mask>
              <g id="Clip-114" />
              <path
                d="M40.2140552,83.1319945 C41.5110667,83.1319945 42.5629287,84.1781703 42.5629287,85.4681703 C42.5629287,86.7581703 41.5110667,87.8043462 40.2140552,87.8043462 C38.9170437,87.8043462 37.8651816,86.7581703 37.8651816,85.4681703 C37.8651816,84.1781703 38.9170437,83.1319945 40.2140552,83.1319945"
                id="Fill-113"
                fill="#BBB3FF"
                mask="url(#mask-64)"
              />
            </g>
            <g id="Group-118">
              <mask id="mask-66" fill="white">
                <use xlink:href="#path-65" />
              </mask>
              <g id="Clip-117" />
              <path
                d="M25.8561379,83.1319945 C27.1531494,83.1319945 28.2050115,84.1781703 28.2050115,85.4681703 C28.2050115,86.7581703 27.1531494,87.8043462 25.8561379,87.8043462 C24.5591264,87.8043462 23.5072644,86.7581703 23.5072644,85.4681703 C23.5072644,84.1781703 24.5591264,83.1319945 25.8561379,83.1319945"
                id="Fill-116"
                fill="#BBB3FF"
                mask="url(#mask-66)"
              />
            </g>
            <g id="Group-121">
              <mask id="mask-68" fill="white">
                <use xlink:href="#path-67" />
              </mask>
              <g id="Clip-120" />
              <path
                d="M11.4987908,83.1319945 C12.7958023,83.1319945 13.8476644,84.1781703 13.8476644,85.4681703 C13.8476644,86.7581703 12.7958023,87.8043462 11.4987908,87.8043462 C10.200354,87.8043462 9.14991724,86.7581703 9.14991724,85.4681703 C9.14991724,84.1781703 10.200354,83.1319945 11.4987908,83.1319945"
                id="Fill-119"
                fill="#BBB3FF"
                mask="url(#mask-68)"
              />
            </g>
            <g id="Group-124">
              <mask id="mask-70" fill="white">
                <use xlink:href="#path-69" />
              </mask>
              <g id="Clip-123" />
              <path
                d="M54.5714023,69.358622 C55.8698391,69.358622 56.9202759,70.4047978 56.9202759,71.6947978 C56.9202759,72.9847978 55.8698391,74.0309736 54.5714023,74.0309736 C53.2743908,74.0309736 52.2225287,72.9847978 52.2225287,71.6947978 C52.2225287,70.4047978 53.2743908,69.358622 54.5714023,69.358622"
                id="Fill-122"
                fill="#BBB3FF"
                mask="url(#mask-70)"
              />
            </g>
            <g id="Group-127">
              <mask id="mask-72" fill="white">
                <use xlink:href="#path-71" />
              </mask>
              <g id="Clip-126" />
              <path
                d="M40.2140552,69.358622 C41.5110667,69.358622 42.5629287,70.4047978 42.5629287,71.6947978 C42.5629287,72.9847978 41.5110667,74.0309736 40.2140552,74.0309736 C38.9170437,74.0309736 37.8651816,72.9847978 37.8651816,71.6947978 C37.8651816,70.4047978 38.9170437,69.358622 40.2140552,69.358622"
                id="Fill-125"
                fill="#BBB3FF"
                mask="url(#mask-72)"
              />
            </g>
            <g id="Group-130">
              <mask id="mask-74" fill="white">
                <use xlink:href="#path-73" />
              </mask>
              <g id="Clip-129" />
              <path
                d="M25.8561379,69.358622 C27.1531494,69.358622 28.2050115,70.4047978 28.2050115,71.6947978 C28.2050115,72.9847978 27.1531494,74.0309736 25.8561379,74.0309736 C24.5591264,74.0309736 23.5072644,72.9847978 23.5072644,71.6947978 C23.5072644,70.4047978 24.5591264,69.358622 25.8561379,69.358622"
                id="Fill-128"
                fill="#BBB3FF"
                mask="url(#mask-74)"
              />
            </g>
            <g id="Group-133">
              <mask id="mask-76" fill="white">
                <use xlink:href="#path-75" />
              </mask>
              <g id="Clip-132" />
              <path
                d="M11.4987908,69.358622 C12.7958023,69.358622 13.8476644,70.4047978 13.8476644,71.6947978 C13.8476644,72.9847978 12.7958023,74.0309736 11.4987908,74.0309736 C10.200354,74.0309736 9.14991724,72.9847978 9.14991724,71.6947978 C9.14991724,70.4047978 10.200354,69.358622 11.4987908,69.358622"
                id="Fill-131"
                fill="#BBB3FF"
                mask="url(#mask-76)"
              />
            </g>
            <g id="Group-136">
              <mask id="mask-78" fill="white">
                <use xlink:href="#path-77" />
              </mask>
              <g id="Clip-135" />
              <path
                d="M54.5714023,55.5853912 C55.8698391,55.5853912 56.9202759,56.631567 56.9202759,57.921567 C56.9202759,59.211567 55.8698391,60.2577429 54.5714023,60.2577429 C53.2743908,60.2577429 52.2225287,59.211567 52.2225287,57.921567 C52.2225287,56.631567 53.2743908,55.5853912 54.5714023,55.5853912"
                id="Fill-134"
                fill="#BBB3FF"
                mask="url(#mask-78)"
              />
            </g>
            <g id="Group-139">
              <mask id="mask-80" fill="white">
                <use xlink:href="#path-79" />
              </mask>
              <g id="Clip-138" />
              <path
                d="M40.2140552,55.5853912 C41.5110667,55.5853912 42.5629287,56.631567 42.5629287,57.921567 C42.5629287,59.211567 41.5110667,60.2577429 40.2140552,60.2577429 C38.9170437,60.2577429 37.8651816,59.211567 37.8651816,57.921567 C37.8651816,56.631567 38.9170437,55.5853912 40.2140552,55.5853912"
                id="Fill-137"
                fill="#BBB3FF"
                mask="url(#mask-80)"
              />
            </g>
            <g id="Group-142">
              <mask id="mask-82" fill="white">
                <use xlink:href="#path-81" />
              </mask>
              <g id="Clip-141" />
              <path
                d="M25.8561379,55.5853912 C27.1531494,55.5853912 28.2050115,56.631567 28.2050115,57.921567 C28.2050115,59.211567 27.1531494,60.2577429 25.8561379,60.2577429 C24.5591264,60.2577429 23.5072644,59.211567 23.5072644,57.921567 C23.5072644,56.631567 24.5591264,55.5853912 25.8561379,55.5853912"
                id="Fill-140"
                fill="#BBB3FF"
                mask="url(#mask-82)"
              />
            </g>
            <g id="Group-145">
              <mask id="mask-84" fill="white">
                <use xlink:href="#path-83" />
              </mask>
              <g id="Clip-144" />
              <path
                d="M11.4987908,55.5853912 C12.7958023,55.5853912 13.8476644,56.631567 13.8476644,57.921567 C13.8476644,59.211567 12.7958023,60.2577429 11.4987908,60.2577429 C10.200354,60.2577429 9.14991724,59.211567 9.14991724,57.921567 C9.14991724,56.631567 10.200354,55.5853912 11.4987908,55.5853912"
                id="Fill-143"
                fill="#BBB3FF"
                mask="url(#mask-84)"
              />
            </g>
            <g id="Group-148">
              <mask id="mask-86" fill="white">
                <use xlink:href="#path-85" />
              </mask>
              <g id="Clip-147" />
              <path
                d="M54.5714023,41.8120187 C55.8698391,41.8120187 56.9202759,42.8581945 56.9202759,44.1481945 C56.9202759,45.4381945 55.8698391,46.4843703 54.5714023,46.4843703 C53.2743908,46.4843703 52.2225287,45.4381945 52.2225287,44.1481945 C52.2225287,42.8581945 53.2743908,41.8120187 54.5714023,41.8120187"
                id="Fill-146"
                fill="#BBB3FF"
                mask="url(#mask-86)"
              />
            </g>
            <g id="Group-151">
              <mask id="mask-88" fill="white">
                <use xlink:href="#path-87" />
              </mask>
              <g id="Clip-150" />
              <path
                d="M40.2140552,41.8120187 C41.5110667,41.8120187 42.5629287,42.8581945 42.5629287,44.1481945 C42.5629287,45.4381945 41.5110667,46.4843703 40.2140552,46.4843703 C38.9170437,46.4843703 37.8651816,45.4381945 37.8651816,44.1481945 C37.8651816,42.8581945 38.9170437,41.8120187 40.2140552,41.8120187"
                id="Fill-149"
                fill="#BBB3FF"
                mask="url(#mask-88)"
              />
            </g>
            <g id="Group-154">
              <mask id="mask-90" fill="white">
                <use xlink:href="#path-89" />
              </mask>
              <g id="Clip-153" />
              <path
                d="M25.8561379,41.8120187 C27.1531494,41.8120187 28.2050115,42.8581945 28.2050115,44.1481945 C28.2050115,45.4381945 27.1531494,46.4843703 25.8561379,46.4843703 C24.5591264,46.4843703 23.5072644,45.4381945 23.5072644,44.1481945 C23.5072644,42.8581945 24.5591264,41.8120187 25.8561379,41.8120187"
                id="Fill-152"
                fill="#BBB3FF"
                mask="url(#mask-90)"
              />
            </g>
            <g id="Group-157">
              <mask id="mask-92" fill="white">
                <use xlink:href="#path-91" />
              </mask>
              <g id="Clip-156" />
              <path
                d="M11.4987908,41.8120187 C12.7958023,41.8120187 13.8476644,42.8581945 13.8476644,44.1481945 C13.8476644,45.4381945 12.7958023,46.4843703 11.4987908,46.4843703 C10.200354,46.4843703 9.14991724,45.4381945 9.14991724,44.1481945 C9.14991724,42.8581945 10.200354,41.8120187 11.4987908,41.8120187"
                id="Fill-155"
                fill="#BBB3FF"
                mask="url(#mask-92)"
              />
            </g>
            <g id="Group-160">
              <mask id="mask-94" fill="white">
                <use xlink:href="#path-93" />
              </mask>
              <g id="Clip-159" />
              <path
                d="M97.6445839,26.7141989 C98.9415954,26.7141989 99.9934575,27.7603747 99.9934575,29.0503747 C99.9934575,30.3417923 98.9415954,31.3865505 97.6445839,31.3865505 C96.3475724,31.3865505 95.2957103,30.3417923 95.2957103,29.0503747 C95.2957103,27.7603747 96.3475724,26.7141989 97.6445839,26.7141989"
                id="Fill-158"
                fill="#BBB3FF"
                mask="url(#mask-94)"
              />
            </g>
            <g id="Group-163">
              <mask id="mask-96" fill="white">
                <use xlink:href="#path-95" />
              </mask>
              <g id="Clip-162" />
              <path
                d="M83.2872368,26.7141989 C84.5842483,26.7141989 85.6361103,27.7603747 85.6361103,29.0503747 C85.6361103,30.3417923 84.5842483,31.3865505 83.2872368,31.3865505 C81.9888,31.3865505 80.9383632,30.3417923 80.9383632,29.0503747 C80.9383632,27.7603747 81.9888,26.7141989 83.2872368,26.7141989"
                id="Fill-161"
                fill="#BBB3FF"
                mask="url(#mask-96)"
              />
            </g>
            <g id="Group-166">
              <mask id="mask-98" fill="white">
                <use xlink:href="#path-97" />
              </mask>
              <g id="Clip-165" />
              <path
                d="M68.9293195,26.7141989 C70.226331,26.7141989 71.2781931,27.7603747 71.2781931,29.0503747 C71.2781931,30.3417923 70.226331,31.3865505 68.9293195,31.3865505 C67.632308,31.3865505 66.580446,30.3417923 66.580446,29.0503747 C66.580446,27.7603747 67.632308,26.7141989 68.9293195,26.7141989"
                id="Fill-164"
                fill="#BBB3FF"
                mask="url(#mask-98)"
              />
            </g>
            <g id="Group-169">
              <mask id="mask-100" fill="white">
                <use xlink:href="#path-99" />
              </mask>
              <g id="Clip-168" />
              <path
                d="M97.6445839,12.9408264 C98.9415954,12.9408264 99.9934575,13.9870022 99.9934575,15.2770022 C99.9934575,16.5684198 98.9415954,17.613178 97.6445839,17.613178 C96.3475724,17.613178 95.2957103,16.5684198 95.2957103,15.2770022 C95.2957103,13.9870022 96.3475724,12.9408264 97.6445839,12.9408264"
                id="Fill-167"
                fill="#BBB3FF"
                mask="url(#mask-100)"
              />
            </g>
            <g id="Group-172">
              <mask id="mask-102" fill="white">
                <use xlink:href="#path-101" />
              </mask>
              <g id="Clip-171" />
              <path
                d="M83.2872368,12.9408264 C84.5842483,12.9408264 85.6361103,13.9870022 85.6361103,15.2770022 C85.6361103,16.5684198 84.5842483,17.613178 83.2872368,17.613178 C81.9888,17.613178 80.9383632,16.5684198 80.9383632,15.2770022 C80.9383632,13.9870022 81.9888,12.9408264 83.2872368,12.9408264"
                id="Fill-170"
                fill="#BBB3FF"
                mask="url(#mask-102)"
              />
            </g>
            <g id="Group-175">
              <mask id="mask-104" fill="white">
                <use xlink:href="#path-103" />
              </mask>
              <g id="Clip-174" />
              <path
                d="M68.9293195,12.9408264 C70.226331,12.9408264 71.2781931,13.9870022 71.2781931,15.2770022 C71.2781931,16.5684198 70.226331,17.613178 68.9293195,17.613178 C67.632308,17.613178 66.580446,16.5684198 66.580446,15.2770022 C66.580446,13.9870022 67.632308,12.9408264 68.9293195,12.9408264"
                id="Fill-173"
                fill="#BBB3FF"
                mask="url(#mask-104)"
              />
            </g>
            <g id="Group-178">
              <mask id="mask-106" fill="white">
                <use xlink:href="#path-105" />
              </mask>
              <g id="Clip-177" />
              <path
                d="M97.6445839,-0.832404396 C98.9415954,-0.832404396 99.9934575,0.213771429 99.9934575,1.50377143 C99.9934575,2.79518901 98.9415954,3.83994725 97.6445839,3.83994725 C96.3475724,3.83994725 95.2957103,2.79518901 95.2957103,1.50377143 C95.2957103,0.213771429 96.3475724,-0.832404396 97.6445839,-0.832404396"
                id="Fill-176"
                fill="#BBB3FF"
                mask="url(#mask-106)"
              />
            </g>
            <g id="Group-181">
              <mask id="mask-108" fill="white">
                <use xlink:href="#path-107" />
              </mask>
              <g id="Clip-180" />
              <path
                d="M83.2872368,-0.832404396 C84.5842483,-0.832404396 85.6361103,0.213771429 85.6361103,1.50377143 C85.6361103,2.79518901 84.5842483,3.83994725 83.2872368,3.83994725 C81.9888,3.83994725 80.9383632,2.79518901 80.9383632,1.50377143 C80.9383632,0.213771429 81.9888,-0.832404396 83.2872368,-0.832404396"
                id="Fill-179"
                fill="#BBB3FF"
                mask="url(#mask-108)"
              />
            </g>
            <g id="Group-184">
              <mask id="mask-110" fill="white">
                <use xlink:href="#path-109" />
              </mask>
              <g id="Clip-183" />
              <path
                d="M68.9293195,-0.832404396 C70.226331,-0.832404396 71.2781931,0.213771429 71.2781931,1.50377143 C71.2781931,2.79518901 70.226331,3.83994725 68.9293195,3.83994725 C67.632308,3.83994725 66.580446,2.79518901 66.580446,1.50377143 C66.580446,0.213771429 67.632308,-0.832404396 68.9293195,-0.832404396"
                id="Fill-182"
                fill="#BBB3FF"
                mask="url(#mask-110)"
              />
            </g>
            <g id="Group-187">
              <mask id="mask-112" fill="white">
                <use xlink:href="#path-111" />
              </mask>
              <g id="Clip-186" />
              <path
                d="M54.5714023,26.7141989 C55.8698391,26.7141989 56.9202759,27.7603747 56.9202759,29.0503747 C56.9202759,30.3417923 55.8698391,31.3865505 54.5714023,31.3865505 C53.2743908,31.3865505 52.2225287,30.3417923 52.2225287,29.0503747 C52.2225287,27.7603747 53.2743908,26.7141989 54.5714023,26.7141989"
                id="Fill-185"
                fill="#BBB3FF"
                mask="url(#mask-112)"
              />
            </g>
            <g id="Group-190">
              <mask id="mask-114" fill="white">
                <use xlink:href="#path-113" />
              </mask>
              <g id="Clip-189" />
              <path
                d="M40.2140552,26.7141989 C41.5110667,26.7141989 42.5629287,27.7603747 42.5629287,29.0503747 C42.5629287,30.3417923 41.5110667,31.3865505 40.2140552,31.3865505 C38.9170437,31.3865505 37.8651816,30.3417923 37.8651816,29.0503747 C37.8651816,27.7603747 38.9170437,26.7141989 40.2140552,26.7141989"
                id="Fill-188"
                fill="#BBB3FF"
                mask="url(#mask-114)"
              />
            </g>
            <g id="Group-193">
              <mask id="mask-116" fill="white">
                <use xlink:href="#path-115" />
              </mask>
              <g id="Clip-192" />
              <path
                d="M25.8561379,26.7141989 C27.1531494,26.7141989 28.2050115,27.7603747 28.2050115,29.0503747 C28.2050115,30.3417923 27.1531494,31.3865505 25.8561379,31.3865505 C24.5591264,31.3865505 23.5072644,30.3417923 23.5072644,29.0503747 C23.5072644,27.7603747 24.5591264,26.7141989 25.8561379,26.7141989"
                id="Fill-191"
                fill="#BBB3FF"
                mask="url(#mask-116)"
              />
            </g>
            <g id="Group-196">
              <mask id="mask-118" fill="white">
                <use xlink:href="#path-117" />
              </mask>
              <g id="Clip-195" />
              <path
                d="M11.4987908,26.7141989 C12.7958023,26.7141989 13.8476644,27.7603747 13.8476644,29.0503747 C13.8476644,30.3417923 12.7958023,31.3865505 11.4987908,31.3865505 C10.200354,31.3865505 9.14991724,30.3417923 9.14991724,29.0503747 C9.14991724,27.7603747 10.200354,26.7141989 11.4987908,26.7141989"
                id="Fill-194"
                fill="#BBB3FF"
                mask="url(#mask-118)"
              />
            </g>
            <g id="Group-199">
              <mask id="mask-120" fill="white">
                <use xlink:href="#path-119" />
              </mask>
              <g id="Clip-198" />
              <path
                d="M54.5714023,12.9408264 C55.8698391,12.9408264 56.9202759,13.9870022 56.9202759,15.2770022 C56.9202759,16.5684198 55.8698391,17.613178 54.5714023,17.613178 C53.2743908,17.613178 52.2225287,16.5684198 52.2225287,15.2770022 C52.2225287,13.9870022 53.2743908,12.9408264 54.5714023,12.9408264"
                id="Fill-197"
                fill="#BBB3FF"
                mask="url(#mask-120)"
              />
            </g>
            <g id="Group-202">
              <mask id="mask-122" fill="white">
                <use xlink:href="#path-121" />
              </mask>
              <g id="Clip-201" />
              <path
                d="M40.2140552,12.9408264 C41.5110667,12.9408264 42.5629287,13.9870022 42.5629287,15.2770022 C42.5629287,16.5684198 41.5110667,17.613178 40.2140552,17.613178 C38.9170437,17.613178 37.8651816,16.5684198 37.8651816,15.2770022 C37.8651816,13.9870022 38.9170437,12.9408264 40.2140552,12.9408264"
                id="Fill-200"
                fill="#BBB3FF"
                mask="url(#mask-122)"
              />
            </g>
            <g id="Group-205">
              <mask id="mask-124" fill="white">
                <use xlink:href="#path-123" />
              </mask>
              <g id="Clip-204" />
              <path
                d="M25.8561379,12.9408264 C27.1531494,12.9408264 28.2050115,13.9870022 28.2050115,15.2770022 C28.2050115,16.5684198 27.1531494,17.613178 25.8561379,17.613178 C24.5591264,17.613178 23.5072644,16.5684198 23.5072644,15.2770022 C23.5072644,13.9870022 24.5591264,12.9408264 25.8561379,12.9408264"
                id="Fill-203"
                fill="#BBB3FF"
                mask="url(#mask-124)"
              />
            </g>
            <g id="Group-208">
              <mask id="mask-126" fill="white">
                <use xlink:href="#path-125" />
              </mask>
              <g id="Clip-207" />
              <path
                d="M11.4987908,12.9408264 C12.7958023,12.9408264 13.8476644,13.9870022 13.8476644,15.2770022 C13.8476644,16.5684198 12.7958023,17.613178 11.4987908,17.613178 C10.200354,17.613178 9.14991724,16.5684198 9.14991724,15.2770022 C9.14991724,13.9870022 10.200354,12.9408264 11.4987908,12.9408264"
                id="Fill-206"
                fill="#BBB3FF"
                mask="url(#mask-126)"
              />
            </g>
            <g id="Group-211">
              <mask id="mask-128" fill="white">
                <use xlink:href="#path-127" />
              </mask>
              <g id="Clip-210" />
              <path
                d="M54.5714023,-0.832404396 C55.8698391,-0.832404396 56.9202759,0.213771429 56.9202759,1.50377143 C56.9202759,2.79518901 55.8698391,3.83994725 54.5714023,3.83994725 C53.2743908,3.83994725 52.2225287,2.79518901 52.2225287,1.50377143 C52.2225287,0.213771429 53.2743908,-0.832404396 54.5714023,-0.832404396"
                id="Fill-209"
                fill="#BBB3FF"
                mask="url(#mask-128)"
              />
            </g>
            <g id="Group-214">
              <mask id="mask-130" fill="white">
                <use xlink:href="#path-129" />
              </mask>
              <g id="Clip-213" />
              <path
                d="M40.2140552,-0.832404396 C41.5110667,-0.832404396 42.5629287,0.213771429 42.5629287,1.50377143 C42.5629287,2.79518901 41.5110667,3.83994725 40.2140552,3.83994725 C38.9170437,3.83994725 37.8651816,2.79518901 37.8651816,1.50377143 C37.8651816,0.213771429 38.9170437,-0.832404396 40.2140552,-0.832404396"
                id="Fill-212"
                fill="#BBB3FF"
                mask="url(#mask-130)"
              />
            </g>
            <g id="Group-217">
              <mask id="mask-132" fill="white">
                <use xlink:href="#path-131" />
              </mask>
              <g id="Clip-216" />
              <path
                d="M155.075683,110.678598 C156.372694,110.678598 157.424556,111.724774 157.424556,113.014774 C157.424556,114.304774 156.372694,115.350949 155.075683,115.350949 C153.777246,115.350949 152.726809,114.304774 152.726809,113.014774 C152.726809,111.724774 153.777246,110.678598 155.075683,110.678598"
                id="Fill-215"
                fill="#BBB3FF"
                mask="url(#mask-132)"
              />
            </g>
            <g id="Group-220">
              <mask id="mask-134" fill="white">
                <use xlink:href="#path-133" />
              </mask>
              <g id="Clip-219" />
              <path
                d="M140.717766,110.678598 C142.014777,110.678598 143.066639,111.724774 143.066639,113.014774 C143.066639,114.304774 142.014777,115.350949 140.717766,115.350949 C139.420754,115.350949 138.368892,114.304774 138.368892,113.014774 C138.368892,111.724774 139.420754,110.678598 140.717766,110.678598"
                id="Fill-218"
                fill="#BBB3FF"
                mask="url(#mask-134)"
              />
            </g>
            <g id="Group-223">
              <mask id="mask-136" fill="white">
                <use xlink:href="#path-135" />
              </mask>
              <g id="Clip-222" />
              <path
                d="M126.359848,110.678598 C127.658285,110.678598 128.708722,111.724774 128.708722,113.014774 C128.708722,114.304774 127.658285,115.350949 126.359848,115.350949 C125.062837,115.350949 124.010975,114.304774 124.010975,113.014774 C124.010975,111.724774 125.062837,110.678598 126.359848,110.678598"
                id="Fill-221"
                fill="#BBB3FF"
                mask="url(#mask-136)"
              />
            </g>
            <g id="Group-226">
              <mask id="mask-138" fill="white">
                <use xlink:href="#path-137" />
              </mask>
              <g id="Clip-225" />
              <path
                d="M112.002501,110.678598 C113.299513,110.678598 114.351375,111.724774 114.351375,113.014774 C114.351375,114.304774 113.299513,115.350949 112.002501,115.350949 C110.704064,115.350949 109.653628,114.304774 109.653628,113.014774 C109.653628,111.724774 110.704064,110.678598 112.002501,110.678598"
                id="Fill-224"
                fill="#BBB3FF"
                mask="url(#mask-138)"
              />
            </g>
            <g id="Group-229">
              <mask id="mask-140" fill="white">
                <use xlink:href="#path-139" />
              </mask>
              <g id="Clip-228" />
              <path
                d="M155.075683,96.905367 C156.372694,96.905367 157.424556,97.9515429 157.424556,99.2415429 C157.424556,100.531543 156.372694,101.577719 155.075683,101.577719 C153.777246,101.577719 152.726809,100.531543 152.726809,99.2415429 C152.726809,97.9515429 153.777246,96.905367 155.075683,96.905367"
                id="Fill-227"
                fill="#BBB3FF"
                mask="url(#mask-140)"
              />
            </g>
            <g id="Group-232">
              <mask id="mask-142" fill="white">
                <use xlink:href="#path-141" />
              </mask>
              <g id="Clip-231" />
              <path
                d="M140.717766,96.905367 C142.014777,96.905367 143.066639,97.9515429 143.066639,99.2415429 C143.066639,100.531543 142.014777,101.577719 140.717766,101.577719 C139.420754,101.577719 138.368892,100.531543 138.368892,99.2415429 C138.368892,97.9515429 139.420754,96.905367 140.717766,96.905367"
                id="Fill-230"
                fill="#BBB3FF"
                mask="url(#mask-142)"
              />
            </g>
            <g id="Group-235">
              <mask id="mask-144" fill="white">
                <use xlink:href="#path-143" />
              </mask>
              <g id="Clip-234" />
              <path
                d="M126.359848,96.905367 C127.658285,96.905367 128.708722,97.9515429 128.708722,99.2415429 C128.708722,100.531543 127.658285,101.577719 126.359848,101.577719 C125.062837,101.577719 124.010975,100.531543 124.010975,99.2415429 C124.010975,97.9515429 125.062837,96.905367 126.359848,96.905367"
                id="Fill-233"
                fill="#BBB3FF"
                mask="url(#mask-144)"
              />
            </g>
            <g id="Group-238">
              <mask id="mask-146" fill="white">
                <use xlink:href="#path-145" />
              </mask>
              <g id="Clip-237" />
              <path
                d="M112.002501,96.905367 C113.299513,96.905367 114.351375,97.9515429 114.351375,99.2415429 C114.351375,100.531543 113.299513,101.577719 112.002501,101.577719 C110.704064,101.577719 109.653628,100.531543 109.653628,99.2415429 C109.653628,97.9515429 110.704064,96.905367 112.002501,96.905367"
                id="Fill-236"
                fill="#BBB3FF"
                mask="url(#mask-146)"
              />
            </g>
            <g id="Group-241">
              <mask id="mask-148" fill="white">
                <use xlink:href="#path-147" />
              </mask>
              <g id="Clip-240" />
              <path
                d="M155.075683,83.1319945 C156.372694,83.1319945 157.424556,84.1781703 157.424556,85.4681703 C157.424556,86.7581703 156.372694,87.8043462 155.075683,87.8043462 C153.777246,87.8043462 152.726809,86.7581703 152.726809,85.4681703 C152.726809,84.1781703 153.777246,83.1319945 155.075683,83.1319945"
                id="Fill-239"
                fill="#BBB3FF"
                mask="url(#mask-148)"
              />
            </g>
            <g id="Group-244">
              <mask id="mask-150" fill="white">
                <use xlink:href="#path-149" />
              </mask>
              <g id="Clip-243" />
              <path
                d="M140.717766,83.1319945 C142.014777,83.1319945 143.066639,84.1781703 143.066639,85.4681703 C143.066639,86.7581703 142.014777,87.8043462 140.717766,87.8043462 C139.420754,87.8043462 138.368892,86.7581703 138.368892,85.4681703 C138.368892,84.1781703 139.420754,83.1319945 140.717766,83.1319945"
                id="Fill-242"
                fill="#BBB3FF"
                mask="url(#mask-150)"
              />
            </g>
            <g id="Group-247">
              <mask id="mask-152" fill="white">
                <use xlink:href="#path-151" />
              </mask>
              <g id="Clip-246" />
              <path
                d="M126.359848,83.1319945 C127.658285,83.1319945 128.708722,84.1781703 128.708722,85.4681703 C128.708722,86.7581703 127.658285,87.8043462 126.359848,87.8043462 C125.062837,87.8043462 124.010975,86.7581703 124.010975,85.4681703 C124.010975,84.1781703 125.062837,83.1319945 126.359848,83.1319945"
                id="Fill-245"
                fill="#BBB3FF"
                mask="url(#mask-152)"
              />
            </g>
            <g id="Group-250">
              <mask id="mask-154" fill="white">
                <use xlink:href="#path-153" />
              </mask>
              <g id="Clip-249" />
              <path
                d="M155.075683,69.358622 C156.372694,69.358622 157.424556,70.4047978 157.424556,71.6947978 C157.424556,72.9847978 156.372694,74.0309736 155.075683,74.0309736 C153.777246,74.0309736 152.726809,72.9847978 152.726809,71.6947978 C152.726809,70.4047978 153.777246,69.358622 155.075683,69.358622"
                id="Fill-248"
                fill="#BBB3FF"
                mask="url(#mask-154)"
              />
            </g>
            <g id="Group-253">
              <mask id="mask-156" fill="white">
                <use xlink:href="#path-155" />
              </mask>
              <g id="Clip-252" />
              <path
                d="M140.717766,69.358622 C142.014777,69.358622 143.066639,70.4047978 143.066639,71.6947978 C143.066639,72.9847978 142.014777,74.0309736 140.717766,74.0309736 C139.420754,74.0309736 138.368892,72.9847978 138.368892,71.6947978 C138.368892,70.4047978 139.420754,69.358622 140.717766,69.358622"
                id="Fill-251"
                fill="#BBB3FF"
                mask="url(#mask-156)"
              />
            </g>
            <g id="Group-256">
              <mask id="mask-158" fill="white">
                <use xlink:href="#path-157" />
              </mask>
              <g id="Clip-255" />
              <path
                d="M126.359848,69.358622 C127.658285,69.358622 128.708722,70.4047978 128.708722,71.6947978 C128.708722,72.9847978 127.658285,74.0309736 126.359848,74.0309736 C125.062837,74.0309736 124.010975,72.9847978 124.010975,71.6947978 C124.010975,70.4047978 125.062837,69.358622 126.359848,69.358622"
                id="Fill-254"
                fill="#BBB3FF"
                mask="url(#mask-158)"
              />
            </g>
            <g id="Group-259">
              <mask id="mask-160" fill="white">
                <use xlink:href="#path-159" />
              </mask>
              <g id="Clip-258" />
              <path
                d="M155.075683,55.5853912 C156.372694,55.5853912 157.424556,56.631567 157.424556,57.921567 C157.424556,59.211567 156.372694,60.2577429 155.075683,60.2577429 C153.777246,60.2577429 152.726809,59.211567 152.726809,57.921567 C152.726809,56.631567 153.777246,55.5853912 155.075683,55.5853912"
                id="Fill-257"
                fill="#BBB3FF"
                mask="url(#mask-160)"
              />
            </g>
            <g id="Group-262">
              <mask id="mask-162" fill="white">
                <use xlink:href="#path-161" />
              </mask>
              <g id="Clip-261" />
              <path
                d="M140.717766,55.5853912 C142.014777,55.5853912 143.066639,56.631567 143.066639,57.921567 C143.066639,59.211567 142.014777,60.2577429 140.717766,60.2577429 C139.420754,60.2577429 138.368892,59.211567 138.368892,57.921567 C138.368892,56.631567 139.420754,55.5853912 140.717766,55.5853912"
                id="Fill-260"
                fill="#BBB3FF"
                mask="url(#mask-162)"
              />
            </g>
            <g id="Group-265">
              <mask id="mask-164" fill="white">
                <use xlink:href="#path-163" />
              </mask>
              <g id="Clip-264" />
              <path
                d="M126.359848,55.5853912 C127.658285,55.5853912 128.708722,56.631567 128.708722,57.921567 C128.708722,59.211567 127.658285,60.2577429 126.359848,60.2577429 C125.062837,60.2577429 124.010975,59.211567 124.010975,57.921567 C124.010975,56.631567 125.062837,55.5853912 126.359848,55.5853912"
                id="Fill-263"
                fill="#BBB3FF"
                mask="url(#mask-164)"
              />
            </g>
            <g id="Group-268">
              <mask id="mask-166" fill="white">
                <use xlink:href="#path-165" />
              </mask>
              <g id="Clip-267" />
              <path
                d="M155.075683,41.8120187 C156.372694,41.8120187 157.424556,42.8581945 157.424556,44.1481945 C157.424556,45.4381945 156.372694,46.4843703 155.075683,46.4843703 C153.777246,46.4843703 152.726809,45.4381945 152.726809,44.1481945 C152.726809,42.8581945 153.777246,41.8120187 155.075683,41.8120187"
                id="Fill-266"
                fill="#BBB3FF"
                mask="url(#mask-166)"
              />
            </g>
            <g id="Group-271">
              <mask id="mask-168" fill="white">
                <use xlink:href="#path-167" />
              </mask>
              <g id="Clip-270" />
              <path
                d="M140.717766,41.8120187 C142.014777,41.8120187 143.066639,42.8581945 143.066639,44.1481945 C143.066639,45.4381945 142.014777,46.4843703 140.717766,46.4843703 C139.420754,46.4843703 138.368892,45.4381945 138.368892,44.1481945 C138.368892,42.8581945 139.420754,41.8120187 140.717766,41.8120187"
                id="Fill-269"
                fill="#BBB3FF"
                mask="url(#mask-168)"
              />
            </g>
            <g id="Group-274">
              <mask id="mask-170" fill="white">
                <use xlink:href="#path-169" />
              </mask>
              <g id="Clip-273" />
              <path
                d="M126.359848,41.8120187 C127.658285,41.8120187 128.708722,42.8581945 128.708722,44.1481945 C128.708722,45.4381945 127.658285,46.4843703 126.359848,46.4843703 C125.062837,46.4843703 124.010975,45.4381945 124.010975,44.1481945 C124.010975,42.8581945 125.062837,41.8120187 126.359848,41.8120187"
                id="Fill-272"
                fill="#BBB3FF"
                mask="url(#mask-170)"
              />
            </g>
            <g id="Group-277">
              <mask id="mask-172" fill="white">
                <use xlink:href="#path-171" />
              </mask>
              <g id="Clip-276" />
              <path
                d="M112.002501,83.1319945 C113.299513,83.1319945 114.351375,84.1781703 114.351375,85.4681703 C114.351375,86.7581703 113.299513,87.8043462 112.002501,87.8043462 C110.704064,87.8043462 109.653628,86.7581703 109.653628,85.4681703 C109.653628,84.1781703 110.704064,83.1319945 112.002501,83.1319945"
                id="Fill-275"
                fill="#BBB3FF"
                mask="url(#mask-172)"
              />
            </g>
            <g id="Group-280">
              <mask id="mask-174" fill="white">
                <use xlink:href="#path-173" />
              </mask>
              <g id="Clip-279" />
              <path
                d="M112.002501,69.358622 C113.299513,69.358622 114.351375,70.4047978 114.351375,71.6947978 C114.351375,72.9847978 113.299513,74.0309736 112.002501,74.0309736 C110.704064,74.0309736 109.653628,72.9847978 109.653628,71.6947978 C109.653628,70.4047978 110.704064,69.358622 112.002501,69.358622"
                id="Fill-278"
                fill="#BBB3FF"
                mask="url(#mask-174)"
              />
            </g>
            <g id="Group-283">
              <mask id="mask-176" fill="white">
                <use xlink:href="#path-175" />
              </mask>
              <g id="Clip-282" />
              <path
                d="M112.002501,55.5853912 C113.299513,55.5853912 114.351375,56.631567 114.351375,57.921567 C114.351375,59.211567 113.299513,60.2577429 112.002501,60.2577429 C110.704064,60.2577429 109.653628,59.211567 109.653628,57.921567 C109.653628,56.631567 110.704064,55.5853912 112.002501,55.5853912"
                id="Fill-281"
                fill="#BBB3FF"
                mask="url(#mask-176)"
              />
            </g>
            <g id="Group-286">
              <mask id="mask-178" fill="white">
                <use xlink:href="#path-177" />
              </mask>
              <g id="Clip-285" />
              <path
                d="M112.002501,41.8120187 C113.299513,41.8120187 114.351375,42.8581945 114.351375,44.1481945 C114.351375,45.4381945 113.299513,46.4843703 112.002501,46.4843703 C110.704064,46.4843703 109.653628,45.4381945 109.653628,44.1481945 C109.653628,42.8581945 110.704064,41.8120187 112.002501,41.8120187"
                id="Fill-284"
                fill="#BBB3FF"
                mask="url(#mask-178)"
              />
            </g>
            <g id="Group-289">
              <mask id="mask-180" fill="white">
                <use xlink:href="#path-179" />
              </mask>
              <g id="Clip-288" />
              <path
                d="M155.075683,26.7141989 C156.372694,26.7141989 157.424556,27.7603747 157.424556,29.0503747 C157.424556,30.3417923 156.372694,31.3865505 155.075683,31.3865505 C153.777246,31.3865505 152.726809,30.3417923 152.726809,29.0503747 C152.726809,27.7603747 153.777246,26.7141989 155.075683,26.7141989"
                id="Fill-287"
                fill="#BBB3FF"
                mask="url(#mask-180)"
              />
            </g>
            <g id="Group-292">
              <mask id="mask-182" fill="white">
                <use xlink:href="#path-181" />
              </mask>
              <g id="Clip-291" />
              <path
                d="M140.717766,26.7141989 C142.014777,26.7141989 143.066639,27.7603747 143.066639,29.0503747 C143.066639,30.3417923 142.014777,31.3865505 140.717766,31.3865505 C139.420754,31.3865505 138.368892,30.3417923 138.368892,29.0503747 C138.368892,27.7603747 139.420754,26.7141989 140.717766,26.7141989"
                id="Fill-290"
                fill="#BBB3FF"
                mask="url(#mask-182)"
              />
            </g>
            <g id="Group-295">
              <mask id="mask-184" fill="white">
                <use xlink:href="#path-183" />
              </mask>
              <g id="Clip-294" />
              <path
                d="M126.359848,26.7141989 C127.658285,26.7141989 128.708722,27.7603747 128.708722,29.0503747 C128.708722,30.3417923 127.658285,31.3865505 126.359848,31.3865505 C125.062837,31.3865505 124.010975,30.3417923 124.010975,29.0503747 C124.010975,27.7603747 125.062837,26.7141989 126.359848,26.7141989"
                id="Fill-293"
                fill="#BBB3FF"
                mask="url(#mask-184)"
              />
            </g>
            <g id="Group-298">
              <mask id="mask-186" fill="white">
                <use xlink:href="#path-185" />
              </mask>
              <g id="Clip-297" />
              <path
                d="M155.075683,12.9408264 C156.372694,12.9408264 157.424556,13.9870022 157.424556,15.2770022 C157.424556,16.5684198 156.372694,17.613178 155.075683,17.613178 C153.777246,17.613178 152.726809,16.5684198 152.726809,15.2770022 C152.726809,13.9870022 153.777246,12.9408264 155.075683,12.9408264"
                id="Fill-296"
                fill="#BBB3FF"
                mask="url(#mask-186)"
              />
            </g>
            <g id="Group-301">
              <mask id="mask-188" fill="white">
                <use xlink:href="#path-187" />
              </mask>
              <g id="Clip-300" />
              <path
                d="M140.717766,12.9408264 C142.014777,12.9408264 143.066639,13.9870022 143.066639,15.2770022 C143.066639,16.5684198 142.014777,17.613178 140.717766,17.613178 C139.420754,17.613178 138.368892,16.5684198 138.368892,15.2770022 C138.368892,13.9870022 139.420754,12.9408264 140.717766,12.9408264"
                id="Fill-299"
                fill="#BBB3FF"
                mask="url(#mask-188)"
              />
            </g>
            <g id="Group-304">
              <mask id="mask-190" fill="white">
                <use xlink:href="#path-189" />
              </mask>
              <g id="Clip-303" />
              <path
                d="M126.359848,12.9408264 C127.658285,12.9408264 128.708722,13.9870022 128.708722,15.2770022 C128.708722,16.5684198 127.658285,17.613178 126.359848,17.613178 C125.062837,17.613178 124.010975,16.5684198 124.010975,15.2770022 C124.010975,13.9870022 125.062837,12.9408264 126.359848,12.9408264"
                id="Fill-302"
                fill="#BBB3FF"
                mask="url(#mask-190)"
              />
            </g>
            <g id="Group-307">
              <mask id="mask-192" fill="white">
                <use xlink:href="#path-191" />
              </mask>
              <g id="Clip-306" />
              <path
                d="M155.075683,-0.832404396 C156.372694,-0.832404396 157.424556,0.213771429 157.424556,1.50377143 C157.424556,2.79518901 156.372694,3.83994725 155.075683,3.83994725 C153.777246,3.83994725 152.726809,2.79518901 152.726809,1.50377143 C152.726809,0.213771429 153.777246,-0.832404396 155.075683,-0.832404396"
                id="Fill-305"
                fill="#BBB3FF"
                mask="url(#mask-192)"
              />
            </g>
            <g id="Group-310">
              <mask id="mask-194" fill="white">
                <use xlink:href="#path-193" />
              </mask>
              <g id="Clip-309" />
              <path
                d="M140.717766,-0.832404396 C142.014777,-0.832404396 143.066639,0.213771429 143.066639,1.50377143 C143.066639,2.79518901 142.014777,3.83994725 140.717766,3.83994725 C139.420754,3.83994725 138.368892,2.79518901 138.368892,1.50377143 C138.368892,0.213771429 139.420754,-0.832404396 140.717766,-0.832404396"
                id="Fill-308"
                fill="#BBB3FF"
                mask="url(#mask-194)"
              />
            </g>
            <g id="Group-313">
              <mask id="mask-196" fill="white">
                <use xlink:href="#path-195" />
              </mask>
              <g id="Clip-312" />
              <path
                d="M126.359848,-0.832404396 C127.658285,-0.832404396 128.708722,0.213771429 128.708722,1.50377143 C128.708722,2.79518901 127.658285,3.83994725 126.359848,3.83994725 C125.062837,3.83994725 124.010975,2.79518901 124.010975,1.50377143 C124.010975,0.213771429 125.062837,-0.832404396 126.359848,-0.832404396"
                id="Fill-311"
                fill="#BBB3FF"
                mask="url(#mask-196)"
              />
            </g>
            <g id="Group-316">
              <mask id="mask-198" fill="white">
                <use xlink:href="#path-197" />
              </mask>
              <g id="Clip-315" />
              <path
                d="M112.002501,26.7141989 C113.299513,26.7141989 114.351375,27.7603747 114.351375,29.0503747 C114.351375,30.3417923 113.299513,31.3865505 112.002501,31.3865505 C110.704064,31.3865505 109.653628,30.3417923 109.653628,29.0503747 C109.653628,27.7603747 110.704064,26.7141989 112.002501,26.7141989"
                id="Fill-314"
                fill="#BBB3FF"
                mask="url(#mask-198)"
              />
            </g>
            <g id="Group-319">
              <mask id="mask-200" fill="white">
                <use xlink:href="#path-199" />
              </mask>
              <g id="Clip-318" />
              <path
                d="M112.002501,12.9408264 C113.299513,12.9408264 114.351375,13.9870022 114.351375,15.2770022 C114.351375,16.5684198 113.299513,17.613178 112.002501,17.613178 C110.704064,17.613178 109.653628,16.5684198 109.653628,15.2770022 C109.653628,13.9870022 110.704064,12.9408264 112.002501,12.9408264"
                id="Fill-317"
                fill="#BBB3FF"
                mask="url(#mask-200)"
              />
            </g>
            <g id="Group-322">
              <mask id="mask-202" fill="white">
                <use xlink:href="#path-201" />
              </mask>
              <g id="Clip-321" />
              <path
                d="M112.002501,-0.832404396 C113.299513,-0.832404396 114.351375,0.213771429 114.351375,1.50377143 C114.351375,2.79518901 113.299513,3.83994725 112.002501,3.83994725 C110.704064,3.83994725 109.653628,2.79518901 109.653628,1.50377143 C109.653628,0.213771429 110.704064,-0.832404396 112.002501,-0.832404396"
                id="Fill-320"
                fill="#BBB3FF"
                mask="url(#mask-202)"
              />
            </g>
            <g id="Group-325">
              <mask id="mask-204" fill="white">
                <use xlink:href="#path-203" />
              </mask>
              <g id="Clip-324" />
              <path
                d="M25.8561379,-0.832404396 C27.1531494,-0.832404396 28.2050115,0.213771429 28.2050115,1.50377143 C28.2050115,2.79518901 27.1531494,3.83994725 25.8561379,3.83994725 C24.5591264,3.83994725 23.5072644,2.79518901 23.5072644,1.50377143 C23.5072644,0.213771429 24.5591264,-0.832404396 25.8561379,-0.832404396"
                id="Fill-323"
                fill="#BBB3FF"
                mask="url(#mask-204)"
              />
            </g>
            <g id="Group-328">
              <mask id="mask-206" fill="white">
                <use xlink:href="#path-205" />
              </mask>
              <g id="Clip-327" />
              <path
                d="M11.4987908,-0.832404396 C12.7958023,-0.832404396 13.8476644,0.213771429 13.8476644,1.50377143 C13.8476644,2.79518901 12.7958023,3.83994725 11.4987908,3.83994725 C10.200354,3.83994725 9.14991724,2.79518901 9.14991724,1.50377143 C9.14991724,0.213771429 10.200354,-0.832404396 11.4987908,-0.832404396"
                id="Fill-326"
                fill="#BBB3FF"
                mask="url(#mask-206)"
              />
            </g>
          </g>
          <g id="Group-555" transform="translate(0.000000, 3.000000)">
            <path
              d="M34.2222571,38.4812645 L55.663951,60.9766194 L74.9715701,38.8091355 L84.8528626,50.4364903 C85.3945565,57.5772645 72.2645224,74.5158452 59.8794952,80.663071 C46.0471075,87.531329 26.2930531,51.3065548 26.2930531,51.3065548 L21.4533524,44.499329 L34.2222571,38.4812645 Z"
              id="Fill-330"
              fill="#3424C7"
            />
            <path
              d="M34.7595435,38.9373032 L29.1492442,41.1231097 C29.1492442,41.1231097 20.6115231,31.5254323 22.0659925,29.2672387 C23.8901218,26.4313677 30.4288361,33.0413032 34.7595435,38.9373032"
              id="Fill-332"
              fill="#3424C7"
            />
            <path
              d="M27.5355367,13.1567097 C27.6194211,15.1054839 29.5544483,32.6416129 29.5544483,32.6416129 L27.952115,32.8105161 C27.952115,32.8105161 26.089598,14.4469032 25.9005027,13.3284516 C25.5734959,11.4052258 25.0972034,10.3534839 24.9550265,9.02212903 L24.3294483,3.09490323 L26.9355503,2.81954839 L27.5625503,8.74819355 C27.7018837,10.0809677 27.4530741,11.2079355 27.5355367,13.1567097"
              id="Fill-334"
              fill="#B1B1B1"
            />
            <path
              d="M34.8991612,44.7474323 C35.1778279,46.7572387 36.1887054,57.7870452 36.1887054,57.7870452 C36.1887054,57.7870452 36.4972293,59.4448516 35.1678755,60.2595613 C34.4058075,60.7279484 33.1219503,61.2928516 31.7783789,61.4731097 C30.4234333,61.5781419 29.0514265,61.2914323 28.2054741,60.9933677 C26.7382088,60.4724645 26.6955558,58.7876903 26.6955558,58.7876903 C26.6955558,58.7876903 25.378998,47.7891097 25.2325558,45.7651097 C25.0861136,43.742529 25.4543517,42.8909161 26.0202156,40.614271 C26.5860796,38.3390452 24.8287735,36.0680774 24.8287735,36.0680774 C24.2956102,35.7614968 24.0425354,34.6359484 24.0780796,33.5955613 C24.1292633,32.1307871 26.7254129,31.2891097 28.1230116,31.0563355 C28.268032,31.0322065 28.4144741,31.0151742 28.5609163,30.9995613 C28.7087803,30.9839484 28.8566442,30.9697548 29.0030864,30.9640774 C30.4163245,30.9016258 33.1219503,31.1883355 33.4887667,32.606271 C33.7375762,33.574271 33.7290456,34.7707871 33.2698143,35.1795613 C33.2698143,35.1795613 32.0257667,37.7670452 33.0537054,39.8747871 C34.0816442,41.9839484 34.6219163,42.7376258 34.8991612,44.7474323"
              id="Fill-336"
              fill="#766DFF"
            />
            <path
              d="M30.9607197,43.4745548 C30.8469782,42.4001032 29.8844408,41.6222968 28.8081619,41.7344258 C27.7347265,41.8493935 26.9541755,42.8102968 27.0693388,43.883329 L28.6560327,58.9299097 C28.7697741,60.0029419 29.7323116,60.7807484 30.8071687,60.6686194 C31.8820259,60.555071 32.6611551,59.5941677 32.5488354,58.5211355 L30.9607197,43.4745548 Z"
              id="Fill-338"
              fill="#2D2D2B"
            />
            <path
              d="M31.7965776,33.7474323 L31.5278633,31.198271 C32.4776048,31.4324645 33.3064959,31.8639484 33.4970129,32.6048516 C33.7472442,33.5728516 33.7372918,34.7693677 33.2780605,35.1781419 C33.2780605,35.1781419 33.2368293,35.2647226 33.177115,35.4137548 C32.4463259,35.1923355 31.8818837,34.5522065 31.7965776,33.7474323"
              id="Fill-340"
              fill="#2D2D2B"
            />
            <path
              d="M34.3915898,58.3275355 L32.8034741,43.2809548 C32.718168,42.4747613 33.136168,41.7324387 33.8058211,41.3634065 C34.3674197,42.4917935 34.7072224,43.2923097 34.9091136,44.7485677 C35.1877803,46.7555355 36.1958143,57.7867613 36.1958143,57.7867613 C36.1958143,57.7867613 36.4346714,59.0670194 35.5915626,59.9299871 C34.9503449,59.6659871 34.4683653,59.0656 34.3915898,58.3275355"
              id="Fill-342"
              fill="#2D2D2B"
            />
            <path
              d="M29.9548184,33.9397548 C30.0685599,35.0142065 29.2880088,35.9751097 28.2131517,36.0872387 C27.1382946,36.2007871 26.1757571,35.4229806 26.0634374,34.3499484 L25.7904578,31.7709806 C26.5781177,31.400529 27.4780973,31.1649161 28.1221585,31.0556258 C28.2671789,31.0314968 28.4150429,31.0144645 28.561485,31.000271 C28.7079272,30.9832387 28.8557912,30.9704645 29.0036551,30.9633677 C29.1941721,30.9534323 29.410281,30.9534323 29.6406075,30.960529 L29.9548184,33.9397548 Z"
              id="Fill-344"
              fill="#2D2D2B"
            />
            <path
              d="M38.1369551,58.6994065 L45.2443769,62.1711484 C45.2443769,62.1711484 41.8108054,64.5286968 38.0530707,62.693471 C34.2967578,60.8596645 33.7735469,56.5646968 34.080649,55.5086968 L12.2621864,44.8663742 C12.2621864,44.8663742 8.84567619,48.441729 4.29601633,46.2190194 C0.238288435,44.2390194 0.141608163,40.1555355 0.141608163,40.1555355 L7.2504517,43.6286968 L10.3513293,37.3026323 L3.24390748,33.829471 C3.24390748,33.829471 6.37748571,31.3271484 10.4337918,33.3071484 C14.4886762,35.2885677 14.532751,39.3465032 14.4090571,40.5061161 L36.2246762,51.1356645 C36.2246762,51.1356645 39.6682,47.5716645 44.345819,49.8554065 C48.2883837,51.7828903 48.3452544,55.8465032 48.3452544,55.8465032 L41.1823837,52.3477935 L38.1369551,58.6994065 Z"
              id="Fill-346"
              fill="#B1B1B1"
            />
            <path
              d="M34.4082245,52.9388129 C34.847551,52.0389419 34.4594082,50.9446194 33.5437891,50.5003613 L16.640381,42.2893935 C15.7247619,41.8451355 14.6228912,42.2155871 14.1835646,43.1140387 C13.7456599,44.0139097 14.1338027,45.1082323 15.0494218,45.5524903 L31.9528299,53.7634581 C32.868449,54.2077161 33.9703197,53.8386839 34.4082245,52.9388129"
              id="Fill-348"
              fill="#575756"
            />
            <path
              d="M14.9520306,43.4867613 C15.1866224,43.0027613 15.7809218,42.8026323 16.2728537,43.0425032 L33.1776837,51.2548903 C33.6710374,51.4933419 33.8800374,52.0823742 33.642602,52.5663742 C33.4065884,53.0503742 32.8137109,53.2505032 32.3203571,53.0106323 L15.416949,44.7996645 C14.9235952,44.5597935 14.7145952,43.9707613 14.9520306,43.4867613"
              id="Fill-350"
              fill="#868686"
            />
            <path
              d="M11.7752306,36.7655484 L7.66631905,45.1482581 L0.368380272,41.5842581 C0.138053741,40.763871 0.125257823,40.191871 0.125257823,40.191871 L7.23125782,43.6636129 L10.3335571,37.3389677 L3.22755714,33.8643871 C3.22755714,33.8643871 3.66830544,33.5123871 4.43321701,33.1774194 L11.7752306,36.7655484 Z"
              id="Fill-352"
              fill="#868686"
            />
            <path
              d="M12.0140878,36.6782581 L7.74451633,45.3902581 L0.43662517,41.822 L0.369802041,41.5835484 L7.66631905,45.1489677 L11.7752306,36.7662581 L4.43606054,33.178129 C4.50999252,33.1469032 4.58534626,33.1156774 4.66354354,33.0844516 L12.0140878,36.6782581 Z"
              id="Fill-354"
              fill="#575756"
            />
            <path
              d="M36.712485,59.2362065 L40.8213966,50.8534968 L48.1193354,54.4189161 C48.3496619,55.2378839 48.3624578,55.8098839 48.3624578,55.8098839 L41.2536143,52.3381419 L38.1541585,58.6627871 L45.2615803,62.1373677 C45.2615803,62.1373677 44.8194102,62.4893677 44.0544986,62.8257548 L36.712485,59.2362065 Z"
              id="Fill-356"
              fill="#868686"
            />
            <path
              d="M36.472917,59.3249161 L40.7424884,50.6100774 L48.0518014,54.1797548 L48.1186245,54.4182065 L40.8206857,50.8527871 L36.7117741,59.2369161 L44.0509442,62.8250452 C43.978434,62.856271 43.9030803,62.8860774 43.824883,62.9173032 L36.472917,59.3249161 Z"
              id="Fill-358"
              fill="#575756"
            />
            <path
              d="M41.6990544,54.6048516 C42.2137347,55.270529 42.0900408,56.2285935 41.4218095,56.7409806 L36.1299864,60.8116903 C35.4631769,61.3254968 34.5049048,61.2005935 33.9916463,60.5349161 L14.5176803,31.2621419 C14.003,30.5950452 14.1281156,29.6384 14.7949252,29.1260129 L16.166932,28.0700129 C16.8351633,27.5562065 17.7934354,27.6796903 18.3081156,28.3467871 L41.6990544,54.6048516 Z"
              id="Fill-360"
              fill="#EE5A8C"
            />
            <polygon
              id="Fill-362"
              fill="#868686"
              points="10.6756347 27.9397161 5.17623333 32.1693935 1.95450544 27.9936516 7.95010408 23.3821677"
            />
            <path
              d="M23.2493306,20.7357806 C14.5481061,16.0575871 14.2921878,17.2640387 11.0903646,19.7280387 C8.44160952,21.7648129 7.36533061,22.6121677 5.6620517,23.9222323 C5.15163673,24.3139742 5.3350449,24.9938452 5.53409252,25.2521677 L8.76008571,29.4321677 C10.5444054,28.1348774 14.5950245,31.4150065 15.1523578,32.2212 L19.0935007,29.1894581 C19.0935007,29.1894581 17.523868,26.4926839 17.0162966,25.5857161 C16.1191605,23.9804258 16.0025755,23.5262323 16.3708136,22.961329 C17.486902,21.2581032 18.4935143,22.5128129 21.7920177,23.4950065 C23.4753918,23.9960387 24.7165959,23.9562968 25.1161129,23.1543613 C25.349283,22.6845548 24.8985823,21.6242968 23.2493306,20.7357806"
              id="Fill-364"
              fill="#B1B1B1"
            />
            <path
              d="M24.9321361,22.3772645 C24.5340408,23.1777806 23.2928367,23.2189419 21.6108844,22.7179097 C18.3109592,21.7342968 17.3043469,20.4795871 16.1896803,22.1842323 C15.9465578,22.5546839 15.9152789,22.8782968 16.1711973,23.5042323 C16.1811497,23.3055226 16.2493946,23.1352 16.3674014,22.9563613 C17.482068,21.2531355 18.4886803,22.5064258 21.7886054,23.4900387 C23.4705578,23.9896516 24.7131837,23.9499097 25.1112789,23.1479742 C25.2136463,22.9421677 25.1823673,22.6171355 24.9747891,22.2452645 C24.9648367,22.2921032 24.9534626,22.3375226 24.9321361,22.3772645"
              id="Fill-366"
              fill="#070000"
            />
            <path
              d="M15.4900279,31.9696903 C14.1692048,30.472271 10.3119463,27.4078839 8.58307551,28.6625935 L5.35566054,24.4825935 C5.35281701,24.4769161 5.34997347,24.4698194 5.34570816,24.4641419 C5.29736803,24.7764 5.41253129,25.0957548 5.53622517,25.2533032 L8.76221837,29.4333032 C10.2380143,28.3616903 13.2749122,30.4538194 15.1601776,32.2223355 L15.4900279,31.9696903 Z"
              id="Fill-368"
              fill="#070000"
            />
            <g id="Group-372" transform="translate(0.000000, 25.548387)">
              <mask id="mask-208" fill="white">
                <use xlink:href="#path-207" />
              </mask>
              <g id="Clip-371" />
              <polygon
                id="Fill-370"
                fill="#B1B1B1"
                mask="url(#mask-208)"
                points="7.15661497 5.95845161 4.01024082 8.37845161 -0.000568707483 3.1836129 3.14580544 0.763612903"
              />
            </g>
            <path
              d="M25.9659041,54.7122968 C28.148319,53.2602968 31.5548769,51.3115226 32.5728633,52.5222323 C33.9007952,54.1005548 32.5885027,56.0961677 28.6047068,58.7006839 C27.4914619,59.4288129 25.9914959,59.0981032 25.2791898,57.9753935 C24.5839449,56.881071 24.8853599,55.4304903 25.9659041,54.7122968"
              id="Fill-373"
              fill="#3424C7"
            />
            <path
              d="M32.1784646,53.3788129 L33.6542605,53.2312 C33.9016483,55.7235871 33.5661109,56.1763613 29.6505599,58.6275871 L28.8614782,57.3728774 C32.3576075,55.1842323 32.3547639,55.1515871 32.1784646,53.3788129"
              id="Fill-375"
              fill="#070000"
            />
            <path
              d="M23.5368122,50.9886194 C25.7178054,49.5366194 29.125785,47.5878452 30.1423497,48.7971355 C31.4717034,50.3768774 30.1594109,52.3724903 26.175615,54.9770065 C25.0623701,55.7051355 23.5624041,55.3744258 22.850098,54.2517161 C22.1548531,53.1573935 22.456268,51.7068129 23.5368122,50.9886194"
              id="Fill-377"
              fill="#3424C7"
            />
            <path
              d="M29.7674293,49.8248903 L31.2432252,49.6772774 C31.4920347,52.1696645 31.1550755,52.6224387 27.2395245,55.0736645 L26.4518646,53.8189548 C29.9465721,51.6303097 29.9451503,51.5976645 29.7674293,49.8248903"
              id="Fill-379"
              fill="#070000"
            />
            <path
              d="M21.0403286,47.5371742 C23.2213218,46.0851742 26.6293014,44.1364 27.645866,45.3471097 C28.9752197,46.9254323 27.6629272,48.9210452 23.6791313,51.5255613 C22.5644646,52.2536903 21.0659204,51.9229806 20.3536143,50.800271 C19.6583694,49.7059484 19.9597844,48.2553677 21.0403286,47.5371742"
              id="Fill-381"
              fill="#3424C7"
            />
            <path
              d="M27.2709456,46.3735871 L28.7481633,46.2259742 C28.995551,48.7183613 28.6585918,49.1711355 24.7430408,51.6223613 L23.955381,50.3676516 C27.4515102,48.1790065 27.4472449,48.1449419 27.2709456,46.3735871"
              id="Fill-383"
              fill="#070000"
            />
            <path
              d="M19.1222204,43.9296 C20.8539347,42.5982452 23.6178531,40.8041806 24.6628531,41.9822452 C25.9154313,43.3945032 24.9955469,45.4397935 22.130683,47.7533419 C20.8837918,48.7596645 19.014166,48.2941161 18.3743701,46.8265032 C17.9279347,45.8031484 18.2364585,44.6108903 19.1222204,43.9296"
              id="Fill-385"
              fill="#3424C7"
            />
            <path
              d="M24.2920558,42.9936774 L25.7621646,42.7978065 C26.1005456,45.3214194 24.6403891,46.4583226 22.1949469,48.0295484 L21.3916476,46.7847742 C23.8612599,45.1965161 24.499634,44.5464516 24.2920558,42.9936774"
              id="Fill-387"
              fill="#070000"
            />
            <path
              d="M152.960844,57.391329 L178.411926,39.5415226 L185.027416,41.4108129 L183.661096,53.6726194 C183.661096,53.6726194 155.285436,87.5512 146.416443,78.2984258 C134.868837,66.2481032 129.0993,57.1173935 129.0993,57.1173935 L144.218388,45.9229419 L152.960844,57.391329 Z"
              id="Fill-389"
              fill="#3424C7"
            />
            <path
              d="M192.146212,32.8925548 C193.127232,35.3920387 182.866327,43.1275226 182.866327,43.1275226 L177.794878,39.8828774 C183.203286,34.9520387 190.91496,29.7543613 192.146212,32.8925548"
              id="Fill-391"
              fill="#3424C7"
            />
            <path
              d="M196.311567,16.6923226 C196.082663,16.4254839 195.660397,16.4056129 195.374622,16.6497419 L156.254656,50.074129 C155.970302,50.3182581 155.924805,50.7369677 156.15371,51.0038065 L168.483288,65.3847097 C168.712193,65.6529677 169.133037,65.6728387 169.41739,65.4287097 L208.538778,32.0043226 C208.824554,31.7601935 208.87005,31.3414839 208.641146,31.0746452 L196.311567,16.6923226 Z"
              id="Fill-393"
              fill="#7264D6"
            />
            <path
              d="M161.770407,51.1112516 C161.830122,51.1808 161.823013,51.2858323 161.751924,51.3454452 L159.819741,52.9975742 C159.750074,53.0571871 159.643441,53.048671 159.583727,52.9791226 L157.927367,51.0459613 C157.866231,50.9749935 157.874761,50.8699613 157.94585,50.8103484 L159.878033,49.1596387 C159.9477,49.1000258 160.052911,49.1085419 160.112625,49.1780903 L161.770407,51.1112516 Z"
              id="Fill-395"
              fill="#C1BBF9"
            />
            <path
              d="M168.058748,50.3506194 C168.118463,50.4215871 168.112776,50.5266194 168.041687,50.5862323 L166.108082,52.2369419 C166.039837,52.2965548 165.934626,52.2880387 165.87349,52.217071 L164.215707,50.2839097 C164.157415,50.2157806 164.164524,50.1107484 164.23419,50.0511355 L166.166374,48.4004258 C166.237463,48.3393935 166.341252,48.3479097 166.400966,48.4174581 L168.058748,50.3506194 Z"
              id="Fill-397"
              fill="#C1BBF9"
            />
            <path
              d="M170.972379,52.4758194 C171.032093,52.5453677 171.023563,52.6504 170.953896,52.7100129 L169.02029,54.3607226 C168.952046,54.4189161 168.846835,54.4132387 168.785699,54.3436903 L167.127916,52.4091097 C167.069624,52.3409806 167.078154,52.234529 167.147821,52.1749161 L169.080005,50.5242065 C169.149671,50.4645935 169.254882,50.4731097 169.313175,50.5412387 L170.972379,52.4758194 Z"
              id="Fill-399"
              fill="#C1BBF9"
            />
            <path
              d="M171.951978,56.2515871 C172.011692,56.3211355 172.003161,56.4261677 171.933495,56.4857806 L170.001311,58.1364903 C169.933066,58.1961032 169.826433,58.1875871 169.766719,58.1180387 L168.108937,56.1848774 C168.049222,56.115329 168.057753,56.0088774 168.12742,55.9506839 L170.059603,54.2985548 C170.12927,54.2389419 170.234481,54.2488774 170.294195,54.3184258 L171.951978,56.2515871 Z"
              id="Fill-401"
              fill="#C1BBF9"
            />
            <path
              d="M171.189625,62.0987613 C171.249339,62.1683097 171.242231,62.2733419 171.172564,62.3329548 L169.238959,63.9836645 C169.169292,64.0432774 169.064081,64.0361806 169.004367,63.9652129 L167.057965,61.6956645 C166.999673,61.6275355 167.006782,61.5210839 167.075027,61.461471 L169.008632,59.8093419 C169.078299,59.749729 169.184931,59.7596645 169.243224,59.8277935 L171.189625,62.0987613 Z"
              id="Fill-403"
              fill="#C1BBF9"
            />
            <path
              d="M173.843641,59.8314839 C173.903355,59.9010323 173.894824,60.0060645 173.825158,60.0656774 L171.892974,61.7163871 C171.824729,61.776 171.718097,61.7674839 171.658382,61.6979355 L169.711981,59.4269677 C169.653688,59.3588387 169.660797,59.2523871 169.730464,59.1941935 L171.662648,57.5420645 C171.732314,57.4824516 171.838947,57.4923871 171.897239,57.5605161 L173.843641,59.8314839 Z"
              id="Fill-405"
              fill="#C1BBF9"
            />
            <path
              d="M176.498367,57.5625032 C176.558082,57.6320516 176.549551,57.7370839 176.479884,57.7966968 L174.547701,59.4488258 C174.478034,59.5084387 174.372823,59.4999226 174.313109,59.4303742 L172.366707,57.1594065 C172.308415,57.0912774 172.315524,56.9848258 172.383769,56.9266323 L174.317374,55.2745032 C174.387041,55.2148903 174.493673,55.2248258 174.551966,55.2929548 L176.498367,57.5625032 Z"
              id="Fill-407"
              fill="#C1BBF9"
            />
            <path
              d="M199.171029,38.1911484 C199.230743,38.2606968 199.222212,38.3671484 199.152546,38.4267613 L197.21894,40.077471 C197.150695,40.1370839 197.044063,40.1285677 196.984348,40.0590194 L195.037947,37.7880516 C194.979654,37.7199226 194.986763,37.6148903 195.05643,37.5552774 L196.990035,35.9031484 C197.05828,35.8435355 197.166335,35.8520516 197.224627,35.9201806 L199.171029,38.1911484 Z"
              id="Fill-409"
              fill="#C1BBF9"
            />
            <path
              d="M201.8313,35.9180516 C201.891014,35.9876 201.883905,36.0926323 201.814239,36.1522452 L199.882055,37.8029548 C199.810967,37.8625677 199.705756,37.855471 199.646041,37.7859226 L198.780184,36.7753419 C198.721892,36.7072129 198.729001,36.6007613 198.800089,36.5411484 L200.732273,34.8904387 C200.801939,34.8308258 200.908572,34.8407613 200.966865,34.9088903 L201.8313,35.9180516 Z"
              id="Fill-411"
              fill="#C1BBF9"
            />
            <path
              d="M207.154544,31.369871 C207.214259,31.4394194 207.20715,31.5444516 207.136061,31.6040645 L205.203878,33.2547742 C205.135633,33.3143871 205.029,33.3072903 204.969286,33.2377419 L204.103429,32.2285806 C204.043714,32.1590323 204.052245,32.0525806 204.123333,31.9929677 L206.055517,30.3422581 C206.123762,30.2826452 206.230395,30.2911613 206.290109,30.3607097 L207.154544,31.369871 Z"
              id="Fill-413"
              fill="#C1BBF9"
            />
            <path
              d="M179.845922,54.702929 C179.905636,54.7724774 179.897105,54.8775097 179.828861,54.9357032 L177.201432,57.1811226 C177.131765,57.2407355 177.027976,57.2308 176.968262,57.1612516 L175.020439,54.8917032 C174.962146,54.8235742 174.969255,54.7171226 175.038922,54.6575097 L177.66635,52.4135097 C177.734595,52.3553161 177.841228,52.3638323 177.89952,52.4319613 L179.845922,54.702929 Z"
              id="Fill-415"
              fill="#C1BBF9"
            />
            <path
              d="M196.508624,40.4660903 C196.568339,40.5356387 196.56123,40.640671 196.490141,40.7002839 L193.864135,42.9442839 C193.79589,43.0024774 193.689257,42.9953806 193.629543,42.9258323 L191.683141,40.6562839 C191.624849,40.5867355 191.63338,40.4802839 191.701624,40.4220903 L194.327631,38.176671 C194.39872,38.1170581 194.503931,38.1269935 194.562223,38.1951226 L196.508624,40.4660903 Z"
              id="Fill-417"
              fill="#C1BBF9"
            />
            <path
              d="M193.154246,43.3319097 C193.21396,43.4028774 193.205429,43.5079097 193.135763,43.5675226 L180.557375,54.3148774 C180.487708,54.373071 180.382497,54.3659742 180.321361,54.2964258 L178.37496,52.0254581 C178.316667,51.957329 178.325198,51.8494581 178.393443,51.7912645 L190.971831,41.0439097 C191.042919,40.9842968 191.149552,40.9942323 191.207844,41.0623613 L193.154246,43.3319097 Z"
              id="Fill-419"
              fill="#C1BBF9"
            />
            <path
              d="M174.61296,53.9776387 C174.672674,54.0471871 174.665565,54.1522194 174.595899,54.2118323 L172.662293,55.8639613 C172.594048,55.9221548 172.487416,55.9136387 172.427701,55.8440903 L170.771341,53.910929 C170.711627,53.8413806 170.720157,53.734929 170.788402,53.6767355 L172.720586,52.0246065 C172.790252,51.9649935 172.895463,51.974929 172.955178,52.0430581 L174.61296,53.9776387 Z"
              id="Fill-421"
              fill="#C1BBF9"
            />
            <path
              d="M177.274511,51.7038323 C177.334225,51.7733806 177.327116,51.8784129 177.25745,51.9366065 L175.325266,53.5887355 C175.255599,53.6483484 175.148967,53.6398323 175.089252,53.5702839 L173.43147,51.6371226 C173.373178,51.5675742 173.380286,51.4611226 173.449953,51.4015097 L175.382137,49.7508 C175.451803,49.6911871 175.557014,49.7011226 175.616729,49.770671 L177.274511,51.7038323 Z"
              id="Fill-423"
              fill="#C1BBF9"
            />
            <path
              d="M179.936204,49.4291742 C179.995918,49.4987226 179.98881,49.6037548 179.917721,49.6633677 L177.985537,51.3154968 C177.917293,51.3736903 177.809238,51.3665935 177.749524,51.2970452 L176.093163,49.3638839 C176.033449,49.2943355 176.04198,49.1864645 176.111646,49.128271 L178.042408,47.4775613 C178.113497,47.4179484 178.218707,47.4264645 178.278422,47.4960129 L179.936204,49.4291742 Z"
              id="Fill-425"
              fill="#C1BBF9"
            />
            <path
              d="M182.597897,47.1553677 C182.657612,47.2249161 182.649081,47.3313677 182.580836,47.3895613 L180.647231,49.040271 C180.578986,49.0998839 180.472353,49.0913677 180.412639,49.0218194 L178.754856,47.0886581 C178.695142,47.0191097 178.703673,46.9126581 178.773339,46.8530452 L180.705523,45.2023355 C180.77519,45.1441419 180.880401,45.1526581 180.940115,45.2222065 L182.597897,47.1553677 Z"
              id="Fill-427"
              fill="#C1BBF9"
            />
            <path
              d="M185.259448,44.8811355 C185.319163,44.9506839 185.310632,45.0557161 185.240965,45.115329 L183.308782,46.7674581 C183.240537,46.8256516 183.133904,46.8171355 183.07419,46.7475871 L181.416407,44.8144258 C181.358115,44.7448774 181.365224,44.6384258 181.43489,44.5802323 L183.367074,42.9281032 C183.436741,42.8699097 183.541952,42.8784258 183.601666,42.9479742 L185.259448,44.8811355 Z"
              id="Fill-429"
              fill="#C1BBF9"
            />
            <path
              d="M187.921141,42.6076129 C187.980856,42.6771613 187.973747,42.7821935 187.90408,42.8403871 L185.970475,44.4939355 C185.900808,44.552129 185.794176,44.5436129 185.735883,44.4740645 L184.078101,42.5409032 C184.018386,42.4713548 184.025495,42.3663226 184.095162,42.3067097 L186.028767,40.6545806 C186.098434,40.5949677 186.203645,40.6049032 186.263359,40.6730323 L187.921141,42.6076129 Z"
              id="Fill-431"
              fill="#C1BBF9"
            />
            <path
              d="M190.582835,40.3330968 C190.642549,40.4026452 190.634018,40.5090968 190.564352,40.5687097 L188.632168,42.2194194 C188.562501,42.2776129 188.45729,42.2690968 188.397576,42.1995484 L186.739794,40.2663871 C186.68008,40.1968387 186.68861,40.0918065 186.756855,40.0321935 L188.689039,38.3814839 C188.758705,38.321871 188.865338,38.3303871 188.925052,38.3999355 L190.582835,40.3330968 Z"
              id="Fill-433"
              fill="#C1BBF9"
            />
            <path
              d="M193.244386,38.0591484 C193.3041,38.1286968 193.295569,38.233729 193.225903,38.2933419 L191.293719,39.945471 C191.225474,40.0036645 191.11742,39.9965677 191.057705,39.9270194 L189.399923,37.9924387 C189.341631,37.9243097 189.350161,37.8164387 189.418406,37.7582452 L191.35059,36.1075355 C191.421678,36.0479226 191.526889,36.0564387 191.586603,36.1245677 L193.244386,38.0591484 Z"
              id="Fill-435"
              fill="#C1BBF9"
            />
            <path
              d="M195.905368,35.7853419 C195.965082,35.8548903 195.957973,35.9599226 195.888307,36.0195355 L193.954701,37.6716645 C193.885035,37.7312774 193.779824,37.7227613 193.72011,37.6532129 L192.062327,35.7186323 C192.002613,35.6505032 192.009722,35.5440516 192.08081,35.4844387 L194.012994,33.833729 C194.082661,33.7726968 194.187871,33.7826323 194.247586,33.8521806 L195.905368,35.7853419 Z"
              id="Fill-437"
              fill="#C1BBF9"
            />
            <path
              d="M198.567772,33.5111097 C198.627486,33.5806581 198.618956,33.6871097 198.549289,33.7453032 L196.615684,35.3974323 C196.547439,35.4556258 196.440806,35.448529 196.381092,35.3789806 L194.72331,33.4444 C194.665017,33.376271 194.672126,33.2698194 194.741793,33.2102065 L196.673976,31.5594968 C196.743643,31.4998839 196.850276,31.5084 196.90999,31.576529 L198.567772,33.5111097 Z"
              id="Fill-439"
              fill="#C1BBF9"
            />
            <path
              d="M204.561665,28.3890839 C204.621379,28.4586323 204.61427,28.5636645 204.544603,28.6232774 L199.278372,33.1226323 C199.208705,33.1822452 199.102073,33.173729 199.04378,33.1041806 L197.385998,31.1710194 C197.326284,31.101471 197.334814,30.9950194 197.403059,30.9354065 L202.66929,26.4360516 C202.740379,26.3764387 202.844168,26.3863742 202.903882,26.4559226 L204.561665,28.3890839 Z"
              id="Fill-441"
              fill="#C1BBF9"
            />
            <path
              d="M173.633361,50.2020129 C173.693076,50.2729806 173.685967,50.3751742 173.6163,50.4347871 L171.681273,52.0869161 C171.613028,52.146529 171.509239,52.1394323 171.448103,52.0684645 L169.79032,50.1338839 C169.732028,50.0657548 169.739137,49.9607226 169.808803,49.902529 L171.742409,48.2489806 C171.812076,48.1893677 171.915865,48.1993032 171.974157,48.2674323 L173.633361,50.2020129 Z"
              id="Fill-443"
              fill="#C1BBF9"
            />
            <path
              d="M176.295054,47.9273548 C176.354769,47.9983226 176.346238,48.1019355 176.276571,48.1615484 L174.342966,49.8136774 C174.274721,49.871871 174.170932,49.8647742 174.109796,49.7938065 L172.452014,47.8592258 C172.393721,47.7910968 172.40083,47.6860645 172.470497,47.627871 L174.40268,45.9757419 C174.472347,45.916129 174.577558,45.9246452 174.637272,45.9927742 L176.295054,47.9273548 Z"
              id="Fill-445"
              fill="#C1BBF9"
            />
            <path
              d="M178.955895,45.6542581 C179.015609,45.7252258 179.0085,45.8274194 178.938833,45.8870323 L177.005228,47.5391613 C176.936983,47.5987742 176.831772,47.5916774 176.772058,47.5207097 L175.112854,45.586129 C175.054561,45.518 175.06167,45.4129677 175.131337,45.3533548 L177.064942,43.7012258 C177.134609,43.6416129 177.238398,43.6515484 177.29669,43.7196774 L178.955895,45.6542581 Z"
              id="Fill-447"
              fill="#C1BBF9"
            />
            <path
              d="M181.618299,43.3796 C181.678013,43.4491484 181.669482,43.5541806 181.601237,43.6123742 L179.66621,45.2659226 C179.597965,45.3241161 179.492754,45.3170194 179.43304,45.2460516 L177.775258,43.311471 C177.716965,43.2447613 177.724074,43.1383097 177.793741,43.0801161 L179.727346,41.4279871 C179.795591,41.3683742 179.900802,41.3768903 179.959095,41.4450194 L181.618299,43.3796 Z"
              id="Fill-449"
              fill="#C1BBF9"
            />
            <path
              d="M184.279281,41.1057935 C184.338995,41.1767613 184.330465,41.2803742 184.260798,41.3399871 L182.328614,42.9906968 C182.260369,43.0488903 182.153737,43.0432129 182.094022,42.9722452 L180.43624,41.0390839 C180.376526,40.9709548 180.386478,40.8630839 180.454723,40.8048903 L182.386907,39.1541806 C182.456573,39.0945677 182.561784,39.1030839 182.620077,39.1712129 L184.279281,41.1057935 Z"
              id="Fill-451"
              fill="#C1BBF9"
            />
            <path
              d="M186.940832,38.8318452 C187.000546,38.9028129 186.992016,39.0064258 186.922349,39.0660387 L184.990165,40.7167484 C184.920499,40.7763613 184.81671,40.7692645 184.755573,40.6982968 L183.097791,38.7637161 C183.039499,38.6955871 183.046607,38.5905548 183.116274,38.5309419 L185.048458,36.8802323 C185.118124,36.8206194 185.223335,36.8291355 185.281628,36.8972645 L186.940832,38.8318452 Z"
              id="Fill-453"
              fill="#C1BBF9"
            />
            <path
              d="M189.602525,36.5580387 C189.662239,36.6290065 189.655131,36.7326194 189.584042,36.7922323 L187.650437,38.4429419 C187.582192,38.5025548 187.476981,38.4954581 187.417267,38.4244903 L185.759484,36.4899097 C185.701192,36.4217806 185.708301,36.3167484 185.777967,36.2571355 L187.710151,34.6064258 C187.779818,34.5468129 187.885029,34.555329 187.943321,34.6234581 L189.602525,36.5580387 Z"
              id="Fill-455"
              fill="#C1BBF9"
            />
            <path
              d="M192.264218,34.2838065 C192.323933,34.3533548 192.315402,34.4583871 192.245735,34.518 L190.31213,36.1687097 C190.243885,36.2283226 190.138674,36.2212258 190.07896,36.1502581 L188.421178,34.2156774 C188.362885,34.1489677 188.369994,34.0425161 188.439661,33.9829032 L190.371844,32.3321935 C190.441511,32.2725806 190.546722,32.2810968 190.605014,32.3492258 L192.264218,34.2838065 Z"
              id="Fill-457"
              fill="#C1BBF9"
            />
            <path
              d="M194.925912,32.0095742 C194.985626,32.0805419 194.977095,32.1841548 194.907429,32.2437677 L192.973823,33.8944774 C192.904156,33.9555097 192.800367,33.9469935 192.740653,33.8774452 L191.081449,31.9428645 C191.023156,31.8747355 191.030265,31.7682839 191.101354,31.7100903 L193.033537,30.0579613 C193.103204,29.9983484 193.208415,30.0068645 193.266707,30.0749935 L194.925912,32.0095742 Z"
              id="Fill-459"
              fill="#C1BBF9"
            />
            <path
              d="M197.586752,29.7360516 C197.646466,29.8056 197.637935,29.9106323 197.568269,29.9702452 L195.636085,31.6209548 C195.566418,31.6805677 195.461207,31.673471 195.401493,31.6025032 L193.743711,29.6679226 C193.685418,29.5997935 193.692527,29.4947613 193.763616,29.4351484 L195.694378,27.7844387 C195.764044,27.7248258 195.869255,27.7333419 195.927548,27.801471 L197.586752,29.7360516 Z"
              id="Fill-461"
              fill="#C1BBF9"
            />
            <path
              d="M200.249156,27.4615355 C200.30887,27.5310839 200.300339,27.6361161 200.230673,27.695729 L198.297067,29.3478581 C198.227401,29.407471 198.123612,29.3989548 198.063897,29.3279871 L196.404693,27.3948258 C196.346401,27.3252774 196.35351,27.2216645 196.423176,27.1620516 L198.356782,25.5099226 C198.426448,25.4503097 198.531659,25.4588258 198.589952,25.5269548 L200.249156,27.4615355 Z"
              id="Fill-463"
              fill="#C1BBF9"
            />
            <path
              d="M170.720441,48.0768129 C170.780156,48.1477806 170.773047,48.2528129 170.70338,48.3124258 L168.769775,49.9645548 C168.70153,50.0227484 168.594897,50.0142323 168.533761,49.9446839 L166.875979,48.0101032 C166.817686,47.9419742 166.826217,47.8355226 166.895884,47.777329 L168.828067,46.1252 C168.897734,46.0655871 169.002945,46.0741032 169.062659,46.1436516 L170.720441,48.0768129 Z"
              id="Fill-465"
              fill="#C1BBF9"
            />
            <path
              d="M173.381282,45.8028645 C173.442418,45.8738323 173.433887,45.9788645 173.36422,46.0384774 L171.430615,47.6906065 C171.36237,47.7488 171.257159,47.7402839 171.196023,47.6693161 L169.538241,45.7361548 C169.478527,45.6680258 169.487057,45.5629935 169.556724,45.5033806 L171.488907,43.8512516 C171.559996,43.7916387 171.663785,43.8001548 171.723499,43.8697032 L173.381282,45.8028645 Z"
              id="Fill-467"
              fill="#C1BBF9"
            />
            <path
              d="M176.042975,43.5290581 C176.102689,43.6000258 176.09558,43.7050581 176.025914,43.764671 L174.092308,45.4153806 C174.024063,45.4749935 173.918852,45.4664774 173.857716,45.3955097 L172.199934,43.4623484 C172.141641,43.3928 172.150172,43.2877677 172.218417,43.2295742 L174.150601,41.5774452 C174.220267,41.5178323 174.325478,41.5263484 174.385193,41.5944774 L176.042975,43.5290581 Z"
              id="Fill-469"
              fill="#C1BBF9"
            />
            <path
              d="M178.703957,41.2555355 C178.763671,41.3265032 178.756563,41.4315355 178.688318,41.489729 L176.754712,43.1418581 C176.685046,43.201471 176.579835,43.1929548 176.518699,43.1219871 L174.860916,41.1888258 C174.802624,41.1192774 174.811154,41.0142452 174.880821,40.9546323 L176.813005,39.3039226 C176.88125,39.2443097 176.986461,39.2528258 177.046175,39.3209548 L178.703957,41.2555355 Z"
              id="Fill-471"
              fill="#C1BBF9"
            />
            <path
              d="M181.36565,38.9813032 C181.426786,39.052271 181.418256,39.1573032 181.348589,39.2169161 L179.416405,40.8676258 C179.346739,40.9272387 179.241528,40.9187226 179.180392,40.8477548 L177.524031,38.9145935 C177.464317,38.8450452 177.472848,38.7400129 177.541093,38.6818194 L179.473276,37.0296903 C179.544365,36.9700774 179.649576,36.9785935 179.707868,37.0481419 L181.36565,38.9813032 Z"
              id="Fill-473"
              fill="#C1BBF9"
            />
            <path
              d="M184.02649,36.7077806 C184.087627,36.7787484 184.080518,36.8823613 184.010851,36.9419742 L182.077246,38.5941032 C182.007579,38.6537161 181.902368,38.6452 181.842654,38.5742323 L180.18345,36.641071 C180.125157,36.5715226 180.133688,36.4664903 180.203354,36.4068774 L182.135538,34.7561677 C182.205205,34.6965548 182.308994,34.705071 182.368708,34.7732 L184.02649,36.7077806 Z"
              id="Fill-475"
              fill="#C1BBF9"
            />
            <path
              d="M186.688895,34.4331226 C186.748609,34.5040903 186.7415,34.6091226 186.671833,34.6687355 L184.738228,36.3208645 C184.669983,36.3790581 184.564772,36.3705419 184.503636,36.2995742 L182.845854,34.3664129 C182.787561,34.2982839 182.79467,34.1918323 182.864337,34.1336387 L184.79652,32.4815097 C184.867609,32.4218968 184.971398,32.4304129 185.02969,32.4999613 L186.688895,34.4331226 Z"
              id="Fill-477"
              fill="#C1BBF9"
            />
            <path
              d="M189.350588,32.1588903 C189.410302,32.2298581 189.403193,32.3348903 189.333527,32.3945032 L187.399921,34.0466323 C187.331676,34.1048258 187.225044,34.0963097 187.165329,34.0267613 L185.507547,32.0921806 C185.447833,32.0240516 185.456363,31.9190194 185.52603,31.8594065 L187.458214,30.2072774 C187.52788,30.1476645 187.633091,30.1561806 187.692805,30.225729 L189.350588,32.1588903 Z"
              id="Fill-479"
              fill="#C1BBF9"
            />
            <path
              d="M192.011428,29.8853677 C192.072564,29.9563355 192.064033,30.0613677 191.995788,30.1195613 L190.062183,31.7716903 C189.992516,31.8313032 189.887305,31.8227871 189.827591,31.7518194 L188.169809,29.8172387 C188.110095,29.7491097 188.117203,29.6440774 188.188292,29.5844645 L190.120476,27.9337548 C190.18872,27.8741419 190.293931,27.8826581 190.353646,27.9522065 L192.011428,29.8853677 Z"
              id="Fill-481"
              fill="#C1BBF9"
            />
            <path
              d="M194.673121,27.6111355 C194.734257,27.6821032 194.725727,27.7871355 194.65606,27.8467484 L192.722454,29.4988774 C192.655631,29.557071 192.548999,29.5485548 192.487863,29.4775871 L190.83008,27.5444258 C190.771788,27.4762968 190.780318,27.3698452 190.848563,27.3116516 L192.780747,25.6595226 C192.851835,25.5999097 192.957046,25.6084258 193.015339,25.6765548 L194.673121,27.6111355 Z"
              id="Fill-483"
              fill="#C1BBF9"
            />
            <path
              d="M197.334814,25.337329 C197.394529,25.4082968 197.38742,25.513329 197.319175,25.5715226 L195.385569,27.2236516 C195.315903,27.2832645 195.210692,27.2747484 195.149556,27.2037806 L193.491773,25.2706194 C193.432059,25.2024903 193.44059,25.0974581 193.510256,25.0378452 L195.443862,23.3857161 C195.513529,23.3261032 195.617318,23.3346194 195.677032,23.4041677 L197.334814,25.337329 Z"
              id="Fill-485"
              fill="#C1BBF9"
            />
            <path
              d="M165.397766,52.6251355 C165.45748,52.6961032 165.450371,52.7997161 165.380705,52.859329 L162.103528,55.6597161 C162.032439,55.7207484 161.927229,55.7122323 161.867514,55.6412645 L160.209732,53.7066839 C160.150018,53.6385548 160.157127,53.5335226 160.228215,53.4739097 L163.505392,50.6735226 C163.575059,50.6139097 163.680269,50.6224258 163.738562,50.6905548 L165.397766,52.6251355 Z"
              id="Fill-487"
              fill="#C1BBF9"
            />
            <path
              d="M197.713858,20.4010968 C197.773572,20.4706452 197.766463,20.5756774 197.696797,20.6352903 L194.418198,23.4356774 C194.349953,23.493871 194.244742,23.4867742 194.185028,23.4172258 L192.527246,21.4840645 C192.467531,21.4130968 192.476062,21.3080645 192.544307,21.249871 L195.821484,18.4494839 C195.89115,18.389871 195.996361,18.3983871 196.056076,18.4679355 L197.713858,20.4010968 Z"
              id="Fill-489"
              fill="#C1BBF9"
            />
            <path
              d="M168.310117,54.7500516 C168.369831,54.8210194 168.362722,54.9232129 168.291634,54.9842452 L164.384614,58.3225677 C164.314947,58.3821806 164.211158,58.3750839 164.150022,58.3041161 L162.492239,56.3709548 C162.433947,56.3028258 162.441056,56.1963742 162.510722,56.1367613 L166.417743,52.7984387 C166.488831,52.7388258 166.59262,52.7473419 166.650913,52.815471 L168.310117,54.7500516 Z"
              id="Fill-491"
              fill="#C1BBF9"
            />
            <path
              d="M169.290995,58.5246839 C169.35071,58.5942323 169.342179,58.6992645 169.272512,58.7588774 L166.667832,60.9858452 C166.598165,61.0454581 166.491533,61.0369419 166.43324,60.9673935 L164.775458,59.0328129 C164.715744,58.9646839 164.722852,58.8582323 164.792519,58.7986194 L167.397199,56.573071 C167.468288,56.5134581 167.573499,56.5219742 167.633213,56.5915226 L169.290995,58.5246839 Z"
              id="Fill-493"
              fill="#C1BBF9"
            />
            <path
              d="M164.43139,48.8374452 C164.491104,48.9069935 164.483995,49.0120258 164.412907,49.0730581 L162.480723,50.7237677 C162.412478,50.7819613 162.305846,50.7734452 162.246131,50.7038968 L160.588349,48.7707355 C160.528635,48.7011871 160.537165,48.5961548 160.606832,48.5365419 L162.539016,46.8858323 C162.608682,46.8262194 162.713893,46.8347355 162.773607,46.9042839 L164.43139,48.8374452 Z"
              id="Fill-495"
              fill="#C1BBF9"
            />
            <path
              d="M167.093083,46.5632129 C167.152797,46.6327613 167.145688,46.7392129 167.076022,46.7974065 L165.142416,48.4495355 C165.074171,48.5091484 164.967539,48.5006323 164.907824,48.4296645 L163.250042,46.4965032 C163.190328,46.4269548 163.198859,46.3219226 163.268525,46.263729 L165.200709,44.6116 C165.270376,44.5519871 165.375586,44.5605032 165.435301,44.6300516 L167.093083,46.5632129 Z"
              id="Fill-497"
              fill="#C1BBF9"
            />
            <path
              d="M169.755487,44.2889806 C169.815201,44.358529 169.806671,44.4649806 169.737004,44.5245935 L167.803399,46.1753032 C167.735154,46.2349161 167.628521,46.2264 167.568807,46.1568516 L165.912446,44.2236903 C165.85131,44.1527226 165.859841,44.0491097 165.929507,43.9894968 L167.861691,42.3373677 C167.931358,42.2777548 168.03799,42.2848516 168.097705,42.3558194 L169.755487,44.2889806 Z"
              id="Fill-499"
              fill="#C1BBF9"
            />
            <path
              d="M172.416327,42.0157419 C172.476041,42.0852903 172.467511,42.1903226 172.397844,42.2499355 L170.464239,43.9020645 C170.395994,43.9602581 170.289361,43.9531613 170.229647,43.8836129 L168.573286,41.9490323 C168.51215,41.8794839 168.522103,41.7744516 168.590348,41.7148387 L170.523953,40.064129 C170.59362,40.0045161 170.698831,40.0116129 170.758545,40.0811613 L172.416327,42.0157419 Z"
              id="Fill-501"
              fill="#C1BBF9"
            />
            <path
              d="M175.076599,39.7422194 C175.136313,39.8117677 175.129204,39.9168 175.059537,39.9764129 L173.125932,41.6285419 C173.057687,41.6867355 172.951054,41.6796387 172.89134,41.608671 L171.23498,39.6755097 C171.173844,39.6059613 171.182374,39.500929 171.252041,39.4413161 L173.185646,37.7891871 C173.255313,37.7295742 173.359102,37.7395097 173.418816,37.8090581 L175.076599,39.7422194 Z"
              id="Fill-503"
              fill="#C1BBF9"
            />
            <path
              d="M177.739003,37.4679871 C177.798717,37.5375355 177.791608,37.6425677 177.721941,37.7021806 L175.789758,39.3528903 C175.720091,39.4125032 175.613459,39.4039871 175.553744,39.3344387 L173.897384,37.4012774 C173.836248,37.3303097 173.844778,37.2266968 173.915867,37.1656645 L175.846629,35.5163742 C175.916295,35.4567613 176.021506,35.4652774 176.08122,35.5348258 L177.739003,37.4679871 Z"
              id="Fill-505"
              fill="#C1BBF9"
            />
            <path
              d="M180.399274,35.1947484 C180.458988,35.2642968 180.453301,35.3679097 180.382213,35.4275226 L178.450029,37.0796516 C178.380363,37.1392645 178.275152,37.1307484 178.215437,37.0612 L176.557655,35.1280387 C176.497941,35.057071 176.50505,34.9534581 176.576138,34.8924258 L178.508322,33.2417161 C178.577988,33.1821032 178.681778,33.1906194 178.741492,33.2615871 L180.399274,35.1947484 Z"
              id="Fill-507"
              fill="#C1BBF9"
            />
            <path
              d="M183.061536,32.9202323 C183.12125,32.9897806 183.114141,33.0948129 183.043053,33.1544258 L181.110869,34.8065548 C181.041203,34.8661677 180.935992,34.8576516 180.874856,34.7866839 L179.218495,32.8535226 C179.157359,32.7839742 179.16589,32.6789419 179.236978,32.619329 L181.169162,30.9686194 C181.238829,30.9090065 181.344039,30.9161032 181.403754,30.9856516 L183.061536,32.9202323 Z"
              id="Fill-509"
              fill="#C1BBF9"
            />
            <path
              d="M185.722518,30.646 C185.782233,30.7155484 185.775124,30.8205806 185.705457,30.8801935 L183.773273,32.5309032 C183.703607,32.5919355 183.598396,32.5834194 183.53726,32.5124516 L181.880899,30.5792903 C181.821185,30.5097419 181.828294,30.4047097 181.899382,30.3450968 L183.831566,28.6943871 C183.901233,28.6347742 184.005022,28.6432903 184.064736,28.7128387 L185.722518,30.646 Z"
              id="Fill-511"
              fill="#C1BBF9"
            />
            <path
              d="M188.384922,28.3714839 C188.444637,28.4410323 188.436106,28.5474839 188.367861,28.6056774 L186.434256,30.2578065 C186.366011,30.3174194 186.259378,30.3089032 186.199664,30.2379355 L184.541882,28.3047742 C184.482167,28.2352258 184.490698,28.1301935 184.560365,28.072 L186.492548,26.419871 C186.562215,26.3602581 186.667426,26.3687742 186.72714,26.4383226 L188.384922,28.3714839 Z"
              id="Fill-513"
              fill="#C1BBF9"
            />
            <path
              d="M191.046473,26.0975355 C191.106188,26.1670839 191.099079,26.2721161 191.02799,26.331729 L189.095807,27.9838581 C189.02614,28.043471 188.919507,28.0349548 188.859793,27.9654065 L187.203433,26.0322452 C187.142297,25.9612774 187.152249,25.8562452 187.221916,25.7966323 L189.154099,24.1459226 C189.223766,24.0863097 189.328977,24.0948258 189.388691,24.1643742 L191.046473,26.0975355 Z"
              id="Fill-515"
              fill="#C1BBF9"
            />
            <path
              d="M193.706745,23.8244387 C193.766459,23.8939871 193.760772,23.9990194 193.691105,24.0586323 L191.756078,25.7107613 C191.687833,25.7689548 191.582622,25.7604387 191.522908,25.6908903 L189.865126,23.757729 C189.805412,23.6881806 189.813942,23.5831484 189.882187,23.5235355 L191.815793,21.8714065 C191.885459,21.8117935 191.989248,21.8203097 192.048963,21.8912774 L193.706745,23.8244387 Z"
              id="Fill-517"
              fill="#C1BBF9"
            />
            <path
              d="M201.395954,34.4477419 L202.307308,35.5108387 C202.335744,35.5434839 202.375553,35.5661935 202.42105,35.5690323 C202.466546,35.5732903 202.510621,35.5562581 202.5419,35.5307097 L204.475505,33.8771613 C204.506784,33.8501935 204.529533,33.811871 204.532376,33.7650323 C204.536641,33.7196129 204.521002,33.6770323 204.493988,33.6429677 L203.581213,32.579871 L201.395954,34.4477419 Z"
              id="Fill-519"
              fill="#C1BBF9"
            />
            <path
              d="M203.459225,32.4372258 L202.54645,31.3727097 C202.519436,31.3414839 202.479627,31.3201935 202.43413,31.3159355 C202.388633,31.3130968 202.344559,31.3272903 202.31328,31.3542581 L200.379674,33.0063871 C200.348395,33.0347742 200.325647,33.0745161 200.321382,33.1213548 C200.318538,33.1653548 200.334178,33.2093548 200.361191,33.2405806 L201.272545,34.3050968 L203.459225,32.4372258 Z"
              id="Fill-521"
              fill="#C1BBF9"
            />
            <path
              d="M196.171239,22.763329 C196.13996,22.7902968 196.117212,22.8300387 196.114368,22.8768774 C196.111524,22.9222968 196.127164,22.9634581 196.154178,22.9961032 L197.81196,24.9292645 C197.840395,24.9619097 197.880205,24.9846194 197.925701,24.9888774 C197.971198,24.9917161 198.013851,24.9775226 198.046552,24.9505548 L198.55128,24.519071 L200.725164,27.0540387 C200.753599,27.0881032 200.793409,27.1093935 200.838905,27.1122323 C200.884402,27.1164903 200.927055,27.1008774 200.959756,27.0724903 L202.262096,25.9597161 C202.294797,25.9327484 202.316123,25.8930065 202.318967,25.8461677 C202.323232,25.8021677 202.307593,25.7581677 202.280579,25.7255226 L198.339436,21.1296516 C198.311001,21.0970065 198.272613,21.0757161 198.225695,21.0728774 C198.178776,21.0686194 198.137545,21.0842323 198.104844,21.1112 L196.171239,22.763329 Z"
              id="Fill-523"
              fill="#C1BBF9"
            />
            <path
              d="M184.81998,44.6465161 C183.246082,47.874129 179.62768,49.9407097 178.686469,53.4053548 C177.641469,57.2532258 180.314395,61.2217419 179.917721,65.1888387 C179.754218,66.8267742 179.068925,68.4050968 179.124374,70.050129 C179.192619,72.0414839 180.453728,73.9476774 182.262218,74.7921935"
              id="Stroke-525"
              stroke="#28265E"
              stroke-width="0.569"
            />
            <path
              d="M188.596624,81.5601032 L185.589583,71.8446194 C184.897182,69.6091355 182.52425,68.3572645 180.289229,69.0484903 L179.211529,69.3820387 L178.132406,69.7170065 C175.898807,70.4082323 174.647651,72.7828129 175.338631,75.0182968 L178.347093,84.7337806 C179.038073,86.9678452 181.412427,88.2197161 183.646025,87.5284903 L184.725148,87.1935226 L185.801427,86.8599742 C188.036447,86.1687484 189.287603,83.7941677 188.596624,81.5601032"
              id="Fill-527"
              fill="#FF3D81"
            />
            <path
              d="M182.159708,74.1317677 L181.890994,73.2617032 C181.659246,72.5179613 180.865899,72.100671 180.123735,72.3306065 C179.377307,72.5619613 178.96215,73.3525419 179.192477,74.0962839 L179.462613,74.9677677 C179.692939,75.712929 180.483443,76.1316387 181.229871,75.9002839 C181.970613,75.668929 182.390035,74.876929 182.159708,74.1317677"
              id="Fill-529"
              fill="#C1BBF9"
            />
            <path
              d="M182.4152,55.7844774 C183.313758,56.7198323 183.295275,58.2002194 182.379656,59.1185419 C181.439867,60.0609935 179.904356,60.0609935 178.97452,59.1100258 C175.649003,55.7064129 174.800207,53.4751871 176.439506,52.2204774 C177.694928,51.2581548 180.599601,53.8953161 182.4152,55.7844774"
              id="Fill-531"
              fill="#3424C7"
            />
            <path
              d="M176.638696,53.1419226 C176.082784,54.8337935 176.072832,54.8664387 179.011628,57.7576645 L177.970893,58.8122452 C174.678077,55.5746968 174.44775,55.059471 175.229723,52.6806323 L176.638696,53.1419226 Z"
              id="Fill-533"
              fill="#070000"
            />
            <path
              d="M185.593422,52.6729677 C186.49198,53.6069032 186.473497,55.0887097 185.557878,56.0070323 C184.618088,56.9494839 183.082578,56.9494839 182.152741,55.9985161 C178.827224,52.5949032 177.978429,50.3636774 179.617728,49.1089677 C180.87315,48.1466452 183.777823,50.7838065 185.593422,52.6729677"
              id="Fill-535"
              fill="#3424C7"
            />
            <path
              d="M179.761895,50.1922194 C179.204562,51.8840903 179.19461,51.9167355 182.134827,54.8065419 L181.094093,55.8625419 C177.801276,52.6249935 177.569528,52.1083484 178.351501,49.730929 L179.761895,50.1922194 Z"
              id="Fill-537"
              fill="#070000"
            />
            <path
              d="M188.778468,49.8419226 C189.677026,50.7772774 189.658543,52.2576645 188.742924,53.1759871 C187.803135,54.1184387 186.267624,54.1184387 185.337788,53.167471 C182.012271,49.7638581 181.163475,47.5326323 182.801352,46.2779226 C184.058196,45.3156 186.962869,47.9527613 188.778468,49.8419226"
              id="Fill-539"
              fill="#3424C7"
            />
            <path
              d="M182.946373,47.3611742 C182.390461,49.0530452 182.380509,49.0856903 185.319305,51.9769161 L184.27857,53.0314968 C180.985754,49.7939484 180.755427,49.2773032 181.5374,46.8998839 L182.946373,47.3611742 Z"
              id="Fill-541"
              fill="#070000"
            />
            <path
              d="M191.845507,46.6057935 C192.744065,47.5411484 192.725582,49.0215355 191.809963,49.9398581 C190.871596,50.8823097 189.334664,50.8823097 188.406249,49.9313419 C185.07931,46.527729 184.230514,44.2965032 185.869814,43.0417935 C187.125235,42.079471 190.029909,44.7166323 191.845507,46.6057935"
              id="Fill-543"
              fill="#3424C7"
            />
            <path
              d="M186.014123,44.1250452 C185.458212,45.8169161 185.446837,45.8495613 188.387055,48.7407871 L187.34632,49.7953677 C184.053504,46.5578194 183.823178,46.0411742 184.60515,43.6637548 L186.014123,44.1250452 Z"
              id="Fill-545"
              fill="#070000"
            />
            <path
              d="M96.6752959,28.7633677 C120.679017,20.5438839 144.21782,45.9233677 144.21782,45.9233677 L131.072146,59.9991097 L127.344269,55.0782065 L119.769085,79.2086581 L80.8183095,70.0779484 C81.0002959,68.1206581 82.4505,58.2078839 82.8301122,49.7939484 C82.9012007,48.1914968 74.9719966,38.8095613 74.9719966,38.8095613 C91.8910442,28.1033677 90.583017,30.8498194 96.6752959,28.7633677"
              id="Fill-547"
              fill="#000000"
            />
            <path
              d="M117.239474,0.618129032 C122.629399,0.618129032 123.465399,7.36006452 123.465399,7.36006452 C114.276508,4.45890323 103.798073,12.8217419 103.798073,12.8217419 C103.798073,12.8217419 111.848127,0.618129032 117.239474,0.618129032"
              id="Fill-549"
              fill="#000000"
            />
            <path
              d="M104.825443,11.7753935 C107.000749,8.72945806 113.027627,0.864812903 117.238905,0.864812903 C121.617953,0.864812903 122.879062,5.61397419 123.154885,7.01061935 C121.910837,6.66003871 120.644041,6.5095871 119.384354,6.5095871 C113.253688,6.5095871 107.289368,10.0920387 104.825443,11.7753935 M103.591348,12.6866194 L102.732599,13.9881677 L103.952477,13.0159097 C104.056266,12.9321677 114.435178,4.76945806 123.390899,7.59539355 L123.757715,7.71178065 L123.710797,7.32997419 C123.702266,7.26042581 122.783803,0.370877419 117.238905,0.370877419 C111.777892,0.370877419 103.92262,12.1841677 103.591348,12.6866194"
              id="Fill-551"
              fill="#3424C7"
            />
            <path
              d="M123.465257,7.58190968 C120.182393,3.76384516 114.421386,3.32384516 110.595407,6.60113548 C106.770849,9.87700645 106.330101,15.6296516 109.612965,19.4491355 C112.895829,23.2672 118.658257,23.7072 122.482815,20.4299097 C126.308795,17.1526194 126.748121,11.3999742 123.465257,7.58190968"
              id="Fill-553"
              fill="#EAE8FD"
            />
          </g>
          <g id="Group-558" transform="translate(106.000000, 8.000000)">
            <mask id="mask-210" fill="white">
              <use xlink:href="#path-209" />
            </mask>
            <g id="Clip-557" />
            <path
              d="M56.4417143,4.16187692 L57.3145714,22.0192615 L47.2602857,25.4614154 C51.2445714,13.2698769 37.3231429,15.6638769 41.1531429,3.89326154 L56.4417143,4.16187692 Z"
              id="Fill-556"
              fill="#EAE8FD"
              mask="url(#mask-210)"
            />
          </g>
          <g id="Group-570" transform="translate(85.000000, 0.000000)">
            <path
              d="M34.9195714,18.5662856 C36.291,20.5277402 36.7052857,22.014603 36.181,23.1114691 C35.7424286,24.0305424 34.7538571,24.3330767 34.2381429,24.3674882 L34.141,22.8748901 C34.1452857,22.8748901 34.6681429,22.8189715 34.8367143,22.4648199 C34.931,22.2683877 35.1267143,21.4654531 33.6995714,19.4265727 L34.9195714,18.5662856 Z"
              id="Fill-559"
              fill="#000000"
            />
            <path
              d="M39.6301429,14.5970644 L39.4687143,16.0839273 C38.2001429,15.9434137 37.0558571,16.3764249 36.0687143,17.365755 L35.0158571,16.3076019 C36.3187143,15.0013994 37.9144286,14.4078013 39.6301429,14.5970644"
              id="Fill-561"
              fill="#000000"
            />
            <path
              d="M32.4872857,16.7562416 L32.3258571,18.2431045 C30.9544286,18.093988 29.0258571,18.4079928 28.1515714,19.2854856 L27.0987143,18.2273325 C28.3701429,16.95124 30.7844286,16.5698461 32.4872857,16.7562416"
              id="Fill-563"
              fill="#000000"
            />
            <g id="Group-567">
              <mask id="mask-212" fill="white">
                <use xlink:href="#path-211" />
              </mask>
              <g id="Clip-566" />
              <path
                d="M1.46742857,36.8817976 C2.15028571,32.6434499 3.76457143,33.3245105 4.51028571,29.6195408 C5.25457143,25.9131373 3.51742857,26.1626206 4.51028571,22.0504483 C5.50314286,17.9368423 7.08742857,17.4694196 7.956,15.0075648 C8.82457143,12.5471437 7.86314286,10.0222011 10.4088571,6.90652807 C12.9545714,3.79085502 14.7088571,2.57785024 16.626,2.24950734 L16.626,2.24950734 C19.2988571,0.91606236 22.8331429,0.845805582 29.8402857,0.845805582 C41.1002857,0.845805582 37.8245714,10.2989268 37.8245714,10.2989268 C37.0688571,5.4038933 35.2302857,5.18738772 33.1217143,8.52530159 C32.9402857,12.9514786 28.3988571,13.633973 27.7431429,17.7059986 C27.0602857,21.9443463 29.2874286,22.6641198 27.0531429,27.5906971 C24.8174286,32.5158407 26.7202857,31.3659236 27.4645714,35.7275791 C28.2102857,40.0906684 28.2274286,38.1277801 26.7374286,41.4312825 C25.2474286,44.733351 25.9317143,44.4222139 27.0488571,48.908611 C28.166,53.3964419 26.4488571,53.5828375 25.6002857,56.512115 C24.7517143,59.4399587 25.9931429,61.6681022 25.9931429,61.6681022 L23.6988571,61.6681022 L2.61171429,61.6681022 C2.61171429,61.0745041 2.61885714,60.4565313 2.63028571,59.8213526 C2.556,58.4076142 2.25742857,56.3988439 1.28171429,54.5793367 C-0.456857143,51.338922 0.908857143,49.6570608 2.15028571,46.1040751 C3.39314286,42.5525233 0.784571429,41.1187115 1.46742857,36.8817976"
                id="Fill-565"
                fill="#3424C7"
                mask="url(#mask-212)"
              />
            </g>
            <path
              d="M13.8188571,44.8030343 C12.8588571,43.4351778 11.866,42.0214394 11.866,38.6978636 C11.866,37.2454123 12.7445714,35.990827 13.6731429,34.6631172 C14.9645714,32.8192352 16.4288571,30.7287376 16.246,27.4295367 C16.0417143,23.7503756 17.9588571,22.1445064 19.6502857,20.7264665 C20.946,19.6396372 22.1717143,18.6130279 22.596,16.6802496 C23.0002857,14.8349338 22.7474286,13.6405686 22.526,12.5852831 C22.166,10.8847823 21.856,9.4151252 24.2374286,6.81132297 C27.7945714,2.91995774 33.4645714,0.598616427 37.4231429,3.69421611 C39.646,5.43199601 40.0574286,8.25087002 38.4474286,10.7098573 L37.2017143,9.88684928 C38.6288571,7.70888915 37.7788571,5.86930861 36.5074286,4.87424322 C34.0502857,2.95293541 29.4245714,3.34866746 25.336,7.82216029 C23.4731429,9.85960686 23.666,10.7686435 23.9845714,12.2755797 C24.2245714,13.4183278 24.526,14.8406691 24.0517143,17.0028573 C23.5174286,19.4331683 21.9702857,20.7307679 20.6045714,21.8749498 C18.9774286,23.2385048 17.5717143,24.4170981 17.7345714,27.3463756 C17.946,31.1631826 16.2531429,33.5805893 14.8931429,35.5234043 C14.0688571,36.7005638 13.356,37.7185702 13.356,38.6978636 C13.356,41.5468477 14.136,42.656618 15.0374286,43.9413134 C15.7531429,44.957886 16.5617143,46.1121045 16.9088571,48.1610215 C17.2374286,50.1067041 16.6145714,51.6795957 15.956,53.3442512 C15.366,54.8339817 14.7545714,56.3753293 14.7545714,58.3812321 L13.2645714,58.3812321 C13.2645714,56.088567 13.9588571,54.336449 14.5702857,52.7922337 C15.176,51.2637903 15.6974286,49.9446834 15.4388571,48.4105048 C15.1488571,46.6956659 14.5031429,45.7765925 13.8188571,44.8030343"
              id="Fill-568"
              fill="#FF3D81"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END fiche_de_poste.svg -->

  <!-- BEGIN evaluation.svg -->
  <svg
    v-else-if="name == 'evaluation'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="150px"
    height="154px"
    viewBox="0 0 150 154"
    version="1.1"
  >
    <title>{{ label }}</title>
    <defs>
      <polygon
        id="evaluation-path-1"
        points="0.362279764 0.294497563 139.971385 0.294497563 139.971385 125.49186 0.362279764 125.49186"
      />
      <polygon
        id="evaluation-path-3"
        points="0.372528202 5.55651172 3.47956204 17.2084518 9.60072993 15.3934691 8.99688122 10.3998463 13.8076974 14.1455244 30.2049768 9.72354975 27.1499668 0.514944295 16.1771068 1.94268152 15.0506967 0.254014599"
      />
      <path
        d="M12.6119908,1.04323159 C-5.98636685,2.77976775 2.22944431,17.8083842 2.22944431,17.8083842 L2.22944431,17.8083842 L30.5636037,17.4317916 L26.2189016,45.9817186 L24.6062515,50.4147512 C26.4238757,50.9878268 28.9972834,52.4745488 32.9657317,48.506994 L32.9657317,48.506994 C34.3158465,47.1573424 35.547095,48.2997512 36.9987609,49.4416921 L36.9987609,49.4416921 C38.0872763,50.2977969 39.3002737,51.1543696 40.7804862,50.95929 L40.7804862,50.95929 C44.2327555,50.5055076 43.5972422,47.0534871 47.5043854,48.5603251 L47.5043854,48.5603251 C51.4110607,50.0671632 55.1370968,49.8692767 57.7947404,47.2125448 L57.7947404,47.2125448 C57.7947404,47.2125448 56.3631976,28.7291009 54.2081616,17.1716855 L54.2081616,17.1716855 C52.5781964,8.43239881 52.7967418,0.20677505 28.2971892,0.2081785 L28.2971892,0.2081785 C23.912709,0.2081785 18.7317312,0.472027206 12.6119908,1.04323159 L12.6119908,1.04323159 Z"
        id="evaluation-path-5"
      />
      <path
        d="M12.6119908,1.04323159 C-5.98636685,2.77976775 2.22944431,17.8083842 2.22944431,17.8083842 L2.22944431,17.8083842 L30.5636037,17.4317916 L26.2189016,45.9817186 L24.6062515,50.4147512 C26.4238757,50.9878268 28.9972834,52.4745488 32.9657317,48.506994 L32.9657317,48.506994 C34.3158465,47.1573424 35.547095,48.2997512 36.9987609,49.4416921 L36.9987609,49.4416921 C38.0872763,50.2977969 39.3002737,51.1543696 40.7804862,50.95929 L40.7804862,50.95929 C44.2327555,50.5055076 43.5972422,47.0534871 47.5043854,48.5603251 L47.5043854,48.5603251 C51.4110607,50.0671632 55.1370968,49.8692767 57.7947404,47.2125448 L57.7947404,47.2125448 C57.7947404,47.2125448 56.3631976,28.7291009 54.2081616,17.1716855 L54.2081616,17.1716855 C52.5781964,8.43239881 52.7967418,0.20677505 28.2971892,0.2081785 L28.2971892,0.2081785 C23.912709,0.2081785 18.7317312,0.472027206 12.6119908,1.04323159"
        id="evaluation-path-7"
      />
      <path
        d="M12.6119908,1.04323159 C-5.98636685,2.77976775 2.22944431,17.8083842 2.22944431,17.8083842 L2.22944431,17.8083842 L30.5636037,17.4317916 L26.2189016,45.9817186 L24.6062515,50.4147512 C26.4238757,50.9878268 28.9972834,52.4745488 32.9657317,48.506994 L32.9657317,48.506994 C34.3158465,47.1573424 35.547095,48.2997512 36.9987609,49.4416921 L36.9987609,49.4416921 C38.0872763,50.2977969 39.3002737,51.1543696 40.7804862,50.95929 L40.7804862,50.95929 C44.2327555,50.5055076 43.5972422,47.0534871 47.5043854,48.5603251 L47.5043854,48.5603251 C51.4110607,50.0671632 55.1370968,49.8692767 57.7947404,47.2125448 L57.7947404,47.2125448 C57.7947404,47.2125448 56.3631976,28.7291009 54.2081616,17.1716855 L54.2081616,17.1716855 C52.5781964,8.43239881 52.7967418,0.20677505 28.2971892,0.2081785 L28.2971892,0.2081785 C23.912709,0.2081785 18.7317312,0.472027206 12.6119908,1.04323159"
        id="evaluation-path-9"
      />
      <path
        d="M12.6119908,1.04323159 C-5.98636685,2.77976775 2.22944431,17.8083842 2.22944431,17.8083842 L2.22944431,17.8083842 L30.5636037,17.4317916 L26.2189016,45.9817186 L24.6062515,50.4147512 C26.4238757,50.9878268 28.9972834,52.4745488 32.9657317,48.506994 L32.9657317,48.506994 C34.3158465,47.1573424 35.547095,48.2997512 36.9987609,49.4416921 L36.9987609,49.4416921 C38.0872763,50.2977969 39.3002737,51.1543696 40.7804862,50.95929 L40.7804862,50.95929 C44.2327555,50.5055076 43.5972422,47.0534871 47.5043854,48.5603251 L47.5043854,48.5603251 C51.4110607,50.0671632 55.1370968,49.8692767 57.7947404,47.2125448 L57.7947404,47.2125448 C57.7947404,47.2125448 56.3631976,28.7291009 54.2081616,17.1716855 L54.2081616,17.1716855 C52.5781964,8.43239881 52.7967418,0.20677505 28.2971892,0.2081785 L28.2971892,0.2081785 C23.912709,0.2081785 18.7317312,0.472027206 12.6119908,1.04323159"
        id="evaluation-path-11"
      />
      <path
        d="M12.6119908,1.04323159 C-5.98636685,2.77976775 2.22944431,17.8083842 2.22944431,17.8083842 L2.22944431,17.8083842 L30.5636037,17.4317916 L26.2189016,45.9817186 L24.6062515,50.4147512 C26.4238757,50.9878268 28.9972834,52.4745488 32.9657317,48.506994 L32.9657317,48.506994 C34.3158465,47.1573424 35.547095,48.2997512 36.9987609,49.4416921 L36.9987609,49.4416921 C38.0872763,50.2977969 39.3002737,51.1543696 40.7804862,50.95929 L40.7804862,50.95929 C44.2327555,50.5055076 43.5972422,47.0534871 47.5043854,48.5603251 L47.5043854,48.5603251 C51.4110607,50.0671632 55.1370968,49.8692767 57.7947404,47.2125448 L57.7947404,47.2125448 C57.7947404,47.2125448 56.3631976,28.7291009 54.2081616,17.1716855 L54.2081616,17.1716855 C52.5781964,8.43239881 52.7967418,0.20677505 28.2971892,0.2081785 L28.2971892,0.2081785 C23.912709,0.2081785 18.7317312,0.472027206 12.6119908,1.04323159"
        id="evaluation-path-13"
      />
      <polygon
        id="evaluation-path-15"
        points="0.455161627 11.1270502 6.25542231 13.9750537 9.25010428 9.79562044 10.2420751 15.9322885 25.4768509 23.8939459 29.5559437 14.8492915 20.4165798 8.36736797 20.7441084 6.3189781 6.17987487 0.205452984"
      />
      <path
        d="M0.211694199,8.60032317 C9.77715328,27.8280715 17.44398,25.9877194 19.3709643,33.6669304 L19.3709643,33.6669304 C20.7323281,39.0939098 12.9398079,51.5476458 12.9398079,51.5476458 L12.9398079,51.5476458 C13.9231464,52.521179 15.028398,52.5085418 16.3354207,52.4963727 L16.3354207,52.4963727 C17.3362428,52.4870118 18.4556704,52.4771828 19.7291433,52.9105923 L19.7291433,52.9105923 C22.6654552,53.910336 20.9218133,55.2732824 24.8674529,56.9998997 L24.8674529,56.9998997 C26.6205455,57.7674932 28.1203611,57.4581156 29.5757587,57.1482699 L29.5757587,57.1482699 C31.3950058,56.7611969 33.1452632,56.3745919 35.2357434,58.0904441 L35.2357434,58.0904441 C38.9989858,61.1804758 41.9145063,61.0894911 41.9145063,61.0894911 L41.9145063,61.0894911 C47.171894,40.0285953 47.1175528,27.801861 17.5970803,0.281294924 L17.5970803,0.281294924 L0.211694199,8.60032317 Z"
        id="evaluation-path-17"
      />
      <path
        d="M0.211694199,8.60032317 C9.77715328,27.8280715 17.44398,25.9877194 19.3709643,33.6669304 L19.3709643,33.6669304 C20.7323281,39.0939098 12.9398079,51.5476458 12.9398079,51.5476458 L12.9398079,51.5476458 C13.9231464,52.521179 15.028398,52.5085418 16.3354207,52.4963727 L16.3354207,52.4963727 C17.3362428,52.4870118 18.4556704,52.4771828 19.7291433,52.9105923 L19.7291433,52.9105923 C22.6654552,53.910336 20.9218133,55.2732824 24.8674529,56.9998997 L24.8674529,56.9998997 C26.6205455,57.7674932 28.1203611,57.4581156 29.5757587,57.1482699 L29.5757587,57.1482699 C31.3950058,56.7611969 33.1452632,56.3745919 35.2357434,58.0904441 L35.2357434,58.0904441 C38.9989858,61.1804758 41.9145063,61.0894911 41.9145063,61.0894911 L41.9145063,61.0894911 C47.171894,40.0285953 47.1175528,27.801861 17.5970803,0.281294924 L17.5970803,0.281294924"
        id="evaluation-path-19"
      />
      <path
        d="M0.211694199,8.60032317 C9.77715328,27.8280715 17.44398,25.9877194 19.3709643,33.6669304 L19.3709643,33.6669304 C20.7323281,39.0939098 12.9398079,51.5476458 12.9398079,51.5476458 L12.9398079,51.5476458 C13.9231464,52.521179 15.028398,52.5085418 16.3354207,52.4963727 L16.3354207,52.4963727 C17.3362428,52.4870118 18.4556704,52.4771828 19.7291433,52.9105923 L19.7291433,52.9105923 C22.6654552,53.910336 20.9218133,55.2732824 24.8674529,56.9998997 L24.8674529,56.9998997 C26.6205455,57.7674932 28.1203611,57.4581156 29.5757587,57.1482699 L29.5757587,57.1482699 C31.3950058,56.7611969 33.1452632,56.3745919 35.2357434,58.0904441 L35.2357434,58.0904441 C38.9989858,61.1804758 41.9145063,61.0894911 41.9145063,61.0894911 L41.9145063,61.0894911 C47.171894,40.0285953 47.1175528,27.801861 17.5970803,0.281294924 L17.5970803,0.281294924"
        id="evaluation-path-21"
      />
      <path
        d="M0.211694199,8.60032317 C9.77715328,27.8280715 17.44398,25.9877194 19.3709643,33.6669304 L19.3709643,33.6669304 C20.7323281,39.0939098 12.9398079,51.5476458 12.9398079,51.5476458 L12.9398079,51.5476458 C13.9231464,52.521179 15.028398,52.5085418 16.3354207,52.4963727 L16.3354207,52.4963727 C17.3362428,52.4870118 18.4556704,52.4771828 19.7291433,52.9105923 L19.7291433,52.9105923 C22.6654552,53.910336 20.9218133,55.2732824 24.8674529,56.9998997 L24.8674529,56.9998997 C26.6205455,57.7674932 28.1203611,57.4581156 29.5757587,57.1482699 L29.5757587,57.1482699 C31.3950058,56.7611969 33.1452632,56.3745919 35.2357434,58.0904441 L35.2357434,58.0904441 C38.9989858,61.1804758 41.9145063,61.0894911 41.9145063,61.0894911 L41.9145063,61.0894911 C47.171894,40.0285953 47.1175528,27.801861 17.5970803,0.281294924 L17.5970803,0.281294924"
        id="evaluation-path-23"
      />
      <path
        d="M0.211694199,8.60032317 C9.77715328,27.8280715 17.44398,25.9877194 19.3709643,33.6669304 L19.3709643,33.6669304 C20.7323281,39.0939098 12.9398079,51.5476458 12.9398079,51.5476458 L12.9398079,51.5476458 C13.9231464,52.521179 15.028398,52.5085418 16.3354207,52.4963727 L16.3354207,52.4963727 C17.3362428,52.4870118 18.4556704,52.4771828 19.7291433,52.9105923 L19.7291433,52.9105923 C22.6654552,53.910336 20.9218133,55.2732824 24.8674529,56.9998997 L24.8674529,56.9998997 C26.6205455,57.7674932 28.1203611,57.4581156 29.5757587,57.1482699 L29.5757587,57.1482699 C31.3950058,56.7611969 33.1452632,56.3745919 35.2357434,58.0904441 L35.2357434,58.0904441 C38.9989858,61.1804758 41.9145063,61.0894911 41.9145063,61.0894911 L41.9145063,61.0894911 C47.171894,40.0285953 47.1175528,27.801861 17.5970803,0.281294924 L17.5970803,0.281294924"
        id="evaluation-path-25"
      />
      <path
        d="M0.211694199,8.60032317 C9.77715328,27.8280715 17.44398,25.9877194 19.3709643,33.6669304 L19.3709643,33.6669304 C20.7323281,39.0939098 12.9398079,51.5476458 12.9398079,51.5476458 L12.9398079,51.5476458 C13.9231464,52.521179 15.028398,52.5085418 16.3354207,52.4963727 L16.3354207,52.4963727 C17.3362428,52.4870118 18.4556704,52.4771828 19.7291433,52.9105923 L19.7291433,52.9105923 C22.6654552,53.910336 20.9218133,55.2732824 24.8674529,56.9998997 L24.8674529,56.9998997 C26.6205455,57.7674932 28.1203611,57.4581156 29.5757587,57.1482699 L29.5757587,57.1482699 C31.3950058,56.7611969 33.1452632,56.3745919 35.2357434,58.0904441 L35.2357434,58.0904441 C38.9989858,61.1804758 41.9145063,61.0894911 41.9145063,61.0894911 L41.9145063,61.0894911 C47.171894,40.0285953 47.1175528,27.801861 17.5970803,0.281294924 L17.5970803,0.281294924"
        id="evaluation-path-27"
      />
      <polygon
        id="evaluation-path-29"
        points="4.37471324 5.35050076 6.4693952 13.394585 6.07851929 19.5338652 26.2285714 3.69869292 0.428415016 0.31624512"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Competences-Socio-Pro-/-Aptitudes-Personnelles-1-"
        transform="translate(-846.000000, -805.000000)"
      >
        <g id="Formulaire" transform="translate(440.000000, 576.000000)">
          <g
            id="Illustration-Evaluation"
            transform="translate(406.000000, 229.000000)"
          >
            <g id="Group-26" transform="translate(9.854015, 0.000000)">
              <g id="Group-3">
                <mask id="evaluation-mask-2" fill="white">
                  <use xlink:href="#evaluation-path-1" />
                </mask>
                <g id="Clip-2" />
                <path
                  d="M116.776433,19.6069313 C75.1563344,-1.87464215 31.0741363,-11.9126823 14.2589461,24.4561384 C-2.55624415,60.8249591 -11.7774775,100.102932 32.7014128,116.105362 C77.1798375,132.107327 124.370855,130.167737 135.761325,90.4045176 C147.15226,50.6417637 133.615834,28.2985639 116.776433,19.6069313"
                  id="Fill-1"
                  fill="#766DFF"
                  mask="url(#evaluation-mask-2)"
                />
              </g>
              <path
                d="M76.0263104,52.6439284 C77.8849907,50.2814346 79.6905924,46.6451108 80.9519063,47.5923415 C82.2132202,48.5400374 79.5658113,56.0988082 79.5658113,56.0988082 L76.0263104,52.6439284 Z"
                id="Fill-4"
                fill="#4C3BE3"
              />
              <path
                d="M81.0920057,51.7698801 C85.3164061,49.806563 90.0734544,48.6420648 90.3151015,50.2615688 C90.5562829,51.881538 81.9766482,54.7646366 81.9766482,54.7646366 L81.0920057,51.7698801 Z"
                id="Fill-6"
                fill="#4C3BE3"
              />
              <path
                d="M82.6838499,51.6510576 C88.0447831,49.3560236 89.3461387,49.8049812 89.6562291,50.1045964 L90.1623377,49.5807351 C89.821052,49.2513444 88.7818299,48.2482848 82.3970396,50.9815758 L82.6838499,51.6510576 Z"
                id="Fill-8"
                fill="#070000"
              />
              <path
                d="M81.8535897,54.5606284 C86.0779902,52.5973113 90.835504,51.432813 91.0766855,53.052317 C91.317867,54.6722862 82.7382322,57.5553848 82.7382322,57.5553848 L81.8535897,54.5606284 Z"
                id="Fill-10"
                fill="#4C3BE3"
              />
              <path
                d="M83.9719824,54.098644 C88.5218382,52.1506799 90.0322487,52.2781559 90.4987812,52.7275788 L91.0044242,52.2037174 C90.0569256,51.2895188 87.7996906,51.6672945 83.6851721,53.4291622 L83.9719824,54.098644 Z"
                id="Fill-12"
                fill="#070000"
              />
              <path
                d="M82.4842467,57.4646628 C86.7086471,55.5013457 91.466161,54.3368474 91.7073424,55.9563514 C91.9485239,57.5763206 83.3688891,60.4594192 83.3688891,60.4594192 L82.4842467,57.4646628 Z"
                id="Fill-14"
                fill="#766DFF"
              />
              <path
                d="M84.8072246,56.9197725 C86.1188234,56.3582266 90.1113544,54.6489311 91.1268308,55.6287287 L91.6329394,55.1048673 C90.6770599,54.1827596 88.5501933,54.525177 84.5204142,56.2502907 L84.8072246,56.9197725 Z"
                id="Fill-16"
                fill="#070000"
              />
              <path
                d="M83.2153804,59.9396054 C86.9937348,58.3373154 91.8844106,57.411951 92.0808943,59.0300592 C92.2773781,60.6481675 84.6163746,62.8129339 84.6163746,62.8129339 L83.2153804,59.9396054 Z"
                id="Fill-18"
                fill="#766DFF"
              />
              <path
                d="M85.7707399,59.4899965 C88.6402406,58.4199422 90.7154255,57.8774711 91.5125349,58.7079264 L92.0386643,58.2036051 C90.9580037,57.0781871 88.8283435,57.5727383 85.516056,58.8074879 L85.7707399,59.4899965 Z"
                id="Fill-20"
                fill="#070000"
              />
              <path
                d="M44.5359265,59.9188091 C52.9539976,63.8142722 48.6392706,62.6032498 52.8292165,63.4388227 C59.2140068,64.7121873 76.5483425,65.7171079 84.6162815,62.8126083 L81.6462109,51.6859041 L56.493033,52.3000223 L43.5991367,48.7069659 L44.5359265,59.9188091 Z"
                id="Fill-22"
                fill="#4C3BE3"
              />
              <polygon
                id="Fill-24"
                fill="#7BEAFF"
                points="81.8535897 133.549155 84.9679967 145.308122 91.1036904 143.476003 90.4984087 138.436512 95.3211068 142.21706 111.757298 137.754469 108.694572 128.460814 97.6952077 129.901665 96.5670558 128.197488"
              />
            </g>
            <g id="Group-29" transform="translate(90.875912, 128.102190)">
              <mask id="evaluation-mask-4" fill="white">
                <use xlink:href="#evaluation-path-3" />
              </mask>
              <g id="Clip-28" />
              <polygon
                id="Fill-27"
                fill="#070000"
                mask="url(#evaluation-mask-4)"
                points="29.9470869 6.8400461 12.6421765 11.9719708 8.7733643 9.09759508 1.67163902 11.2034729 2.41344393 19.0004764 32.8450962 10.7369343"
              />
            </g>
            <g id="Group-36" transform="translate(52.554745, 65.693431)">
              <polygon
                id="Fill-30"
                fill="#070000"
                points="54.4865949 68.8130208 56.6814108 65.0397322 57.7104481 68.5012211 58.390447 68.5431673 60.0396878 64.751702 61.1934147 68.6354488 61.8914913 68.6261274 63.3882306 63.0626706 62.6873728 62.8720487 61.5239118 67.1985604 60.4508391 63.5893278 59.7708402 63.5473816 58.122063 67.3388469 57.1375246 64.0260337 56.476994 63.9463361 54.7114071 66.9813726 55.015483 64.0926815 54.2937663 64.0157802 53.8126219 68.5902402"
              />
              <polygon
                id="Fill-32"
                fill="#4C3BE3"
                points="51.1531632 63.5661642 51.1531632 42.3530674 36.7053876 44.2303904 38.8445799 68.07118"
              />
              <path
                d="M12.4922804,1.03942543 C52.4240242,-2.71055978 51.7899148,6.84290738 53.6931701,17.1075947 C55.8277271,28.621811 57.2456663,47.0361679 57.2456663,47.0361679 C54.6128142,49.6829695 50.9226496,49.8801164 47.0530987,48.3789105 C43.1830843,46.8777047 43.8125585,50.3163563 40.392632,50.7689086 C36.9727055,51.2214608 34.9925041,45.9726001 32.6526032,48.3257788 C28.7218664,52.2780376 26.1729133,50.7968727 24.3725617,50.225939 L25.969887,45.8099423 L30.2728387,17.3667286 L2.20793383,17.7419136 C2.20793383,17.7419136 -5.9293404,2.7694708 12.4922804,1.03942543"
                id="Fill-34"
                fill="#B7B3FF"
              />
            </g>
            <g id="Group-171" transform="translate(52.554745, 65.693431)">
              <g id="Group-158">
                <mask id="evaluation-mask-6" fill="white">
                  <use xlink:href="#evaluation-path-5" />
                </mask>
                <g id="Clip-38" />
                <polygon
                  id="Fill-37"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="5.56003944 -18.9339516 6.29242406 -18.9339516 6.29242406 -24.8041175 5.56003944 -24.8041175"
                />
                <polygon
                  id="Fill-39"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="9.85228132 -18.7089784 10.4662677 -24.546865 9.73762685 -24.6235869 9.12364051 -18.7857004"
                />
                <polygon
                  id="Fill-40"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="13.3694122 -18.113354 14.5903653 -23.8548703 13.8734239 -24.0073786 12.6529388 -18.2658623"
                />
                <polygon
                  id="Fill-41"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="16.8047407 -17.1534406 18.619557 -22.736367 17.9227387 -22.9623225 16.1079224 -17.379864"
                />
                <polygon
                  id="Fill-42"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="20.1208285 -15.8397641 22.5093852 -21.2028165 21.8401775 -21.500348 19.4516209 -16.1377634"
                />
                <polygon
                  id="Fill-43"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="23.2815011 -14.1869672 26.2175912 -19.2707329 25.5834819 -19.6370335 22.6473917 -14.5532678"
                />
                <polygon
                  id="Fill-44"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="26.2520344 -12.2128736 29.7038356 -16.9621503 29.1109083 -17.3925418 25.659107 -12.6432651"
                />
                <polygon
                  id="Fill-45"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="29.0000444 -9.93914333 32.9291827 -14.3015355 32.384457 -14.7918076 28.4553188 -10.4294154"
                />
                <polygon
                  id="Fill-46"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="31.4948319 -7.39085136 35.8587212 -11.3186417 35.3682808 -11.8631805 31.0043916 -7.93492236"
                />
                <polygon
                  id="Fill-47"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="33.7099561 -4.59573922 38.4603947 -8.04588852 38.0293875 -8.63861248 33.278949 -5.18799536"
                />
                <polygon
                  id="Fill-48"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="35.6202867 -1.58444891 40.705797 -4.51953185 40.3393707 -5.15389151 35.2538604 -2.21834074"
                />
                <polygon
                  id="Fill-49"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="37.2056537 1.60989814 42.5700786 -0.777839084 42.271977 -1.44681719 36.9070841 0.94092004"
                />
                <polygon
                  id="Fill-50"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="38.4478061 4.95244957 44.0326483 3.13825581 43.8061473 2.44167651 38.221773 4.25587027"
                />
                <polygon
                  id="Fill-51"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="39.3339213 8.40652853 45.0778759 7.18599436 44.9253152 6.46929894 39.1818286 7.69030093"
                />
                <polygon
                  id="Fill-52"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="39.8539846 11.9341951 45.6938745 11.3204194 45.6171262 10.5920285 39.7777043 11.2058042"
                />
                <polygon
                  id="Fill-53"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="40.0027078 15.4969011 45.8748882 15.4969011 45.8748882 14.7647678 40.0027078 14.7647678"
                />
                <polygon
                  id="Fill-54"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="45.6173602 19.669079 45.6941085 18.9406881 39.8542186 18.3273802 39.7774703 19.0557711"
                />
                <polygon
                  id="Fill-55"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="44.9254556 23.7918086 45.0780162 23.075581 39.3340617 21.8550468 39.181969 22.5712744"
                />
                <polygon
                  id="Fill-56"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="43.8062409 27.8194778 44.032274 27.1228985 38.4478997 25.3091725 38.2213986 26.0057518"
                />
                <polygon
                  id="Fill-57"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="42.2720238 31.708065 42.5701254 31.0390869 37.2057005 28.6513497 36.9071309 29.3203278"
                />
                <polygon
                  id="Fill-58"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="40.3393707 35.4150926 40.705797 34.7812007 35.6202867 31.84565 35.2538604 32.4800096"
                />
                <polygon
                  id="Fill-59"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="38.0296215 38.8999539 38.4606287 38.3076977 33.7101901 34.8570806 33.279183 35.4493368"
                />
                <polygon
                  id="Fill-60"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="35.368468 42.1243816 35.8589083 41.5803106 31.4950191 37.6520524 31.0045788 38.1965912"
                />
                <polygon
                  id="Fill-61"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="32.3846442 45.0530086 32.9289019 44.5627366 29.0002316 40.2003444 28.4555059 40.6906165"
                />
                <polygon
                  id="Fill-62"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="29.1110955 47.6538364 29.7040228 47.2234449 26.2522216 42.4741682 25.6592942 42.9045597"
                />
                <polygon
                  id="Fill-63"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="25.5834351 49.898141 26.2175444 49.5318404 23.2814543 44.4485425 22.6473449 44.8143752"
                />
                <polygon
                  id="Fill-64"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="21.8400839 51.7618298 22.5092916 51.4638305 20.1207349 46.1012459 19.4515273 46.3992452"
                />
                <polygon
                  id="Fill-65"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="17.9225983 53.2238978 18.6194166 52.9974745 16.8046003 47.4150159 16.107782 47.6414393"
                />
                <polygon
                  id="Fill-66"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="13.8734707 54.2689071 14.5904121 54.1163988 13.369459 48.3748825 12.6529856 48.526923"
                />
                <polygon
                  id="Fill-67"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="9.73758006 54.8848816 10.4662209 54.8081596 9.85223452 48.9702731 9.12359371 49.046995"
                />
                <polygon
                  id="Fill-68"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="5.56003944 55.0653185 6.29242406 55.0653185 6.29242406 49.1951526 5.56003944 49.1951526"
                />
                <polygon
                  id="Fill-69"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="2.11464946 54.8848816 2.7286358 49.046995 1.999995 48.9702731 1.38600865 54.8081596"
                />
                <polygon
                  id="Fill-70"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-2.02128797 54.2689071 -0.800334942 48.526923 -1.51680834 48.3748825 -2.73776136 54.1163988"
                />
                <polygon
                  id="Fill-71"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-6.06994761 53.2238978 -4.25559925 47.6414393 -4.95241759 47.4150159 -6.76676595 52.9974745"
                />
                <polygon
                  id="Fill-72"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-9.98785437 51.7618298 -7.59929774 46.3992452 -8.26850542 46.1012459 -10.657062 51.4638305"
                />
                <polygon
                  id="Fill-73"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-13.7307844 49.898141 -10.7946942 44.8143752 -11.4288036 44.4485425 -14.3648937 49.5318404"
                />
                <polygon
                  id="Fill-74"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-17.2584448 47.6538364 -13.8071115 42.9045597 -14.4000389 42.4741682 -17.8513721 47.2234449"
                />
                <polygon
                  id="Fill-75"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-20.5324146 45.0530086 -16.6032764 40.6906165 -17.1475341 40.2003444 -21.0766724 44.5627366"
                />
                <polygon
                  id="Fill-76"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-23.5162385 42.1243816 -19.1523493 38.1965912 -19.6427896 37.6520524 -24.0062109 41.5803106"
                />
                <polygon
                  id="Fill-77"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-26.177392 38.8999539 -21.4269534 35.4493368 -21.8574926 34.8570806 -26.6079312 38.3076977"
                />
                <polygon
                  id="Fill-78"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-28.4866732 35.4150926 -23.4016309 32.4800096 -23.7675892 31.84565 -28.8530995 34.7812007"
                />
                <polygon
                  id="Fill-79"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-30.4193731 31.708065 -25.0549482 29.3203278 -25.3530498 28.6513497 -30.7174747 31.0390869"
                />
                <polygon
                  id="Fill-80"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-31.9535434 27.8194778 -26.3687011 26.0057518 -26.5952022 25.3091725 -32.1800444 27.1228985"
                />
                <polygon
                  id="Fill-81"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-33.0727581 23.7918086 -27.3292715 22.5712744 -27.4813642 21.8550468 -33.2253188 23.075581"
                />
                <polygon
                  id="Fill-82"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-33.7651307 19.669079 -27.9252408 19.0557711 -28.0019891 18.3273802 -33.841411 18.9406881"
                />
                <polygon
                  id="Fill-83"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-34.0219567 15.4969011 -28.1497763 15.4969011 -28.1497763 14.7647678 -34.0219567 14.7647678"
                />
                <polygon
                  id="Fill-84"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-28.0018019 11.9341951 -27.9250536 11.2058042 -33.7649435 10.5920285 -33.8416918 11.3204194"
                />
                <polygon
                  id="Fill-85"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-27.4812706 8.40652853 -27.3291779 7.69030093 -33.0726645 6.46929894 -33.2252252 7.18599436"
                />
                <polygon
                  id="Fill-86"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-26.5951086 4.95244957 -26.3690755 4.25587027 -31.9534498 2.44167651 -32.1804188 3.13825581"
                />
                <polygon
                  id="Fill-87"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-25.3529562 1.60989814 -25.0548546 0.94092004 -30.4192795 -1.44681719 -30.7173811 -0.777839084"
                />
                <polygon
                  id="Fill-88"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-23.7675892 -1.58444891 -23.4016309 -2.21834074 -28.4866732 -5.15389151 -28.8530995 -4.51953185"
                />
                <polygon
                  id="Fill-89"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-21.8573055 -4.59573922 -21.4267662 -5.18799536 -26.1772048 -8.63861248 -26.607744 -8.04588852"
                />
                <polygon
                  id="Fill-90"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-19.6426492 -7.39085136 -19.1522089 -7.93492236 -23.5160981 -11.8631805 -24.0060705 -11.3186417"
                />
                <polygon
                  id="Fill-91"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-17.147347 -9.93914333 -16.6030892 -10.4294154 -20.5322275 -14.7918076 -21.0764852 -14.3015355"
                />
                <polygon
                  id="Fill-92"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-14.3998517 -12.2128736 -13.8069243 -12.6432651 -17.2582576 -17.3925418 -17.851185 -16.9621503"
                />
                <polygon
                  id="Fill-93"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-11.4288036 -14.1869672 -10.7946942 -14.5532678 -13.7307844 -19.6370335 -14.3648937 -19.2707329"
                />
                <polygon
                  id="Fill-94"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-8.26859901 -15.8397641 -7.59892336 -16.1377634 -9.98794796 -21.500348 -10.6571556 -21.2028165"
                />
                <polygon
                  id="Fill-95"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-4.95255798 -17.1534406 -4.25573964 -17.379864 -6.070088 -22.9623225 -6.76690635 -22.736367"
                />
                <polygon
                  id="Fill-96"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-1.51676154 -18.113354 -0.800288145 -18.2658623 -2.02124117 -24.0073786 -2.73771456 -23.8548703"
                />
                <polygon
                  id="Fill-97"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="1.9999482 -18.7089784 2.728589 -18.7857004 2.11460266 -24.6235869 1.38596186 -24.546865"
                />
                <polygon
                  id="Fill-98"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-18.4283883 -8.69765096 -17.9103373 -9.21552422 -22.0627007 -13.3664632 -22.5807517 -12.8485899"
                />
                <polygon
                  id="Fill-99"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-15.8033159 -11.1120537 -15.2337874 -11.5728534 -18.9294049 -16.1345355 -19.4984654 -15.6737359"
                />
                <polygon
                  id="Fill-100"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-12.9401366 -13.238796 -12.3261502 -13.6378437 -15.5238398 -18.5606805 -16.1382941 -18.1621005"
                />
                <polygon
                  id="Fill-101"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-9.87039204 -15.0547674 -9.21756357 -15.3873852 -11.8836308 -20.6175776 -12.5359913 -20.2849599"
                />
                <polygon
                  id="Fill-102"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-6.62749588 -16.5400392 -5.9437809 -16.8024844 -8.04780728 -22.2829589 -8.73199023 -22.0200458"
                />
                <polygon
                  id="Fill-103"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-3.24696757 -17.6783779 -2.53938574 -17.8678437 -4.05937632 -23.5382518 -4.76695815 -23.3483182"
                />
                <polygon
                  id="Fill-104"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="0.233614316 -18.4571058 0.957575347 -18.571721 0.0389357193 -24.3698431 -0.685025312 -24.2547601"
                />
                <polygon
                  id="Fill-105"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="3.77676478 -18.8679894 4.50821344 -18.9063504 4.20122027 -24.7685634 3.4697716 -24.7302024"
                />
                <polygon
                  id="Fill-106"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="8.07541794 -18.8679894 8.38287909 -24.7302024 7.65143042 -24.7685634 7.34396927 -18.9063504"
                />
                <polygon
                  id="Fill-107"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="11.6186152 -18.4571058 12.5372548 -24.2547601 11.8137618 -24.3698431 10.8951221 -18.571721"
                />
                <polygon
                  id="Fill-108"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="15.0996651 -17.6783779 16.6191877 -23.3483182 15.9116058 -23.5382518 14.3920832 -17.8678437"
                />
                <polygon
                  id="Fill-109"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="18.4801466 -16.5400392 20.5841729 -22.0200458 19.900458 -22.2829589 17.7959636 -16.8024844"
                />
                <polygon
                  id="Fill-110"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="21.7230895 -15.0547674 24.3886888 -20.2849599 23.7363283 -20.6175776 21.0697931 -15.3873852"
                />
                <polygon
                  id="Fill-111"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="24.7928341 -13.238796 27.9909916 -18.1621005 27.3765373 -18.5606805 24.1788477 -13.6378437"
                />
                <polygon
                  id="Fill-112"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="27.6554986 -11.1120537 31.3511161 -15.6737359 30.7820556 -16.1345355 27.0864381 -11.5728534"
                />
                <polygon
                  id="Fill-113"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="30.280571 -8.69765096 34.4329344 -12.8485899 33.9153514 -13.3664632 29.762988 -9.21552422"
                />
                <polygon
                  id="Fill-114"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="32.6387559 -6.02234672 37.2024715 -9.71669642 36.7415137 -10.2855617 32.1782661 -6.59121201"
                />
                <polygon
                  id="Fill-115"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="34.7044081 -3.11509887 39.6289342 -6.31215926 39.2302175 -6.92640279 34.3052234 -3.7293424"
                />
                <polygon
                  id="Fill-116"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="36.454784 -0.00799966821 41.6867713 -2.67315229 41.3545073 -3.32528898 36.122052 -0.66060418"
                />
                <polygon
                  id="Fill-117"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="37.8706028 3.26494061 43.35249 1.16116821 43.0899547 0.47768779 37.6075995 2.58099237"
                />
                <polygon
                  id="Fill-118"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="38.9363277 6.66774685 44.6082137 5.1482777 44.4186829 4.44093862 38.7467969 5.96040776"
                />
                <polygon
                  id="Fill-119"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="39.6401189 10.1635083 45.4402308 9.24518381 45.3251083 8.52193895 39.5254644 9.44026344"
                />
                <polygon
                  id="Fill-120"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="39.9750971 13.7135365 45.8388539 13.4066486 45.8004798 12.6749831 39.936723 12.9823388"
                />
                <polygon
                  id="Fill-121"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="45.8006201 17.5864051 45.8389943 16.8552074 39.9752375 16.5478517 39.9368634 17.2790494"
                />
                <polygon
                  id="Fill-122"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="45.3253423 21.739496 45.4399968 21.0162512 39.6403529 20.0979267 39.5252305 20.8211715"
                />
                <polygon
                  id="Fill-123"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="44.4186361 25.8202157 44.6081669 25.1128766 38.9362809 23.5934074 38.7467501 24.3007465"
                />
                <polygon
                  id="Fill-124"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="43.0900951 29.7838875 43.3526304 29.0999393 37.8707432 26.9966347 37.6077399 27.6801151"
                />
                <polygon
                  id="Fill-125"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="41.3543669 33.5868175 41.6866309 32.934213 36.4546436 30.2695282 36.1219116 30.9221327"
                />
                <polygon
                  id="Fill-126"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="39.2301707 37.1876974 39.6293554 36.5734539 34.7043613 33.3763935 34.3056446 33.990637"
                />
                <polygon
                  id="Fill-127"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="36.7413265 40.5469031 37.2022843 39.9780378 32.6385687 36.2836881 32.1780789 36.8525534"
                />
                <polygon
                  id="Fill-128"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="33.9151642 43.627711 34.4327472 43.1098378 30.2803838 38.9588988 29.7628008 39.4767721"
                />
                <polygon
                  id="Fill-129"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="30.7819152 46.3961576 31.3514437 45.935358 27.6553582 41.373208 27.0867657 41.8344754"
                />
                <polygon
                  id="Fill-130"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="27.3763033 48.8221622 27.9907576 48.4231145 24.7926001 43.5002777 24.1786137 43.8988577"
                />
                <polygon
                  id="Fill-131"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="23.7361879 50.8790126 24.3890164 50.5463948 21.7229491 45.3162024 21.0701207 45.6488202"
                />
                <polygon
                  id="Fill-132"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="19.9005516 52.5440664 20.5842665 52.2816211 18.4802402 46.8011466 17.7960572 47.0640597"
                />
                <polygon
                  id="Fill-133"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="15.9117462 53.7993593 16.6193281 53.6098935 15.0998055 47.9399532 14.3922236 48.129419"
                />
                <polygon
                  id="Fill-134"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="11.8137618 54.6310441 12.5372548 54.516429 11.6186152 48.7183069 10.8951221 48.832922"
                />
                <polygon
                  id="Fill-135"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="7.65129003 55.029858 8.3827387 54.991497 8.07527755 49.129284 7.34382888 49.167645"
                />
                <polygon
                  id="Fill-136"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="4.20136067 55.029858 4.50835384 49.167645 3.77690517 49.129284 3.469912 54.991497"
                />
                <polygon
                  id="Fill-137"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="0.0388889216 54.6310441 0.95752855 48.832922 0.233567518 48.7183069 -0.68507211 54.516429"
                />
                <polygon
                  id="Fill-138"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-4.05956352 53.7993593 -2.53957293 48.129419 -3.24715476 47.9399532 -4.76714534 53.6098935"
                />
                <polygon
                  id="Fill-139"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-8.04785407 52.5440664 -5.9438277 47.0640597 -6.62754268 46.8011466 -8.73203703 52.2816211"
                />
                <polygon
                  id="Fill-140"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-11.8835372 50.8790126 -9.21793796 45.6488202 -9.87029845 45.3162024 -12.5363657 50.5463948"
                />
                <polygon
                  id="Fill-141"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-15.5240738 48.8221622 -12.3259162 43.8988577 -12.9403706 43.5002777 -16.1380601 48.4231145"
                />
                <polygon
                  id="Fill-142"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-18.9292645 46.3961576 -15.234115 41.8344754 -15.8031755 41.373208 -19.498793 45.935358"
                />
                <polygon
                  id="Fill-143"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-22.0625135 43.627711 -17.9101501 39.4767721 -18.4282011 38.9588988 -22.5805645 43.1098378"
                />
                <polygon
                  id="Fill-144"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-24.889097 40.5469031 -20.3253814 36.8525534 -20.7863392 36.2836881 -25.3495868 39.9780378"
                />
                <polygon
                  id="Fill-145"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-27.37752 37.1876974 -22.4529939 33.990637 -22.8517106 33.3763935 -27.7767047 36.5734539"
                />
                <polygon
                  id="Fill-146"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-29.5017162 33.5868175 -24.2692609 30.9221327 -24.6019929 30.2695282 -29.8344481 32.934213"
                />
                <polygon
                  id="Fill-147"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-31.2373976 29.7838875 -25.7555104 27.6801151 -26.0180457 26.9966347 -31.5004009 29.0999393"
                />
                <polygon
                  id="Fill-148"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-32.5659386 25.8202157 -26.8940526 24.3007465 -27.0835834 23.5934074 -32.7554694 25.1128766"
                />
                <polygon
                  id="Fill-149"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-33.4731128 21.739496 -27.6730009 20.8211715 -27.7881234 20.0979267 -33.5877672 21.0162512"
                />
                <polygon
                  id="Fill-150"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-33.9483906 17.5864051 -28.0841659 17.2790494 -28.12254 16.5478517 -33.9867648 16.8552074"
                />
                <polygon
                  id="Fill-151"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-28.1224464 13.7135365 -28.0840723 12.9823388 -33.948297 12.6749831 -33.9866712 13.4066486"
                />
                <polygon
                  id="Fill-152"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-27.7879362 10.1635083 -27.6732817 9.44026344 -33.4729256 8.52193895 -33.588048 9.24518381"
                />
                <polygon
                  id="Fill-153"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-27.083677 6.66774685 -26.8941462 5.96040776 -32.5660322 4.44093862 -32.755563 5.1482777"
                />
                <polygon
                  id="Fill-154"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-26.0179053 3.26494061 -25.75537 2.58099237 -31.2372572 0.47768779 -31.5002605 1.16116821"
                />
                <polygon
                  id="Fill-155"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-24.6020865 -0.00799966821 -24.2693545 -0.66060418 -29.5018098 -3.32528898 -29.8345417 -2.67315229"
                />
                <polygon
                  id="Fill-156"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-22.8517574 -3.11509887 -22.4525727 -3.7293424 -27.3775668 -6.92640279 -27.7762836 -6.31215926"
                />
                <polygon
                  id="Fill-157"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-6)"
                  points="-20.7865264 -6.02234672 -20.3255686 -6.59121201 -24.8892842 -10.2855617 -25.349774 -9.71669642"
                />
              </g>
              <g id="Group-161">
                <mask id="evaluation-mask-8" fill="white">
                  <use xlink:href="#evaluation-path-7" />
                </mask>
                <g id="Clip-160" />
                <path
                  d="M48.727772,19.3049771 C48.727772,28.661782 56.3431681,36.2745657 65.703184,36.2745657 C75.0636679,36.2745657 82.679064,28.661782 82.679064,19.3049771 C82.679064,9.9481722 75.0636679,2.33538852 65.703184,2.33538852 C56.3431681,2.33538852 48.727772,9.9481722 48.727772,19.3049771 M47.9953873,19.3049771 C47.9953873,9.54397843 55.9393036,1.60325514 65.703184,1.60325514 C75.4680004,1.60325514 83.4114487,9.54397843 83.4114487,19.3049771 C83.4114487,29.0659758 75.4680004,37.0066991 65.703184,37.0066991 C55.9393036,37.0066991 47.9953873,29.0659758 47.9953873,19.3049771"
                  id="Fill-159"
                  fill="#E7E6FF"
                  mask="url(#evaluation-mask-8)"
                />
              </g>
              <g id="Group-164">
                <mask id="evaluation-mask-10" fill="white">
                  <use xlink:href="#evaluation-path-9" />
                </mask>
                <g id="Clip-163" />
                <path
                  d="M50.6371197,19.3049771 C50.6371197,27.6096619 57.3956493,34.3663407 65.703184,34.3663407 C74.0107187,34.3663407 80.7697163,27.6096619 80.7697163,19.3049771 C80.7697163,11.0002923 74.0107187,4.24408129 65.703184,4.24408129 C57.3956493,4.24408129 50.6371197,11.0002923 50.6371197,19.3049771 M49.9047351,19.3049771 C49.9047351,10.5965664 56.9917848,3.51148009 65.703184,3.51148009 C74.4150512,3.51148009 81.5021009,10.5965664 81.5021009,19.3049771 C81.5021009,28.0133879 74.4150512,35.0984741 65.703184,35.0984741 C56.9917848,35.0984741 49.9047351,28.0133879 49.9047351,19.3049771"
                  id="Fill-162"
                  fill="#E7E6FF"
                  mask="url(#evaluation-mask-10)"
                />
              </g>
              <g id="Group-167">
                <mask id="evaluation-mask-12" fill="white">
                  <use xlink:href="#evaluation-path-11" />
                </mask>
                <g id="Clip-166" />
                <path
                  d="M52.5460463,19.3049771 C52.5460463,26.5575418 58.4481772,32.457648 65.7032308,32.457648 C72.9582844,32.457648 78.8604153,26.5575418 78.8604153,19.3049771 C78.8604153,12.0524124 72.9582844,6.15230624 65.7032308,6.15230624 C58.4481772,6.15230624 52.5460463,12.0524124 52.5460463,19.3049771 M51.8136617,19.3049771 C51.8136617,11.6486865 58.0443128,5.42017286 65.7032308,5.42017286 C73.3621489,5.42017286 79.5932679,11.6486865 79.5932679,19.3049771 C79.5932679,26.9612678 73.3621489,33.1902492 65.7032308,33.1902492 C58.0443128,33.1902492 51.8136617,26.9612678 51.8136617,19.3049771"
                  id="Fill-165"
                  fill="#E7E6FF"
                  mask="url(#evaluation-mask-12)"
                />
              </g>
              <g id="Group-170">
                <mask id="evaluation-mask-14" fill="white">
                  <use xlink:href="#evaluation-path-13" />
                </mask>
                <g id="Clip-169" />
                <path
                  d="M54.4554409,19.3049771 C54.4554409,25.5049539 59.5011732,30.549423 65.7032776,30.549423 C71.905382,30.549423 76.9515823,25.5049539 76.9515823,19.3049771 C76.9515823,13.1050003 71.905382,8.06053119 65.7032776,8.06053119 C59.5011732,8.06053119 54.4554409,13.1050003 54.4554409,19.3049771 M53.7230563,19.3049771 C53.7230563,12.7012744 59.0973087,7.32839781 65.7032776,7.32839781 C72.3092465,7.32839781 77.6844349,12.7012744 77.6844349,19.3049771 C77.6844349,25.9086798 72.3092465,31.2815564 65.7032776,31.2815564 C59.0973087,31.2815564 53.7230563,25.9086798 53.7230563,19.3049771"
                  id="Fill-168"
                  fill="#E7E6FF"
                  mask="url(#evaluation-mask-14)"
                />
              </g>
            </g>
            <polygon
              id="Fill-172"
              fill="#7BEAFF"
              points="47.421386 129.19708 41.6058394 139.797882 47.4981321 142.562232 50.5403303 138.50556 51.5480406 144.461978 67.0245446 152.189781 71.1678832 143.410792 61.8839828 137.119259 62.2167084 135.131035"
            />
            <g id="Group-176" transform="translate(40.510949, 129.197080)">
              <mask id="evaluation-mask-16" fill="white">
                <use xlink:href="#evaluation-path-15" />
              </mask>
              <g id="Clip-175" />
              <polygon
                id="Fill-174"
                fill="#070000"
                mask="url(#evaluation-mask-16)"
                points="27.2727216 21.5426191 10.8751721 13.4912237 9.9817414 8.66000859 3.2523879 5.35575784 -1.57279458 11.742748 26.7396663 26.4758523"
              />
            </g>
            <g id="Group-183" transform="translate(38.321168, 73.357664)">
              <polygon
                id="Fill-177"
                fill="#070000"
                points="25.4872255 72.2585778 30.4313246 69.1843796 30.0367607 68.5666494 26.1922428 70.9573817 27.8668951 67.5708218 27.3858579 67.0766376 23.5451202 68.7428773 25.0822658 65.6346456 24.6413938 65.1260089 21.2330227 66.1563362 23.4449435 64.2378761 22.9563458 63.6896115 19.4534683 66.7279115 19.8064495 67.35077 24.0436412 66.0696209 22.4379785 69.317716 22.9190158 69.8119002 26.7592808 68.1456605 24.95799 71.7895691"
              />
              <polygon
                id="Fill-179"
                fill="#4C3BE3"
                points="12.9397607 51.3454514 9.77805109 56.6383499 22.5874403 61.9093365 31.8656001 47.0003607 18.7911206 41.7046649"
              />
              <path
                d="M17.5972693,0.280239699 C47.1177418,27.6930064 47.172083,39.8718479 41.9146954,60.8507091 C41.9146954,60.8507091 38.9987023,60.9408754 35.2359324,57.8629475 C31.4731625,54.7854858 28.8123365,58.4965288 24.867642,56.7766748 C20.9220023,55.0568208 22.6656443,53.6992131 19.7293323,52.7033854 C16.7934929,51.7075578 14.6760784,53.0586386 12.9399969,51.3453115 C12.9399969,51.3453115 20.7325171,38.9408236 19.3711533,33.535102 C17.444169,25.8859708 9.77686977,27.7191142 0.211883212,8.56668189 L17.5972693,0.280239699 Z"
                id="Fill-181"
                fill="#E7E6FF"
              />
            </g>
            <g id="Group-293" transform="translate(38.321168, 73.357664)">
              <g id="Group-277">
                <mask id="evaluation-mask-18" fill="white">
                  <use xlink:href="#evaluation-path-17" />
                </mask>
                <g id="Clip-185" />
                <polygon
                  id="Fill-184"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-7.28596619 14.4733493 -6.54645409 14.4733493 -6.54645409 8.60032317 -7.28596619 8.60032317"
                />
                <polygon
                  id="Fill-186"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-2.95138571 14.6981512 -2.33142413 8.85742018 -3.06715597 8.78066083 -3.68759009 14.6218599"
                />
                <polygon
                  id="Fill-187"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="0.59950096 15.2942531 1.83233615 9.54947122 1.10889013 9.39735666 -0.123945063 15.1416705"
                />
                <polygon
                  id="Fill-188"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="4.06826162 16.2544938 5.90073953 10.6688472 5.19713984 10.4427815 3.36513446 16.0279601"
                />
                <polygon
                  id="Fill-189"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="7.41662121 17.5688104 9.82842297 12.2036129 9.15270265 11.9054683 6.74090088 17.2706658"
                />
                <polygon
                  id="Fill-190"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="10.608053 19.2225063 13.5727169 14.1362634 12.9324364 13.7697844 9.96777257 18.8560272"
                />
                <polygon
                  id="Fill-191"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="13.6074952 21.1976553 17.092889 16.4460645 16.4941913 16.0154633 13.0092701 20.7670541"
                />
                <polygon
                  id="Fill-192"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="16.3822486 23.4723998 20.3496247 19.1078821 19.7995978 18.6173711 15.8326942 22.9818889"
                />
                <polygon
                  id="Fill-193"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="18.9017876 26.0219803 23.3076731 22.0922761 22.8124599 21.547472 18.4065743 25.4776442"
                />
                <polygon
                  id="Fill-194"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="21.1379965 28.8184075 25.9346658 25.3661091 25.4999366 24.7735644 20.7027949 28.2258628"
                />
                <polygon
                  id="Fill-195"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="23.0669182 31.8310715 28.2019201 28.8945584 27.8319278 28.2603577 22.6973984 31.1964027"
                />
                <polygon
                  id="Fill-196"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="24.6672413 35.026975 30.0843446 32.6380743 29.7833419 31.9692383 24.3667111 34.3576709"
                />
                <polygon
                  id="Fill-197"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="25.9219547 38.3712019 31.5611479 36.5565922 31.3324426 35.8596735 25.6937219 37.6742832"
                />
                <polygon
                  id="Fill-198"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="26.8166934 41.8268702 32.6165474 40.6057413 32.4625021 39.8891648 26.6631206 41.1102936"
                />
                <polygon
                  id="Fill-199"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="27.3418179 45.3562556 33.2385409 44.7421809 33.1615182 44.0139032 27.2647952 44.6275099"
                />
                <polygon
                  id="Fill-200"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="27.491894 48.9209784 33.4212217 48.9209784 33.4212217 48.1884883 27.491894 48.1884883"
                />
                <polygon
                  id="Fill-201"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="33.1617073 53.0950956 33.2387299 52.3663498 27.3420069 51.7527431 27.2649842 52.4810208"
                />
                <polygon
                  id="Fill-202"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="32.4626439 57.2195999 32.6166892 56.5030233 26.8168352 55.2818945 26.6632624 55.9984711"
                />
                <polygon
                  id="Fill-203"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="31.3325371 61.2493252 31.5607699 60.5524065 25.9220492 58.7377968 25.6933438 59.4347156"
                />
                <polygon
                  id="Fill-204"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="29.7833892 65.1398072 30.0843919 64.4705031 24.6672885 62.0820705 24.3667584 62.7509066"
                />
                <polygon
                  id="Fill-205"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="27.8319278 68.848641 28.2019201 68.2144403 23.0669182 65.2779272 22.6973984 65.9121279"
                />
                <polygon
                  id="Fill-206"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="25.5001729 72.3352003 25.934902 71.7426556 21.1382328 68.2903572 20.7030311 68.8833699"
                />
                <polygon
                  id="Fill-207"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="22.8126489 75.5611055 23.3078621 75.0167694 18.9019766 71.0865972 18.4067633 71.6314013"
                />
                <polygon
                  id="Fill-208"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="19.7997868 78.4912999 20.3498137 78.000789 16.3824376 73.6362712 15.8324107 74.1267822"
                />
                <polygon
                  id="Fill-209"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="16.4943803 81.0933482 17.093078 80.662747 13.6076842 75.9111562 13.0094591 76.3422254"
                />
                <polygon
                  id="Fill-210"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="12.9323892 83.3388399 13.5726696 82.9723608 10.6080058 77.8865861 9.96772532 78.2525971"
                />
                <polygon
                  id="Fill-211"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="9.15260814 85.2034836 9.828801 84.9053391 7.4165267 79.5401415 6.74080638 79.837818"
                />
                <polygon
                  id="Fill-212"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-22.9846032 85.2034836 -20.5728014 79.837818 -21.2485217 79.5401415 -23.660796 84.9053391"
                />
                <polygon
                  id="Fill-213"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-26.7644314 83.3388399 -23.7997676 78.2525971 -24.440048 77.8865861 -27.4047119 82.9723608"
                />
                <polygon
                  id="Fill-214"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-30.3264226 81.0933482 -26.8415013 76.3422254 -27.4397265 75.9111562 -30.9251202 80.662747"
                />
                <polygon
                  id="Fill-215"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-33.631829 78.4912999 -29.6644529 74.1267822 -30.2144798 73.6362712 -34.1818559 78.000789"
                />
                <polygon
                  id="Fill-216"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-36.6446911 75.5611055 -32.2388056 71.6314013 -32.7335463 71.0865972 -37.1399043 75.0167694"
                />
                <polygon
                  id="Fill-217"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-39.3322151 72.3352003 -34.5350734 68.8833699 -34.9702751 68.2903572 -39.7669443 71.7426556"
                />
                <polygon
                  id="Fill-218"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-41.6639228 68.848641 -36.5293934 65.9121279 -36.8989132 65.2779272 -42.0339151 68.2144403"
                />
                <polygon
                  id="Fill-219"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-43.6154314 65.1398072 -38.1988006 62.7509066 -38.4993308 62.0820705 -43.9164341 64.4705031"
                />
                <polygon
                  id="Fill-220"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-38.4992835 35.026975 -38.1987534 34.3576709 -43.6153842 31.9692383 -43.9163869 32.6380743"
                />
                <polygon
                  id="Fill-221"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-36.8989132 31.8310715 -36.5293934 31.1964027 -41.6639228 28.2603577 -42.0339151 28.8945584"
                />
                <polygon
                  id="Fill-222"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-34.9700388 28.8184075 -34.5348371 28.2258628 -39.3319789 24.7735644 -39.766708 25.3661091"
                />
                <polygon
                  id="Fill-223"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-32.7333573 26.0219803 -32.2386166 25.4776442 -36.6445021 21.547472 -37.1397153 22.0922761"
                />
                <polygon
                  id="Fill-224"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-30.2142908 23.4723998 -29.6647365 22.9818889 -33.63164 18.6173711 -34.1816669 19.1078821"
                />
                <polygon
                  id="Fill-225"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-27.4395375 21.1976553 -26.8413123 20.7670541 -30.3262336 16.0154633 -30.9249312 16.4460645"
                />
                <polygon
                  id="Fill-226"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-24.440048 19.2225063 -23.7997676 18.8560272 -26.7644314 13.7697844 -27.4047119 14.1362634"
                />
                <polygon
                  id="Fill-227"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-21.2486162 17.5688104 -20.5728959 17.2706658 -22.9846977 11.9054683 -23.660418 12.2036129"
                />
                <polygon
                  id="Fill-228"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-17.9003039 16.2544938 -17.1971767 16.0279601 -19.0291821 10.4427815 -19.7327818 10.6688472"
                />
                <polygon
                  id="Fill-229"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-14.4315432 15.2942531 -13.7080972 15.1416705 -14.9409324 9.39735666 -15.6643784 9.54947122"
                />
                <polygon
                  id="Fill-230"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-10.8801368 14.6981512 -10.1444049 14.6218599 -10.7643665 8.78066083 -11.5000983 8.85742018"
                />
                <polygon
                  id="Fill-231"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-31.5077518 24.7144503 -30.9846592 24.1963247 -35.177433 20.0438313 -35.700053 20.5614888"
                />
                <polygon
                  id="Fill-232"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-28.8571325 22.2989647 -28.2820615 21.8379406 -32.0136443 17.2735677 -32.5882428 17.7345919"
                />
                <polygon
                  id="Fill-233"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-25.9660891 20.1710927 -25.345655 19.7718504 -28.5749366 14.846615 -29.1953707 15.2453892"
                />
                <polygon
                  id="Fill-234"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-22.8664702 18.3541896 -22.2072885 18.0214097 -24.8993016 12.7886689 -25.5580108 13.1214487"
                />
                <polygon
                  id="Fill-235"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-19.5920146 16.8681941 -18.9011733 16.605621 -21.0261483 11.1224762 -21.7169896 11.3855174"
                />
                <polygon
                  id="Fill-236"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-16.1785874 15.7293943 -15.4641195 15.5398362 -16.9984299 9.86713323 -17.7133703 10.0566914"
                />
                <polygon
                  id="Fill-237"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-12.6637076 14.9501933 -11.9331736 14.8355224 -12.8607534 9.03504318 -13.5912874 9.14971416"
                />
                <polygon
                  id="Fill-238"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-9.08602843 14.5392032 -8.34746139 14.5008235 -8.65791471 8.63575417 -9.39648175 8.67413384"
                />
                <polygon
                  id="Fill-239"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-4.74601383 14.5392032 -4.43556051 8.67413384 -5.17412755 8.63575417 -5.48458087 14.5008235"
                />
                <polygon
                  id="Fill-240"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-1.16833461 14.9501933 -0.240754898 9.14971416 -0.971288897 9.03504318 -1.89886861 14.8355224"
                />
                <polygon
                  id="Fill-241"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="2.34659239 15.7293943 3.88137534 10.0566914 3.16643488 9.86713323 1.63212447 15.5398362"
                />
                <polygon
                  id="Fill-242"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="5.75997234 16.8681941 7.88494737 11.3855174 7.19410603 11.1224762 5.069131 16.605621"
                />
                <polygon
                  id="Fill-243"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="9.03447522 18.3541896 11.7260158 13.1214487 11.0673066 12.7886689 8.37529351 18.0214097"
                />
                <polygon
                  id="Fill-244"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="12.1340941 20.1710927 15.3633757 15.2453892 14.7429416 14.846615 11.5141325 19.7718504"
                />
                <polygon
                  id="Fill-245"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="15.0250903 22.2989647 18.7562005 17.7345919 18.181602 17.2735677 14.4500192 21.8379406"
                />
                <polygon
                  id="Fill-246"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="17.6757096 24.7144503 21.8680108 20.5614888 21.3453907 20.0438313 17.152617 24.1963247"
                />
                <polygon
                  id="Fill-247"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="20.0567968 27.3911517 24.6644533 23.695002 24.1994821 23.1258595 19.5913531 26.8220092"
                />
                <polygon
                  id="Fill-248"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="22.1421264 30.2996757 27.1145774 27.1010576 26.7119804 26.4865147 21.7390569 29.6851329"
                />
                <polygon
                  id="Fill-249"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="23.9095367 33.4082889 29.1929136 30.7418376 28.8569435 30.0893832 23.5735667 32.7553664"
                />
                <polygon
                  id="Fill-250"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="25.3391341 36.6828239 30.8743703 34.5780264 30.6092801 33.894213 25.0735713 35.9985424"
                />
                <polygon
                  id="Fill-251"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="26.4152305 40.0874285 32.1423146 38.567219 31.9509393 37.8595353 26.2238552 39.3797448"
                />
                <polygon
                  id="Fill-252"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="27.1258709 43.5847061 32.9824287 42.6659341 32.8661859 41.9423369 27.0105732 42.8611088"
                />
                <polygon
                  id="Fill-253"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="27.4641091 47.1366513 33.3849312 46.8291458 33.3461836 46.0975918 27.4253615 46.4050972"
                />
                <polygon
                  id="Fill-254"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="33.3463254 51.0113601 33.385073 50.2798061 27.4642509 49.9723007 27.4255033 50.7038547"
                />
                <polygon
                  id="Fill-255"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="32.866375 55.1664278 32.9821452 54.4428306 27.1260599 53.5240586 27.0102897 54.2476559"
                />
                <polygon
                  id="Fill-256"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="31.9508448 59.2491358 32.1422201 58.5414521 26.415136 57.0212425 26.2237607 57.7289263"
                />
                <polygon
                  id="Fill-257"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="30.6094218 63.214739 30.8745121 62.5309255 25.3392758 60.426128 25.073713 61.1099415"
                />
                <polygon
                  id="Fill-258"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="28.8568018 67.0196623 29.1927718 66.3667398 23.9093949 63.7002886 23.5734249 64.3532111"
                />
                <polygon
                  id="Fill-259"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="26.7119332 70.6222032 27.1150027 70.0076603 22.1420791 66.8090422 21.7394821 67.423585"
                />
                <polygon
                  id="Fill-260"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="24.1993404 73.9830924 24.6643116 73.4134819 20.056655 69.7178002 19.5912113 70.2869427"
                />
                <polygon
                  id="Fill-261"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="21.3452017 77.065261 21.8678217 76.5471355 17.6755206 72.394642 17.152428 72.9122995"
                />
                <polygon
                  id="Fill-262"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="18.1814602 79.8351034 18.7565313 79.3740792 15.0249485 74.8097064 14.45035 75.2707305"
                />
                <polygon
                  id="Fill-263"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="14.7431306 82.2621965 15.3630922 81.8629543 12.1342831 76.9377188 11.513849 77.3369611"
                />
                <polygon
                  id="Fill-264"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="11.0672121 84.3201894 11.7263938 83.9874096 9.03438071 78.7546687 8.37567153 79.0874486"
                />
                <polygon
                  id="Fill-265"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-24.8992071 84.3201894 -22.2076665 79.0874486 -22.8663757 78.7546687 -25.5583888 83.9874096"
                />
                <polygon
                  id="Fill-266"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-28.5751729 82.2621965 -25.3454187 77.3369611 -25.9663254 76.9377188 -29.1951345 81.8629543"
                />
                <polygon
                  id="Fill-267"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-32.0135025 79.8351034 -28.2823922 75.2707305 -28.8569908 74.8097064 -32.5885736 79.3740792"
                />
                <polygon
                  id="Fill-268"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-35.1772439 77.065261 -30.9844702 72.9122995 -31.5075628 72.394642 -35.699864 76.5471355"
                />
                <polygon
                  id="Fill-269"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-38.0308629 73.9830924 -33.4232063 70.2869427 -33.88865 69.7178002 -38.4963066 73.4134819"
                />
                <polygon
                  id="Fill-270"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-40.5439754 70.6222032 -35.5715244 67.423585 -35.9741214 66.8090422 -40.9470449 70.0076603"
                />
                <polygon
                  id="Fill-271"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-42.688844 67.0196623 -37.4054672 64.3532111 -37.7414372 63.7002886 -43.0248141 66.3667398"
                />
                <polygon
                  id="Fill-274"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-37.7415317 33.4082889 -37.4055617 32.7553664 -42.6889385 30.0893832 -43.0249086 30.7418376"
                />
                <polygon
                  id="Fill-275"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-35.9741687 30.2996757 -35.5710991 29.6851329 -40.5440227 26.4865147 -40.9466197 27.1010576"
                />
                <polygon
                  id="Fill-276"
                  fill="#3424C7"
                  mask="url(#evaluation-mask-18)"
                  points="-33.888839 27.3911517 -33.4233953 26.8220092 -38.0310519 23.1258595 -38.4964956 23.695002"
                />
              </g>
              <g id="Group-280">
                <mask id="evaluation-mask-20" fill="white">
                  <use xlink:href="#evaluation-path-19" />
                </mask>
                <g id="Clip-279" />
                <path
                  d="M37.6655486,39.53434 C37.6655486,48.895704 45.3545843,56.512197 54.8056907,56.512197 C64.2572697,56.512197 71.9467779,48.895704 71.9467779,39.53434 C71.9467779,30.172976 64.2572697,22.556483 54.8056907,22.556483 C45.3545843,22.556483 37.6655486,30.172976 37.6655486,39.53434 M36.9260365,39.53434 C36.9260365,29.7685853 44.9467895,21.8239929 54.8056907,21.8239929 C64.6655371,21.8239929 72.68629,29.7685853 72.68629,39.53434 C72.68629,49.3000947 64.6655371,57.2446871 54.8056907,57.2446871 C44.9467895,57.2446871 36.9260365,49.3000947 36.9260365,39.53434"
                  id="Fill-278"
                  fill="#FFFFFF"
                  mask="url(#evaluation-mask-20)"
                />
              </g>
              <g id="Group-283">
                <mask id="evaluation-mask-22" fill="white">
                  <use xlink:href="#evaluation-path-21" />
                </mask>
                <g id="Clip-282" />
                <path
                  d="M39.5930526,39.53434 C39.5930526,47.8430713 46.4173554,54.6030423 54.805738,54.6030423 C63.1941206,54.6030423 70.0193684,47.8430713 70.0193684,39.53434 C70.0193684,31.2256087 63.1941206,24.4661058 54.805738,24.4661058 C46.4173554,24.4661058 39.5930526,31.2256087 39.5930526,39.53434 M38.8535405,39.53434 C38.8535405,30.8216861 46.0095605,23.7331476 54.805738,23.7331476 C63.602388,23.7331476 70.7588805,30.8216861 70.7588805,39.53434 C70.7588805,48.2469939 63.602388,55.3355324 54.805738,55.3355324 C46.0095605,55.3355324 38.8535405,48.2469939 38.8535405,39.53434"
                  id="Fill-281"
                  fill="#FFFFFF"
                  mask="url(#evaluation-mask-22)"
                />
              </g>
              <g id="Group-286">
                <mask id="evaluation-mask-24" fill="white">
                  <use xlink:href="#evaluation-path-23" />
                </mask>
                <g id="Clip-285" />
                <path
                  d="M41.5205567,39.53434 C41.5205567,46.7904385 47.4801264,52.6934195 54.8057852,52.6934195 C62.1314441,52.6934195 68.0910138,46.7904385 68.0910138,39.53434 C68.0910138,32.2782415 62.1314441,26.3752605 54.8057852,26.3752605 C47.4801264,26.3752605 41.5205567,32.2782415 41.5205567,39.53434 M40.7810446,39.53434 C40.7810446,31.8743188 47.0723315,25.6427704 54.8057852,25.6427704 C62.539239,25.6427704 68.8309985,31.8743188 68.8309985,39.53434 C68.8309985,47.1943612 62.539239,53.4263777 54.8057852,53.4263777 C47.0723315,53.4263777 40.7810446,47.1943612 40.7810446,39.53434"
                  id="Fill-284"
                  fill="#FFFFFF"
                  mask="url(#evaluation-mask-24)"
                />
              </g>
              <g id="Group-289">
                <mask id="evaluation-mask-26" fill="white">
                  <use xlink:href="#evaluation-path-25" />
                </mask>
                <g id="Clip-288" />
                <path
                  d="M43.4485332,39.53434 C43.4485332,45.7373377 48.54337,50.7842648 54.8058325,50.7842648 C61.068295,50.7842648 66.1636043,45.7373377 66.1636043,39.53434 C66.1636043,33.3313423 61.068295,28.2844152 54.8058325,28.2844152 C48.54337,28.2844152 43.4485332,33.3313423 43.4485332,39.53434 M42.7090211,39.53434 C42.7090211,32.9274196 48.1355751,27.5519251 54.8058325,27.5519251 C61.4760899,27.5519251 66.9035889,32.9274196 66.9035889,39.53434 C66.9035889,46.1412604 61.4760899,51.5167549 54.8058325,51.5167549 C48.1355751,51.5167549 42.7090211,46.1412604 42.7090211,39.53434"
                  id="Fill-287"
                  fill="#FFFFFF"
                  mask="url(#evaluation-mask-26)"
                />
              </g>
              <g id="Group-292">
                <mask id="evaluation-mask-28" fill="white">
                  <use xlink:href="#evaluation-path-27" />
                </mask>
                <g id="Clip-291" />
                <path
                  d="M38.3028048,81.8908029 C38.3028048,86.9494311 42.4573035,91.064481 47.564426,91.064481 C52.6710761,91.064481 56.8260473,86.9494311 56.8260473,81.8908029 C56.8260473,76.8321747 52.6710761,72.7171249 47.564426,72.7171249 C42.4573035,72.7171249 38.3028048,76.8321747 38.3028048,81.8908029 M33.3709915,81.8908029 C33.3709915,74.139045 39.7378836,67.8321413 47.564426,67.8321413 C55.390496,67.8321413 61.7578605,74.139045 61.7578605,81.8908029 C61.7578605,89.6425609 10.1143992,95.9489965 17.9404691,95.9489965 C25.7670115,95.9489965 33.3709915,89.6425609 33.3709915,81.8908029"
                  id="Fill-290"
                  fill="#766DFF"
                  mask="url(#evaluation-mask-28)"
                />
              </g>
            </g>
            <g id="Group-300" transform="translate(0.000000, 45.985401)">
              <path
                d="M67.5438359,22.1432716 C62.8805201,10.590773 60.9450596,6.36374696 50.6728773,1.46387797 C45.7999061,-0.860658806 42.0503891,0.336702227 38.9247021,1.28841475 C31.9705856,3.40613887 29.2847547,10.1312933 31.084803,15.2244058 L38.4983872,36.2037245 L67.5438359,22.1432716 Z"
                id="Fill-294"
                fill="#FFFFFF"
              />
              <polygon
                id="Fill-296"
                fill="#FF3D81"
                points="5.73601385 54.6685851 106.907133 25.5566629 107.29656 19.2891166 105.212146 11.0769699 101.285193 5.93800299 0.1140731 35.0494572"
              />
              <polygon
                id="Fill-298"
                fill="#070000"
                points="106.907133 25.5567097 126.958878 9.39069811 101.285193 5.93758188 105.212146 11.0770167 107.29656 19.2891634"
              />
            </g>
            <g id="Group-303" transform="translate(100.729927, 51.459854)">
              <mask id="evaluation-mask-30" fill="white">
                <use xlink:href="#evaluation-path-29" />
              </mask>
              <g id="Clip-302" />
              <polygon
                id="Fill-301"
                fill="#FFFFFF"
                mask="url(#evaluation-mask-30)"
                points="15.504635 21.3157461 36.0699635 13.8583195 29.83378 -7.35439484 17.4177216 -4.53614666"
              />
            </g>
            <g id="Group-348" transform="translate(0.000000, 9.854015)">
              <polygon
                id="Fill-304"
                fill="#070000"
                points="2.3904713 76.5172017 106.067875 46.7168802 105.867108 46.0167743 2.18923988 75.8170958"
              />
              <polygon
                id="Fill-306"
                fill="#070000"
                points="4.91339285 84.4229556 107.356453 54.8812779 107.155222 54.1816372 4.71216142 83.7233149"
              />
              <polygon
                id="Fill-308"
                fill="#070000"
                points="6.17371501 89.7055221 6.88011632 83.8762683 4.61173161 75.4996524 0.578273119 70.2002462 0.082397994 77.3957532 3.00327443 85.9198332"
              />
              <path
                d="M2.55522082,80.2020381 C2.95768366,81.6045758 3.67152077,82.6298472 4.15066534,82.492152 C4.62888043,82.3549219 4.69069054,81.106361 4.2882277,79.7038232 C3.88576485,78.3012855 3.17192774,77.2760141 2.69324791,77.4137094 C2.21503282,77.5514046 2.15322271,78.7995004 2.55522082,80.2020381"
                id="Fill-310"
                fill="#FFFFFF"
              />
              <path
                d="M98.6125064,1.52292803 C97.8173402,2.1541863 97.4799407,3.28970689 97.6872137,4.63921334 C98.118955,7.45219697 100.939448,11.3388314 107.43927,14.4774456 C107.755756,13.4684558 107.909584,12.3706153 107.888671,11.2029969 C107.810595,6.85024545 105.328431,2.71334065 101.987432,1.36662532 C101.367936,1.11682009 100.781902,0.992615257 100.249777,0.992615257 C99.6149456,0.992615257 99.0572604,1.16985137 98.6125064,1.52292803 L98.6125064,1.52292803 Z M126.348052,44.9476359 C131.563339,30.6785008 127.168779,22.9489596 110.134283,16.4284384 C109.343765,16.1256019 108.583919,15.8088098 107.856604,15.4785273 C106.932705,17.7402647 105.194586,19.5223948 102.783527,20.5965107 C98.4805209,22.5135449 97.8498719,23.8970099 97.8568429,24.5510624 C97.8675319,25.5274891 99.2120181,26.102925 99.2250307,26.1085072 L98.9466528,26.7811671 C98.8732243,26.7504648 97.1485827,26.018261 97.1295284,24.5622268 C97.1104742,23.0610696 98.8625353,21.5459567 102.487489,19.9312938 C104.726131,18.9339337 106.337841,17.2755433 107.191564,15.1682478 C104.449612,13.8559563 102.18448,12.3380523 100.434278,10.6382603 C98.4926041,8.75192844 97.2615139,6.6604493 96.9682645,4.74992776 C96.7200945,3.13433456 97.1546243,1.7504043 98.1603167,0.952144019 C99.1915696,0.134345902 100.647128,0.0413085738 102.259303,0.691174313 C105.859626,2.14209145 108.532797,6.55764305 108.615985,11.1899716 C108.639222,12.4757475 108.464481,13.6838372 108.107098,14.7909814 C108.826976,15.1198684 109.588217,15.4394516 110.394072,15.7478704 C119.192021,19.1158216 124.50955,22.7707931 127.127417,27.2510056 C129.840556,31.8926379 129.809883,37.595361 127.031217,45.1974411 L126.348052,44.9476359 Z"
                id="Fill-312"
                fill="#FFFFFF"
              />
              <path
                d="M34.2476829,51.926645 C40.4510017,63.1455512 47.7947868,78.8055943 54.6413026,78.9525933 C66.5199982,79.2075156 83.8979349,77.144878 83.8979349,77.144878 L83.9471971,64.4880799 L78.7351638,65.3817034 L56.6210852,65.1058477 C56.6210852,65.1058477 47.5326747,50.5696955 40.2883435,38.7404644 C40.2883435,38.7404644 28.9928937,42.4224167 34.2476829,51.926645"
                id="Fill-314"
                fill="#4C3BE3"
              />
              <path
                d="M77.806432,66.3569207 C82.4737927,61.8543792 84.1626495,54.4234878 86.0587793,56.1981748 C87.5691769,57.6123422 83.0166064,66.3992527 83.0166064,66.3992527 L77.806432,66.3569207 Z"
                id="Fill-316"
                fill="#4C3BE3"
              />
              <path
                d="M83.7740359,63.857845 C90.4165318,63.0800529 97.4331416,63.4582497 97.0436914,65.4911153 C96.6547059,67.5244461 83.6536688,67.7802988 83.6536688,67.7802988 L83.7740359,63.857845 Z"
                id="Fill-318"
                fill="#4C3BE3"
              />
              <path
                d="M96.5484204,64.8523675 L97.1683805,64.4713797 C96.3035036,63.0600034 93.2952565,62.6962274 87.109133,63.253521 L87.174661,63.978747 C89.245997,63.7922072 95.5501638,63.2237491 96.5484204,64.8523675"
                id="Fill-320"
                fill="#070000"
              />
              <path
                d="M83.8733968,66.9392878 C90.7329252,66.0954393 97.965638,66.4080447 97.5450504,68.4506792 C97.1244628,70.4933138 83.7121328,70.8743017 83.7121328,70.8743017 L83.8733968,66.9392878 Z"
                id="Fill-322"
                fill="#4C3BE3"
              />
              <path
                d="M97.0530791,67.8135131 L97.6702507,67.4274082 C96.7918965,66.021149 93.6944197,65.684819 87.3149653,66.3021217 L87.384676,67.0273477 C89.5252578,66.8198744 96.0385567,66.1895465 97.0530791,67.8135131"
                id="Fill-324"
                fill="#070000"
              />
              <path
                d="M82.9185467,70.5439726 C89.5615074,69.7657154 96.5781172,70.1443773 96.188667,72.1772429 C95.7996815,74.2105737 82.7986444,74.4664264 82.7986444,74.4664264 L82.9185467,70.5439726 Z"
                id="Fill-326"
                fill="#4C3BE3"
              />
              <path
                d="M95.6933495,71.5384486 L96.3133096,71.1574608 C95.4484328,69.7460845 92.4401856,69.3827737 86.2540621,69.9396021 L86.3195901,70.6648281 C88.3909261,70.4782883 94.6950929,69.9098302 95.6933495,71.5384486"
                id="Fill-328"
                fill="#070000"
              />
              <path
                d="M82.4651486,73.8935956 C88.3385036,73.3818902 95.4308657,74.0973473 94.9814643,76.1116055 C94.5315982,78.1258636 82.9893727,77.1517628 82.9893727,77.1517628 L82.4651486,73.8935956 Z"
                id="Fill-330"
                fill="#4C3BE3"
              />
              <path
                d="M94.5006467,75.4862551 L95.1359431,75.1317828 C94.1925256,73.4380383 91.1141031,73.2463814 86.1153844,73.4873481 L86.1502397,74.2149 C90.6177632,73.9995186 93.7468421,74.1330271 94.5006467,75.4862551"
                id="Fill-332"
                fill="#070000"
              />
              <path
                d="M32.835345,26.1336273 C33.3702581,22.4144601 36.8162881,19.8336046 40.5323308,20.3694996 C44.2479087,20.9053947 46.8258087,24.3547536 46.2904309,28.0739208 C45.7555178,31.793088 42.3094877,34.3739435 38.5939098,33.8380485 C34.8783319,33.3021535 32.2999672,29.8527945 32.835345,26.1336273"
                id="Fill-334"
                fill="#4C3BE3"
              />
              <path
                d="M41.4792803,26.3103517 C42.9799183,25.4432438 44.2960555,25.339042 44.3090682,25.3385768 L44.2584118,24.6119553 C44.1989253,24.616142 42.7698569,24.7236001 41.1158554,25.6800238 L41.4792803,26.3103517 Z"
                id="Fill-336"
                fill="#070000"
              />
              <path
                d="M41.9185969,29.55354 C41.9878428,29.0716066 42.4344557,28.7371374 42.915924,28.8069154 C43.397857,28.8762282 43.7315386,29.3232726 43.6622927,29.8052059 C43.5930468,30.2866741 43.1464339,30.6211433 42.6645009,30.5518305 C42.1834973,30.4825177 41.8498157,30.0354733 41.9185969,29.55354"
                id="Fill-338"
                fill="#FF3D81"
              />
              <path
                d="M46.0240897,27.0609304 C47.4838308,28.8305004 47.666008,28.9607526 47.5693425,29.400354 C47.437357,30.00091 45.6383574,30.0190522 45.6383574,30.0190522 L46.0240897,27.0609304 Z"
                id="Fill-340"
                fill="#4C3BE3"
              />
              <path
                d="M45.6383109,30.3830608 L45.6420288,30.3830608 C46.2698895,30.3770134 47.7496143,30.2760678 47.9248204,29.4787379 C48.0465817,28.925631 47.8620808,28.7042022 46.8391931,27.4737835 C46.683506,27.2872437 46.5064409,27.073723 46.3047448,26.8290348 C46.1769419,26.6741277 45.9473615,26.6522639 45.7926038,26.7801902 C45.6373815,26.9081166 45.6155388,27.1379188 45.7438064,27.2928259 C45.9459673,27.5384445 46.1239618,27.7519651 46.2801137,27.9399005 C47.1951822,29.0405321 47.2560629,29.1307783 47.2142365,29.3224352 C47.1250068,29.4815291 46.3563307,29.6466703 45.634593,29.6550437 C45.4338263,29.6569044 45.2725624,29.8215805 45.2748612,30.0225411 C45.2772097,30.2225714 45.4389385,30.3830608 45.6383109,30.3830608"
                id="Fill-342"
                fill="#070000"
              />
              <path
                d="M44.5549609,22.4870292 C39.8058063,22.8405711 40.4150775,26.7695375 38.3851032,23.991908 C38.3851032,23.991908 37.1670257,26.0922257 37.1670257,28.124161 C37.1670257,30.1565614 36.6688269,33.2616822 36.6688269,33.2616822 C36.6688269,33.2616822 32.7650302,31.9517167 32.5238313,26.334588 C28.5656603,22.3721281 37.2678738,21.0565803 38.892132,16.3144677 C40.3709274,11.9980008 44.9602122,13.5898695 45.6382645,15.9865111 C47.0473492,20.9663341 44.5549609,22.4870292 44.5549609,22.4870292"
                id="Fill-344"
                fill="#070000"
              />
              <path
                d="M35.8470312,27.4808078 C35.8470312,26.63882 36.5288014,25.9568564 37.3695119,25.9568564 C38.2106871,25.9568564 38.8924573,26.63882 38.8924573,27.4808078 C38.8924573,28.3227957 38.2106871,29.0052245 37.3695119,29.0052245 C36.5288014,29.0052245 35.8470312,28.3227957 35.8470312,27.4808078"
                id="Fill-346"
                fill="#4C3BE3"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END evaluation.svg -->
  <!-- BEGIN templates.svg -->
  <svg
    v-else-if="name == 'templates'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="277px"
    height="237px"
    viewBox="0 0 277 237"
    version="1.1"
  >
    <title>{{ label }}</title>
    <defs>
      <path
        d="M2.024,4.624125 L0.0784864865,18.7405313 L40.7814595,18.7405313 C43.5029189,18.7310313 44.8853514,15.482625 43.0123784,13.511375 L43.0123784,13.511375 C38.7402162,9.0143125 31.1728108,2.8785 20.171027,0.524875 L20.171027,0.524875 C19.7304324,0.43046875 19.2184865,0.38771875 18.6524324,0.38771875 L18.6524324,0.38771875 C13.024,0.38771875 2.024,4.624125 2.024,4.624125 L2.024,4.624125 Z"
        id="template-path-1"
      />
      <path
        d="M2.024,4.624125 L0.0784864865,18.7405313 L40.7814595,18.7405313 C43.5029189,18.7310313 44.8853514,15.482625 43.0123784,13.511375 L43.0123784,13.511375 C38.7402162,9.0143125 31.1728108,2.8785 20.171027,0.524875 L20.171027,0.524875 C19.7304324,0.43046875 19.2184865,0.38771875 18.6524324,0.38771875 L18.6524324,0.38771875 C13.024,0.38771875 2.024,4.624125 2.024,4.624125 L2.024,4.624125 Z"
        id="template-path-3"
      />
      <path
        d="M12.7685937,53.1428901 C46.0509115,53.161456 75.81375,53.1428901 75.81375,53.1428901 L75.81375,53.1428901 C83.431901,73.6133297 88.0498698,108.791582 88.0498698,108.791582 L88.0498698,108.791582 L114.917943,107.211082 C114.917943,107.211082 113.486432,58.4174121 103.054974,40.8330769 L103.054974,40.8330769 C95.9986458,28.9377033 55.0113281,20.334489 55.0113281,20.334489 L55.0113281,20.334489 L52.0902083,3.21250549 L6.22497396,0.488703297 C-1.70044271,30.5912692 -3.30864583,53.1351044 12.7685937,53.1428901 L12.7685937,53.1428901 Z"
        id="template-path-5"
      />
      <path
        d="M1.98713514,4.624125 L0.0416216216,18.7405313 L40.7451892,18.7405313 C43.4666486,18.7310313 44.8484865,15.482625 42.9755135,13.511375 L42.9755135,13.511375 C38.7039459,9.0143125 31.1365405,2.8785 20.1347568,0.524875 L20.1347568,0.524875 C19.6935676,0.43046875 19.1822162,0.38771875 18.6161622,0.38771875 L18.6161622,0.38771875 C12.9871351,0.38771875 1.98713514,4.624125 1.98713514,4.624125 L1.98713514,4.624125 Z"
        id="template-path-7"
      />
      <path
        d="M1.98713514,4.624125 L0.0416216216,18.7405313 L40.7451892,18.7405313 C43.4666486,18.7310313 44.8484865,15.482625 42.9755135,13.511375 L42.9755135,13.511375 C38.7039459,9.0143125 31.1365405,2.8785 20.1347568,0.524875 L20.1347568,0.524875 C19.6935676,0.43046875 19.1822162,0.38771875 18.6161622,0.38771875 L18.6161622,0.38771875 C12.9871351,0.38771875 1.98713514,4.624125 1.98713514,4.624125 L1.98713514,4.624125 Z"
        id="template-path-9"
      />
      <path
        d="M0.17365,10.7732 C-0.3197,16.946975 4.28375,22.351975 10.45695,22.845325 L10.45695,22.845325 C16.630725,23.339825 22.035725,18.735225 22.529075,12.56145 L22.529075,12.56145 C23.023575,6.38825 18.418975,0.983825 12.2452,0.489325 L12.2452,0.489325 C11.9416,0.465175 11.639725,0.4531 11.34015,0.4531 L11.34015,0.4531 C5.552775,0.453675 0.64285,4.904175 0.17365,10.7732 L0.17365,10.7732 Z"
        id="template-path-11"
      />
      <polygon
        id="template-path-13"
        points="0 262.089965 275.5254 262.089965 275.5254 0.108306584 0 0.108306584"
      />
      <path
        d="M0.0906506024,4.09929897 C12.7900843,40.1961649 24.0808554,48.6145361 32.4356205,51.4163505 L32.4356205,51.4163505 C42.7477229,54.875134 77.8002831,60.7390825 97.3521867,53.1798247 L97.3521867,53.1798247 C101.250163,51.6725567 93.2574036,37.1757526 93.2574036,37.1757526 L93.2574036,37.1757526 L87.3883735,40.1844124 L43.3458976,34.9527526 L14.6036928,0.210958763 L0.0906506024,4.09929897 Z"
        id="template-path-15"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Modèles-de-page-/-Competences-Perso-/-Socle-commun-1"
        transform="translate(-1049.000000, -146.000000)"
      >
        <g id="Bandeau-Header" transform="translate(440.000000, 130.000000)">
          <g
            id="Illustration-Inscription"
            transform="translate(609.000000, 0.000000)"
          >
            <g id="Group-9" transform="translate(137.000000, 35.000000)">
              <polygon
                id="Fill-4"
                fill="#B7B3FF"
                points="0.392684597 90.1030692 135.369106 90.1030692 135.369106 77.6131879 0.392684597 77.6131879"
              />
              <polygon
                id="Fill-6"
                fill="#766DFF"
                points="30.898487 61.9671614 119.088328 61.9671614 139.321817 0.116419683 51.1319761 0.116419683"
              />
              <polygon
                id="Fill-7"
                fill="#FFFFFF"
                points="35.4908708 58.3291275 114.758533 58.3291275 132.945476 2.73599968 53.6778133 2.73599968"
              />
              <polygon
                id="Fill-8"
                fill="#4C3BE3"
                points="95.1961056 77.6131879 66.925302 77.6131879 62.0705082 61.9670408 90.3413118 61.9670408"
              />
            </g>
            <polygon
              id="Fill-17"
              fill="#3424C7"
              points="171.022068 197 193 236.979954 175.222347 239 155 200.627958"
            />
            <g id="Group-22" transform="translate(104.000000, 123.000000)">
              <path
                d="M10.1692228,28.7906465 C17.7731063,49.4570186 49.3246196,89.8821814 49.3246196,89.8821814 L83.0781381,81.2749721 C83.0781381,81.2749721 57.6627042,41.5433442 47.2499635,23.7901814 C40.2062968,11.7806 0.578571958,0.576413953 0.578571958,0.576413953 L10.1692228,28.7906465 Z"
                id="Fill-18"
                fill="#4C3BE3"
              />
              <path
                d="M89.0390376,111.185553 C100.101678,113.582391 107.710942,119.830856 112.007334,124.410484 C113.890069,126.417926 112.49999,129.725972 109.764075,129.736251 L68.835355,129.736251 L70.7916302,115.360065 C70.7916302,115.360065 84.1884079,110.135274 89.0390376,111.185553"
                id="Fill-20"
                fill="#E7E6FF"
              />
            </g>
            <g id="Group-29" transform="translate(173.000000, 234.000000)">
              <g id="Group-25">
                <mask id="template-mask-2" fill="white">
                  <use xlink:href="#template-path-1" />
                </mask>
                <g id="Clip-24" />
                <path
                  d="M28.5890226,1.41947812 C28.6092162,6.71216562 15.0530541,12.3207281 2.08197297,8.40019687 C-10.8885135,4.47966562 12.6717027,-2.62277188 12.6717027,-2.62277188 L28.5890226,1.41947812 Z"
                  id="Fill-23"
                  fill="#3424C7"
                  mask="url(#template-mask-2)"
                />
              </g>
              <g id="Group-28">
                <mask id="template-mask-4" fill="white">
                  <use xlink:href="#template-path-3" />
                </mask>
                <g id="Clip-27" />
                <polygon
                  id="Fill-26"
                  fill="#766DFF"
                  mask="url(#template-mask-4)"
                  points="-5.92132973 21.3982156 46.2882378 21.2010906 46.2614811 14.1877156 -5.94749189 14.3848406"
                />
              </g>
            </g>
            <g id="Group-34" transform="translate(51.000000, 104.000000)">
              <polygon
                id="Fill-30"
                fill="#4C3BE3"
                points="104.614661 89.6186748 113.024635 132.540312 95.5021094 134.589206 88.822526 93.2995155"
              />
              <path
                d="M6.22467448,0.487134956 C-1.70014323,30.5120907 -3.30834635,52.9967588 12.7682943,53.0051217 C46.0512109,53.023042 75.8140495,53.0051217 75.8140495,53.0051217 C83.4316016,73.4223783 88.0495703,108.508639 88.0495703,108.508639 L114.918242,106.932246 C114.918242,106.932246 113.486133,58.2659403 103.055273,40.7266925 C95.9983464,28.8622235 55.0116276,20.281958 55.0116276,20.281958 L52.0905078,3.20445796 L6.22467448,0.487134956 Z"
                id="Fill-32"
                fill="#766DFF"
              />
            </g>
            <g id="Group-52" transform="translate(51.000000, 104.000000)">
              <mask id="template-mask-6" fill="white">
                <use xlink:href="#template-path-5" />
              </mask>
              <g id="Clip-36" />
              <polygon
                id="Fill-35"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 -8.05462088 136.83263 -8.05462088 136.83263 -9.17276923 -17.178724 -9.17276923"
              />
              <polygon
                id="Fill-37"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 -0.379104396 136.83263 -0.379104396 136.83263 -1.49665385 -17.178724 -1.49665385"
              />
              <polygon
                id="Fill-38"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 7.29701099 136.83263 7.29701099 136.83263 6.17946154 -17.178724 6.17946154"
              />
              <polygon
                id="Fill-39"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 14.9731264 136.83263 14.9731264 136.83263 13.854978 -17.178724 13.854978"
              />
              <polygon
                id="Fill-40"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 22.6486429 136.83263 22.6486429 136.83263 21.5304945 -17.178724 21.5304945"
              />
              <polygon
                id="Fill-41"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 30.3247582 136.83263 30.3247582 136.83263 29.2072088 -17.178724 29.2072088"
              />
              <polygon
                id="Fill-42"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 38.0002747 136.83263 38.0002747 136.83263 36.8827253 -17.178724 36.8827253"
              />
              <polygon
                id="Fill-43"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 45.676989 136.83263 45.676989 136.83263 44.5588407 -17.178724 44.5588407"
              />
              <polygon
                id="Fill-44"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 52.4319945 136.83263 52.4319945 136.83263 51.3138462 -17.178724 51.3138462"
              />
              <polygon
                id="Fill-45"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 60.1081099 136.83263 60.1081099 136.83263 58.9899615 -17.178724 58.9899615"
              />
              <polygon
                id="Fill-46"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 67.7836264 136.83263 67.7836264 136.83263 66.6660769 -17.178724 66.6660769"
              />
              <polygon
                id="Fill-47"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 75.4597418 136.83263 75.4597418 136.83263 74.3421923 -17.178724 74.3421923"
              />
              <polygon
                id="Fill-48"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 83.1352582 136.83263 83.1352582 136.83263 82.0171099 -17.178724 82.0171099"
              />
              <polygon
                id="Fill-49"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 90.8119725 136.83263 90.8119725 136.83263 89.6938242 -17.178724 89.6938242"
              />
              <polygon
                id="Fill-50"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 98.4868901 136.83263 98.4868901 136.83263 97.3693407 -17.178724 97.3693407"
              />
              <polygon
                id="Fill-51"
                fill="#B7B3FF"
                mask="url(#template-mask-6)"
                points="-17.178724 106.163604 136.83263 106.163604 136.83263 105.046055 -17.178724 105.046055"
              />
            </g>
            <path
              d="M164.186616,234.141815 C175.239911,236.578381 182.842748,242.930417 187.135511,247.585955 C189.016656,249.626671 187.627751,252.989551 184.894146,253 L144,253 L145.954623,238.385521 C145.954623,238.385521 159.340084,233.074127 164.186616,234.141815"
              id="Fill-53"
              fill="#E7E6FF"
            />
            <g id="Group-61" transform="translate(144.000000, 234.000000)">
              <g id="Group-57">
                <mask id="template-mask-8" fill="white">
                  <use xlink:href="#template-path-7" />
                </mask>
                <g id="Clip-56" />
                <path
                  d="M28.5523956,1.41947812 C28.5725892,6.71216562 15.016427,12.3207281 2.04534595,8.40019687 C-10.9251405,4.47966562 12.6350757,-2.62277188 12.6350757,-2.62277188 L28.5523956,1.41947812 Z"
                  id="Fill-55"
                  fill="#4C3BE3"
                  mask="url(#template-mask-8)"
                />
              </g>
              <g id="Group-60">
                <mask id="template-mask-10" fill="white">
                  <use xlink:href="#template-path-9" />
                </mask>
                <g id="Clip-59" />
                <polygon
                  id="Fill-58"
                  fill="#766DFF"
                  mask="url(#template-mask-10)"
                  points="-5.9578973 21.3982156 46.2516703 21.2010906 46.2249135 14.1877156 -5.98405946 14.3848406"
                />
              </g>
            </g>
            <g id="Group-68" transform="translate(45.000000, 26.000000)">
              <path
                d="M0.4605,89.54946 L60.7695,89.71026 C60.7695,89.71026 74.0211,48.24006 64.1001,34.54986 C54.1791,20.86026 43.5975,22.83006 30.7599,33.73206 C16.4499,45.88446 0.4605,89.54946 0.4605,89.54946"
                id="Fill-62"
                fill="#B8B3FF"
              />
              <path
                d="M74.0346,19.71972 C74.0346,19.71972 77.0376,20.47752 77.52,19.53612 C77.8728,18.84732 77.6262,18.55092 75.9702,14.96832 L74.0346,19.71972 Z"
                id="Fill-64"
                fill="#4C3BE3"
              />
              <path
                d="M77.5089,13.10802 C76.9935,19.54962 71.3535,24.35442 64.9119,23.83902 C58.4703,23.32362 53.6661,17.68362 54.1815,11.24202 C54.6963,4.79982 60.3363,-0.00438 66.7779,0.51102 C73.2201,1.02642 78.0243,6.66642 77.5089,13.10802"
                id="Fill-66"
                fill="#4C3BE3"
              />
            </g>
            <g id="Group-71" transform="translate(100.000000, 26.000000)">
              <mask id="template-mask-12" fill="white">
                <use xlink:href="#template-path-11" />
              </mask>
              <g id="Clip-70" />
              <path
                d="M14.96035,-3.310735 C20.9599,11.66629 -0.439875,9.73659 5.33255,24.199565 L28.150275,22.653965 L27.54365,0.10649 L14.96035,-3.310735 Z"
                id="Fill-69"
                fill="#4C3BE3"
                mask="url(#template-mask-12)"
              />
            </g>
            <g id="Group-91">
              <path
                d="M116.51598,41.8239936 C116.59578,41.7216708 118.52478,39.3060151 121.02198,40.2999225 L121.43778,39.2629318 C118.80978,38.2151703 116.48958,40.0330455 115.63038,41.1400465 L116.51598,41.8239936 Z"
                id="Fill-72"
                fill="#FFFFFF"
              />
              <path
                d="M94.58988,23.4349717 C94.58988,19.482679 97.80288,16.2777615 101.76588,16.2777615 C105.72948,16.2777615 108.94248,19.482679 108.94248,23.4349717 C108.94248,27.3872645 105.72948,30.5921819 101.76588,30.5921819 C97.80288,30.5921819 94.58988,27.3872645 94.58988,23.4349717"
                id="Fill-74"
                fill="#070000"
              />
              <path
                d="M121.02942,33.3450241 C119.94042,39.5047367 108.44382,40.1144848 108.44382,40.1144848 L102.96282,47.0078099 C102.96282,47.0078099 91.76262,40.3891407 101.41482,29.2281772 C109.68822,19.6618935 121.63122,29.9426416 121.02942,33.3450241"
                id="Fill-76"
                fill="#070000"
              />
              <mask id="template-mask-14" fill="white">
                <use xlink:href="#template-path-13" />
              </mask>
              <g id="Clip-79" />
              <polygon
                id="Fill-78"
                fill="#FF3D81"
                mask="url(#template-mask-14)"
                points="10.989 150.319366 64.3902 150.319366 64.3902 104.347111 10.989 104.347111"
              />
              <polygon
                id="Fill-80"
                fill="#000000"
                mask="url(#template-mask-14)"
                points="0 150.319366 53.4018 150.319366 53.4018 104.347111 0 104.347111"
              />
              <path
                d="M140.01732,248.227321 L141.13692,248.227321 C141.13692,243.268555 137.60592,238.928513 132.74052,237.90708 L89.59332,228.847623 L89.59332,164.76543 L88.47312,164.76543 L88.47312,229.753569 L132.50952,238.99972 C136.86012,239.912846 140.01732,243.793932 140.01732,248.227321"
                id="Fill-81"
                fill="#070000"
                mask="url(#template-mask-14)"
              />
              <polygon
                id="Fill-82"
                fill="#070000"
                mask="url(#template-mask-14)"
                points="88.473 239.197185 89.5932 239.197185 89.5932 229.300596 88.473 229.300596"
              />
              <polygon
                id="Fill-83"
                fill="#070000"
                mask="url(#template-mask-14)"
                points="45.843 172.315177 132.2244 172.315177 132.2244 157.215085 45.843 157.215085"
              />
              <polygon
                id="Fill-84"
                fill="#000000"
                mask="url(#template-mask-14)"
                points="37.6902 172.315177 74.3856 172.315177 74.3856 157.215085 37.6902 157.215085"
              />
              <path
                d="M125.6847,247.059226 C125.6847,244.189999 128.0175,241.863501 130.8945,241.863501 C133.7721,241.863501 136.1043,244.189999 136.1043,247.059226 C136.1043,249.929051 133.7721,252.25495 130.8945,252.25495 C128.0175,252.25495 125.6847,249.929051 125.6847,247.059226"
                id="Fill-85"
                fill="#070000"
                mask="url(#template-mask-14)"
              />
              <path
                d="M36.92952,248.227321 L38.04972,248.227321 C38.04972,243.793932 41.20692,239.912846 45.55692,238.99972 L89.59332,229.753569 L89.59332,164.76543 L88.47312,164.76543 L88.47312,228.847623 L45.32652,237.90708 C40.46112,238.928513 36.92952,243.268555 36.92952,248.227321"
                id="Fill-86"
                fill="#070000"
                mask="url(#template-mask-14)"
              />
              <path
                d="M52.38186,247.059226 C52.38186,244.189999 50.04966,241.863501 47.17206,241.863501 C44.29506,241.863501 41.96286,244.189999 41.96286,247.059226 C41.96286,249.929051 44.29506,252.25495 47.17206,252.25495 C50.04966,252.25495 52.38186,249.929051 52.38186,247.059226"
                id="Fill-87"
                fill="#070000"
                mask="url(#template-mask-14)"
              />
              <path
                d="M83.82384,247.059226 C83.82384,244.189999 86.15604,241.863501 89.03364,241.863501 C91.91064,241.863501 94.24284,244.189999 94.24284,247.059226 C94.24284,249.929051 91.91064,252.25495 89.03364,252.25495 C86.15604,252.25495 83.82384,249.929051 83.82384,247.059226"
                id="Fill-88"
                fill="#070000"
                mask="url(#template-mask-14)"
              />
              <path
                d="M45.147,165.862617 L56.76,165.862617 L56.76,164.745444 L45.147,164.745444 C35.2842,164.745444 27.2604,156.743323 27.2604,146.907768 L27.2604,129.512295 L26.1408,129.512295 L26.1408,146.907768 C26.1408,157.359055 34.6668,165.862617 45.147,165.862617"
                id="Fill-89"
                fill="#070000"
                mask="url(#template-mask-14)"
              />
              <path
                d="M82.89132,62.2168069 C95.66712,98.9740269 107.02692,107.546403 115.43172,110.399474 C125.80692,113.921532 161.07192,119.893354 180.74232,112.195209 C184.66392,110.660367 176.62272,95.8989577 176.62272,95.8989577 L170.71752,98.9620594 L126.40872,93.6346919 L97.49232,58.257932 L82.89132,62.2168069 Z"
                id="Fill-90"
                fill="#4C3BE3"
                mask="url(#template-mask-14)"
              />
            </g>
            <g id="Group-94" transform="translate(83.000000, 58.000000)">
              <mask id="template-mask-16" fill="white">
                <use xlink:href="#template-path-15" />
              </mask>
              <g id="Clip-93" />
              <path
                d="M23.8856584,-14.604634 L48.1072608,17.0568093 L78.5127849,39.1293247 L80.1421102,68.0456696 C80.1421102,68.0456696 38.2203813,68.2187165 22.9117608,60.2816134 C7.60314036,52.3456856 -5.47798012,3.06654124 -5.47798012,3.06654124 L23.8856584,-14.604634 Z"
                id="Fill-92"
                fill="#B8B3FF"
                mask="url(#template-mask-16)"
              />
            </g>
            <g id="Group-115" transform="translate(82.000000, 62.000000)">
              <path
                d="M88.4394201,38.6678364 C92.4069757,31.5074159 90.7006159,21.52595 94.2646,23.2080977 C97.1027534,24.5487568 95.6134254,37.1314386 95.6134254,37.1314386 L88.4394201,38.6678364 Z"
                id="Fill-95"
                fill="#4C3BE3"
              />
              <path
                d="M94.2396085,33.1961886 C101.876974,29.6999955 110.402196,27.4517114 110.714889,30.0457 C111.026984,32.6390864 95.5956085,37.9571545 95.5956085,37.9571545 L94.2396085,33.1961886 Z"
                id="Fill-97"
                fill="#4C3BE3"
              />
              <path
                d="M98.3877249,32.125167 C100.77627,31.1085307 108.045339,28.015258 109.812085,29.545633 L110.539709,28.6940193 C108.933794,27.3003602 105.168921,28.0182693 97.9530635,31.089258 L98.3877249,32.125167 Z"
                id="Fill-99"
                fill="#FFFFFF"
              />
              <path
                d="M95.5366571,36.8615602 C103.407197,33.203958 112.166192,30.7918557 112.444207,33.409333 C112.722821,36.0268102 96.8484138,41.6538443 96.8484138,41.6538443 L95.5366571,36.8615602 Z"
                id="Fill-101"
                fill="#4C3BE3"
              />
              <path
                d="M99.8047688,35.708208 C102.268049,34.6403784 109.763118,31.3905148 111.547801,32.9112534 L112.26825,32.0530148 C110.647388,30.6714011 106.788647,31.4561625 99.3635307,34.6753102 L99.8047688,35.708208 Z"
                id="Fill-103"
                fill="#FFFFFF"
              />
              <path
                d="M95.7740169,41.5627205 C103.411382,38.0671295 111.936604,35.8182432 112.248699,38.4122318 C112.561393,41.0056182 97.1300169,46.3236864 97.1300169,46.3236864 L95.7740169,41.5627205 Z"
                id="Fill-105"
                fill="#4C3BE3"
              />
              <path
                d="M99.9218344,40.4923011 C102.310379,39.4750625 109.57885,36.3811875 111.346194,37.912767 L112.074416,37.0605511 C110.468501,35.6662898 106.70303,36.3854034 99.487173,39.456392 L99.9218344,40.4923011 Z"
                id="Fill-107"
                fill="#FFFFFF"
              />
              <path
                d="M96.5120444,45.7639341 C103.332103,42.8856727 112.077346,41.0114 112.309923,43.6065932 C112.542499,46.2017864 98.7923725,50.2894114 98.7923725,50.2894114 L96.5120444,45.7639341 Z"
                id="Fill-109"
                fill="#4C3BE3"
              />
              <path
                d="M101.07294,44.8263761 C106.29067,42.8587511 110.048368,41.8144102 111.427686,43.114717 L112.190585,42.2938193 C110.377802,40.5851716 106.597384,41.542183 100.681924,43.7730011 L101.07294,44.8263761 Z"
                id="Fill-111"
                fill="#FFFFFF"
              />
              <path
                d="M50.9730444,52.4471739 L51.0238646,51.3245375 C50.8295524,51.3149011 31.4670921,50.3115148 22.9502402,40.816083 C9.59352063,25.925492 1.49040423,0.281321591 1.40968995,0.0241511364 L0.344859259,0.361423864 C0.426171429,0.621003409 8.60402328,26.4988557 22.1221714,41.5701284 C24.6775259,44.4188784 29.8414466,48.324617 39.9289386,50.7547875 C45.9292984,52.2014466 50.9234201,52.4447648 50.9730444,52.4471739"
                id="Fill-113"
                fill="#000000"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END templates.svg -->
  <!-- begin help -->
  <svg
    v-else-if="name === 'help'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 313 223"
  >
    <defs>
      <path id="a" d="M0 .74h60.42v48.13H0z" />
      <path id="c" d="M.33.58h67.95v52.07H.33z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path fill="#E7E6FF" d="M45 223h268V40H45z" />
      <path
        d="M271.47 132.67s16 32.9 19.92 45.03c3.92 12.12-31.98-38.18-31.98-38.18l12.06-6.85zM111.1 136.06l-51.34-45.5-13.84 18.15s42.8 74 60.36 74.16c13.37.12 37.33-20.2 37.33-20.2l-32.51-26.61z"
        fill="#B7B3FF"
      />
      <path
        d="M282.16 136.41s-22.75-42.53-39.08-51.33c-9.35-5.04-41.73-7.97-41.73-7.97s-29.28 1.08-32.94 2.5c-6.76 2.64-57.31 56.45-57.31 56.45l32.51 32.1 10.89-9.84c1.97 4 2.46 3.72 2.67 6.2.44 4.89-1.7 35.6-1.7 35.6h101.79l-12.62-47.06 37.52-16.65z"
        fill="#766DFF"
      />
      <path
        d="M194.88 18.85c-2.33-2.88 7.34-4.06 7.44-2.2.1 1.87-6.07 3.9-7.44 2.2M220.57 30.84a3.65 3.65 0 11-7.3.08 3.65 3.65 0 017.3-.08M202.8 28.31a3.65 3.65 0 11-7.3.09 3.65 3.65 0 017.3-.09"
        fill="#FFF"
      />
      <g transform="translate(0 59.85)">
        <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
        <path
          d="M60.42 32.1s-2.6-5.42-5-10.91c-2.41-5.5-6-19.8-9.32-19.83-3.32-.04.07 17.46.07 17.46S22.02-.93 18.77.85c-3.87 2.11 12.4 15.33 12.4 15.33S11.2 5.32 8.87 7.4C6.56 9.47 25.4 21.03 25.4 21.03s-21.85-8.6-23.86-6.59c-2 2.02 18.08 12 18.08 12S1.46 19.4.03 22.03c-1.42 2.62 45.9 26.84 45.9 26.84L60.41 32.1z"
          fill="#B7B3FF"
          mask="url(#b)"
        />
      </g>
      <path
        d="M47.94 96.28a.89.89 0 01-.53-.18 19.86 19.86 0 00-17.6-3.03.89.89 0 11-.53-1.69 21.7 21.7 0 0116.33 1.5 35.03 35.03 0 01-2.22-6.59.89.89 0 011.73-.4c.72 3.2 2.1 6.66 3.58 9.04a.89.89 0 01-.76 1.35"
        fill="#122030"
      />
      <path
        d="M290.45 176.37c-4.4-7.1-32.89-44.07-32.89-44.07s3.51-2.59 3.09-6.2c-.43-3.62-3.4-2.98-3.4-2.98s4.03-6.37 1.73-8.6c-1.16-1.13-4.2-.39-6.95.63 4.56-6.39 13.05-18.87 10.59-19.91-3.33-1.4-23.2 18.86-23.2 18.86s-8.51-3.94-10.76-3.83c-2.24.1-6.89 5.63-7.55 15.61-.65 9.98 4.45 10.73 6.12 14.92 1.68 4.18 5.16 16.96 17.46 42.03 12.3 25.08 26.15 32.09 37.8 25.5 11.64-6.58 12.36-24.86 7.96-31.96"
        fill="#B7B3FF"
      />
      <path
        d="M283.13 167.37a.89.89 0 01-.72-.36l-14.9-20.18a.89.89 0 111.42-1.06l14.9 20.18a.89.89 0 01-.7 1.42M238.52 137.64c-1.09 0-2.03-.15-2.68-.54a2.12 2.12 0 01-1.04-1.51c-.13-.8.15-3.44 7.34-7.71-4 .5-8.58.58-9.6-1.38a1.7 1.7 0 01-.06-1.4c1.2-3.21 13.44-8.23 15.88-9.2a.89.89 0 11.66 1.64c-7.94 3.17-14.76 6.93-14.89 8.22.56 1.04 6.67.83 13.04-.53a.89.89 0 01.57 1.66c-5.6 2.73-11.47 6.72-11.2 8.42.02.08.05.17.22.27 1.56.94 7.75-.51 11.64-1.85a.89.89 0 01.58 1.68c-1.31.45-6.75 2.23-10.46 2.23"
        fill="#122030"
      />
      <path
        d="M306.92 205h-73.53a1.03 1.03 0 010-2.07h73.53a1.03 1.03 0 010 2.07"
        fill-opacity=".3"
        fill="#FF3D81"
      />
      <path
        d="M233.4 205H53.31a1.03 1.03 0 110-2.07h180.07a1.03 1.03 0 010 2.07"
        fill="#FF3D81"
      />
      <path
        d="M235.6 203.97a2.2 2.2 0 11-4.4 0 2.2 2.2 0 014.4 0"
        fill="#FF3D81"
      />
      <path
        d="M52.48 209.77v4.81h1.4v-1.94l2.97 1.94v-4.8l-2.96 1.94v-1.95h-1.4zm24.01 0v1.95l-2.96-1.95v4.81l2.96-1.94v1.94h1.41v-4.8h-1.4zm-13.36 4.81h1.41v-4.8h-1.4v4.8zm2.71 0h1.4v-4.8h-1.4v4.8zM297.29 212.18a2.4 2.4 0 11-4.8 0 2.4 2.4 0 014.8 0"
        fill="#FFF"
      />
      <path
        fill="#FFFDFF"
        d="M301.94 211.55v-.92h1.75v-.85h-2.6v1.77zM305.1 210.63h1.74v.92h.85v-1.77h-2.6zM303.7 213.88h-1.76v-.92h-.85v1.77h2.6z"
      />
      <path fill="#FFF" d="M306.84 212.96v.92h-1.75v.85h2.6v-1.77z" />
      <g transform="translate(86.42)">
        <mask id="d" fill="#fff"><use xlink:href="#c" /></mask>
        <path
          d="M22.49.58h23.63a22.16 22.16 0 0122.16 22.17v1.12a22.16 22.16 0 01-22.16 22.16h-5.24v6.62l-10.2-6.62h-8.2A22.16 22.16 0 01.34 23.87v-1.12A22.16 22.16 0 0122.49.58"
          fill="#FF3D81"
          mask="url(#d)"
        />
      </g>
      <path
        d="M136.85 17.73a5.58 5.58 0 100 11.15 5.58 5.58 0 000-11.15m-16.13 0a5.58 5.58 0 100 11.15 5.58 5.58 0 000-11.15m-10.55 5.58a5.58 5.58 0 11-11.16 0 5.58 5.58 0 0111.16 0"
        fill="#FFF"
      />
      <path
        d="M226.26 48.9a23.8 23.8 0 11-47.6.01 23.8 23.8 0 0147.6 0"
        fill="#4C3BE3"
      />
      <path
        d="M182.58 35.83c-23.37-14.6-9.71-21.12 6.45-25.21 16.16-4.1 36.16 4.85 38.5 12.99 2.32 8.14 1.17 28.07-4.52 37.31-2-5.88-17.26-31.71-31.2-30.19-4.75.52-5.37 1.42-9.23 5.1"
        fill="#000"
      />
      <path
        d="M223.29 45.3a5.58 5.58 0 11-11.17 0 5.58 5.58 0 0111.17 0"
        fill="#4C3BE3"
      />
      <path
        d="M183.19 41.23c-1.73-2.13 5.44-3 5.51-1.62.08 1.38-4.5 2.88-5.51 1.62M202.23 50.12a2.7 2.7 0 11-5.41.06 2.7 2.7 0 015.4-.06M189.05 48.25a2.7 2.7 0 11-5.4.06 2.7 2.7 0 015.4-.06"
        fill="#000"
      />
      <path
        d="M200.8 57.05a1.98 1.98 0 103.91-.67 1.98 1.98 0 00-3.9.67"
        fill="#FF3D81"
      />
      <path
        d="M191.78 56.87a.65.65 0 01-.34-.1c-.23-.14-2.28-1.46-2.5-3.2-.19-1.59 2.1-6.43 2.57-7.39a.66.66 0 111.18.58c-1.08 2.23-2.55 5.77-2.44 6.65.12.95 1.4 1.94 1.88 2.24a.66.66 0 01-.35 1.22"
        fill="#000"
      />
      <path
        d="M195.9 56a8.66 8.66 0 01-7.9 4.09c1.58 2.13 5.24 3.12 7.4 1.58 2.14-1.54 2.01-3.49.5-5.66"
        fill="#FFF"
      />
    </g>
  </svg>
  <!-- end help -->

  <!-- BEGIN depot_documents -->
  <svg
    v-else-if="name === 'depot_documents'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="201px"
    height="239px"
    viewBox="0 0 201 239"
    version="1.1"
  >
    <title>{{ label }}</title>
    <defs>
      <path
        d="M1.69824274,3.57875 L0.294181197,13.8215 L29.6675556,13.818 C31.6312068,13.810125 32.6291419,11.45375 31.2776479,10.024 L31.2776479,10.024 C28.1948171,6.761125 22.7337299,2.310875 14.7951863,0.60375 L14.7951863,0.60375 C14.4772376,0.5355 14.1084171,0.504875 13.7005949,0.504875 L13.7005949,0.504875 C9.63848205,0.504875 1.69824274,3.57875 1.69824274,3.57875 L1.69824274,3.57875 Z"
        id="path-1"
      />
      <path
        d="M1.69824274,3.57875 L0.294181197,13.8215 L29.6675556,13.818 C31.6312068,13.810125 32.6291419,11.45375 31.2776479,10.024 L31.2776479,10.024 C28.1948171,6.761125 22.7337299,2.310875 14.7951863,0.60375 L14.7951863,0.60375 C14.4772376,0.5355 14.1084171,0.504875 13.7005949,0.504875 L13.7005949,0.504875 C9.63848205,0.504875 1.69824274,3.57875 1.69824274,3.57875 L1.69824274,3.57875 Z"
        id="path-3"
      />
      <path
        d="M1.51171282,3.57875 L0.106803419,13.8215 L29.4810256,13.818 C31.4446769,13.810125 32.442612,11.45375 31.0911179,10.024 L31.0911179,10.024 C28.0082872,6.761125 22.5472,2.310875 14.6086564,0.60375 L14.6086564,0.60375 C14.2907077,0.5355 13.9218872,0.504875 13.514065,0.504875 L13.514065,0.504875 C9.45195214,0.504875 1.51171282,3.57875 1.51171282,3.57875 L1.51171282,3.57875 Z"
        id="path-5"
      />
      <path
        d="M1.51171282,3.57875 L0.106803419,13.8215 L29.4810256,13.818 C31.4446769,13.810125 32.442612,11.45375 31.0911179,10.024 L31.0911179,10.024 C28.0082872,6.761125 22.5472,2.310875 14.6086564,0.60375 L14.6086564,0.60375 C14.2907077,0.5355 13.9218872,0.504875 13.514065,0.504875 L13.514065,0.504875 C9.45195214,0.504875 1.51171282,3.57875 1.51171282,3.57875 L1.51171282,3.57875 Z"
        id="path-7"
      />
      <polygon
        id="offre-9"
        points="0.455981885 0.0789016336 117.890502 0.0789016336 117.890502 93.2908794 0.455981885 93.2908794"
      />
      <polygon
        id="offre-11"
        points="0.455981885 0.0789016336 117.890502 0.0789016336 117.890502 93.2908794 0.455981885 93.2908794"
      />
      <polygon
        id="offre-13"
        points="0.168517847 0.215983607 48.6452157 0.215983607 48.6452157 66.279694 0.168517847 66.279694"
      />
      <polygon
        id="offre-15"
        points="0.167924632 0.215983607 14.5567828 0.215983607 14.5567828 14.5960874 0.167924632 14.5960874"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Dépot-de-document-/-Module-1"
        transform="translate(-1099.000000, -136.000000)"
      >
        <g id="Bandeau-Header" transform="translate(312.000000, 136.000000)">
          <g id="Illustration" transform="translate(787.000000, 0.000000)">
            <g id="Group-31" transform="translate(29.000000, 53.000000)">
              <path
                d="M20.2912415,20.2035068 C35.8813776,24.5435068 65.6534864,27.9314247 73.735119,27.7861918 C88.2045068,27.5271507 108.286139,25.9346849 108.286139,25.9346849 L108.463861,11.0275068 L102.303146,12.0305479 C102.303146,12.0305479 79.5693027,11.1667945 71.2461735,10.974 C63.6271259,10.7981918 41.3133503,6.75120548 25.1875,3.6919726 C20.6407313,2.82906849 11.8346088,17.8500548 20.2912415,20.2035068"
                id="Fill-1"
                fill="#766DFF"
              />
              <path
                d="M101.197704,13.1705836 C106.749575,7.91162466 108.814201,-0.825279452 111.034439,1.28356986 C112.803997,2.96351507 107.347364,13.2699534 107.347364,13.2699534 L101.197704,13.1705836 Z"
                id="Fill-3"
                fill="#766DFF"
              />
              <path
                d="M108.265306,10.2838466 C116.113095,9.43028493 124.391156,9.94242192 123.913265,12.3332438 C123.434524,14.7240658 108.086735,14.9024219 108.086735,14.9024219 L108.265306,10.2838466 Z"
                id="Fill-5"
                fill="#766DFF"
              />
              <path
                d="M108.353741,13.9141589 C116.458333,12.9850082 124.992347,13.4215562 124.47619,15.8234192 C123.960884,18.2252822 108.12585,18.5471726 108.12585,18.5471726 L108.353741,13.9141589 Z"
                id="Fill-7"
                fill="#766DFF"
              />
              <path
                d="M123.902381,15.0682932 C122.720408,13.1462932 115.026531,13.8274438 112.497619,14.0508137 L112.421939,13.1964027 C119.957653,12.5296904 123.610714,12.9543479 124.634524,14.6198548 L123.902381,15.0682932 Z"
                id="Fill-9"
                fill="#070000"
              />
              <path
                d="M107.192857,18.1503726 C115.040646,17.296811 123.318707,17.8089479 122.840816,20.1997699 C122.362075,22.5905918 107.014286,22.7689479 107.014286,22.7689479 L107.192857,18.1503726 Z"
                id="Fill-11"
                fill="#766DFF"
              />
              <path
                d="M122.261905,19.4425205 C121.098639,17.5154247 113.653061,18.1252329 111.205782,18.3256712 L111.136054,17.470411 C118.441327,16.8724932 121.989796,17.3294247 122.997449,19.0000274 L122.261905,19.4425205 Z"
                id="Fill-13"
                fill="#070000"
              />
              <path
                d="M106.625255,22.0912795 C113.56318,21.5443205 121.927976,22.453937 121.377806,24.8218274 C120.827636,27.1905671 107.21369,25.9335808 107.21369,25.9335808 L106.625255,22.0912795 Z"
                id="Fill-15"
                fill="#766DFF"
              />
              <path
                d="M120.816922,24.0814795 C119.939371,22.4805205 116.247194,22.2928219 110.972534,22.5051507 L110.93767,21.6473425 C116.839881,21.4112329 120.472534,21.6660274 121.570323,23.6695616 L120.816922,24.0814795 Z"
                id="Fill-17"
                fill="#070000"
              />
              <polygon
                id="Fill-19"
                fill="#766DFF"
                points="14.6892857 178.437784 14.5719388 141.566468 29.4333333 141.566468 27.7318027 173.165236"
              />
              <polygon
                id="Fill-21"
                fill="#766DFF"
                points="64.1701531 178.359477 53.9082483 127.638381 69.824915 125.92786 76.4107993 172.996901"
              />
              <path
                d="M8.65263605,52.2900356 C8.72066327,58.0076247 8.88647959,152.341049 9.17219388,163.491707 C18.5233844,163.968173 22.5310374,164.349515 38.6577381,163.491707 C38.6577381,150.340063 37.7980442,117.888584 35.6407313,100.518392 C46.4230442,118.435542 47.1492347,122.63031 52.4927721,162.848775 C67.1245748,161.633405 75.0837585,160.694063 81.8822279,159.632419 C77.9460034,120.648858 55.5463435,72.0952137 41.8184524,46.4688301 C27.4119898,48.3755425 21.5769558,49.6028027 8.65263605,52.2900356"
                id="Fill-23"
                fill="#3424C7"
              />
              <path
                d="M15.2406463,0.426271233 C33.9744898,-3.34723562 48.0612245,30.5930932 50.9234694,41.4575315 C32.6113946,47.7823808 18.289966,52.6387644 0.542517007,53.1729836 C-0.411564626,44.0241616 -2.04761905,3.90931233 15.2406463,0.426271233"
                id="Fill-25"
                fill="#070000"
              />
              <path
                d="M16.6340986,0.216830137 C19.057568,-0.00569041096 21.9368197,-0.0965671233 26.7803571,2.80384384 C24.1060374,3.35674795 10.2863095,5.59893973 6.90705782,6.23337808 C9.98358844,1.68869315 13.8628401,0.470775342 16.6340986,0.216830137"
                id="Fill-27"
                fill="#766DFF"
              />
              <path
                d="M28.1282313,172.996901 C36.0908163,174.653915 41.5670068,178.974381 44.6588435,182.140627 C46.0142857,183.528408 45.0134354,185.816463 43.0440476,185.824107 L13.5848639,185.826655 L14.9938776,175.885422 C14.9938776,175.885422 24.637585,172.270737 28.1282313,172.996901"
                id="Fill-29"
                fill="#7BEAFF"
              />
            </g>
            <g id="Group-38" transform="translate(42.000000, 225.000000)">
              <g id="Group-34">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1" />
                </mask>
                <g id="Clip-33" />
                <path
                  d="M20.8699728,1.2522125 C20.8843706,5.0925875 11.1008766,9.1630875 1.74046632,6.3193375 C-7.61909607,3.4755875 9.3839535,-1.6790375 9.3839535,-1.6790375 L20.8699728,1.2522125 Z"
                  id="Fill-32"
                  fill="#766DFF"
                  mask="url(#mask-2)"
                />
              </g>
              <g id="Group-37">
                <mask id="mask-4" fill="white">
                  <use xlink:href="#path-3" />
                </mask>
                <g id="Clip-36" />
                <polygon
                  id="Fill-35"
                  fill="#3424C7"
                  mask="url(#mask-4)"
                  points="-4.03602598 15.75 33.641321 15.603 33.622668 10.514875 -4.05467897 10.661875"
                />
              </g>
            </g>
            <path
              d="M105.223626,226.09695 C113.01115,227.76343 118.366945,232.108579 121.390806,235.292914 C122.716448,236.688623 121.737602,238.98975 119.811512,238.997437 L91,239 L92.3780359,229.001973 C92.3780359,229.001973 101.809723,225.366637 105.223626,226.09695"
              id="Fill-39"
              fill="#7BEAFF"
            />
            <g id="Group-47" transform="translate(90.000000, 225.000000)">
              <g id="Group-43">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#path-5" />
                </mask>
                <g id="Clip-42" />
                <path
                  d="M20.6832733,1.2522125 C20.6976711,5.0925875 10.9141771,9.1630875 1.55376684,6.3193375 C-7.80579556,3.4755875 9.19725402,-1.6790375 9.19725402,-1.6790375 L20.6832733,1.2522125 Z"
                  id="Fill-41"
                  fill="#766DFF"
                  mask="url(#mask-6)"
                />
              </g>
              <g id="Group-46">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-7" />
                </mask>
                <g id="Clip-45" />
                <polygon
                  id="Fill-44"
                  fill="#3424C7"
                  mask="url(#mask-8)"
                  points="-4.22272547 15.75 33.4546215 15.603 33.4359685 10.514875 -4.24137846 10.661875"
                />
              </g>
            </g>
            <g id="Group-108">
              <path
                d="M52.8673377,43.6202186 L52.7622539,42.7715301 C53.6198736,42.6648087 53.9910568,42.4505191 54.0512258,42.2845082 C54.1647841,41.9778962 53.5563148,41.3146995 53.296995,41.0318033 C53.2385209,40.9682787 53.1851316,40.9098361 53.1393693,40.8573224 L53.782584,40.292377 C53.8241091,40.3406557 53.8741086,40.3948634 53.9283455,40.453306 C54.3842737,40.9513388 55.1486739,41.7839344 54.8554561,42.5801093 C54.6486782,43.1399727 53.9986838,43.4796175 52.8673377,43.6202186"
                id="Fill-48"
                fill="#070000"
              />
              <path
                d="M51.8125164,45.0590082 C48.7091535,48.6231612 43.3032682,48.9966858 39.7380449,45.8958388 C36.1719742,42.7941448 35.7982486,37.3911667 38.900764,33.8278607 C42.0041269,30.2637077 47.4100122,29.8893361 50.9752355,32.9910301 C54.5413062,36.092724 54.9158793,41.4957022 51.8125164,45.0590082"
                id="Fill-50"
                fill="#766DFF"
              />
              <path
                d="M39.7380449,45.8956694 C36.1719742,42.7939754 35.7982486,37.3909973 38.900764,33.8276913 C42.0041269,30.2635383 47.4100122,29.8891667 50.9752355,32.9908607 C49.7269413,39.443265 44.9871519,44.8369262 39.7380449,45.8956694"
                id="Fill-52"
                fill="#000000"
              />
              <path
                d="M46.9852701,41.5465219 C46.9852701,40.1938716 45.8886695,39.0978607 44.5352914,39.0978607 C43.1819133,39.0978607 42.0853127,40.1938716 42.0853127,41.5465219 C42.0853127,42.8991721 43.1819133,43.9951831 44.5352914,43.9951831 C45.8886695,43.9951831 46.9852701,42.8991721 46.9852701,41.5465219"
                id="Fill-54"
                fill="#766DFF"
              />
              <path
                d="M40.1398211,33.9082404 C40.1398211,32.5555902 39.0432204,31.4595792 37.6898423,31.4595792 C36.3364643,31.4595792 35.2398636,32.5555902 35.2398636,33.9082404 C35.2398636,35.2608907 36.3364643,36.3569016 37.6898423,36.3569016 C39.0432204,36.3569016 40.1398211,35.2608907 40.1398211,33.9082404"
                id="Fill-56"
                fill="#7BEAFF"
              />
              <path
                d="M35.565793,32.7321038 C32.3064992,28.9680601 25.3311361,32.2713388 22.323535,41.8855738 C20.2905018,48.3854098 21.0430377,52.9515574 17.6159488,58.5425683 C13.8600492,64.6714208 6.37113114,66.4196175 2.34065765,71.9750546 C-0.451690995,75.8237978 2.82878901,79.7208197 0,87.5860109 C3.38895363,90.8181421 8.55840029,91.5253825 11.8388803,93.1456831 C16.9507003,86.6593989 10.4371975,85.6142077 15.1913936,79.0322131 C15.0490219,83.3324044 17.3786627,85.4236339 16.3329091,93.3599727 C19.376103,95.1183333 20.7540571,96.3066667 22.8464119,96.6386885 C23.9404702,89.130082 26.142146,84.3903005 26.9353594,81.0514481 C28.7421234,73.4479781 32.5929374,56.0981421 32.0709081,49.592377 C31.4522694,41.8855738 31.5234552,35.6084973 34.9971539,35.0147541 C36.3979892,34.7759016 35.565793,32.7321038 35.565793,32.7321038"
                id="Fill-58"
                fill="#000000"
              />
              <path
                d="M50.6034591,39.810776 L49.9424479,39.2670055 C50.6246453,38.4386448 52.1822589,37.5569235 53.492417,37.5916503 L53.4729257,38.4471148 C52.4636124,38.4267869 51.149217,39.1475792 50.6034591,39.810776"
                id="Fill-60"
                fill="#070000"
              />
              <path
                d="M50.9754897,45.3224235 C50.9754897,45.8941448 50.5119344,46.3582978 49.9390581,46.3582978 C49.3670291,46.3582978 48.9034738,45.8941448 48.9034738,45.3224235 C48.9034738,44.7507022 49.3670291,44.2865492 49.9390581,44.2865492 C50.5119344,44.2865492 50.9754897,44.7507022 50.9754897,45.3224235"
                id="Fill-62"
                fill="#FF3D81"
              />
              <path
                d="M64.067071,154.750137 C63.8069038,154.243634 62.4264073,152.326038 60.6789648,149.898552 C55.3188419,142.451776 46.3460384,129.988251 45.2401158,124.970656 L46.0757018,124.786858 C47.1443365,129.631667 56.4010359,142.490738 61.3738741,149.398825 C63.2797897,152.04653 64.5391008,153.796421 64.8289288,154.359672 L64.067071,154.750137 Z"
                id="Fill-64"
                fill="#FFFFFF"
              />
              <path
                d="M70.78625,124.719522 L70.2820171,124.028374 C74.6379115,120.855533 75.7463764,114.512391 72.9175874,108.945096 L73.6811401,108.558019 C76.7006054,114.502227 75.4828194,121.298511 70.78625,124.719522"
                id="Fill-66"
                fill="#FFFFFF"
              />
              <g id="Group-70" transform="translate(82.202676, 30.491803)">
                <mask id="mask-10" fill="white">
                  <use xlink:href="#path-9" />
                </mask>
                <g id="Clip-69" />
                <path
                  d="M68.651099,9.23291803 L71.6264969,17.3428907 C72.1671702,18.8175082 73.3688547,19.8254317 74.854435,20.0498852 L114.356635,26.0305137 C116.905765,26.4167432 118.413379,29.0305683 117.723554,31.869694 L103.892319,88.8012787 C103.203341,91.6404044 100.577941,93.6291475 98.0288101,93.242918 L3.98979588,79.0049399 C1.44066546,78.6195574 -0.0661011212,76.0048852 0.622875949,73.1666066 L17.288833,4.56767213 C17.9778101,1.72854645 20.603211,-0.259349727 23.1531889,0.126879781 L65.4231609,6.5259235 C66.9087413,6.75122404 68.1104258,7.75830055 68.651099,9.23291803"
                  id="Fill-68"
                  fill="#007CFF"
                  mask="url(#mask-10)"
                />
              </g>
              <g id="Group-73" transform="translate(82.202676, 30.491803)">
                <mask id="mask-12" fill="white">
                  <use xlink:href="#path-11" />
                </mask>
                <g id="Clip-72" />
                <path
                  d="M68.651099,9.23291803 L71.6264969,17.3428907 C72.1671702,18.8175082 73.3688547,19.8254317 74.854435,20.0498852 L114.356635,26.0305137 C116.905765,26.4167432 118.413379,29.0305683 117.723554,31.869694 L103.892319,88.8012787 C103.203341,91.6404044 100.577941,93.6291475 98.0288101,93.242918 L3.98979588,79.0049399 C1.44066546,78.6195574 -0.0661011212,76.0048852 0.622875949,73.1666066 L17.288833,4.56767213 C17.9778101,1.72854645 20.603211,-0.259349727 23.1531889,0.126879781 L65.4231609,6.5259235 C66.9087413,6.75122404 68.1104258,7.75830055 68.651099,9.23291803"
                  id="Fill-71"
                  fill="#E82A81"
                  mask="url(#mask-12)"
                />
              </g>
              <g id="Group-76" transform="translate(120.023235, 0.000000)">
                <mask id="mask-14" fill="white">
                  <use xlink:href="#path-13" />
                </mask>
                <g id="Clip-75" />
                <polygon
                  id="Fill-74"
                  fill="#E7E6FF"
                  mask="url(#mask-14)"
                  points="48.6452157 0.215814208 48.6452157 66.279694 0.168517847 66.279694 0.168517847 14.5960874 14.5565286 0.215814208"
                />
              </g>
              <g id="Group-79" transform="translate(120.023235, 0.000000)">
                <mask id="mask-16" fill="white">
                  <use xlink:href="#path-15" />
                </mask>
                <g id="Clip-78" />
                <polygon
                  id="Fill-77"
                  fill="#B7B3FF"
                  mask="url(#mask-16)"
                  points="14.5567828 14.5960874 14.5567828 0.215814208 0.167924632 14.5960874"
                />
              </g>
              <path
                d="M133.566298,46.2137158 L138.038293,53.6740437 C138.851846,55.030082 140.214546,55.9677049 141.700126,56.1921585 L181.202325,62.1727869 C183.751456,62.5590164 185.725168,64.9712568 185.610762,67.5596721 L183.315866,119.482131 C183.201461,122.071393 181.042157,123.857705 178.493027,123.471475 L84.4540127,109.234344 C81.9057297,108.848115 79.9311706,106.436721 80.0455764,103.847459 L82.8116541,41.2842077 C82.9260599,38.6957923 85.0853632,36.9094809 87.6344936,37.2957104 L129.905313,43.6947541 C131.390893,43.9200546 132.753593,44.8576776 133.566298,46.2137158"
                id="Fill-80"
                fill="#FF3D81"
              />
              <path
                d="M137.431943,35.8321885 C137.561603,35.8321885 137.69211,35.7822158 137.790414,35.6839645 C137.988718,35.4857678 137.988718,35.1647568 137.790414,34.9665601 C133.963329,31.1406858 133.963329,24.916123 137.790414,21.0902486 C139.644635,19.2370246 142.110716,18.2172432 144.732727,18.2172432 C147.354738,18.2172432 149.819971,19.2370246 151.674192,21.0902486 C153.528413,22.9434727 154.549591,25.4073798 154.549591,28.0288279 C154.549591,30.649429 153.528413,33.1133361 151.674192,34.9665601 C151.475889,35.1647568 151.475889,35.4857678 151.674192,35.6839645 C151.872495,35.8813142 152.193679,35.8813142 152.391135,35.6839645 C154.437727,33.6393197 155.563989,30.9204672 155.563989,28.0288279 C155.563989,25.1371885 154.437727,22.4183361 152.391135,20.3736913 C150.34539,18.3281995 147.625922,17.2025437 144.732727,17.2025437 C141.839532,17.2025437 139.119216,18.3281995 137.073471,20.3736913 C132.849779,24.594265 132.849779,31.4625437 137.073471,35.6839645 C137.172623,35.7822158 137.302283,35.8321885 137.431943,35.8321885"
                id="Fill-82"
                fill="#B7B3FF"
              />
              <path
                d="M140.38768,38.8669699 L140.38768,27.5663689 C140.38768,26.5482814 141.213944,25.7224617 142.232579,25.7224617 L147.232536,25.7224617 C148.251171,25.7224617 149.077435,26.5482814 149.077435,27.5663689 L149.077435,38.8669699 L150.957927,38.8669699 L144.732557,44.2267514 L138.507188,38.8669699 L140.38768,38.8669699 Z"
                id="Fill-84"
                fill="#B7B3FF"
              />
              <path
                d="M35.6087587,76.237724 C42.2103963,89.7777787 54.2899525,104.467205 63.3432637,104.355402 C75.7592577,104.202943 107.856437,72.0713579 107.856437,72.0713579 L99.5082041,59.7662213 L95.0395988,64.0918224 C95.0395988,64.0918224 71.0431969,85.9713852 65.912733,85.2455109 C60.8729462,84.5323415 63.347501,83.7852923 51.6755684,65.7265219 C46.2281581,57.2980792 30.1808397,65.1048279 35.6087587,76.237724"
                id="Fill-86"
                fill="#766DFF"
              />
              <path
                d="M94.7846857,65.6540191 C96.330435,58.1903033 93.0406331,49.864347 96.059251,50.326806 C98.4634674,50.6952486 99.8719297,62.2372432 99.8719297,62.2372432 L94.7846857,65.6540191 Z"
                id="Fill-88"
                fill="#766DFF"
              />
              <path
                d="M98.9217685,59.2701366 C104.855615,54.1068579 111.919961,49.8176776 112.891139,52.0469672 C113.861469,54.2762568 101.40734,63.1527596 101.40734,63.1527596 L98.9217685,59.2701366 Z"
                id="Fill-90"
                fill="#766DFF"
              />
              <path
                d="M101.062767,62.1920137 C107.163561,56.8212213 114.394007,52.3236803 115.340609,54.5834617 C116.287211,56.8432432 103.516983,66.1144454 103.516983,66.1144454 L101.062767,62.1920137 Z"
                id="Fill-92"
                fill="#766DFF"
              />
              <path
                d="M104.530788,59.9467158 L103.982487,59.2902951 C109.767183,54.4564973 112.998511,52.7286284 114.784088,53.5087104 L114.440871,54.2921803 C112.375635,53.3909781 106.472296,58.3247213 104.530788,59.9467158"
                id="Fill-94"
                fill="#070000"
              />
              <path
                d="M102.526737,66.3206885 C108.461431,61.1574098 115.524929,56.8682295 116.496107,59.0975191 C117.467285,61.3268087 105.012309,70.2033115 105.012309,70.2033115 L102.526737,66.3206885 Z"
                id="Fill-96"
                fill="#766DFF"
              />
              <path
                d="M105.909504,64.1809262 L105.364594,63.5211175 C111.000986,58.8753525 114.162823,57.2304891 115.940773,58.0258169 L115.590776,58.8067459 C113.543336,57.8919918 107.797624,62.6249973 105.909504,64.1809262"
                id="Fill-98"
                fill="#070000"
              />
              <path
                d="M104.308162,69.8695956 C109.672523,65.475388 117.034323,61.4614809 117.933468,63.7127923 C118.83346,65.9649508 106.979326,72.6799235 106.979326,72.6799235 L104.308162,69.8695956 Z"
                id="Fill-100"
                fill="#766DFF"
              />
              <path
                d="M108.100163,67.7350847 L107.584066,67.0532541 C112.277246,63.501806 115.394168,61.644347 117.433981,62.6598934 L117.052628,63.4255765 C115.421286,62.6141557 112.295042,64.5613962 108.100163,67.7350847"
                id="Fill-102"
                fill="#070000"
              />
              <path
                d="M77.2989901,78.9991803 L76.8303501,78.2834699 C78.245592,77.3577049 89.2446491,69.5170765 90.7954831,68.2999454 C92.5912302,66.8905464 94.0827427,64.8696175 94.1895214,63.700765 L95.0420564,63.7778415 C94.8946,65.3888251 93.0598702,67.6104918 91.3242921,68.973306 C89.765831,70.1946721 78.7201642,78.0691803 77.2989901,78.9991803"
                id="Fill-104"
                fill="#070000"
              />
              <path
                d="M99.1141397,81.388806 L98.5361786,80.7586421 C99.925997,79.4847623 106.01408,74.2706639 107.952199,72.7858825 L108.238637,72.5673579 C110.348788,70.9538333 115.956366,66.667194 117.259745,64.5547896 L117.987705,65.0045437 C116.601276,67.2507732 111.104714,71.4527131 108.758124,73.2466475 L108.472533,73.4651721 C106.547973,74.9389426 100.496331,80.1225492 99.1141397,81.388806"
                id="Fill-106"
                fill="#070000"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END depot_documents -->

  <!-- BEGIN illustration-offre -->
  <svg
    v-else-if="name === 'illustration-offre'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="231px"
    height="128px"
    viewBox="0 0 231 128"
    version="1.1"
  >
    <title>{{ label }}</title>
    <defs>
      <polygon
        id="offre-1"
        points="0 127 230.7415 127 230.7415 0.0215660377 0 0.0215660377"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-3"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-5"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-7"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-9"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-11"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-13"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-15"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-17"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-19"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-21"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-23"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-25"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-27"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-29"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-31"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-33"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-35"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-37"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-39"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-41"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-43"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-45"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-47"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-49"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-51"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-53"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-55"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-57"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-59"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-61"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-63"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-65"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-67"
      />
      <path
        d="M32.0393909,25.4968986 C30.1799188,27.1330338 23.5304162,27.3173919 23.5304162,27.3173919 L23.5304162,27.3173919 L0.242659898,36.2289527 C0.242659898,36.2289527 6.26911675,50.9665743 13.6579898,50.9061124 L13.6579898,50.9061124 C26.7371168,50.7991014 38.0599797,50.9061124 38.0599797,50.9061124 L38.0599797,50.9061124 C43.1554924,50.9061124 47.8595736,48.1760473 50.3810964,43.7555878 L50.3810964,43.7555878 L67.854335,13.1225068 L54.0002843,0.087527027 C54.0002843,0.087527027 42.8810761,15.9595541 32.0393909,25.4968986"
        id="offre-69"
      />
      <path
        d="M4.14066667,0.304666667 C1.50533333,0.841 -0.196,3.41266667 0.340666667,6.048 L0.340666667,6.048 C0.877333333,8.68333333 3.449,10.3846667 6.08433333,9.848 L6.08433333,9.848 C8.71966667,9.31133333 10.421,6.74 9.88433333,4.10433333 L9.88433333,4.10433333 C9.41433333,1.797 7.38466667,0.205666667 5.118,0.205666667 L5.118,0.205666667 C4.796,0.205666667 4.46866667,0.237666667 4.14066667,0.304666667 L4.14066667,0.304666667 Z"
        id="offre-71"
      />
      <polygon
        id="offre-73"
        points="0 127 230.7415 127 230.7415 0.0215660377 0 0.0215660377"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-75"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-77"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-79"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-81"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-83"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-85"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-87"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-89"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-91"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-93"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-95"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-97"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-99"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-101"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-103"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-105"
      />
      <path
        d="M0.299552941,16.3728222 L22.0826471,30.8425889 C22.0826471,30.8425889 28.7724353,17.1767556 28.7717529,10.8300222 L28.7717529,10.8300222 C28.7710706,4.48328889 26.8082824,2.81721111 24.4285765,1.19177778 L24.4285765,1.19177778 C23.4872706,0.5487 22.0362471,0.0602777778 20.2072,0.0606220402 L20.2072,0.0606220402 C15.3833059,0.0609666667 7.93405882,3.45856667 0.299552941,16.3728222 L0.299552941,16.3728222 Z"
        id="offre-107"
      />
      <path
        d="M0.2509375,4.805625 C-0.1656875,7.69759375 1.841125,10.3802188 4.7334375,10.7965 L4.7334375,10.7965 C7.62540625,11.2134688 10.3076875,9.2063125 10.7243125,6.31434375 L10.7243125,6.31434375 C11.1412813,3.422375 9.134125,0.73975 6.24215625,0.32346875 L6.24215625,0.32346875 C5.98640625,0.28634375 5.732375,0.26846875 5.48109375,0.26846875 L5.48109375,0.26846875 C2.89334375,0.2688125 0.63078125,2.16940625 0.2509375,4.805625 L0.2509375,4.805625 Z"
        id="offre-109"
      />
      <polygon
        id="offre-111"
        points="0.0248475833 0.0218235294 10.9928806 0.0218235294 10.9928806 13.5187065 0.0248475833 13.5187065"
      />
    </defs>
    <g
      id="Ecrans"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Parametre-du-compte-/--Mon-abonnement"
        transform="translate(-744.000000, -1478.000000)"
      >
        <g id="Formulaire" transform="translate(312.000000, 428.000000)">
          <g id="Offre" transform="translate(325.000000, 234.000000)">
            <g
              id="Illustration-offre"
              transform="translate(107.000000, 816.000000)"
            >
              <g id="Group-40">
                <path
                  d="M202.432209,28.1069827 L210.740991,18.2869046 L193.640459,3.93830081 L190.916241,7.15814447 C190.916241,7.15814447 195.778584,12.1820043 195.790616,16.40929 C195.802647,20.6174059 194.118616,22.9205218 194.118616,22.9205218 L202.432209,28.1069827 Z"
                  id="Fill-1"
                  fill="#E7E6FF"
                />
                <polygon
                  id="Fill-3"
                  fill="#070000"
                  points="208.153103 21.3455164 202.581603 16.670821 200.828478 12.7225245 192.278384 5.54822264 193.640666 3.93830081 210.740853 18.2869046"
                />
                <path
                  d="M196.301463,24.267783 L195.769681,23.9651739 C197.512838,20.9271011 199.044244,15.1378181 196.117556,11.6396698 L196.58815,11.2494272 C198.062494,13.010996 199.899494,17.9992547 196.301463,24.267783"
                  id="Fill-5"
                  fill="#070000"
                />
                <path
                  d="M194.118616,22.9203849 C194.118616,22.9203849 168.476928,37.3771612 160.598178,48.8461854 C152.719084,60.3152097 150.025459,73.0384873 150.025459,73.0384873 L158.042741,94.6681962 L176.356022,55.2256248 L202.432209,28.1068458 L194.118616,22.9203849 Z"
                  id="Fill-7"
                  fill="#4C3BE3"
                />
                <path
                  d="M155.065212,52.0777706 L175.397681,60.7391022 C175.397681,60.7391022 165.495619,97.0008542 154.955212,97.9552369 C144.414463,98.9092774 134.5124,99.8636601 134.5124,99.8636601 L137.655306,79.1352747 C137.655306,79.1352747 141.270181,74.1251075 142.497713,72.8263528 C146.639213,68.445024 155.065212,52.0777706 155.065212,52.0777706"
                  id="Fill-9"
                  fill="#00AEFF"
                />
                <path
                  d="M112.969759,52.2611504 C122.748416,46.4461935 129.934166,26.8091181 134.512572,24.9448539 C139.090634,23.0805898 141.400634,24.3434011 141.400634,24.3434011 L128.458791,49.9238027 L119.180634,61.2127677 L112.969759,52.2611504 Z"
                  id="Fill-11"
                  fill="#4C3BE3"
                />
                <path
                  d="M132.026056,28.6669124 C131.868619,25.9862197 130.223775,20.8213248 131.5314,20.5536321 C132.839025,20.2859394 135.38965,26.6544245 135.38965,26.6544245 L132.026056,28.6669124 Z"
                  id="Fill-13"
                  fill="#4C3BE3"
                />
                <path
                  d="M133.209794,26.1901385 C134.898294,22.2325995 137.354388,18.4349229 138.369138,19.2989337 C139.383544,20.1632868 135.368888,27.5053245 135.368888,27.5053245 L133.209794,26.1901385 Z"
                  id="Fill-15"
                  fill="#4C3BE3"
                />
                <path
                  d="M133.488334,26.3168305 L132.931116,26.0635151 C133.260428,25.3453318 136.198116,19.0449679 137.874928,18.9915663 L137.894522,19.6012348 C137.152709,19.6248547 135.176147,22.637596 133.488334,26.3168305"
                  id="Fill-17"
                  fill="#070000"
                />
                <path
                  d="M135.181406,27.4560992 C136.87025,23.4985601 139.326,19.7008836 140.34075,20.5648943 C141.355156,21.4292474 137.340844,28.7712852 137.340844,28.7712852 L135.181406,27.4560992 Z"
                  id="Fill-19"
                  fill="#4C3BE3"
                />
                <path
                  d="M136.313547,25.8088647 L135.756328,25.5555493 C137.470953,21.8174361 138.721172,20.1349429 139.809828,20.1003687 L139.829422,20.7096949 C139.284578,20.7274954 138.232359,21.6260803 136.313547,25.8088647"
                  id="Fill-21"
                  fill="#070000"
                />
                <path
                  d="M137.128441,28.8777119 C138.816941,24.9201728 141.273034,21.1224962 142.287784,21.986507 C143.302191,22.8508601 139.287878,30.1928978 139.287878,30.1928978 L137.128441,28.8777119 Z"
                  id="Fill-23"
                  fill="#4C3BE3"
                />
                <path
                  d="M138.348856,27.0465841 L137.791638,26.7932687 C139.470513,23.133204 140.655419,21.5561447 141.7537,21.5212283 L141.773294,22.1308968 C140.985763,22.1562283 139.833513,23.8099668 138.348856,27.0465841"
                  id="Fill-25"
                  fill="#070000"
                />
                <path
                  d="M138.912813,29.9645032 C140.504719,26.5214682 143.173938,22.7881474 144.158438,23.6802283 C145.143281,24.5726515 141.341063,30.8706191 141.341063,30.8706191 L138.912813,29.9645032 Z"
                  id="Fill-27"
                  fill="#4C3BE3"
                />
                <path
                  d="M140.335319,28.0407784 L139.7891,27.7641854 C141.260006,24.8818674 142.364131,23.2106706 143.645631,23.2106706 L143.659725,23.2106706 L143.653881,23.8206814 L143.646662,23.8206814 C142.629162,23.8206814 141.453881,25.8482313 140.335319,28.0407784"
                  id="Fill-29"
                  fill="#070000"
                />
                <mask id="mask-2" fill="white">
                  <use xlink:href="#offre-1" />
                </mask>
                <g id="Clip-32" />
                <polygon
                  id="Fill-31"
                  fill="#B7B3FF"
                  mask="url(#mask-2)"
                  points="125.409281 78.9231402 145.068 78.9231402 145.068 68.4793585 125.409281 68.4793585"
                />
                <path
                  d="M210.740956,60.7644337 L222.793862,65.3282181 L230.741362,44.5139108 L226.789612,43.0176385 C226.789612,43.0176385 223.635019,49.2478272 219.632737,50.6561237 C215.648331,52.0582585 212.908987,51.2366951 212.908987,51.2366951 L210.740956,60.7644337 Z"
                  id="Fill-33"
                  fill="#E7E6FF"
                  mask="url(#mask-2)"
                />
                <polygon
                  id="Fill-34"
                  fill="#070000"
                  mask="url(#mask-2)"
                  points="219.039803 63.9068108 221.628928 57.12549 224.791772 54.1729968 228.765522 43.7658431 230.741397 44.5138081 222.793897 65.3281154"
                />
                <path
                  d="M215.461813,54.0275458 C214.498281,54.0275458 213.462563,53.9371739 212.353625,53.7334946 L212.464656,53.1334111 C215.920031,53.7684111 221.912969,53.2943005 224.261125,49.3870822 L224.786719,49.7003032 C223.788125,51.3619151 220.694031,54.0275458 215.461813,54.0275458"
                  id="Fill-35"
                  fill="#070000"
                  mask="url(#mask-2)"
                />
                <path
                  d="M212.909056,51.236524 C169.066838,37.9429445 166.241213,45.5468555 147.2889,76.8552652 L157.190963,96.0466426 L179.292713,58.4067181 L210.741025,60.7642625 L212.909056,51.236524 Z"
                  id="Fill-36"
                  fill="#4C3BE3"
                  mask="url(#mask-2)"
                />
                <polygon
                  id="Fill-37"
                  fill="#766DFF"
                  mask="url(#mask-2)"
                  points="127.849906 70.514097 149.435688 70.514097 149.435688 60.7241429 127.849906 60.7241429"
                />
                <polygon
                  id="Fill-38"
                  fill="#B7B3FF"
                  mask="url(#mask-2)"
                  points="124.682938 60.7241429 152.506406 60.7241429 152.506406 46.6637709 124.682938 46.6637709"
                />
                <path
                  d="M135.15205,76.4306539 C135.15205,76.4306539 141.773706,76.2475137 143.625831,74.6221876 C154.422331,65.1478507 165.49555,49.3806809 165.49555,49.3806809 L179.292644,62.3295461 L161.891675,92.7602523 C159.380581,97.1515084 154.695956,99.8638756 149.621175,99.8638756 C149.621175,99.8638756 138.345488,99.7575757 125.320456,99.8638756 C117.9618,99.9232577 111.960269,85.2829989 111.960269,85.2829989 L135.15205,76.4306539 Z"
                  id="Fill-39"
                  fill="#00AEFF"
                  mask="url(#mask-2)"
                />
              </g>
              <g id="Group-143" transform="translate(111.000000, 49.000000)">
                <g id="Group-43">
                  <mask id="mask-4" fill="white">
                    <use xlink:href="#offre-3" />
                  </mask>
                  <g id="Clip-42" />
                  <path
                    d="M8.26662538,50.0886507 C8.26662538,49.2388804 7.57661523,48.5500358 6.72575228,48.5500358 C5.87454416,48.5500358 5.18453401,49.2388804 5.18453401,50.0886507 C5.18453401,50.9380764 5.87454416,51.6269209 6.72575228,51.6269209 C7.57661523,51.6269209 8.26662538,50.9380764 8.26662538,50.0886507"
                    id="Fill-41"
                    fill="#7BEAFF"
                    mask="url(#mask-4)"
                  />
                </g>
                <g id="Group-46">
                  <mask id="mask-6" fill="white">
                    <use xlink:href="#offre-5" />
                  </mask>
                  <g id="Clip-45" />
                  <path
                    d="M17.6851777,50.0886507 C17.6851777,49.2388804 16.9951675,48.5500358 16.1443046,48.5500358 C15.2930964,48.5500358 14.6030863,49.2388804 14.6030863,50.0886507 C14.6030863,50.9380764 15.2930964,51.6269209 16.1443046,51.6269209 C16.9951675,51.6269209 17.6851777,50.9380764 17.6851777,50.0886507"
                    id="Fill-44"
                    fill="#7BEAFF"
                    mask="url(#mask-6)"
                  />
                </g>
                <g id="Group-49">
                  <mask id="mask-8" fill="white">
                    <use xlink:href="#offre-7" />
                  </mask>
                  <g id="Clip-48" />
                  <path
                    d="M27.1037299,50.0886507 C27.1037299,49.2388804 26.4137198,48.5500358 25.5628569,48.5500358 C24.7116487,48.5500358 24.0216386,49.2388804 24.0216386,50.0886507 C24.0216386,50.9380764 24.7116487,51.6269209 25.5628569,51.6269209 C26.4137198,51.6269209 27.1037299,50.9380764 27.1037299,50.0886507"
                    id="Fill-47"
                    fill="#7BEAFF"
                    mask="url(#mask-8)"
                  />
                </g>
                <g id="Group-52">
                  <mask id="mask-10" fill="white">
                    <use xlink:href="#offre-9" />
                  </mask>
                  <g id="Clip-51" />
                  <path
                    d="M36.5223168,50.0886507 C36.5223168,49.2388804 35.8323066,48.5500358 34.9814437,48.5500358 C34.1302355,48.5500358 33.4402254,49.2388804 33.4402254,50.0886507 C33.4402254,50.9380764 34.1302355,51.6269209 34.9814437,51.6269209 C35.8323066,51.6269209 36.5223168,50.9380764 36.5223168,50.0886507"
                    id="Fill-50"
                    fill="#7BEAFF"
                    mask="url(#mask-10)"
                  />
                </g>
                <g id="Group-55">
                  <mask id="mask-12" fill="white">
                    <use xlink:href="#offre-11" />
                  </mask>
                  <g id="Clip-54" />
                  <path
                    d="M45.940869,50.0886507 C45.940869,49.2388804 45.2508589,48.5500358 44.3999959,48.5500358 C43.5487878,48.5500358 42.8587777,49.2388804 42.8587777,50.0886507 C42.8587777,50.9380764 43.5487878,51.6269209 44.3999959,51.6269209 C45.2508589,51.6269209 45.940869,50.9380764 45.940869,50.0886507"
                    id="Fill-53"
                    fill="#7BEAFF"
                    mask="url(#mask-12)"
                  />
                </g>
                <g id="Group-58">
                  <mask id="mask-14" fill="white">
                    <use xlink:href="#offre-13" />
                  </mask>
                  <g id="Clip-57" />
                  <path
                    d="M55.3594213,50.0886507 C55.3594213,49.2388804 54.6694112,48.5500358 53.8185482,48.5500358 C52.9673401,48.5500358 52.2773299,49.2388804 52.2773299,50.0886507 C52.2773299,50.9380764 52.9673401,51.6269209 53.8185482,51.6269209 C54.6694112,51.6269209 55.3594213,50.9380764 55.3594213,50.0886507"
                    id="Fill-56"
                    fill="#7BEAFF"
                    mask="url(#mask-14)"
                  />
                </g>
                <g id="Group-61">
                  <mask id="mask-16" fill="white">
                    <use xlink:href="#offre-15" />
                  </mask>
                  <g id="Clip-60" />
                  <path
                    d="M64.7780081,50.0886507 C64.7780081,49.2388804 64.087998,48.5500358 63.237135,48.5500358 C62.3859269,48.5500358 61.6959168,49.2388804 61.6959168,50.0886507 C61.6959168,50.9380764 62.3859269,51.6269209 63.237135,51.6269209 C64.087998,51.6269209 64.7780081,50.9380764 64.7780081,50.0886507"
                    id="Fill-59"
                    fill="#7BEAFF"
                    mask="url(#mask-16)"
                  />
                </g>
                <g id="Group-64">
                  <mask id="mask-18" fill="white">
                    <use xlink:href="#offre-17" />
                  </mask>
                  <g id="Clip-63" />
                  <path
                    d="M8.26662538,41.0196791 C8.26662538,40.1699088 7.57661523,39.4810642 6.72575228,39.4810642 C5.87454416,39.4810642 5.18453401,40.1699088 5.18453401,41.0196791 C5.18453401,41.8691047 5.87454416,42.5579493 6.72575228,42.5579493 C7.57661523,42.5579493 8.26662538,41.8691047 8.26662538,41.0196791"
                    id="Fill-62"
                    fill="#7BEAFF"
                    mask="url(#mask-18)"
                  />
                </g>
                <g id="Group-67">
                  <mask id="mask-20" fill="white">
                    <use xlink:href="#offre-19" />
                  </mask>
                  <g id="Clip-66" />
                  <path
                    d="M17.6851777,41.0196791 C17.6851777,40.1699088 16.9951675,39.4810642 16.1443046,39.4810642 C15.2930964,39.4810642 14.6030863,40.1699088 14.6030863,41.0196791 C14.6030863,41.8691047 15.2930964,42.5579493 16.1443046,42.5579493 C16.9951675,42.5579493 17.6851777,41.8691047 17.6851777,41.0196791"
                    id="Fill-65"
                    fill="#7BEAFF"
                    mask="url(#mask-20)"
                  />
                </g>
                <g id="Group-70">
                  <mask id="mask-22" fill="white">
                    <use xlink:href="#offre-21" />
                  </mask>
                  <g id="Clip-69" />
                  <path
                    d="M27.1037299,41.0196791 C27.1037299,40.1699088 26.4137198,39.4810642 25.5628569,39.4810642 C24.7116487,39.4810642 24.0216386,40.1699088 24.0216386,41.0196791 C24.0216386,41.8691047 24.7116487,42.5579493 25.5628569,42.5579493 C26.4137198,42.5579493 27.1037299,41.8691047 27.1037299,41.0196791"
                    id="Fill-68"
                    fill="#7BEAFF"
                    mask="url(#mask-22)"
                  />
                </g>
                <g id="Group-73">
                  <mask id="mask-24" fill="white">
                    <use xlink:href="#offre-23" />
                  </mask>
                  <g id="Clip-72" />
                  <path
                    d="M36.5223168,41.0196791 C36.5223168,40.1699088 35.8323066,39.4810642 34.9814437,39.4810642 C34.1302355,39.4810642 33.4402254,40.1699088 33.4402254,41.0196791 C33.4402254,41.8691047 34.1302355,42.5579493 34.9814437,42.5579493 C35.8323066,42.5579493 36.5223168,41.8691047 36.5223168,41.0196791"
                    id="Fill-71"
                    fill="#7BEAFF"
                    mask="url(#mask-24)"
                  />
                </g>
                <g id="Group-76">
                  <mask id="mask-26" fill="white">
                    <use xlink:href="#offre-25" />
                  </mask>
                  <g id="Clip-75" />
                  <path
                    d="M45.940869,41.0196791 C45.940869,40.1699088 45.2508589,39.4810642 44.3999959,39.4810642 C43.5487878,39.4810642 42.8587777,40.1699088 42.8587777,41.0196791 C42.8587777,41.8691047 43.5487878,42.5579493 44.3999959,42.5579493 C45.2508589,42.5579493 45.940869,41.8691047 45.940869,41.0196791"
                    id="Fill-74"
                    fill="#7BEAFF"
                    mask="url(#mask-26)"
                  />
                </g>
                <g id="Group-79">
                  <mask id="mask-28" fill="white">
                    <use xlink:href="#offre-27" />
                  </mask>
                  <g id="Clip-78" />
                  <path
                    d="M55.3594213,41.0196791 C55.3594213,40.1699088 54.6694112,39.4810642 53.8185482,39.4810642 C52.9673401,39.4810642 52.2773299,40.1699088 52.2773299,41.0196791 C52.2773299,41.8691047 52.9673401,42.5579493 53.8185482,42.5579493 C54.6694112,42.5579493 55.3594213,41.8691047 55.3594213,41.0196791"
                    id="Fill-77"
                    fill="#7BEAFF"
                    mask="url(#mask-28)"
                  />
                </g>
                <g id="Group-82">
                  <mask id="mask-30" fill="white">
                    <use xlink:href="#offre-29" />
                  </mask>
                  <g id="Clip-81" />
                  <path
                    d="M64.7780081,41.0196791 C64.7780081,40.1699088 64.087998,39.4810642 63.237135,39.4810642 C62.3859269,39.4810642 61.6959168,40.1699088 61.6959168,41.0196791 C61.6959168,41.8691047 62.3859269,42.5579493 63.237135,42.5579493 C64.087998,42.5579493 64.7780081,41.8691047 64.7780081,41.0196791"
                    id="Fill-80"
                    fill="#7BEAFF"
                    mask="url(#mask-30)"
                  />
                </g>
                <g id="Group-85">
                  <mask id="mask-32" fill="white">
                    <use xlink:href="#offre-31" />
                  </mask>
                  <g id="Clip-84" />
                  <path
                    d="M8.26662538,31.950673 C8.26662538,31.1009027 7.57661523,30.4124027 6.72575228,30.4124027 C5.87454416,30.4124027 5.18453401,31.1009027 5.18453401,31.950673 C5.18453401,32.8000986 5.87454416,33.4889432 6.72575228,33.4889432 C7.57661523,33.4889432 8.26662538,32.8000986 8.26662538,31.950673"
                    id="Fill-83"
                    fill="#7BEAFF"
                    mask="url(#mask-32)"
                  />
                </g>
                <g id="Group-88">
                  <mask id="mask-34" fill="white">
                    <use xlink:href="#offre-33" />
                  </mask>
                  <g id="Clip-87" />
                  <path
                    d="M17.6851777,31.950673 C17.6851777,31.1009027 16.9951675,30.4124027 16.1443046,30.4124027 C15.2930964,30.4124027 14.6030863,31.1009027 14.6030863,31.950673 C14.6030863,32.8000986 15.2930964,33.4889432 16.1443046,33.4889432 C16.9951675,33.4889432 17.6851777,32.8000986 17.6851777,31.950673"
                    id="Fill-86"
                    fill="#7BEAFF"
                    mask="url(#mask-34)"
                  />
                </g>
                <g id="Group-91">
                  <mask id="mask-36" fill="white">
                    <use xlink:href="#offre-35" />
                  </mask>
                  <g id="Clip-90" />
                  <path
                    d="M27.1037299,31.950673 C27.1037299,31.1009027 26.4137198,30.4124027 25.5628569,30.4124027 C24.7116487,30.4124027 24.0216386,31.1009027 24.0216386,31.950673 C24.0216386,32.8000986 24.7116487,33.4889432 25.5628569,33.4889432 C26.4137198,33.4889432 27.1037299,32.8000986 27.1037299,31.950673"
                    id="Fill-89"
                    fill="#7BEAFF"
                    mask="url(#mask-36)"
                  />
                </g>
                <g id="Group-94">
                  <mask id="mask-38" fill="white">
                    <use xlink:href="#offre-37" />
                  </mask>
                  <g id="Clip-93" />
                  <path
                    d="M36.5223168,31.950673 C36.5223168,31.1009027 35.8323066,30.4124027 34.9814437,30.4124027 C34.1302355,30.4124027 33.4402254,31.1009027 33.4402254,31.950673 C33.4402254,32.8000986 34.1302355,33.4889432 34.9814437,33.4889432 C35.8323066,33.4889432 36.5223168,32.8000986 36.5223168,31.950673"
                    id="Fill-92"
                    fill="#7BEAFF"
                    mask="url(#mask-38)"
                  />
                </g>
                <g id="Group-97">
                  <mask id="mask-40" fill="white">
                    <use xlink:href="#offre-39" />
                  </mask>
                  <g id="Clip-96" />
                  <path
                    d="M45.940869,31.950673 C45.940869,31.1009027 45.2508589,30.4124027 44.3999959,30.4124027 C43.5487878,30.4124027 42.8587777,31.1009027 42.8587777,31.950673 C42.8587777,32.8000986 43.5487878,33.4889432 44.3999959,33.4889432 C45.2508589,33.4889432 45.940869,32.8000986 45.940869,31.950673"
                    id="Fill-95"
                    fill="#7BEAFF"
                    mask="url(#mask-40)"
                  />
                </g>
                <g id="Group-100">
                  <mask id="mask-42" fill="white">
                    <use xlink:href="#offre-41" />
                  </mask>
                  <g id="Clip-99" />
                  <path
                    d="M55.3594213,31.950673 C55.3594213,31.1009027 54.6694112,30.4124027 53.8185482,30.4124027 C52.9673401,30.4124027 52.2773299,31.1009027 52.2773299,31.950673 C52.2773299,32.8000986 52.9673401,33.4889432 53.8185482,33.4889432 C54.6694112,33.4889432 55.3594213,32.8000986 55.3594213,31.950673"
                    id="Fill-98"
                    fill="#7BEAFF"
                    mask="url(#mask-42)"
                  />
                </g>
                <g id="Group-103">
                  <mask id="mask-44" fill="white">
                    <use xlink:href="#offre-43" />
                  </mask>
                  <g id="Clip-102" />
                  <path
                    d="M64.7780081,31.950673 C64.7780081,31.1009027 64.087998,30.4124027 63.237135,30.4124027 C62.3859269,30.4124027 61.6959168,31.1009027 61.6959168,31.950673 C61.6959168,32.8000986 62.3859269,33.4889432 63.237135,33.4889432 C64.087998,33.4889432 64.7780081,32.8000986 64.7780081,31.950673"
                    id="Fill-101"
                    fill="#7BEAFF"
                    mask="url(#mask-44)"
                  />
                </g>
                <g id="Group-106">
                  <mask id="mask-46" fill="white">
                    <use xlink:href="#offre-45" />
                  </mask>
                  <g id="Clip-105" />
                  <path
                    d="M36.5223168,22.8816669 C36.5223168,22.0318966 35.8323066,21.343052 34.9814437,21.343052 C34.1302355,21.343052 33.4402254,22.0318966 33.4402254,22.8816669 C33.4402254,23.7310926 34.1302355,24.4199372 34.9814437,24.4199372 C35.8323066,24.4199372 36.5223168,23.7310926 36.5223168,22.8816669"
                    id="Fill-104"
                    fill="#7BEAFF"
                    mask="url(#mask-46)"
                  />
                </g>
                <g id="Group-109">
                  <mask id="mask-48" fill="white">
                    <use xlink:href="#offre-47" />
                  </mask>
                  <g id="Clip-108" />
                  <path
                    d="M45.940869,22.8816669 C45.940869,22.0318966 45.2508589,21.343052 44.3999959,21.343052 C43.5487878,21.343052 42.8587777,22.0318966 42.8587777,22.8816669 C42.8587777,23.7310926 43.5487878,24.4199372 44.3999959,24.4199372 C45.2508589,24.4199372 45.940869,23.7310926 45.940869,22.8816669"
                    id="Fill-107"
                    fill="#7BEAFF"
                    mask="url(#mask-48)"
                  />
                </g>
                <g id="Group-112">
                  <mask id="mask-50" fill="white">
                    <use xlink:href="#offre-49" />
                  </mask>
                  <g id="Clip-111" />
                  <path
                    d="M55.3594213,22.8816669 C55.3594213,22.0318966 54.6694112,21.343052 53.8185482,21.343052 C52.9673401,21.343052 52.2773299,22.0318966 52.2773299,22.8816669 C52.2773299,23.7310926 52.9673401,24.4199372 53.8185482,24.4199372 C54.6694112,24.4199372 55.3594213,23.7310926 55.3594213,22.8816669"
                    id="Fill-110"
                    fill="#7BEAFF"
                    mask="url(#mask-50)"
                  />
                </g>
                <g id="Group-115">
                  <mask id="mask-52" fill="white">
                    <use xlink:href="#offre-51" />
                  </mask>
                  <g id="Clip-114" />
                  <path
                    d="M64.7780081,22.8816669 C64.7780081,22.0318966 64.087998,21.343052 63.237135,21.343052 C62.3859269,21.343052 61.6959168,22.0318966 61.6959168,22.8816669 C61.6959168,23.7310926 62.3859269,24.4199372 63.237135,24.4199372 C64.087998,24.4199372 64.7780081,23.7310926 64.7780081,22.8816669"
                    id="Fill-113"
                    fill="#7BEAFF"
                    mask="url(#mask-52)"
                  />
                </g>
                <g id="Group-118">
                  <mask id="mask-54" fill="white">
                    <use xlink:href="#offre-53" />
                  </mask>
                  <g id="Clip-117" />
                  <path
                    d="M36.5223168,13.8126953 C36.5223168,12.962925 35.8323066,12.274425 34.9814437,12.274425 C34.1302355,12.274425 33.4402254,12.962925 33.4402254,13.8126953 C33.4402254,14.6621209 34.1302355,15.3509655 34.9814437,15.3509655 C35.8323066,15.3509655 36.5223168,14.6621209 36.5223168,13.8126953"
                    id="Fill-116"
                    fill="#7BEAFF"
                    mask="url(#mask-54)"
                  />
                </g>
                <g id="Group-121">
                  <mask id="mask-56" fill="white">
                    <use xlink:href="#offre-55" />
                  </mask>
                  <g id="Clip-120" />
                  <path
                    d="M45.940869,13.8126953 C45.940869,12.962925 45.2508589,12.274425 44.3999959,12.274425 C43.5487878,12.274425 42.8587777,12.962925 42.8587777,13.8126953 C42.8587777,14.6621209 43.5487878,15.3509655 44.3999959,15.3509655 C45.2508589,15.3509655 45.940869,14.6621209 45.940869,13.8126953"
                    id="Fill-119"
                    fill="#7BEAFF"
                    mask="url(#mask-56)"
                  />
                </g>
                <g id="Group-124">
                  <mask id="mask-58" fill="white">
                    <use xlink:href="#offre-57" />
                  </mask>
                  <g id="Clip-123" />
                  <path
                    d="M55.3594213,13.8126953 C55.3594213,12.962925 54.6694112,12.274425 53.8185482,12.274425 C52.9673401,12.274425 52.2773299,12.962925 52.2773299,13.8126953 C52.2773299,14.6621209 52.9673401,15.3509655 53.8185482,15.3509655 C54.6694112,15.3509655 55.3594213,14.6621209 55.3594213,13.8126953"
                    id="Fill-122"
                    fill="#7BEAFF"
                    mask="url(#mask-58)"
                  />
                </g>
                <g id="Group-127">
                  <mask id="mask-60" fill="white">
                    <use xlink:href="#offre-59" />
                  </mask>
                  <g id="Clip-126" />
                  <path
                    d="M64.7780081,13.8126953 C64.7780081,12.962925 64.087998,12.274425 63.237135,12.274425 C62.3859269,12.274425 61.6959168,12.962925 61.6959168,13.8126953 C61.6959168,14.6621209 62.3859269,15.3509655 63.237135,15.3509655 C64.087998,15.3509655 64.7780081,14.6621209 64.7780081,13.8126953"
                    id="Fill-125"
                    fill="#7BEAFF"
                    mask="url(#mask-60)"
                  />
                </g>
                <g id="Group-130">
                  <mask id="mask-62" fill="white">
                    <use xlink:href="#offre-61" />
                  </mask>
                  <g id="Clip-129" />
                  <path
                    d="M36.5223168,4.74368919 C36.5223168,3.89391892 35.8323066,3.20541892 34.9814437,3.20541892 C34.1302355,3.20541892 33.4402254,3.89391892 33.4402254,4.74368919 C33.4402254,5.59311486 34.1302355,6.28195946 34.9814437,6.28195946 C35.8323066,6.28195946 36.5223168,5.59311486 36.5223168,4.74368919"
                    id="Fill-128"
                    fill="#7BEAFF"
                    mask="url(#mask-62)"
                  />
                </g>
                <g id="Group-133">
                  <mask id="mask-64" fill="white">
                    <use xlink:href="#offre-63" />
                  </mask>
                  <g id="Clip-132" />
                  <path
                    d="M45.940869,4.74368919 C45.940869,3.89391892 45.2508589,3.20541892 44.3999959,3.20541892 C43.5487878,3.20541892 42.8587777,3.89391892 42.8587777,4.74368919 C42.8587777,5.59311486 43.5487878,6.28195946 44.3999959,6.28195946 C45.2508589,6.28195946 45.940869,5.59311486 45.940869,4.74368919"
                    id="Fill-131"
                    fill="#7BEAFF"
                    mask="url(#mask-64)"
                  />
                </g>
                <g id="Group-136">
                  <mask id="mask-66" fill="white">
                    <use xlink:href="#offre-65" />
                  </mask>
                  <g id="Clip-135" />
                  <path
                    d="M55.3594213,4.74368919 C55.3594213,3.89391892 54.6694112,3.20541892 53.8185482,3.20541892 C52.9673401,3.20541892 52.2773299,3.89391892 52.2773299,4.74368919 C52.2773299,5.59311486 52.9673401,6.28195946 53.8185482,6.28195946 C54.6694112,6.28195946 55.3594213,5.59311486 55.3594213,4.74368919"
                    id="Fill-134"
                    fill="#7BEAFF"
                    mask="url(#mask-66)"
                  />
                </g>
                <g id="Group-139">
                  <mask id="mask-68" fill="white">
                    <use xlink:href="#offre-67" />
                  </mask>
                  <g id="Clip-138" />
                  <path
                    d="M64.7780081,4.74368919 C64.7780081,3.89391892 64.087998,3.20541892 63.237135,3.20541892 C62.3859269,3.20541892 61.6959168,3.89391892 61.6959168,4.74368919 C61.6959168,5.59311486 62.3859269,6.28195946 63.237135,6.28195946 C64.087998,6.28195946 64.7780081,5.59311486 64.7780081,4.74368919"
                    id="Fill-137"
                    fill="#7BEAFF"
                    mask="url(#mask-68)"
                  />
                </g>
                <g id="Group-142">
                  <mask id="mask-70" fill="white">
                    <use xlink:href="#offre-69" />
                  </mask>
                  <g id="Clip-141" />
                  <path
                    d="M72.5519269,0.251691892 C72.5519269,-1.04329459 71.5005157,-2.09292973 70.2033381,-2.09292973 C68.9058152,-2.09292973 67.8544041,-1.04329459 67.8544041,0.251691892 C67.8544041,1.54667838 68.9058152,2.59665811 70.2033381,2.59665811 C71.5005157,2.59665811 72.5519269,1.54667838 72.5519269,0.251691892"
                    id="Fill-140"
                    fill="#7BEAFF"
                    mask="url(#mask-70)"
                  />
                </g>
              </g>
              <g id="Group-152" transform="translate(105.000000, 39.000000)">
                <path
                  d="M62.7087887,8.88000764 L62.3564648,8.38128153 C69.4508939,3.25575287 82.28623,5.30706497 83.7264729,5.55780382 L83.6237684,6.16212229 C82.1138089,5.89900127 78.1042543,5.32151083 73.4995579,5.63347261 C68.8890802,5.94543439 65.2587158,7.03781656 62.7087887,8.88000764"
                  id="Fill-144"
                  fill="#070000"
                />
                <path
                  d="M3.7556502,14.5254153 C-1.68088421,17.8300777 0.225609717,30.2218739 1.83249231,36.9261287 C3.43971498,43.6303834 7.65297814,53.8360395 7.65297814,53.8360395 L29.9847352,36.896549 C29.9847352,36.896549 22.9501603,22.5617847 17.1534802,16.9402815 C10.2865652,10.2810841 5.50604696,13.4615809 3.7556502,14.5254153"
                  id="Fill-146"
                  fill="#E7E6FF"
                />
                <path
                  d="M11.1450996,7.37657197 C11.1450996,7.37657197 12.4595126,7.3318586 12.545553,6.88610064 C12.608468,6.55969299 12.4731158,6.46682675 11.3760146,5.18561656 L11.1450996,7.37657197 Z"
                  id="Fill-148"
                  fill="#4C3BE3"
                />
                <path
                  d="M11.7848259,4.23518217 C12.3323563,6.95444331 10.596583,9.60801019 7.90790283,10.1614242 C5.21922267,10.7155261 2.59549798,8.96001019 2.04796761,6.24074904 C1.50043725,3.52114395 3.23621053,0.867921019 5.92489069,0.314163057 C8.61357085,-0.239594904 11.2372955,1.51592102 11.7848259,4.23518217"
                  id="Fill-150"
                  fill="#4C3BE3"
                />
              </g>
              <g id="Group-155" transform="translate(106.000000, 40.000000)">
                <mask id="mask-72" fill="white">
                  <use xlink:href="#offre-71" />
                </mask>
                <g id="Clip-154" />
                <path
                  d="M4.8162,-1.60796667 C9.12186667,3.9197 -0.0401333333,5.68936667 4.10853333,11.0293667 L13.4438667,7.63936667 L10.4778667,-1.69596667 L4.8162,-1.60796667 Z"
                  id="Fill-153"
                  fill="#4C3BE3"
                  mask="url(#mask-72)"
                />
              </g>
              <g id="Group-212">
                <path
                  d="M114.9533,45.8306372 L114.38405,45.6053919 C114.612644,45.0316668 115.376456,43.9763003 116.62255,44.1039849 L116.56205,44.7109148 C115.45655,44.6041116 114.958113,45.8183137 114.9533,45.8306372"
                  id="Fill-156"
                  fill="#FFFFFF"
                />
                <path
                  d="M109.83775,46.7374035 C109.83775,45.3903819 108.741188,44.2987296 107.388875,44.2987296 C106.036563,44.2987296 104.94,45.3903819 104.94,46.7374035 C104.94,48.0844251 106.036563,49.1760774 107.388875,49.1760774 C108.741188,49.1760774 109.83775,48.0844251 109.83775,46.7374035"
                  id="Fill-158"
                  fill="#070000"
                />
                <path
                  d="M108.400394,43.0175358 C108.400394,41.6705143 107.303831,40.578862 105.951519,40.578862 C104.599206,40.578862 103.502644,41.6705143 103.502644,43.0175358 C103.502644,44.3642151 104.599206,45.4562097 105.951519,45.4562097 C107.303831,45.4562097 108.400394,44.3642151 108.400394,43.0175358"
                  id="Fill-160"
                  fill="#070000"
                />
                <path
                  d="M111.354925,43.0175358 C111.354925,41.6705143 110.258706,40.578862 108.90605,40.578862 C107.553738,40.578862 106.457175,41.6705143 106.457175,43.0175358 C106.457175,44.3642151 107.553738,45.4562097 108.90605,45.4562097 C110.258706,45.4562097 111.354925,44.3642151 111.354925,43.0175358"
                  id="Fill-162"
                  fill="#070000"
                />
                <path
                  d="M111.2485,40.1547984 C111.2485,38.8077768 110.152281,37.7161245 108.799625,37.7161245 C107.447313,37.7161245 106.35075,38.8077768 106.35075,40.1547984 C106.35075,41.5014776 107.447313,42.5934722 108.799625,42.5934722 C110.152281,42.5934722 111.2485,41.5014776 111.2485,40.1547984"
                  id="Fill-164"
                  fill="#070000"
                />
                <path
                  d="M114.852169,39.9199682 C114.852169,38.5729466 113.75595,37.4812943 112.403294,37.4812943 C111.050981,37.4812943 109.954419,38.5729466 109.954419,39.9199682 C109.954419,41.2669898 111.050981,42.358642 112.403294,42.358642 C113.75595,42.358642 114.852169,41.2669898 114.852169,39.9199682"
                  id="Fill-166"
                  fill="#070000"
                />
                <path
                  d="M114.133525,42.643793 C114.133525,41.2971137 113.037306,40.2051191 111.68465,40.2051191 C110.332338,40.2051191 109.235775,41.2971137 109.235775,42.643793 C109.235775,43.9908146 110.332338,45.0824668 111.68465,45.0824668 C113.037306,45.0824668 114.133525,43.9908146 114.133525,42.643793"
                  id="Fill-168"
                  fill="#070000"
                />
                <path
                  d="M111.168613,45.2170321 C111.168613,44.5950402 110.662269,44.0904633 110.037331,44.0904633 C109.412738,44.0904633 108.90605,44.5950402 108.90605,45.2170321 C108.90605,45.839024 109.412738,46.3436008 110.037331,46.3436008 C110.662269,46.3436008 111.168613,45.839024 111.168613,45.2170321"
                  id="Fill-170"
                  fill="#4C3BE3"
                />
                <path
                  d="M118.115869,56.8160687 C122.260806,60.9437399 127.166119,66.7641739 127.166119,66.7641739 L132.720088,58.109004 C140.096619,55.7069582 141.400463,57.9823464 141.400463,57.9823464 C141.400463,57.9823464 133.810806,80.066996 127.698244,78.922969 C120.909525,77.6526267 115.656681,72.1495216 113.2714,69.1682736 C105.254119,59.148624 111.168681,49.8978208 118.115869,56.8160687"
                  id="Fill-172"
                  fill="#4C3BE3"
                />
                <polygon
                  id="Fill-174"
                  fill="#070000"
                  points="132.173422 46.7409294 152.506578 48.2984765 152.506578 46.7409294"
                />
                <mask id="mask-74" fill="white">
                  <use xlink:href="#offre-73" />
                </mask>
                <g id="Clip-177" />
                <polygon
                  id="Fill-176"
                  fill="#766DFF"
                  mask="url(#mask-74)"
                  points="132.173594 46.7411348 157.862719 46.7411348 157.862719 27.0222453 132.173594 27.0222453"
                />
                <polygon
                  id="Fill-178"
                  fill="#070000"
                  mask="url(#mask-74)"
                  points="132.173594 37.4530189 157.862719 37.4530189 157.862719 36.8430081 132.173594 36.8430081"
                />
                <path
                  d="M163.633456,114.885946 L118.361581,114.885946 C114.660425,114.885946 111.563237,112.242223 110.997081,108.599959 L102.417769,53.3820024 C101.917956,50.2059755 99.2116125,47.9008057 95.9831125,47.9008057 L86.0456437,47.9008057 L86.0456437,47.2907949 L95.9831125,47.2907949 C99.5154875,47.2907949 102.476206,49.8129943 103.023112,53.2882073 L111.602769,108.506506 C112.122175,111.849585 114.964644,114.275935 118.361581,114.275935 L163.633456,114.275935 L163.633456,114.885946 Z"
                  id="Fill-179"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M128.458653,120.637813 C128.458653,118.911846 127.053747,117.512792 125.320559,117.512792 C123.587372,117.512792 122.182122,118.911846 122.182122,120.637813 C122.182122,122.363781 123.587372,123.762835 125.320559,123.762835 C127.053747,123.762835 128.458653,122.363781 128.458653,120.637813"
                  id="Fill-180"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M125.320422,114.885946 C122.135578,114.885946 119.544734,117.466339 119.544734,120.637916 C119.544734,123.809493 122.135578,126.389887 125.320422,126.389887 C128.505266,126.389887 131.096453,123.809493 131.096453,120.637916 C131.096453,117.466339 128.505266,114.885946 125.320422,114.885946 M125.320422,126.999897 C121.797672,126.999897 118.931828,124.145992 118.931828,120.637916 C118.931828,117.129841 121.797672,114.275935 125.320422,114.275935 C128.843172,114.275935 131.709016,117.129841 131.709016,120.637916 C131.709016,124.145992 128.843172,126.999897 125.320422,126.999897"
                  id="Fill-181"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M156.301888,120.637813 C156.301888,118.911846 154.896981,117.512792 153.163794,117.512792 C151.430606,117.512792 150.0257,118.911846 150.0257,120.637813 C150.0257,122.363781 151.430606,123.762835 153.163794,123.762835 C154.896981,123.762835 156.301888,122.363781 156.301888,120.637813"
                  id="Fill-182"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M153.163828,114.885946 C149.978984,114.885946 147.387797,117.466339 147.387797,120.637916 C147.387797,123.809493 149.978984,126.389887 153.163828,126.389887 C156.348672,126.389887 158.939516,123.809493 158.939516,120.637916 C158.939516,117.466339 156.348672,114.885946 153.163828,114.885946 M153.163828,126.999897 C149.641078,126.999897 146.775234,124.145992 146.775234,120.637916 C146.775234,117.129841 149.641078,114.275935 153.163828,114.275935 C156.686578,114.275935 159.552422,117.129841 159.552422,120.637916 C159.552422,124.145992 156.686578,126.999897 153.163828,126.999897"
                  id="Fill-183"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M158.776647,100.168597 L110.023959,100.168597 L110.023959,99.5585863 L158.776647,99.5585863 C162.725303,99.5585863 166.207147,97.0490526 167.440866,93.3136779 L178.869522,58.7121685 L103.508522,58.7121685 L103.508522,58.1018154 L179.715834,58.1018154 L168.022491,93.5043491 C166.705928,97.4903005 162.990334,100.168597 158.776647,100.168597"
                  id="Fill-184"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <polygon
                  id="Fill-185"
                  fill="#070000"
                  mask="url(#mask-74)"
                  points="105.254187 68.7843639 157.191031 68.7843639 157.191031 68.1743531 105.254187 68.1743531"
                />
                <polygon
                  id="Fill-186"
                  fill="#070000"
                  mask="url(#mask-74)"
                  points="106.695875 79.2281456 172.516094 79.2281456 172.516094 78.6181348 106.695875 78.6181348"
                />
                <polygon
                  id="Fill-187"
                  fill="#070000"
                  mask="url(#mask-74)"
                  points="121.576125 89.6719272 169.066906 89.6719272 169.066906 89.0615741 121.576125 89.0615741"
                />
                <polygon
                  id="Fill-188"
                  fill="#4C3BE3"
                  mask="url(#mask-74)"
                  points="12.2819125 88.5142418 18.84685 96.5905518 11.7508187 102.311029 5.1855375 94.2347189"
                />
                <path
                  d="M65.1322031,50.4317 C52.3460781,84.7545625 49.2286094,86.0269588 16.4190469,102.024166 L8.50248438,87.5033765 L40.5468594,69.3184143 C40.5468594,69.3184143 44.8062656,44.769417 47.6672969,37.4585302 C50.7778906,29.5092202 61.7923281,34.3735598 61.7923281,34.3735598 L65.1322031,50.4317 Z"
                  id="Fill-189"
                  fill="#766DFF"
                  mask="url(#mask-74)"
                />
                <polygon
                  id="Fill-190"
                  fill="#FF3D81"
                  mask="url(#mask-74)"
                  points="8.2234625 89.9341771 -6.875e-05 95.0504628 3.5553375 99.1979884 5.51780625 98.4411232 4.74986875 100.893832 14.0696188 112.358749 16.8134313 110.467784 13.5306188 102.295625 14.6244313 101.093061"
                />
                <polygon
                  id="Fill-191"
                  fill="#070000"
                  mask="url(#mask-74)"
                  points="15.4664469 107.45357 11.9093219 107.294392 13.3224781 103.019182 10.3346031 102.50639 10.4387594 101.904937 14.1268531 102.538225 12.7439469 106.72101 15.4939469 106.844244"
                />
                <polygon
                  id="Fill-192"
                  fill="#070000"
                  mask="url(#mask-74)"
                  points="19.1699063 100.691454 11.4004687 85.8454617 11.9439375 85.563734 19.7130313 100.409384"
                />
                <polygon
                  id="Fill-193"
                  fill="#4C3BE3"
                  mask="url(#mask-74)"
                  points="57.9060625 121.917604 68.34025 121.917604 68.34025 112.825636 57.9060625 112.825636"
                />
                <path
                  d="M65.7999031,43.7264081 C79.9318094,78.5517935 77.3138094,82.6869957 71.0537781,118.123419 L54.7394031,115.114785 L60.7075906,78.8701493 C60.7075906,78.8701493 45.8259656,53.6135806 46.3639344,45.0991035 C46.9022469,36.5849687 49.8279031,32.4614054 49.8279031,32.4614054 L65.7999031,43.7264081 Z"
                  id="Fill-194"
                  fill="#B7B3FF"
                  mask="url(#mask-74)"
                />
                <polygon
                  id="Fill-195"
                  fill="#FF3D81"
                  mask="url(#mask-74)"
                  points="56.4609031 116.860128 55.2801219 126.444692 60.7543406 126.301945 61.3985281 124.306573 62.8295594 126.444692 77.6417469 126.444692 77.8919969 123.131053 69.4484656 120.53012 69.1978719 118.926702"
                />
                <polygon
                  id="Fill-196"
                  fill="#070000"
                  mask="url(#mask-74)"
                  points="72.3297094 124.930003 69.8822094 121.146361 67.6017719 123.136256 67.1978656 122.67755 70.0124906 120.221418 72.4073969 123.923588 74.2340844 121.872075 74.6923031 122.277038"
                />
                <polygon
                  id="Fill-197"
                  fill="#070000"
                  mask="url(#mask-74)"
                  points="71.6345094 114.88177 55.2293844 112.130559 55.3311344 111.528764 71.7362594 114.279974"
                />
                <path
                  d="M66.6887375,117.298056 L66.0803,117.226854 C66.4054875,114.462293 65.7430813,111.236972 65.0418313,107.822692 C63.8304563,101.923525 62.457175,95.2377108 65.9266438,89.1454763 C68.4552688,84.7062957 69.5600813,79.7888968 69.1221438,74.9255841 C68.7148,70.4025356 66.9926125,66.4200073 64.2732063,63.7115868 C61.2461438,60.697134 58.2232063,57.3345437 56.613425,53.1750369 C54.6409875,48.0786057 55.1315188,42.8079345 58.1132063,37.0607566 L58.6573625,37.3411151 C55.760925,42.9239803 55.2793313,48.0313658 57.1850813,52.9556111 C58.112175,55.3511528 59.6648938,58.2598294 64.7063313,63.280266 C67.5271438,66.089328 69.3122375,70.2057027 69.7323,74.8711555 C70.1815813,79.8587296 69.0499563,84.8990208 66.4598,89.4467162 C63.103425,95.3397216 64.4519563,101.906751 65.6420188,107.700484 C66.3535813,111.164058 67.0256125,114.435935 66.6887375,117.298056"
                  id="Fill-198"
                  fill="#FFFFFF"
                  mask="url(#mask-74)"
                />
                <polygon
                  id="Fill-199"
                  fill="#FFFFFF"
                  mask="url(#mask-74)"
                  points="66.1205875 49.9513251 58.9784938 51.8792604 58.369025 49.6405003 65.5111188 47.712565"
                />
                <path
                  d="M84.007825,38.1799655 C86.5656688,37.3303321 89.6477313,35.5773213 90.247575,36.765165 C90.8474188,37.9526663 85.3371062,42.0628792 85.3371062,42.0628792 L84.007825,38.1799655 Z"
                  id="Fill-200"
                  fill="#3424C7"
                  mask="url(#mask-74)"
                />
                <path
                  d="M88.501325,39.7133792 C92.7982,40.1385383 97.1707,41.340417 96.6451063,42.5624925 C96.1191688,43.7845679 87.8846375,42.1578725 87.8846375,42.1578725 L88.501325,39.7133792 Z"
                  id="Fill-201"
                  fill="#3424C7"
                  mask="url(#mask-74)"
                />
                <path
                  d="M96.2137,42.2016892 C96.0944188,41.8600558 95.2340125,40.9926218 89.8385125,40.3134628 L89.9151688,39.7082445 C96.2704188,40.5078995 96.663325,41.6317296 96.7922313,42.0010908 L96.2137,42.2016892 Z"
                  id="Fill-202"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M87.8758375,41.9648394 C92.1727125,42.3899984 96.5452125,43.5918771 96.0196188,44.8139526 C95.4936813,46.036028 87.25915,44.4096749 87.25915,44.4096749 L87.8758375,41.9648394 Z"
                  id="Fill-203"
                  fill="#3424C7"
                  mask="url(#mask-74)"
                />
                <path
                  d="M95.72805,44.371438 C95.5489563,43.8586456 94.373675,43.1264272 89.792175,42.5499636 L89.869175,41.9447453 C93.9632375,42.459934 95.9487375,43.1462817 96.3065813,44.1708396 L95.72805,44.371438 Z"
                  id="Fill-204"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M87.0938406,44.2395429 C91.3907156,44.6643596 95.7632156,45.8665806 95.2376219,47.0886561 C94.7116844,48.3107315 86.4771531,46.6840361 86.4771531,46.6840361 L87.0938406,44.2395429 Z"
                  id="Fill-205"
                  fill="#3424C7"
                  mask="url(#mask-74)"
                />
                <path
                  d="M94.9457094,46.642958 C94.6865219,45.901497 92.7577406,45.2997019 89.2129906,44.8536615 L89.2896469,44.2481008 C93.2984594,44.7526776 95.1633031,45.4089013 95.5242406,46.4423596 L94.9457094,46.642958 Z"
                  id="Fill-206"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M86.5842656,46.2596987 C90.3589844,46.7461326 94.7335469,48.1701757 94.1718594,49.3720544 C93.6105156,50.5742755 86.4398906,48.8380383 86.4398906,48.8380383 L86.5842656,46.2596987 Z"
                  id="Fill-207"
                  fill="#3424C7"
                  mask="url(#mask-74)"
                />
                <path
                  d="M93.8867875,48.9342296 C93.5921938,47.9623887 91.29285,47.4489116 88.852225,47.0384722 L88.9543188,46.4366771 C92.1676938,46.9771973 94.1009438,47.530041 94.473225,48.7579358 L93.8867875,48.9342296 Z"
                  id="Fill-208"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M64.0021938,16.5072615 C51.2851625,30.076407 57.8641938,35.4066415 62.9052875,38.4871617 C67.9463813,41.5676819 78.6101938,47.4418598 86.4397875,48.8378329 L88.9876625,39.8892965 L67.3255688,30.4067439 L72.9018813,23.009593 L64.0021938,16.5072615 Z"
                  id="Fill-209"
                  fill="#3424C7"
                  mask="url(#mask-74)"
                />
                <path
                  d="M57.9236281,34.1299663 L57.8277219,33.5274865 C58.3608781,33.4432763 58.7651281,32.6302709 58.7290344,31.7142278 C58.7104719,31.2435404 58.5052531,29.6962628 56.6445344,29.5511199 L56.6923156,28.9428208 C58.5733156,29.0896752 59.2948469,30.5147453 59.3412531,31.6906078 C59.3907531,32.9462305 58.7812844,33.995093 57.9236281,34.1299663"
                  id="Fill-210"
                  fill="#070000"
                  mask="url(#mask-74)"
                />
                <path
                  d="M46.3641063,30.9914574 C56.9729188,13.2912175 67.2249188,13.5787647 70.6754813,15.9041313 C73.0731375,17.5195302 75.0503875,19.1753226 75.051075,25.4828752 C75.0521062,31.7904278 68.3115125,45.3718968 68.3115125,45.3718968 L46.3641063,30.9914574 Z"
                  id="Fill-211"
                  fill="#766DFF"
                  mask="url(#mask-74)"
                />
              </g>
              <g id="Group-264" transform="translate(47.000000, 14.000000)">
                <g id="Group-215">
                  <mask id="mask-76" fill="white">
                    <use xlink:href="#offre-75" />
                  </mask>
                  <g id="Clip-214" />
                  <path
                    d="M13.9585529,-1.13663222 C13.6948235,-1.34777667 13.4304118,-1.56236556 13.1656588,-1.78005444 L13.5498235,-2.25607667 C13.8125294,-2.04011 14.0748941,-1.82724333 14.3365765,-1.61747667 L13.9585529,-1.13663222 Z"
                    id="Fill-213"
                    fill="#FFFFFF"
                    mask="url(#mask-76)"
                  />
                </g>
                <g id="Group-218">
                  <mask id="mask-78" fill="white">
                    <use xlink:href="#offre-77" />
                  </mask>
                  <g id="Clip-217" />
                  <path
                    d="M17.1009588,1.25160778 C16.5677,0.866863333 16.0341,0.471785556 15.5151706,0.0773966667 L15.8809118,-0.413092222 C16.3957471,-0.0214588889 16.9252529,0.370174444 17.4544176,0.751818889 L17.1009588,1.25160778 Z M20.3571471,3.47844111 C19.8095588,3.12331889 19.2571941,2.75579667 18.7154059,2.38551889 L19.0565824,1.87711889 C19.5939353,2.24464111 20.1422059,2.60975222 20.6857,2.96177444 L20.3571471,3.47844111 Z M23.7184176,5.53994111 C23.1530882,5.21237444 22.5833235,4.87275222 22.0251588,4.53037444 L22.3407471,4.00544111 C22.8948176,4.34506333 23.4601471,4.68227444 24.0210412,5.00743 L23.7184176,5.53994111 Z M27.1786294,7.42921889 C26.6027235,7.13368556 26.0162412,6.82368556 25.4362412,6.50679667 L25.7259,5.96670778 C26.3011235,6.28118556 26.8824882,6.58877444 27.4539588,6.88155222 L27.1786294,7.42921889 Z M30.7374412,9.12767444 C30.1536882,8.87037444 29.5508294,8.59344111 28.9455824,8.30410778 L29.2055588,7.74920778 C29.8053471,8.03578556 30.4024059,8.31030778 30.9803588,8.56485222 L30.7374412,9.12767444 Z"
                    id="Fill-216"
                    fill="#FFFFFF"
                    mask="url(#mask-78)"
                  />
                </g>
                <g id="Group-221">
                  <mask id="mask-80" fill="white">
                    <use xlink:href="#offre-79" />
                  </mask>
                  <g id="Clip-220" />
                  <path
                    d="M33.8079271,11.0112344 L33.2033624,10.9444122 L33.2872918,10.1687233 C33.1248918,10.1091344 32.8789035,10.0168233 32.5558094,9.88937889 L32.7772329,9.31760111 C33.3756565,9.55389 33.7096682,9.66893444 33.71308,9.66996778 L33.9443976,9.74884556 L33.8079271,11.0112344 Z"
                    id="Fill-219"
                    fill="#FFFFFF"
                    mask="url(#mask-80)"
                  />
                </g>
                <g id="Group-224">
                  <mask id="mask-82" fill="white">
                    <use xlink:href="#offre-81" />
                  </mask>
                  <g id="Clip-223" />
                  <path
                    d="M33.4546729,14.2787722 L33.0612965,14.0745167 C33.0612965,14.0745167 32.7392259,13.9071167 32.1612729,13.60125 L32.4434259,13.0577167 C32.6423318,13.1627722 32.8108729,13.2519833 32.94632,13.3229389 L33.0080729,12.7508167 L33.6126376,12.8176389 L33.4546729,14.2787722 Z"
                    id="Fill-222"
                    fill="#FFFFFF"
                    mask="url(#mask-82)"
                  />
                </g>
                <g id="Group-227">
                  <mask id="mask-84" fill="white">
                    <use xlink:href="#offre-83" />
                  </mask>
                  <g id="Clip-226" />
                  <path
                    d="M8.59044824,-0.590033333 C7.98690706,-1.03677778 7.41987176,-1.47387778 6.90401294,-1.88893333 L7.28306,-2.36908889 C7.79243647,-1.9592 8.35333059,-1.52726667 8.95038941,-1.08465556 L8.59044824,-0.590033333 Z M12.06806,1.84656667 C11.4573541,1.4384 10.8678012,1.03608889 10.3154365,0.649966667 L10.6617306,0.145355556 C11.2103424,0.528722222 11.7964835,0.928966667 12.4034365,1.33437778 L12.06806,1.84656667 Z M15.6299424,4.14504444 C15.0100247,3.7572 14.4081894,3.37486667 13.8411541,3.00941111 L14.1683424,2.49171111 C14.7329894,2.85613333 15.3327776,3.23674444 15.9503071,3.62286667 L15.6299424,4.14504444 Z M19.2453894,6.35121111 C18.6425306,5.99195556 18.0366012,5.62684444 17.4320365,5.2576 L17.7466012,4.73232222 C18.3498012,5.10053333 18.9536835,5.46426667 19.5548365,5.82317778 L19.2453894,6.35121111 Z M22.8990482,8.48883333 C22.2989188,8.14438889 21.6868482,7.78995556 21.0676129,7.4276 L21.3726247,6.89646667 C21.9904953,7.25778889 22.60086,7.61153333 23.1996247,7.95563333 L22.8990482,8.48883333 Z M26.5840953,10.5713444 C25.9931776,10.2427444 25.3756482,9.89692222 24.7379894,9.53663333 L25.0348129,9.00102222 C25.6714482,9.36062222 26.2876129,9.70575556 26.8775071,10.0336667 L26.5840953,10.5713444 Z M30.2971188,12.6049444 C29.7420247,12.3056222 29.1173306,11.9670333 28.4370247,11.5943444 L28.7270247,11.0546 C29.4059659,11.4266 30.0292953,11.7645 30.5833659,12.0634778 L30.2971188,12.6049444 Z"
                    id="Fill-225"
                    fill="#FFFFFF"
                    mask="url(#mask-84)"
                  />
                </g>
                <g id="Group-230">
                  <mask id="mask-86" fill="white">
                    <use xlink:href="#offre-85" />
                  </mask>
                  <g id="Clip-229" />
                  <path
                    d="M4.48892706,-3.16227556 L3.97272706,-3.48674222 L4.71103294,-4.68334222 L4.98158588,-4.41019778 C5.20130353,-4.18837556 5.44490353,-3.95484222 5.70556235,-3.71579778 L5.29717412,-3.26113111 C5.13238588,-3.41199778 4.97442118,-3.56079778 4.82430353,-3.70615333 L4.48892706,-3.16227556 Z"
                    id="Fill-228"
                    fill="#FFFFFF"
                    mask="url(#mask-86)"
                  />
                </g>
                <g id="Group-233">
                  <mask id="mask-88" fill="white">
                    <use xlink:href="#offre-87" />
                  </mask>
                  <g id="Clip-232" />
                  <polygon
                    id="Fill-231"
                    fill="#FFFFFF"
                    mask="url(#mask-88)"
                    points="3.22814353 -1.11899667 2.71194353 -1.44346333 3.34209647 -2.46508556 3.85863765 -2.14061889"
                  />
                </g>
                <g id="Group-236">
                  <mask id="mask-90" fill="white">
                    <use xlink:href="#offre-89" />
                  </mask>
                  <g id="Clip-235" />
                  <path
                    d="M2.46776353,1.44098333 C1.92802235,1.06932778 1.63085765,0.861283333 1.63085765,0.861283333 L1.39271647,0.694572222 L2.08155176,-0.421772222 L2.59809294,-0.0969611111 L2.21529294,0.522694444 C2.35585765,0.620172222 2.55612824,0.758983333 2.81030471,0.933616667 L2.46776353,1.44098333 Z"
                    id="Fill-234"
                    fill="#FFFFFF"
                    mask="url(#mask-90)"
                  />
                </g>
                <g id="Group-239">
                  <mask id="mask-92" fill="white">
                    <use xlink:href="#offre-91" />
                  </mask>
                  <g id="Clip-238" />
                  <path
                    d="M5.99215059,3.82653667 C5.34220941,3.39288111 4.74924471,2.99435889 4.22451529,2.63923667 L4.56296235,2.12911444 C5.08666824,2.48354778 5.67860941,2.88138111 6.32718588,3.31400333 L5.99215059,3.82653667 Z M9.54959765,6.16324778 C8.93104471,5.76265889 8.33500941,5.37378111 7.76729176,5.00074778 L8.09891529,4.48649222 C8.66560941,4.85883667 9.26028,5.24668111 9.87780941,5.64623667 L9.54959765,6.16324778 Z M13.1397976,8.44932556 C12.5277271,8.06630333 11.9269153,7.68672556 11.3404329,7.31334778 L11.6648918,6.79392556 C12.2500094,7.16661444 12.8494565,7.54550333 13.4601624,7.92749222 L13.1397976,8.44932556 Z M16.7671859,10.67547 C16.1557976,10.3082922 15.5485035,9.93939222 14.9483741,9.57049222 L15.2643035,9.04624778 C15.8630682,9.41377 16.4686565,9.78198111 17.0779976,10.1481256 L16.7671859,10.67547 Z M20.4416565,12.8258367 C19.8456212,12.4869033 19.2253624,12.1286811 18.5979388,11.7615033 L18.9029506,11.23037 C19.5279859,11.5965144 20.1461976,11.9530144 20.7401859,12.29057 L20.4416565,12.8258367 Z M24.1785624,14.8694256 C23.5763859,14.5546033 22.9445271,14.2163589 22.3010682,13.8636478 L22.5910682,13.3239033 C23.2311153,13.6745478 23.8595624,14.01107 24.4583271,14.3245144 L24.1785624,14.8694256 Z M28.0086094,16.7445811 C27.4002918,16.4707478 26.7510329,16.1645367 26.0789153,15.8342144 L26.3453741,15.28207 C27.0110094,15.6092922 27.6541271,15.9127478 28.2563035,16.1838256 L28.0086094,16.7445811 Z"
                    id="Fill-237"
                    fill="#FFFFFF"
                    mask="url(#mask-92)"
                  />
                </g>
                <g id="Group-242">
                  <mask id="mask-94" fill="white">
                    <use xlink:href="#offre-93" />
                  </mask>
                  <g id="Clip-241" />
                  <path
                    d="M31.1443965,18.6975122 L30.5452906,18.5928011 L30.6742553,17.8395011 C30.4425965,17.7554567 30.2024082,17.6645233 29.9571024,17.5684233 L30.1771612,16.9963011 C30.5033259,17.1237456 30.8195965,17.24189 31.1174435,17.3469456 L31.3610435,17.4327122 L31.1443965,18.6975122 Z"
                    id="Fill-240"
                    fill="#FFFFFF"
                    mask="url(#mask-94)"
                  />
                </g>
                <g id="Group-245">
                  <mask id="mask-96" fill="white">
                    <use xlink:href="#offre-95" />
                  </mask>
                  <g id="Clip-244" />
                  <polygon
                    id="Fill-243"
                    fill="#FFFFFF"
                    mask="url(#mask-96)"
                    points="30.7324941 21.1025611 30.1333882 20.99785 30.3391176 19.7953944 30.9385647 19.9001056"
                  />
                </g>
                <g id="Group-248">
                  <mask id="mask-98" fill="white">
                    <use xlink:href="#offre-97" />
                  </mask>
                  <g id="Clip-247" />
                  <path
                    d="M30.2867129,23.7059067 L29.9277953,23.5402289 C29.9277953,23.5402289 29.6023129,23.3897067 29.00696,23.1069178 L29.2659129,22.5513289 C29.4910894,22.6584511 29.6777129,22.7466289 29.8223718,22.8144844 L29.9274541,22.20034 L30.52656,22.3053956 L30.2867129,23.7059067 Z"
                    id="Fill-246"
                    fill="#FFFFFF"
                    mask="url(#mask-98)"
                  />
                </g>
                <g id="Group-251">
                  <mask id="mask-100" fill="white">
                    <use xlink:href="#offre-99" />
                  </mask>
                  <g id="Clip-250" />
                  <path
                    d="M4.53348471,9.62488 C3.92482588,9.23255778 3.31889647,8.83506889 2.73241412,8.44412444 L3.06779059,7.93159111 C3.65154353,8.32115778 4.25474353,8.71692444 4.86101412,9.10786889 L4.53348471,9.62488 Z M8.18304941,11.9088911 C7.57200235,11.5372356 6.96061412,11.1604133 6.35093176,10.7794578 L6.67129647,10.25728 C7.27859059,10.6372022 7.88759059,11.0126467 8.49659059,11.3829244 L8.18304941,11.9088911 Z M11.8844729,14.1026578 C11.2693318,13.7468467 10.6497553,13.3844911 10.0277906,13.0159356 L10.3355318,12.4865244 C10.9554494,12.8540467 11.57332,13.2150244 12.1867553,13.5698022 L11.8844729,14.1026578 Z M15.6288847,16.2192689 C15.0116965,15.8779244 14.3852965,15.5283133 13.7520729,15.1700911 L14.0488965,14.63448 C14.6804141,14.9913244 15.3054494,15.3405911 15.9212729,15.6809022 L15.6288847,16.2192689 Z M19.4104847,18.2673356 C18.79432,17.9404578 18.1617788,17.6015244 17.5152494,17.2515689 L17.8028612,16.7104467 C18.4473435,17.0593689 19.0788612,17.3976133 19.69332,17.7238022 L19.4104847,18.2673356 Z M23.2248376,20.2520244 C22.6168612,19.9420244 21.97852,19.6134244 21.3135671,19.2672578 L21.5919671,18.7216578 C22.2552141,19.0667911 22.8925318,19.3947022 23.4988024,19.7040133 L23.2248376,20.2520244 Z M27.0716024,22.17368 C26.5001318,21.8943356 25.8536024,21.57538 25.1439553,21.2209467 L25.4134847,20.6705244 C26.1217671,21.0242689 26.7662494,21.3421911 27.3366965,21.6211911 L27.0716024,22.17368 Z"
                    id="Fill-249"
                    fill="#FFFFFF"
                    mask="url(#mask-100)"
                  />
                </g>
                <g id="Group-254">
                  <mask id="mask-102" fill="white">
                    <use xlink:href="#offre-101" />
                  </mask>
                  <g id="Clip-253" />
                  <path
                    d="M0.0516882353,7.44285889 L-0.473723529,7.13389222 L0.202829412,5.96209222 L0.473382353,6.15291444 C0.748711765,6.34752556 1.02608824,6.54110333 1.30482941,6.73399222 L0.960923529,7.24067 C0.771911765,7.10943667 0.583582353,6.97820333 0.395935294,6.84697 L0.0516882353,7.44285889 Z"
                    id="Fill-252"
                    fill="#FFFFFF"
                    mask="url(#mask-102)"
                  />
                </g>
                <g id="Group-257">
                  <mask id="mask-104" fill="white">
                    <use xlink:href="#offre-103" />
                  </mask>
                  <g id="Clip-256" />
                  <path
                    d="M-0.855124706,10.3754933 C-1.39043059,9.99522667 -1.68384235,9.78373778 -1.68384235,9.78373778 L-1.90936,9.62116 L-1.25941882,8.49551556 L-0.734348235,8.80413778 L-1.10452471,9.44618222 C-0.965324706,9.54607111 -0.763689412,9.69004889 -0.505418824,9.87329333 L-0.855124706,10.3754933 Z"
                    id="Fill-255"
                    fill="#FFFFFF"
                    mask="url(#mask-104)"
                  />
                </g>
                <g id="Group-260">
                  <mask id="mask-106" fill="white">
                    <use xlink:href="#offre-105" />
                  </mask>
                  <g id="Clip-259" />
                  <path
                    d="M2.57028706,12.76828 C1.93774588,12.3325578 1.36184,11.9330022 0.852122353,11.5771911 L1.19841647,11.0722356 C1.70676941,11.4273578 2.28165176,11.8262244 2.91282824,12.2612578 L2.57028706,12.76828 Z M6.02640471,15.11808 C5.42388706,14.7137022 4.84525176,14.3227578 4.29493412,13.9486911 L4.63440471,13.4392578 C5.18404,13.81298 5.76165176,14.2032356 6.36314588,14.6069244 L6.02640471,15.11808 Z M9.51186353,17.4234467 C8.91616941,17.0352578 8.33309882,16.6522356 7.76538118,16.2767911 L8.09871059,15.7632244 C8.66540471,16.13798 9.24711059,16.5203133 9.84178118,16.9078133 L9.51186353,17.4234467 Z M13.0300753,19.6785244 C12.4354047,19.3041133 11.8465341,18.9297022 11.2665341,18.5580467 L11.5926988,18.0393133 C12.1713341,18.4106244 12.7584988,18.7840022 13.3521459,19.1577244 L13.0300753,19.6785244 Z M16.5864988,21.8733244 C15.9897812,21.5137244 15.3947694,21.1499911 14.8028282,20.7845356 L15.1201224,20.26098 C15.7100165,20.6254022 16.3036635,20.9877578 16.8983341,21.3466689 L16.5864988,21.8733244 Z M20.1913694,23.9909689 C19.6048871,23.6568578 18.9962282,23.3044911 18.3824518,22.9435133 L18.6884871,22.4130689 C19.2998753,22.7723244 19.9061459,23.1233133 20.4905812,23.4563911 L20.1913694,23.9909689 Z M23.8596988,26.0001133 C23.2711694,25.69218 22.6509106,25.3597911 22.0163224,25.0119022 L22.3066635,24.4721578 C22.93784,24.8183244 23.5543459,25.1489911 24.1394635,25.4548578 L23.8596988,26.0001133 Z M27.6208282,27.8401356 C27.0217224,27.5711244 26.3844047,27.2704244 25.7259341,26.9469911 L25.9920518,26.3951911 C26.64404,26.71518 27.2752165,27.01278 27.8681812,27.27938 L27.6208282,27.8401356 Z"
                    id="Fill-258"
                    fill="#FFFFFF"
                    mask="url(#mask-106)"
                  />
                </g>
                <g id="Group-263">
                  <mask id="mask-108" fill="white">
                    <use xlink:href="#offre-107" />
                  </mask>
                  <g id="Clip-262" />
                  <path
                    d="M30.48596,29.0062867 C30.17856,28.8967533 29.8558071,28.7758533 29.5272541,28.6466867 L29.7479953,28.0745644 C30.0704071,28.20132 30.3866776,28.3201533 30.6879365,28.4272756 L30.48596,29.0062867 Z"
                    id="Fill-261"
                    fill="#FFFFFF"
                    mask="url(#mask-108)"
                  />
                </g>
              </g>
              <path
                d="M72.0517211,11.2871691 C72.4453906,8.55421961 74.9798813,6.6583049 77.7128309,7.05164954 C80.4457804,7.445319 82.3416951,9.98013456 81.9483505,12.7127593 C81.5543562,15.4457088 79.0198654,17.3419483 76.2872407,16.9482789 C73.5542912,16.5546094 71.6580517,14.0201187 72.0517211,11.2871691"
                id="Fill-265"
                fill="#4C3BE3"
              />
              <g id="Group-269" transform="translate(72.000000, 6.000000)">
                <mask id="mask-110" fill="white">
                  <use xlink:href="#offre-109" />
                </mask>
                <g id="Clip-268" />
                <path
                  d="M3.34173125,12.5053844 C0.963325,5.27425938 9.01085625,6.61110313 6.7238875,-0.370803125 L-2.094675,-0.114021875 L-2.48139375,10.5209156 L3.34173125,12.5053844 Z"
                  id="Fill-267"
                  fill="#4C3BE3"
                  mask="url(#mask-110)"
                />
              </g>
              <g id="Group-305" transform="translate(50.000000, 0.000000)">
                <path
                  d="M28.0206032,13.7130745 L27.6419258,13.2249895 C27.7549742,13.137349 28.7710226,12.3794144 29.6417726,12.6239765 C29.9153774,12.7015712 30.2871194,12.9149569 30.5045468,13.4931072 L29.9257806,13.7099569 C29.8227887,13.4362967 29.6750629,13.2755647 29.4742806,13.2184078 C28.9874097,13.0805386 28.2598774,13.5284405 28.0206032,13.7130745"
                  id="Fill-270"
                  fill="#070000"
                />
                <path
                  d="M27.0254306,16.1154294 C27.0798742,15.7378477 27.4304629,15.475619 27.8084468,15.530351 C28.1864306,15.5847366 28.4489387,15.9349523 28.3944952,16.312534 C28.3400516,16.6901157 27.9894629,16.951998 27.611479,16.8976124 C27.2331484,16.8432268 26.9709871,16.4930111 27.0254306,16.1154294"
                  id="Fill-272"
                  fill="#FF3D81"
                />
                <path
                  d="M29.659146,16.3006176 C29.659146,16.3006176 30.9318073,16.9130621 31.2335008,16.5372124 C31.454396,16.2618203 31.3711702,16.1069771 30.9588556,14.3565915 L29.659146,16.3006176 Z"
                  id="Fill-274"
                  fill="#4C3BE3"
                />
                <path
                  d="M30.8771903,16.9667203 C30.4010694,16.9667203 29.82265,16.7218118 29.5251177,16.5787464 C29.37115,16.5049621 29.30665,16.3203281 29.3808597,16.1668706 C29.4547226,16.0134131 29.6399,15.9489817 29.7931742,16.0224196 C30.2852468,16.258668 30.873029,16.4110863 31.0023758,16.3345307 C31.0807468,16.2337268 31.0672226,16.1384654 30.8109565,15.0691124 C30.7662226,14.8827464 30.7152468,14.6704 30.658029,14.4272235 C30.6188435,14.2612954 30.7218355,14.0950209 30.8879403,14.0562235 C31.0540452,14.0167333 31.2204968,14.1199621 31.2593355,14.2858902 C31.3165532,14.5280275 31.3671823,14.739681 31.4119161,14.9253542 C31.7063274,16.1537072 31.7593839,16.3750601 31.4746823,16.7301255 C31.3359726,16.9029817 31.1199323,16.9667203 30.8771903,16.9667203"
                  id="Fill-276"
                  fill="#070000"
                />
                <path
                  d="M29.2370177,42.6986359 C31.5621387,41.2884203 34.1997032,38.8694725 35.0565823,39.9069562 C35.9138081,40.9451327 31.4175339,46.2330085 31.4175339,46.2330085 L29.2370177,42.6986359 Z"
                  id="Fill-278"
                  fill="#4C3BE3"
                />
                <path
                  d="M34.0017992,43.2069163 C38.3239927,42.665485 42.8951702,42.8736745 42.652775,44.1969425 C42.4103798,45.5205569 33.9449282,45.7568052 33.9449282,45.7568052 L34.0017992,43.2069163 Z"
                  id="Fill-280"
                  fill="#4C3BE3"
                />
                <path
                  d="M42.1473516,43.9374503 C41.9531581,43.6274176 40.9121419,42.9633588 35.4518355,43.5002869 L35.39115,42.8854176 C41.8224242,42.2542673 42.461529,43.2747771 42.6713274,43.6104438 L42.1473516,43.9374503 Z"
                  id="Fill-282"
                  fill="#070000"
                />
                <path
                  d="M33.8925653,45.5683261 C38.2147589,45.0268948 42.7859363,45.2354307 42.5435411,46.5586987 C42.301146,47.8819667 33.8356944,48.1185614 33.8356944,48.1185614 L33.8925653,45.5683261 Z"
                  id="Fill-284"
                  fill="#4C3BE3"
                />
                <path
                  d="M42.1574081,46.1870405 C41.865771,45.7207791 40.5452548,45.2614458 35.9092306,45.717315 L35.8485452,45.1024458 C39.99215,44.6954196 42.09915,44.9292431 42.6813839,45.8596876 L42.1574081,46.1870405 Z"
                  id="Fill-286"
                  fill="#070000"
                />
                <path
                  d="M33.634704,47.9875856 C37.9568976,47.4461542 42.528075,47.6546902 42.2856798,48.9779582 C42.0432847,50.3012261 33.5774863,50.5374745 33.5774863,50.5374745 L33.634704,47.9875856 Z"
                  id="Fill-288"
                  fill="#4C3BE3"
                />
                <path
                  d="M41.8984371,48.6032516 C41.4771065,47.9294935 39.4446629,47.766683 35.8572839,48.1196699 L35.7965984,47.5051471 C39.8538565,47.106781 41.8349774,47.3371405 42.4224129,48.2762451 L41.8984371,48.6032516 Z"
                  id="Fill-290"
                  fill="#070000"
                />
                <path
                  d="M33.5875427,50.0949418 C37.4096879,49.7308699 42.0328815,50.1576412 41.750954,51.4691314 C41.4686798,52.780968 34.0251718,52.6711575 34.0251718,52.6711575 L33.5875427,50.0949418 Z"
                  id="Fill-292"
                  fill="#4C3BE3"
                />
                <path
                  d="M41.3719298,51.1010065 C40.8635589,50.2083203 38.4864218,50.2152484 35.9934621,50.3562353 L35.9587847,49.7392876 C39.2410024,49.5546536 41.2668573,49.6675817 41.9094298,50.7961699 L41.3719298,51.1010065 Z"
                  id="Fill-294"
                  fill="#070000"
                />
                <path
                  d="M4.68682661,25.787202 C-4.77213306,42.019751 2.89747177,45.8080386 8.54850403,47.7205418 C14.1995363,49.6326987 26.009625,53.0444438 34.0249637,52.6713654 L34.5198105,43.2716595 L11.0803024,38.7586922 L14.9027944,30.2132216 L4.68682661,25.787202 Z"
                  id="Fill-296"
                  fill="#4C3BE3"
                />
                <path
                  d="M2.66894758,44.535034 L2.43938306,43.9617333 C2.94463306,43.7597791 3.15963306,42.8670928 2.91827823,41.9712889 C2.79413306,41.5109163 2.24518952,40.0307268 0.381625,40.3030013 L0.292157258,39.6922889 C2.17514113,39.4165503 3.20506048,40.6611843 3.51507661,41.8109033 C3.84589919,43.0389098 3.48213306,44.2101059 2.66894758,44.535034"
                  id="Fill-298"
                  fill="#070000"
                />
                <g id="Group-302" transform="translate(20.806452, 0.000000)">
                  <mask id="mask-112" fill="white">
                    <use xlink:href="#offre-111" />
                  </mask>
                  <g id="Clip-301" />
                  <path
                    d="M9.6994129,11.5428111 C7.41278387,10.993066 5.38276774,12.3651771 4.99334032,13.5187065 L0.295243548,12.3537458 C-0.0973048387,8.7597915 0.0531951613,1.27224248 0.0531951613,1.27224248 C0.0531951613,1.27224248 4.87474355,-0.571672549 8.0761629,0.218477778 C8.0761629,0.218477778 10.9228323,7.8120268 10.9928806,10.6414647 C10.9928806,10.6414647 10.6166306,9.99888301 9.6994129,11.5428111"
                    id="Fill-300"
                    fill="#070000"
                    mask="url(#mask-112)"
                  />
                </g>
                <path
                  d="M24.7631798,12.3785484 C24.7631798,11.7491301 24.2523815,11.2385288 23.621946,11.2385288 C22.9918573,11.2385288 22.4807121,11.7491301 22.4807121,12.3785484 C22.4807121,13.0079667 22.9918573,13.518568 23.621946,13.518568 C24.2523815,13.518568 24.7631798,13.0079667 24.7631798,12.3785484"
                  id="Fill-303"
                  fill="#4C3BE3"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <!-- END illustration-offre -->

  <!-- BEGIN cv-dashboard-femme -->
  <svg
    v-else-if="name === 'cv-dashboard-femme'"
    xmlns="http://www.w3.org/2000/svg"
    width="379"
    height="196"
    viewBox="0 0 271 140"
    fill="none"
  >
    <path
      d="M28.303 70.0793C38.4004 66.7083 48.6371 65.0228 58.7036 65.0538C79.6099 65.1311 95.4442 72.5689 109.438 79.1098C121.206 84.6147 131.752 89.5629 143.318 89.5629C147.153 89.5629 151.112 89.0217 155.256 87.7692C167.255 84.1354 173.533 76.8058 179.595 69.7236C185.687 62.6106 191.424 55.8995 202.48 54.3068C206.315 53.7502 210.258 53.8893 214.325 54.6934C216.598 66.5228 217.093 79.1407 215.423 90.8464C210.305 89.2228 205.357 88.7743 200.579 89.5165C189.94 91.1711 184.497 98.0522 178.714 105.32C176.935 107.562 175.142 109.82 173.162 111.985H110.119C98.2276 106.109 84.7127 100.31 67.4867 100.248C58.0232 100.202 48.4361 101.918 38.9571 105.32C34.0862 107.067 29.1844 109.294 24.2671 111.985H20.2157C11.4017 104.516 5.13907 94.0937 2.10829 82.589C10.845 77.1614 19.6281 72.9709 28.303 70.0793Z"
      fill="#FFF0F0"
    />
    <path
      d="M67.1465 101.33C67.2547 101.33 67.363 101.33 67.4712 101.33C83.5065 101.408 96.341 106.511 107.629 112H26.5556C30.8234 109.758 35.0758 107.887 39.3127 106.356C48.5597 103.016 57.9304 101.33 67.1465 101.33Z"
      fill="#FFF0F0"
    />
    <path
      d="M42.8848 36.3077C42.993 36.3077 43.1012 36.3077 43.2095 36.3077C62.5694 36.3851 77.244 43.8074 90.2021 50.3638C97.3616 53.9822 104.134 57.415 111.016 59.3015C114.727 60.3221 118.252 60.8324 121.685 60.8324C125.412 60.8324 129.046 60.2293 132.71 59.0386C143.844 55.4048 149.658 48.0752 155.287 40.9776C160.915 33.88 166.25 27.169 176.471 25.5763C186.631 23.999 197.687 28.004 209.501 37.5139C211.403 42.5549 212.934 47.967 214.078 53.5647C210.057 52.807 206.13 52.6987 202.31 53.2554C190.852 54.91 184.976 61.7756 178.76 69.0433C172.791 76.0172 166.621 83.2231 154.931 86.7487C138.71 91.6505 125.35 85.3879 109.887 78.1512C95.7998 71.5484 79.8418 64.0642 58.7036 63.9869C58.5799 63.9869 58.4716 63.9869 58.3479 63.9869C48.2659 63.9869 38.0448 65.6878 27.9473 69.0588C19.2879 71.9504 10.5357 76.1255 1.81448 81.5067C-0.95343 70.2185 -0.644165 57.9408 3.36079 46.4207C7.27299 44.4259 11.1697 42.725 15.051 41.3333C24.3134 37.9932 33.6687 36.3077 42.8848 36.3077Z"
      fill="#FFF0F0"
    />
    <path
      d="M31.875 15.4014C32.0915 15.4014 32.3234 15.4014 32.5399 15.4014C32.6481 15.4014 32.7564 15.4014 32.8646 15.4014C52.2245 15.4787 66.8991 22.9011 79.8573 29.4575C87.0168 33.0759 93.7896 36.5087 100.671 38.3952C104.382 39.4158 107.908 39.9261 111.34 39.9261C115.067 39.9261 118.701 39.323 122.366 38.1323C133.499 34.4985 139.313 27.1689 144.942 20.0713C149.117 14.8138 153.122 9.75736 159.075 6.85028C165.307 5.52044 172.265 5.16479 181.25 6.7575C182.997 7.06676 184.682 7.57705 186.321 8.28836C187.667 8.93781 189.012 9.66458 190.388 10.4687C197.965 15.4014 204.228 24.4474 208.712 35.5191C197.192 26.6277 186.337 22.932 176.286 24.4938C165.647 26.1484 160.204 33.0295 154.421 40.2972C148.9 47.2556 143.179 54.4615 132.355 58.0026C117.356 62.9044 104.985 56.6418 90.6661 49.405C77.5997 42.8022 62.8014 35.318 43.194 35.2253C33.746 35.1789 24.1434 36.8953 14.6644 40.3127C11.077 41.5961 7.4895 43.1424 3.87111 44.9362C5.10817 41.658 6.65448 38.4416 8.52553 35.3335C13.7985 26.6123 21.2672 19.2363 31.875 15.4014Z"
      fill="#FFF0F0"
    />
    <path
      d="M179.549 106C185.177 98.9028 190.512 92.1917 200.733 90.599C205.388 89.8723 210.228 90.3207 215.253 91.9289C214.124 99.1347 212.176 105.954 209.284 112H174.616C176.348 110.036 177.956 108.011 179.549 106Z"
      fill="#FFF0F0"
    />
    <path
      d="M144.107 19.3909C138.587 26.3494 132.865 33.5552 122.041 37.0963C107.042 41.9981 94.6711 35.7355 80.3522 28.4988C67.8115 22.1589 53.6472 14.9994 35.1687 14.3654C43.5498 12.0614 53.74 11.8449 66.1106 14.6283C121.206 27.0298 135.788 13.2984 155.333 7.77808C150.911 10.8089 147.571 15.0303 144.107 19.3909Z"
      fill="#FFF0F0"
    />
    <path
      d="M152.086 89.4392H160.328L150.416 106.34L171.353 89.4392H216.397L176.487 0H112.175L152.086 89.4392Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M196.172 79.9139H200.532L184.219 43.2506H179.842L196.172 79.9139Z"
      fill="#DAE6F7"
    />
    <path
      opacity="0.5"
      d="M186.352 79.9139H190.729L163.142 17.9838H158.782L186.352 79.9139Z"
      fill="#DAE6F7"
    />
    <path
      opacity="0.5"
      d="M176.533 79.9138H180.909L159.895 32.7201H155.519L176.533 79.9138Z"
      fill="#DAE6F7"
    />
    <path
      d="M196.172 79.9138H200.532L188.316 52.4512H183.94L196.172 79.9138Z"
      fill="#BBD3F9"
    />
    <path
      d="M186.352 79.9138H190.729L167.147 26.9678H162.771L186.352 79.9138Z"
      fill="#BBD3F9"
    />
    <path
      d="M176.533 79.9137H180.909L163.173 40.1115H158.812L176.533 79.9137Z"
      fill="#BBD3F9"
    />
    <path
      d="M164.101 66.1825H151.05"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M166.018 71.007H152.967"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M167.936 75.8316H154.885"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M117.819 96.5831L126.85 54.4768C127.84 49.8533 131.953 46.3895 136.87 46.3895C142.53 46.3895 147.122 50.9821 147.122 56.6416C147.122 57.1365 147.091 57.6158 147.014 58.0952L140.968 100.727C140.164 106.433 135.246 110.825 129.324 110.825C122.829 110.825 117.557 105.552 117.557 99.0572C117.557 98.2222 117.649 97.3872 117.819 96.5831Z"
      fill="#FF9494"
    />
    <path
      d="M137.999 40.359L132.741 51.6317L148.684 53.7656L155.689 40.359H137.999Z"
      fill="#FF9494"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M144.571 41.8898C144.045 42.5083 144.122 43.4516 144.741 43.9774C145.359 44.5031 146.287 44.4258 146.813 43.8073L157.204 31.6377C161.766 34.5757 167.92 33.7716 171.539 29.5347C175.482 24.9267 174.941 17.9528 170.317 14.0097C165.709 10.0665 158.735 10.6078 154.792 15.2313C151.174 19.4682 151.344 25.6844 154.962 29.7203L144.571 41.8898ZM168.4 16.2518C171.786 19.1434 172.188 24.2308 169.296 27.6173C166.42 30.9883 161.317 31.3903 157.931 28.5142C154.545 25.6225 154.142 20.5351 157.034 17.1487C159.926 13.7623 165.013 13.3602 168.4 16.2518Z"
      fill="#0B1E5B"
    />
    <path
      d="M126.865 54.4923L127.948 49.4513C132.602 36.7096 141.54 33.617 141.54 33.617L149.457 33.5706C150.787 33.8644 150.57 35.1479 150.4 35.7973C150.014 37.2509 145.545 38.5807 144.045 38.7662L143.148 41.194L141.463 46.4669L143.396 48.7245C143.658 48.941 143.89 49.1575 144.122 49.3895L149.596 47.704L147.401 41.9053C147.122 40.9002 147.694 39.8332 148.73 39.5394C149.596 39.292 150.509 39.694 150.973 40.4517L151.56 41.4259L151.019 37.4673C150.895 36.5241 151.436 35.5963 152.38 35.2716C153.184 34.9932 154.065 35.2716 154.622 35.921L154.962 36.3231V34.3747C154.962 33.6789 155.534 33.1067 156.23 33.1067C157.714 32.4882 159.307 33.7098 159.075 35.3025L159.477 42.3537C159.508 42.9258 159.462 43.498 159.338 44.0547C158.921 45.8948 158.271 47.5648 157.251 48.6008C154.699 51.1677 148.081 59.3014 145.622 61.992C143.813 64.9145 140.581 66.8629 136.901 66.8629C131.241 66.8629 126.649 62.2703 126.649 56.6108C126.633 55.9149 126.711 55.1882 126.865 54.4923Z"
      fill="#FF9494"
    />
    <path
      d="M149.194 37.0034C149.194 37.0034 144.803 38.9982 140.411 38.8435"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M150.926 40.4053L154.498 46.4823"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M154.947 36.3385L157.606 43.9464"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M140.968 41.1012C140.968 41.1012 139.251 51.6316 138.076 53.7656"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M147.385 50.1935L139.205 51.2914"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M148.035 43.6371L150.679 49.9615"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M86.3672 9.64908C86.3672 9.64908 80.2283 5.41216 74.2904 14.319C68.3526 23.2258 68.8319 26.8906 63.0332 25.4989C57.2345 24.1226 49.9204 27.973 49.9204 33.4779C49.9204 38.1323 55.1779 42.8331 55.1779 42.8331L81.3417 31.0965L86.8929 9.54084"
      fill="#0B1E5B"
    />
    <path
      d="M101.923 18.5249C99.7894 5.05643 87.3415 6.03061 85.7488 9.75724C83.8932 14.0869 80.5841 42.8021 80.5841 42.8021C80.5841 42.8021 99.9904 47.7658 102.062 26.2874C102.109 25.7771 102.14 25.2823 102.171 24.8029C102.372 33.0448 101.614 39.3229 96.8977 42.4001C96.8977 42.3691 106.067 38.4106 101.923 18.5249Z"
      fill="#0B1E5B"
    />
    <path
      d="M79.9036 32.5965C78.6046 32.3491 77.8006 31.0502 78.1562 29.7822C78.6665 27.8957 79.3778 25.3752 79.7644 24.1227C81.7591 17.7209 81.7282 12.2624 85.9961 11.4892C90.2639 10.7161 90.2794 18.293 89.1042 22.7619C87.929 27.2308 83.8621 25.6844 83.8621 25.6844L82.5323 30.9419C82.2385 32.1017 81.0788 32.8284 79.9036 32.5965Z"
      fill="#FF9494"
    />
    <path
      d="M86.3671 10.6696C86.3671 10.6696 91.5318 10.8243 91.7174 16.7467L86.2744 16.5457L85.6868 14.9839C85.6868 14.9839 84.6816 18.2775 82.5787 18.2002C82.5787 18.2002 78.2026 18.494 77.5686 16.0972C76.9346 13.7004 82.3776 9.35526 86.3671 10.6696Z"
      fill="#0B1E5B"
    />
    <path
      d="M85.0218 17.7208C85.0218 17.7208 85.6094 17.1332 86.3826 17.3343"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M85.4084 20.6279C85.4084 20.6279 85.2074 22.1897 86.3826 21.4011"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M87.697 17.5198L88.8722 20.2413L87.898 20.6279"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M89.0731 16.9941C89.0731 16.9941 88.7793 16.6848 88.0062 17.0869"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M82.0221 23.3959C82.0221 23.3959 82.8261 25.4525 83.8622 25.669L83.723 26.6895L83.3828 27.6173C83.3674 27.6173 81.8365 26.4267 82.0221 23.3959Z"
      fill="#0B1E5B"
    />
    <circle
      r="0.309264"
      transform="matrix(-1 0 0 1 88.7794 17.9837)"
      fill="#0B1E5B"
    />
    <circle
      r="0.309264"
      transform="matrix(-1 0 0 1 86.1197 18.2156)"
      fill="#0B1E5B"
    />
    <circle
      r="2.42772"
      transform="matrix(-1 0 0 1 80.259 18.9734)"
      fill="#FF9494"
    />
    <path
      d="M78.9912 18.293C78.9912 18.293 80.151 16.9323 81.3262 18.293"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M80.1663 19.2671C80.1663 19.2671 79.888 18.293 80.8931 17.9064"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M63.6053 25.638C63.6053 25.638 54.7759 22.3598 47.8947 27.741C47.8947 27.741 55.4253 23.6123 61.456 27.0297L63.6053 25.638Z"
      fill="#0B1E5B"
    />
    <path
      d="M97.2998 33.0448C96.4493 34.7767 95.2741 36.4003 93.635 37.4363"
      stroke="white"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M98.8615 28.4832C98.7223 29.0862 98.5522 29.7666 98.3357 30.447"
      stroke="white"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.508 64.4506H13.0408C9.83993 64.4506 7.55138 67.5432 8.47917 70.6049L21.0198 111.814L67.8424 111.35L53.508 64.4506Z"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.4532 64.4506L26.9268 111.768"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3137 64.4506L32.6636 111.35"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.1897 64.4506L38.524 111.35"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.0504 64.4506L44.3848 111.35"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M35.9108 64.4506L50.2452 111.35"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.7714 64.4506L56.1212 111.35"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M47.632 64.4506L61.9818 111.35"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M126.865 111.768L27.6689 111.814C30.777 50.1935 53.91 37.9157 53.91 37.9157L79.1768 28.9161L81.9911 29.7202L98.2275 44.1319L129.432 108.211L126.865 111.768Z"
      fill="#FF9494"
    />
    <path
      d="M119.629 88.0782L125.458 99.5519"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M59.3685 99.351L59.2294 111.397H102.944H102.913L103.299 89.4391L109.763 89.3C110.722 89.2845 111.572 88.7124 111.974 87.8464L113.583 84.3517C113.954 83.5322 114.758 82.9755 115.655 82.8982C117.386 82.759 118.453 80.9344 117.711 79.3571L101.568 45.0133C101.104 44.0392 100.052 43.5134 99.0007 43.7299C75.8214 48.3534 59.152 40.8537 53.7245 37.8848C52.4719 37.2044 50.9411 37.2817 49.7813 38.1322C31.4111 51.5234 27.1741 80.7179 26.2154 91.4184L26.0299 95.1451C25.9371 97.0625 27.4679 98.6707 29.3854 98.6707C30.4678 98.6707 31.4729 98.1449 32.1069 97.279L32.8027 96.3048C34.148 94.4183 36.9623 94.4492 38.2767 96.3512L38.6014 96.8151C39.5138 98.114 40.9828 98.9181 42.56 98.9799C44.261 99.0418 45.8846 98.2377 46.8743 96.846L47.0598 96.5986C48.3278 94.8049 50.9566 94.6966 52.3637 96.3821L53.6935 97.9748C54.2811 98.6861 55.1471 99.1191 56.0594 99.1655L59.3685 99.351Z"
      fill="#7DACEF"
    />
    <path
      d="M62.322 70.6514L60.0799 95.7945"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M65.3838 71.1306L61.719 77.3932"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M99.3717 65.3474L104.567 79.2643L103.299 89.4391"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M79.3161 67.0021L83.6768 80.4551L80.9398 88.0784"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.5285 43.4979C54.5285 43.4979 68.2598 51.2295 82.687 49.0801"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M79.316 34.3127C79.316 34.3127 76.9502 35.1323 75.0637 33.4932"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M122.118 109.603L115.778 104.346C112.036 101.237 107.598 99.8767 103.176 100.48L51.838 107.516L27.6691 111.83H121.608C122.536 111.83 122.891 110.253 122.118 109.603Z"
      fill="#FF9494"
    />
    <path
      d="M118.407 111.598L112.191 106.464L105.789 103.727"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M110.444 111.598L107.088 108.722L100.686 106.34"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M95.9391 109.247L103.578 111.768"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.985 103.433L122.814 108.737"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M112.717 102.274C112.717 102.274 109.624 99.9695 105.573 100.341"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M59.2603 107.516L43.6579 108.969"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M149.442 111.814H113.181C112.376 111.814 111.727 111.165 111.727 110.361C111.727 109.557 112.376 108.907 113.181 108.907H124.159L129.046 97.8975C129.386 97.1398 130.128 96.6604 130.948 96.6604H153.988C154.869 96.6604 155.457 97.5573 155.117 98.3614L149.442 111.814Z"
      fill="#0B1E5B"
    />
    <circle
      r="1.51539"
      transform="matrix(-1 0 0 1 140.087 104.392)"
      fill="white"
    />
    <path
      d="M169.853 111.814H15.5612"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <!-- END cv-dashboard-femme -->

  <!-- BEGIN cv-dashboard-homme -->
  <svg
    v-else-if="name === 'cv-dashboard-homme'"
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="158"
    viewBox="0 0 246 113"
    fill="none"
  >
    <path
      d="M28.303 70.0793C38.4004 66.7083 48.6371 65.0228 58.7036 65.0538C79.6099 65.1311 95.4442 72.5689 109.438 79.1098C121.206 84.6147 131.752 89.5629 143.318 89.5629C147.153 89.5629 151.112 89.0217 155.256 87.7692C167.255 84.1354 173.533 76.8058 179.595 69.7236C185.687 62.6106 191.424 55.8995 202.48 54.3068C206.315 53.7502 210.258 53.8893 214.325 54.6934C216.598 66.5228 217.093 79.1407 215.423 90.8464C210.305 89.2227 205.357 88.7743 200.579 89.5165C189.94 91.1711 184.497 98.0522 178.714 105.32C176.935 107.562 175.142 109.82 173.162 111.985H110.119C98.2276 106.109 84.7127 100.31 67.4867 100.248C58.0232 100.202 48.4361 101.918 38.9571 105.32C34.0862 107.067 29.1844 109.294 24.2671 111.985H20.2157C11.4017 104.516 5.13907 94.0937 2.10828 82.589C10.845 77.1615 19.6281 72.9709 28.303 70.0793Z"
      fill="#FFF0F0"
    />
    <path
      d="M67.1465 101.33C67.2547 101.33 67.363 101.33 67.4712 101.33C83.5065 101.408 96.341 106.511 107.629 112H26.5556C30.8234 109.758 35.0758 107.887 39.3127 106.356C48.5597 103.016 57.9304 101.33 67.1465 101.33Z"
      fill="#FFF0F0"
    />
    <path
      d="M42.8847 36.3077C42.993 36.3077 43.1012 36.3077 43.2095 36.3077C62.5694 36.3851 77.244 43.8074 90.2022 50.3638C97.3616 53.9822 104.134 57.415 111.016 59.3015C114.727 60.3221 118.252 60.8324 121.685 60.8324C125.412 60.8324 129.046 60.2293 132.71 59.0386C143.844 55.4048 149.658 48.0752 155.287 40.9776C160.915 33.88 166.25 27.169 176.471 25.5763C186.631 23.999 197.687 28.004 209.501 37.5139C211.403 42.5549 212.934 47.967 214.078 53.5647C210.057 52.807 206.13 52.6987 202.31 53.2554C190.852 54.91 184.976 61.7756 178.76 69.0433C172.791 76.0172 166.621 83.2231 154.931 86.7487C138.71 91.6505 125.35 85.3879 109.887 78.1512C95.7998 71.5484 79.8418 64.0642 58.7036 63.9869C58.5799 63.9869 58.4717 63.9869 58.348 63.9869C48.2659 63.9869 38.0448 65.6878 27.9473 69.0588C19.2879 71.9504 10.5357 76.1255 1.81448 81.5067C-0.953436 70.2185 -0.644172 57.9408 3.3608 46.4207C7.27299 44.4259 11.1697 42.725 15.051 41.3333C24.3134 37.9932 33.6687 36.3077 42.8847 36.3077Z"
      fill="#FFF0F0"
    />
    <path
      d="M31.875 15.4014C32.0915 15.4014 32.3234 15.4014 32.5399 15.4014C32.6481 15.4014 32.7564 15.4014 32.8646 15.4014C52.2245 15.4787 66.8991 22.9011 79.8573 29.4575C87.0168 33.0759 93.7896 36.5087 100.671 38.3952C104.382 39.4158 107.908 39.9261 111.34 39.9261C115.067 39.9261 118.701 39.323 122.366 38.1323C133.499 34.4985 139.313 27.1689 144.942 20.0713C149.117 14.8138 153.122 9.75736 159.075 6.85028C165.307 5.52044 172.265 5.16479 181.25 6.7575C182.997 7.06676 184.682 7.57705 186.321 8.28836C187.667 8.93781 189.012 9.66458 190.388 10.4687C197.965 15.4014 204.228 24.4474 208.712 35.5191C197.192 26.6277 186.337 22.932 176.286 24.4938C165.647 26.1484 160.204 33.0295 154.421 40.2972C148.9 47.2556 143.179 54.4615 132.355 58.0026C117.356 62.9044 104.985 56.6418 90.6661 49.405C77.5997 42.8022 62.8014 35.318 43.194 35.2253C33.746 35.1789 24.1434 36.8953 14.6644 40.3127C11.077 41.5961 7.4895 43.1424 3.87111 44.9362C5.10817 41.658 6.65449 38.4416 8.52553 35.3335C13.7985 26.6123 21.2672 19.2363 31.875 15.4014Z"
      fill="#FFF0F0"
    />
    <path
      d="M179.549 106C185.177 98.9028 190.512 92.1917 200.733 90.599C205.388 89.8723 210.228 90.3207 215.253 91.9289C214.124 99.1347 212.176 105.954 209.284 112H174.616C176.348 110.036 177.956 108.011 179.549 106Z"
      fill="#FFF0F0"
    />
    <path
      d="M144.107 19.3909C138.587 26.3494 132.865 33.5552 122.041 37.0963C107.042 41.9981 94.6711 35.7355 80.3522 28.4988C67.8115 22.1589 53.6472 14.9994 35.1687 14.3654C43.5497 12.0614 53.74 11.8449 66.1106 14.6283C121.206 27.0298 135.788 13.2984 155.333 7.77808C150.911 10.8089 147.571 15.0303 144.107 19.3909Z"
      fill="#FFF0F0"
    />
    <path
      d="M152.086 89.4392H160.328L150.416 106.34L171.353 89.4392H216.397L176.487 0H112.175L152.086 89.4392Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M196.172 79.9139H200.532L184.219 43.2506H179.842L196.172 79.9139Z"
      fill="#DAE6F7"
    />
    <path
      opacity="0.5"
      d="M186.352 79.9139H190.729L163.142 17.9838H158.782L186.352 79.9139Z"
      fill="#DAE6F7"
    />
    <path
      opacity="0.5"
      d="M176.533 79.9138H180.909L159.895 32.7201H155.519L176.533 79.9138Z"
      fill="#DAE6F7"
    />
    <path
      d="M196.172 79.9138H200.532L188.316 52.4512H183.94L196.172 79.9138Z"
      fill="#BBD3F9"
    />
    <path
      d="M186.352 79.9138H190.729L167.147 26.9678H162.771L186.352 79.9138Z"
      fill="#BBD3F9"
    />
    <path
      d="M176.533 79.9137H180.909L163.173 40.1115H158.813L176.533 79.9137Z"
      fill="#BBD3F9"
    />
    <path
      d="M164.101 66.1825H151.05"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M166.019 71.007H152.968"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M167.936 75.8316H154.885"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57.5079 65H17.0407C13.8398 65 11.5513 68.0926 12.479 71.1544L25.0197 112.364L71.8423 111.9L57.5079 65Z"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.453 65L30.9265 112.317"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.3137 65L36.6636 111.9"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.1895 65L42.5239 111.9"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.0501 65L48.3845 111.9"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M39.9107 65L54.2451 111.9"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.7712 65L60.1211 111.9"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M51.6318 65L65.9817 111.9"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <mask
      id="mask0_15_806"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="30"
      y="0"
      width="216"
      height="112"
    >
      <rect x="30" width="216" height="112" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_15_806)">
      <path
        d="M96.728 92.4288L110.165 73.2455L123.56 68.4083L152.541 100.904C155.766 104.088 157.792 108.553 157.792 113.472C157.792 123.229 149.895 131.126 140.138 131.126C134.764 131.126 129.927 128.728 126.702 124.883V124.883L96.728 92.4288Z"
        fill="#BBD3F9"
      />
      <path
        d="M66.6715 50.1345C66.6715 39.468 75.3122 30.7859 86.0201 30.7859C91.8082 30.7859 97.0174 33.3492 100.573 37.4008V37.4008L125.875 66.3411L96.728 92.47L71.2192 62.6202V62.6202C68.3665 59.23 66.6715 54.8477 66.6715 50.1345Z"
        fill="#0B1E5B"
      />
      <path
        d="M124.717 104.873V104.873L152.955 54.8889V54.8889C155.229 50.8786 159.528 48.1499 164.448 48.1499C171.725 48.1499 177.637 54.062 177.637 61.3384C177.637 62.9921 177.347 64.5218 176.81 65.9688V65.9688L156.593 119.715V119.715C154.071 126.413 147.622 131.167 140.056 131.167C130.299 131.167 122.402 123.271 122.402 113.514C122.443 110.413 123.27 107.436 124.717 104.873Z"
        fill="#BBD3F9"
      />
      <path
        d="M153.492 53.9795V53.9795L159.859 44.4292C160.893 42.4447 162.712 40.9977 164.862 40.4602L179.539 36.698C180.118 36.5326 180.655 37.1528 180.407 37.6902L180.242 38.1037C179.373 40.2535 177.968 42.114 176.149 43.561L174.454 44.9253L182.267 41.7419L181.689 41.4525C180.903 40.8323 180.572 39.7574 180.862 38.8065C181.316 37.4422 182.846 36.7807 184.169 37.3595L188.676 38.5998C190.04 38.9719 190.949 40.2949 190.743 41.7005C190.619 42.5687 190.164 43.2302 189.544 43.685L189.585 44.1398L190.412 44.3878C191.983 44.8013 193.017 46.331 192.81 47.9434V47.9434C192.645 49.3077 191.652 50.3413 190.453 50.672L190.536 50.7134C191.942 51.0855 192.81 52.4498 192.645 53.8555C192.479 55.1784 191.446 56.1293 190.288 56.336L190.371 57.8244C190.495 59.8089 189.296 61.6693 187.394 62.3722L176.107 67.6228C173.875 71.7157 169.492 74.5271 164.49 74.5271C157.213 74.5271 151.301 68.615 151.301 61.3386C151.26 58.5686 152.087 56.0466 153.492 53.9795Z"
        fill="#BBD3F9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M172.349 49.5158C171.823 50.1343 171.901 51.0776 172.519 51.6033C173.138 52.1291 174.066 52.0518 174.591 51.4332L184.983 39.2637C189.544 42.2017 195.699 41.3976 199.317 37.1607C203.26 32.5527 202.719 25.5788 198.095 21.6356C193.487 17.6925 186.513 18.2337 182.57 22.8572C178.952 27.0941 179.122 33.3104 182.74 37.3463L172.349 49.5158ZM196.178 23.8778C199.564 26.7694 199.966 31.8568 197.075 35.2433C194.199 38.6142 189.096 39.0163 185.709 36.1401C182.323 33.2485 181.921 28.1611 184.812 24.7747C187.704 21.3882 192.791 20.9862 196.178 23.8778Z"
        fill="#0B1E5B"
      />
      <path
        d="M190.536 50.7546L183.59 49.0182C183.59 49.0182 181.73 48.4807 181.647 46.5376"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M190.536 56.3359L183.508 54.9716C183.508 54.9716 181.606 54.5581 181.399 52.615"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M187.104 61.2971L182.722 60.4702C182.722 60.4702 180.82 60.0568 180.614 58.1136"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M167.177 51.4574C167.177 51.4574 171.931 47.7779 174.453 44.9252"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M177.678 52.2428L169.575 49.4728"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M176.148 43.5608C177.967 42.1138 179.373 40.2534 180.241 38.1035L180.407 37.6901C180.655 37.1113 180.117 36.5325 179.538 36.6979L173.626 38.2276L176.148 43.5608Z"
        fill="#BBD3F9"
      />
      <path
        d="M99.4155 92.3459L78.7852 102.558L71.0127 92.3873"
        stroke="#81B8EA"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M74.8575 31.6127C74.8575 31.6127 77.9169 30.7445 86.0201 30.7445C96.6867 30.7445 105.369 39.3852 105.369 50.0931C105.369 52.7805 104.79 55.3851 103.798 57.7003L157.048 132.408H64.3976L57.7 114.01C54.1858 104.46 51.8706 95.9015 50.0515 82.4236L47.819 67.5813C45.2144 51.0854 58.4442 34.9615 74.8575 31.6127Z"
        fill="#0B1E5B"
      />
      <path
        d="M144.025 111.86L175.198 117.4"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M107 63L135 101"
        stroke="#BBD3F9"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M89.7825 32.9356L94.8677 41.4109L85.9789 37.7314L80.0668 46.6202L74.9816 31.5299"
        stroke="#BBD3F9"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M85.9788 37.7314L90.8159 51.7468"
        stroke="#BBD3F9"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        r="0.826865"
        transform="matrix(-1 0 0 1 91.8496 48.3153)"
        fill="#BBD3F9"
      />
      <circle
        r="0.826865"
        transform="matrix(-1 0 0 1 90.0306 43.6436)"
        fill="#BBD3F9"
      />
      <path
        d="M167.673 91.6431L137.864 100.739"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M71.0127 32.6462C71.0127 32.6462 35.4575 43.0234 30.0002 81.5967L71.0127 79.1987V32.6462Z"
        fill="#0B1E5B"
      />
      <path
        d="M68.2839 98.0099L66.3408 79.4468L33.4729 81.2245L35.0853 104.708C35.9948 117.731 46.8268 127.818 59.8912 127.818H89.1623C89.1623 127.818 111.488 128.687 123.849 147.208C125.462 149.606 126.164 152.459 125.875 155.312L125.462 159.983C125.214 162.671 128.232 164.407 130.423 162.877L143.694 153.534C145.678 152.128 146.877 149.854 146.877 147.415V142.33C146.877 133.234 142.206 124.759 134.516 119.963C119.467 110.578 68.2839 98.0099 68.2839 98.0099Z"
        fill="#BBD3F9"
      />
      <path
        d="M68.2839 98.0099L55.5089 102.558"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M71.7156 62.8268L71.0127 79.1987"
        stroke="#BBD3F9"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M81.5137 7.09611C78.2476 4.90492 76.3871 9.12193 76.3871 9.12193C78.2062 4.73955 80.7695 5.97985 81.8031 6.72402C81.0589 5.73179 79.6946 3.08582 84.201 1.26672C84.201 1.26672 79.7773 3.16851 82.2579 6.55865C81.8031 5.73179 81.3483 4.1194 83.4568 2.79642C86.4336 0.894626 89.1622 3.87134 89.9477 3.87134C90.7746 3.87134 91.3121 0.0677614 94.5368 1.43209C97.803 2.79642 97.5135 2.25895 99.1259 0.894626C99.2086 0.81194 99.2913 0.770597 99.4153 0.68791C100.532 -0.0976117 102.805 -1.00716 104.707 2.92045C104.707 2.92045 103.136 -0.0562684 100.78 0.522537C102.103 0.977313 103.384 3.08582 103.219 7.05477C102.93 12.7601 98.3818 17.0598 98.3818 17.0598L78.0822 14.7033C78.0822 14.7033 76.8419 12.8842 76.8006 10.1969C76.7179 7.50955 79.8186 7.09611 81.5137 7.09611Z"
        fill="#F77777"
      />
      <path
        d="M80.7281 19.5818C78.8263 19.2924 77.4207 17.5559 77.5861 15.5301C77.7101 13.7937 79.0744 12.3467 80.8108 12.0986C81.7204 11.9746 82.5472 12.1813 83.2501 12.5534V12.5534C84.449 11.4785 86.0201 10.8583 87.6738 10.817L94.1234 10.6516C94.1234 10.6516 94.4541 11.5198 94.8675 12.8428C95.0742 12.8015 95.281 12.8015 95.529 12.8015C97.5962 12.8015 99.2913 14.4965 99.2913 16.5637C99.2913 18.3415 98.051 19.8298 96.3559 20.2432C96.4386 21.9383 96.2319 23.5094 95.4877 24.5843C92.8831 28.3465 88.8728 25.7832 88.8728 25.7832V35.4989C88.8728 35.4989 79.6532 37.4007 76.5938 31.4886L80.7281 19.5818Z"
        fill="#BBD3F9"
      />
      <path
        d="M90.3612 14.786L91.7668 18.3415H90.6092"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M91.2708 20.9047C91.2708 20.9047 89.7824 22.9306 89.0382 20.0779L91.2708 20.9047Z"
        fill="#0B1E5B"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M81.5964 15.3647C81.5964 15.3647 81.1417 14.4138 79.2399 14.4138"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M80.1907 16.8117C80.1907 16.8117 79.4879 15.406 81.1416 14.9099"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M95.281 16.233C95.281 16.233 95.405 15.1994 97.2241 14.5792"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M97.0587 17.1425C97.0587 17.1425 97.2654 15.5715 95.5703 15.6542"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M88.8728 25.7419C88.8728 25.7419 86.4336 24.5429 85.2759 22.7651C85.2759 22.7651 86.3922 27.6023 88.8728 27.933V25.7419Z"
        fill="#0B1E5B"
      />
      <circle
        r="0.620149"
        transform="matrix(-1 0 0 1 92.883 15.158)"
        fill="#0B1E5B"
      />
      <path
        d="M87.2192 14.2485C87.2192 14.2485 88.1288 13.7937 89.1624 13.8764"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M91.8082 13.6284C91.8082 13.6284 92.8418 13.6698 93.71 14.2486"
        stroke="#0B1E5B"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        r="0.620149"
        transform="matrix(-1 0 0 1 88.2939 15.6541)"
        fill="#0B1E5B"
      />
    </g>
    <path
      d="M181.442 111.814H145.181C144.376 111.814 143.727 111.165 143.727 110.361V110.361C143.727 109.557 144.376 108.907 145.181 108.907H156.159L161.046 97.8975C161.386 97.1398 162.128 96.6604 162.948 96.6604H185.988C186.869 96.6604 187.457 97.5573 187.117 98.3614L181.442 111.814Z"
      fill="#F77777"
    />
    <circle
      r="1.51539"
      transform="matrix(-1 0 0 1 172.086 104.392)"
      fill="white"
    />
  </svg>
  <!-- END cv-dashboard-homme -->

  <!-- BEGIN illustration-cles-reussite -->
  <svg
    v-else-if="name === 'illustration-cles-reussite'"
    xmlns="http://www.w3.org/2000/svg"
    width="268"
    height="148"
    viewBox="0 0 179 99"
    fill="none"
  >
    <path
      d="M40.107 64.3221L32.6193 81.1293H49.3521L56.8526 64.3221H40.107Z"
      fill="#FFF0F0"
    />
    <path
      d="M22.2662 64.3221L14.7657 81.1293H31.4986L38.9991 64.3221H22.2662Z"
      fill="#FFF0F0"
    />
    <path
      d="M46.9453 46.4979H30.2124L22.7119 63.3051H39.4448L46.9453 46.4979Z"
      fill="#FFF0F0"
    />
    <path
      d="M57.2983 63.3051L64.7988 46.4979H48.0659L40.5654 63.3051H57.2983Z"
      fill="#FFF0F0"
    />
    <path
      d="M75.1516 63.3051L82.6521 46.4979H65.9065L58.4187 63.3051H75.1516Z"
      fill="#FFF0F0"
    />
    <path
      d="M139.269 82.1464L132.214 97.9746L148.947 97.9873L156.014 82.1464H139.269Z"
      fill="#FFF0F0"
    />
    <path
      d="M172.403 87.9182L167.908 97.9872H171.206L172.403 87.9182Z"
      fill="#FFF0F0"
    />
    <path
      d="M57.9604 64.3221L50.4727 81.1293H67.2055L74.706 64.3221H57.9604Z"
      fill="#FFF0F0"
    />
    <path
      d="M173.078 82.1464H157.122L150.068 97.9873H166.8L172.798 84.5238L173.078 82.1464Z"
      fill="#FFF0F0"
    />
    <path
      d="M157.581 81.1293H173.206L175.192 64.3221H165.069L157.581 81.1293Z"
      fill="#FFF0F0"
    />
    <path
      d="M10.2069 82.1464L3.16479 97.9491H6.15735L13.1994 82.1464H10.2069Z"
      fill="#FFF0F0"
    />
    <path
      d="M133.016 53.6428L115.112 63.305H128.712L133.016 53.6428Z"
      fill="#FFF0F0"
    />
    <path
      d="M102.912 81.1292L109.509 66.3308L88.0387 77.9255L88.026 76.9719L86.1667 81.1292H102.912Z"
      fill="#FFF0F0"
    />
    <path
      d="M87.746 27.6566L87.6441 10.7605L78.4372 18.4013L74.3113 27.6566H87.746Z"
      fill="#FFF0F0"
    />
    <path
      d="M68.326 81.1293H85.0589L88.0133 74.5056L87.9496 64.3221H75.8138L68.326 81.1293Z"
      fill="#FFF0F0"
    />
    <path
      d="M76.2723 63.3051H87.9497L87.8478 46.4979H83.7601L76.2723 63.3051Z"
      fill="#FFF0F0"
    />
    <path
      d="M66.3651 45.4809H83.098L87.7842 34.9796L87.746 28.6737H73.8656L66.3651 45.4809Z"
      fill="#FFF0F0"
    />
    <path
      d="M87.8478 45.4808L87.7968 37.4459L84.2185 45.4808H87.8478Z"
      fill="#FFF0F0"
    />
    <path
      d="M120.753 81.1293L128.254 64.3221H113.227L110.973 65.5426L104.02 81.1293H120.753Z"
      fill="#FFF0F0"
    />
    <path
      d="M177.421 45.4808L178.86 33.4158L173.473 45.4808H177.421Z"
      fill="#FFF0F0"
    />
    <path
      d="M165.527 63.3051H175.32L177.306 46.4979H173.015L165.527 63.3051Z"
      fill="#FFF0F0"
    />
    <path
      d="M179 30.5807L169.182 45.4808H172.353L179 30.5807Z"
      fill="#FFF0F0"
    />
    <path
      d="M171.907 46.4979H168.507L157.428 63.3051H164.406L171.907 46.4979Z"
      fill="#FFF0F0"
    />
    <path
      d="M143.943 63.3051L140.122 49.8162L134.481 52.8547L129.82 63.3051H143.943Z"
      fill="#FFF0F0"
    />
    <path
      d="M121.874 81.1293H138.607L144.961 66.8775L144.235 64.3221H129.374L121.874 81.1293Z"
      fill="#FFF0F0"
    />
    <path
      d="M156.46 81.1293L163.961 64.3221H156.753L148.005 77.595L145.394 68.4159L139.727 81.1293H156.46Z"
      fill="#FFF0F0"
    />
    <path
      d="M50.0143 82.1464L42.9595 97.9491L59.7051 97.9619L66.7471 82.1464H50.0143Z"
      fill="#FFF0F0"
    />
    <path
      d="M76.6671 19.876L67.2947 27.6566H73.2034L76.6671 19.876Z"
      fill="#FFF0F0"
    />
    <path
      d="M32.1607 82.1464L25.1187 97.9491H41.8515L48.9063 82.1464H32.1607Z"
      fill="#FFF0F0"
    />
    <path
      d="M14.3073 82.1464L7.26526 97.9491H23.9981L31.0529 82.1464H14.3073Z"
      fill="#FFF0F0"
    />
    <path
      d="M121.415 82.1464L114.361 97.9746H131.093L138.161 82.1464H121.415Z"
      fill="#FFF0F0"
    />
    <path
      d="M103.575 82.1464L96.5199 97.9746H113.253L120.308 82.1464H103.575Z"
      fill="#FFF0F0"
    />
    <path
      d="M67.8677 82.1464L60.8129 97.9619H77.5457L84.6005 82.1464H67.8677Z"
      fill="#FFF0F0"
    />
    <path
      d="M85.7213 82.1464L78.6665 97.9619H95.3994L102.454 82.1464H85.7213Z"
      fill="#FFF0F0"
    />
    <path
      d="M21.1456 64.3221H18.153L10.6653 81.1293H13.6451L21.1456 64.3221Z"
      fill="#FFF0F0"
    />
    <path
      d="M40.349 27.6565L39.5085 25.6478L38.6044 27.6565H40.349Z"
      fill="#FFF0F0"
    />
    <path
      d="M30.6581 45.4809H47.4037L48.3205 43.4213L47.2763 44.2985L40.7691 28.6737H38.1586L30.6581 45.4809Z"
      fill="#FFF0F0"
    />
    <path
      d="M65.2445 45.4809L72.745 28.6737H66.0722L50.0906 41.9465L48.5116 45.4809H65.2445Z"
      fill="#FFF0F0"
    />
    <path
      d="M37.0379 28.6737H34.0581L26.5576 45.4809H29.5502L37.0379 28.6737Z"
      fill="#FFF0F0"
    />
    <path
      d="M38.9735 24.3511L37.5345 20.8931L34.5038 27.6566H37.4963L38.9735 24.3511Z"
      fill="#FFF0F0"
    />
    <path
      d="M29.0918 46.4979H26.112L18.6115 63.3051H21.604L29.0918 46.4979Z"
      fill="#FFF0F0"
    />
    <path
      d="M1 97.9366H174.135"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.3695 52.0791L54.4077 54.3167C54.4204 54.8379 54.2549 55.3337 53.962 55.766L53.0578 57.0373L52.1919 54.8252L52.9814 52.8165L54.3695 52.0791Z"
      fill="#BBD3F9"
    />
    <path
      d="M26.4683 80.0231L35.3823 60.0376C37.3943 55.5244 42.6918 51.8629 47.2124 51.8629C51.7331 51.8629 53.7706 55.5244 51.7586 60.0376L42.8446 80.0231"
      stroke="#FF9494"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M37.7892 97.9874H15.4915C14.9439 97.9874 14.6892 97.5424 14.9439 96.9957L22.75 79.4893C22.992 78.9427 23.6414 78.4977 24.189 78.4977H46.4868C47.0343 78.4977 47.289 78.9427 47.0343 79.4893L39.2282 96.9957C38.9863 97.5424 38.3368 97.9874 37.7892 97.9874Z"
      fill="#FF9494"
    />
    <ellipse
      rx="1.60356"
      ry="1.03049"
      transform="matrix(0.780666 -0.624948 0.626197 0.779665 31.6707 86.5364)"
      fill="#0B1E5B"
    />
    <path
      d="M31.2056 86.5452L28.2894 91.2237H30.849L32.097 86.5452H31.2056Z"
      fill="#0B1E5B"
    />
    <path
      d="M26.5448 78.4849H28.2894"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.8557 85.4518C29.8557 85.4518 30.7853 83.9516 32.6573 84.2059"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.801 83.1633L17.0833 95.8386"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.243 95.8387H36.5922C37.318 95.8387 37.9802 95.4065 38.2731 94.7454L39.4956 91.9993"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.8373 95.2793H53.0067L55.1206 90.41L48.053 90.2321L45.8373 95.2793Z"
      fill="#BBD3F9"
    />
    <path
      d="M65.7666 47.7566L45.1498 92.6985H56.9417L75.6866 57.7875L75.1773 48.0109L65.7666 47.7566Z"
      fill="#7DACEF"
    />
    <path
      d="M55.9484 90.4102H47.3528"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.0127 94.0079L46.1556 93.83L45.2515 95.8387L53.4396 95.6861L54.0127 94.0079Z"
      fill="white"
    />
    <path
      d="M54.242 95.2412L62.1627 96.6651L63.8691 97.0211V97.9492H43.9017L45.5063 95.0632L54.242 95.2412Z"
      fill="#0B1E5B"
    />
    <path
      d="M53.0068 93.9573L45.5573 93.8173"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M78.0807 95.2793H85.2501L87.364 90.41L80.2965 90.2321L78.0807 95.2793Z"
      fill="#BBD3F9"
    />
    <path
      d="M86.2433 94.008L78.3353 93.9572L77.4821 95.8387L85.6829 95.6862L86.2433 94.008Z"
      fill="white"
    />
    <path
      d="M86.4853 95.2412L94.406 96.6651L96.0997 97.0211V97.9492H76.145L77.7368 95.0759L86.4853 95.2412Z"
      fill="#0B1E5B"
    />
    <path
      d="M84.0529 93.9572H78.2461"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M81.7862 48.138L89.6178 72.8529C90.0508 74.2132 90.1781 75.6625 89.9871 77.0864L87.7968 93.2198L77.5203 93.2833L78.8574 75.2938L67.7531 47.7693L81.7862 48.138Z"
      fill="#7DACEF"
    />
    <path
      d="M87.0074 91.5036H78.4244"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M60.4181 75.2938C60.4181 75.2938 62.29 77.0356 64.5567 75.6625"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M86.6382 75.2938C88.2809 76.972 89.5543 75.2938 89.5543 75.2938"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M92.343 35.8314L94.4951 44.057L96.7236 58.0799L97.6532 59.9615L98.6083 62.7966C99.0795 64.1951 98.6847 66.5089 97.8442 67.6913L97.4368 68.2761C97.1439 68.6829 96.5454 68.5303 96.4689 68.0091L96.0232 66.5725L94.8008 64.2841L95.7304 66.6488L96.1124 68.5558C96.2143 69.0389 95.8704 69.4966 95.4247 69.4966C95.1318 69.4966 94.8772 69.3059 94.7753 69.0135L94.1513 67.3226L92.0119 63.8137C91.7318 66.814 90.0891 66.1529 90.0891 66.1529L90.2164 63.4831L90.8277 59.6945L88.1025 45.8496L86.0778 37.9418L92.343 35.8314Z"
      fill="#BBD3F9"
    />
    <path
      d="M83.2379 25.6861L85.5683 26.4997C85.5683 26.4997 87.8732 32.1953 86.7526 37.7002L82.6521 48.1634L64.6204 47.782C64.6204 47.7693 73.8273 24.58 83.2379 25.6861Z"
      fill="#0B1E5B"
    />
    <path
      d="M69.001 29.7289L46.2193 50.5535C45.7227 51.0112 45.4171 51.6468 45.3916 52.3079L45.3279 53.7827C45.2515 55.41 46.5377 56.783 48.1932 56.8466L50.116 56.9356C50.7273 56.961 51.2876 56.6051 51.5168 56.0457L51.937 55.143C52.1535 54.6726 52.5356 54.2912 53.0067 54.0751L75.0753 33.3776L69.001 29.7289Z"
      fill="#BBD3F9"
    />
    <path
      d="M85.1991 21.9738C85.7977 21.7322 85.9505 22.4823 85.9505 22.4823C85.8104 21.7195 85.3647 21.8212 85.1737 21.9102C85.3265 21.7831 85.6448 21.4016 84.9827 20.9567C84.9827 20.9567 85.6194 21.4144 85.11 21.872C85.2119 21.7576 85.3392 21.5161 85.0463 21.2237C84.6388 20.8168 84.104 21.1982 83.9639 21.1728C83.8366 21.1474 83.8748 20.5244 83.3145 20.6261C82.7414 20.7278 82.8051 20.6516 82.6014 20.3719C82.5886 20.3591 82.5759 20.3464 82.5631 20.3337C82.4103 20.1684 82.0792 19.9396 81.6335 20.5117C81.6335 20.5117 81.9901 20.0922 82.3467 20.2702C82.1174 20.2956 81.8373 20.588 81.7354 21.2364C81.5826 22.1517 82.1557 23.0035 82.1557 23.0035L85.492 23.3468C85.492 23.3468 85.7467 23.1052 85.8613 22.673C85.9505 22.2026 85.4666 22.0373 85.1991 21.9738Z"
      fill="#F77777"
    />
    <path
      d="M84.9571 24.0079C85.2882 24.0207 85.5811 23.7791 85.6066 23.4358C85.6193 23.1816 85.4665 22.9273 85.2373 22.8256C85.0972 22.762 84.9444 22.762 84.8043 22.8002C84.6515 22.584 84.4223 22.4315 84.1549 22.3679L83.1361 22.1136C83.1361 22.1136 83.047 22.2408 82.9324 22.4315C82.7796 22.3679 82.5886 22.3552 82.3339 22.5332C82.2193 22.6222 82.1301 22.7366 82.0919 22.8765C82.041 23.1561 82.1811 23.4358 82.4357 23.5503C82.3593 23.8172 82.3466 24.0842 82.423 24.2749C82.7032 24.9742 83.4418 24.6945 83.4418 24.6945L83.1616 26.1311C83.1234 26.3472 83.1998 26.5761 83.3781 26.7032C83.6582 26.9193 84.0912 27.2117 84.5242 27.3389C84.9953 27.4787 85.441 27.0846 85.3646 26.6015L84.9571 24.0079Z"
      fill="#BBD3F9"
    />
    <path
      d="M83.5056 22.8892L83.1617 23.4113L83.34 23.4495"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M84.8936 23.2961C84.8936 23.2961 85.0082 23.156 85.3011 23.2324"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M85.0721 23.5762C85.0721 23.5762 85.2376 23.3725 84.9829 23.2451"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M82.6778 22.9533C82.6778 22.9533 82.6905 22.775 82.4231 22.6222"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M82.3467 23.0292C82.3467 23.0292 82.3721 22.7746 82.6396 22.8382"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.4163 24.7072C83.4163 24.7072 83.7856 24.5928 84.0403 24.3512C84.0403 24.3512 83.7729 25.0759 83.3654 25.0377L83.4163 24.7072Z"
      fill="#0B1E5B"
    />
    <path
      d="M83.3146 22.6605C83.3146 22.6605 83.1618 22.5968 82.9962 22.6223"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="83.098" cy="22.8639" r="0.127343" fill="#0B1E5B" />
    <path
      d="M84.0149 22.9785C84.0149 22.9785 83.9003 22.8511 83.7347 22.8002"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="83.8109" cy="23.1055" r="0.127343" fill="#0B1E5B" />
    <path
      d="M89.3633 33.7463L87.797 35.8313"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.238 25.6861C83.238 25.6861 73.7636 24.2749 66.8744 30.7715L74.2858 35.0813L83.238 25.6861Z"
      fill="#0B1E5B"
    />
    <ellipse
      cx="83.2888"
      cy="23.8427"
      rx="0.0891401"
      ry="0.0636715"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M85.5683 26.4998C85.5683 26.4998 90.904 28.483 93.8583 36.8103L86.3323 39.8107L85.3136 35.8314L85.5683 26.4998Z"
      fill="#0B1E5B"
    />
    <path
      d="M94.4824 63.6102L95.7176 66.6487L96.0997 68.5558"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M95.8575 62.7203L97.0928 65.0596L97.8314 67.6913"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M97.3094 61.9702L98.1881 63.8645L98.672 65.5681"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M87.7969 35.3483L85.874 39.9378"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M77.4184 32.4115L74.5277 35.1703L67.4729 31.1147"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M46.4486 53.7192V56.2365"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M48.0023 54.0752L47.9131 56.8467"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M49.6067 54.4185L49.4539 56.9103"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M53.325 52.7529L52.3827 53.8844"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M64.3784 39.8107L66.0339 40.7769"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M89.6179 45.3029L88.1025 45.8504"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M77.1001 55.4227L71.1659 66.2164"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M68.619 50.6044L63.0287 53.7192"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M80.8821 50.6044L83.6072 53.8844"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.2478 78.4851H43.9018"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.3282 52.0791V54.2022"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M51.9371 54.9778C51.9371 54.9778 52.472 54.1769 52.9941 54.0752"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M91.7317 59.2749L90.8021 59.6951"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M92.1901 62.7203L91.8845 64.5384"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M82.6776 27.1354C82.6776 27.1354 83.76 28.5593 84.8934 28.305"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M126.063 39.0099C124.026 34.1025 122.676 30.3393 122.676 30.3393L127.057 30.0215L133.946 37.3571L136.48 25.9786C136.544 25.7243 136.506 24.9361 136.506 24.9361L136.467 21.4653L137.741 23.0037L140.109 20.7788L143.102 21.9866C143.713 22.9401 143.79 24.1352 143.293 25.1522L141.345 29.1315L139.867 41.0186C139.294 43.7138 136.9 45.6463 134.137 45.6463C132.341 45.6463 130.648 44.8199 129.54 43.4087L126.063 39.0099Z"
      fill="#FF9494"
    />
    <path
      d="M141.052 24.7834L139.167 25.8005"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M138.62 23.5248L139.727 25.4954"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M100.264 93.2324L98.3662 97.9364H102.352L103.052 96.843L104.148 97.9364H117.493V96.8939L111.024 95.0632L109.33 93.2324H100.264Z"
      fill="#0B1E5B"
    />
    <path
      d="M136.378 93.2324L136.99 97.9364H140.199L140.886 96.843L141.994 97.9364H156.116V96.8939L148.323 95.0632L146.629 93.2324H136.378Z"
      fill="#0B1E5B"
    />
    <path
      d="M116.844 22.5967C118.028 19.8125 120.664 20.6897 120.804 21.5796C120.97 22.6094 120.142 28.9788 120.142 28.9788C120.142 28.9788 115.685 29.0043 116.398 24.2622C116.411 24.1477 116.436 24.046 116.449 23.9316C115.965 25.6988 115.787 27.0845 116.64 27.9999C116.64 28.0126 114.883 26.665 116.844 22.5967Z"
      fill="#0B1E5B"
    />
    <path
      d="M120.346 25.3428C120.346 25.3428 119.327 25.4699 119.314 24.3766C119.301 23.2832 119.734 21.5542 120.677 21.9737C121.606 22.3933 122.23 23.1688 122.307 24.7453C122.383 26.3217 122.536 27.2117 122.536 27.2117L126.509 29.8561C126.509 29.8561 121.81 32.0555 116.08 29.1314L120.295 27.3515L120.346 25.3428Z"
      fill="#FF9494"
    />
    <path
      d="M120.524 23.4997C120.524 23.4997 120.422 23.3341 120.231 23.3341"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M120.282 24.0969C120.282 24.0969 120.244 24.4662 120.015 24.2243"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M119.925 23.2578L119.505 23.8172L119.709 23.9571"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M119.684 23.1688C119.684 23.1688 119.773 23.1179 119.926 23.2452"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M120.893 24.9232C120.893 24.9232 120.588 25.3428 120.346 25.3428V25.8132C120.346 25.8132 120.766 25.6225 120.893 24.9232Z"
      fill="#0B1E5B"
    />
    <path
      d="M120.511 21.7449C120.893 21.3635 121.314 21.3762 121.314 21.3762C124.102 21.0329 123.376 27.1354 125.58 25.508C125.669 25.4445 125.745 25.3936 125.834 25.3428C127.706 23.601 129.578 25.6097 129.578 25.6097C128.47 24.6054 127.579 24.7834 127.133 24.9741C128.228 25.1012 128.712 26.4234 128.712 26.4234C126.611 28.216 126.318 29.7162 126.318 29.7162L125.261 29.0169C122.294 32.0046 121.148 23.7282 121.148 23.7282C120.613 23.601 120.537 22.7746 120.537 22.7746L120.32 23.0925L119.06 22.8255C119.302 21.6813 120.511 21.7449 120.511 21.7449Z"
      fill="#0B1E5B"
    />
    <path
      d="M117.57 26.6268C117.57 26.6268 117.799 27.3134 118.194 27.9109"
      stroke="white"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <ellipse
      cx="121.556"
      cy="24.0079"
      rx="0.573043"
      ry="0.572104"
      fill="#FF9494"
    />
    <path
      d="M121.887 23.9319C121.887 23.9319 121.696 23.5499 121.352 23.8046"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M121.555 24.0847C121.555 24.0847 121.67 23.881 121.466 23.7281"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M122.714 22.6221C122.714 22.6221 122.409 21.7958 121.403 21.6305"
      stroke="white"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.775 45.7605L109.585 70.5136L97.1311 93.296L113.877 93.2579L124.255 71.4035L135.27 93.3469L149.584 93.3087L127.553 45.6588L113.775 45.7605Z"
      fill="#BBD3F9"
    />
    <path
      d="M116.869 58.7536L116.627 47.8201L116.806 38.374L111.47 38.0308L110.833 43.7009C110.668 45.2138 110.617 46.7395 110.719 48.2524L111.355 58.7918L111.139 61.9574C111.075 62.8982 111.126 63.839 111.292 64.7671L111.495 65.8859C111.546 66.191 111.839 66.3944 112.119 66.3181C112.387 66.2546 112.552 65.9749 112.514 65.6825L112.208 63.5212L113.38 67.5005C113.469 67.8183 113.775 67.9963 114.068 67.92C114.386 67.8437 114.59 67.4878 114.501 67.1318L113.52 63.1906L114.844 67.1954C114.934 67.475 115.201 67.6276 115.468 67.564C115.761 67.4878 115.94 67.1699 115.863 66.8648L114.883 62.6694L116.487 66.8267C116.589 67.0936 116.857 67.2335 117.111 67.1699C117.417 67.0936 117.595 66.7504 117.506 66.4325L116.373 62.3134L117.175 63.5975C117.48 64.0806 118.041 64.3221 118.563 64.195L116.869 58.7536Z"
      fill="#FF9494"
    />
    <path
      d="M132.978 35.7932C133.118 35.539 133.067 35.2211 132.851 35.0304L127.222 29.9959C127.057 29.8306 126.866 29.6399 126.611 29.6908C121.199 30.7714 117.022 28.3177 116.997 28.305C116.704 28.1398 116.334 28.1652 116.067 28.3559C111.725 31.5088 109.636 38.3995 109.407 40.9295L109.369 41.8067C109.343 42.2644 109.713 42.6331 110.158 42.6331C110.413 42.6331 110.655 42.5059 110.808 42.3025L110.973 42.0737C111.292 41.6287 111.954 41.6414 112.272 42.0864L112.349 42.1881C112.565 42.4932 112.909 42.6839 113.278 42.6966C113.686 42.7093 114.068 42.5186 114.297 42.2008L114.335 42.1372C114.641 41.7177 115.252 41.6923 115.583 42.0864L115.901 42.4678C116.042 42.6331 116.245 42.7348 116.462 42.7475L116.716 42.7729L116.653 45.7224L127.541 45.6334H127.528L128.203 40.0268L128.343 38.552L129.234 38.5139C129.833 38.4885 130.355 38.0816 130.508 37.4968C130.661 36.9374 131.157 36.5179 131.743 36.4798L131.858 36.467C132.341 36.4543 132.749 36.2001 132.978 35.7932Z"
      fill="#7DACEF"
    />
    <path
      d="M118.728 36.0475L117.99 40.4718"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M119.454 36.1492L118.487 37.8146"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M127.49 34.7888L128.445 37.8146L128.177 40.4717"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M122.74 35.183L123.771 38.3486L123.134 40.1539"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M116.895 29.6399C116.895 29.6399 120.142 31.4579 123.555 30.9621"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M124.408 55.1812L125.656 67.7929L124.255 71.4035"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M133.933 37.3442V40.0395"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M133.933 68.6828C133.933 68.6828 136.251 70.4118 137.066 67.9581"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M120.142 67.9454C120.142 67.9454 122.345 69.9287 123.466 67.9454"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M117.57 45.7352H127.566"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M114.233 46.4726H116.118"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.52 63.2034L114.45 66.9284"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M114.883 62.6821L115.761 66.4707"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M116.36 62.0719L117.353 65.8732"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M112.157 63.2034L112.514 65.6952"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M101.486 90.9315H111.916"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M135.805 90.9315H146.247"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M138.62 28.2034L141.345 29.1442"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M108.63 96.1693L111.024 95.0632"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M145.356 96.2074L148.323 95.0632"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M173.728 0.0939123C174.212 -0.134929 174.785 0.0684855 175.001 0.551596C175.218 1.03471 175.014 1.5941 174.517 1.82294L158.052 9.47642L158.51 10.4554C158.74 10.9385 158.536 11.4979 158.052 11.7267C157.912 11.7903 157.785 11.8157 157.644 11.8157C157.288 11.8157 156.944 11.6123 156.778 11.269L156.32 10.2901L147.699 14.2948L148.552 16.1128C149.265 17.6384 149.342 19.3547 148.756 20.9439C148.17 22.5331 147.011 23.8044 145.483 24.5164L144.757 24.8597C143.904 25.2665 142.987 25.4572 142.096 25.4572C139.702 25.4572 137.41 24.0969 136.34 21.7957L133.844 16.4307C132.367 13.2777 133.742 9.50185 136.913 8.02709L137.639 7.68383C140.797 6.20907 144.579 7.58212 146.056 10.7478L146.909 12.5658L155.531 8.56105L155.161 7.76011C154.932 7.277 155.136 6.71761 155.62 6.48876C156.104 6.25992 156.677 6.46334 156.893 6.94645L157.262 7.74739L173.728 0.0939123ZM143.968 23.1306L144.694 22.7874C146.897 21.7576 147.864 19.1259 146.833 16.9138L145.585 14.2312L144.337 11.5487C143.305 9.34928 140.669 8.38306 138.454 9.41285L137.728 9.75611C135.525 10.7859 134.557 13.4176 135.588 15.6297L138.084 20.9948C139.116 23.1942 141.752 24.1604 143.968 23.1306Z"
      fill="#BBD3F9"
    />
    <path
      d="M164.916 5.20473L165.858 7.22616C166.227 8.01439 167.132 8.3958 167.947 8.1161C169.105 7.70927 170.824 7.3533 172.493 7.9254C173.104 8.12881 173.677 7.50586 173.397 6.92104L171.219 2.28064L164.916 5.20473Z"
      fill="#BBD3F9"
    />
    <path
      d="M147.088 12.8964L147.839 14.3838"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M148.705 12.7818L154.397 10.1375"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M142.873 8.66272C142.873 8.66272 144.35 9.33653 145.165 11.091"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M145.802 23.2705C145.802 23.2705 147.33 22.4568 147.928 20.5625"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M159.083 7.95081L163.324 5.98022"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M165.934 5.98022L171.334 3.41211"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M167.552 7.21419C167.552 7.21419 170.442 6.10631 172.302 7.21419"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M157.492 8.19238L158.218 9.52729"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M139.511 22.6984L140.517 21.7957L139.982 22.6603C139.702 23.1179 139.855 23.7028 140.351 23.9952L141.497 24.669C141.93 24.9232 142.529 24.7961 142.784 24.402L143.191 23.7663C143.713 22.9527 143.369 21.9102 142.414 21.4779L141.332 20.9694C140.504 20.5753 139.473 20.7787 138.887 21.427L138.454 21.9102C138.416 21.961 138.377 21.9992 138.352 22.05C138.085 22.6475 138.989 23.1688 139.511 22.6984Z"
      fill="#FF9494"
    />
    <path
      d="M140.288 21.7958L139.167 22.9018"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M141.459 22.4696L140.415 24.0588"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M142.261 23.0035L141.23 24.6054"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <!-- END illustration-cles-reussite -->

  <!-- BEGIN teamwork -->
  <svg
    v-else-if="name === 'teamwork'"
    width="205"
    height="92"
    viewBox="0 0 158 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M102.604 68.9353C101.336 67.6016 100.652 66.4361 100.114 65.5059C99.3956 64.2731 98.8795 63.3877 97.4099 62.6593C96.9051 62.4127 95.5589 61.7403 93.9323 61.9981C91.6437 62.3567 89.5683 64.4412 89.1084 66.8508C88.9065 67.8818 89.0186 68.9577 89.4113 69.9888H103.703C103.356 69.6862 102.985 69.3275 102.604 68.9353Z"
      fill="#FFF0F0"
    />
    <path
      d="M150.742 69.9888H158L156.979 61.4938C156.418 61.7403 155.891 62.0317 155.397 62.3679C152.481 64.3516 151.538 67.3215 150.742 69.9888Z"
      fill="#FFF0F0"
    />
    <path
      d="M102.828 3.27247C103.03 5.03199 104.051 6.79152 105.577 7.80017C107.013 8.74157 108.853 8.97692 110.76 8.46139C112.633 7.94586 114.26 6.78031 114.899 5.49149C115.168 4.94234 115.168 4.52767 115.18 4.09059C115.18 3.87766 115.18 3.65351 115.213 3.41816C112.981 3.03712 110.636 2.83539 108.157 2.82418C106.34 2.79056 104.556 2.95867 102.828 3.27247Z"
      fill="#FFF0F0"
    />
    <path
      d="M18.1303 44.6605C5.56582 47.2942 2.83977 58.8712 2.32373 65.4274C4.72444 64.5869 6.95688 63.3653 9.00983 61.7515C15.8418 56.3832 17.6704 49.0313 18.1303 44.6605Z"
      fill="#FFF0F0"
    />
    <path
      d="M109.47 15.0287C109.761 15.0624 110.053 15.0736 110.333 15.0736C115.999 15.0736 120.138 9.6493 122.18 6.982C122.517 6.53371 122.842 6.07421 123.145 5.61472C120.912 4.72935 118.534 4.0233 115.987 3.54139C115.965 3.72071 115.965 3.90002 115.965 4.07934C115.965 4.56125 115.954 5.1104 115.606 5.82766C114.877 7.31821 113.048 8.64066 110.973 9.21222C110.244 9.41395 109.515 9.51482 108.808 9.51482C107.473 9.51482 106.216 9.15619 105.151 8.46134C103.423 7.32942 102.29 5.40178 102.054 3.42932C100.989 3.65346 99.9453 3.93364 98.9244 4.25865C99.0142 4.66211 99.1264 5.07678 99.2498 5.49144C100.607 9.73896 104.388 14.5356 109.47 15.0287Z"
      fill="#FFF0F0"
    />
    <path
      d="M69.9476 31.6379C69.9252 32.0638 69.9252 32.4896 69.9589 32.9155C70.1832 35.4035 71.5855 37.7122 73.8965 39.4157C76.1738 41.0855 78.9784 41.8812 81.0313 41.433C81.9288 41.2424 82.4112 40.8614 82.916 40.4691C83.5218 39.9872 84.15 39.4941 85.4289 39.3484C85.6533 39.326 85.8664 39.3148 86.0795 39.3148C87.6838 39.3148 88.8392 40.0433 89.9611 40.7493C91.1727 41.5114 92.3057 42.2287 93.9884 42.0718C96.0302 41.8812 97.9597 40.5476 98.6665 38.8441C98.7899 38.5527 99.3508 37.0509 98.7338 35.4483C98.128 33.8681 96.7706 33.375 94.7289 32.6465C93.3153 32.1422 91.5541 31.5034 89.5236 30.3154C87.2687 28.993 85.9449 27.7266 84.7894 26.6171C83.2974 25.1938 82.2205 24.1627 79.8758 23.7256C79.0681 23.5799 76.9254 23.1877 74.7491 24.1963C74.6818 24.2299 74.6145 24.2636 74.5584 24.2972C73.1224 26.3593 71.9108 28.2981 70.9461 29.9792C70.6544 30.4948 70.3178 31.0551 69.9476 31.6379Z"
      fill="#FFF0F0"
    />
    <path
      d="M121.675 62.3904C126.97 61.5162 131.973 65.9094 136.393 69.7871C136.472 69.8543 136.551 69.9328 136.64 70H149.923C150.764 67.1534 151.718 63.9145 154.96 61.7291C155.554 61.3257 156.205 60.9783 156.889 60.6981L156.609 58.367C155.24 48.5383 152.312 39.0346 147.881 30.3603C142.934 20.6773 135.418 10.8037 123.885 5.92863C123.549 6.45537 123.178 6.9709 122.797 7.47522C121.754 8.83129 120.026 11.1063 117.782 12.9219C115.348 14.8832 112.835 15.8806 110.322 15.8806C110.008 15.8806 109.705 15.8694 109.391 15.8358C103.95 15.309 99.9228 10.2322 98.4981 5.74931C98.3635 5.33465 98.2625 4.93119 98.1728 4.53894C88.3343 7.95713 80.5713 16.0263 75.4109 23.098C77.4414 22.4704 79.2812 22.8066 80.0328 22.9411C82.613 23.4118 83.8246 24.5662 85.3503 26.0343C86.4833 27.1214 87.7622 28.343 89.9386 29.6206C91.9018 30.7749 93.6182 31.3913 95.0092 31.8844C97.1856 32.6689 98.7561 33.2293 99.4853 35.1457C100.203 37.0285 99.5414 38.7881 99.4068 39.1243C98.5879 41.0967 96.4003 42.6209 94.0781 42.8338C93.8874 42.8563 93.7079 42.8563 93.5284 42.8563C91.8681 42.8563 90.6902 42.1166 89.5459 41.3881C88.3343 40.626 87.2013 39.9088 85.5185 40.0993C84.464 40.2226 83.9704 40.6148 83.3983 41.0519C82.871 41.4666 82.2652 41.9373 81.1995 42.1726C78.9334 42.6657 75.882 41.8252 73.4252 40.0208C70.9236 38.1829 69.4091 35.6725 69.1623 32.9603C69.1623 32.9043 69.1511 32.8483 69.1511 32.781C64.1814 39.9424 53.6923 49.5357 32.3438 45.0641C26.9703 43.9434 22.5615 43.8425 18.9268 44.4813C18.4893 48.9642 16.6495 56.7083 9.48096 62.3455C7.27096 64.0826 4.85903 65.3827 2.25638 66.2568C2.13298 68.4983 2.25638 69.9776 2.25638 69.9776H88.5699C88.2109 68.8905 88.1212 67.7698 88.3343 66.6827C88.8728 63.9145 91.1726 61.6171 93.8089 61.2024C95.6823 60.911 97.1856 61.6619 97.7465 61.9421C99.418 62.7714 100.046 63.8473 100.775 65.0913C101.325 66.0327 101.953 67.0974 103.154 68.375C103.771 69.025 104.365 69.5405 104.915 69.9776H112.734C115.37 65.4947 118.366 62.9395 121.675 62.3904Z"
      fill="#FFF0F0"
    />
    <path
      d="M121.81 63.1637C118.826 63.6568 116.1 65.9542 113.665 70H135.451C131.267 66.3353 126.566 62.3792 121.81 63.1637Z"
      fill="#FFF0F0"
    />
    <path
      d="M117.794 17.584C120.486 11.2632 126.454 13.258 126.78 15.2753C127.161 17.6176 125.265 32.0525 125.265 32.0525C125.265 32.0525 115.157 32.1085 116.773 21.3608C116.807 21.1031 116.851 20.8565 116.896 20.6212C115.786 24.6221 115.393 27.7825 117.323 29.8671C117.334 29.8559 113.329 26.8075 117.794 17.584Z"
      fill="#0B1E5B"
    />
    <path
      d="M78.2155 13.5943C78.2155 10.7813 75.9269 8.495 73.1111 8.495C70.8563 8.495 68.9492 9.95193 68.2761 11.9692L60.5018 35.0336C60.255 35.7733 60.1204 36.5578 60.1204 37.3759C60.1204 41.4217 63.4073 44.7054 67.4571 44.7054C71.1479 44.7054 74.2105 41.9708 74.7154 38.4294L78.1706 14.3339C78.193 14.0874 78.2155 13.8408 78.2155 13.5943Z"
      fill="#BBD3F9"
    />
    <path
      d="M67.4459 30.0352C67.1543 30.0352 66.8738 30.0576 66.5933 30.0912L56.5417 31.0438L57.3607 44.6941H67.4571C71.507 44.6941 74.7939 41.4104 74.7939 37.3646C74.7939 33.3189 71.4957 30.0352 67.4459 30.0352Z"
      fill="#BBD3F9"
    />
    <path
      d="M63.4634 46.0054L60.3671 29.4636L44.0782 30.674C39.1421 31.0438 35.2494 35.1569 35.2494 40.1889C35.2494 45.4563 39.5236 49.7262 44.7962 49.7262C47.2081 49.7262 49.4069 48.8296 51.0896 47.3615L63.4634 46.0054Z"
      fill="#0B1E5B"
    />
    <path
      d="M101.538 23.0868C101.213 23.0196 100.865 22.986 100.518 22.986C97.6905 22.986 95.402 25.2722 95.402 28.0964C95.402 30.5732 97.1632 32.6465 99.5079 33.106L109.627 35.4708L111.758 24.4429L101.538 23.0868Z"
      fill="#FF9494"
    />
    <path
      d="M116.739 24.5101L107.944 23.4454C107.271 23.3669 106.777 24.0506 107.08 24.6558L107.271 25.0368C107.518 25.5411 107.394 26.1463 106.957 26.4937L106.418 26.942C106.014 27.2782 105.869 27.8498 106.071 28.3317L106.407 29.1498C106.643 29.7214 106.418 30.3714 105.869 30.674C105.196 31.0438 105.038 31.9292 105.532 32.512L105.566 32.5568C105.97 33.0387 105.936 33.756 105.487 34.2043C105.095 34.5853 105.274 35.2577 105.813 35.381L112.364 36.9388C113.396 37.5664 114.596 37.9363 115.898 37.9363C119.633 37.9363 122.651 34.9103 122.651 31.1895C122.651 27.7601 120.082 24.9247 116.739 24.5101Z"
      fill="#7DACEF"
    />
    <path
      d="M133.466 36.5802L134.913 58.154H146.165L140.937 34.9327L133.466 36.5802Z"
      fill="#FF9494"
    />
    <path
      d="M128.586 24.6222L138.402 30.0577C138.402 30.0577 124.682 31.1784 114.641 26.0567L125.972 24.4429L128.586 24.6222Z"
      fill="#FF9494"
    />
    <path
      d="M126.723 25.8666C126.723 25.8666 125.747 26.2143 124.962 25.5188"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M130.235 40.189L131.536 47.9667"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M128.967 40.3795L130.672 43.2934"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M123.19 38.676L121.384 44.246L122.517 47.3952"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.3542 40.1889C54.3542 34.9215 50.0801 30.6516 44.8075 30.6516C44.6953 30.6516 44.5831 30.6516 44.4597 30.6628L44.4485 30.6516C23.7395 30.6516 17.5807 69.8767 17.5807 69.8767H52.4584L52.9071 48.5831C52.9632 47.4512 52.9407 46.3641 52.851 45.333C53.7933 43.8425 54.3542 42.0717 54.3542 40.1889Z"
      fill="#0B1E5B"
    />
    <path
      d="M54.3543 40.1889C54.3543 34.9215 50.0801 30.6516 44.8075 30.6516C44.6953 30.6516 44.5831 30.6516 44.4597 30.6628L44.4485 30.6516C42.676 30.6516 37.2239 30.6516 35.9675 30.6516C31.5923 30.6516 28.0586 34.1931 28.0586 38.5527C28.0586 39.3035 28.1596 40.0208 28.3615 40.7044C20.3404 52.3263 17.5919 69.8767 17.5919 69.8767H52.4696L52.9183 48.5831C52.9744 47.4512 52.952 46.3641 52.8622 45.333C53.7933 43.8425 54.3543 42.0717 54.3543 40.1889Z"
      fill="#0B1E5B"
    />
    <path
      d="M52.5704 40.9062L52.8733 49.1211"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M135.765 51.1832L136.562 28.7128C126.432 30.8534 121.339 26.9869 120.475 26.236C120.441 26.2024 120.407 26.1688 120.363 26.1352C120.34 26.1128 120.329 26.1128 120.329 26.1128C119.14 25.0817 117.592 24.4541 115.898 24.4541C112.162 24.4541 109.144 27.48 109.144 31.2008C109.144 33.6664 110.468 35.8294 112.442 37.0061L111.601 40.7942L114.91 58.1541H135.877L135.777 51.8108L135.765 51.1832Z"
      fill="#7DACEF"
    />
    <path
      d="M113.912 31.2233L112.454 36.9389"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M122.292 37.1854L120.43 42.2959L122.09 47.4064"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M133.466 39.6958L132.849 48.74"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M132.131 40.3795L133.163 44.0779"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M132.849 31.0888C132.849 31.0888 126.443 32.3776 121.036 29.6879"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M140.23 32.243C146.524 43.0579 148.072 49.9504 147.388 53.1108C147.242 53.772 146.412 53.9849 145.963 53.4806L145.447 52.909C145.043 52.4608 144.381 52.3487 143.854 52.6513L142.35 53.5254C141.868 53.8056 141.274 53.7384 140.858 53.3797L139.725 52.3823C139.333 52.0349 138.761 51.9564 138.301 52.203L136.854 52.9427C136.36 53.1892 135.754 53.0996 135.362 52.6961L134.172 51.4857L136.584 28.7352C136.562 28.7128 138.469 29.2283 140.23 32.243Z"
      fill="#7DACEF"
    />
    <path
      d="M141.734 56.8316L124.446 43.7529C123.717 43.1701 122.797 42.8339 121.799 42.8339C119.443 42.8339 117.536 44.7391 117.536 47.0926C117.536 48.1797 117.94 49.1659 118.601 49.9168C118.68 49.9952 118.747 50.0849 118.837 50.1521L126.544 58.1541H143.057C142.709 57.661 142.261 57.2127 141.734 56.8316Z"
      fill="#FF9494"
    />
    <path
      d="M132.635 49.9392L141.532 56.6747"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M116.504 36.4681L110.547 47.7762V50.3202L112.566 48.6952L118.657 37.6337C119.028 36.9613 118.702 36.1207 117.973 35.8854C117.401 35.6836 116.784 35.9414 116.504 36.4681Z"
      fill="#0B1E5B"
    />
    <path
      d="M125.568 45.1201C124.446 43.0132 122.539 41.4442 120.262 40.7269L117.177 39.9088L113.329 43.0356L112.6 44.0779C112.274 44.9969 112.891 46.5995 113.43 47.4176L119.185 50.4436C119.903 51.0039 120.811 51.3401 121.787 51.3401C124.143 51.3401 126.05 49.4349 126.05 47.0814C126.05 46.3754 125.882 45.7029 125.568 45.1201Z"
      fill="#FF9494"
    />
    <path
      d="M113.733 46.5658L116.257 47.0818"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.564 44.8067L116.952 44.4813"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.329 44.0778L112.084 44.8623L111.332 46.2968L111.074 45.9606C110.446 45.1649 110.39 44.0666 110.917 43.2036L111.096 42.9122C112.297 40.9846 116.066 39.3035 117.58 40.0432L117.816 40.3794L118.231 42.576L113.329 44.0778Z"
      fill="#FF9494"
    />
    <path
      d="M112.981 43.7415L116.313 42.0829L118.321 42.3182"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M111.668 45.0309L112.51 44.5822"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M128.451 21.5401C128.272 17.9538 126.88 16.2167 124.76 15.2529C122.64 14.2891 121.653 18.234 121.675 20.6996C121.698 23.1652 124.02 22.8962 124.02 22.8962L123.863 25.3393C123.829 26.7066 124.928 27.8273 126.297 27.8273C127.711 27.8273 128.821 26.6394 128.72 25.2273C128.619 23.6134 128.552 23.3893 128.451 21.5401Z"
      fill="#FF9494"
    />
    <path
      d="M124.435 18.7164C124.435 18.7164 124.21 18.335 123.773 18.335"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M123.885 20.0833C123.885 20.0833 123.784 20.9134 123.279 20.3637"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M123.1 18.1669L122.135 19.4333L122.595 19.7583"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M122.55 17.9875C122.55 17.9875 122.741 17.8641 123.1 18.167"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M125.209 21.9661C125.209 21.9661 124.525 22.9299 123.964 22.9075V23.9834C123.964 23.9834 124.917 23.5575 125.209 21.9661Z"
      fill="#0B1E5B"
    />
    <path
      d="M124.424 14.7598C125.287 13.8969 126.241 13.9305 126.241 13.9305C132.557 13.146 130.919 26.9981 135.911 23.3109C136.102 23.1652 136.293 23.0419 136.483 22.9187C140.735 18.9625 144.964 23.535 144.964 23.535C142.451 21.26 140.443 21.6634 139.434 22.1005C141.924 22.3919 143.798 28.5222 143.798 28.5222C136.887 28.399 135.204 31.2904 135.204 31.2904C128.462 38.082 125.86 19.2987 125.86 19.2987C124.648 18.9961 124.469 17.1245 124.469 17.1245L123.964 17.853L121.114 17.2478C121.664 14.6029 124.424 14.7598 124.424 14.7598Z"
      fill="#0B1E5B"
    />
    <ellipse
      cx="126.779"
      cy="19.8927"
      rx="1.30132"
      ry="1.30003"
      fill="#FF9494"
    />
    <path
      d="M127.52 19.7027C127.52 19.7027 127.094 18.8389 126.308 19.3998"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M126.791 20.0616C126.791 20.0616 127.06 19.5905 126.589 19.2539"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M104.13 24.4877L90.163 10.546C89.2319 9.62699 87.953 9.05542 86.5507 9.05542C83.7237 9.05542 81.4352 11.3417 81.4352 14.1659C81.4352 15.578 82.0073 16.8556 82.9384 17.7858L96.9052 31.7275C97.8363 32.6465 99.1152 33.2181 100.517 33.2181C103.345 33.2181 105.633 30.9318 105.633 28.1076C105.633 26.6843 105.061 25.4067 104.13 24.4877Z"
      fill="#FF9494"
    />
    <path
      d="M91.2175 12.0701L87.5155 2.46559C87.4481 2.29748 87.235 2.23024 87.0892 2.3311C86.2029 2.86904 86.0907 3.732 86.3488 4.79668L86.3936 6.37689L82.9496 0.593988C82.6243 0.0448369 81.9287 -0.168099 81.4239 0.145701C80.9976 0.403466 80.8518 0.952618 81.0649 1.43453L83.432 7.36312L80.1675 2.20782C79.8421 1.69229 79.169 1.51298 78.6867 1.80436C78.2491 2.07333 78.1145 2.63369 78.3613 3.12681L80.8181 8.2709L78.0136 3.67596C77.6658 3.10439 76.9254 2.89146 76.3869 3.21647C75.8933 3.51906 75.7475 4.15787 76.0504 4.69581L78.8437 9.72783L77.3405 8.2709C77.0039 7.83382 76.3981 7.69934 75.9606 7.96831C75.4894 8.25969 75.3885 8.8985 75.725 9.38041L77.2732 11.2744C78.5184 12.877 80.0216 14.603 82.6467 17.4608C83.5891 18.5703 84.9913 19.2763 86.5507 19.2763C89.3777 19.2763 91.6662 16.9901 91.6662 14.1659C91.6662 13.415 91.5092 12.7089 91.2175 12.0701Z"
      fill="#FF9494"
    />
    <path
      d="M86.3825 6.37692L83.4994 1.54663"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M86.3825 7.63208L85.7318 13.1012"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M81.4127 9.40283L85.9449 11.3081"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M84.823 10.6916C84.5426 10.2209 83.4768 8.98815 80.8405 10.8373C80.6723 10.9494 80.4591 10.8037 80.5152 10.602L81.9399 5.24495C81.9399 5.23375 81.9511 5.22254 81.9511 5.21133L83.1403 2.77937C83.3422 2.3535 83.2861 1.87159 82.9832 1.55779C82.5121 1.06468 81.6595 1.17675 81.2332 1.79314L79.5616 4.18027C79.5504 4.19148 79.5504 4.20269 79.5392 4.21389C79.427 4.46045 79.0568 4.31476 79.1353 4.05699L79.1578 3.96733C79.1578 3.95613 79.169 3.94492 79.169 3.93371L80.2572 1.97246C80.7283 1.34486 80.2796 0.526733 79.528 0.638804L78.4735 0.795705C76.3196 1.12071 73.3804 3.08197 72.3483 5.05443L68.7809 10.8261C68.276 11.6218 67.9731 12.5632 67.9731 13.5719C67.9731 16.3849 70.2617 18.6711 73.0775 18.6711C74.648 18.6711 76.0503 17.9651 76.9814 16.8556L81.8277 13.4934C81.839 13.4934 81.839 13.4822 81.8502 13.4822L84.7557 10.9494C84.8679 10.8934 84.8791 10.7813 84.823 10.6916Z"
      fill="#BBD3F9"
    />
    <path
      d="M77.5312 8.69671L79.5618 4.20263L81.2557 1.79309"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M75.1528 8.13662L76.4093 4.3486L78.5071 0.807129"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M72.8082 7.34071L73.9749 4.40443L75.3211 2.11816"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M78.9672 12.1262L81.2557 10.5684"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.387 50.9029L21.3836 47.0364L16.0437 45.9493L8.95374 57.8626C8.3143 58.8264 7.94409 59.9807 7.94409 61.2247C7.94409 64.6093 10.6926 67.355 14.0805 67.355C16.8402 67.355 19.1624 65.5395 19.9364 63.0403L26.387 50.9029Z"
      fill="#BBD3F9"
    />
    <path
      d="M35.9562 30.6404C34.8007 30.6404 33.7013 30.8869 32.7029 31.3352C27.4751 33.5206 20.5422 39.2251 15.1462 46.0951L27.879 51.5754L31.8391 45.2994C33.0394 46.0278 34.4417 46.4425 35.945 46.4425C40.3201 46.4425 43.8538 42.901 43.8538 38.5414C43.8538 34.1818 40.3313 30.6404 35.9562 30.6404Z"
      fill="#0B1E5B"
    />
    <path
      d="M26.387 50.9029L27.8902 51.5865L31.1996 46.3528"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.7946 56.7868C45.7946 53.8505 43.4051 51.4634 40.4659 51.4634C40.2191 51.4634 39.9723 51.4858 39.7367 51.5194L13.2279 55.1617C10.2438 55.5764 7.94409 58.1316 7.94409 61.2248C7.94409 64.6094 10.6926 67.3551 14.0805 67.3551C14.4956 67.3551 14.8994 67.3103 15.2921 67.2319L41.5204 61.9981C43.9548 61.5162 45.7946 59.3644 45.7946 56.7868Z"
      fill="#BBD3F9"
    />
    <path
      d="M26.0841 53.391L19.7794 54.266"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M48.9694 55.6996L48.6553 52.4944C48.5206 51.0935 47.1744 50.1185 45.7946 50.4323L42.2945 51.2392C42.99 49.1547 42.6535 48.146 42.2384 47.6641C41.9804 47.3615 41.4868 47.4176 41.3073 47.7874L39.4114 51.5754C36.977 52.0685 35.1372 54.2091 35.1372 56.7867C35.1372 59.723 37.5267 62.1102 40.4659 62.1102C40.9483 62.1102 41.4195 62.0429 41.857 61.9196L44.7288 61.3929C47.3988 60.8662 49.2274 58.4006 48.9694 55.6996Z"
      fill="#BBD3F9"
    />
    <path
      d="M48.9806 56.5289L46.0863 58.6471"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M48.8236 54.2651L45.4244 55.9462"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M48.5206 51.9229L45.043 53.4246"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M39.5349 19.5341C37.9419 18.7496 37.3585 20.7668 37.3585 20.7668C37.897 18.6935 39.1198 19.0858 39.6246 19.3547C39.2432 18.9625 38.4579 17.853 40.365 16.7771C40.365 16.7771 38.5028 17.909 39.8265 19.2651C39.5685 18.9177 39.2656 18.234 40.1182 17.5056C41.3298 16.4745 42.7209 17.64 43.0911 17.584C43.4501 17.528 43.4613 15.8133 44.9982 16.2055C46.5351 16.609 46.378 16.3848 47.0175 15.6788C47.0511 15.6452 47.096 15.6115 47.1297 15.5779C47.5784 15.1521 48.5319 14.6141 49.6426 16.2504C49.6426 16.2504 48.7563 15.0176 47.7354 15.4322C48.3637 15.5555 49.0592 16.4185 49.2275 18.2116C49.4631 20.7668 47.6906 22.9747 47.6906 22.9747L38.4691 23.1876C38.4691 23.1876 37.8073 22.4591 37.6165 21.2488C37.4146 20.016 38.772 19.6461 39.5349 19.5341Z"
      fill="#F77777"
    />
    <path
      d="M39.7592 25.1936C38.8954 25.1712 38.155 24.4988 38.0989 23.591C38.054 22.8065 38.57 22.078 39.3217 21.8651C39.7143 21.753 40.0957 21.7867 40.4323 21.9211C40.9034 21.3608 41.5653 20.9797 42.2945 20.8677L45.1552 20.397C45.1552 20.397 45.3571 20.7668 45.6263 21.3272C45.7161 21.2935 45.8171 21.2711 45.918 21.2599C46.8491 21.1254 47.7129 21.7755 47.8363 22.7056C47.9485 23.5014 47.4886 24.2522 46.7594 24.5212C46.9052 25.2833 46.9052 25.9894 46.6472 26.5161C45.7273 28.3653 43.7641 27.4575 43.7641 27.4575L43.8763 31.8059C43.8763 31.8059 39.5909 34.3947 37.8633 31.9516L39.7592 25.1936Z"
      fill="#BBD3F9"
    />
    <path
      d="M43.9661 22.4255L44.8187 23.9273L44.2914 23.9945"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M40.0845 23.2327C40.0845 23.2327 39.8152 22.8401 38.9739 22.9523"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M39.546 23.9506C39.546 23.9506 39.1422 23.3672 39.8489 23.0531"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M46.2434 22.7737C46.2434 22.7737 46.2434 22.3026 47.0063 21.9211"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M47.1072 23.0537C47.1072 23.0537 47.1072 22.3357 46.3444 22.4816"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M43.7866 27.4464C43.7866 27.4464 42.8218 27.0317 42.1824 26.3145C42.1824 26.3145 42.676 28.5447 43.809 28.5335L43.7866 27.4464Z"
      fill="#0B1E5B"
    />
    <path
      d="M44.5382 21.8428C44.5382 21.8428 44.9757 21.6969 45.4357 21.8091"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="45.1104" cy="22.4481" r="0.224366" fill="#0B1E5B" />
    <path
      d="M42.5414 22.538C42.5414 22.538 42.8779 22.2127 43.3379 22.1229"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="43.0911" cy="22.9413" r="0.224366" fill="#0B1E5B" />
    <path
      d="M44.4484 25.2837C44.4484 25.2837 43.6407 25.8334 43.0349 24.8574"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M93.7528 58.1541H108.942C109.279 58.1541 109.548 57.8851 109.548 57.5489C109.548 57.2127 109.279 56.9437 108.942 56.9437H104.343L102.29 52.3376C102.155 52.0238 101.841 51.822 101.493 51.822H91.8345C91.4643 51.822 91.2175 52.1919 91.3633 52.5393L93.7528 58.1541Z"
      fill="#0B1E5B"
    />
    <ellipse
      cx="97.8924"
      cy="55.0385"
      rx="0.628224"
      ry="0.627602"
      fill="white"
    />
    <path
      d="M79.4494 65.0465H57.3718C56.7324 65.0465 56.4407 64.5197 56.7212 63.8809L63.0707 49.6366C63.3512 48.9978 64.114 48.4711 64.7535 48.4711H86.8311C87.4705 48.4711 87.7622 48.9978 87.4817 49.6366L81.1322 63.8809C80.8517 64.5309 80.0889 65.0465 79.4494 65.0465Z"
      fill="#0B1E5B"
    />
    <path
      d="M76.4878 69.2156H69.2632L67.401 65.0465H74.6368L76.4878 69.2156Z"
      fill="#0B1E5B"
    />
    <path
      d="M79.0905 69.9104H67.2777C66.8402 69.9104 66.3241 69.5518 66.1222 69.1147C65.9203 68.6776 66.1222 68.319 66.5709 68.319H78.3726C78.8101 68.319 79.3261 68.6776 79.5281 69.1147C79.73 69.5518 79.5281 69.9104 79.0905 69.9104Z"
      fill="#0B1E5B"
    />
    <ellipse cx="72.8195" cy="57.2239" rx="1.22279" ry="1.22158" fill="white" />
    <path
      d="M69.9364 68.2182H75.6914"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M68.2761 65.0466H74.0311"
      stroke="#BBD3F9"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M82.3663 69.9105H1"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M154.04 58.1541H86.4722"
      stroke="#0B1E5B"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <!-- END teamwork -->
</template>

<script>
export default {
  props: ['name', 'label'],
};
</script>
